(function(){
    /*! ping-landing.js — built from resources/views/public/ping-landing.blade.php */
    var PL = (window.__pingL10n = window.__pingL10n || {});

    // Subdomain apex for the CURRENT tenant host. Server injects
    // __pingL10n.subdomainApex (request host, www-stripped) so links on
    // jutdee.com read {slug}.jutdee.com, not the hardcoded gamifeye.com.
    // Falls back to the page hostname for any surface that didn't inject it.
    function gfeSubdomainApex() {
        var apex = (window.__pingL10n && window.__pingL10n.subdomainApex) || '';
        if (apex) return String(apex).toLowerCase();
        var h = (window.location.hostname || '').toLowerCase().replace(/^www\./, '');
        return h || 'gamifeye.com';
    }
    window.gfeSubdomainApex = gfeSubdomainApex;
    function gfeSubdomainHost(slug) {
        return String(slug == null ? '' : slug) + '.' + gfeSubdomainApex();
    }
    window.gfeSubdomainHost = gfeSubdomainHost;

    function pingToursSectionEnabled() {
        var l10n = window.__pingL10n || {};
        if (l10n.toursEnabled === false) return false;
        var vp = document.getElementById('spinIntroAuthedCarouselViewport');
        if (vp && vp.getAttribute('data-tours-enabled') === '0') return false;
        return true;
    }
    window.pingToursSectionEnabled = pingToursSectionEnabled;

    function lookupTownBoundaryRing(areaId) {
        if (areaId == null || areaId === '') return null;
        var cache = window.__pingTerritoryBoundaryRings;
        if (!cache) return null;
        var ring = cache[areaId] || cache[String(areaId)];
        return (ring && ring.length >= 3) ? ring : null;
    }
    window.__pingLookupTownBoundaryRing = lookupTownBoundaryRing;

    function rememberTownBoundaryRing(areaId, ring) {
        if (areaId == null || areaId === '' || !ring || ring.length < 3) return;
        if (!window.__pingTerritoryBoundaryRings) {
            window.__pingTerritoryBoundaryRings = {};
        }
        window.__pingTerritoryBoundaryRings[String(areaId)] = ring;
    }
    window.__pingRememberTownBoundaryRing = rememberTownBoundaryRing;

    function pingCanEditDomain() {
        return window.pingCanCustomSubdomain === true;
    }

    function pingSetDomainReadonlyLink(linkEl, slug) {
        if (!linkEl) return;
        slug = slug ? String(slug).trim().toLowerCase() : '';
        if (!slug || slug.length < 2) {
            linkEl.textContent = '';
            linkEl.removeAttribute('href');
            linkEl.hidden = true;
            return;
        }
        linkEl.textContent = gfeSubdomainHost(slug);
        linkEl.href = 'https://' + gfeSubdomainHost(slug);
        linkEl.hidden = false;
    }
    // ── Basemap: Carto Dark Matter (matches subdomain our-app-home.js) ──
    var BASEMAP_STYLE_URL = 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';
    // Detailed OSM vector for route close-up (free, z18+, 3D buildings).
    var ROUTE_DETAIL_STYLE_URL = 'https://tiles.openfreemap.org/styles/bright';
    var _routeDetailStyleActive = false;
    // Glyph font for game hex number labels (minesweeper, dungeon, etc.).
    window.PING_MAP_GAME_LABEL_FONT = 'Open Sans Bold';
    var BUILDINGS_LAYER_ID = 'buildings-3d';
    var BUILDING_HEIGHT_EXPR = ['coalesce', ['get', 'render_height'], ['get', 'height'], 0];
    var BUILDING_BASE_EXPR   = ['coalesce', ['get', 'render_min_height'], ['get', 'min_height'], 0];
    var BUILDING_OPACITY_EXPR = [
        'interpolate', ['linear'], ['zoom'],
        13,   0,
        13.5, 1
    ];
    var BUILDING_PAINT = {
        'fill-extrusion-color': [
            'interpolate', ['linear'], BUILDING_HEIGHT_EXPR,
            0,   '#a83770',
            30,  '#e04ba0',
            80,  '#ff66c4',
            200, '#ffaadd'
        ],
        'fill-extrusion-height': BUILDING_HEIGHT_EXPR,
        'fill-extrusion-base':   BUILDING_BASE_EXPR,
        'fill-extrusion-opacity': BUILDING_OPACITY_EXPR,
        'fill-extrusion-vertical-gradient': true
    };

    var map = new maplibregl.Map({
        container: 'pingMap',
        style: BASEMAP_STYLE_URL,
        center: [0, 15],
        zoom: 1.8,
        interactive: false,
        attributionControl: false,
        logoPosition: 'top-left',
        preserveDrawingBuffer: true,
    });

    // Auto-spin state (controllable by the Spin The Globe feature below).
    var autoSpin = { active: true, rotation: 0 };
    var globalSpinRaf = null;
    var countryBackdrop = {
        active: false,
        ready: false,
        center: null,
        zoom: null,
        pitch: 50,
        bearingRaf: null,
    };

    function stopCountryBackdropSpin() {
        if (countryBackdrop.bearingRaf != null) {
            cancelAnimationFrame(countryBackdrop.bearingRaf);
            countryBackdrop.bearingRaf = null;
        }
    }

    function startCountryBackdropSpin() {
        if (PL && PL.globeIdleSpinEnabled === false) return;
        if (!countryBackdrop.active || !countryBackdrop.center) return;
        stopCountryBackdropSpin();
        var center = countryBackdrop.center;
        function tick() {
            if (!countryBackdrop.active) return;
            try {
                map.setCenter(center);
                map.setBearing(map.getBearing() + 0.03);
            } catch (e) {}
            countryBackdrop.bearingRaf = requestAnimationFrame(tick);
        }
        countryBackdrop.bearingRaf = requestAnimationFrame(tick);
    }

    function hideCountryBackdropLayers() {
        ['country-backdrop-fill', 'country-backdrop-line'].forEach(function (id) {
            try {
                if (map.getLayer(id)) map.setLayoutProperty(id, 'visibility', 'none');
            } catch (e) {}
        });
    }

    function showCountryBackdropLayers() {
        if (!countryBackdrop.ready) return;
        ['country-backdrop-fill', 'country-backdrop-line'].forEach(function (id) {
            try {
                if (map.getLayer(id)) map.setLayoutProperty(id, 'visibility', 'visible');
            } catch (e) {}
        });
    }

    var jutdeeSpinSatellite = {
        sourceId: 'jutdee-spin-satellite-src',
        layerId: 'jutdee-spin-satellite-layer',
        active: false,
    };

    function isJutdeeSpinFlyIn() {
        return !!(PL && PL.spinDirectFlyIn);
    }

    function addJutdeeSpinSatelliteLayer() {
        if (!map) return;
        try {
            if (map.getSource(jutdeeSpinSatellite.sourceId)) return;
            map.addSource(jutdeeSpinSatellite.sourceId, {
                type: 'raster',
                tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
                tileSize: 256,
                maxzoom: 17,
                attribution: '© Esri',
            });
            var beforeId;
            try {
                var layers = map.getStyle().layers || [];
                for (var i = 0; i < layers.length; i++) {
                    if (layers[i].type === 'symbol') { beforeId = layers[i].id; break; }
                }
            } catch (e) {}
            map.addLayer({
                id: jutdeeSpinSatellite.layerId,
                type: 'raster',
                source: jutdeeSpinSatellite.sourceId,
                maxzoom: 17,
                paint: {
                    'raster-opacity': 0,
                    'raster-opacity-transition': { duration: 0, delay: 0 },
                    'raster-fade-duration': 0,
                },
            }, beforeId);
        } catch (e) {}
    }

    var jutdeeSpinSatelliteFadeGen = 0;

    function fadeJutdeeSpinSatelliteIn(durationMs) {
        if (!map) return;
        durationMs = durationMs || 900;
        // Invalidate any in-flight fade-out cleanup so a stale timeout
        // can't rip the layer off after we've brought satellite back
        // (e.g. territory-view → territories-modal return race).
        jutdeeSpinSatelliteFadeGen += 1;
        addJutdeeSpinSatelliteLayer();
        try {
            if (!map.getLayer(jutdeeSpinSatellite.layerId)) return;
            map.setPaintProperty(jutdeeSpinSatellite.layerId, 'raster-opacity-transition', { duration: durationMs, delay: 0 });
            map.setPaintProperty(jutdeeSpinSatellite.layerId, 'raster-opacity', 1);
            jutdeeSpinSatellite.active = true;
        } catch (e) {}
    }

    function fadeJutdeeSpinSatelliteOut(durationMs, onDone) {
        // Jutdee: tiles stay satellite permanently — fly-in/out and modal
        // open/close must never swap back to the vector basemap. Keep the
        // raster pinned at full opacity and let callers proceed (country
        // backdrop restore etc. still runs via onDone).
        if (document.body.classList.contains('is-jutdee-tenant')) {
            addJutdeeSpinSatelliteLayer();
            try {
                if (map && map.getLayer(jutdeeSpinSatellite.layerId)) {
                    map.setPaintProperty(jutdeeSpinSatellite.layerId, 'raster-opacity-transition', { duration: 0, delay: 0 });
                    map.setPaintProperty(jutdeeSpinSatellite.layerId, 'raster-opacity', 1);
                }
            } catch (e) {}
            jutdeeSpinSatellite.active = true;
            if (onDone) onDone();
            return;
        }
        if (!map || !jutdeeSpinSatellite.active) {
            if (onDone) onDone();
            return;
        }
        durationMs = durationMs || 600;
        var fadeGen = ++jutdeeSpinSatelliteFadeGen;
        jutdeeSpinSatellite.active = false;
        try {
            if (!map.getLayer(jutdeeSpinSatellite.layerId)) {
                if (onDone) onDone();
                return;
            }
            map.setPaintProperty(jutdeeSpinSatellite.layerId, 'raster-opacity-transition', { duration: durationMs, delay: 0 });
            map.setPaintProperty(jutdeeSpinSatellite.layerId, 'raster-opacity', 0);
        } catch (e) {}
        setTimeout(function () {
            // A newer fade-in/out superseded this one — leave the map alone.
            if (fadeGen !== jutdeeSpinSatelliteFadeGen) return;
            try {
                if (map.getLayer(jutdeeSpinSatellite.layerId)) map.removeLayer(jutdeeSpinSatellite.layerId);
                if (map.getSource(jutdeeSpinSatellite.sourceId)) map.removeSource(jutdeeSpinSatellite.sourceId);
            } catch (e) {}
            if (onDone) onDone();
        }, durationMs + 100);
    }

    var jutdeeTerritoriesModalMapActive = false;

    function syncJutdeeTerritoriesModalMapBackdrop(revealed) {
        if (!document.body.classList.contains('is-jutdee-tenant')) {
            return;
        }
        revealed = !!revealed;
        if (!revealed && document.body.classList.contains('is-jutdee-territory-view-active')) {
            return;
        }
        if (revealed === jutdeeTerritoriesModalMapActive) {
            return;
        }
        jutdeeTerritoriesModalMapActive = revealed;
        if (revealed) {
            removeJutdeeCountryBackdrop(900);
            fadeJutdeeSpinSatelliteIn(900);
            return;
        }
        fadeJutdeeSpinSatelliteOut(600, function () {
            restoreJutdeeCountryBackdrop();
        });
    }
    window.syncJutdeeTerritoriesModalMapBackdrop = syncJutdeeTerritoriesModalMapBackdrop;

    function syncJutdeeModalSatelliteBackdrop() {
        if (!document.body.classList.contains('is-jutdee-tenant')) {
            return;
        }
        var terrOverlay = document.getElementById('spinIntroTerritoriesTableOverlay');
        var fpOverlay = document.getElementById('spinIntroFocalPointsOverlay');
        var locViewModal = document.getElementById('jutdeeLocationViewModal');
        var wantSatellite = !!(terrOverlay && terrOverlay.classList.contains('is-revealed'))
            || !!(fpOverlay
                && fpOverlay.classList.contains('is-revealed')
                && fpOverlay.getAttribute('data-fp-needs-business-setup') === '1')
            || !!(document.body.classList.contains('is-jutdee-location-view-active'))
            || !!(locViewModal && locViewModal.classList.contains('visible'));
        syncJutdeeTerritoriesModalMapBackdrop(wantSatellite);
    }
    window.syncJutdeeModalSatelliteBackdrop = syncJutdeeModalSatelliteBackdrop;

    function removeJutdeeCountryBackdrop(durationMs) {
        durationMs = durationMs || 900;
        stopCountryBackdropSpin();
        try {
            if (!map.getLayer('country-backdrop-fill')) return;
            map.setPaintProperty('country-backdrop-fill', 'fill-opacity-transition', { duration: durationMs, delay: 0 });
            map.setPaintProperty('country-backdrop-line', 'line-opacity-transition', { duration: durationMs, delay: 0 });
            map.setPaintProperty('country-backdrop-fill', 'fill-opacity', 0);
            map.setPaintProperty('country-backdrop-line', 'line-opacity', 0);
        } catch (e) {}
        setTimeout(function () { hideCountryBackdropLayers(); }, durationMs + 50);
    }

    function restoreJutdeeCountryBackdrop() {
        showCountryBackdropLayers();
        applyCountryBackdropPaint();
        try {
            if (!map.getLayer('country-backdrop-fill')) return;
            map.setPaintProperty('country-backdrop-fill', 'fill-opacity-transition', { duration: 0, delay: 0 });
            map.setPaintProperty('country-backdrop-line', 'line-opacity-transition', { duration: 0, delay: 0 });
            map.setPaintProperty('country-backdrop-fill', 'fill-opacity', countryBackdropFillOpacity());
            map.setPaintProperty('country-backdrop-line', 'line-opacity', countryBackdropLineOpacity());
        } catch (e) {}
    }

    function teardownJutdeeSpinMapView(onDone) {
        if (!isJutdeeSpinFlyIn()) {
            if (onDone) onDone();
            return;
        }
        fadeJutdeeSpinSatelliteOut(600, function () {
            restoreJutdeeCountryBackdrop();
            if (onDone) onDone();
        });
    }

    function countryBackdropFillColor() {
        return (PL && PL.countryBackdropFillColor) || '#ff2bd6';
    }
    function countryBackdropLineColor() {
        return (PL && PL.countryBackdropLineColor) || countryBackdropFillColor();
    }
    function countryBackdropFillOpacity() {
        var n = PL && PL.countryBackdropFillOpacity;
        return typeof n === 'number' ? n : 0.16;
    }
    function countryBackdropLineOpacity() {
        var n = PL && PL.countryBackdropLineOpacity;
        return typeof n === 'number' ? n : 0.95;
    }
    function applyCountryBackdropPaint() {
        try {
            if (!map.getLayer('country-backdrop-fill')) return;
            map.setPaintProperty('country-backdrop-fill', 'fill-color', countryBackdropFillColor());
            map.setPaintProperty('country-backdrop-line', 'line-color', countryBackdropLineColor());
        } catch (e) {}
    }

    function initGuestLandingDeckCarousel(host, options) {
        if (!host) return null;
        options = options || {};
        var slides = host.querySelector('.eye-opener-slides');
        if (!slides) return null;
        if (host.__guestDeckCarouselInit) return host.__guestDeckCarouselApi || null;
        host.__guestDeckCarouselInit = true;

        var slideEls = slides.querySelectorAll('.eye-opener-slide');
        var dotEls = slides.querySelectorAll('.eye-opener-slide-dot');
        var prevBtn = slides.querySelector('[data-eo-nav="prev"]');
        var nextBtn = slides.querySelector('[data-eo-nav="next"]');
        var slideIdx = 0;
        var FADE_STAGGER_MS = 600;
        var BG_DIM_DELAY_MS = 1000;

        function isActive() {
            return typeof options.isActive === 'function' ? !!options.isActive() : true;
        }

        function animateSlide(slideEl) {
            if (!slideEl) return;
            slideEl.classList.remove('is-bg-dim');
            var items = slideEl.querySelectorAll('.eye-opener-fadein');
            items.forEach(function (el) {
                el.style.transition = 'none';
                el.classList.remove('is-fade-visible');
            });
            void slideEl.offsetWidth;
            items.forEach(function (el) { el.style.transition = ''; });

            if (!items.length) {
                setTimeout(function () { slideEl.classList.add('is-bg-dim'); }, BG_DIM_DELAY_MS);
                return;
            }

            var maxOrder = 0;
            items.forEach(function (el) {
                var o = parseInt(el.getAttribute('data-eo-fade-order') || '0', 10);
                if (o > maxOrder) maxOrder = o;
            });

            for (var order = 0; order <= maxOrder; order++) {
                (function (o) {
                    setTimeout(function () {
                        items.forEach(function (el) {
                            if (parseInt(el.getAttribute('data-eo-fade-order') || '0', 10) === o) {
                                el.classList.add('is-fade-visible');
                            }
                        });
                    }, o * FADE_STAGGER_MS);
                })(order);
            }

            setTimeout(function () { slideEl.classList.add('is-bg-dim'); }, BG_DIM_DELAY_MS);
        }

        function setActiveSlide(n) {
            if (!slideEls.length) return;
            slideIdx = (n + slideEls.length) % slideEls.length;
            slideEls.forEach(function (el, i) {
                el.classList.toggle('is-active', i === slideIdx);
            });
            dotEls.forEach(function (d, i) {
                var active = (i === slideIdx);
                d.classList.toggle('is-active', active);
                d.setAttribute('aria-selected', active ? 'true' : 'false');
            });
            if (isActive()) {
                animateSlide(slideEls[slideIdx]);
            }
        }

        function resetSlideshow() {
            setActiveSlide(0);
        }

        function animateCurrent() {
            if (!slideEls.length) return;
            animateSlide(slideEls[slideIdx]);
        }

        dotEls.forEach(function (dot) {
            dot.addEventListener('click', function () {
                var i = parseInt(dot.getAttribute('data-eo-dot'), 10);
                if (!isNaN(i)) setActiveSlide(i);
            });
        });
        if (prevBtn) prevBtn.addEventListener('click', function () { setActiveSlide(slideIdx - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { setActiveSlide(slideIdx + 1); });

        if (options.keyboard !== false) {
            document.addEventListener('keydown', function (e) {
                if (!isActive()) return;
                if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
                if (e.key === 'ArrowLeft') setActiveSlide(slideIdx - 1);
                if (e.key === 'ArrowRight') setActiveSlide(slideIdx + 1);
            });
        }

        if (slideEls.length > 1) {
            var tx = 0;
            var ty = 0;
            slides.addEventListener('touchstart', function (e) {
                var t = e.changedTouches[0];
                tx = t.clientX;
                ty = t.clientY;
            }, { passive: true });
            slides.addEventListener('touchend', function (e) {
                var t = e.changedTouches[0];
                var dx = t.clientX - tx;
                var dy = t.clientY - ty;
                if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
                    setActiveSlide(slideIdx + (dx < 0 ? 1 : -1));
                }
            }, { passive: true });
        }

        var api = {
            reset: resetSlideshow,
            animateCurrent: animateCurrent,
            setActiveSlide: setActiveSlide,
            getActiveSlide: function () { return slideIdx; }
        };
        host.__guestDeckCarouselApi = api;
        return api;
    }
    window.initGuestLandingDeckCarousel = initGuestLandingDeckCarousel;

    function hideJutdeeGuestCta() {
        var cta = document.getElementById('spinJutdeeGuestCtaMount');
        if (!cta) return;
        cta.classList.remove('is-revealed');
        cta.setAttribute('aria-hidden', 'true');
    }

    function hideJutdeeGuestWalkReward() {
        var reward = document.getElementById('spinJutdeeGuestWalkRewardMount');
        if (!reward) return;
        reward.classList.remove('is-revealed');
        reward.setAttribute('aria-hidden', 'true');
        if (reward.__walkRewardCountRaf) {
            cancelAnimationFrame(reward.__walkRewardCountRaf);
            reward.__walkRewardCountRaf = null;
        }
        if (reward.__walkRewardCountTimer) {
            clearInterval(reward.__walkRewardCountTimer);
            reward.__walkRewardCountTimer = null;
        }
    }

    function revealJutdeeGuestCta() {
        hideJutdeeGuestWalkReward();
        var cta = document.getElementById('spinJutdeeGuestCtaMount');
        if (!cta) return;
        cta.classList.add('is-revealed');
        cta.setAttribute('aria-hidden', 'false');
    }

    function restoreGuestLandingChromeAfterPlay() {
        if (document.getElementById('spinJutdeeGuestCtaMount')) {
            if (typeof window.setPingGuestEyeOpenerChromeHidden === 'function') {
                window.setPingGuestEyeOpenerChromeHidden(false);
            }
            revealJutdeeGuestCta();
            return true;
        }
        if (document.querySelector('[data-spin-guest-banner="1"]')
            && typeof window.setPingGuestEyeOpenerChromeHidden === 'function') {
            window.setPingGuestEyeOpenerChromeHidden(false);
            return true;
        }
        return false;
    }

    function hideJutdeeAuthedCta() {
        var cta = document.getElementById('spinJutdeeAuthedCtaMount');
        if (!cta) return;
        cta.classList.remove('is-revealed');
        cta.setAttribute('aria-hidden', 'true');
    }
    window.hideJutdeeAuthedCta = hideJutdeeAuthedCta;

    function forceAuthedCarouselSlide(slideId, attempt) {
        slideId = String(slideId);
        attempt = attempt || 0;
        var viewport = document.getElementById('spinIntroAuthedCarouselViewport');
        if (!viewport) return;
        if (typeof viewport._spinIntroCarForceSlide === 'function') {
            if (viewport._spinIntroCarForceSlide(slideId)) {
                return;
            }
        }
        if (attempt < 60) {
            requestAnimationFrame(function () {
                forceAuthedCarouselSlide(slideId, attempt + 1);
            });
        }
    }
    window.forceAuthedCarouselSlide = forceAuthedCarouselSlide;

    function openAuthedIntroCarouselSlide(slideId) {
        slideId = String(slideId);
        hideJutdeeAuthedCta();
        try {
            localStorage.setItem('spinIntroAuthedCarouselSlide', slideId);
        } catch (e) {}
        var carViewport = document.getElementById('spinIntroAuthedCarouselViewport');
        if (carViewport) {
            carViewport._spinIntroCarSkipRestore = true;
        }
        if (typeof window.showPingIntro === 'function') {
            window.showPingIntro();
        } else {
            var introModal = document.getElementById('spinIntroModal');
            if (introModal) introModal.classList.add('visible');
        }
        if (carViewport) {
            carViewport._spinIntroCarSkipRestore = false;
        }
        forceAuthedCarouselSlide(slideId, 0);
        setTimeout(function () {
            forceAuthedCarouselSlide(slideId, 0);
        }, 150);
    }
    window.openAuthedIntroCarouselSlide = openAuthedIntroCarouselSlide;

    /** Jutdee authed: intro slide 2 + territories table overlay (not the play-menu CTA). */
    function pingLandingReturnToTerritoriesModal() {
        openAuthedIntroCarouselSlide('2');
        function revealTerritoriesOverlay() {
            if (typeof window.__jutdeeOnCarouselSlideActive === 'function') {
                window.__jutdeeOnCarouselSlideActive('2');
            }
            // Do NOT force jutdeeTerritoriesModalMapActive=false here.
            // That lied about satellite already being on (territory view
            // keeps it) and could kick a fade-out→fade-in race whose
            // stale fade-out timeout then stripped the satellite layer.
            if (typeof window.syncJutdeeModalSatelliteBackdrop === 'function') {
                window.syncJutdeeModalSatelliteBackdrop();
            }
            if (typeof window.syncSpinIntroTerritoriesTable === 'function') {
                window.syncSpinIntroTerritoriesTable();
            }
            if (typeof window.syncSpinIntroFocalPointsTable === 'function') {
                window.syncSpinIntroFocalPointsTable();
            }
        }
        revealTerritoriesOverlay();
        setTimeout(revealTerritoriesOverlay, 150);
        setTimeout(revealTerritoriesOverlay, 400);
    }
    window.pingLandingReturnToTerritoriesModal = pingLandingReturnToTerritoriesModal;

    /** Jutdee authed: intro slide 1 + focal points overlay (not the play-menu CTA). */
    function pingLandingReturnToFocalPointsModal() {
        openAuthedIntroCarouselSlide('1');
        function revealFocalPointsOverlay() {
            if (typeof window.__jutdeeOnCarouselSlideActive === 'function') {
                window.__jutdeeOnCarouselSlideActive('1');
            }
        }
        revealFocalPointsOverlay();
        setTimeout(revealFocalPointsOverlay, 150);
        setTimeout(revealFocalPointsOverlay, 400);
    }
    window.pingLandingReturnToFocalPointsModal = pingLandingReturnToFocalPointsModal;

    function returnJutdeeAuthedToPlayMenu() {
        // Territories is the permanent authed home — never hide intro first
        // (that would flash-dismiss home) and never reveal the play-menu CTA.
        hideJutdeeAuthedCta();
        pingLandingReturnToTerritoriesModal();
    }
    window.returnJutdeeAuthedToPlayMenu = returnJutdeeAuthedToPlayMenu;

    function revealJutdeeAuthedCta() {
        // Guard: while the walk-reward modal is active it owns the surface.
        // Any auto-reveal that races in behind it (globe-framing moveend,
        // late walk-sync callbacks, etc.) must stand down. The reward's own
        // dismiss path clears the flag BEFORE calling through here, so the
        // legitimate restore still works.
        if (window.__jutdeeWalkRewardActive) return false;
        if (typeof window.hideJutdeeAuthedWalkReward === 'function') {
            window.hideJutdeeAuthedWalkReward();
        }
        // Alias: authed home is territories, not the cream play menu.
        hideJutdeeAuthedCta();
        pingLandingReturnToTerritoriesModal();
        return true;
    }
    window.revealJutdeeAuthedCta = revealJutdeeAuthedCta;

    function syncJutdeeAuthedCtaProfileChrome(opts) {
        opts = opts || {};
        var mount = document.getElementById('spinJutdeeAuthedCtaMount');
        if (!mount) return;

        if (opts.displayName) {
            var titleEl = document.getElementById('spinJutdeeAuthedCtaTitle');
            if (titleEl) {
                titleEl.textContent = opts.displayName;
            }
        }

        if (opts.avatarUrl) {
            var art = mount.querySelector('.spin-jutdee-authed-cta-art');
            if (!art) return;
            var bustUrl = opts.avatarUrl;
            if (bustUrl.indexOf('?') < 0) {
                bustUrl = bustUrl + '?t=' + Date.now();
            }
            var img = art.querySelector('img.spin-jutdee-authed-cta-avatar');
            if (img) {
                img.src = bustUrl;
                return;
            }
            art.innerHTML = '<img class="spin-jutdee-authed-cta-avatar" src="'
                + bustUrl.replace(/"/g, '&quot;')
                + '" alt="" width="256" height="256" decoding="async" loading="lazy">';
        }
    }
    window.syncJutdeeAuthedCtaProfileChrome = syncJutdeeAuthedCtaProfileChrome;

    document.addEventListener('jutdee:authed-profile-updated', function (e) {
        var detail = e && e.detail ? e.detail : {};
        if (detail.avatarUrl) {
            window.PLAYER_AVATAR_URL = detail.avatarUrl;
        }
        syncJutdeeAuthedCtaProfileChrome(detail);
    });

    function restoreAuthedJutdeePlaySurface() {
        if (!document.getElementById('spinJutdeeAuthedCtaMount')) return false;
        showJutdeeAuthedLandingAfterFlyIn();
        return true;
    }
    window.restoreAuthedJutdeePlaySurface = restoreAuthedJutdeePlaySurface;

    function jutdeeAuthedNeedsOnboarding() {
        // Avatar/verify onboarding is disabled — territories is the home.
        return false;
    }
    window.jutdeeAuthedNeedsOnboarding = jutdeeAuthedNeedsOnboarding;

    function shouldDeferJutdeeAuthedCtaForAvatar() {
        return jutdeeAuthedNeedsOnboarding();
    }
    window.shouldDeferJutdeeAuthedCtaForAvatar = shouldDeferJutdeeAuthedCtaForAvatar;

    function hideJutdeeTerritoriesTableOverlay() {
        var terrOverlay = document.getElementById('spinIntroTerritoriesTableOverlay');
        if (!terrOverlay) return;
        terrOverlay.classList.remove('is-revealed', 'is-hero-in', 'is-hero-ready');
        var terrHero = terrOverlay.querySelector('.spin-intro-territories-table-hero');
        if (terrHero) {
            if (terrHero._terrHeroAnim && typeof terrHero._terrHeroAnim.cancel === 'function') {
                try { terrHero._terrHeroAnim.cancel(); } catch (eHideAnim) {}
            }
            terrHero._terrHeroAnim = null;
            terrHero.style.removeProperty('opacity');
            terrHero.style.removeProperty('transform');
            terrHero.style.removeProperty('will-change');
            terrHero.style.removeProperty('transition');
        }
        terrOverlay.setAttribute('aria-hidden', 'true');
        if (typeof window.syncJutdeeModalSatelliteBackdrop === 'function') {
            window.syncJutdeeModalSatelliteBackdrop();
        }
    }
    window.hideJutdeeTerritoriesTableOverlay = hideJutdeeTerritoriesTableOverlay;

    function syncJutdeeOnboardingScrim() {
        var scrim = document.getElementById('spinJutdeeOnboardingScrimMount');
        if (!scrim) return;
        var introModal = document.getElementById('spinIntroModal');
        var active = !!(introModal
            && introModal.classList.contains('visible')
            && jutdeeAuthedNeedsOnboarding());
        scrim.classList.toggle('is-revealed', active);
        scrim.setAttribute('aria-hidden', active ? 'false' : 'true');
        document.body.classList.toggle('is-jutdee-onboarding-active', active);
    }
    window.syncJutdeeOnboardingScrim = syncJutdeeOnboardingScrim;

    function showJutdeeAuthedOnboardingIntro() {
        hideJutdeeAuthedCta();
        hideJutdeeTerritoriesTableOverlay();
        if (typeof window.hideJutdeeFocalPointsOverlay === 'function') {
            window.hideJutdeeFocalPointsOverlay();
        }
        var carViewport = document.getElementById('spinIntroAuthedCarouselViewport');
        if (carViewport) {
            carViewport._spinIntroCarSkipRestore = true;
        }
        if (typeof window.showPingIntro === 'function') {
            window.showPingIntro();
        } else {
            var introModal = document.getElementById('spinIntroModal');
            if (introModal) introModal.classList.add('visible');
        }
        var introCard = document.getElementById('spinIntroCard');
        if (introCard) {
            introCard.classList.add('spin-intro-flyin-rest');
        }
        if (carViewport) {
            carViewport._spinIntroCarSkipRestore = false;
        }
        hideJutdeeTerritoriesTableOverlay();
        if (typeof window.hideJutdeeFocalPointsOverlay === 'function') {
            window.hideJutdeeFocalPointsOverlay();
        }
        syncJutdeeOnboardingScrim();
    }

    function kickJutdeeOnboardingIfPending() {
        if (!document.getElementById('spinJutdeeAuthedCtaMount')) return;
        if (!jutdeeAuthedNeedsOnboarding()) return;
        requestAnimationFrame(function () {
            showJutdeeAuthedOnboardingIntro();
        });
    }
    window.kickJutdeeOnboardingIfPending = kickJutdeeOnboardingIfPending;

    function showJutdeeAuthedLandingAfterFlyIn() {
        // Never surface the home while the walk-reward modal owns the
        // screen — the user dismisses it explicitly via Return To Main Menu.
        if (window.__jutdeeWalkRewardActive) return;
        revealJutdeeAuthedCta();
    }

    function revealJutdeeAuthedLanding() {
        showJutdeeAuthedLandingAfterFlyIn();
    }

    function revealJutdeeTenantLanding() {
        if (document.getElementById('spinJutdeeAuthedCtaMount')) {
            revealJutdeeAuthedLanding();
            return;
        }
        revealJutdeeGuestLanding();
    }

    function revealJutdeeGuestDeck(force) {
        var mount = document.getElementById('spinJutdeeGuestIntroMount');
        if (!mount) return;
        if (!force && mount.classList.contains('is-flyin-revealed')) return;
        hideJutdeeGuestCta();
        hideJutdeeGuestWalkReward();
        if (typeof window.hideJutdeeAuthedCta === 'function') {
            window.hideJutdeeAuthedCta();
        }
        var deckApi = initJutdeeGuestDeckTabs();
        mount.classList.add('is-flyin-revealed');
        mount.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-jutdee-how-to-play-active');
        if (deckApi && deckApi.activate) deckApi.activate('player');
        if (deckApi && deckApi.carousel) {
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    deckApi.carousel.animateCurrent();
                });
            });
        }
    }
    window.revealJutdeeGuestDeck = revealJutdeeGuestDeck;

    function restoreJutdeeGuestDeckFromCta() {
        var mount = document.getElementById('spinJutdeeGuestIntroMount');
        if (!mount) return;
        var deckApi = initJutdeeGuestDeckTabs();
        if (deckApi && typeof deckApi.restoreFromCta === 'function') {
            deckApi.restoreFromCta();
            return;
        }
        hideJutdeeGuestCta();
        mount.classList.add('is-flyin-revealed');
        mount.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-jutdee-how-to-play-active');
    }
    window.restoreJutdeeGuestDeckFromCta = restoreJutdeeGuestDeckFromCta;

    (function wireJutdeeGuestCtaCloseEarly() {
        var ctaCloseBtn = document.getElementById('jutdeeGuestCtaClose');
        if (!ctaCloseBtn || ctaCloseBtn.__jutdeeCtaCloseWired) return;
        ctaCloseBtn.__jutdeeCtaCloseWired = true;
        ctaCloseBtn.addEventListener('click', function (e) {
            e.preventDefault();
            restoreJutdeeGuestDeckFromCta();
        });
    })();

    function initJutdeeGuestDeckTabs() {
        var root = document.querySelector('.spin-jutdee-guest-deck-stack');
        if (!root || root.__jutdeeDeckTabsInit) return root && root.__jutdeeDeckTabsApi ? root.__jutdeeDeckTabsApi : null;
        root.__jutdeeDeckTabsInit = true;
        var tabs = root.querySelectorAll('[data-jutdee-deck-tab]');
        var panels = root.querySelectorAll('[data-jutdee-deck-panel]');
        if (!tabs.length || !panels.length) return null;

        var mount = document.getElementById('spinJutdeeGuestIntroMount');
        var playerPanel = root.querySelector('[data-jutdee-deck-panel="player"]');
        var businessPanel = root.querySelector('[data-jutdee-deck-panel="business"]');
        var carousels = {};

        function panelCarouselHost(panel) {
            if (!panel) return null;
            if (panel.classList.contains('guest-landing-deck-carousel-host')) return panel;
            return panel.querySelector('.guest-landing-deck-carousel-host');
        }

        function initPanelCarousel(panel, key) {
            var host = panelCarouselHost(panel);
            if (!host) return null;
            var api = initGuestLandingDeckCarousel(host, {
                isActive: function () {
                    return !!(mount && mount.classList.contains('is-flyin-revealed')
                        && panel.classList.contains('is-active'));
                }
            });
            if (api) carousels[key] = api;
            return api;
        }

        initPanelCarousel(playerPanel, 'player');
        initPanelCarousel(businessPanel, 'business');

        var lastActiveDeck = 'player';

        function getActiveDeck() {
            var activeTab = root.querySelector('[data-jutdee-deck-tab].is-active');
            return activeTab
                ? (activeTab.getAttribute('data-jutdee-deck-tab') || lastActiveDeck)
                : lastActiveDeck;
        }

        function replayDeckEntrance() {
            var stack = mount.querySelector('.spin-jutdee-guest-deck-stack');
            if (!stack) return;
            stack.style.animation = 'none';
            void stack.offsetHeight;
            stack.style.animation = '';
        }

        function restoreFromCta() {
            if (!mount) return;
            hideJutdeeGuestCta();
            mount.classList.add('is-flyin-revealed');
            mount.setAttribute('aria-hidden', 'false');
            document.body.classList.add('is-jutdee-how-to-play-active');
            activate(lastActiveDeck);
            replayDeckEntrance();
        }

        root.querySelectorAll('.jutdee-guest-deck-close').forEach(function (closeBtn) {
            if (!mount) return;
            closeBtn.addEventListener('click', function () {
                lastActiveDeck = getActiveDeck();
                mount.classList.remove('is-flyin-revealed');
                mount.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('is-jutdee-how-to-play-active');
                if (document.getElementById('spinJutdeeAuthedCtaMount')) {
                    if (typeof window.restoreAuthedJutdeePlaySurface === 'function') {
                        window.restoreAuthedJutdeePlaySurface();
                    }
                } else {
                    revealJutdeeGuestCta();
                }
                var bgImage = document.querySelector('.ping-bg-image');
                if (bgImage) bgImage.classList.remove('is-faded');
                if (typeof window.setPingGuestEyeOpenerChromeHidden === 'function') {
                    window.setPingGuestEyeOpenerChromeHidden(false);
                }
            });
        });

        function activate(deck) {
            lastActiveDeck = deck;
            tabs.forEach(function (tab) {
                var on = tab.getAttribute('data-jutdee-deck-tab') === deck;
                tab.classList.toggle('is-active', on);
                tab.setAttribute('aria-selected', on ? 'true' : 'false');
                tab.setAttribute('tabindex', on ? '0' : '-1');
            });
            panels.forEach(function (panel) {
                var on = panel.getAttribute('data-jutdee-deck-panel') === deck;
                panel.classList.toggle('is-active', on);
                if (on) panel.removeAttribute('hidden');
                else panel.setAttribute('hidden', '');
            });
            var activeCarousel = carousels[deck];
            if (activeCarousel) {
                requestAnimationFrame(function () {
                    activeCarousel.animateCurrent();
                });
            }
        }

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                activate(tab.getAttribute('data-jutdee-deck-tab'));
            });
        });

        var api = {
            activate: activate,
            carousel: carousels.player || null,
            carousels: carousels,
            restoreFromCta: restoreFromCta
        };
        root.__jutdeeDeckTabsApi = api;
        return api;
    }

    function revealJutdeeGuestLanding() {
        if (document.getElementById('spinJutdeeGuestIntroMount')) {
            revealJutdeeGuestDeck(false);
            return;
        }
        if (!document.getElementById('spinJutdeeGuestCtaMount')) return;
        hideJutdeeGuestWalkReward();
        revealJutdeeGuestCta();
    }

    function fadeCountryBackdropIn(durationMs) {
        var start = performance.now();
        var fillTarget = countryBackdropFillOpacity();
        var lineTarget = countryBackdropLineOpacity();
        function tick(timestamp) {
            var t = Math.min((timestamp - start) / durationMs, 1);
            try {
                map.setPaintProperty('country-backdrop-fill', 'fill-opacity', fillTarget * t);
                map.setPaintProperty('country-backdrop-line', 'line-opacity', lineTarget * t);
            } catch (e) {}
            if (t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
    }

    function initCountryBackdrop(data) {
        var meta = data.meta;
        if (!meta || !meta.bbox || !meta.center) return false;
        countryBackdrop.center = meta.center;
        countryBackdrop.pitch = 50;
        countryBackdrop.zoom = 5;
        try {
            var bounds = new maplibregl.LngLatBounds(
                [meta.bbox[0], meta.bbox[1]],
                [meta.bbox[2], meta.bbox[3]]
            );
            var camera = map.cameraForBounds(bounds, { padding: 40, maxZoom: 10 });
            if (camera && camera.zoom) countryBackdrop.zoom = camera.zoom;
        } catch (e) {}

        try {
            if (map.getSource('country-backdrop')) {
                map.getSource('country-backdrop').setData(data);
                applyCountryBackdropPaint();
            } else {
                map.addSource('country-backdrop', { type: 'geojson', data: data });
                map.addLayer({
                    id: 'country-backdrop-fill',
                    type: 'fill',
                    source: 'country-backdrop',
                    paint: {
                        'fill-color': countryBackdropFillColor(),
                        'fill-opacity': 0,
                    },
                });
                map.addLayer({
                    id: 'country-backdrop-line',
                    type: 'line',
                    source: 'country-backdrop',
                    paint: {
                        'line-color': countryBackdropLineColor(),
                        'line-width': 2.2,
                        'line-opacity': 0,
                    },
                });
            }
        } catch (e) {
            return false;
        }

        map.flyTo({
            center: countryBackdrop.center,
            zoom: countryBackdrop.zoom,
            pitch: countryBackdrop.pitch,
            duration: 2000,
            essential: true,
        });
        map.once('moveend', function onCountryBackdropFramed() {
            map.off('moveend', onCountryBackdropFramed);
            try { map.setRenderWorldCopies(false); } catch (e) {}
            fadeCountryBackdropIn(1000);
            // Don't auto-reveal the default landing on top of a celebrate
            // takeover (post-win territories modal / no-free-slots) — see
            // spinCelebrateInit. This moveend fires ~2s after load, long
            // after the flag is set synchronously during init.
            if (!window.__pingCelebrateTakeover) revealJutdeeTenantLanding();
            countryBackdrop.active = true;
            countryBackdrop.ready = true;
            startCountryBackdropSpin();
        });
        return true;
    }

    // Animate the camera back to the idle map framing and resume ambient
    // rotation (whole-planet longitude spin or country bearing spin).
    function restoreIdleMapFraming(easeMs) {
        easeMs = typeof easeMs === 'number' ? easeMs : 900;
        if (countryBackdrop.active && countryBackdrop.center) {
            stopCountryBackdropSpin();
            autoSpin.active = false;
            try {
                map.easeTo({
                    center: countryBackdrop.center,
                    zoom: countryBackdrop.zoom,
                    pitch: countryBackdrop.pitch,
                    duration: easeMs,
                    essential: true,
                });
            } catch (e) {
                easeMs = 0;
            }
            setTimeout(function () {
                startCountryBackdropSpin();
            }, easeMs + 60);
            return;
        }
        var startLng = map.getCenter().lng;
        try {
            map.easeTo({ center: [startLng, 15], zoom: 1.8, pitch: 0, duration: easeMs, essential: true });
        } catch (e) {
            easeMs = 0;
        }
        setTimeout(function () {
            try { autoSpin.rotation = (map.getCenter().lng + 360) % 360; } catch (e) {}
            autoSpin.active = !(PL && PL.globeIdleSpinEnabled === false);
        }, easeMs + 60);
    }

    // Dark Matter has no `projection` field — force globe + fog on every
    // style load, then re-attach pink 3D buildings (same as subdomains).
    function applyGlobeChrome() {
        var landColor = PL && PL.globeLandColor;
        var faceColor = landColor || '#0a0a1a';
        try { map.setProjection({ type: 'globe' }); } catch(e) {}
        try {
            map.setFog({
                color: faceColor,
                'high-color': faceColor,
                'horizon-blend': 0.02,
                'space-color': '#0a0a1a',
                'star-intensity': 0.0,
            });
        } catch(e) {}
    }
    // On Carto Dark Matter the visible continents at globe zoom are the style
    // background (#0e0e0e) showing wherever water polygons do not cover —
    // landcover/landuse fills only paint forests, parks, cemeteries, etc.
    function applyGlobeLandColors() {
        var landColor = PL && PL.globeLandColor;
        if (!landColor) return;
        try {
            var style = map.getStyle();
            if (!style || !style.layers) return;
            style.layers.forEach(function (layer) {
                if (!layer || !layer.id) return;
                if (layer.type === 'background') {
                    map.setPaintProperty(layer.id, 'background-color', landColor);
                    return;
                }
                if (layer.type !== 'fill') return;
                if (layer.id.indexOf('country-backdrop') === 0) return;
                var sl = layer['source-layer'] || '';
                if (sl === 'water' || sl === 'building') return;
                if (/water|ocean|lake|river|waterway/i.test(layer.id)) return;
                if (sl === 'landcover' || sl === 'landuse' || sl === 'park') {
                    map.setPaintProperty(layer.id, 'fill-color', landColor);
                }
            });
        } catch (e) {}
    }
    function applyBuildingLight() {
        try {
            map.setLight({
                anchor: 'viewport',
                color: '#ffffff',
                intensity: 0.45,
                position: [1.4, 90, 80]
            });
        } catch (e) {}
    }
    function attachPinkBuildings() {
        if (map.getLayer(BUILDINGS_LAYER_ID)) return;
        var s = map.getStyle();
        if (!s || !s.sources) return;
        var sourceName = null;
        for (var n in s.sources) {
            if (s.sources[n] && s.sources[n].type === 'vector') {
                sourceName = n;
                break;
            }
        }
        if (!sourceName) return;
        var beforeId;
        var layers = s.layers || [];
        for (var i = 0; i < layers.length; i++) {
            if (layers[i].type === 'symbol') {
                beforeId = layers[i].id;
                break;
            }
        }
        try {
            map.addLayer({
                id: BUILDINGS_LAYER_ID,
                source: sourceName,
                'source-layer': 'building',
                type: 'fill-extrusion',
                minzoom: 13,
                paint: BUILDING_PAINT
            }, beforeId);
        } catch (e) {}
    }
    /** Localize Carto place labels (countries, continents, cities) from vector tile name:{locale}. */
    function pingMapLocale() {
        var l10n = window.__pingL10n || {};
        var raw = l10n.locale || document.documentElement.lang || 'en';
        return String(raw).split(/[-_]/)[0].toLowerCase();
    }
    function buildLocalizedPlaceNameExpr(locale) {
        locale = (locale || 'en').split(/[-_]/)[0].toLowerCase();
        if (locale === 'en') {
            return ['coalesce', ['get', 'name_en'], ['get', 'name:en'], ['get', 'name']];
        }
        return ['coalesce',
            ['get', 'name:' + locale],
            ['get', 'name_en'],
            ['get', 'name:en'],
            ['get', 'name'],
        ];
    }
    function applyGlobeCountryLabelVisibility() {
        if (!(PL && PL.globeHideCountryLabels)) return;
        try {
            var style = map.getStyle();
            if (!style || !style.layers) return;
            style.layers.forEach(function (layer) {
                if (!layer || layer.type !== 'symbol') return;
                var id = layer.id || '';
                if (id.indexOf('place_') === 0) {
                    map.setLayoutProperty(id, 'visibility', 'none');
                }
            });
        } catch (e) {}
    }
    function applyBasemapPlaceLabels() {
        if (_routeDetailStyleActive) return;
        var locale = pingMapLocale();
        var expr = buildLocalizedPlaceNameExpr(locale);
        var useUppercase = locale === 'en';
        try {
            var style = map.getStyle();
            if (!style || !style.layers) return;
            style.layers.forEach(function (layer) {
                if (!layer || layer.type !== 'symbol') return;
                var id = layer.id || '';
                var isPlace = id.indexOf('place_') === 0;
                var isWaterName = id.indexOf('watername_') === 0;
                if (!isPlace && !isWaterName) return;
                try {
                    map.setLayoutProperty(id, 'text-field', expr);
                    if (!useUppercase) {
                        var transform = map.getLayoutProperty(id, 'text-transform');
                        if (transform === 'uppercase') {
                            map.setLayoutProperty(id, 'text-transform', 'none');
                        }
                    }
                } catch (e) {}
            });
        } catch (e) {}
    }
    function applyMagentaMapLabels() {
        var labelColor = '#ff2bd6';
        var haloColor = 'rgba(10,14,30,0.92)';
        try {
            var style = map.getStyle();
            if (!style || !style.layers) return;
            style.layers.forEach(function (layer) {
                if (!layer || layer.type !== 'symbol') return;
                var id = layer.id;
                if (!id) return;
                try {
                    var textField = map.getLayoutProperty(id, 'text-field');
                    if (!textField) return;
                    map.setPaintProperty(id, 'text-color', labelColor);
                    map.setPaintProperty(id, 'text-halo-color', haloColor);
                    map.setPaintProperty(id, 'text-halo-width', 1.25);
                } catch (e) {}
            });
        } catch (e) {}
    }
    function applyBasemapChrome() {
        applyGlobeChrome();
        applyGlobeLandColors();
        attachPinkBuildings();
        applyBuildingLight();
        if (!_routeDetailStyleActive) {
            applyBasemapPlaceLabels();
            applyMagentaMapLabels();
            applyGlobeCountryLabelVisibility();
            // Vector labels can settle one frame after style.load.
            map.once('idle', function () {
                if (!_routeDetailStyleActive) {
                    applyBasemapPlaceLabels();
                    applyGlobeCountryLabelVisibility();
                }
            });
        }
    }
    map.on('style.load', applyBasemapChrome);

    // ── Basemap chrome toggle for in-game views ───────────────────────────
    // Dark Matter is a dense cartographic style (roads, buildings, POIs, labels).
    // During a minesweeper/dungeon run those layers clash with the game's
    // own hex grid and symbol layers — the scene stops reading cleanly,
    // and OpenFreeMap's symbol layers can collide with our own labels.
    // We hide every layer that isn't part of the "basemap backdrop"
    // (background, water, landcover/landuse, parks, boundaries) when a
    // game starts and restore the previous visibility on exit, so nothing
    // is permanently mutated on the shared style.
    var _basemapChromeSnapshot = null;
    function hideBasemapChrome() {
        if (_basemapChromeSnapshot) return;
        if (!jutdeeSpinSatellite.active) hideCountryBackdropLayers();
        try {
            var style = map.getStyle();
            if (!style || !style.layers) return;
            _basemapChromeSnapshot = {};
            style.layers.forEach(function(layer) {
                var id = layer.id || '';
                // Keep-list: anything that forms the "planet backdrop".
                var keep = layer.type === 'background'
                    || /water|ocean|lake|river|waterway/i.test(id)
                    || /land(cover|use)|park|wood|forest|grass|farmland|sand|glacier/i.test(id)
                    || /boundary|border|country|admin/i.test(id)
                    || (jutdeeSpinSatellite.active && id === jutdeeSpinSatellite.layerId);
                if (keep) return;
                var currentVis;
                try { currentVis = map.getLayoutProperty(id, 'visibility'); } catch(e) {}
                _basemapChromeSnapshot[id] = currentVis || 'visible';
                try { map.setLayoutProperty(id, 'visibility', 'none'); } catch(e) {}
            });
        } catch(e) {
            _basemapChromeSnapshot = null;
        }
    }
    function restoreBasemapChrome() {
        if (!_basemapChromeSnapshot) {
            if (!jutdeeSpinSatellite.active) showCountryBackdropLayers();
            return;
        }
        var snap = _basemapChromeSnapshot;
        _basemapChromeSnapshot = null;
        try {
            Object.keys(snap).forEach(function(id) {
                try { map.setLayoutProperty(id, 'visibility', snap[id]); } catch(e) {}
            });
        } catch(e) {}
        if (!jutdeeSpinSatellite.active) showCountryBackdropLayers();
    }

    // Hide the fixed top chrome (Eye Sockets, balance, logout) while a
    // map game HUD is active. CSS lives in ping-landing.css / blade, but
    // we also stamp inline display:none because production serves the
    // minified CSS bundle which may lag behind source edits.
    // Memoized list of the top-chrome nodes. These are static,
    // server-rendered elements, so we resolve them once and reuse the
    // array across every hide/restore toggle instead of re-running two
    // getElementById lookups plus a querySelectorAll each time. The
    // isConnected guard rebuilds the cache for free if the markup was
    // ever re-rendered, so we never act on detached nodes.
    var _pingTopChromeNodes = null;
    function getPingTopChromeNodes() {
        if (_pingTopChromeNodes && _pingTopChromeNodes.length
            && _pingTopChromeNodes.every(function (el) { return el.isConnected; })) {
            return _pingTopChromeNodes;
        }
        var nodes = [];
        var upgrade = document.getElementById('pingUpgradeBtn');
        if (upgrade) nodes.push(upgrade);
        document.querySelectorAll('.spin-intro-floating-top-left-bar, .spin-intro-floating-corner-bar').forEach(function(el) {
            nodes.push(el);
        });
        _pingTopChromeNodes = nodes;
        return nodes;
    }
    function setPingTopChromeHidden(hidden) {
        document.body.classList.toggle('is-ping-map-game-active', !!hidden);
        if (hidden) document.body.classList.add('ms-active');
        getPingTopChromeNodes().forEach(function(el) {
            if (hidden) {
                el.setAttribute('data-ping-game-chrome-hidden', '1');
                el.style.setProperty('display', 'none', 'important');
            } else if (el.getAttribute('data-ping-game-chrome-hidden')) {
                el.removeAttribute('data-ping-game-chrome-hidden');
                el.style.removeProperty('display');
            }
        });
    }

    // Inverse of setPingTopChromeHidden — restores Eye Sockets, balance,
    // logout, and the floating corner bar after a map game session.
    //
    // Self-guards: if no game / walk session hid the chrome (no body
    // state class set and no basemap snapshot captured), this is a
    // no-op. That keeps it cheap to call from hot paths like
    // finishIntroCarouselBannerLayout() (fires on every carousel slide
    // settle) — a normal slide swipe never touches the DOM query loop
    // or the map-layer restore.
    function restorePingLandingTopChrome() {
        var wasHidden = document.body.classList.contains('ms-active')
            || document.body.classList.contains('is-ping-map-game-active')
            || document.body.classList.contains('is-walk-earn-active')
            || !!_basemapChromeSnapshot;
        if (!wasHidden) return;
        document.body.classList.remove('ms-active');
        document.body.classList.remove('is-ping-map-game-active');
        document.body.classList.remove('is-walk-earn-active');
        setPingTopChromeHidden(false);
        try { restoreBasemapChrome(); } catch (e) {}
    }
    window.restorePingLandingTopChrome = restorePingLandingTopChrome;

    // ── Map fly-in location title (viewport top-left, z-index 40) ───────
    // Shown AFTER the camera fly-in settles (map `moveend`), not during
    // the animation. Lives at outer IIFE scope so spin-globe, focal-
    // point focus, town-focus, and any other map fly-in can share it.
    var _spinFlyinTitleEl = null;
    var _spinFlyinStatsEl = null;
    var _flyinTitleTrip = 0;
    function ensureSpinFlyinTitleEl() {
        if (_spinFlyinTitleEl && _spinFlyinTitleEl.parentNode === document.body) {
            return _spinFlyinTitleEl;
        }
        var el = document.getElementById('spinFlyinLocationTitle');
        if (!el) {
            el = document.createElement('p');
            el.id = 'spinFlyinLocationTitle';
            el.className = 'spin-flyin-location-title';
        }
        document.body.appendChild(el);
        _spinFlyinTitleEl = el;
        return el;
    }
    function flyinTitleZIndex() {
        if (document.body.classList.contains('is-route-focused')
            || document.body.classList.contains('is-gfe-focused')
            || document.body.classList.contains('is-gfe-import-flyin')) {
            return '51';
        }
        return '40';
    }
    function applySpinFlyinTitleChrome(el) {
        var mobile = false;
        try {
            mobile = window.matchMedia && window.matchMedia('(max-width: 500px)').matches;
        } catch (e) {}
        el.style.position = 'fixed';
        el.style.top = mobile ? '12px' : '18px';
        el.style.left = mobile ? '14px' : '18px';
        el.style.zIndex = flyinTitleZIndex();
        el.style.maxWidth = '45%';
        el.style.margin = '0';
        el.style.padding = '0';
        el.style.fontFamily = "'Fredoka',sans-serif";
        el.style.fontWeight = '700';
        el.style.fontSize = mobile
            ? 'clamp(22px, 5.5vw, 32px)'
            : 'clamp(30px, 7.25vw, 46px)';
        el.style.lineHeight = '1.15';
        el.style.letterSpacing = '-0.5px';
        el.style.color = '#fff';
        el.style.textShadow = '0 2px 14px rgba(0, 0, 0, 0.75), 0 1px 4px rgba(0, 0, 0, 0.9)';
        el.style.pointerEvents = 'none';
        el.style.overflowWrap = 'break-word';
    }
    function ensureSpinFlyinStatsEl() {
        if (_spinFlyinStatsEl && _spinFlyinStatsEl.parentNode === document.body) {
            return _spinFlyinStatsEl;
        }
        var el = document.getElementById('spinFlyinLocationStats');
        if (!el) {
            el = document.createElement('p');
            el.id = 'spinFlyinLocationStats';
            el.className = 'spin-flyin-location-stats';
        }
        document.body.appendChild(el);
        _spinFlyinStatsEl = el;
        return el;
    }
    function applySpinFlyinStatsChrome(el) {
        var mobile = false;
        try {
            mobile = window.matchMedia && window.matchMedia('(max-width: 500px)').matches;
        } catch (e) {}
        el.style.position = 'fixed';
        el.style.top = mobile ? '48px' : '62px';
        el.style.left = mobile ? '14px' : '18px';
        el.style.zIndex = flyinTitleZIndex();
        el.style.maxWidth = '55%';
        el.style.margin = '0';
        el.style.padding = '0';
        el.style.fontFamily = "'Fredoka',sans-serif";
        el.style.fontWeight = '500';
        el.style.fontSize = mobile ? '14px' : '16px';
        el.style.lineHeight = '1.25';
        el.style.letterSpacing = '0.01em';
        el.style.color = 'rgba(255, 255, 255, 0.92)';
        el.style.textShadow = '0 1px 10px rgba(0, 0, 0, 0.75), 0 1px 3px rgba(0, 0, 0, 0.9)';
        el.style.pointerEvents = 'none';
        el.style.overflowWrap = 'break-word';
    }
    function setSpinFlyinRouteStats(label) {
        var text = label ? String(label).trim() : '';
        if (!text || !document.body.classList.contains('is-route-focused')) {
            clearSpinFlyinRouteStats();
            return;
        }
        var el = ensureSpinFlyinStatsEl();
        applySpinFlyinStatsChrome(el);
        el.textContent = text;
        el.style.removeProperty('opacity');
        el.style.removeProperty('visibility');
        el.setAttribute('aria-hidden', 'false');
        el.classList.remove('is-revealed');
        void el.offsetWidth;
        requestAnimationFrame(function () {
            el.classList.add('is-revealed');
        });
    }
    function clearSpinFlyinRouteStats() {
        var el = _spinFlyinStatsEl || document.getElementById('spinFlyinLocationStats');
        if (!el) return;
        el.classList.remove('is-revealed');
        el.style.removeProperty('opacity');
        el.style.removeProperty('visibility');
        el.textContent = '';
        el.setAttribute('aria-hidden', 'true');
    }
    var _pingHeroFlyinData = null;
    var PING_HERO_SOCIALS = [
        { key: 'facebook',  icon: 'bi-facebook'  },
        { key: 'instagram', icon: 'bi-instagram' },
        { key: 'twitter',   icon: 'bi-twitter-x' },
        { key: 'linkedin',  icon: 'bi-linkedin'  },
        { key: 'youtube',   icon: 'bi-youtube'   },
        { key: 'tiktok',    icon: 'bi-tiktok'    }
    ];
    function pingHeroSocialHref(url) {
        var u = String(url || '').trim();
        if (!u) return '';
        if (u.indexOf('//') === 0) return 'https:' + u;
        if (/^https?:\/\//i.test(u)) return u;
        return 'https://' + u;
    }
    function collectPingHeroSocials(data) {
        if (!data) return [];
        var out = [];
        for (var i = 0; i < PING_HERO_SOCIALS.length; i++) {
            var spec = PING_HERO_SOCIALS[i];
            var raw = data[spec.key + '_url'];
            if (!raw) continue;
            var href = pingHeroSocialHref(raw);
            if (!href) continue;
            out.push({ key: spec.key, icon: spec.icon, href: href });
        }
        return out;
    }
    function renderPingHeroSocials(data) {
        var box = document.getElementById('pingHeroSocials');
        if (!box) return;
        box.innerHTML = '';
        var links = collectPingHeroSocials(data);
        if (!links.length) {
            box.setAttribute('aria-hidden', 'true');
            box.classList.remove('is-revealed');
            return;
        }
        for (var i = 0; i < links.length; i++) {
            var item = links[i];
            var label = item.key.charAt(0).toUpperCase() + item.key.slice(1);
            var a = document.createElement('a');
            a.className = 'ping-hero-chip-btn ping-hero-social-btn is-' + item.key;
            a.href = item.href;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            a.title = label;
            a.setAttribute('aria-label', label);
            a.innerHTML = '<i class="' + item.icon + '" aria-hidden="true"></i>';
            box.appendChild(a);
        }
    }
    function clearPingHeroSocials() {
        var box = document.getElementById('pingHeroSocials');
        if (!box) return;
        box.innerHTML = '';
        box.classList.remove('is-revealed');
        box.setAttribute('aria-hidden', 'true');
    }
    function clearPingHeroEditBtn() {
        var editBtn = document.getElementById('pingHeroEditBtn');
        if (!editBtn) return;
        editBtn.classList.remove('is-revealed');
        editBtn.setAttribute('aria-hidden', 'true');
    }
    function clearPingHeroRoutePathBtn() {
        var pathBtn = document.getElementById('pingHeroRoutePathBtn');
        if (!pathBtn) return;
        pathBtn.classList.remove('is-revealed');
        pathBtn.setAttribute('aria-hidden', 'true');
    }
    function revealPingHeroRoutePathBtn() {
        var pathBtn = document.getElementById('pingHeroRoutePathBtn');
        var band = document.getElementById('pingHeroBand');
        if (!pathBtn || !band || !band.classList.contains('is-editable')) return;
        if (!_pingHeroFlyinData || _pingHeroFlyinData._entity !== 'route') return;
        if (!document.body.classList.contains('is-route-focused')) return;
        pathBtn.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
            pathBtn.classList.add('is-revealed');
        });
    }
    function clearPingHeroStampBtn() {
        var stampBtn = document.getElementById('pingHeroStampBtn');
        if (!stampBtn) return;
        stampBtn.classList.remove('is-revealed');
        stampBtn.setAttribute('aria-hidden', 'true');
    }
    // `opts.editable === true` flags the fly-in as user-owned (slide-1
    // focal-point flow or importer "Your Locations" tile), which toggles
    // .is-editable on #pingHeroBand and reveals the hero pencil. Spin-
    // globe random / town / tour fly-ins omit opts and stay read-only.
    function bindPingHeroFlyinData(data, opts) {
        _pingHeroFlyinData = data || null;
        var band = document.getElementById('pingHeroBand');
        if (band) {
            if (opts && opts.editable) band.classList.add('is-editable');
            else band.classList.remove('is-editable');
        }
        if (opts && opts.skipHeroImage) {
            hidePingHeroLocationImageOnly();
            return;
        }
        var url = pickLocationHeroUrl(data);
        if (url) setPingHeroLocationImage(url);
    }

    /** Strip route/location hero chrome without clearing _pingHeroFlyinData. */
    function hidePingHeroLocationImageOnly() {
        var el = document.querySelector('.ping-bg-image');
        var img = document.getElementById('pingFlyinHeroImg');
        var band = document.getElementById('pingHeroBand');
        if (el) {
            el.classList.remove('is-location-hero');
            el.style.removeProperty('opacity');
            if (_pingBgDefaultImage) el.style.backgroundImage = _pingBgDefaultImage;
        }
        if (img) {
            img.hidden = true;
            img.removeAttribute('src');
        }
        if (band) band.classList.remove('is-location-hero');
    }

    // Hero pencil click → reuse the same #gfeEditModal the importer
    // "Your Locations" pencil opens (window.openGfeEditModal, wired in
    // wireGfeEditModal further down). Delegate on document so DOM-timing
    // doesn't matter, and gate on:
    //   • #pingHeroBand.is-editable (set by bindPingHeroFlyinData when
    //     the fly-in is user-owned — focal-point / importer)
    //   • _pingHeroFlyinData.id (defence against a stale band class)
    document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('#pingHeroEditBtn');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var band = document.getElementById('pingHeroBand');
        if (!band || !band.classList.contains('is-editable')) return;
        if (!_pingHeroFlyinData || !_pingHeroFlyinData.id) return;
        if (_pingHeroFlyinData._entity === 'route') {
            if (typeof window.openRouteEditModal !== 'function') {
                console.warn('[route-edit] openRouteEditModal missing — is #routeEditModal on the page?');
                return;
            }
            window.openRouteEditModal(_pingHeroFlyinData);
            return;
        }
        if (typeof window.openGfeEditModal !== 'function') {
            console.warn('[gfe-edit] openGfeEditModal global missing — modal partial not mounted?');
            return;
        }
        if (typeof window.closeGfeLocationRewardModal === 'function') {
            window.closeGfeLocationRewardModal(true);
        }
        window.openGfeEditModal(_pingHeroFlyinData);
    });

    document.addEventListener('click', function (e) {
        var pathBtn = e.target && e.target.closest && e.target.closest('#pingHeroRoutePathBtn');
        if (!pathBtn) return;
        e.preventDefault();
        e.stopPropagation();
        var pathBand = document.getElementById('pingHeroBand');
        if (!pathBand || !pathBand.classList.contains('is-editable')) return;
        if (!_pingHeroFlyinData || _pingHeroFlyinData._entity !== 'route') return;
        if (typeof window.RouteGeometryEditor !== 'object' || typeof window.RouteGeometryEditor.open !== 'function') {
            console.warn('[route-geometry] RouteGeometryEditor missing');
            return;
        }
        if (window.RouteGeometryEditor.isActive()) return;
        var map = typeof window.pingLandingGetMap === 'function' ? window.pingLandingGetMap() : null;
        if (!map) return;
        var feature = routeOverlayState.feature;
        if (!feature && routeOverlayState.geoUrl) {
            fetch(routeOverlayState.geoUrl)
                .then(function (r) { return r.json(); })
                .then(function (f) {
                    routeOverlayState.feature = f;
                    openRouteGeometryEditor(map, f);
                })
                .catch(function (err) {
                    console.warn('[route-geometry] fetch failed', err);
                    try { window.alert('Could not load route path for editing.'); } catch (ae) { /* noop */ }
                });
            return;
        }
        if (!feature) {
            try { window.alert('Could not load route path for editing.'); } catch (ae) { /* noop */ }
            return;
        }
        openRouteGeometryEditor(map, feature);
    });

    function openRouteGeometryEditor(map, feature) {
        var rid = routeOverlayState.routeId || (_pingHeroFlyinData && _pingHeroFlyinData.id);
        if (!rid) return;
        function launchEditor() {
            window.RouteGeometryEditor.open({
                map: map,
                routeId: rid,
                feature: feature,
                kind: routeOverlayState.kind || 'route',
                sourceId: routeOverlayState.sourceId,
                layerId: routeOverlayState.layerId,
                onSaved: function (savedRoute, savedFeature) {
                    routeOverlayState.feature = savedFeature;
                    if (savedFeature.geometry) {
                        var g = savedFeature.geometry;
                        if (g.type === 'LineString') routeOverlayState.coords = g.coordinates || [];
                        else if (g.type === 'Polygon' && g.coordinates) routeOverlayState.coords = g.coordinates[0] || [];
                    }
                    if (savedRoute.kind) routeOverlayState.kind = savedRoute.kind;
                    if (savedRoute.geojson_url) routeOverlayState.geoUrl = savedRoute.geojson_url;
                    _redrawRouteCanvas(map, routeOverlayState.coords);
                    try {
                        document.dispatchEvent(new CustomEvent('route-edited', {
                            detail: { id: rid, route: savedRoute },
                        }));
                    } catch (evErr) { /* noop */ }
                },
            });
        }
        if (routeOverlayState.mapMode === 'detail') {
            launchEditor();
            return;
        }
        _swapRouteMapToDetail(map, launchEditor);
    }

    document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('#pingHeroStampBtn');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var band = document.getElementById('pingHeroBand');
        if (!band || !band.classList.contains('is-editable')) return;
        if (!_pingHeroFlyinData) return;
        var locId = _pingHeroFlyinData.id != null ? _pingHeroFlyinData.id : _pingHeroFlyinData.fpid;
        if (locId == null || locId === '') return;
        if (typeof window.openGfeLocationRewardModal !== 'function') {
            console.warn('[gfe-reward] openGfeLocationRewardModal missing — is #gfeLocationRewardModal on the page?');
            return;
        }
        if (typeof window.closeGfeEditModal === 'function') {
            window.closeGfeEditModal(true);
        }
        window.openGfeLocationRewardModal(_pingHeroFlyinData);
    });

    /**
     * Insert (or skip if present) a location in slide-1's #pingFpLocationsList.
     * Server-rendered on first paint; imports only patched the importer panel
     * until this ran, so new GamifEYEs were missing after fly-in until refresh.
     */
    function appendPingFpLocationItem(data) {
        if (!data || data.id == null) return null;

        var list = document.getElementById('pingFpLocationsList');
        if (!list) return null;

        var id = String(data.id);
        var enc = id.replace(/"/g, '\\"');
        if (list.querySelector('.ping-fp-location-item[data-fpid="' + enc + '"]')) {
            return null;
        }

        var lat = parseFloat(data.latitude != null ? data.latitude : data.lat);
        var lng = parseFloat(data.longitude != null ? data.longitude : data.lng);
        if (!isFinite(lat) || !isFinite(lng)) return null;

        var title = data.title ? String(data.title) : 'Untitled';
        var logoUrl = data.logo_url || data.logo || '';
        var slug = data.subdomain_slug ? String(data.subdomain_slug) : '';
        var areaId = data.eyeland_area_id != null ? data.eyeland_area_id : '';
        var hexCount = parseInt(data.hex_count, 10);
        if (!isFinite(hexCount) || hexCount < 0) hexCount = 1;
        var category = data.primary_category_display_name || data.primary_category || '';
        var addr = data.address ? String(data.address) : '';
        var desc = data.description ? String(data.description) : '';
        var isPublic = !!data.is_public;

        function escHtml(s) {
            return String(s || '').replace(/[&<>"']/g, function (c) {
                return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
            });
        }

        var payload = {
            id:                            data.id,
            title:                         title,
            address:                       addr,
            latitude:                      lat,
            longitude:                     lng,
            logo_url:                      logoUrl,
            subdomain_slug:                slug,
            description:                   desc,
            phone:                         data.phone || null,
            website:                       data.website || null,
            eyeland_area_id:               areaId || null,
            hex_count:                     hexCount,
            hexes:                         Array.isArray(data.hexes) ? data.hexes : [],
            facebook_url:                  data.facebook_url || null,
            instagram_url:                 data.instagram_url || null,
            twitter_url:                   data.twitter_url || null,
            linkedin_url:                  data.linkedin_url || null,
            youtube_url:                   data.youtube_url || null,
            tiktok_url:                    data.tiktok_url || null,
            custom_domain:                 data.custom_domain || null,
            custom_domain_active:          !!data.custom_domain_active,
            custom_domain_status:          data.custom_domain_status || null,
            google_place_id:               data.google_place_id || null,
            is_public:                     isPublic,
            is_visit_mechanic_enabled:     !!data.is_visit_mechanic_enabled,
            is_branch_stamps_enabled:      data.is_branch_stamps_enabled !== false && data.is_branch_stamps_enabled !== 0 && data.is_branch_stamps_enabled !== '0',
            show_location_on_map:          locationShowsOnMap(data),
            visit_duration_minutes:        parseInt(data.visit_duration_minutes, 10) || 0,
            arrival_radius_m:              parseInt(data.arrival_radius_m, 10) || 0,
        };

        var card = document.createElement('a');
        card.href = '/focal-points?fp=' + encodeURIComponent(id);
        card.className = 'territory-modal-item gfe-towns-item gfe-loc-item ping-fp-location-item';
        card.setAttribute('draggable', 'false');
        card.setAttribute('data-fpid', id);
        card.setAttribute('data-slug', slug);
        card.setAttribute('data-lat', String(lat));
        card.setAttribute('data-lng', String(lng));
        card.setAttribute('data-title', title);
        card.setAttribute('data-logo', logoUrl);
        card.setAttribute('data-areaid', areaId === '' ? '' : String(areaId));
        card.setAttribute('data-hexes', '[]');
        card.setAttribute('data-gfe-loc-id', id);
        card.setAttribute('data-gfe-loc-lat', String(lat));
        card.setAttribute('data-gfe-loc-lng', String(lng));
        card.setAttribute('data-gfe-loc-title', title);
        card.setAttribute('data-gfe-loc-logo', logoUrl);
        try {
            card.setAttribute('data-gfe-loc-payload', JSON.stringify(payload));
        } catch (jsonErr) {
            card.setAttribute('data-gfe-loc-payload', '{}');
        }

        var thumbHtml = logoUrl
            ? '<img class="territory-modal-item-thumb" src="' + escHtml(logoUrl) + '" alt="' + escHtml(title) + '" loading="lazy" onerror="this.outerHTML=\'<div class=&quot;territory-modal-item-icon&quot;><i class=&quot;bi bi-shop&quot;></i></div>\'">'
            : '<div class="territory-modal-item-icon"><i class="bi bi-shop"></i></div>';

        var badgeHtml = hexCount > 0
            ? '<span class="ping-fp-slide1-loc-badge">' +
                '<i class="bi bi-hexagon-half ping-fp-slide1-loc-badge-icon" aria-hidden="true"></i>' +
                '<span class="ping-fp-slide1-loc-badge-count">' + hexCount + '</span>' +
              '</span>'
            : '';

        var countryHtml = category
            ? '<div class="territory-modal-item-country">' + escHtml(category) + '</div>'
            : (addr ? '<div class="territory-modal-item-country">' + escHtml(addr.length > 80 ? addr.slice(0, 80) : addr) + '</div>' : '');

        var extractHtml = desc
            ? '<div class="territory-modal-item-extract">' + escHtml(desc.length > 140 ? desc.slice(0, 140) : desc) + '</div>'
            : '';

        var metaHtml = '<div class="territory-modal-item-meta">';
        if (slug) {
            metaHtml += '<span title="Public listing"><i class="bi bi-link-45deg"></i> ' + escHtml(window.gfeSubdomainHost(slug)) + '</span>';
        }
        metaHtml += '<span><i class="bi bi-hexagon"></i> ' + hexCount + '</span>';
        if (!isPublic) {
            metaHtml += '<span style="color:#fbbf24;"><i class="bi bi-eye-slash"></i> Private</span>';
        }
        metaHtml += '</div>';

        card.innerHTML =
            thumbHtml +
            '<div class="territory-modal-item-body">' +
                '<div class="territory-modal-item-name">' +
                    '<span class="ping-fp-slide1-loc-title">' + escHtml(title) + '</span>' +
                '</div>' +
                badgeHtml +
                countryHtml +
                extractHtml +
                metaHtml +
            '</div>';

        var firstLoc = list.querySelector('.ping-fp-location-item');
        var firstEmpty = list.querySelector('[data-ping-fp-empty-slot]');
        if (firstLoc) {
            list.insertBefore(card, firstLoc);
        } else if (firstEmpty) {
            list.insertBefore(card, firstEmpty);
        } else {
            list.appendChild(card);
        }

        var emptySlot = list.querySelector('[data-ping-fp-empty-slot]');
        if (emptySlot) {
            var slotCount = parseInt(emptySlot.getAttribute('data-available-slots-count') || '1', 10);
            setAvailableSlotsCount(emptySlot, slotCount - 1);
        }

        var viewportFp = document.getElementById('spinIntroAuthedCarouselViewport');
        if (viewportFp) {
            var fpRem = parseInt(viewportFp.getAttribute('data-focal-slots-remaining') || '0', 10);
            if (!isNaN(fpRem) && fpRem > 0) {
                viewportFp.setAttribute('data-focal-slots-remaining', String(fpRem - 1));
            }
        }

        card.classList.add('is-fresh-import');
        card.addEventListener('animationend', function once() {
            card.classList.remove('is-fresh-import');
            card.removeEventListener('animationend', once);
        });

        if (typeof window.syncSpinIntroFocalPointsTable === 'function') {
            window.syncSpinIntroFocalPointsTable();
        }

        return card;
    }
    window.appendPingFpLocationItem = appendPingFpLocationItem;

    // ── Route Recorder: append a route item card to slide 3 ──────────

    function wirePingFpRouteDeleteBtn(card, routeId) {
        var delBtn = card && card.querySelector('.ping-fp-route-item-delete');
        if (!delBtn || delBtn.__routeDeleteWired) return;
        delBtn.__routeDeleteWired = true;
        delBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!confirm('Delete this route? This cannot be undone.')) return;
            delBtn.disabled = true;
            var csrfMeta = document.querySelector('meta[name="csrf-token"]');
            var csrf = csrfMeta ? csrfMeta.getAttribute('content') : '';
            fetch('/user-routes/' + parseInt(routeId, 10), {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: { 'X-CSRF-TOKEN': csrf, 'Accept': 'application/json' },
            })
            .then(function (res) {
                if (!res.ok) throw new Error(res.status);
                card.remove();
                var listEl = document.getElementById('pingFpRoutesList');
                if (listEl && !listEl.querySelector('.ping-fp-route-item')) {
                    listEl.className = 'gfe-towns-empty ping-fp-routes-empty';
                    listEl.id = 'pingFpRoutesList';
                    listEl.innerHTML = '<div class="gfe-towns-empty-icon"><i class="bi bi-map"></i></div>'
                        + '<h4>No recorded routes yet.</h4>'
                        + '<p>Tap "Create A Route" to start recording your first walk or run.</p>';
                }
            })
            .catch(function () {
                delBtn.disabled = false;
                if (typeof window.pingLandingShowToast === 'function') {
                    window.pingLandingShowToast('Could not delete route. Please try again.', 4000);
                }
            });
        });
    }
    window.wirePingFpRouteDeleteBtn = wirePingFpRouteDeleteBtn;

    function formatAvailableSlotsLabel(count) {
        var n = Math.max(0, parseInt(count, 10) || 0);
        var l10n = window.__pingL10n || {};
        if (n === 1) {
            return l10n.availableSlotSingular || '1 Available Slot';
        }
        var fmt = l10n.availableSlotsFmt || ':n Available Slots';
        return fmt.replace(':n', String(n));
    }

    function setAvailableSlotsCount(slotEl, count) {
        if (!slotEl) {
            return;
        }
        count = Math.max(0, parseInt(count, 10) || 0);
        if (count <= 0) {
            slotEl.parentNode && slotEl.parentNode.removeChild(slotEl);
            return;
        }
        slotEl.setAttribute('data-available-slots-count', String(count));
        var label = slotEl.querySelector('[data-available-slots-label]');
        if (label) {
            label.textContent = formatAvailableSlotsLabel(count);
        }
        slotEl.setAttribute('aria-label', formatAvailableSlotsLabel(count));
    }

    function decrementAvailableSlotsBadge(selector) {
        var slot = document.querySelector(selector);
        if (!slot) {
            return;
        }
        var count = parseInt(slot.getAttribute('data-available-slots-count') || '0', 10);
        setAvailableSlotsCount(slot, count - 1);
    }

    function buildAvailableSlotsBadge(options) {
        options = options || {};
        var count = Math.max(1, parseInt(options.count, 10) || 1);
        var kind = options.kind || 'territory';
        var atCap = !!options.atCap;
        var tag = options.tag || 'div';
        var el = document.createElement(tag);
        el.className = 'territory-modal-item ping-fp-slide1-loc-empty ping-fp-available-slots-badge';
        if (atCap) {
            el.classList.add('ping-fp-slide1-loc-empty--at-cap');
        }
        if (kind === 'territory') {
            el.classList.add('ping-fp-slide2-empty-placeholder');
            el.setAttribute('data-ping-fp-empty-territory-slot', '');
            el.setAttribute('aria-hidden', 'true');
        } else if (kind === 'focal_point') {
            el.setAttribute('data-ping-fp-empty-slot', '');
            if (atCap) {
                el.setAttribute('data-ping-fp-empty-slot-at-cap', '1');
            }
            el.setAttribute('role', 'button');
            el.setAttribute('tabindex', '0');
        } else if (kind === 'route') {
            el.setAttribute('data-ping-fp-empty-route-slot', '');
            if (atCap) {
                el.setAttribute('data-ping-fp-empty-route-slot-at-cap', '1');
            }
            el.setAttribute('role', 'button');
            el.setAttribute('tabindex', '0');
        }
        var wrap = document.createElement('span');
        wrap.className = 'ping-fp-slide1-loc-empty-icon ping-fp-available-slots-label-wrap';
        wrap.setAttribute('aria-hidden', 'true');
        var label = document.createElement('span');
        label.className = 'ping-fp-available-slots-label';
        label.setAttribute('data-available-slots-label', '');
        wrap.appendChild(label);
        el.appendChild(wrap);
        setAvailableSlotsCount(el, count);
        return el;
    }

    function isRouteSlotCap() {
        var viewport = document.getElementById('spinIntroAuthedCarouselViewport');
        if (viewport) {
            var rem = viewport.getAttribute('data-route-slots-remaining');
            if (rem !== null && rem !== '' && parseInt(rem, 10) <= 0) {
                return true;
            }
        }
        var capBtn = document.getElementById('routeRecorderStartBtn');
        if (capBtn && capBtn.classList.contains('is-route-cap')) {
            return true;
        }
        return !!document.querySelector('[data-ping-fp-empty-route-slot-at-cap]');
    }

    function isTerritorySlotCap() {
        return getTerritorySlotsRemaining() <= 0;
    }

    function getTerritorySlotsRemaining() {
        var vp = document.getElementById('spinIntroAuthedCarouselViewport');
        if (vp) {
            var raw = vp.getAttribute('data-territory-slots-remaining');
            if (raw !== null && raw !== '') {
                return Math.max(0, parseInt(raw, 10) || 0);
            }
        }
        var list = document.getElementById('gfeTownsList');
        if (list) {
            var slot = list.querySelector('[data-ping-fp-empty-territory-slot]');
            if (slot) {
                var domCount = parseInt(slot.getAttribute('data-available-slots-count') || '0', 10);
                if (domCount > 0) {
                    return domCount;
                }
            }
        }
        return 0;
    }

    function setTerritorySlotsRemaining(n) {
        n = Math.max(0, parseInt(n, 10) || 0);
        var vp = document.getElementById('spinIntroAuthedCarouselViewport');
        if (vp) {
            vp.setAttribute('data-territory-slots-remaining', String(n));
        }
        appendTerritoryEmptySlot();
        if (typeof window.syncSpinIntroTerritoriesTable === 'function') {
            window.syncSpinIntroTerritoriesTable();
        }
        if (typeof window.syncSpinIntroFocalPointsTable === 'function') {
            window.syncSpinIntroFocalPointsTable();
        }
        syncTerritorySpinCapChrome();
    }

    function needsTerritorySlotReserve() {
        return isTerritorySlotCap() && getPingSlotBankBalance() > 0;
    }

    function handleTerritoryReserveSuccess(data, options) {
        options = options || {};
        if (data && typeof data.empty_territory_slots === 'number') {
            setTerritorySlotsRemaining(data.empty_territory_slots);
        }
        if (typeof window.applyPingSlotBankFromResponse === 'function') {
            applyPingSlotBankFromResponse(data);
        }
        appendTerritoryEmptySlot();
        syncTerritorySlotBankTiles();
        syncTerritorySpinCapChrome();
        if (options.showToast !== false && typeof window.pingLandingShowToast === 'function') {
            window.pingLandingShowToast(
                'Territory slot unlocked. Spin below to claim your next town.',
                4500
            );
        }
        if (options.thenSpin && typeof window.triggerPingSpin === 'function') {
            window.triggerPingSpin(options.thenSpin);
        }
    }

    function reserveTerritorySlotFromBank(options) {
        options = options || {};
        if (getPingSlotBankBalance() < 1) {
            return Promise.resolve({ ok: false });
        }
        if (window.__territoryReserveInFlight) {
            return Promise.resolve({ ok: false });
        }
        window.__territoryReserveInFlight = true;
        var csrfMeta = document.querySelector('meta[name="csrf-token"]');
        var csrf = csrfMeta ? csrfMeta.getAttribute('content') : '';
        return fetch('/slot-bank/reserve', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': csrf,
                'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                resource_type: 'territory',
                preemptive: !!options.preemptive,
            }),
        })
            .then(function (r) {
                return r.json().then(function (d) {
                    return { ok: r.ok, data: d };
                });
            })
            .then(function (res) {
                if (!res.ok || (res.data && res.data.status === 'error')) {
                    if (res.data && typeof res.data.empty_territory_slots === 'number') {
                        setTerritorySlotsRemaining(res.data.empty_territory_slots);
                    }
                    if (res.data && res.data.error === 'slot_bank_empty') {
                        openSlotUpgrade('territory', null);
                    } else if (options.showToast !== false && typeof window.pingLandingShowToast === 'function') {
                        window.pingLandingShowToast(
                            (res.data && res.data.message) || 'Could not add territory slot.',
                            4000
                        );
                    }
                    syncTerritorySlotBankTiles();
                    syncTerritorySpinCapChrome();
                    return { ok: false };
                }
                handleTerritoryReserveSuccess(res.data, options);
                return { ok: true };
            })
            .catch(function () {
                if (options.showToast !== false && typeof window.pingLandingShowToast === 'function') {
                    window.pingLandingShowToast('Network error. Try again.', 3000);
                }
                return { ok: false };
            })
            .finally(function () {
                window.__territoryReserveInFlight = false;
            });
    }

    function applyTerritoryBankToGrid(options) {
        options = options || {};
        if (!document.getElementById('gfeTownsList')) {
            return Promise.resolve(false);
        }
        if (getPingSlotBankBalance() < 1) {
            return Promise.resolve(false);
        }
        if (window.__territoryReserveInFlight) {
            return Promise.resolve(false);
        }
        return reserveTerritorySlotFromBank(Object.assign({ preemptive: true }, options)).then(function (res) {
            if (!res || !res.ok) {
                return false;
            }
            if (getPingSlotBankBalance() < 1) {
                return true;
            }
            return applyTerritoryBankToGrid(options);
        });
    }

    function autoReserveTerritorySlotIfEligible(options) {
        if (!document.getElementById('gfeTownsList')) {
            return Promise.resolve(false);
        }
        if (getPingSlotBankBalance() < 1) {
            return Promise.resolve(false);
        }
        if (!isTerritorySlotCap()) {
            return Promise.resolve(false);
        }
        return reserveTerritorySlotFromBank(options).then(function (res) {
            if (!res || !res.ok) {
                return false;
            }
            if (getPingSlotBankBalance() < 1 || !isTerritorySlotCap()) {
                return true;
            }
            return autoReserveTerritorySlotIfEligible(options).then(function (more) {
                return true || more;
            });
        });
    }

    /**
     * Paint a newly claimed town into slide 2 without a full page reload.
     */
    function appendTerritoryTownFromClaim(data) {
        if (!data || !data.territory_id) return false;

        var list = document.getElementById('gfeTownsList');
        if (!list) return false;

        var tid = String(data.territory_id);
        var enc = tid.replace(/"/g, '\\"');
        if (list.querySelector('.ping-fp-slide2-town-item[data-id="' + enc + '"]')) {
            return true;
        }

        // Full empty-state panel (no grid mount) — reload is the reliable path.
        if (list.querySelector('.gfe-towns-empty, .ping-fp-rewards-empty')) {
            return false;
        }

        var name = data.area_name ? String(data.area_name) : 'Territory';
        var areaId = data.area_id != null ? String(data.area_id) : '';
        var hexCount = parseInt(data.hex_count, 10);
        if (!isFinite(hexCount) || hexCount < 1) hexCount = 1;

        function applyClaimDailyAuraAttrs(card, claimData) {
            var da = claimData && claimData.daily_aura;
            if (claimData && claimData.area_km2 != null && claimData.area_km2 !== '') {
                card.setAttribute('data-area-km2', String(claimData.area_km2));
            }
            if (!da) return;
            card.setAttribute('data-daily-aura-amount', String(parseInt(da.amount, 10) || 0));
            card.setAttribute('data-daily-aura-collectible', da.collectible ? '1' : '0');
            card.setAttribute('data-daily-aura-collected', da.collected ? '1' : '0');
            if (da.expires_at) {
                card.setAttribute('data-daily-aura-expires-at', da.expires_at);
            } else {
                card.removeAttribute('data-daily-aura-expires-at');
            }
            if (da.next_available_at) {
                card.setAttribute('data-daily-aura-next-at', da.next_available_at);
            } else {
                card.removeAttribute('data-daily-aura-next-at');
            }
            if (da.period) {
                card.setAttribute('data-daily-aura-period', da.period);
            } else {
                card.removeAttribute('data-daily-aura-period');
            }
        }

        var card = document.createElement('a');
        card.className = 'territory-modal-item gfe-towns-item ping-fp-slide2-town-item';
        card.href = '#';
        card.setAttribute('data-id', tid);
        if (areaId) card.setAttribute('data-eyeland-area-id', areaId);
        if (data.area_lat != null && data.area_lat !== '') {
            card.setAttribute('data-area-lat', String(data.area_lat));
        }
        if (data.area_lng != null && data.area_lng !== '') {
            card.setAttribute('data-area-lng', String(data.area_lng));
        }
        if (data.boundary_ring && data.boundary_ring.length >= 3) {
            rememberTownBoundaryRing(areaId, data.boundary_ring);
        }
        card.setAttribute('data-name', name);
        var claimCountry = data.country != null && data.country !== ''
            ? String(data.country).trim()
            : '';
        var claimCountryCode = data.country_code != null && data.country_code !== ''
            ? String(data.country_code).trim().toLowerCase()
            : '';
        if (claimCountry) card.setAttribute('data-country', claimCountry);
        if (claimCountryCode) card.setAttribute('data-country-code', claimCountryCode);
        card.setAttribute('data-hex-count', String(hexCount));
        card.setAttribute('draggable', 'false');

        var icon = document.createElement('div');
        icon.className = 'territory-modal-item-icon';
        icon.innerHTML = '<i class="bi bi-hexagon-fill"></i>';

        var body = document.createElement('div');
        body.className = 'territory-modal-item-body';
        var nameWrap = document.createElement('div');
        nameWrap.className = 'territory-modal-item-name';
        var titleSpan = document.createElement('span');
        titleSpan.className = 'ping-fp-slide2-town-title';
        titleSpan.textContent = name;
        nameWrap.appendChild(titleSpan);
        body.appendChild(nameWrap);
        card.appendChild(icon);
        card.appendChild(body);
        applyClaimDailyAuraAttrs(card, data);

        var firstTown = list.querySelector('.ping-fp-slide2-town-item');
        if (firstTown) {
            list.appendChild(card);
        } else {
            var badge = list.querySelector('[data-ping-fp-empty-territory-slot]');
            if (badge) {
                list.insertBefore(card, badge.nextSibling);
            } else {
                list.appendChild(card);
            }
        }
        var emptySlot = list.querySelector('[data-ping-fp-empty-territory-slot]');
        if (emptySlot) {
            var terrCount = parseInt(emptySlot.getAttribute('data-available-slots-count') || '1', 10);
            setAvailableSlotsCount(emptySlot, terrCount - 1);
        }
        setTerritorySlotsRemaining(getTerritorySlotsRemaining() - 1);
        syncTerritorySlotBankTiles();
        syncTerritorySpinCapChrome();
        window.__pingLastClaimedTerritoryId = tid;
        if (typeof window.pingLandingSyncTerritoryCard === 'function') {
            window.pingLandingSyncTerritoryCard(card);
        }
        if (typeof window.syncSpinIntroTerritoriesTable === 'function') {
            window.syncSpinIntroTerritoriesTable();
        }
        if (typeof window.syncSpinIntroFocalPointsTable === 'function') {
            window.syncSpinIntroFocalPointsTable();
        }
        return true;
    }

    function appendTerritoryEmptySlot() {
        var list = document.getElementById('gfeTownsList');
        if (!list) {
            return;
        }
        var remaining = getTerritorySlotsRemaining();
        var slot = list.querySelector('[data-ping-fp-empty-territory-slot]');
        if (remaining <= 0) {
            if (slot) {
                slot.remove();
            }
            return;
        }
        if (!slot) {
            slot = buildAvailableSlotsBadge({ count: remaining, kind: 'territory' });
            var firstTown = list.querySelector('.ping-fp-slide2-town-item');
            if (firstTown) {
                list.insertBefore(slot, firstTown);
            } else {
                var bankTile = list.querySelector('[data-ping-fp-slot-bank-plus], [data-ping-fp-slot-upgrade]');
                if (bankTile) {
                    list.insertBefore(slot, bankTile.nextSibling);
                } else {
                    list.insertBefore(slot, list.firstChild);
                }
            }
        } else {
            setAvailableSlotsCount(slot, remaining);
        }
    }

    function setTerritorySpinUpgradeMode(upgrade) {
        var btn = document.getElementById('spinGlobeBtn');
        if (!btn) {
            return;
        }
        var l10n = window.__pingL10n || {};
        var line1 = l10n.spinGlobeUpgradeLine1 || 'Upgrade To Add';
        var line2 = l10n.spinGlobeUpgradeLine2 || 'More Territories';
        var label = btn.querySelector('.spin-label');
        var sub = btn.querySelector('.spin-sub');
        if (upgrade) {
            btn.classList.add('spin-globe-pill--secondary');
            if (label) {
                label.textContent = line1;
            }
            if (sub) {
                sub.textContent = line2;
                sub.style.display = '';
            }
            btn.setAttribute('aria-label', line1 + ' ' + line2);
            return;
        }
        btn.classList.remove('spin-globe-pill--secondary');
        var trigger = document.getElementById('spinGlobeTrigger');
        if (trigger) {
            var freeLeft = trigger.getAttribute('data-free-spins-left');
            var freeTotal = trigger.getAttribute('data-free-spins-total');
            if (freeLeft != null) {
                btn.setAttribute('data-free-spins-left', freeLeft);
            }
            if (freeTotal != null) {
                btn.setAttribute('data-free-spins-total', freeTotal);
            }
        }
    }

    function ensureWalkEarnButton() {
        if (document.getElementById('spinJutdeeAuthedCtaMount')) {
            return;
        }
        var walkBtn = document.getElementById('spinWalkEarnBtn');
        if (!walkBtn) {
            var tpl = document.getElementById('spinWalkEarnBtnTpl');
            var actions = document.querySelector('#spinIntroBottomStack .spin-intro-bottom-actions');
            if (!tpl || !actions) {
                return;
            }
            actions.appendChild(tpl.content.cloneNode(true));
        }
        if (typeof window.wireSpinWalkEarnButton === 'function') {
            window.wireSpinWalkEarnButton();
        }
    }

    function syncTerritorySpinCapChrome() {
        var trigger = document.getElementById('spinGlobeTrigger')
            || document.getElementById('spinGlobeTriggerAuthedSentinel');
        if (!trigger) {
            return;
        }
        var showUpgrade = isTerritorySlotCap() && getPingSlotBankBalance() < 1;
        if (showUpgrade) {
            trigger.classList.add('is-location-cap');
            setTerritorySpinUpgradeMode(true);
            return;
        }
        trigger.classList.remove('is-location-cap');
        setTerritorySpinUpgradeMode(false);
        ensureWalkEarnButton();
        if (typeof window.pingLandingUpdateSpinGlobeSub === 'function') {
            window.pingLandingUpdateSpinGlobeSub();
        }
        if (typeof window.__jutdeeSyncTerritoriesTableSpinBtn === 'function') {
            window.__jutdeeSyncTerritoriesTableSpinBtn();
        }
    }

    function reserveTerritorySlot(e) {
        var tile = e.target && e.target.closest
            ? e.target.closest('[data-ping-fp-slot-bank-plus]')
            : null;
        if (!tile || getPingSlotBankBalance() < 1) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (tile.__territoryReserveBusy) {
            return;
        }
        tile.__territoryReserveBusy = true;
        reserveTerritorySlotFromBank().finally(function () {
            tile.__territoryReserveBusy = false;
        });
    }

    function startTerritoryClaimSpin(triggerEl) {
        if (needsTerritorySlotReserve()) {
            if (getPingSlotBankBalance() < 1) {
                openSlotUpgrade('territory', triggerEl);
                return;
            }
            reserveTerritorySlotFromBank({ thenSpin: triggerEl, showToast: false });
            return;
        }
        if (isTerritorySlotCap()) {
            openSlotUpgrade('territory', triggerEl);
            return;
        }
        if (typeof window.triggerPingSpin === 'function') {
            window.triggerPingSpin(triggerEl);
        }
    }

    function getPingSlotBankBalance() {
        var vp = document.getElementById('spinIntroAuthedCarouselViewport');
        if (vp) {
            var raw = vp.getAttribute('data-slot-bank-balance');
            if (raw !== null && raw !== '') {
                return Math.max(0, parseInt(raw, 10) || 0);
            }
        }
        return 0;
    }

    function formatPingEyeSocketsLabel(n) {
        n = Math.max(0, parseInt(n, 10) || 0);
        var l10n = window.__pingL10n || {};
        if (n === 1 && l10n.eyeSocketOne) {
            return l10n.eyeSocketOne;
        }
        var tpl = l10n.eyeSockets || (n + ' Eye Sockets');
        return String(tpl).replace(':count', String(n)).replace(':n', String(n));
    }

    function setPingSlotBankBalance(n) {
        n = Math.max(0, parseInt(n, 10) || 0);
        var label = formatPingEyeSocketsLabel(n);
        var vp = document.getElementById('spinIntroAuthedCarouselViewport');
        if (vp) {
            vp.setAttribute('data-slot-bank-balance', String(n));
        }
        var upgradeBtn = document.getElementById('pingUpgradeBtn');
        if (upgradeBtn) {
            upgradeBtn.setAttribute('data-slot-bank-balance', String(n));
        }
        var balanceEl = document.getElementById('pingUpgradeBtnBalance');
        if (balanceEl) {
            balanceEl.textContent = label;
        }
        var title = document.getElementById('pingUpgradesTitle');
        if (title) {
            title.textContent = label;
        }
        if (n <= 0) {
            document.querySelectorAll('[data-ping-fp-slot-bank-plus]').forEach(function (el) {
                el.remove();
            });
        }
    }

    function buildSlotBankPlusTile(upgradeEl) {
        var resource = (upgradeEl && upgradeEl.getAttribute('data-slot-resource')) || 'territory';
        var isTourSlot = upgradeEl && upgradeEl.classList.contains('ping-fp-slide1-tour-slot');
        var tag = isTourSlot ? 'li' : (upgradeEl ? upgradeEl.tagName.toLowerCase() : 'div');
        var tile = document.createElement(tag);
        var cls = 'territory-modal-item ping-fp-slide1-loc-empty ping-fp-slot-bank-plus';
        if (isTourSlot) {
            cls += ' ping-fp-slide1-tour-slot';
        }
        tile.className = cls;
        tile.setAttribute('role', 'button');
        tile.setAttribute('tabindex', '0');
        tile.setAttribute('data-ping-fp-slot-bank-plus', '');
        tile.setAttribute('data-slot-resource', resource);
        tile.setAttribute('aria-label', (window.__pingL10n && window.__pingL10n.eyeSocketOne) || 'Add using a slot');
        var iconWrap = document.createElement('span');
        iconWrap.className = 'ping-fp-slide1-loc-empty-icon';
        iconWrap.setAttribute('aria-hidden', 'true');
        iconWrap.innerHTML = '<i class="bi bi-plus-lg"></i>';
        tile.appendChild(iconWrap);
        return tile;
    }

    function buildSlotBankUpgradeTile(plusEl) {
        var resource = (plusEl && plusEl.getAttribute('data-slot-resource')) || 'territory';
        var isTourSlot = plusEl && plusEl.classList.contains('ping-fp-slide1-tour-slot');
        var tag = isTourSlot ? 'li' : (plusEl ? plusEl.tagName.toLowerCase() : 'div');
        var tile = document.createElement(tag);
        var cls = 'territory-modal-item ping-fp-slide1-loc-empty ping-fp-slide1-loc-empty--at-cap ping-fp-slot-upgrade';
        if (isTourSlot) {
            cls += ' ping-fp-slide1-tour-slot';
        }
        tile.className = cls;
        tile.setAttribute('role', 'button');
        tile.setAttribute('tabindex', '0');
        tile.setAttribute('data-ping-fp-slot-upgrade', '');
        tile.setAttribute('data-slot-resource', resource);
        var l10n = window.__pingL10n || {};
        var label = l10n.spinGlobeUpgradeLine1 || 'Upgrade';
        tile.setAttribute('aria-label', label);
        var iconWrap = document.createElement('span');
        iconWrap.className = 'ping-fp-slide1-loc-empty-icon ping-fp-slot-upgrade-label';
        iconWrap.setAttribute('aria-hidden', 'true');
        iconWrap.textContent = label;
        tile.appendChild(iconWrap);
        return tile;
    }

    function syncTerritorySlotBankTiles() {
        var list = document.getElementById('gfeTownsList');
        if (!list) {
            return;
        }
        var atCap = isTerritorySlotCap();
        var bank = getPingSlotBankBalance();
        var plus = list.querySelector('[data-ping-fp-slot-bank-plus]');
        var upgrade = list.querySelector('[data-ping-fp-slot-upgrade]');

        if (!atCap) {
            if (plus) {
                plus.remove();
            }
            if (upgrade) {
                upgrade.remove();
            }
            return;
        }

        if (bank > 0) {
            if (upgrade && upgrade.parentNode) {
                upgrade.parentNode.replaceChild(buildSlotBankPlusTile(upgrade), upgrade);
            }
        } else if (plus && plus.parentNode) {
            plus.parentNode.replaceChild(buildSlotBankUpgradeTile(plus), plus);
        }
    }

    function refreshPingSlotBankAffordances() {
        syncTerritorySlotBankTiles();
        syncTerritorySpinCapChrome();
        if (getPingSlotBankBalance() < 1) {
            return Promise.resolve(false);
        }
        wirePingSlotBankTiles();
        return applyTerritoryBankToGrid({ showToast: false });
    }

    function beginPingSlotBankSpend() {
        window.pingSlotBankPending = true;
    }

    function endPingSlotBankSpend() {
        window.pingSlotBankPending = false;
    }

    function pingSlotBankJsonExtra() {
        return window.pingSlotBankPending ? { use_slot_bank: true } : {};
    }

    function applyPingSlotBankFromResponse(data) {
        if (!data) {
            return;
        }
        var bal = data.slot_bank_balance;
        if (bal == null && data.data && data.data.slot_bank_balance != null) {
            bal = data.data.slot_bank_balance;
        }
        if (bal == null) {
            return;
        }
        setPingSlotBankBalance(bal);
        endPingSlotBankSpend();
    }

    function openSlotUpgrade(resourceType, e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (typeof window.openPingUpgradesModal === 'function') {
            window.openPingUpgradesModal();
            return;
        }
        window.location.href = window.PING_UPGRADES_FALLBACK_URL || '/upgrades';
    }

    function openRouteUpgrade(e) {
        openSlotUpgrade('route', e);
    }

    function onPingSlotBankPlusActivate(e) {
        var tile = e.target && e.target.closest
            ? e.target.closest('[data-ping-fp-slot-bank-plus]')
            : null;
        if (!tile || getPingSlotBankBalance() < 1) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        var resource = tile.getAttribute('data-slot-resource') || 'focal_point';
        beginPingSlotBankSpend();
        if (resource === 'focal_point') {
            if (typeof window.openPingAddLocationModal === 'function') {
                window.openPingAddLocationModal(e);
            }
            return;
        }
        if (resource === 'route') {
            if (window.RouteRecorder && typeof window.RouteRecorder.start === 'function') {
                window.RouteRecorder.start();
            }
            return;
        }
        if (resource === 'territory') {
            reserveTerritorySlot(e);
            return;
        }
        if (resource === 'tour') {
            var tourTray = document.getElementById('spinHeroTourTray');
            if (tourTray && tourTray.scrollIntoView) {
                tourTray.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
            if (typeof window.pingLandingShowToast === 'function') {
                window.pingLandingShowToast('Add stops in the tour tray, then create your tour.', 4500);
            }
        }
    }

    function wirePingSlotBankTiles() {
        document.querySelectorAll('[data-ping-fp-slot-bank-plus]').forEach(function (tile) {
            if (tile.__slotBankWired) {
                return;
            }
            tile.__slotBankWired = true;
            tile.addEventListener('click', onPingSlotBankPlusActivate, true);
            tile.addEventListener('keydown', function (ev) {
                if (ev.key === 'Enter' || ev.key === ' ') {
                    onPingSlotBankPlusActivate(ev);
                }
            });
        });
        document.querySelectorAll('[data-ping-fp-slot-upgrade]').forEach(function (tile) {
            if (tile.__slotUpgradeWired) {
                return;
            }
            tile.__slotUpgradeWired = true;
            tile.addEventListener('click', function (ev) {
                openSlotUpgrade(null, ev);
            }, true);
            tile.addEventListener('keydown', function (ev) {
                if (ev.key === 'Enter' || ev.key === ' ') {
                    openSlotUpgrade(null, ev);
                }
            });
        });
    }

    window.getPingSlotBankBalance = getPingSlotBankBalance;
    window.setPingSlotBankBalance = setPingSlotBankBalance;
    window.setTerritorySlotsRemaining = setTerritorySlotsRemaining;
    window.syncTerritorySpinCapChrome = syncTerritorySpinCapChrome;
    window.beginPingSlotBankSpend = beginPingSlotBankSpend;
    window.endPingSlotBankSpend = endPingSlotBankSpend;
    window.pingSlotBankJsonExtra = pingSlotBankJsonExtra;
    window.applyPingSlotBankFromResponse = applyPingSlotBankFromResponse;
    window.refreshPingSlotBankAffordances = refreshPingSlotBankAffordances;
    window.applyTerritoryBankToGrid = applyTerritoryBankToGrid;
    window.openRouteUpgrade = openRouteUpgrade;
    window.openSlotUpgrade = openSlotUpgrade;
    window.isTerritorySlotCap = isTerritorySlotCap;
    window.startTerritoryClaimSpin = startTerritoryClaimSpin;
    wirePingSlotBankTiles();
    syncTerritorySlotBankTiles();
    syncTerritorySpinCapChrome();
    applyTerritoryBankToGrid({ showToast: false });

    function appendPingFpRouteItem(data) {
        if (!data || data.id == null) return null;
        if (isRouteSlotCap() && !window.pingSlotBankPending) {
            openRouteUpgrade();
            return null;
        }

        var list = document.getElementById('pingFpRoutesList');
        if (!list) return null;

        function escHtml(s) {
            return String(s || '').replace(/[&<>"']/g, function (c) {
                return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
            });
        }

        // Remove empty state if present.
        var empty = list.querySelector('.ping-fp-routes-empty');
        if (empty) empty.remove();
        // Ensure parent has the right class.
        list.className = 'ping-fp-routes-list';
        list.id = 'pingFpRoutesList';

        var id           = String(data.id);
        var kind         = data.kind || 'route';
        var title        = data.title || 'Route';
        var distM        = parseInt(data.distance_m, 10) || 0;
        var durSec       = parseInt(data.duration_seconds, 10) || 0;
        var geoUrl       = data.geojson_url || '';
        var slug         = data.slug || '';
        var subdomainUrl = data.subdomain_url || (slug ? 'https://' + window.gfeSubdomainHost(slug) : '');

        var distLabel = distM >= 1000
            ? (distM / 1000).toFixed(1) + 'km'
            : distM + 'm';
        // Format recorded_at as "May 22, 5:28am".
        var dateLabel = '';
        if (data.recorded_at) {
            try {
                var d = new Date(data.recorded_at);
                var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                var h = d.getHours(), m = d.getMinutes();
                var ampm = h >= 12 ? 'pm' : 'am';
                h = h % 12 || 12;
                dateLabel = months[d.getMonth()] + ' ' + d.getDate() + ', '
                    + h + ':' + (m < 10 ? '0' : '') + m + ampm;
            } catch (e) {}
        }

        var thumbUrl = data.thumbnail_url || '';
        var heroTitle = distLabel + ' Route';
        var heroDefault = window.PING_ROUTE_HERO_DEFAULT || '/images/routes/route-hero-default.png';
        var thumbSrc = (thumbUrl && !isRouteHeroDefaultUrl(thumbUrl))
            ? bustRouteThumbUrl(thumbUrl)
            : heroDefault;

        var card = document.createElement('div');
        card.className = 'territory-modal-item gfe-towns-item ping-fp-route-item';
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('data-routeid', id);
        card.setAttribute('data-geojson-url', geoUrl);
        card.setAttribute('data-distance-m', String(distM));
        card.setAttribute('data-duration-seconds', String(durSec));
        card.setAttribute('data-kind', kind);
        card.setAttribute('data-title', title);
        card.setAttribute('data-slug', slug);
        card.setAttribute('data-subdomain-url', subdomainUrl);
        card.setAttribute('data-thumbnail-url', thumbSrc);
        card.setAttribute('aria-label', title);

        var thumbHtml = '<img class="territory-modal-item-thumb" src="' + escHtml(thumbSrc) + '" alt="' + escHtml(title) + '" loading="lazy"'
            + ' onerror="this.onerror=null;this.src=\'' + escHtml(heroDefault) + '\';var c=this.closest(\'.ping-fp-route-item\');if(c)c.setAttribute(\'data-thumbnail-url\',\'' + escHtml(heroDefault) + '\')">';

        card.innerHTML = thumbHtml
            + '<div class="territory-modal-item-body">'
            + '<div class="territory-modal-item-name">'
            + '<span class="ping-fp-route-hero-title">' + escHtml(heroTitle) + '</span>'
            + '</div>'
            + (dateLabel ? '<span class="ping-fp-route-hero-date">' + escHtml(dateLabel) + '</span>' : '')
            + '</div>'
            + '<button type="button" class="ping-fp-route-item-delete" data-route-delete="' + escHtml(id) + '" '
            + 'aria-label="Delete route" title="Delete">'
            + '<i class="bi bi-trash" aria-hidden="true"></i>'
            + '</button>';

        wirePingFpRouteDeleteBtn(card, id);

        var firstRoute = list.querySelector('.ping-fp-route-item');
        var firstEmpty = list.querySelector('[data-ping-fp-empty-route-slot]');
        if (firstRoute) {
            list.insertBefore(card, firstRoute);
        } else if (firstEmpty) {
            list.insertBefore(card, firstEmpty);
        } else {
            list.insertBefore(card, list.firstChild);
        }

        var emptySlot = list.querySelector('[data-ping-fp-empty-route-slot]');
        if (emptySlot) {
            var routeCount = parseInt(emptySlot.getAttribute('data-available-slots-count') || '1', 10);
            setAvailableSlotsCount(emptySlot, routeCount - 1);
        }

        var viewport = document.getElementById('spinIntroAuthedCarouselViewport');
        if (viewport) {
            var rem = parseInt(viewport.getAttribute('data-route-slots-remaining') || '0', 10);
            if (!isNaN(rem) && rem > 0) {
                viewport.setAttribute('data-route-slots-remaining', String(rem - 1));
            }
        }

        return card;
    }
    window.appendPingFpRouteItem = appendPingFpRouteItem;

    // ── Route Recorder: overlay a saved route on #pingMap ────────────

    function _routeLineStyle() {
        return window.RouteLineStyle || {
            BRAND: '#e91e8c',
            CASING: 'rgba(12, 8, 18, 0.72)',
            FILL_RGBA_BOUNDARY: 'rgba(233, 30, 140, 0.12)',
            widthsAtZoom: function () { return { casing: 10, fill: 5 }; },
        };
    }

    function _extractRouteCoords(feature) {
        var geom = feature && feature.geometry ? feature.geometry : {};
        if (geom.type === 'LineString') return geom.coordinates || [];
        if (geom.type === 'Polygon' && geom.coordinates) return geom.coordinates[0] || [];
        return [];
    }

    function _projectedPath(ctx, map, coords) {
        if (!coords || coords.length < 2) return false;
        var pts = [];
        var i;
        for (i = 0; i < coords.length; i++) {
            try {
                pts.push(map.project([coords[i][0], coords[i][1]]));
            } catch (e) {
                return false;
            }
        }
        ctx.beginPath();
        ctx.moveTo(pts[0].x, pts[0].y);
        for (i = 1; i < pts.length; i++) ctx.lineTo(pts[i].x, pts[i].y);
        return true;
    }

    function _strokePolylineOnCanvas(ctx, map, coords, color, lineW, lineCap) {
        if (!_projectedPath(ctx, map, coords)) return;
        ctx.save();
        ctx.globalCompositeOperation = 'source-over';
        ctx.strokeStyle = color;
        ctx.lineWidth = lineW;
        ctx.lineCap = lineCap || 'round';
        ctx.lineJoin = 'round';
        ctx.stroke();
        ctx.restore();
    }

    function _fillPolygonOnCanvas(ctx, map, coords, fillColor) {
        if (!coords || coords.length < 3) return false;
        var pts = [];
        var i;
        for (i = 0; i < coords.length; i++) {
            try {
                pts.push(map.project([coords[i][0], coords[i][1]]));
            } catch (e) {
                return false;
            }
        }
        ctx.beginPath();
        ctx.moveTo(pts[0].x, pts[0].y);
        for (i = 1; i < pts.length; i++) ctx.lineTo(pts[i].x, pts[i].y);
        ctx.closePath();
        ctx.save();
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.restore();
        return true;
    }

    function _paintRouteStrokeOnCanvas(ctx, map, coords, lineCap) {
        var style = _routeLineStyle();
        var widths = style.widthsAtZoom(map.getZoom());
        var cap = lineCap || 'round';
        ctx.save();
        ctx.shadowColor = 'rgba(0, 0, 0, 0.35)';
        ctx.shadowBlur = 4;
        _strokePolylineOnCanvas(ctx, map, coords, style.CASING, widths.casing, cap);
        ctx.restore();
        _strokePolylineOnCanvas(ctx, map, coords, style.BRAND, widths.fill, cap);
    }

    function _cross2d(o, a, b) {
        return (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);
    }

    function _pointOnSeg(p, a, b) {
        return Math.min(a.x, b.x) - 0.5 <= p.x && p.x <= Math.max(a.x, b.x) + 0.5
            && Math.min(a.y, b.y) - 0.5 <= p.y && p.y <= Math.max(a.y, b.y) + 0.5;
    }

    function _segmentsCross(a, b, c, d) {
        var d1 = _cross2d(c, d, a);
        var d2 = _cross2d(c, d, b);
        var d3 = _cross2d(a, b, c);
        var d4 = _cross2d(a, b, d);
        if (((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0))
            && ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0))) return true;
        if (Math.abs(d1) < 0.5 && _pointOnSeg(a, c, d)) return true;
        if (Math.abs(d2) < 0.5 && _pointOnSeg(b, c, d)) return true;
        if (Math.abs(d3) < 0.5 && _pointOnSeg(c, a, b)) return true;
        if (Math.abs(d4) < 0.5 && _pointOnSeg(d, a, b)) return true;
        return false;
    }

    function _findCrossingEdgeIndices(map, coords) {
        var crossing = {};
        var edgeCount = coords.length - 1;
        if (edgeCount < 2) return crossing;
        var projected = [];
        var i;
        for (i = 0; i < coords.length; i++) {
            try {
                projected[i] = map.project([coords[i][0], coords[i][1]]);
            } catch (e) {
                return crossing;
            }
        }
        var a;
        for (a = 0; a < edgeCount; a++) {
            var b;
            for (b = a + 2; b < edgeCount; b++) {
                if (_segmentsCross(
                    projected[a], projected[a + 1],
                    projected[b], projected[b + 1]
                )) {
                    crossing[b] = true;
                }
            }
        }
        return crossing;
    }

    function _mergeCrossingEdgeRuns(crossing, edgeCount) {
        var edges = [];
        var e;
        for (e = 0; e < edgeCount; e++) {
            if (crossing[e]) edges.push(e);
        }
        if (!edges.length) return [];
        var runs = [];
        var runStart = edges[0];
        var runEnd = edges[0];
        for (e = 1; e < edges.length; e++) {
            if (edges[e] === runEnd + 1) {
                runEnd = edges[e];
            } else {
                runs.push([runStart, runEnd]);
                runStart = edges[e];
                runEnd = edges[e];
            }
        }
        runs.push([runStart, runEnd]);
        return runs;
    }

    function _paintCrossingEdgesOnTop(ctx, map, coords) {
        var edgeCount = coords.length - 1;
        var crossing = _findCrossingEdgeIndices(map, coords);
        var runs = _mergeCrossingEdgeRuns(crossing, edgeCount);
        var ri;
        for (ri = 0; ri < runs.length; ri++) {
            var startEdge = runs[ri][0];
            var endEdge = runs[ri][1];
            // Extend one vertex each side so the on-top branch joins the existing
            // polyline instead of floating as a detached 2-point stub with flat ends.
            var from = Math.max(0, startEdge - 1);
            var to = Math.min(coords.length - 1, endEdge + 2);
            var slice = coords.slice(from, to + 1);
            if (slice.length < 2) continue;
            _paintRouteStrokeOnCanvas(ctx, map, slice, 'round');
        }
    }

    function _ensureRouteCanvasOverlay(map) {
        if (!map) return null;
        var container = map.getContainer();
        if (!container) return null;
        var canvas = container.querySelector('.route-map-canvas-overlay');
        if (!canvas) {
            canvas = document.createElement('canvas');
            canvas.className = 'route-map-canvas-overlay';
            canvas.setAttribute('aria-hidden', 'true');
            canvas.style.position = 'absolute';
            canvas.style.left = '0';
            canvas.style.top = '0';
            canvas.style.width = '100%';
            canvas.style.height = '100%';
            canvas.style.pointerEvents = 'none';
            canvas.style.zIndex = '5';
            container.appendChild(canvas);
        }
        return canvas;
    }

    function _drawRouteCanvasOverlay(map, coords) {
        var canvas = _ensureRouteCanvasOverlay(map);
        if (!canvas || !map) return;
        var container = map.getContainer();
        var w = container.clientWidth;
        var h = container.clientHeight;
        if (w < 1 || h < 1) return;
        var dpr = window.devicePixelRatio || 1;
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        canvas.style.width = w + 'px';
        canvas.style.height = h + 'px';
        var ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, w, h);
        if (!coords || coords.length < 2) return;

        if (routeOverlayState.kind === 'boundary') {
            _fillPolygonOnCanvas(ctx, map, coords, _routeLineStyle().FILL_RGBA_BOUNDARY);
        }

        _paintRouteStrokeOnCanvas(ctx, map, coords, 'round');
        _paintCrossingEdgesOnTop(ctx, map, coords);
        _drawRouteEndpointDots(ctx, map, coords);
    }

    function _drawRouteEndpointDots(ctx, map, coords) {
        if (!coords || coords.length < 2) return;
        if (document.body.classList.contains('is-route-geometry-editing')) return;
        if (routeOverlayState.kind === 'boundary') return;

        var style = _routeLineStyle();
        var dpr = window.devicePixelRatio || 1;
        var radius = Math.max(5, Math.min(9, 6 + (map.getZoom() - 15) * 0.8));
        var endpoints = [
            { c: coords[0], fill: '#22c55e' },
            { c: coords[coords.length - 1], fill: style.BRAND },
        ];
        var i;
        for (i = 0; i < endpoints.length; i++) {
            var pt;
            try {
                pt = map.project([endpoints[i].c[0], endpoints[i].c[1]]);
            } catch (e) {
                continue;
            }
            ctx.save();
            ctx.beginPath();
            ctx.arc(pt.x, pt.y, radius + 2, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(12, 8, 18, 0.72)';
            ctx.fill();
            ctx.beginPath();
            ctx.arc(pt.x, pt.y, radius, 0, Math.PI * 2);
            ctx.fillStyle = endpoints[i].fill;
            ctx.fill();
            ctx.lineWidth = 2;
            ctx.strokeStyle = '#ffffff';
            ctx.stroke();
            ctx.restore();
        }
        void dpr;
    }

    function _clearRouteCanvasOverlay(map) {
        if (!map) return;
        var container = map.getContainer();
        if (!container) return;
        var canvas = container.querySelector('.route-map-canvas-overlay');
        if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }

    function _unbindRouteCanvasSync(map) {
        if (!map || !routeOverlayState.canvasSyncHandler) return;
        try {
            map.off('move', routeOverlayState.canvasSyncHandler);
            map.off('zoom', routeOverlayState.canvasSyncHandler);
            map.off('rotate', routeOverlayState.canvasSyncHandler);
            map.off('pitch', routeOverlayState.canvasSyncHandler);
            map.off('resize', routeOverlayState.canvasSyncHandler);
            map.off('render', routeOverlayState.canvasSyncHandler);
        } catch (e) { /* noop */ }
        routeOverlayState.canvasSyncHandler = null;
    }

    function _bindRouteCanvasSync(map) {
        _unbindRouteCanvasSync(map);
        if (!map) return;
        routeOverlayState.canvasSyncHandler = function () {
            _drawRouteCanvasOverlay(map, routeOverlayState.coords);
        };
        map.on('move', routeOverlayState.canvasSyncHandler);
        map.on('zoom', routeOverlayState.canvasSyncHandler);
        map.on('rotate', routeOverlayState.canvasSyncHandler);
        map.on('pitch', routeOverlayState.canvasSyncHandler);
        map.on('resize', routeOverlayState.canvasSyncHandler);
        map.on('render', routeOverlayState.canvasSyncHandler);
        routeOverlayState.canvasSyncHandler();
    }

    var routeOverlayState = {
        sourceId:    'route-recorder-overlay-src',
        layerId:     'route-recorder-overlay-layer',
        casingLayerId: 'route-recorder-overlay-casing',
        satSourceId: 'route-overlay-satellite-src',
        satLayerId:  'route-overlay-satellite-layer',
        satZoomHandler: null,
        mapMode:     null,
        mapSwapInFlight: false,
        routeId:     null,
        coords:      null,
        geoUrl:      null,
        kind:        'route',
        feature:     null,
        canvasSyncHandler: null,
        startMarker: null,
        endMarker:   null,
        distanceM:   null,
        durationSeconds: null,
    };

    function _removeRouteEndpointMarkers() {
        if (routeOverlayState.startMarker) {
            try { routeOverlayState.startMarker.remove(); } catch (e) { /* noop */ }
            routeOverlayState.startMarker = null;
        }
        if (routeOverlayState.endMarker) {
            try { routeOverlayState.endMarker.remove(); } catch (e) { /* noop */ }
            routeOverlayState.endMarker = null;
        }
    }

    function _addRouteEndpointMarkers(map, coords) {
        _removeRouteEndpointMarkers();
        if (!map || !coords || coords.length < 2) return;
        if (document.body.classList.contains('is-route-geometry-editing')) return;
        if (routeOverlayState.kind === 'boundary') return;
        try {
            var startEl = document.createElement('div');
            startEl.className = 'route-flyin-marker route-flyin-marker--start';
            startEl.innerHTML = '<i class="bi bi-circle-fill" aria-hidden="true"></i>';
            routeOverlayState.startMarker = new maplibregl.Marker({ element: startEl })
                .setLngLat(coords[0])
                .addTo(map);

            var endEl = document.createElement('div');
            endEl.className = 'route-flyin-marker route-flyin-marker--end';
            endEl.innerHTML = '<i class="bi bi-flag-fill" aria-hidden="true"></i>';
            routeOverlayState.endMarker = new maplibregl.Marker({ element: endEl })
                .setLngLat(coords[coords.length - 1])
                .addTo(map);
        } catch (e) {
            console.warn('[ping-landing] route endpoint markers failed', e);
        }
    }

    function _syncRouteEndpointMarkers(map) {
        if (!map || !routeOverlayState.coords || routeOverlayState.coords.length < 2) return;
        if (document.body.classList.contains('is-route-geometry-editing')) {
            _removeRouteEndpointMarkers();
            return;
        }
        _addRouteEndpointMarkers(map, routeOverlayState.coords);
    }

    var ROUTE_FLYIN_MAX_ZOOM = 18;
    var ROUTE_FLYIN_MIN_FRAME_M = 650;
    // One-time swap: Esri satellite (overview) → OpenFreeMap Bright (detail).
    var ROUTE_DETAIL_SWAP_ZOOM = 16.5;

    function _metersToLngDelta(m, lat) {
        var scale = 111320 * Math.cos((lat || 0) * Math.PI / 180);
        return scale > 0 ? (m / scale) : 0;
    }

    function _metersToLatDelta(m) {
        return m / 111320;
    }

    /** Short trails otherwise hit maxZoom and Esri shows “map data not available”. */
    function _expandRouteFlyinBbox(bbox, minSpanM) {
        var minLng = bbox[0][0];
        var minLat = bbox[0][1];
        var maxLng = bbox[1][0];
        var maxLat = bbox[1][1];
        var midLat = (minLat + maxLat) / 2;
        var latSpanM = Math.max(0, (maxLat - minLat) * 111320);
        var lngSpanM = Math.max(0, (maxLng - minLng) * 111320 * Math.cos(midLat * Math.PI / 180));
        if (latSpanM < minSpanM) {
            var padLat = _metersToLatDelta((minSpanM - latSpanM) / 2);
            minLat -= padLat;
            maxLat += padLat;
        }
        if (lngSpanM < minSpanM) {
            var padLng = _metersToLngDelta((minSpanM - lngSpanM) / 2, midLat);
            minLng -= padLng;
            maxLng += padLng;
        }
        return [[minLng, minLat], [maxLng, maxLat]];
    }

    function _addOverlaySatelliteLayer(map) {
        if (!map) return;
        try {
            if (map.getSource(routeOverlayState.satSourceId)) return;
            map.addSource(routeOverlayState.satSourceId, {
                type: 'raster',
                tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
                tileSize: 256,
                maxzoom: 17,
                attribution: '© Esri',
            });
            var beforeId;
            try {
                var layers = map.getStyle().layers || [];
                for (var i = 0; i < layers.length; i++) {
                    if (layers[i].type === 'symbol') { beforeId = layers[i].id; break; }
                }
            } catch (e) {}
            map.addLayer({
                id:     routeOverlayState.satLayerId,
                type:   'raster',
                source: routeOverlayState.satSourceId,
                maxzoom: 17,
                paint:  {
                    'raster-opacity': 0,
                    'raster-opacity-transition': { duration: 0, delay: 0 },
                    'raster-fade-duration': 0,
                },
            }, beforeId);
        } catch (e) {}
    }

    function _removeRouteOverlayLayers(map) {
        if (!map) return;
        _unbindRouteCanvasSync(map);
        _clearRouteCanvasOverlay(map);
        _removeRouteEndpointMarkers();
        try {
            if (map.getLayer(routeOverlayState.layerId)) map.removeLayer(routeOverlayState.layerId);
            if (map.getLayer(routeOverlayState.casingLayerId)) map.removeLayer(routeOverlayState.casingLayerId);
            if (map.getSource(routeOverlayState.sourceId)) map.removeSource(routeOverlayState.sourceId);
        } catch (e) { /* noop */ }
    }

    function _addRouteOverlayLayers(map, feature) {
        if (!map || !feature) return;
        _removeRouteOverlayLayers(map);
        routeOverlayState.feature = feature;
        routeOverlayState.coords = _extractRouteCoords(feature);
        _bindRouteCanvasSync(map);
    }

    function _redrawRouteCanvas(map, coords) {
        if (!map) return;
        if (coords && coords.length) routeOverlayState.coords = coords;
        _drawRouteCanvasOverlay(map, routeOverlayState.coords);
    }

    function _paintRouteOverlayFeature(map, feature) {
        if (!map || !feature) return;
        try {
            _addRouteOverlayLayers(map, feature);
            _syncRouteEndpointMarkers(map);
        } catch (e) {
            console.warn('[ping-landing] route overlay paint failed', e);
        }
    }

    function _readdRouteOverlayOnMap(map, done) {
        function finish(feature) {
            if (feature) {
                routeOverlayState.feature = feature;
                _paintRouteOverlayFeature(map, feature);
            }
            if (done) done();
        }
        if (routeOverlayState.feature) {
            finish(routeOverlayState.feature);
            return;
        }
        if (!routeOverlayState.geoUrl) {
            if (done) done();
            return;
        }
        fetch(routeOverlayState.geoUrl)
            .then(function (r) { return r.json(); })
            .then(finish)
            .catch(function (err) {
                console.warn('[ping-landing] route overlay re-fetch failed', err);
                if (done) done();
            });
    }

    function _removeRouteSatelliteLayerImmediate(map) {
        _unbindRouteSatelliteZoomGuard(map);
        try {
            if (map.getLayer(routeOverlayState.satLayerId)) map.removeLayer(routeOverlayState.satLayerId);
            if (map.getSource(routeOverlayState.satSourceId)) map.removeSource(routeOverlayState.satSourceId);
        } catch (e) { /* noop */ }
    }

    function _swapRouteMapToDetail(map, done) {
        if (!map || routeOverlayState.mapMode === 'detail') {
            if (done) done();
            return;
        }
        if (routeOverlayState.mapSwapInFlight) return;
        routeOverlayState.mapSwapInFlight = true;

        _removeRouteSatelliteLayerImmediate(map);

        var camera = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch(),
        };

        _routeDetailStyleActive = true;

        var onReady = function () {
            map.off('style.load', onReady);
            applyBasemapChrome();
            try { map.jumpTo(camera); } catch (e) { /* noop */ }
            routeOverlayState.mapMode = 'detail';
            routeOverlayState.mapSwapInFlight = false;
            _readdRouteOverlayOnMap(map, done);
        };
        map.on('style.load', onReady);
        try {
            map.setStyle(ROUTE_DETAIL_STYLE_URL);
        } catch (e) {
            _routeDetailStyleActive = false;
            routeOverlayState.mapSwapInFlight = false;
            console.warn('[ping-landing] route detail style swap failed', e);
            if (done) done();
        }
    }

    function _maybeSwapRouteMapToDetail(map) {
        if (!map || !document.body.classList.contains('is-route-focused')) return;
        if (routeOverlayState.mapMode === 'detail' || routeOverlayState.mapSwapInFlight) return;
        var editing = document.body.classList.contains('is-route-geometry-editing');
        if (editing || map.getZoom() >= ROUTE_DETAIL_SWAP_ZOOM) {
            _swapRouteMapToDetail(map);
        }
    }

    var ROUTE_EDIT_MAX_ZOOM = 20;

    function _routeBboxSpanM(bbox) {
        var minLng = bbox[0][0];
        var minLat = bbox[0][1];
        var maxLng = bbox[1][0];
        var maxLat = bbox[1][1];
        var midLat = (minLat + maxLat) / 2;
        var latSpanM = Math.max(0, (maxLat - minLat) * 111320);
        var lngSpanM = Math.max(0, (maxLng - minLng) * 111320 * Math.cos(midLat * Math.PI / 180));
        return Math.max(latSpanM, lngSpanM, 1);
    }

    /** Tight edit frame — never balloon short trails to 400m+ overview scale. */
    function _expandRouteEditBboxTight(rawBbox) {
        var spanM = _routeBboxSpanM(rawBbox);
        var targetSpan = Math.max(spanM * 1.2, 40);
        return _expandRouteFlyinBbox(rawBbox, targetSpan);
    }

    function _minEditZoomForSpanM(spanM) {
        if (spanM <= 150) return 19.5;
        if (spanM <= 350) return 18.5;
        if (spanM <= 800) return 17.5;
        return 16;
    }

    function _frameMapToRouteCoords(map, coords) {
        if (!map || !coords || coords.length < 2) return;
        var lngs = [];
        var lats = [];
        for (var i = 0; i < coords.length; i++) {
            lngs.push(coords[i][0]);
            lats.push(coords[i][1]);
        }
        var rawBbox = [
            [Math.min.apply(null, lngs), Math.min.apply(null, lats)],
            [Math.max.apply(null, lngs), Math.max.apply(null, lats)],
        ];
        var spanM = _routeBboxSpanM(rawBbox);
        var bbox = _expandRouteEditBboxTight(rawBbox);
        var padding = { top: 72, bottom: 150, left: 40, right: 40 };
        var minZoom = _minEditZoomForSpanM(spanM);
        try { map.stop(); } catch (e) { /* noop */ }

        var framed = false;
        try {
            if (typeof map.cameraForBounds === 'function') {
                var cam = map.cameraForBounds(bbox, {
                    padding: padding,
                    maxZoom: ROUTE_EDIT_MAX_ZOOM,
                    pitch: 0,
                    bearing: 0,
                });
                if (cam && cam.center != null && isFinite(cam.zoom)) {
                    if (cam.zoom < minZoom) cam.zoom = minZoom;
                    map.easeTo({
                        center: cam.center,
                        zoom: cam.zoom,
                        bearing: cam.bearing || 0,
                        pitch: cam.pitch || 0,
                        duration: 800,
                        essential: true,
                    });
                    framed = true;
                }
            }
        } catch (e) { /* noop */ }

        if (!framed) {
            try {
                map.fitBounds(bbox, {
                    padding: padding,
                    pitch: 0,
                    bearing: 0,
                    maxZoom: ROUTE_EDIT_MAX_ZOOM,
                    duration: 800,
                    essential: true,
                });
                map.once('moveend', function () {
                    try {
                        if (map.getZoom() < minZoom) map.setZoom(minZoom);
                    } catch (ze) { /* noop */ }
                });
            } catch (e2) {
                console.warn('[ping-landing] route edit frame failed', e2);
            }
        }
    }

    window.pingLandingEnsureRouteDetailMap = function (map, done) {
        if (!map) {
            if (done) done();
            return;
        }
        if (routeOverlayState.mapMode === 'detail') {
            if (done) done();
            return;
        }
        _swapRouteMapToDetail(map, done || function () {});
    };

    window.pingLandingFitRouteForEditing = function (map, coords) {
        _frameMapToRouteCoords(map, coords);
    };

    function _bindRouteSatelliteZoomGuard(map) {
        if (!map || routeOverlayState.satZoomHandler) return;
        routeOverlayState.satZoomHandler = function () {
            _maybeSwapRouteMapToDetail(map);
        };
        map.on('zoom', routeOverlayState.satZoomHandler);
        map.on('moveend', routeOverlayState.satZoomHandler);
    }

    function _unbindRouteSatelliteZoomGuard(map) {
        if (!map || !routeOverlayState.satZoomHandler) return;
        try {
            map.off('zoom', routeOverlayState.satZoomHandler);
            map.off('moveend', routeOverlayState.satZoomHandler);
        } catch (e) { /* noop */ }
        routeOverlayState.satZoomHandler = null;
    }

    function _fadeOverlaySatelliteIn(map, duration) {
        if (!map) return;
        try {
            if (!map.getLayer(routeOverlayState.satLayerId)) return;
            map.setPaintProperty(routeOverlayState.satLayerId, 'raster-opacity-transition', { duration: duration || 0, delay: 0 });
            map.setPaintProperty(routeOverlayState.satLayerId, 'raster-opacity', 1);
        } catch (e) { /* noop */ }
    }

    function _fadeOverlaySatelliteOut(map, duration) {
        if (!map) return;
        _unbindRouteSatelliteZoomGuard(map);
        try {
            if (!map.getLayer(routeOverlayState.satLayerId)) return;
            map.setPaintProperty(routeOverlayState.satLayerId, 'raster-opacity-transition', { duration: duration, delay: 0 });
            map.setPaintProperty(routeOverlayState.satLayerId, 'raster-opacity', 0);
            setTimeout(function () {
                try {
                    if (map.getLayer(routeOverlayState.satLayerId))  map.removeLayer(routeOverlayState.satLayerId);
                    if (map.getSource(routeOverlayState.satSourceId)) map.removeSource(routeOverlayState.satSourceId);
                } catch (e) {}
            }, duration + 100);
        } catch (e) {}
    }

    function _closeRouteOverlay() {
        if (typeof window.RouteGeometryEditor === 'object'
            && typeof window.RouteGeometryEditor.isActive === 'function'
            && window.RouteGeometryEditor.isActive()) {
            window.RouteGeometryEditor.close(true);
        }
        document.body.classList.remove('is-route-focused');
        var wasDetail = routeOverlayState.mapMode === 'detail';
        routeOverlayState.routeId = null;
        routeOverlayState.coords = null;
        routeOverlayState.geoUrl = null;
        routeOverlayState.kind = 'route';
        routeOverlayState.feature = null;
        routeOverlayState.mapMode = null;
        routeOverlayState.mapSwapInFlight = false;
        routeOverlayState.distanceM = null;
        routeOverlayState.durationSeconds = null;
        _removeRouteEndpointMarkers();
        var hud = document.getElementById('routeViewHud');
        if (hud) hud.classList.remove('is-visible');
        clearSpinFlyinLocationTitle();
        clearPingHeroLocationImage();

        var map = (typeof window.pingLandingGetMap === 'function') ? window.pingLandingGetMap() : null;
        if (map) {
            _unbindRouteSatelliteZoomGuard(map);
            if (wasDetail || _routeDetailStyleActive) {
                _routeDetailStyleActive = false;
                map.once('style.load', function () {
                    applyBasemapChrome();
                });
                try { map.setStyle(BASEMAP_STYLE_URL); } catch (e) { /* noop */ }
            } else {
                _fadeOverlaySatelliteOut(map, 600);
                try { _removeRouteOverlayLayers(map); } catch (e) {}
            }
        }
        if (typeof window.pingLandingRestoreGlobeFraming === 'function') {
            window.pingLandingRestoreGlobeFraming(1200);
        }
        setTimeout(function () {
            if (typeof window.showPingIntro === 'function') window.showPingIntro();
        }, 400);
    }
    window.pingLandingCloseRouteOverlay = _closeRouteOverlay;
    window.pingLandingRedrawRouteCanvas = _redrawRouteCanvas;
    window.pingLandingClearRouteCanvas = function (map) {
        _unbindRouteCanvasSync(map);
        _clearRouteCanvasOverlay(map);
    };
    window.pingLandingHideRouteEndpointMarkers = function () {
        _removeRouteEndpointMarkers();
        var map = (typeof window.pingLandingGetMap === 'function') ? window.pingLandingGetMap() : null;
        _redrawRouteCanvas(map, routeOverlayState.coords);
    };
    window.pingLandingShowRouteEndpointMarkers = function () {
        var map = (typeof window.pingLandingGetMap === 'function') ? window.pingLandingGetMap() : null;
        _syncRouteEndpointMarkers(map);
        _redrawRouteCanvas(map, routeOverlayState.coords);
    };

    function showRouteOverlay(geoUrl, title, heroUrl, routeId, routeSlug, routeMeta) {
        if (!geoUrl) return;
        var map = (function () {
            if (typeof window.pingLandingGetMap === 'function') return window.pingLandingGetMap();
            return null;
        }());
        if (!map) return;

        var heroRaw = heroUrl && String(heroUrl).trim();
        var heroImg = (heroRaw && !isRouteHeroDefaultUrl(heroRaw))
            ? bustRouteThumbUrl(heroRaw)
            : PING_ROUTE_HERO_DEFAULT;
        var flyDuration = 2800;
        var flyLabel = title || '';
        var rid = routeId != null && routeId !== '' ? parseInt(routeId, 10) : null;
        if (rid != null && !isFinite(rid)) rid = null;
        routeMeta = routeMeta || {};
        routeOverlayState.routeId = rid;
        routeOverlayState.coords = null;
        routeOverlayState.geoUrl = geoUrl;
        routeOverlayState.kind = 'route';
        routeOverlayState.feature = null;
        routeOverlayState.mapMode = 'satellite';
        routeOverlayState.mapSwapInFlight = false;
        routeOverlayState.distanceM = parseInt(routeMeta.distance_m, 10) || 0;
        routeOverlayState.durationSeconds = parseInt(routeMeta.duration_seconds, 10) || 0;

        // Paint the hero before intro fly-out so carousel backdrop sync
        // cannot clobber the route photo (sync skips .is-location-hero).
        var slugVal = routeSlug != null ? String(routeSlug).trim().toLowerCase() : '';
        bindPingHeroFlyinData({
            id: rid,
            _entity: 'route',
            title: flyLabel,
            thumbnail_url: heroImg,
            image: heroImg,
            logo_url: heroImg,
            slug: slugVal,
            subdomain_slug: slugVal,
        }, { editable: !!rid, skipHeroImage: true });
        document.body.classList.add('is-route-focused');
        _addOverlaySatelliteLayer(map);
        _bindRouteSatelliteZoomGuard(map);
        _fadeOverlaySatelliteIn(map, 800);

        var introModalEl = document.getElementById('spinIntroModal');
        if (typeof window.hidePingIntro === 'function') {
            try { window.hidePingIntro(true); } catch (e) {}
        }
        // If intro was already dismissed, hidePingIntro no-ops — strip visibility
        // so the modal backdrop cannot sit above the hero (same z-index stack).
        if (introModalEl) {
            introModalEl.classList.remove('visible');
            introModalEl.classList.remove('is-flying-out');
        }
        if (typeof window.pingLandingStopGlobeSpin === 'function') {
            window.pingLandingStopGlobeSpin();
        }
        autoSpin.active = false;

        try { if (map.dragPan)         map.dragPan.enable(); } catch (e) {}
        try { if (map.scrollZoom)      map.scrollZoom.enable(); } catch (e) {}
        try { if (map.touchZoomRotate) map.touchZoomRotate.enable(); } catch (e) {}
        try { if (map.doubleClickZoom) map.doubleClickZoom.enable(); } catch (e) {}
        try { if (map.keyboard)        map.keyboard.enable(); } catch (e) {}

        fetch(geoUrl).then(function (r) { return r.json(); }).then(function (feature) {
            var coords = [];
            var geom = feature.geometry || {};
            if (geom.type === 'LineString') {
                coords = geom.coordinates || [];
            } else if (geom.type === 'Polygon' && Array.isArray(geom.coordinates)) {
                coords = geom.coordinates[0] || [];
            }
            if (coords.length < 2) return;
            routeOverlayState.coords = coords;
            routeOverlayState.feature = feature;
            routeOverlayState.kind = (feature.properties && feature.properties.kind)
                || (geom.type === 'Polygon' ? 'boundary' : 'route');

            try { _paintRouteOverlayFeature(map, feature); } catch (e) {}

            var lngs = coords.map(function (c) { return c[0]; });
            var lats = coords.map(function (c) { return c[1]; });
            var bbox = _expandRouteFlyinBbox([
                [Math.min.apply(null, lngs), Math.min.apply(null, lats)],
                [Math.max.apply(null, lngs), Math.max.apply(null, lats)],
            ], ROUTE_FLYIN_MIN_FRAME_M);

            function flyAndPaint() {
                var statsLabel = '';
                if (window.RouteLineStyle && window.RouteLineStyle.formatRouteStats) {
                    statsLabel = window.RouteLineStyle.formatRouteStats(
                        routeOverlayState.distanceM,
                        routeOverlayState.durationSeconds
                    );
                }
                revealFlyinTitleAfterMove(flyLabel, {
                    flyMs: flyDuration,
                    fallbackMs: flyDuration + 400,
                    onTitleReveal: function () {
                        if (statsLabel) setSpinFlyinRouteStats(statsLabel);
                    },
                });
                setTimeout(revealPingHeroRoutePathBtn, flyDuration + 200);
                try {
                    map.fitBounds(bbox, {
                        padding:   { top: 80, bottom: 72, left: 56, right: 56 },
                        pitch:     0,
                        bearing:   0,
                        maxZoom:   ROUTE_FLYIN_MAX_ZOOM,
                        duration:  flyDuration,
                        essential: true,
                    });
                } catch (e) {
                    console.warn('[ping-landing] route fitBounds failed', e);
                }
                map.once('moveend', function onRouteFlyinZoomClamp() {
                    try {
                        if (!document.body.classList.contains('is-route-focused')) return;
                        if (map.getZoom() > ROUTE_FLYIN_MAX_ZOOM) {
                            map.setZoom(ROUTE_FLYIN_MAX_ZOOM);
                        }
                        _maybeSwapRouteMapToDetail(map);
                    } catch (ze) { /* noop */ }
                });
            }

            if (map.isStyleLoaded && map.isStyleLoaded()) {
                flyAndPaint();
            } else {
                var fired = false;
                var onReady = function () {
                    if (fired) return;
                    if (map.isStyleLoaded && !map.isStyleLoaded()) return;
                    fired = true;
                    map.off('styledata', onReady);
                    map.off('idle', onReady);
                    flyAndPaint();
                };
                map.on('styledata', onReady);
                map.on('idle', onReady);
                setTimeout(onReady, 2000);
            }
        }).catch(function (e) {
            console.warn('[ping-landing] route overlay failed', e);
        });
    }
    window.pingLandingShowRouteOverlay = showRouteOverlay;

    function locationShowsOnMap(data) {
        if (!data) return true;
        if (data.show_location_on_map === false) return false;
        if (data.show_location_on_map === 0 || data.show_location_on_map === '0') return false;
        return true;
    }

    // Live refresh after a successful save in #gfeEditModal. Fires from
    // the save success branch of wireGfeEditModal (search this file for
    // "gfe-location-edited"). Two responsibilities:
    //   1. Hero band — if the user is currently mid-fly-in on the same
    //      location they just edited, swap in fresh title / image /
    //      socials without a page reload. Title updates via textContent
    //      only (no .is-revealed cycle) so there's no fade flicker on
    //      what the user already sees.
    //   2. Slide-1 carousel card — patch the underlying
    //      .ping-fp-location-item so the next fly-in from the carousel
    //      starts from fresh data (otherwise the card's
    //      data-gfe-loc-payload would lag until the next page load).
    document.addEventListener('route-edited', function (e) {
        var detail = e && e.detail ? e.detail : {};
        var id = detail.id;
        var data = detail.route || detail.data || {};
        if (!id) return;

        if (_pingHeroFlyinData && _pingHeroFlyinData._entity === 'route' && String(_pingHeroFlyinData.id) === String(id)) {
            var mergedRoute = {};
            for (var rk0 in _pingHeroFlyinData) {
                if (Object.prototype.hasOwnProperty.call(_pingHeroFlyinData, rk0)) {
                    mergedRoute[rk0] = _pingHeroFlyinData[rk0];
                }
            }
            for (var rk1 in data) {
                if (Object.prototype.hasOwnProperty.call(data, rk1)) {
                    mergedRoute[rk1] = data[rk1];
                }
            }
            _pingHeroFlyinData = mergedRoute;
            if (data.title != null) {
                var routeTitleEl = document.getElementById('spinFlyinLocationTitle');
                if (routeTitleEl) routeTitleEl.textContent = String(data.title);
            }
            if (!document.body.classList.contains('is-route-focused')) {
                var newRouteHero = data.thumbnail_url || data.image || data.logo_url;
                if (newRouteHero) setPingHeroLocationImage(bustRouteThumbUrl(newRouteHero));
            }
        }

        var routeCard = document.querySelector('.ping-fp-route-item[data-routeid="' + id + '"]');
        if (routeCard) {
            if (data.title != null) {
                routeCard.setAttribute('data-title', String(data.title));
                routeCard.setAttribute('aria-label', String(data.title));
            }
            if (data.slug != null || data.subdomain_slug != null) {
                var newSlug = String(data.subdomain_slug || data.slug || '').toLowerCase();
                routeCard.setAttribute('data-slug', newSlug);
                if (newSlug) {
                    routeCard.setAttribute('data-subdomain-url', 'https://' + window.gfeSubdomainHost(newSlug));
                }
            }
            if (data.thumbnail_url) {
                var bustedThumb = bustRouteThumbUrl(data.thumbnail_url);
                routeCard.setAttribute('data-thumbnail-url', bustedThumb);
                var routeThumb = routeCard.querySelector('.territory-modal-item-thumb');
                if (routeThumb) routeThumb.src = bustedThumb;
            }
            if (data.distance_m != null) {
                routeCard.setAttribute('data-distance-m', String(data.distance_m));
                var distM = parseInt(data.distance_m, 10) || 0;
                var distLabel = distM >= 1000
                    ? (distM / 1000).toFixed(1) + 'km'
                    : distM + 'm';
                var titleSpan = routeCard.querySelector('.ping-fp-route-hero-title');
                if (titleSpan) titleSpan.textContent = distLabel + ' Route';
            }
            if (data.kind != null) {
                routeCard.setAttribute('data-kind', String(data.kind));
            }
            if (data.geojson_url) {
                routeCard.setAttribute('data-geojson-url', data.geojson_url);
            }
        }
    });

    document.addEventListener('gfe-location-edited', function (e) {
        var detail = e && e.detail ? e.detail : {};
        var id   = detail.id;
        var data = detail.data || {};
        if (!id) return;

        // ── 1. Hero band refresh (only if same id is currently shown) ──
        if (_pingHeroFlyinData && _pingHeroFlyinData.id === id) {
            var merged = {};
            for (var k0 in _pingHeroFlyinData) {
                if (Object.prototype.hasOwnProperty.call(_pingHeroFlyinData, k0)) {
                    merged[k0] = _pingHeroFlyinData[k0];
                }
            }
            for (var k1 in data) {
                if (Object.prototype.hasOwnProperty.call(data, k1)) {
                    merged[k1] = data[k1];
                }
            }
            _pingHeroFlyinData = merged;

            // Title: textContent in place. NO .is-revealed toggle —
            // the title is already visible to the user, re-triggering
            // the .65s fade would read as a flicker. Server returns
            // the new title under `data.title` (see UserController
            // updateUserLocation success payload, same field
            // updateLocationTileInPlace reads on line ~5523).
            if (data.title != null) {
                var titleEl = document.getElementById('spinFlyinLocationTitle');
                if (titleEl) titleEl.textContent = String(data.title);
            }

            // Image: re-pick from merged and set if a new URL resolved.
            var newHeroUrl = pickLocationHeroUrl(merged);
            if (newHeroUrl) setPingHeroLocationImage(newHeroUrl);

            // Socials: re-render then snap the new chips to .is-revealed
            // with transitions disabled for one frame, so the freshly
            // recreated elements adopt the same visible state without
            // a fade-from-0 flash.
            renderPingHeroSocials(merged);
            var socBox = document.getElementById('pingHeroSocials');
            if (socBox && socBox.childElementCount) {
                socBox.setAttribute('aria-hidden', 'false');
                socBox.classList.add('is-revealed');
                var chips = socBox.querySelectorAll('.ping-hero-chip-btn');
                for (var ci = 0; ci < chips.length; ci++) {
                    var chip = chips[ci];
                    var prevT = chip.style.transition;
                    chip.style.transition = 'none';
                    chip.classList.add('is-revealed');
                    /* eslint-disable no-unused-expressions */
                    chip.offsetWidth;
                    /* eslint-enable no-unused-expressions */
                    chip.style.transition = prevT;
                }
            }

            if (typeof window.syncGfeFocusMapPin === 'function') {
                window.syncGfeFocusMapPin(merged);
            }
        }

        // ── 2. Slide-1 carousel card sync ───────────────────────────
        var card = document.querySelector(
            '#pingFpLocationsList .ping-fp-location-item[data-fpid="' + String(id).replace(/"/g, '\\"') + '"]'
        );
        if (card) {
            var existing = {};
            try {
                var raw = card.getAttribute('data-gfe-loc-payload');
                if (raw) existing = JSON.parse(raw) || {};
            } catch (err) {
                console.warn('[gfe-edit] could not parse card payload for re-sync', err);
            }
            var cardMerged = {};
            for (var k2 in existing) {
                if (Object.prototype.hasOwnProperty.call(existing, k2)) {
                    cardMerged[k2] = existing[k2];
                }
            }
            for (var k3 in data) {
                if (Object.prototype.hasOwnProperty.call(data, k3)) {
                    cardMerged[k3] = data[k3];
                }
            }
            try {
                card.setAttribute('data-gfe-loc-payload', JSON.stringify(cardMerged));
            } catch (err) {
                console.warn('[gfe-edit] could not stringify merged card payload', err);
            }

            // Title — same `data.title` field updateLocationTileInPlace
            // mirrors. The slide-1 partial puts the visible title in
            // .ping-fp-slide1-loc-title (a span inside .territory-
            // modal-item-name), so prefer that selector and fall back
            // to the broader name container if the partial ever changes.
            if (data.title != null) {
                card.setAttribute('data-title', String(data.title));
                var nameSpan = card.querySelector('.ping-fp-slide1-loc-title')
                    || card.querySelector('.territory-modal-item-name');
                if (nameSpan) nameSpan.textContent = String(data.title);
            }

            // Logo — same response shape as the title above.
            if (data.logo_url != null) {
                card.setAttribute('data-logo', String(data.logo_url || ''));
                var img = card.querySelector('img.territory-modal-item-thumb');
                if (img && data.logo_url) {
                    img.src = String(data.logo_url);
                }
            }

            if (data.subdomain_slug != null) {
                card.setAttribute('data-slug', String(data.subdomain_slug || ''));
            }
        } else if (typeof window.appendPingFpLocationItem === 'function') {
            var appendData = { id: id };
            for (var k4 in data) {
                if (Object.prototype.hasOwnProperty.call(data, k4)) {
                    appendData[k4] = data[k4];
                }
            }
            if (_pingHeroFlyinData && String(_pingHeroFlyinData.id) === String(id)) {
                for (var k5 in _pingHeroFlyinData) {
                    if (Object.prototype.hasOwnProperty.call(_pingHeroFlyinData, k5) && appendData[k5] == null) {
                        appendData[k5] = _pingHeroFlyinData[k5];
                    }
                }
            }
            try { window.appendPingFpLocationItem(appendData); } catch (appendErr) {}
        }
    });
    function setSpinFlyinLocationTitle(name) {
        var el = ensureSpinFlyinTitleEl();
        var label = name ? String(name).trim() : '';
        if (!label) {
            clearSpinFlyinLocationTitle();
            return;
        }
        applySpinFlyinTitleChrome(el);
        el.textContent = label;
        el.style.removeProperty('opacity');
        el.style.removeProperty('visibility');
        el.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-spin-arriving');
        el.classList.remove('is-revealed');
        renderPingHeroSocials(_pingHeroFlyinData);
        var editBtn = document.getElementById('pingHeroEditBtn');
        var pathBtn = document.getElementById('pingHeroRoutePathBtn');
        var stampBtn = document.getElementById('pingHeroStampBtn');
        var socialsBox = document.getElementById('pingHeroSocials');
        var heroBand = document.getElementById('pingHeroBand');
        var showRoutePathBtn = _pingHeroFlyinData
            && _pingHeroFlyinData._entity === 'route'
            && heroBand && heroBand.classList.contains('is-editable');
        if (pathBtn) {
            if (showRoutePathBtn) {
                pathBtn.setAttribute('aria-hidden', 'false');
                pathBtn.classList.remove('is-revealed');
            } else {
                clearPingHeroRoutePathBtn();
            }
        }
        if (editBtn) {
            editBtn.setAttribute('aria-hidden', 'false');
            editBtn.classList.remove('is-revealed');
        }
        if (stampBtn) {
            stampBtn.setAttribute('aria-hidden', 'false');
            stampBtn.classList.remove('is-revealed');
        }
        if (socialsBox && socialsBox.childElementCount) {
            socialsBox.setAttribute('aria-hidden', 'false');
        }
        var chips = document.querySelectorAll('#pingHeroSocials .ping-hero-chip-btn');
        for (var ci = 0; ci < chips.length; ci++) {
            chips[ci].classList.remove('is-revealed');
        }
        void el.offsetWidth;
        requestAnimationFrame(function () {
            el.classList.add('is-revealed');
            if (pathBtn && showRoutePathBtn) pathBtn.classList.add('is-revealed');
            if (editBtn) editBtn.classList.add('is-revealed');
            if (stampBtn) stampBtn.classList.add('is-revealed');
            for (var cj = 0; cj < chips.length; cj++) {
                chips[cj].classList.add('is-revealed');
            }
        });
    }
    function clearSpinFlyinLocationTitle() {
        // Cancel any pending revealFlyinTitleAfterMove timers / moveend.
        // Without this, dismissing manage/location view before the fly-in
        // settles re-paints the placename under the territories scrim.
        ++_flyinTitleTrip;
        document.body.classList.remove('is-spin-arriving');
        clearPingHeroEditBtn();
        clearPingHeroRoutePathBtn();
        clearPingHeroStampBtn();
        clearPingHeroSocials();
        clearSpinFlyinRouteStats();
        var el = _spinFlyinTitleEl || document.getElementById('spinFlyinLocationTitle');
        if (!el) return;
        el.classList.remove('is-revealed');
        el.style.removeProperty('opacity');
        el.style.removeProperty('visibility');
        el.textContent = '';
        el.setAttribute('aria-hidden', 'true');
    }

    // Map-surround hero (.ping-bg-image): hidden at rest; fly-in flows swap in
    // the location photo at 16:9 (see .is-location-hero).
    var _pingBgDefaultImage = '';
    function capturePingBgDefault() {
        var el = document.querySelector('.ping-bg-image');
        if (!el || _pingBgDefaultImage) return;
        _pingBgDefaultImage = el.style.backgroundImage || '';
        if (!_pingBgDefaultImage || _pingBgDefaultImage === 'none') {
            var attr = el.getAttribute('style') || '';
            var m = attr.match(/background-image\s*:\s*([^;]+)/i);
            if (m) _pingBgDefaultImage = m[1].trim();
        }
    }
    function pingHeroBgUrlCss(url) {
        var u = String(url || '').trim();
        if (!u) return '';
        if (u.indexOf('//') === 0) u = 'https:' + u;
        return 'url(' + JSON.stringify(u) + ')';
    }
    function pickLocationHeroUrl(data) {
        if (!data) return '';
        return data.image || data.logo_url || data.logo || data.thumbnail
            || data.thumbnail_url || data.cover_image_url || data.image_fallback || '';
    }

    var PING_ROUTE_HERO_DEFAULT = window.PING_ROUTE_HERO_DEFAULT
        || '/images/routes/route-hero-default.png';
    function isRouteHeroDefaultUrl(url) {
        if (!url) return true;
        return String(url).indexOf('route-hero-default') >= 0;
    }
    function bustRouteThumbUrl(url) {
        if (!url || String(url).indexOf('data:') === 0) return url;
        var u = String(url).trim();
        if (!u || isRouteHeroDefaultUrl(u)) return u;
        return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'v=' + Date.now();
    }
    window.bustRouteThumbUrl = bustRouteThumbUrl;
    function setPingHeroLocationImage(url) {
        var el = document.querySelector('.ping-bg-image');
        var img = document.getElementById('pingFlyinHeroImg');
        if (!url) return;
        capturePingBgDefault();
        if (el) {
            el.classList.remove('is-faded');
            el.classList.add('is-location-hero');
            el.style.backgroundImage = pingHeroBgUrlCss(url);
            el.style.opacity = '1';
        }
        if (img) {
            img.hidden = false;
            img.removeAttribute('hidden');
            if (img.getAttribute('src') !== url) {
                img.src = url;
            }
        }
        var band = document.getElementById('pingHeroBand');
        if (band) band.classList.add('is-location-hero');
    }
    function clearPingHeroLocationImage() {
        var el = document.querySelector('.ping-bg-image');
        var img = document.getElementById('pingFlyinHeroImg');
        if (el) {
            el.classList.remove('is-location-hero');
            el.style.removeProperty('opacity');
            if (_pingBgDefaultImage) el.style.backgroundImage = _pingBgDefaultImage;
        }
        if (img) {
            img.hidden = true;
            img.removeAttribute('src');
        }
        var band = document.getElementById('pingHeroBand');
        if (band) {
            band.classList.remove('is-location-hero');
            band.classList.remove('is-editable');
        }
        _pingHeroFlyinData = null;
    }

    // Fly-in title: fade starts `titleLeadMs` before the camera ease ends;
    // `afterReveal` still runs on moveend (e.g. detail modal 500ms later).
    var FLYIN_TITLE_LEAD_MS = 3000;
    function revealFlyinTitleAfterMove(name, opts) {
        clearSpinFlyinLocationTitle();
        opts = opts || {};
        var label = name ? String(name).trim() : '';
        var flyMs = parseInt(opts.flyMs, 10) || 3500;
        var fallbackMs = parseInt(opts.fallbackMs, 10) || (flyMs + 400);
        var leadMs = parseInt(opts.titleLeadMs, 10);
        if (!isFinite(leadMs)) leadMs = FLYIN_TITLE_LEAD_MS;
        var afterReveal = opts.afterReveal;
        var onTitleReveal = opts.onTitleReveal;
        var trip = ++_flyinTitleTrip;
        var titleShown = false;
        var settled = false;
        function showTitle() {
            if (titleShown || trip !== _flyinTitleTrip) return;
            titleShown = true;
            if (label) setSpinFlyinLocationTitle(label);
            if (typeof onTitleReveal === 'function') onTitleReveal();
        }
        function onSettled() {
            if (settled || trip !== _flyinTitleTrip) return;
            settled = true;
            showTitle();
            if (afterReveal) afterReveal();
        }
        setTimeout(showTitle, Math.max(0, flyMs - leadMs));
        map.once('moveend', onSettled);
        setTimeout(onSettled, Math.max(500, fallbackMs));
    }

    map.on('load', function(){
        capturePingBgDefault();
        applyBasemapChrome();

        // Jutdee: satellite from the first frame — don't wait for a modal
        // fade-in, and never fade back to vector (see fadeJutdeeSpinSatelliteOut).
        if (document.body.classList.contains('is-jutdee-tenant')) {
            addJutdeeSpinSatelliteLayer();
            try {
                if (map.getLayer(jutdeeSpinSatellite.layerId)) {
                    map.setPaintProperty(jutdeeSpinSatellite.layerId, 'raster-opacity-transition', { duration: 0, delay: 0 });
                    map.setPaintProperty(jutdeeSpinSatellite.layerId, 'raster-opacity', 1);
                }
            } catch (eSat) {}
            jutdeeSpinSatellite.active = true;
        }

        function spinGlobe() {
            if (autoSpin.active) {
                autoSpin.rotation += 0.12;
                map.setCenter([autoSpin.rotation % 360, 15]);
            }
            globalSpinRaf = requestAnimationFrame(spinGlobe);
        }

        if (PL.countryBackdropEnabled && PL.countryBackdropUrl) {
            autoSpin.active = false;
            fetch(PL.countryBackdropUrl, {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
            })
                .then(function (r) {
                    if (!r.ok) throw new Error('HTTP ' + r.status);
                    return r.json();
                })
                .then(function (data) {
                    if (!initCountryBackdrop(data)) {
                        autoSpin.active = !(PL && PL.globeIdleSpinEnabled === false);
                        if (autoSpin.active) spinGlobe();
                        if (!window.__pingCelebrateTakeover) revealJutdeeTenantLanding();
                    }
                })
                .catch(function () {
                    autoSpin.active = !(PL && PL.globeIdleSpinEnabled === false);
                    if (autoSpin.active) spinGlobe();
                    if (!window.__pingCelebrateTakeover) revealJutdeeTenantLanding();
                });
        } else {
            spinGlobe();
        }

    });

    // ── Spin The Globe: eye CTA reactivity (cursor-follow + click-squish) ──
    // The pink disc was replaced by a pure-CSS eye (see the eye CTA
    // section in ping-landing.css). The eye's iris tilts toward the
    // cursor via four CSS custom properties the CSS reads — this
    // handler is the writer. Clicks trigger a one-shot vertical
    // "forced blink" squish via the .is-squishing class, and a
    // setTimeout-driven scheduler also fires gentle idle blinks +
    // autonomous gaze hops when the cursor's been still (or there's
    // no cursor at all, on touch).
    //
    // Note on prefers-reduced-motion: deliberately NOT gated. The
    // animations involved are tiny non-vestibular nudges — 220 ms
    // scaleY blink, 360 ms scaleY click squish, ±18° iris tilt, ±8 px
    // translate — well below the threshold reduce-motion is meant to
    // suppress (parallax, autoplaying video, large slide transitions).
    // Gating on it was making the eye look dead on mobile under iOS
    // Low Power Mode (which flips reduce-motion to `reduce` from
    // iOS 16 onward) and on phones with the accessibility setting on,
    // and that's not the trade we want for a hero CTA.
    (function initSpinHeroEye(){
        // Slide 1 hosts the clone eye (.spin-hero-cta--clone, no id);
        // slide 2 keeps #spinGlobeTrigger #spinGlobeBtn for spin CTA.
        // Territory empty-slot eyes are decorative clones (re-queried so
        // appendTerritoryEmptySlot() picks them up without a reload).
        function collectEyeBtns() {
            var out = [];
            function pushBtn(el) {
                if (el && out.indexOf(el) === -1) {
                    out.push(el);
                }
            }
            pushBtn(document.querySelector('#spinGlobeTrigger #spinGlobeBtn'));
            pushBtn(document.querySelector(
                '#spinIntroAuthedCarouselViewport .spin-globe-trigger--floating--clone .spin-hero-cta'
            ));
            pushBtn(document.querySelector('.spin-hero-stack #spinGlobeBtn'));
            document.querySelectorAll(
                '#gfeTownsList .ping-fp-slide2-empty-placeholder .spin-hero-cta--decorative'
            ).forEach(pushBtn);
            return out;
        }
        if (!collectEyeBtns().length) {
            return;
        }

        function wireDecorativeEye(btn) {
            if (!btn || !btn.classList.contains('spin-hero-cta--decorative') || btn.__decorativeEyeWired) {
                return;
            }
            btn.__decorativeEyeWired = true;
            btn.addEventListener('animationend', function (e) {
                if (e.animationName === 'ctaBlink') {
                    btn.classList.remove('is-blinking');
                }
            });
        }

        function setGaze(btn, dx, dy) {
            btn.style.setProperty('--vxAngle', (dx * 18) + 'deg');
            btn.style.setProperty('--vyAngle', (-dy * 18) + 'deg');
            btn.style.setProperty('--vxMove',  (dx * 8)  + 'px');
            btn.style.setProperty('--vyMove',  (dy * 8)  + 'px');
        }

        function visibleBtns() {
            return collectEyeBtns().filter(function (btn) {
                wireDecorativeEye(btn);
                var rect = btn.getBoundingClientRect();
                return rect.width > 0 && rect.height > 0;
            });
        }

        // Cursor-activity timestamp — the autonomous gaze below checks
        // this so the gaze yields to a real cursor on desktop and only
        // animates the eye when the user has been idle for >1.5 s (or
        // has no cursor at all, e.g. on touch devices, where this
        // timestamp stays at 0 forever and the gaze is the only thing
        // moving the eye).
        var lastMouseMove = 0;

        // Clamp dx/dy to [-1, 1] so the iris never tilts past 18°
        // / shifts past 8 px regardless of cursor distance — the eye
        // tracks naturally near the disc and stays calm when the
        // cursor wanders far away. Each button tracks relative to its
        // own centre so slide-1 and slide-2 eyes stay aligned when both
        // exist in the DOM.
        window.addEventListener('mousemove', function(e){
            lastMouseMove = Date.now();
            var range = 200;
            visibleBtns().forEach(function (btn) {
                var rect = btn.getBoundingClientRect();
                var cx = rect.left + rect.width / 2;
                var cy = rect.top  + rect.height / 2;
                var dx = Math.max(-1, Math.min(1, (e.clientX - cx) / range));
                var dy = Math.max(-1, Math.min(1, (e.clientY - cy) / range));
                setGaze(btn, dx, dy);
            });
        }, { passive: true });

        function triggerBlink(btn) {
            if (document.hidden || btn.classList.contains('is-squishing')) return;
            btn.classList.remove('is-blinking');
            void btn.offsetWidth;
            btn.classList.add('is-blinking');
        }

        // Random idle blinks — every 3-8 s the eye plays a brief
        // ctaBlink animation (the calmer scaleY cousin of the
        // click-squish). document.hidden skips blinks while the
        // tab is backgrounded; the .is-squishing guard avoids
        // colliding with an in-flight click reaction. Forced
        // reflow + re-add lets consecutive blinks replay cleanly,
        // mirroring the click-squish pattern below.
        (function scheduleBlink(){
            var delay = 3000 + Math.random() * 5000;
            setTimeout(function(){
                visibleBtns().forEach(triggerBlink);
                scheduleBlink();
            }, delay);
        })();

        // Autonomous "idle gaze" — every 2-5 s, when the cursor has
        // been still for >1.5 s (or there's no cursor at all, e.g. on
        // touch devices), the eye picks a new random target inside
        // 60 % of the mousemove envelope. Same CSS custom properties
        // mousemove writes, so the existing transition on .eye__iris
        // smooths each hop. Skipped when the tab is hidden so we
        // don't waste ticks invisibly. The eye+iris translate
        // transforms are independent of the button's squish/blink
        // scaleY animations, so no class guard is needed.
        (function autonomousGaze(){
            var idle = Date.now() - lastMouseMove > 1500;
            if (idle && !document.hidden){
                var dx = (Math.random() * 2 - 1) * 0.6;
                var dy = (Math.random() * 2 - 1) * 0.6;
                visibleBtns().forEach(function (btn) {
                    setGaze(btn, dx, dy);
                });
            }
            setTimeout(autonomousGaze, 2000 + Math.random() * 3000);
        })();

        // Class is removed/re-added around a forced reflow so
        // consecutive clicks replay the animation. animationend
        // strips the class for next time.
        collectEyeBtns().forEach(function (btn) {
            if (btn.classList.contains('spin-hero-cta--decorative')) {
                wireDecorativeEye(btn);
                return;
            }
            if (btn.__spinHeroEyeClickWired) {
                return;
            }
            btn.__spinHeroEyeClickWired = true;
            btn.addEventListener('click', function () {
                btn.classList.remove('is-squishing');
                void btn.offsetWidth;
                btn.classList.add('is-squishing');
            });
            btn.addEventListener('animationend', function (e) {
                if (e.animationName === 'ctaSquish') {
                    btn.classList.remove('is-squishing');
                } else if (e.animationName === 'ctaBlink') {
                    btn.classList.remove('is-blinking');
                }
            });
        });
    })();

    // ── Spin The Globe: click-to-discover state machine ──
    (function() {
        var floatingSpinBtn = document.querySelector('#spinGlobeTrigger #spinGlobeBtn')
            || document.getElementById('spinAuthedTerritoriesSpinBtn');
        var heroSpinEye     = document.querySelector('.spin-hero-stack #spinGlobeBtn');
        var btn             = floatingSpinBtn || heroSpinEye;
        var modal      = document.getElementById('spinModal');
        if (!modal) return;
        // Authed slide 2 at territory cap renders upgrade-only UI (no
        // #spinGlobeBtn) but the intro carousel must still mount.
        function spinGlobeDataEl() {
            return document.getElementById('spinGlobeTrigger')
                || document.getElementById('spinGlobeTriggerAuthedSentinel')
                || btn
                || document.getElementById('spinCelebrateBanner');
        }

        // Intro modal replaces the previous standalone #spinGlobeBtn as the
        // primary CTA surface. It's the resting "home" of the landing page:
        // shown on load, hidden while spinning / while the result modal is
        // up, and reshown when the result modal closes so the user always
        // has a visible path back to another spin.
        var introModal = document.getElementById('spinIntroModal');
        var introFlyRestFallbackTimer = null;
        // Cached reference to the map-surround backdrop. It fades OUT
        // when the user initiates a spin (intro flies out → spin globe
        // → result modal flies in) and fades back IN when we return to
        // the resting intro state. Nothing happens to the backdrop when
        // the intro itself appears — it's part of the same resting
        // landing surface, so showing the intro is a no-op for the
        // backdrop. See .ping-bg-image.is-faded rule in ping-landing.css.
        var bgImage = document.querySelector('.ping-bg-image');
        function syncSpinIntroMergeDock() {
            var mergeTray = document.getElementById('spinHeroMergeTray');
            var showMergeBottom = false;
            var card = document.getElementById('spinIntroCard');
            var carViewport = document.getElementById('spinIntroAuthedCarouselViewport');
            var activeSlide = carViewport
                ? carViewport.getAttribute('data-active-slide')
                : null;
            var jutdeeAuthedTerritoriesModal = !!(PL.isJutdeeTenant && carViewport
                && carViewport.getAttribute('data-viewer-authed') === '1');
            if (jutdeeAuthedTerritoriesModal) {
                document.body.classList.remove('is-spin-intro-merge-bottom');
                if (mergeTray) {
                    mergeTray.setAttribute('aria-hidden', 'true');
                }
                var stack = document.getElementById('spinIntroBottomStack');
                if (stack) {
                    stack.style.width = '';
                    stack.style.maxWidth = '';
                }
                return;
            }
            // Merge UI lives on the live territories slide (slide 2 after the
            // focal-points swap). Showing it while slide 1 is active left the
            // tray off-screen / under the card because the stack scrolls with
            // the carousel but body.is-spin-intro-merge-bottom did not.
            var onTerritoriesSlide = !carViewport || activeSlide === '2';
            if (mergeTray && introModal && card && onTerritoriesSlide
                && introModal.classList.contains('visible')
                && !introModal.classList.contains('is-flying-out')) {
                var ib = card.querySelector('.spin-intro-body');
                if (!ib || !ib.classList.contains('is-gfeimport')) {
                    showMergeBottom = true;
                }
            }
            document.body.classList.toggle('is-spin-intro-merge-bottom', showMergeBottom);
            if (mergeTray) {
                mergeTray.setAttribute('aria-hidden', showMergeBottom ? 'false' : 'true');
            }

            // Only the bottom stack needs an explicit width; the merge tray
            // is a width:100% child of it (CSS), so it tracks the stack
            // automatically — no need to size #spinIntroMergeBottom here.
            var stack = document.getElementById('spinIntroBottomStack');
            var rail = document.getElementById('pingFpTownsHint');
            var railW = rail ? rail.getBoundingClientRect().width : 0;
            var cardW = card ? card.getBoundingClientRect().width : 0;
            var w = Math.max(railW, cardW);
            if (w < 48) {
                w = Math.min(window.innerWidth * 0.9, 420);
            }
            if (onTerritoriesSlide && w > 0) {
                if (stack) {
                    stack.style.width = w + 'px';
                    stack.style.maxWidth = w + 'px';
                }
            } else {
                if (stack) {
                    stack.style.width = '';
                    stack.style.maxWidth = '';
                }
            }

            var ft = document.getElementById('spinGlobeTrigger');
            if (!ft) return;
            var introResting = introModal && introModal.classList.contains('visible')
                && !introModal.classList.contains('is-flying-out');
            if (introResting && onTerritoriesSlide) {
                ft.classList.add('is-visible');
                ft.setAttribute('aria-hidden', 'false');
            } else if (introResting && !showMergeBottom) {
                ft.classList.add('is-visible');
                ft.setAttribute('aria-hidden', 'false');
            } else {
                ft.classList.remove('is-visible');
                ft.setAttribute('aria-hidden', 'true');
            }
        }
        window.syncSpinIntroMergeDock = syncSpinIntroMergeDock;

        // The merge tray is server-rendered only when the page loads with
        // 2+ towns. Claiming a second territory in-session adds the town
        // card via JS but not the tray markup — a full reload is required
        // so Blade can emit #spinHeroMergeTray and the Sortable IIFE.
        function spinIntroNeedsMergeTrayReload() {
            if (PL.isJutdeeTenant) {
                if (document.getElementById('spinTerritoriesModalMergeTray')) {
                    return false;
                }
                var tbody = document.getElementById('spinIntroTerritoriesTableBody');
                if (!tbody) {
                    return false;
                }
                return tbody.querySelectorAll('.territory-modal-item').length >= 2;
            }
            if (document.getElementById('spinHeroMergeTray')) return false;
            var list = document.getElementById('gfeTownsList');
            if (!list) return false;
            return list.querySelectorAll('.ping-fp-slide2-town-item').length >= 2;
        }

        (function spinIntroCarouselSlideBannerInit() {
            /** Pin #spinCelebrateBanner just under .spin-intro-auth--floating (balance pill). */
            window.syncSpinCelebrateBannerUnderFloatingPill = function () {
                var banner = document.getElementById('spinCelebrateBanner');
                var pill = document.querySelector('.spin-intro-auth--floating');
                if (!banner) return;
                /* Guest headline sits at the bottom via CSS — do not pin under the auth pill. */
                if (banner.getAttribute('data-spin-guest-banner') === '1') {
                    banner.style.removeProperty('top');
                    banner.style.removeProperty('bottom');
                    return;
                }
                if (banner.hidden) {
                    banner.style.removeProperty('top');
                    return;
                }
                if (!pill) {
                    banner.style.removeProperty('top');
                    return;
                }
                var pr = pill.getBoundingClientRect();
                if (pr.height < 2 || pr.width < 2) {
                    banner.style.removeProperty('top');
                    return;
                }
                var gap = 12;
                banner.style.top = (pr.bottom + gap) + 'px';
            };

            /** Focal slide (1): banner is fixed above the modal — push slide 1 content
             *  down by the measured banner bottom edge so the list clears copy. */
            window.syncSpinIntroSlide1UnderBannerPad = function () {
                var viewport = document.getElementById('spinIntroAuthedCarouselViewport');
                var slide1 = viewport && viewport.querySelector('[data-spin-intro-slide="1"]');
                var slide2 = viewport && viewport.querySelector('[data-spin-intro-slide="2"]');
                var slide3 = viewport && viewport.querySelector('[data-spin-intro-slide="3"]');
                var slide4 = viewport && viewport.querySelector('[data-spin-intro-slide="4"]');
                var banner = document.getElementById('spinCelebrateBanner');
                var introMo = document.getElementById('spinIntroModal');

                function clearSlidePad(slide, prop) {
                    if (slide) slide.style.removeProperty(prop);
                }

                if (!viewport || !banner || !introMo
                    || !introMo.classList.contains('visible')
                    || introMo.classList.contains('is-flying-out')
                    || banner.hidden) {
                    clearSlidePad(slide1, '--spin-intro-slide1-top-pad');
                    clearSlidePad(slide2, '--spin-intro-slide2-top-pad');
                    clearSlidePad(slide3, '--spin-intro-slide3-top-pad');
                    clearSlidePad(slide4, '--spin-intro-slide4-top-pad');
                    return;
                }

                var activeSlide = (viewport.getAttribute('data-active-slide') || '1').trim();
                var br = banner.getBoundingClientRect();
                if (br.height < 2 || br.width < 2) {
                    clearSlidePad(slide1, '--spin-intro-slide1-top-pad');
                    clearSlidePad(slide2, '--spin-intro-slide2-top-pad');
                    clearSlidePad(slide3, '--spin-intro-slide3-top-pad');
                    clearSlidePad(slide4, '--spin-intro-slide4-top-pad');
                    return;
                }
                var gap = 14;

                clearSlidePad(slide1, '--spin-intro-slide1-top-pad');
                clearSlidePad(slide2, '--spin-intro-slide2-top-pad');
                clearSlidePad(slide3, '--spin-intro-slide3-top-pad');
                clearSlidePad(slide4, '--spin-intro-slide4-top-pad');

                var activeEl = activeSlide === '1' ? slide1
                    : activeSlide === '2' ? slide2
                    : activeSlide === '3' ? slide3
                    : activeSlide === '4' ? slide4
                    : null;
                var padProp = activeSlide === '1' ? '--spin-intro-slide1-top-pad'
                    : activeSlide === '2' ? '--spin-intro-slide2-top-pad'
                    : activeSlide === '3' ? '--spin-intro-slide3-top-pad'
                    : activeSlide === '4' ? '--spin-intro-slide4-top-pad'
                    : null;
                if (activeEl && padProp) {
                    var sr = activeEl.getBoundingClientRect();
                    var pad = Math.ceil(br.bottom - sr.top + gap);
                    if (pad < 0) pad = 0;
                    activeEl.style.setProperty(padProp, pad + 'px');
                }
            };

            function finishIntroCarouselBannerLayout() {
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        if (typeof window.syncSpinCelebrateBannerUnderFloatingPill === 'function') {
                            window.syncSpinCelebrateBannerUnderFloatingPill();
                        }
                        if (typeof window.syncSpinIntroSlide1UnderBannerPad === 'function') {
                            window.syncSpinIntroSlide1UnderBannerPad();
                        }
                        // Safety net: if a game/walk session left the top
                        // chrome hidden and we're now resting on the intro,
                        // bring it back. restorePingLandingTopChrome()
                        // self-guards (no-op unless chrome was actually
                        // hidden) so a normal slide swipe pays nothing here.
                        var introMo = document.getElementById('spinIntroModal');
                        if (introMo && introMo.classList.contains('visible')
                            && !introMo.classList.contains('is-flying-out')
                            && typeof window.restorePingLandingTopChrome === 'function') {
                            window.restorePingLandingTopChrome();
                        }
                    });
                });
            }

            window.syncSpinIntroSlideBanner = function () {
                var banner = document.getElementById('spinCelebrateBanner');
                if (!banner) return;
                if (window.__spinCelebrateBannerLock) return;

                var introBody = document.querySelector('#spinIntroModal .spin-intro-body.spin-intro-body');
                if (introBody && (
                    introBody.classList.contains('is-avatarprompt')
                    || introBody.classList.contains('is-verifyprompt')
                )) {
                    banner.innerHTML = '';
                    banner.hidden = true;
                    banner.removeAttribute('data-spin-slide-carousel');
                    return;
                }

                var introMo = document.getElementById('spinIntroModal');
                var viewport = document.getElementById('spinIntroAuthedCarouselViewport');

                function clearSlideBanner() {
                    banner.innerHTML = '';
                    banner.hidden = true;
                    banner.removeAttribute('data-spin-slide-carousel');
                }

                window.hideSpinIntroCarouselBanner = function () {
                    if (!banner || window.__spinCelebrateBannerLock) return;
                    clearSlideBanner();
                    finishIntroCarouselBannerLayout();
                };

                if (!viewport || !introMo
                    || !introMo.classList.contains('visible')
                    || introMo.classList.contains('is-flying-out')) {
                    if (banner.getAttribute('data-spin-guest-banner') === '1') {
                        finishIntroCarouselBannerLayout();
                        return;
                    }
                    clearSlideBanner();
                    finishIntroCarouselBannerLayout();
                    return;
                }

                var sw = viewport.getAttribute('data-active-slide') || '1';
                if (!/^[1-9]\d*$/.test(sw)) sw = '1';
                /* Territories slide: title is inside #spinIntroTerritoriesTableOverlay. */
                if (sw === '2' && document.getElementById('spinIntroTerritoriesTableOverlay')) {
                    clearSlideBanner();
                    finishIntroCarouselBannerLayout();
                    return;
                }
                /* Focal Points slide: title is inside #spinIntroFocalPointsOverlay. */
                if (sw === '1' && document.getElementById('spinIntroFocalPointsOverlay')) {
                    clearSlideBanner();
                    finishIntroCarouselBannerLayout();
                    return;
                }
                var section = viewport.querySelector(
                    '[data-spin-intro-slide="' + sw + '"]'
                );
                if (!section) {
                    clearSlideBanner();
                    finishIntroCarouselBannerLayout();
                    return;
                }

                var line1 = (section.getAttribute('data-spin-intro-banner-line1') || '').trim();
                var line2 = (section.getAttribute('data-spin-intro-banner-line2') || '').trim();
                var desc = (section.getAttribute('data-spin-intro-banner-desc') || '').trim();
                var primary = line1 || line2;
                if (!primary && !desc) {
                    clearSlideBanner();
                    finishIntroCarouselBannerLayout();
                    return;
                }

                banner.innerHTML = '';
                banner.removeAttribute('data-spin-slide-carousel');
                banner.hidden = false;

                if (primary) {
                    var span1 = document.createElement('span');
                    span1.className = 'spin-celebrate-line1';
                    span1.textContent = primary;
                    banner.appendChild(span1);
                }

                if (line1 && line2 && line2 !== line1) {
                    var span2 = document.createElement('span');
                    span2.className = 'spin-celebrate-line2';
                    span2.textContent = line2;
                    banner.appendChild(span2);
                }

                if (desc) {
                    var descEl = document.createElement('p');
                    descEl.className = 'spin-celebrate-banner-desc';
                    descEl.textContent = desc;
                    banner.appendChild(descEl);
                }

                banner.setAttribute('data-spin-slide-carousel', '1');
                finishIntroCarouselBannerLayout();
            };
            (function bindSpinIntroCarouselBannerLayoutObservers() {
                var banner = document.getElementById('spinCelebrateBanner');
                if (!banner) return;
                var pill = document.querySelector('.spin-intro-auth--floating');
                function bumpLayout() {
                    if (typeof window.syncSpinCelebrateBannerUnderFloatingPill === 'function') {
                        window.syncSpinCelebrateBannerUnderFloatingPill();
                    }
                    if (typeof window.syncSpinIntroSlide1UnderBannerPad === 'function') {
                        window.syncSpinIntroSlide1UnderBannerPad();
                    }
                }
                if (window.ResizeObserver) {
                    var ro = new ResizeObserver(bumpLayout);
                    ro.observe(banner);
                    if (pill) ro.observe(pill);
                }
                window.addEventListener('resize', bumpLayout);
            })();
            /** Map backdrop (.ping-bg-image): match active authed-carousel slide hero. */
            window.syncPingMapBackdropFromCarousel = function () {
                var bgEl = document.querySelector('.ping-bg-image');
                var viewport = document.getElementById(
                    'spinIntroAuthedCarouselViewport'
                );
                // Do not clobber the location photo during map fly-in.
                if (!bgEl || bgEl.classList.contains('is-location-hero') || !viewport) return;
                if (document.body.classList.contains('is-route-focused')) return;
                var sw = viewport.getAttribute('data-active-slide') || '1';
                if (!/^[1-9]\d*$/.test(sw)) sw = '1';
                var sec = viewport.querySelector(
                    '[data-spin-intro-slide="' + sw + '"]'
                );
                if (!sec) return;
                var url = sec.getAttribute('data-spin-intro-ping-bg');
                var gfe = sec.getAttribute('data-spin-intro-ping-bg-gfe');
                if (sw === '2' && gfe) {
                    var ib = document.querySelector(
                        '#spinIntroCard .spin-intro-body'
                    );
                    if (ib && ib.classList.contains('is-gfeimport')) {
                        url = gfe;
                    }
                }
                url = (url || '').trim();
                if (!url) return;
                bgEl.style.backgroundImage =
                    'url("' + url.replace(/\\/g, '\\\\').replace(/"/g, '\\"') +
                    '")';
            };
        })();
        (function bindSpinIntroMergeDockObservers() {
            if (!window.MutationObserver || !introModal) return;
            var card = document.getElementById('spinIntroCard');
            var ib = card && card.querySelector('.spin-intro-body');
            var mo = new MutationObserver(function () {
                syncSpinIntroMergeDock();
                if (typeof window.syncSpinIntroSlideBanner === 'function') {
                    window.syncSpinIntroSlideBanner();
                }
                if (typeof window.syncPingMapBackdropFromCarousel === 'function') {
                    window.syncPingMapBackdropFromCarousel();
                }
            });
            var opts = { attributes: true, attributeFilter: ['class'] };
            mo.observe(introModal, opts);
            if (card) mo.observe(card, opts);
            if (ib) mo.observe(ib, opts);
            syncSpinIntroMergeDock();
            (function bindMergeStackWidthToIntroCard() {
                var stack = document.getElementById('spinIntroBottomStack');
                if (!stack || !card || !window.ResizeObserver) return;
                function onLayout() {
                    if (typeof window.syncSpinIntroMergeDock === 'function') {
                        window.syncSpinIntroMergeDock();
                    }
                }
                window.addEventListener('resize', onLayout);
                var ro = new ResizeObserver(onLayout);
                ro.observe(card);
            })();
        })();
        function showIntro() {
            if (!introModal) return;
            // Defensive: any showIntro() re-entry means we're back on
            // the carousel, so the in-place close FAB has no purpose.
            // Clearing here keeps the body class from being stranded
            // by an unrelated exit path (browser back, voucher flow,
            // tour controller, etc.).
            document.body.classList.remove('is-gfe-focused');
            document.body.classList.remove('is-gfe-import-flyin');
            document.body.classList.remove('is-gfe-import-setup-pending');
            document.body.classList.remove('is-route-focused');
            // Clear any mid-flight fly-out state so a fresh open is crisp.
            introModal.classList.remove('is-flying-out');
            var introCard = document.getElementById('spinIntroCard');
            if (introCard) {
                introCard.classList.remove('spin-intro-flyin-rest');
            }
            introModal.classList.add('visible');
            if (introCard) {
                introCard.classList.remove('is-intro-modal-collapsed');
                var introToggle = document.getElementById('spinIntroModalToggle');
                if (introToggle) {
                    introToggle.setAttribute('aria-expanded', 'true');
                    introToggle.title = introToggle.getAttribute('data-title-expanded') || '';
                }
            }
            if (introModal) introModal.classList.remove('is-intro-collapsed-bar');
            if (introCard && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                requestAnimationFrame(function () {
                    if (introModal.classList.contains('visible') && !introModal.classList.contains('is-flying-out')) {
                        introCard.classList.add('spin-intro-flyin-rest');
                    }
                });
            }
            // Backdrop belongs to the resting landing state — if the
            // intro is visible, the backdrop should be visible too.
            // Remove the faded class so the 0.9s opacity transition
            // brings it back to 0.35 whenever we re-enter the intro.
            clearPingHeroLocationImage();
            if (bgImage) bgImage.classList.remove('is-faded');
            if (introFlyRestFallbackTimer) clearTimeout(introFlyRestFallbackTimer);
            introFlyRestFallbackTimer = setTimeout(function () {
                introFlyRestFallbackTimer = null;
                var c = document.getElementById('spinIntroCard');
                if (!c || !introModal || !introModal.classList.contains('visible') || introModal.classList.contains('is-flying-out')) return;
                if (!c.classList.contains('spin-intro-flyin-rest')) c.classList.add('spin-intro-flyin-rest');
            }, 800);
            // Authed carousel: restore last active slide from localStorage
            // (see spinIntroAuthedCarouselInit). Demo collapse state survives.
            var carViewport = document.getElementById('spinIntroAuthedCarouselViewport');
            if (carViewport && carViewport._spinIntroCarRestore
                && !carViewport._spinIntroCarSkipRestore
                && !jutdeeAuthedNeedsOnboarding()) {
                carViewport._spinIntroCarRestore();
            }
            syncSpinIntroMergeDock();
            if (typeof window.syncSpinIntroSlideBanner === 'function') {
                window.syncSpinIntroSlideBanner();
            }
            if (typeof window.syncPingMapBackdropFromCarousel === 'function') {
                window.syncPingMapBackdropFromCarousel();
            }
            if (jutdeeAuthedNeedsOnboarding()) {
                hideJutdeeTerritoriesTableOverlay();
                if (typeof window.hideJutdeeFocalPointsOverlay === 'function') {
                    window.hideJutdeeFocalPointsOverlay(false);
                }
                var onboardingCard = document.getElementById('spinIntroCard');
                if (onboardingCard) {
                    onboardingCard.classList.add('spin-intro-flyin-rest');
                }
            }
        }
        function restoreIntroInGfeimportMode() {
            try { showIntro(); } catch (e) {}
            var ib = document.querySelector('#spinIntroModal .spin-intro-body');
            if (ib) ib.classList.add('is-gfeimport');
            if (typeof window.initGamifeyeImporters === 'function') {
                try { window.initGamifeyeImporters(); } catch (e) {}
            }
        }
        // hideIntro animates the intro card up and off-screen (mirroring
        // the result modal's fly-in in reverse), then removes `.visible`
        // so display:flex goes away. Keeping `.visible` on during the
        // animation is what lets the card actually render while it
        // translates up — remove it too early and the browser collapses
        // the modal before the transform kicks in.
        //
        // Pass `animate=false` to skip the animation (e.g. teardown on
        // page unload, or if the caller is already staging its own
        // transition).
        var FLY_OUT_MS = 500; // keep in sync with spinFlyOut duration in ping-landing.css
        function hideIntro(animate) {
            if (!introModal) return;
            if (!introModal.classList.contains('visible')) return;
            if (typeof window.hideSpinIntroCarouselBanner === 'function') {
                window.hideSpinIntroCarouselBanner();
            }
            // Fade the big map backdrop out as the intro leaves — the
            // user has initiated a spin, so we want the globe itself to
            // be the star of the transitional moment, not the backdrop
            // art. Dropped here (not in `finish()`) so the .9s opacity
            // fade runs concurrently with the card's .5s fly-out.
            // Skip when a location/route hero is already painted.
            if (bgImage && !bgImage.classList.contains('is-location-hero')) {
                bgImage.classList.add('is-faded');
            }
            if (animate === false) {
                introModal.classList.remove('visible');
                introModal.classList.remove('is-flying-out');
                var icSnap = document.getElementById('spinIntroCard');
                if (icSnap) icSnap.classList.remove('spin-intro-flyin-rest');
                var terrOverlaySnap = document.getElementById('spinIntroTerritoriesTableOverlay');
                if (terrOverlaySnap) {
                    terrOverlaySnap.classList.remove('is-revealed', 'is-hero-in', 'is-hero-ready');
                    terrOverlaySnap.setAttribute('aria-hidden', 'true');
                }
                if (typeof window.hideJutdeeFocalPointsOverlay === 'function') {
                    window.hideJutdeeFocalPointsOverlay(false);
                }
                if (typeof window.syncJutdeeModalSatelliteBackdrop === 'function') {
                    window.syncJutdeeModalSatelliteBackdrop();
                }
                syncSpinIntroMergeDock();
                if (typeof window.syncSpinIntroSlideBanner === 'function') {
                    window.syncSpinIntroSlideBanner();
                }
                return;
            }
            if (introModal.classList.contains('is-flying-out')) return; // already animating out
            var fpOverlayFly = document.getElementById('spinIntroFocalPointsOverlay');
            if (fpOverlayFly
                && fpOverlayFly.classList.contains('is-revealed')
                && typeof window.hideJutdeeFocalPointsOverlay === 'function') {
                window.hideJutdeeFocalPointsOverlay(true);
            }
            var card = document.getElementById('spinIntroCard') || introModal.querySelector('.spin-card');
            if (card) card.classList.remove('spin-intro-flyin-rest');
            introModal.classList.add('is-flying-out');
            syncSpinIntroMergeDock();
            var finished = false;
            function finish() {
                if (finished) return;
                finished = true;
                if (card) card.removeEventListener('animationend', onEnd);
                introModal.classList.remove('visible');
                introModal.classList.remove('is-flying-out');
                var terrOverlayFinish = document.getElementById('spinIntroTerritoriesTableOverlay');
                if (terrOverlayFinish) {
                    terrOverlayFinish.classList.remove('is-revealed', 'is-hero-in', 'is-hero-ready');
                    terrOverlayFinish.setAttribute('aria-hidden', 'true');
                }
                if (typeof window.hideJutdeeFocalPointsOverlay === 'function') {
                    window.hideJutdeeFocalPointsOverlay(false);
                }
                if (typeof window.syncJutdeeModalSatelliteBackdrop === 'function') {
                    window.syncJutdeeModalSatelliteBackdrop();
                }
                syncSpinIntroMergeDock();
                if (typeof window.syncSpinIntroSlideBanner === 'function') {
                    window.syncSpinIntroSlideBanner();
                }
                if (typeof window.syncJutdeeOnboardingScrim === 'function') {
                    window.syncJutdeeOnboardingScrim();
                }
            }
            function onEnd(e) {
                if (e.animationName === 'spinFlyOut' || e.animationName === 'spinIntroFlyOut' || e.animationName === 'spinIntroCarouselFlyOut') finish();
            }
            if (card) card.addEventListener('animationend', onEnd);
            // Safety timeout: if animationend never fires (reduced-motion
            // preference, animation cancelled, or browser quirks) we
            // still cleanly remove the visibility classes.
            setTimeout(finish, FLY_OUT_MS + 150);
        }
        window.hidePingIntro = hideIntro;

        (function bindSpinIntroFlyinRest() {
            var ic = document.getElementById('spinIntroCard');
            if (!ic || !introModal) return;
            ic.addEventListener('animationend', function (e) {
                if (e.animationName !== 'spinIntroFlyIn' && e.animationName !== 'spinIntroCarouselFlyIn') return;
                if (!introModal.classList.contains('visible')) return;
                if (introModal.classList.contains('is-flying-out')) return;
                ic.classList.add('spin-intro-flyin-rest');
            });
        })();

        var heroEl     = document.getElementById('spinModalHero');
        var nameEl     = document.getElementById('spinModalName');
        var crumbEl    = document.getElementById('spinModalBreadcrumb');
        var extractEl  = document.getElementById('spinModalExtract');
        var wikiEl     = document.getElementById('spinModalWiki');
        var btnCloseX  = modal.querySelector('.spin-close');
        var btnEnterAura = document.getElementById('spinModalEnterAura');
        var btnJutdeeContinue = document.getElementById('spinModalJutdeeContinue');
        var btnJutdeeContinueLabel = document.getElementById('spinModalJutdeeContinueLabel');
        var btnJutdeeContinueSub = document.getElementById('spinModalJutdeeContinueSub');
        var btnJutdeePlayRow = document.getElementById('spinModalJutdeePlayRow');
        var btnJutdeeHowTo = document.getElementById('spinModalJutdeeHowTo');
        var btnJutdeePlay = document.getElementById('spinModalJutdeePlay');
        var btnJutdeePlaySub = document.getElementById('spinModalJutdeePlaySub');
        var btnJutdeePlayLabel = document.getElementById('spinModalJutdeePlayLabel');
        var btnJutdeeBackTerritories = document.getElementById('spinModalJutdeeBackTerritories');
        var spinCardEl   = modal.querySelector('.spin-card');
        var jutdeePickedGameSlug = null;
        var jutdeeSpinUiPhase = 'continue';

        (function bindSpinJutdeeResultFlyinRest() {
            if (!spinCardEl || !modal || modal.getAttribute('data-jutdee-spin-modal') !== '1') return;
            spinCardEl.addEventListener('animationend', function (e) {
                if (e.animationName !== 'spinJutdeeResultFlyIn') return;
                if (!modal.classList.contains('visible')) return;
                if (modal.classList.contains('is-flying-out')) return;
                spinCardEl.classList.add('spin-jutdee-result-rest');
            });
        })();

        // Canonical place label for the current spin result. The legacy
        // #spinModalName node was removed from gamifeye.com — the hero
        // pill (#spinModalHeroLocationName) is the live source now.
        function getSpinPlaceName() {
            var heroNameEl = document.getElementById('spinModalHeroLocationName');
            var fromHero = heroNameEl && heroNameEl.textContent && heroNameEl.textContent.trim();
            if (fromHero) return fromHero;
            var fromLegacy = nameEl && nameEl.textContent && nameEl.textContent.trim();
            if (fromLegacy) return fromLegacy;
            if (currentPlace && currentPlace.name) return String(currentPlace.name).trim();
            return '';
        }

        var STATE = 'IDLE';          // IDLE | SPINNING | ARRIVING | SHOW_MODAL
        var recentExclude = [];
        var RECENT_MAX = 5;
        var fastSpinRaf = null;
        var arriveTimer = null;
        var currentPlace = null;
        var SPIN_MIN_MS = 1500;
        var FLY_IN_MS = 3500;
        var spinStartT = 0;
        var spinFetchAbort = null;
        var spinFlyInTimer = null;

        function isJutdeeDirectFlyIn() {
            return !!(PL && PL.spinDirectFlyIn);
        }
        function isJutdeeSpinModal() {
            return !!(modal && modal.getAttribute('data-jutdee-spin-modal') === '1');
        }

        var jutdeeScrimEl = null;
        var jutdeeScrimRaf = null;
        var jutdeeScrimResizeWired = false;

        function getJutdeeScrimEl() {
            if (!jutdeeScrimEl) jutdeeScrimEl = document.getElementById('spinModalJutdeeScrim');
            return jutdeeScrimEl;
        }

        function layoutJutdeeSpinScrim() {
            var scrim = getJutdeeScrimEl();
            var card = spinCardEl;
            var frost = document.getElementById('spinModalJutdeeScrimFrost');
            if (!scrim || !card || !frost || scrim.hidden) return;
            var r = card.getBoundingClientRect();
            var vw = window.innerWidth;
            var vh = window.innerHeight;
            var radius = parseFloat(getComputedStyle(card).borderTopLeftRadius) || 20;
            var hole = 'M ' + (r.left + radius) + ' ' + r.top
                + ' H ' + (r.right - radius)
                + ' A ' + radius + ' ' + radius + ' 0 0 1 ' + r.right + ' ' + (r.top + radius)
                + ' V ' + (r.bottom - radius)
                + ' A ' + radius + ' ' + radius + ' 0 0 1 ' + (r.right - radius) + ' ' + r.bottom
                + ' H ' + (r.left + radius)
                + ' A ' + radius + ' ' + radius + ' 0 0 1 ' + r.left + ' ' + (r.bottom - radius)
                + ' V ' + (r.top + radius)
                + ' A ' + radius + ' ' + radius + ' 0 0 1 ' + (r.left + radius) + ' ' + r.top
                + ' Z';
            var clip = 'path(evenodd, "M 0 0 H ' + vw + ' V ' + vh + ' H 0 Z ' + hole + '")';
            frost.style.clipPath = clip;
            frost.style.webkitClipPath = clip;
        }

        function stopJutdeeScrimTracking() {
            if (jutdeeScrimRaf) {
                cancelAnimationFrame(jutdeeScrimRaf);
                jutdeeScrimRaf = null;
            }
        }

        function hideJutdeeSpinScrim() {
            stopJutdeeScrimTracking();
            var scrim = getJutdeeScrimEl();
            if (scrim) scrim.hidden = true;
        }

        function startJutdeeScrimTracking() {
            if (!isJutdeeSpinModal()) return;
            var scrim = getJutdeeScrimEl();
            if (!scrim) return;
            scrim.hidden = false;
            layoutJutdeeSpinScrim();
            if (!jutdeeScrimResizeWired) {
                jutdeeScrimResizeWired = true;
                window.addEventListener('resize', layoutJutdeeSpinScrim);
            }
            stopJutdeeScrimTracking();
            var started = performance.now();
            function tick(now) {
                layoutJutdeeSpinScrim();
                if (modal.classList.contains('visible') && now - started < 900) {
                    jutdeeScrimRaf = requestAnimationFrame(tick);
                } else {
                    jutdeeScrimRaf = null;
                }
            }
            jutdeeScrimRaf = requestAnimationFrame(tick);
        }

        function jutdeeGameDisplayName(slug) {
            if (!slug) return '';
            var names = PL && PL.jutdeeGameNames;
            if (names && names[slug]) return names[slug];
            if (slug === 'minesweeper') return 'Durian Picker';
            if (slug === 'flood-fill') return 'Rice Farmer';
            return '';
        }

        function setJutdeeGameSelectedCrumb(gameName) {
            var heroCrumbEl = document.getElementById('spinModalHeroLocationCrumb');
            if (!heroCrumbEl || !gameName) return;
            var fmt = (PL && PL.jutdeeGameSelectedFmt) || ':game Has Been Selected';
            heroCrumbEl.textContent = fmt.replace(':game', gameName);
        }

        function restoreJutdeeSpinPlaceCrumb() {
            var heroCrumbEl = document.getElementById('spinModalHeroLocationCrumb');
            if (!heroCrumbEl) return;
            heroCrumbEl.textContent = spinModalPlaceCrumbText(currentPlace);
        }

        function updateJutdeeContinueCreditsSub() {
            if (!btnJutdeeContinueSub || !isJutdeeSpinModal() || !PL.isJutdeeTenant) return;
            if (jutdeeSpinUiPhase !== 'continue') return;
            var credits = authFreeSpinsLeft != null ? authFreeSpinsLeft : msDemosLeft;
            if (credits != null) {
                btnJutdeeContinueSub.textContent = jutdeeGameCreditsLabel(credits);
                btnJutdeeContinueSub.hidden = false;
            } else {
                btnJutdeeContinueSub.textContent = '';
                btnJutdeeContinueSub.hidden = true;
            }
        }

        function setJutdeeContinueDefaultLabel() {
            if (btnJutdeeContinueLabel) {
                btnJutdeeContinueLabel.textContent = (PL && PL.jutdeeContinueLabel) || 'Click To Select Game';
            }
            updateJutdeeContinueCreditsSub();
        }

        function setJutdeeContinueLoadingLabel() {
            if (btnJutdeeContinueLabel) {
                btnJutdeeContinueLabel.textContent = (PL && PL.jutdeeChoosingGameLabel) || 'Choosing Game...';
            }
            if (btnJutdeeContinueSub) {
                btnJutdeeContinueSub.textContent = (PL && PL.jutdeeChoosingGameSub) || 'One Moment Please.';
                btnJutdeeContinueSub.hidden = false;
            }
        }

        function resetJutdeeSpinUi() {
            jutdeeSpinUiPhase = 'continue';
            if (btnJutdeeContinue) {
                btnJutdeeContinue.hidden = false;
                btnJutdeeContinue.disabled = false;
            }
            setJutdeeContinueDefaultLabel();
            restoreJutdeeSpinPlaceCrumb();
            if (btnJutdeePlayRow) btnJutdeePlayRow.hidden = true;
        }

        function setJutdeePlayReadyLabel() {
            var gameName = jutdeeGameDisplayName(jutdeePickedGameSlug);
            if (btnJutdeePlaySub) {
                btnJutdeePlaySub.textContent = (PL && PL.jutdeePlaySubLabel) || 'Click Here To Play';
            }
            if (btnJutdeePlayLabel) {
                btnJutdeePlayLabel.textContent = gameName;
            }
        }

        function showJutdeeSpinReadyUi() {
            jutdeeSpinUiPhase = 'ready';
            if (btnJutdeeContinue) {
                btnJutdeeContinue.hidden = true;
                btnJutdeeContinue.disabled = false;
            }
            restoreJutdeeSpinPlaceCrumb();
            setJutdeePlayReadyLabel();
            if (btnJutdeePlayRow) btnJutdeePlayRow.hidden = false;
        }

        function dismissJutdeeTerritoryClaimed() {
            if (!spinCardEl || !spinCardEl.classList.contains('won')) return;
            var place = getSpinPlaceName();
            var carVp = document.getElementById('spinIntroAuthedCarouselViewport');
            var canGoToTerritories = !!(carVp
                && carVp.getAttribute('data-territories-enabled') !== '0');

            // Hold carousel banner sync until celebrate copy has painted.
            window.__spinCelebrateBannerLock = true;

            clearSpinFlyinLocationTitle();
            modal.classList.remove('flying-up');
            modal.classList.remove('visible');
            jutdeePickedGameSlug = null;
            resetJutdeeSpinUi();
            spinCardEl.classList.remove('won');
            currentPlace = null;
            window.__spinActive = false;
            document.body.classList.remove('is-spinning');
            STATE = 'IDLE';
            try { resetTownMapOverlays(); } catch (e) {}

            // Post-win teardown: a real game/dungeon was played, so resume the
            // scaffold and exit the live engine (silent so the CTA doesn't flip
            // back to "Continue"). This is the authoritative chrome restore for
            // the dismiss flow; the later finishIntroCarouselBannerLayout() pass
            // calls it again but self-guards to a no-op once state is cleared.
            if (!canGoToTerritories) {
                teardownJutdeeGameSession({ silent: true, exitActive: true });
                restoreGlobeFraming();
                window.__spinCelebrateBannerLock = false;
                var url = '/?celebrate=1';
                if (place) url += '&place=' + encodeURIComponent(place);
                window.location.href = url;
                return;
            }

            try {
                localStorage.setItem('spinIntroAuthedCarouselSlide', '2');
            } catch (e) {}

            window.__pingReturnToTerritoriesModal = true;
            teardownJutdeeGameSession({ silent: true, exitActive: true });
            window.__pingReturnToTerritoriesModal = false;
            restoreGlobeFraming();

            // Second territory claimed this session: merge tray markup was
            // not in the initial HTML — reload so the server renders it.
            if (spinIntroNeedsMergeTrayReload()) {
                window.__spinCelebrateBannerLock = false;
                try {
                    localStorage.setItem('spinIntroAuthedCarouselSlide', '2');
                    localStorage.setItem('spinIntroReopenTerritoriesModal', '1');
                } catch (e) {}
                var mergeReloadUrl = '/?celebrate=1';
                if (place) mergeReloadUrl += '&place=' + encodeURIComponent(place);
                window.location.href = mergeReloadUrl;
                return;
            }

            runTerritoryCelebrateBanner(place);
            if (typeof window.pingLandingReturnToTerritoriesModal === 'function') {
                window.pingLandingReturnToTerritoriesModal();
            } else if (typeof window.openAuthedIntroCarouselSlide === 'function') {
                window.openAuthedIntroCarouselSlide('2');
            } else {
                showIntro();
            }

            var lastTid = window.__pingLastClaimedTerritoryId;
            if (lastTid && typeof window.pingLandingSyncTerritoryCard === 'function') {
                var enc = String(lastTid).replace(/"/g, '\\"');
                var claimedCard = document.querySelector(
                    '#gfeTownsList .ping-fp-slide2-town-item[data-id="' + enc + '"]'
                );
                if (claimedCard) window.pingLandingSyncTerritoryCard(claimedCard);
            }
        }

        function dismissJutdeeSpinResultCard() {
            if (!modal) return;
            modal.classList.remove('flying-up');
            modal.classList.remove('visible');
        }

        // Tear down a jutdee game session mounted behind the spin modal.
        // Two scenarios share this core (see the thin wrappers below):
        //   opts.silent     — suppress the preload onFail UI revert. The
        //                      post-win dismiss path doesn't want the CTA to
        //                      flip back to "Continue"; the preload-cancel
        //                      path (modal closing) leaves it non-silent.
        //   opts.exitActive — a real game / dungeon was actually being
        //                      played, so resume the scaffold and exit the
        //                      live dungeon engine. Preload-cancel leaves
        //                      this false because nothing launched yet (the
        //                      deferred preload is aborted instead).
        // Chrome restore is via the self-guarding restorePingLandingTopChrome()
        // so it's a no-op when the base abortDeferredPreload already handled it.
        function teardownJutdeeGameSession(opts) {
            opts = opts || {};
            if (window.GamifEYEDGame) {
                if (typeof window.GamifEYEDGame.isDeferredLaunchActive === 'function'
                    && window.GamifEYEDGame.isDeferredLaunchActive()) {
                    if (typeof window.GamifEYEDGame.abortDeferredPreload === 'function') {
                        try {
                            window.GamifEYEDGame.abortDeferredPreload(
                                opts.silent ? { silent: true } : undefined
                            );
                        } catch (e) {}
                    }
                } else if (opts.exitActive
                    && typeof window.GamifEYEDGame.getActiveSlug === 'function'
                    && window.GamifEYEDGame.getActiveSlug()) {
                    try { window.GamifEYEDGame.closeAndResume(); } catch (e) {}
                } else if (typeof window.GamifEYEDGame.clearJutdeeDeferred === 'function') {
                    window.GamifEYEDGame.clearJutdeeDeferred();
                }
            }
            msLaunchArmed = false;
            restorePingLandingTopChrome();
            try { toggleMapInteractivity(false); } catch (e) {}
        }

        // Preload-cancel wrapper: user closed / aborted the spin modal while
        // a game was still preloading (phase 'ready' / 'loading'). Both
        // callers (closeModal, abortSpin) reset the jutdee CTA afterward,
        // but we reset here too so the helper leaves a clean slate.
        function teardownJutdeePreloadedGame() {
            teardownJutdeeGameSession({ silent: false, exitActive: false });
            resetJutdeeSpinUi();
        }

        function jutdeePreloadFailed() {
            jutdeeSpinUiPhase = 'continue';
            if (btnJutdeeContinue) {
                btnJutdeeContinue.hidden = false;
                btnJutdeeContinue.disabled = false;
            }
            if (btnJutdeePlayRow) btnJutdeePlayRow.hidden = true;
            setJutdeeContinueDefaultLabel();
            restoreJutdeeSpinPlaceCrumb();
        }

        function preloadJutdeeGame(slug) {
            if (!slug || !currentPlace) return Promise.resolve({ ok: false });
            if (!window.GamifEYEDGame) return Promise.resolve({ ok: false });
            return window.GamifEYEDGame.launch(slug, currentPlace, {
                keepSpinModal: true,
                deferHowTo: true,
                onReady: function() { showJutdeeSpinReadyUi(); },
                onFail: jutdeePreloadFailed
            });
        }

        function beginJutdeePlay() {
            var slug = jutdeePickedGameSlug;
            dismissJutdeeSpinResultCard();
            jutdeeSpinUiPhase = 'playing';
            if (window.GamifEYEDGame && typeof window.GamifEYEDGame.beginDeferredPlay === 'function') {
                window.GamifEYEDGame.beginDeferredPlay();
            }
        }

        function showJutdeeHowTo() {
            var slug = jutdeePickedGameSlug;
            if (window.GamifEYEDGame && typeof window.GamifEYEDGame.showDeferredHowTo === 'function') {
                window.GamifEYEDGame.showDeferredHowTo();
            }
        }

        function setSpinModalPlaceHeader(place) {
            var name = place && place.name ? String(place.name).trim() : '';
            var crumb = spinModalPlaceCrumbText(place);
            var area = spinModalPlaceAreaLabel(place && place.area_km2, place);
            if (nameEl) nameEl.textContent = name;
            if (crumbEl) crumbEl.textContent = crumb;
            var heroNameEl = document.getElementById('spinModalHeroLocationName');
            var heroAreaEl = document.getElementById('spinModalHeroLocationArea');
            var heroCrumbEl = document.getElementById('spinModalHeroLocationCrumb');
            if (heroNameEl) heroNameEl.textContent = name;
            if (heroAreaEl) {
                var areaPill = heroAreaEl.closest('.spin-hero-location-area-overlay');
                heroAreaEl.textContent = area;
                if (areaPill) {
                    areaPill.classList.toggle('is-subtitle-empty', !area);
                }
            }
            if (heroCrumbEl) {
                var crumbPill = heroCrumbEl.closest('.spin-aura-overlay');
                heroCrumbEl.textContent = crumb;
                if (crumbPill) {
                    crumbPill.classList.toggle('is-subtitle-empty', !crumb);
                }
            }
        }

        function spinModalPlaceAreaLabel(km2, place) {
            if (PL && PL.isJutdeeTenant) {
                var amount = place && place.daily_aura_amount != null && place.daily_aura_amount !== ''
                    ? parseInt(place.daily_aura_amount, 10)
                    : NaN;
                if (!isFinite(amount) || amount <= 0) {
                    var n = parseFloat(km2);
                    amount = (isFinite(n) && n > 0) ? Math.max(0, Math.round(n)) : 0;
                }
                if (amount <= 0) return '';
                var fmt = (PL && PL.territoryDailyGoodLuckFmt) || ':count Daily Luck';
                return fmt.replace(':count', amount.toLocaleString());
            }
            var n = parseFloat(km2);
            if (!isFinite(n) || n <= 0) return '';
            var rounded = Math.round(n);
            var text = rounded === 0
                ? n.toLocaleString(undefined, { maximumFractionDigits: 1 })
                : rounded.toLocaleString();
            return text + ' km\u00B2';
        }

        function spinModalPlaceCrumbText(place) {
            return (place && place.breadcrumb && place.breadcrumb.length)
                ? place.breadcrumb.join(' \u00B7 ')
                : '';
        }

        function showSpinFindingLocationOverlay() {
            var el = document.getElementById('spinFindingLocationOverlay');
            if (!el) return;
            el.classList.add('is-visible');
            el.setAttribute('aria-hidden', 'false');
        }
        function clearSpinFindingLocationOverlay() {
            var el = document.getElementById('spinFindingLocationOverlay');
            if (!el) return;
            el.classList.remove('is-visible');
            el.setAttribute('aria-hidden', 'true');
        }

        function beginSpin() {
            if (STATE !== 'IDLE') return;
            if (document.body.classList.contains('is-walk-earn-active')) return;
            // If a territory-claim celebrate is still counting down, finalize
            // it now (reset banner/title, release the lock) so its stale 4s
            // timer can't fire mid-spin and clobber the new flow.
            cancelTerritoryCelebrate();
            var directFlyIn = !!(PL && PL.spinDirectFlyIn);
            STATE = 'SPINNING';
            window.__spinActive = true;
            document.body.classList.add('is-spinning');
            clearSpinFlyinLocationTitle();
            if (!directFlyIn) clearSpinFindingLocationOverlay();

            // Take over from the ambient auto-spin.
            autoSpin.active = false;
            stopCountryBackdropSpin();

            // Drop any arrival-boundary left painted by a prior fly-in
            // BEFORE the fast-spin loop starts nudging setCenter — the
            // boundary is a geojson source pinned to real world coords,
            // so without this it would rotate past the camera with the
            // globe on every subsequent spin until the next flyInToPlace
            // overwrote it. Safe to call even when nothing is painted
            // (the helper silently ignores missing layers/sources).
            try { resetTownMapOverlays(); } catch(e) {}

            // If we're coming from a zoomed / pitched state (e.g. user
            // hit Spin Again after flying into a place), snap back to
            // the idle framing instantly so the fast spin looks right.
            try {
                var cam = { zoom: map.getZoom(), pitch: map.getPitch() };
                if (cam.zoom > 3 || cam.pitch > 1) {
                    if (countryBackdrop.active && countryBackdrop.center) {
                        map.jumpTo({
                            center: countryBackdrop.center,
                            zoom: countryBackdrop.zoom,
                            pitch: countryBackdrop.pitch,
                        });
                    } else {
                        map.jumpTo({ zoom: 1.8, pitch: 0 });
                    }
                }
            } catch(e) {}

            spinStartT = performance.now();
            var startLng = map.getCenter().lng;
            var startBearing = map.getBearing();
            if (!directFlyIn) {
                (function tick(ts) {
                    if (STATE !== 'SPINNING') { fastSpinRaf = null; return; }
                    var elapsed = (ts || performance.now()) - spinStartT;
                    // ~540°/sec rotation — longitude drift on the globe, bearing
                    // drift when the tenant backdrop is scoped to selected countries.
                    var deg = (elapsed / 1000) * 540;
                    try {
                        if (countryBackdrop.active && countryBackdrop.center) {
                            map.setCenter(countryBackdrop.center);
                            map.setBearing(startBearing + deg);
                        } else {
                            map.setCenter([(startLng + deg) % 360, 15]);
                        }
                    } catch(e){}
                    fastSpinRaf = requestAnimationFrame(tick);
                })(performance.now());
            }

            var excludeParam = recentExclude.slice(-RECENT_MAX).join(',');
            if (spinFetchAbort) {
                try { spinFetchAbort.abort(); } catch (e) {}
            }
            spinFetchAbort = new AbortController();
            var spinFetchTimer = setTimeout(function () {
                try { spinFetchAbort.abort(); } catch (e) {}
            }, 20000);
            fetch('/api/spin-globe/random' + (excludeParam ? ('?exclude=' + encodeURIComponent(excludeParam)) : ''), {
                headers: { 'Accept': 'application/json' },
                credentials: 'same-origin',
                signal: spinFetchAbort.signal
            })
            .then(function(r) {
                if (r.status === 204) return null;
                // 402 = authed user with no Aura left to spend. Server
                // aborted the spin before selecting a place, so there's
                // nothing to fly to — surface a toast and bail out of
                // the spin cleanly (abortSpin re-opens the intro modal).
                if (r.status === 402) {
                    return r.json().then(function(d) {
                        var err = new Error('no-aura');
                        err.code = 'no-aura';
                        err.data = d || {};
                        throw err;
                    });
                }
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
            })
            .then(function(place) {
                if (!place) throw new Error('empty-pool');
                if (typeof place.lat !== 'number' || typeof place.lng !== 'number'
                    || !isFinite(place.lat) || !isFinite(place.lng)) {
                    throw new Error('invalid-place');
                }
                // Authed-only state refresh. The server tells us two
                // things in this response:
                //
                //   place.used_free_spin  — was this spin billed as a
                //                           free daily spin (true) or
                //                           an Aura debit (false)?
                //   place.free_spins_left — remaining free spins in
                //                           the current 06:00-UTC
                //                           window after this spin
                //                           was accounted for.
                //
                // When the server debits Aura we update every
                // [data-spin-aura-count] pill and fire the debit
                // floater so the cost reads visually even though the
                // intro modal (and its aura pill) have already flown
                // off-screen by then. Free spins skip the floater —
                // the button sub-label is the only affordance that
                // changes when a free spin is consumed.
                if (typeof place.aura_balance === 'number') {
                    updateAuraPills(place.aura_balance);
                }
                if (typeof place.free_spins_left === 'number') {
                    applyFreeSpinsExpiryFromPayload(place);
                    setFreeSpinsLeft(place.free_spins_left);
                }
                // Mid-spin feedback: one of two mutually exclusive
                // floaters, keyed off how the server billed this
                // spin. used_free_spin is the authoritative signal —
                // we don't try to infer it from aura_balance diffs
                // because an aura_balance echo can also land after a
                // free spin (we still send the current balance so
                // the pill can settle after any unrelated server-
                // side credits). false → aura-debit, true → free.
                if (place.used_free_spin === true) {
                    if (!PL.isJutdeeTenant) {
                        fireFreeSpinFloater();
                    }
                } else if (place.used_free_spin === false) {
                    fireAuraDebitFloater(place.spin_aura_cost);
                }
                var elapsed = performance.now() - spinStartT;
                var wait = directFlyIn ? 0 : Math.max(0, SPIN_MIN_MS - elapsed);
                if (spinFlyInTimer) clearTimeout(spinFlyInTimer);
                spinFlyInTimer = setTimeout(function () {
                    spinFlyInTimer = null;
                    flyInToPlace(place);
                }, wait);
            })
            .catch(function(err) {
                if (err && err.code === 'no-aura') {
                    showToast(PL.noAura || "You're out of Aura — earn more to spin again.", 4500);
                } else if (err && err.message === 'empty-pool') {
                    showToast(PL.spinEmptyPool || 'No locations available right now — try again.', 4500);
                } else if (err && (err.name === 'AbortError' || err.message === 'invalid-place')) {
                    showToast(PL.netErr || 'Network error — try again.', 4500);
                } else {
                    console.warn('[spin-globe] fetch failed', err);
                    showToast(PL.netErr || 'Network error — try again.', 4500);
                }
                abortSpin();
            })
            .finally(function() {
                clearTimeout(spinFetchTimer);
                spinFetchAbort = null;
            });
        }

        // Latest known authoritative Aura balance (hero pills, debit
        // floaters). Seeded from the first [data-spin-aura-count] on
        // the page when the viewer is authed; kept in sync via
        // updateAuraPills() after each spin response.
        var currentAuraBalance = 0;
        var currentLensBalance = 0;

        function formatSpinAuraCostLabel(costM2) {
            var n = Math.max(0, (parseInt(costM2, 10) || 0));
            if (!n && PL.spinAuraCostM2) {
                n = Math.max(0, (parseInt(PL.spinAuraCostM2, 10) || 0));
            }
            return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }

        // Update every visible Lens-balance pill on the page to the
        // server-authoritative value. Called after each spin (and any
        // other flow that returns a fresh balance) so the intro +
        // result modal hero overlays stay in lockstep with the DB.
        function updateLensPills(balance) {
            var n = Math.max(0, (parseInt(balance, 10) || 0));
            currentLensBalance = n;
            var formatted = (n >= 1000)
                ? n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : String(n);
            document.querySelectorAll('[data-spin-lens-count]').forEach(function(el) {
                el.textContent = formatted;
            });
        }

        // Sibling of updateLensPills — same shape, different attribute.
        // Updates every [data-spin-aura-count] pill on the page (the
        // hero AURA overlay is the only one today, but the data-attr
        // contract lets future surfaces opt in by tagging their own
        // counter element). Called after a game-loss POST returns
        // with the fresh total_aura — without this the pill stays
        // stale until the next page render even though the credit
        // landed server-side.
        //
        // Mirrors spin-lens-overlay.blade.php's number_format() exactly
        // (always comma-separates, no unit suffix — the adjacent
        // "AURA" label provides context) so the pill doesn't flicker
        // between server-rendered and client-updated formats.
        //
        // When the balance *increases*, count up with .is-counting (green).
        // When it *decreases*, count down with .is-counting-down (red).
        // Colour mapping lives in ping-landing.css under
        // @keyframes spinAuraPillCountPulse / spinAuraPillCountDownPulse.
        // Rapid repeat calls bump a per-element cancel token so the
        // latest server total always wins. Instant set when flat or
        // under prefers-reduced-motion.
        function formatSpinAuraCount(n) {
            var v = Math.max(0, (parseInt(n, 10) || 0));
            return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }

        // Floating auth pill expand (scale 2×). The class is set BOTH on
        // the wrapper .spin-intro-auth--floating AND on the leaf
        // .nav-lang-btn. iOS Safari sometimes fails to re-evaluate
        // parent-class → descendant-selector style invalidation when the
        // styled element has backdrop-filter and a fixed-positioned
        // ancestor (the same class of issue the hex-wheel JS works
        // around at ~L1254). The leaf-class rule sidesteps that by
        // matching the styled element directly. The wrapper-class rule
        // is kept as a sibling for any future use.
        function getFloatingAuraPillNodes(countEl) {
            var wrap = (countEl && countEl.closest)
                ? countEl.closest('.spin-intro-auth--floating')
                : null;
            if (!wrap) return null;
            var btn = wrap.querySelector('.nav-lang-btn.spin-auth-btn')
                || wrap.querySelector('.nav-lang-btn');
            return { wrap: wrap, btn: btn };
        }
        function clearAuraPillExpanded(countEl) {
            var nodes = getFloatingAuraPillNodes(countEl);
            if (!nodes) return;
            nodes.wrap.classList.remove('is-aura-pill-expanded', 'is-aura-pill-expanded-down');
            if (nodes.btn) {
                nodes.btn.classList.remove('is-aura-pill-expanded', 'is-aura-pill-expanded-down');
            }
        }
        function setAuraPillExpanded(countEl, isDebit, active) {
            var nodes = getFloatingAuraPillNodes(countEl);
            if (!nodes) return;
            if (!active) {
                clearAuraPillExpanded(countEl);
                return;
            }
            var on  = isDebit ? 'is-aura-pill-expanded-down' : 'is-aura-pill-expanded';
            var off = isDebit ? 'is-aura-pill-expanded'      : 'is-aura-pill-expanded-down';
            nodes.wrap.classList.remove(off);
            nodes.wrap.classList.add(on);
            if (nodes.btn) {
                nodes.btn.classList.remove(off);
                nodes.btn.classList.add(on);
            }
        }

        function updateAuraPills(balance) {
            var to = Math.max(0, (parseInt(balance, 10) || 0));
            currentAuraBalance = to;
            // Note: prefers-reduced-motion is intentionally NOT honored here.
            // The count-up + 2× scale on the floating pill is feedback for a
            // currency change (the only signal a spin actually credited /
            // debited the user) — suppressing it leaves the user looking at
            // a number that just teleports, which on iPhone with iOS's
            // default-on Reduce Motion read as "the animation is broken".
            // Reduce Motion is meant for parallax / launch zooms / hero
            // page transitions, not 1.6s tabular tween + 0.35s scale on a
            // small pill. Keep all OTHER animations on this page honoring
            // the preference; this is a deliberate per-feature exception.
            var DURATION = 1600;

            document.querySelectorAll('[data-spin-aura-count]').forEach(function(el) {
                if (typeof el.__auraPillTweenGen !== 'number') el.__auraPillTweenGen = 0;
                el.__auraPillTweenGen++;
                var ticket = el.__auraPillTweenGen;

                var raw = (el.textContent || '0').replace(/[^\d]/g, '');
                var from = parseInt(raw, 10);
                if (!isFinite(from)) {
                    el.classList.remove('is-counting', 'is-counting-down');
                    clearAuraPillExpanded(el);
                    el.textContent = formatSpinAuraCount(to);
                    return;
                }
                if (to === from) {
                    el.classList.remove('is-counting', 'is-counting-down');
                    clearAuraPillExpanded(el);
                    el.textContent = formatSpinAuraCount(to);
                    return;
                }

                var isDebit = to < from;
                el.classList.toggle('is-counting', !isDebit);
                el.classList.toggle('is-counting-down', isDebit);
                setAuraPillExpanded(el, isDebit, true);
                var t0 = (typeof performance !== 'undefined' && performance.now)
                    ? performance.now()
                    : Date.now();
                function step(now) {
                    if (el.__auraPillTweenGen !== ticket) return;
                    var ts = (typeof now === 'number' && isFinite(now))
                        ? now
                        : ((typeof performance !== 'undefined' && performance.now)
                            ? performance.now()
                            : Date.now());
                    var elapsed = ts - t0;
                    if (elapsed < 0) elapsed = 0;
                    var p = elapsed >= DURATION ? 1 : elapsed / DURATION;
                    var eased = 1 - Math.pow(1 - p, 3);
                    var v = Math.round(from + (to - from) * eased);
                    el.textContent = formatSpinAuraCount(v);
                    if (p < 1) {
                        requestAnimationFrame(step);
                    } else {
                        if (el.__auraPillTweenGen !== ticket) return;
                        el.textContent = formatSpinAuraCount(to);
                        el.classList.remove('is-counting', 'is-counting-down');
                        clearAuraPillExpanded(el);
                    }
                }
                requestAnimationFrame(step);
            });
            if (typeof window.syncFocalPointsBusinessSetupProgress === 'function') {
                window.syncFocalPointsBusinessSetupProgress(to);
            }
            if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                window.syncJutdeeSubdomainSaveGate();
            }
        }

        /**
         * Count-up the floating auth-pill Aura total. When `awardedHint`
         * is set and the target is higher than our tracked balance,
         * rewind the pill text to the pre-credit value first so
         * updateAuraPills() always runs a visible tween (territory
         * daily-aura collect, etc.).
         */
        function animateAuraPillsTo(newBalance, awardedHint) {
            var to = Math.max(0, (parseInt(newBalance, 10) || 0));
            var from = Math.max(0, currentAuraBalance || 0);
            if (from <= 0) {
                var seedEl = document.querySelector('[data-spin-aura-count]');
                if (seedEl) {
                    from = parseInt((seedEl.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
                    if (!isFinite(from)) from = 0;
                }
            }
            var awarded = Math.max(0, (parseInt(awardedHint, 10) || 0));
            if (awarded > 0 && to > from) {
                document.querySelectorAll('[data-spin-aura-count]').forEach(function (el) {
                    el.classList.remove('is-counting', 'is-counting-down');
                    clearAuraPillExpanded(el);
                    el.textContent = formatSpinAuraCount(from);
                });
            }
            updateAuraPills(to);
        }

        window.updateAuraPills = updateAuraPills;
        // Authoritative Good Luck balance, kept in sync by updateAuraPills.
        // Callers must read this instead of the pill's textContent, which
        // lags during the count-up tween.
        window.getCurrentAuraBalance = function () { return currentAuraBalance; };
        window.pingLandingAnimateAuraTo = animateAuraPillsTo;
        window.pingLandingShowToast = showToast;

        // ── Route Recorder bridge ──
        // Exposed so the separate route-recorder.js module can drive
        // the main #pingMap without being inside this IIFE's closure.
        window.pingLandingStopGlobeSpin = function () {
            autoSpin.active = false;
            stopCountryBackdropSpin();
            if (typeof fastSpinRaf !== 'undefined' && fastSpinRaf) {
                cancelAnimationFrame(fastSpinRaf);
                fastSpinRaf = null;
            }
        };
        window.pingLandingRestoreGlobeFraming = function (easeMs) {
            restoreIdleMapFraming(easeMs);
        };
        window.pingLandingGetMap = function () { return map; };
        window.showPingIntro = function () { showIntro(); };

        // Shared helper behind both mid-spin floaters. Builds a
        // centre-of-viewport pill that floats up and fades out,
        // then self-destructs so repeated spins don't accumulate
        // dead nodes. The two callers differ only in the class
        // they pass and the inner markup they provide; the
        // animation + cleanup are identical.
        //
        // Kept as a single helper (rather than copy-pasting two
        // sibling functions) because any future tweak — reduced-
        // motion short-circuit, stacking rules when a second spin
        // fires before the first has cleared, etc. — should apply
        // to both variants in lockstep.
        function fireSpinFloater(className, buildInner) {
            var el = document.createElement('div');
            el.className = className;
            el.setAttribute('aria-hidden', 'true');
            buildInner(el);
            document.body.appendChild(el);
            // Self-cleanup keyed off animationend (with a safety timeout
            // in case the listener never fires — reduced-motion user
            // agents, tab-backgrounded pages, etc.). The CSS animation
            // is ~1.8s so 2.5s is a comfortable margin.
            var removed = false;
            function kill() {
                if (removed) return;
                removed = true;
                if (el.parentNode) el.parentNode.removeChild(el);
            }
            el.addEventListener('animationend', kill);
            setTimeout(kill, 2500);
        }

        // Fire a "-{cost} [aura-icon]" element that floats up the middle
        // of the viewport and fades out. Used on Aura-debit spins so the
        // cost registers visually even though the intro modal (and its
        // aura pill) have already flown off-screen by the time the server
        // response lands.
        function fireAuraDebitFloater(costM2) {
            var costLabel = '-' + formatSpinAuraCostLabel(costM2);
            fireSpinFloater('spin-aura-debit-float', function(el) {
                var label = document.createElement('span');
                label.className = 'spin-aura-debit-float-label';
                label.textContent = costLabel;
                var icon = document.createElement('i');
                icon.className = 'bi bi-bounding-box';
                el.appendChild(label);
                el.appendChild(icon);
            });
        }

        // Fire a "✨ Free Spin!" element that floats up the middle of
        // the viewport and fades out. Used on free-daily-spin spins
        // so the user gets the same mid-spin feedback beat as an
        // aura-debit spin but can tell at a glance that no Aura was
        // spent. Copy is server-sourced (PL.freeSpinFloat) so the
        // label translates cleanly for non-English locales.
        function fireFreeSpinFloater() {
            fireSpinFloater('spin-free-spin-float', function(el) {
                var icon = document.createElement('i');
                icon.className = 'bi bi-stars';
                var label = document.createElement('span');
                label.className = 'spin-free-spin-float-label';
                label.textContent = PL.freeSpinFloat || 'Free Spin!';
                // Icon-before-label reads "✨ Free Spin!", matching
                // the celebratory "sparkle → message" grammar used
                // elsewhere on the page (e.g. sparkle-before-label on
                // #spinModalEnterAura).
                el.appendChild(icon);
                el.appendChild(label);
            });
        }

        function fireGameCreditsFloater(labelText) {
            if (!labelText) return;
            fireSpinFloater('spin-game-credits-float', function(el) {
                var label = document.createElement('span');
                label.className = 'spin-game-credits-float-label';
                label.textContent = labelText;
                el.appendChild(label);
            });
        }
        window.pingLandingFireGameCreditsFloater = fireGameCreditsFloater;

        function flyInToPlace(place) {
            if (STATE !== 'SPINNING') {
                if (fastSpinRaf) { cancelAnimationFrame(fastSpinRaf); fastSpinRaf = null; }
                return;
            }
            STATE = 'ARRIVING';
            currentPlace = place;

            if (fastSpinRaf) { cancelAnimationFrame(fastSpinRaf); fastSpinRaf = null; }

            // Paint the town's boundary polygon BEFORE the camera starts
            // easing in, so the magenta outline grows underneath the
            // camera as it arrives rather than only showing up once the
            // user clicks Minesweeper / Dungeon.
            //
            // We reuse the shared helpers (townBoundaryFeature, drawTownBoundary,
            // resetTownMapOverlays) that the GamifEYED Town detail flow uses,
            // so the paint treatment stays identical across both surfaces
            // and the #town-boundary source is owned by one writer.
            //
            // /api/spin-globe/random serialises the boundary as the same
            // [[lng,lat], ...] ring ContainedPlace::boundary() returns —
            // see spinGlobeRandom() in app/Http/Controllers/Auth/UserController.php.
            // Places without a stored polygon report boundary:null and
            // fall through to the centroid-only fly-in below.
            try { resetTownMapOverlays(); } catch(e) {}
            var boundaryFeature = null;
            try { boundaryFeature = townBoundaryFeature(place && place.boundary || null); }
            catch(e) { boundaryFeature = null; }
            if (boundaryFeature) {
                try { drawTownBoundary(boundaryFeature); }
                catch(e) { console.warn('[spin-globe] boundary draw failed', e); }
            }

            if (arriveTimer) clearTimeout(arriveTimer);
            if (!isJutdeeSpinModal()) clearSpinFindingLocationOverlay();
            clearSpinFlyinLocationTitle();
            clearPingHeroLocationImage();
            // Spin result card (#spinModal) carries name + hero image —
            // skip the map-surround location hero / fly-in title.
            revealFlyinTitleAfterMove('', {
                flyMs: FLY_IN_MS,
                fallbackMs: FLY_IN_MS + 400,
                afterReveal: function () {
                    if (arriveTimer) clearTimeout(arriveTimer);
                    arriveTimer = setTimeout(openModal, 500);
                }
            });

            try {
                var flyBearing = (PL && PL.spinDirectFlyIn) ? 0 : (map.getBearing() + 360);
                map.flyTo({
                    center: [place.lng, place.lat],
                    zoom: place.zoom || 12,
                    pitch: 45,
                    bearing: flyBearing,
                    duration: FLY_IN_MS,
                    essential: true,
                    curve: 1.6
                });
                if (isJutdeeDirectFlyIn()) {
                    map.once('moveend', function onJutdeeFlyInDone() {
                        if (STATE !== 'ARRIVING') return;
                        var fadeMs = 900;
                        fadeJutdeeSpinSatelliteIn(fadeMs);
                        removeJutdeeCountryBackdrop(fadeMs);
                    });
                }
            } catch(e) {
                console.warn('[spin-globe] flyTo failed', e);
            }
        }

        function preloadImage(url) {
            return new Promise(function(resolve) {
                if (!url) return resolve(false);
                var img = new Image();
                img.onload = function() { resolve(true); };
                img.onerror = function() { resolve(false); };
                img.src = url;
            });
        }

        function resolveHeroUrl(place) {
            // Try the upgraded 1280px variant first; on failure fall back
            // to the original stored thumbnail (which we know works since
            // it was fetched during enrichment).
            return preloadImage(place.image).then(function(ok) {
                if (ok) return place.image;
                if (place.image_fallback) {
                    return preloadImage(place.image_fallback).then(function(ok2) {
                        return ok2 ? place.image_fallback : '';
                    });
                }
                return '';
            });
        }

        function openModal() {
            if (STATE !== 'ARRIVING') return;
            var p = currentPlace;
            if (!p) { abortSpin(); return; }

            clearPingHeroLocationImage();
            if (bgImage && !isJutdeeSpinModal()) bgImage.classList.add('is-faded');

            // Drop any prior "won" state before repopulating so a
            // returning user doesn't see last round's claim stamp.
            if (spinCardEl) spinCardEl.classList.remove('won');

            // Warm the dungeon bundle cache now — users typically spend
            // 2–8 s reading the card before clicking a game, so the
            // ~110 KB gzipped bundle is usually fully cached by the

            // Same idea for the wheel games actually in play (minesweeper,
            // flood-fill, +area-trivia when enabled) plus the h3-js lib:
            // warm their JS/CSS via rel=prefetch now, while the user reads
            // the result card, so the first launch of the session doesn't
            // pay a cold download in the click path. The base module reads
            // hrefs from its own MANIFEST so they byte-match the loader's
            // requests. Low-priority hint — can't block anything.
            if (window.GamifEYEDGame && typeof window.GamifEYEDGame.prefetchBundles === 'function') {
                window.GamifEYEDGame.prefetchBundles();
            }

            // Body breadcrumb (#spinModalBreadcrumb) and title
            // (#spinModalName) were removed from the result modal — the
            // same two values now render in the hero pills only (see
            // partials/spin-lens-overlay.blade.php). The legacy nameEl /
            // crumbEl writes are kept and null-guarded so any host page
            // that still renders those nodes (e.g. an admin preview
            // mock) continues to receive updates, and so existing
            // readers further down this file (showWinCongrats sanity
            // check, MS-win placeholder, debug helpers) keep getting a
            // value to compare against on hosts that DO keep the
            // elements. On gamifeye.com (the production surface) both
            // lookups now return null and these become no-ops.
            if (nameEl)  nameEl.textContent  = p.name || '';
            if (crumbEl) crumbEl.textContent = spinModalPlaceCrumbText(p);
            setSpinModalPlaceHeader(p);
            extractEl.textContent = p.extract || '';
            extractEl.style.display = p.extract ? '' : 'none';

            if (wikiEl && p.wiki_url) {
                wikiEl.href = p.wiki_url;
                wikiEl.style.display = '';
            } else if (wikiEl) {
                wikiEl.style.display = 'none';
            }

            resolveHeroUrl(p).then(function(heroUrl) {
                if (isJutdeeSpinModal()) {
                    heroEl.style.backgroundImage = '';
                } else {
                    heroEl.style.backgroundImage = heroUrl
                        ? ('url("' + heroUrl.replace(/"/g, '%22') + '")')
                        : '';
                }
                STATE = 'SHOW_MODAL';
                // Guest demo-cap lock-out.
                //
                // Used to hide the per-game buttons (Minesweeper /
                // Dungeon / Flood Fill) for guests who had exhausted
                // their free-demo session counter — clicking any of
                // them would have just bounced the modal off and flown
                // straight back. Those buttons are gone now (the hex
                // wheel governs game choice), so the gate moves onto
                // the SPIN button via the .is-locked-no-demos modifier
                // on .spin-hex-wheel: CSS dims and disables the
                // trigger, and a "Sign up to play more" message
                // appears underneath. The spin click handler above
                // also bails on this class as belt-and-braces.
                //
                // Authed users skip the gate entirely: they paid in
                // Aura (or burned a daily free spin) at /api/spin-globe/random
                // and the per-game spinGlobe*Start endpoints no longer
                // enforce the cap on them either, so the wheel must
                // remain spinnable regardless of msDemosLeft (which
                // can be a stale guest-session value carried into the
                // logged-in browser).
                var noDemos = (!isAuthed && msDemosLeft != null && msDemosLeft <= 0);
                var hexWheelEl = document.getElementById('spinModalHexWheel');
                if (hexWheelEl) hexWheelEl.classList.toggle('is-locked-no-demos', noDemos);
                if (spinCardEl) spinCardEl.classList.remove('spin-jutdee-result-rest');
                modal.classList.add('visible');
                if (isJutdeeSpinModal() && spinCardEl) {
                    setTimeout(function () {
                        if (!modal.classList.contains('visible')) return;
                        if (modal.classList.contains('is-flying-out')) return;
                        spinCardEl.classList.add('spin-jutdee-result-rest');
                    }, 700);
                }
                clearSpinFlyinLocationTitle();
                if (isJutdeeSpinModal()) {
                    startJutdeeScrimTracking();
                    resetJutdeeSpinUi();
                    jutdeePickedGameSlug = noDemos ? null : pickRandomHexGameSlug();
                    if (btnJutdeeContinue) {
                        btnJutdeeContinue.disabled = noDemos;
                    }
                } else if (hexWheelEl && hexWheelEl.__startSpin && !noDemos) {
                    if (hexWheelEl.__autoSpinTimer) clearTimeout(hexWheelEl.__autoSpinTimer);
                    hexWheelEl.__autoSpinTimer = setTimeout(function() {
                        hexWheelEl.__autoSpinTimer = null;
                        if (!modal.classList.contains('visible')) return;
                        if (STATE !== 'SHOW_MODAL') return;
                        hexWheelEl.__startSpin();
                    }, 500);
                }
            });

            if (p.id) {
                recentExclude.push(p.id);
                if (recentExclude.length > RECENT_MAX * 3) {
                    recentExclude = recentExclude.slice(-RECENT_MAX);
                }
            }
        }

        // Animate the camera back to the idle map framing (globe or country
        // backdrop) and then hand control back to the ambient spin loop.
        function restoreGlobeFraming(easeMs) {
            restoreIdleMapFraming(easeMs);
        }

        function closeModal() {
            if (STATE === 'SPINNING' || STATE === 'ARRIVING') {
                abortSpin();
                return;
            }
            if (isJutdeeSpinModal() && (jutdeeSpinUiPhase === 'ready' || jutdeeSpinUiPhase === 'loading')) {
                teardownJutdeePreloadedGame();
            }
            if (window.pingSlotBankPending
                && (!spinCardEl || !spinCardEl.classList.contains('won'))) {
                endPingSlotBankSpend();
            }
            clearSpinFlyinLocationTitle();
            hideJutdeeSpinScrim();
            if (spinCardEl) spinCardEl.classList.remove('spin-jutdee-result-rest');
            modal.classList.remove('visible');
            // Reset the hex wheel before anything else — if the user
            // closed mid-spin, the rotor's 4 s transition gets aborted
            // by the modal hide and `transitionend` may not fire,
            // which would leave `spinning = true` and lock the wheel
            // the next time the modal reopens. Calling __resetSpin
            // here clears the spinning flag AND any pending savour
            // timer the auto-launch handler parked.
            var hexWheel = document.getElementById('spinModalHexWheel');
            if (hexWheel && hexWheel.__resetSpin) hexWheel.__resetSpin();
            jutdeePickedGameSlug = null;
            resetJutdeeSpinUi();
            if (spinCardEl) spinCardEl.classList.remove('won');
            currentPlace = null;
            window.__spinActive = false;
            document.body.classList.remove('is-spinning');
            STATE = 'IDLE';
            // Drop the arrival-painted boundary before the globe zooms
            // back out, otherwise the magenta outline shrinks down to a
            // pixel with the town and then hangs around as the globe
            // resumes its idle spin.
            try { resetTownMapOverlays(); } catch(e) {}
            teardownJutdeeSpinMapView();
            // Bring the globe back so the user sees it spinning again
            // instead of being stuck on a pitched mercator close-up.
            restoreGlobeFraming();
            // The intro modal owns the resting state for authed users;
            // Jutdee guests land back on the cream win/walk modal.
            if (!restoreGuestLandingChromeAfterPlay() && !restoreAuthedJutdeePlaySurface()) {
                showIntro();
            }
        }

        function abortSpin() {
            if (spinFlyInTimer) {
                clearTimeout(spinFlyInTimer);
                spinFlyInTimer = null;
            }
            if (spinFetchAbort) {
                try { spinFetchAbort.abort(); } catch (e) {}
                spinFetchAbort = null;
            }
            if (window.pingSlotBankPending) {
                endPingSlotBankSpend();
            }
            clearSpinFlyinLocationTitle();
            if (isJutdeeSpinModal() && (jutdeeSpinUiPhase === 'ready' || jutdeeSpinUiPhase === 'loading')) {
                teardownJutdeePreloadedGame();
            }
            if (fastSpinRaf) { cancelAnimationFrame(fastSpinRaf); fastSpinRaf = null; }
            if (arriveTimer) { clearTimeout(arriveTimer); arriveTimer = null; }
            var hexWheelAbort = document.getElementById('spinModalHexWheel');
            if (hexWheelAbort && hexWheelAbort.__resetSpin) hexWheelAbort.__resetSpin();
            jutdeePickedGameSlug = null;
            resetJutdeeSpinUi();
            hideJutdeeSpinScrim();
            if (spinCardEl) spinCardEl.classList.remove('spin-jutdee-result-rest');
            modal.classList.remove('visible');
            window.__spinActive = false;
            document.body.classList.remove('is-spinning');
            STATE = 'IDLE';
            // Same rationale as closeModal — we may have painted a
            // boundary in flyInToPlace() before the abort fired, so
            // tear it down so the next spin starts on a clean map.
            try { resetTownMapOverlays(); } catch(e) {}
            teardownJutdeeSpinMapView();
            restoreGlobeFraming();
            if (!restoreGuestLandingChromeAfterPlay() && !restoreAuthedJutdeePlaySurface()) {
                showIntro();
            }
        }

        // ── Spin hex wheel ─────────────────────────────────────────
        // The 6-segment spinning hexagon between the wiki link and
        // .spin-actions. Tapping the SPIN button decelerates the rotor
        // over 4 s, then dispatches gamifeye:hex-resolved with the
        // landed segment index (0–5). The auto-launch handler below
        // routes that into the same per-game launch path (Minesweeper /
        // Flood Fill via GamifEYEDGame.launch) the now-removed games-row
        // buttons used to fire — same contract, different surface.
        (function initSpinHexWheel(){
            var wheel = document.getElementById('spinModalHexWheel');
            if (!wheel) return;
            var rotor   = wheel.querySelector('.spin-hex-wheel-rotor');
            var trigger = wheel.querySelector('.spin-hex-wheel-trigger');
            if (!rotor || !trigger) return;
            var rotation = 0;
            var spinning = false;

            function resetSpinState(){
                spinning = false;
                wheel.classList.remove('is-spinning');
                // Cancel any pending savour-pause timer the auto-launch
                // handler parked on `wheel`. Without this, a mid-savour
                // × close would let the timer fire after currentPlace
                // was nulled — launchGameFromHex would bail safely on
                // its null-check, but a stray timer ticking is sloppy.
                if (wheel.__savourTimer) {
                    clearTimeout(wheel.__savourTimer);
                    wheel.__savourTimer = null;
                }
                if (wheel.__autoSpinTimer) {
                    clearTimeout(wheel.__autoSpinTimer);
                    wheel.__autoSpinTimer = null;
                }
            }
            // Public reset hook so closeModal() can call this when the
            // modal closes mid-spin. The rotor's transition gets
            // aborted by the hide and transitionend may not fire —
            // without this hook, the wheel would stay locked the next
            // time the modal reopened.
            wheel.__resetSpin = resetSpinState;

            function startHexWheelSpin() {
                if (spinning) return;
                // Defence-in-depth on the noDemos guest gate: even if
                // the disabled trigger is force-clicked via devtools,
                // we refuse to spin. The server-side demo cap also
                // enforces this, so this is purely the visual guard.
                if (wheel.classList.contains('is-locked-no-demos')) return;
                if (wheel.__autoSpinTimer) {
                    clearTimeout(wheel.__autoSpinTimer);
                    wheel.__autoSpinTimer = null;
                }
                spinning = true;
                wheel.classList.add('is-spinning');
                // Clear both the landed highlight and dimmed sibling
                // state so the next spin starts from neutral. Both
                // classes are added together at resolve time, so both
                // must clear together at start time.
                wheel.querySelectorAll('.is-landed, .is-dimmed').forEach(function(el){
                    el.classList.remove('is-landed', 'is-dimmed');
                });
                // 3 full turns + a random landing offset within a
                // segment (0–359°) — enough to feel like a real spin
                // without dragging.
                var fullTurns = 1080;
                var extra    = Math.floor(Math.random() * 360);
                rotation += fullTurns + extra;
                rotor.style.transform = 'rotate(' + rotation + 'deg)';
            }
            wheel.__startSpin = startHexWheelSpin;

            trigger.addEventListener('click', startHexWheelSpin);

            rotor.addEventListener('transitionend', function(e){
                if (e.propertyName !== 'transform') return;
                // Defensive guard against rare double-fires of
                // transitionend (some browsers emit it for both the
                // SVG attribute baseline and the CSS property).
                if (!spinning) return;
                resetSpinState();
                // Resolution math:
                //   - At rotation 0, segment 0 (top) sits centred under
                //     the pointer at compass 0°.
                //   - After CW rotation θ, segment N's centre is at
                //     compass (N*60° + θ) mod 360°.
                //   - The segment under the pointer is N such that the
                //     pointer's angle (0°) falls inside segment N's
                //     span [N*60°-30°, N*60°+30°] in the rotor frame.
                //   - The +30° centres each segment; the trailing %6
                //     handles wrap on exact boundaries.
                var landed = Math.floor(((360 - (rotation % 360) + 30) % 360) / 60) % 6;
                wheel.dispatchEvent(new CustomEvent('gamifeye:hex-resolved', {
                    detail: { segmentIndex: landed },
                    bubbles: true
                }));
            });
        })();

        // ── Spin hex wheel: auto-launch ────────────────────────────
        // Routes the landed segment into the existing per-game launch
        // path. Lives inside the same outer IIFE (so currentPlace is
        // reachable) and adds the .is-landed /
        // .is-dimmed classes the CSS uses to highlight the winner.
        function launchGameFromHex(slug, options) {
            if (!currentPlace) return;
            options = options || {};
            if (window.GamifEYEDGame) {
                // Minesweeper / Flood Fill / Area Trivia all go
                // through the shared scaffold, which lazy-loads the
                // per-game module on first call and dispatches to its
                // onFit callback (which then shows the how-to card).
                window.GamifEYEDGame.launch(slug, currentPlace, options);
            }
        }

        function pickRandomHexGameSlug() {
            var jutdeeGames = PL && PL.jutdeePickableGames;
            if (Array.isArray(jutdeeGames) && jutdeeGames.length) {
                return jutdeeGames[Math.floor(Math.random() * jutdeeGames.length)];
            }
            var wheel = document.getElementById('spinModalHexWheel');
            if (!wheel) return null;
            var eligible = [];
            wheel.querySelectorAll('.spin-hex-wheel-segment[data-game]').forEach(function(seg) {
                var slug = seg.getAttribute('data-game');
                if (!slug) return;
                eligible.push(slug);
            });
            if (!eligible.length) return null;
            return eligible[Math.floor(Math.random() * eligible.length)];
        }

        (function bindHexAutoLaunch(){
            var wheel = document.getElementById('spinModalHexWheel');
            if (!wheel) return;
            wheel.addEventListener('gamifeye:hex-resolved', function(e){
                var i = e.detail && typeof e.detail.segmentIndex === 'number'
                    ? e.detail.segmentIndex
                    : -1;
                if (i < 0) return;

                // Highlight the landed segment AND dim the other five
                // in the SAME frame, so the brighten + dim transitions
                // start together with no flicker. We drive both class
                // additions from JS rather than via CSS :has() because
                // (a) :has() had bugs in iOS Safari < 16, and (b) the
                // loop is six elements — belt-and-braces is cheap.
                var segs = wheel.querySelectorAll('.spin-hex-wheel-segment');
                segs.forEach(function(s){
                    if (s.getAttribute('data-seg') === String(i)) {
                        s.classList.add('is-landed');
                    } else {
                        s.classList.add('is-dimmed');
                    }
                });

                // Route by data-game (declarative) — rebalancing the
                // segment-to-game mapping later only requires editing
                // the blade DOM, not this JS.
                var group = wheel.querySelector('.spin-hex-wheel-segment[data-seg="' + i + '"]');
                var slug  = group && group.getAttribute('data-game');
                if (slug) {
                    // 800 ms savouring pause: the brighten + dim
                    // transitions are 350 ms each, so 800 ms gives
                    // ~450 ms of fully-resolved "you won X" state
                    // before the modal flies up and the game loads.
                    // Long enough to register, short enough not to
                    // drag.
                    //
                    // Park the timer on `wheel` so __resetSpin can
                    // cancel it if the user × closes the modal during
                    // the savour. Without this cleanup the timer would
                    // still fire after closeModal nulled currentPlace —
                    // launchGameFromHex's null-check would bail safely,
                    // but a stray timer ticking is sloppy. Two lines.
                    if (wheel.__savourTimer) clearTimeout(wheel.__savourTimer);
                    wheel.__savourTimer = setTimeout(function(){
                        wheel.__savourTimer = null;
                        launchGameFromHex(slug);
                    }, 800);
                } else {
                    // Non-game segments (rewards, free spin, etc.)
                    // would land here when added later — the event
                    // still carries the index, so wire whatever
                    // surface fits. Today every segment maps to a
                    // game so this branch is a no-op.
                    console.info('[hex] resolved on segment', i, 'no game routed');
                }
            });
        })();

        // ── Spin-modal shared refs ─────────────────────────────────
        // The per-game launch buttons used to be wired here — they're
        // gone now, replaced by the spin hex wheel above which
        // auto-routes each landed segment into GamifEYEDGame.launch().
        // Shared toast element used by both games' error paths and by
        // the landing's ambient toasts (demos-remaining chip after a
        // game tears down, etc.).
        var msToastEl      = document.getElementById('msToast');
        // Retained for the Escape / Spin-Again paths — we still want
        // to close a visible game-over overlay before tearing the
        // game down. The per-game module owns its contents; this
        // reference is only used to check .visible and to hide it on
        // teardown from outside the game.
        var msGameOverEl   = document.getElementById('msGameOver');
        var floodGameOverEl  = document.getElementById('floodGameOver');
        var h3Loaded = (typeof h3 !== 'undefined');
        // Seed from local guest allowance (spin-guest-allowance.js) or the
        // server-rendered data-demos-left attr for legacy surfaces.
        var carViewportEl = document.getElementById('spinIntroAuthedCarouselViewport');
        var isAuthed = carViewportEl
            ? carViewportEl.getAttribute('data-viewer-authed') === '1'
            : !!(
                spinGlobeDataEl() && spinGlobeDataEl().hasAttribute
                && spinGlobeDataEl().hasAttribute('data-free-spins-left')
            );
        var msDemosLeft = (function() {
            if (!isAuthed && window.SpinGuestAllowance) {
                return window.SpinGuestAllowance.getCombinedLeft(false);
            }
            var el = spinGlobeDataEl();
            var seed = el && el.getAttribute ? el.getAttribute('data-demos-left') : null;
            if (seed == null || seed === '') return null;
            var n = parseInt(seed, 10);
            return isNaN(n) ? null : n;
        })();
        // Auth flag derived from the Blade-emitted data-free-spins-left
        // attribute, which is ONLY rendered for logged-in users (see
        // the @if($spinAuthed) branch in ping-landing.blade.php). The
        // demo-game cap (msDemosLeft) is sign-up-funnel friction
        // intended for guests only — authed users have already paid in
        // Aura (or burned a daily free spin) at /api/spin-globe/random
        // and shouldn't be re-gated on which game they choose to play
        // on a spun place. This flag lets the per-game button visibility
        // and the Spin-button sub-label both branch on auth state
        // without each having to re-derive it. Server-side gating was
        // also fixed in the matching spinGlobe*Start methods so this
        // is defence-in-depth, not the only line.
        // Dungeon still uses its own launch-armed guard since the scaffold
        // doesn't manage it. Minesweeper and Flood Fill both go through
        // GamifEYEDGame.launch which has its own activeSlug guard.
        var msLaunchArmed = false;

        // Authed-only daily-free-spin counter. Seeded from the Blade-
        // rendered data-free-spins-left attr so the button label is
        // accurate from first paint; subsequent spins refresh this
        // via the /api/spin-globe/random response (see beginSpin()).
        //
        // Remains null for guests — they keep using the
        // session-based msDemosLeft counter below.
        var authFreeSpinsLeft = (function() {
            if (!isAuthed) return null;
            var el = document.getElementById('spinGlobeTrigger')
                || document.getElementById('spinGlobeTriggerAuthedSentinel');
            var seed = el && el.getAttribute ? el.getAttribute('data-free-spins-left') : null;
            if (seed == null || seed === '') return 0;
            var n = parseInt(seed, 10);
            return isNaN(n) ? 0 : n;
        })();
        var spinFreeSpinsExpiryIso = (PL && PL.freeSpinsExpiresAt) ? PL.freeSpinsExpiresAt : null;
        var spinFreeSpinsExpiryTimer = null;
        var spinDailyRolloverRefreshPending = false;
        var spinExpiryRolloverHandledIso = null;

        function spinFreeSpinsTimezone() {
            return (PL && PL.userTimezone) || 'UTC';
        }

        function spinFreeSpinsSecondsUntilExpiry() {
            if (spinFreeSpinsExpiryIso) {
                var ms = Date.parse(spinFreeSpinsExpiryIso) - Date.now();
                if (!isNaN(ms)) {
                    return Math.max(0, Math.ceil(ms / 1000));
                }
            }
            var tz = spinFreeSpinsTimezone();
            var now = new Date();
            var parts;
            try {
                parts = new Intl.DateTimeFormat('en-US', {
                    timeZone: tz,
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: false,
                }).formatToParts(now);
            } catch (e) {
                parts = new Intl.DateTimeFormat('en-US', {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: false,
                }).formatToParts(now);
            }
            var hour = 0;
            var minute = 0;
            var second = 0;
            parts.forEach(function (p) {
                if (p.type === 'hour') hour = parseInt(p.value, 10) % 24;
                if (p.type === 'minute') minute = parseInt(p.value, 10);
                if (p.type === 'second') second = parseInt(p.value, 10);
            });
            var elapsed = hour * 3600 + minute * 60 + second;
            return Math.max(0, 86400 - elapsed);
        }

        window.pingLandingSpinExpiryTimeHms = function () {
            return spinExpiryTimeHms();
        };

        function spinExpiryTimeHms() {
            var secs = spinFreeSpinsSecondsUntilExpiry();
            var h = Math.floor(secs / 3600);
            var m = Math.floor((secs % 3600) / 60);
            var s = secs % 60;
            return String(h).padStart(2, '0') + ':'
                + String(m).padStart(2, '0') + ':'
                + String(s).padStart(2, '0');
        }

        function formatFreeSpinsExpiryLine() {
            var tpl = (PL.isJutdeeTenant && PL.creditsExpiryFmt)
                ? PL.creditsExpiryFmt
                : (PL.freeSpinsExpiryFmt || 'Expiry: :time');
            return tpl.replace(':time', spinExpiryTimeHms());
        }

        function formatTerritoriesTableLuckSubtitle() {
            var tpl = (PL && PL.territoriesLuckInFmt) || 'More Good Luck In :time';
            return tpl.replace(':time', spinExpiryTimeHms());
        }

        function refreshSpinFreeSpinsAfterMidnight() {
            // While a walk is live, the walk-sync responses keep the count
            // and expiry fresh and carry walk-earned spins across a period
            // boundary. Firing the idle expiry refresh here would hit
            // walk-status, which forfeits unspent walk spins — wiping the
            // spins being earned in the current walk. Skip it; the next
            // walk-sync re-arms the countdown for the new period.
            if (document.body.classList.contains('is-walk-earn-active')) return;
            var expiredIso = spinFreeSpinsExpiryIso || '__midnight__';
            if (spinDailyRolloverRefreshPending) return;
            if (spinExpiryRolloverHandledIso === expiredIso) return;

            spinDailyRolloverRefreshPending = true;
            spinExpiryRolloverHandledIso = expiredIso;
            // Daily allowance has expired, but walk-earned spins persist.
            // Let the server tell us the authoritative remaining count
            // (daily + banked walk spins) rather than optimistically
            // zeroing — which would wipe walk spins from the display.
            spinFreeSpinsExpiryIso = null;

            fetch('/api/spin-globe/walk-status', {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
            })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (data) {
                    if (!data) return;
                    if (typeof data.free_spins_expires_at === 'string' && data.free_spins_expires_at) {
                        spinFreeSpinsExpiryIso = data.free_spins_expires_at;
                        spinExpiryRolloverHandledIso = null;
                    }
                    if (typeof data.free_spins_left === 'number') {
                        setFreeSpinsLeft(data.free_spins_left);
                    }
                    if (typeof window.pingLandingOnLocalMidnight === 'function') {
                        window.pingLandingOnLocalMidnight();
                    }
                })
                .catch(function () {
                    spinExpiryRolloverHandledIso = null;
                })
                .finally(function () {
                    spinDailyRolloverRefreshPending = false;
                });
        }
        window.pingLandingRefreshSpinExpiry = refreshSpinFreeSpinsAfterMidnight;

        function stopSpinFreeSpinsExpiryTimer() {
            if (spinFreeSpinsExpiryTimer) {
                clearInterval(spinFreeSpinsExpiryTimer);
                spinFreeSpinsExpiryTimer = null;
            }
        }

        function ensureSpinFreeSpinsExpiryTimer() {
            if (authFreeSpinsLeft == null) {
                stopSpinFreeSpinsExpiryTimer();
                return;
            }
            if (spinFreeSpinsExpiryTimer) return;
            spinFreeSpinsExpiryTimer = setInterval(function () {
                if (authFreeSpinsLeft == null) {
                    stopSpinFreeSpinsExpiryTimer();
                    return;
                }
                if (spinFreeSpinsSecondsUntilExpiry() <= 0) {
                    refreshSpinFreeSpinsAfterMidnight();
                } else {
                    updateSpinGlobeSubExpiryLine();
                }
            }, 1000);
        }

        function updateSpinGlobeSubExpiryLine() {
            var line2 = (PL.isJutdeeTenant && authFreeSpinsLeft != null)
                ? formatJutdeeGameCreditsExpiryLine()
                : formatFreeSpinsExpiryLine();
            var btn = document.getElementById('spinGlobeBtn');
            if (btn) {
                var pillSub = btn.querySelector('.spin-sub');
                if (pillSub && authFreeSpinsLeft != null && authFreeSpinsLeft > 0) {
                    pillSub.textContent = line2;
                    pillSub.style.display = '';
                }
                updateJutdeeAuthedTerritoriesCtaBtn();
                return;
            }
            var territoryPill = queryTerritorySpinPillEl();
            if (territoryPill) {
                queryTerritorySpinPillEls().forEach(function (pill) {
                    if (pill.classList.contains('is-territory-slot-cap')) return;
                    var pillSub = pill.querySelector('.spin-sub');
                    if (pillSub) {
                        pillSub.textContent = line2;
                        pillSub.style.display = '';
                    }
                });
                updateJutdeeAuthedTerritoriesCtaBtn();
                if (typeof window.__jutdeeSyncTerritoriesTableSpinBtn === 'function') {
                    window.__jutdeeSyncTerritoriesTableSpinBtn();
                }
                return;
            }
            spinGlobeSubEl = querySpinGlobeSubEl();
            if (!spinGlobeSubEl) {
                updateJutdeeAuthedTerritoriesCtaBtn();
                return;
            }
            var lineEls = spinGlobeSubEl.querySelectorAll('.spin-intro-status-text-line');
            if (lineEls.length >= 2) {
                lineEls[1].textContent = line2;
            }
            updateJutdeeAuthedTerritoriesCtaBtn();
        }

        function applyFreeSpinsExpiryFromPayload(data) {
            if (data && typeof data.free_spins_expires_at === 'string') {
                spinFreeSpinsExpiryIso = data.free_spins_expires_at;
            }
        }

        // Guest spin-expiry countdown. Guests don't have an authed daily
        // free-spin window, so their pill sub-label shows a rolling
        // 30-minute countdown to the next reset boundary in place of the
        // old "No Reg. Required" value prop. The window is epoch-aligned
        // so it matches the server-side rollover in UserController
        // (spinGlobeGuestApplyWindowRollover) exactly — when the pill
        // hits 00:00 the server has already replenished the allowance, so
        // we optimistically restore the local count + label too.
        var GUEST_SPIN_RESET_SECONDS = 30 * 60;
        var guestSpinExpiryTimer = null;
        var guestSpinWindowId = Math.floor(Date.now() / 1000 / GUEST_SPIN_RESET_SECONDS);

        function guestSpinSecondsUntilReset() {
            var nowSec = Math.floor(Date.now() / 1000);
            var rem = GUEST_SPIN_RESET_SECONDS - (nowSec % GUEST_SPIN_RESET_SECONDS);
            return rem <= 0 ? GUEST_SPIN_RESET_SECONDS : rem;
        }

        function formatGuestSpinExpiryLine() {
            var secs = guestSpinSecondsUntilReset();
            var m = Math.floor(secs / 60);
            var s = secs % 60;
            var time = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
            var tpl = (PL.isJutdeeTenant && PL.guestBannerCreditsRefreshFmt)
                ? PL.guestBannerCreditsRefreshFmt
                : (PL.guestBannerSpinExpiryFmt || 'New spins in :time');
            return tpl.replace(':time', time);
        }

        function jutdeeGameCreditsLabel(n) {
            n = Math.max(0, parseInt(n, 10) || 0);
            if (n === 1) {
                return PL.guestBannerCreditsOne || 'You Have 1 Game Credit';
            }
            return (PL.guestBannerCreditsN || 'You Have :n Game Credits').replace(':n', n);
        }

        function jutdeeGameCreditsExpiryTime() {
            if (authFreeSpinsLeft != null) {
                var secs = spinFreeSpinsSecondsUntilExpiry();
                var h = Math.floor(secs / 3600);
                var m = Math.floor((secs % 3600) / 60);
                var s = secs % 60;
                return String(h).padStart(2, '0') + ':'
                    + String(m).padStart(2, '0') + ':'
                    + String(s).padStart(2, '0');
            }
            return '00:00:00';
        }

        function formatJutdeeGameCreditsExpiryLine() {
            if (authFreeSpinsLeft != null) {
                var tpl = PL.guestBannerCreditsRefreshFmt || 'And :time to use them.';
                return tpl.replace(':time', jutdeeGameCreditsExpiryTime());
            }
            return formatGuestSpinExpiryLine();
        }

        function jutdeeTerritoriesCtaSubLine() {
            var n = Math.max(0, parseInt(authFreeSpinsLeft, 10) || 0);
            var time = jutdeeGameCreditsExpiryTime();
            if (n === 1) {
                return (PL.jutdeeTerritoriesCtaSubOne || ':time To Use 1 Game Credit')
                    .replace(':time', time);
            }
            return (PL.jutdeeTerritoriesCtaSubN || ':time To Use :n Game Credits')
                .replace(':time', time).replace(':n', String(n));
        }

        function updateJutdeeAuthedTerritoriesCtaBtn() {
            if (!PL.isJutdeeTenant || authFreeSpinsLeft == null) return;
            var btn = document.getElementById('spinAuthedCtaTerritoriesBtn');
            if (!btn) return;
            var labelEl = btn.querySelector('.spin-label');
            var subEl = btn.querySelector('.spin-sub');
            if (subEl) {
                subEl.textContent = jutdeeTerritoriesCtaSubLine();
                subEl.style.display = '';
            }
            if (labelEl && subEl) {
                btn.setAttribute('aria-label', labelEl.textContent + ' — ' + subEl.textContent);
            }
        }

        function stopGuestSpinExpiryTimer() {
            if (guestSpinExpiryTimer) {
                clearInterval(guestSpinExpiryTimer);
                guestSpinExpiryTimer = null;
            }
        }

        function ensureGuestSpinExpiryTimer() {
            if (guestSpinExpiryTimer) return;
            guestSpinExpiryTimer = setInterval(function () {
                var guestPill = document.getElementById('spinGuestBannerWinTerritory');
                if (!guestPill || authFreeSpinsLeft != null) {
                    stopGuestSpinExpiryTimer();
                    return;
                }
                var nowWindow = Math.floor(Date.now() / 1000 / GUEST_SPIN_RESET_SECONDS);
                if (nowWindow !== guestSpinWindowId) {
                    // New 30-minute window: server resets the guest allowance
                    // (default demos + walk-earned spins) back to the default.
                    // Restore the local count + label to match (also re-enables
                    // spinning if the guest had hit 0). Skip while a walk is
                    // active — the server preserves an in-progress walk's spins
                    // and the walk-sync responses keep the local count fresh.
                    guestSpinWindowId = nowWindow;
                    if (!document.body.classList.contains('is-walk-earn-active')) {
                        if (window.SpinGuestAllowance) {
                            setFreeSpinsLeft(window.SpinGuestAllowance.applyWindowRollover(false));
                        } else {
                            var maxDemos = parseInt(PL.guestSpinMaxDemos, 10);
                            if (!isFinite(maxDemos) || maxDemos <= 0) maxDemos = 10;
                            setFreeSpinsLeft(maxDemos);
                        }
                    }
                    return;
                }
                var sub = guestPill.querySelector('.spin-sub');
                if (sub) {
                    sub.textContent = formatGuestSpinExpiryLine();
                    sub.style.display = '';
                }
            }, 1000);
        }

        // Keeps the "Spin The Globe" button's sub-label in sync with
        // whichever counter applies to the current viewer. Authed
        // users take the free-spin branch (then the paid-spin cost line
        // once the daily allowance is exhausted); guests keep the
        // existing MS / Dungeon demo counter.
        function queryTerritorySpinPillEls() {
            var pills = [];
            var seen = [];
            function addPill(el) {
                if (!el || seen.indexOf(el) >= 0) return;
                seen.push(el);
                pills.push(el);
            }
            addPill(document.getElementById('spinGlobeBtn'));
            addPill(document.querySelector(
                '#spinGlobeTrigger .spin-globe-pill--territory-spin'
            ));
            addPill(document.getElementById('spinAuthedTerritoriesSpinBtn'));
            addPill(document.getElementById('spinGuestBannerWinTerritory'));
            return pills;
        }

        function queryTerritorySpinPillEl() {
            var pills = queryTerritorySpinPillEls();
            return pills.length ? pills[0] : null;
        }

        function applyTerritorySpinPillStacked(pill, line1, line2) {
            if (!pill || pill.classList.contains('is-territory-slot-cap')) return;
            var pillLabel = pill.querySelector('.spin-label');
            var pillSub = pill.querySelector('.spin-sub');
            if (pillLabel && line1 != null) pillLabel.textContent = line1;
            if (pillSub && line2 != null) {
                pillSub.textContent = line2;
                pillSub.style.display = '';
            }
        }

        function applyTerritorySpinPillSingle(pill, text) {
            if (!pill || pill.classList.contains('is-territory-slot-cap')) return;
            var pillLabel = pill.querySelector('.spin-label');
            var pillSub = pill.querySelector('.spin-sub');
            if (pillLabel) pillLabel.textContent = text;
            if (pillSub) pillSub.style.display = 'none';
        }

        function updateSpinGlobeBtnStacked(line1, line2) {
            var btn = document.getElementById('spinGlobeBtn');
            if (!btn) return false;
            var pillLabel = btn.querySelector('.spin-label');
            var pillSub = btn.querySelector('.spin-sub');
            if (line1 != null && pillLabel) pillLabel.textContent = line1;
            if (pillSub && line2 != null) {
                pillSub.textContent = line2;
                pillSub.style.display = line2 ? '' : 'none';
            }
            return true;
        }

        function updateSpinGlobeBtnSingle(text) {
            var btn = document.getElementById('spinGlobeBtn');
            if (!btn) return false;
            var pillLabel = btn.querySelector('.spin-label');
            var pillSub = btn.querySelector('.spin-sub');
            if (pillLabel) pillLabel.textContent = text;
            if (pillSub) pillSub.style.display = 'none';
            return true;
        }
        function querySpinGlobeSubEl() {
            return document.querySelector('#spinGlobeTrigger #spinGlobeSub')
                || document.querySelector('.spin-hero-stack #spinGlobeSub');
        }
        var spinGlobeSubEl = querySpinGlobeSubEl();
        function spinGlobeSubPlainText(el) {
            var pill = queryTerritorySpinPillEl();
            if (pill) {
                var label = pill.querySelector('.spin-label');
                var sub = pill.querySelector('.spin-sub');
                var parts = [];
                if (label && (label.textContent || '').trim()) {
                    parts.push((label.textContent || '').trim());
                }
                if (sub && sub.style.display !== 'none' && (sub.textContent || '').trim()) {
                    parts.push((sub.textContent || '').trim());
                }
                return parts.join(' ');
            }
            if (!el) return '';
            var lines = el.querySelectorAll('.spin-intro-status-text-line');
            if (lines.length) {
                return Array.prototype.map.call(lines, function(node) {
                    return (node.textContent || '').trim();
                }).filter(Boolean).join(' ');
            }
            return (el.textContent || '').replace(/\s+/g, ' ').trim();
        }
        // Server-rendered initial copy. We capture it as textContent
        // (single-line plain string) so the guest demo-counter branch
        // below can fall back to it. The authed paid-spin line is
        // plain text too; renderSpinSubAuraState() only rewrites it
        // when the client refreshes that state after a spin.
        var SPIN_SUB_DEFAULT = spinGlobeSubPlainText(spinGlobeSubEl);

        // Seed currentAuraBalance from any pre-rendered Aura counter
        // (hero pill) when the page loads in the paid-spin state.
        (function seedAuraBalanceFromChip() {
            var seedEl = spinGlobeSubEl
                ? spinGlobeSubEl.querySelector('[data-spin-aura-count]')
                : null;
            if (!seedEl) {
                seedEl = document.querySelector('[data-spin-aura-count]');
            }
            if (!seedEl) return;
            var raw = (seedEl.textContent || '').replace(/,/g, '');
            var n = parseInt(raw, 10);
            if (!isNaN(n)) currentAuraBalance = Math.max(0, n);
        })();

        function renderSpinGlobeSubStacked(line1, line2) {
            if (updateSpinGlobeBtnStacked(line1, line2)) {
                return;
            }
            var territoryPill = queryTerritorySpinPillEl();
            if (territoryPill) {
                queryTerritorySpinPillEls().forEach(function (pill) {
                    applyTerritorySpinPillStacked(pill, line1, line2);
                });
                return;
            }
            spinGlobeSubEl = querySpinGlobeSubEl();
            if (!spinGlobeSubEl) return;
            var lineEls = spinGlobeSubEl.querySelectorAll('.spin-intro-status-text-line');
            if (lineEls.length < 2) {
                var stacked = document.createElement('span');
                stacked.className = 'spin-intro-status-text spin-intro-status-text--stacked';
                if (spinGlobeSubEl.id) stacked.id = spinGlobeSubEl.id;
                var top = document.createElement('span');
                top.className = 'spin-intro-status-text-line';
                var bottom = document.createElement('span');
                bottom.className = 'spin-intro-status-text-line';
                stacked.appendChild(top);
                stacked.appendChild(bottom);
                spinGlobeSubEl.parentNode.replaceChild(stacked, spinGlobeSubEl);
                spinGlobeSubEl = stacked;
                lineEls = spinGlobeSubEl.querySelectorAll('.spin-intro-status-text-line');
            } else {
                spinGlobeSubEl.classList.add('spin-intro-status-text--stacked');
            }
            lineEls[0].textContent = line1;
            lineEls[1].textContent = line2;
        }

        function renderSpinGlobeSubSingle(text) {
            if (updateSpinGlobeBtnSingle(text)) {
                return;
            }
            var territoryPill = queryTerritorySpinPillEl();
            if (territoryPill) {
                queryTerritorySpinPillEls().forEach(function (pill) {
                    applyTerritorySpinPillSingle(pill, text);
                });
                return;
            }
            spinGlobeSubEl = querySpinGlobeSubEl();
            if (!spinGlobeSubEl) return;
            var lineEls = spinGlobeSubEl.querySelectorAll('.spin-intro-status-text-line');
            if (lineEls.length) {
                var single = document.createElement('span');
                single.className = 'spin-intro-status-text';
                if (spinGlobeSubEl.id) single.id = spinGlobeSubEl.id;
                single.textContent = text;
                spinGlobeSubEl.parentNode.replaceChild(single, spinGlobeSubEl);
                spinGlobeSubEl = single;
            } else {
                spinGlobeSubEl.classList.remove('spin-intro-status-text--stacked');
                spinGlobeSubEl.textContent = text;
            }
        }

        // Paid-spin status: cost only (Aura balance lives in the hero pills).
        function renderSpinSubAuraState() {
            var costStr = formatSpinAuraCostLabel(PL.spinAuraCostM2);
            var tpl = PL.auraPerSpin || ':cost Per spin';
            renderSpinGlobeSubSingle(tpl.replace(':cost', costStr));
            spinGlobeSubEl = querySpinGlobeSubEl();
            if (queryTerritorySpinPillEl()) {
                return;
            }
            // Swap status icon to a spin cue when in paid-spin state.
            var statusWrap = spinGlobeSubEl && spinGlobeSubEl.closest('.spin-intro-status');
            if (statusWrap) {
                var iconEl = statusWrap.querySelector('.spin-intro-status-icon');
                if (iconEl) {
                    iconEl.className = 'bi bi-arrow-repeat spin-intro-status-icon';
                }
            }
        }

        function syncFreeSpinsDomAttrs(count) {
            var n = Math.max(0, parseInt(count, 10) || 0);
            var trigger = document.getElementById('spinGlobeTrigger')
                || document.getElementById('spinGlobeTriggerAuthedSentinel');
            if (trigger) {
                trigger.setAttribute('data-free-spins-left', String(n));
            }
            var btn = document.getElementById('spinGlobeBtn');
            if (btn) {
                btn.setAttribute('data-free-spins-left', String(n));
            }
            var guestBanner = document.getElementById('spinCelebrateBanner');
            if (guestBanner) {
                guestBanner.setAttribute('data-demos-left', String(n));
            }
        }

        function setFreeSpinsLeft(n) {
            n = Math.max(0, parseInt(n, 10) || 0);
            if (authFreeSpinsLeft !== null) {
                authFreeSpinsLeft = n;
            } else {
                msDemosLeft = n;
            }
            syncFreeSpinsDomAttrs(n);
            ensureSpinFreeSpinsExpiryTimer();
            updateSpinGlobeSub();
            updateJutdeeContinueCreditsSub();
        }

        function updateSpinGlobeSub() {
            spinGlobeSubEl = querySpinGlobeSubEl();
            if (!spinGlobeSubEl && !queryTerritorySpinPillEl()) return;
            if (authFreeSpinsLeft != null) {
                if (PL.isJutdeeTenant) {
                    renderSpinGlobeSubStacked(
                        jutdeeGameCreditsLabel(authFreeSpinsLeft),
                        formatJutdeeGameCreditsExpiryLine()
                    );
                    updateJutdeeAuthedTerritoriesCtaBtn();
                    updateJutdeeContinueCreditsSub();
                    ensureSpinFreeSpinsExpiryTimer();
                    if (typeof window.__jutdeeSyncTerritoriesTableSpinBtn === 'function') {
                        window.__jutdeeSyncTerritoriesTableSpinBtn();
                    }
                    return;
                }
                if (authFreeSpinsLeft <= 0) {
                    stopSpinFreeSpinsExpiryTimer();
                    renderSpinSubAuraState();
                } else if (authFreeSpinsLeft === 1) {
                    renderSpinGlobeSubStacked(
                        PL.isJutdeeTenant
                            ? (PL.oneCreditLine1 || '1 Credit')
                            : (PL.oneFreeSpinLine1 || '1 Free Spin'),
                        formatFreeSpinsExpiryLine()
                    );
                    ensureSpinFreeSpinsExpiryTimer();
                } else {
                    renderSpinGlobeSubStacked(
                        PL.isJutdeeTenant
                            ? (PL.nCreditsLine1 || ':n Credits').replace(':n', authFreeSpinsLeft)
                            : (PL.nFreeSpinsLine1 || ':n Free Spins').replace(':n', authFreeSpinsLeft),
                        formatFreeSpinsExpiryLine()
                    );
                    ensureSpinFreeSpinsExpiryTimer();
                }
                return;
            }
            if (msDemosLeft == null) { renderSpinGlobeSubSingle(SPIN_SUB_DEFAULT); return; }
            var guestPill = document.getElementById('spinGuestBannerWinTerritory');
            if (guestPill) {
                var guestSub = formatGuestSpinExpiryLine();
                if (msDemosLeft === 1) {
                    renderSpinGlobeSubStacked(
                        PL.isJutdeeTenant
                            ? (PL.guestBannerCreditsOne || 'You Have 1 Game Credit')
                            : (PL.oneSpinLine1 || '1 Spin'),
                        guestSub
                    );
                } else {
                    renderSpinGlobeSubStacked(
                        PL.isJutdeeTenant
                            ? (PL.guestBannerCreditsN || 'You Have :n Game Credits').replace(
                                ':n',
                                msDemosLeft != null ? msDemosLeft : 0
                            )
                            : (PL.nSpinsLine1 || ':n Spins').replace(
                                ':n',
                                msDemosLeft != null ? msDemosLeft : 0
                            ),
                        guestSub
                    );
                }
                ensureGuestSpinExpiryTimer();
                return;
            }
            if (msDemosLeft <= 0) {
                renderSpinGlobeSubSingle(PL.noFree);
            } else if (msDemosLeft === 1) {
                renderSpinGlobeSubSingle(PL.oneFree);
            } else {
                renderSpinGlobeSubSingle(PL.nFree.replace(':n', msDemosLeft));
            }
        }
        window.pingLandingUpdateSpinGlobeSub = updateSpinGlobeSub;
        window.pingLandingSetFreeSpinsLeft = setFreeSpinsLeft;
        function recordGuestPlayIfNeeded() {
            if (authFreeSpinsLeft !== null) return;
            if (!window.SpinGuestAllowance) return;
            setFreeSpinsLeft(window.SpinGuestAllowance.recordGamePlay());
        }
        window.pingLandingSecondsUntilLocalMidnight = spinFreeSpinsSecondsUntilExpiry;
        window.pingLandingMidnightIso = function () {
            if (spinFreeSpinsExpiryIso) {
                return spinFreeSpinsExpiryIso;
            }
            var secs = spinFreeSpinsSecondsUntilExpiry();
            return new Date(Date.now() + secs * 1000).toISOString();
        };
        window.pingLandingFormatMidnightCountdown = function () {
            var secs = spinFreeSpinsSecondsUntilExpiry();
            var h = Math.floor(secs / 3600);
            var m = Math.floor((secs % 3600) / 60);
            var s = secs % 60;
            return String(h).padStart(2, '0') + ':'
                + String(m).padStart(2, '0') + ':'
                + String(s).padStart(2, '0');
        };
        if (authFreeSpinsLeft != null) {
            // If the daily window already lapsed at load, reconcile with
            // the server (which returns daily + banked walk spins) instead
            // of forcing zero — walk spins must survive a stale window.
            if (spinFreeSpinsSecondsUntilExpiry() <= 0) {
                refreshSpinFreeSpinsAfterMidnight();
            }
            ensureSpinFreeSpinsExpiryTimer();
        } else if (document.getElementById('spinGuestBannerWinTerritory')) {
            // Guests: swap the server-rendered "No Reg. Required" sub-label
            // for the live 30-minute spin-expiry countdown on first paint.
            updateSpinGlobeSub();
        }

        var INTERACTIVITY_HANDLERS = ['dragPan','dragRotate','scrollZoom','boxZoom','doubleClickZoom','touchZoomRotate','keyboard','touchPitch'];

        function ensureH3(cb) {
            if (h3Loaded && typeof h3 !== 'undefined') return cb();
            var s = document.createElement('script');
            s.src = 'https://unpkg.com/h3-js';
            s.onload = function() { h3Loaded = true; cb(); };
            s.onerror = function() { showToast(PL.engineLoadFail); closeMsAndResume(); };
            document.head.appendChild(s);
        }

        function toggleMapInteractivity(on) {
            INTERACTIVITY_HANDLERS.forEach(function(name) {
                try {
                    if (!map[name]) return;
                    if (on) map[name].enable(); else map[name].disable();
                } catch(e) {}
            });
            try { map.getCanvas().style.cursor = on ? '' : ''; } catch(e) {}
        }

        function showToast(text, ms) {
            if (!text) return;
            msToastEl.textContent = text;
            msToastEl.classList.add('visible');
            clearTimeout(showToast._t);
            showToast._t = setTimeout(function() {
                msToastEl.classList.remove('visible');
            }, ms || 2400);
        }

        // ── MS / FF game implementations moved out of this file ─────
        // All Minesweeper- and Flood-Fill-specific board logic, HUD
        // wiring, map handlers, boundary/hex painters, timers and
        // claim payload builders now live in dedicated modules under
        // /js/games/ that are lazy-loaded by GamifEYEDGame.launch().
        // See public/js/games/{minesweeper,flood-fill}.js.
        //
        // What stays in this file is the shared HOST plumbing every
        // game needs: the post-win auth modal + confetti, the claim
        // POST (now to the unified /api/spin-globe/game-claim), the
        // globe-resume teardown, and the hooks the scaffold calls via
        // GamifEYEDGame.configure({...}).

        function showWinAuthModal() {
            // Retired the old standalone #msAuthModal ("You win!" green
            // modal) in favour of the shared inline .spin-auth-panel
            // that already lives inside the result modal's .spin-body.
            // We bring the result modal back on top of the MS overlay
            // and flip its body into .is-authpanel mode with the
            // Register tab active — the same surface (and magenta /
            // Fredoka styling) the homepage pill opens for guests.
            //
            // The spin-auth-panel submit handler notices pendingClaim
            // is set and routes success through claimPendingWinIfAny +
            // msCompleteAuth (confetti + won-state card) instead of
            // the default location.reload(). See that handler below.
            if (!modal) return;
            var body = modal.querySelector('.spin-body');
            if (!body) return;
            var panel = body.querySelector('.spin-auth-panel');
            if (!panel) {
                // Authenticated users: the spin-auth-panel partial is
                // @guest-gated, so its absence here means the current
                // session is already logged in. Skip the login step
                // entirely and fire the same claim → confetti → won-
                // state pipeline the guest flow reaches after register
                // (claimPendingWinIfAny POSTs the stashed pendingClaim,
                // and msCompleteAuth paints the won card on success).
                // showWinCongrats owns modal visibility from there on,
                // so we deliberately don't .add('visible') here — it
                // would flash the pre-won result card (pink location
                // pills / spin CTAs) for a frame before the green
                // Territory Claimed card paints after the claim POST.
                claimPendingWinIfAny().then(msCompleteAuth);
                return;
            }
            modal.classList.add('visible');
            body.classList.add('is-authpanel');
            // Flip the panel into win-mode so the extra "Login Or
            // Register / To Add [Place] To Your Territories" heading
            // and the Spin Again CTA render (see .is-mswin rules in
            // ping-landing.css). Populate the placename from the
            // already-rendered result card so the user sees exactly
            // what they'd be claiming if they sign up.
            panel.classList.add('is-mswin');
            var placeSlot = panel.querySelector('[data-spin-auth-winplace]');
            if (placeSlot) {
                var placeName = getSpinPlaceName() || 'this place';
                placeSlot.textContent = placeName;
            }
            // Default to Register — it's the real conversion goal for a
            // fresh guest. spinAuthSetTab also clears stale errors and
            // focuses the first input for password-manager compatibility.
            spinAuthSetTab(panel, 'register');
        }

        // Fire a three-burst confetti celebration using the deferred
        // canvas-confetti vendor script on ping-landing.
        function msFireConfettiBurst(opts) {
            opts = opts || {};
            var c = window.confetti;
            if (typeof c !== 'function' || typeof c.reset !== 'function') return;
            var colors = opts.colors || ['#00ffd5', '#8ef5e3', '#ffffff', '#ffd166', '#ff7eb9'];
            var zi = opts.zIndex != null ? { zIndex: opts.zIndex } : {};
            try {
                c(Object.assign({ particleCount: 90, spread: 70, startVelocity: 45, origin: { x: 0.5, y: 0.3 }, colors: colors }, zi));
                setTimeout(function() {
                    c(Object.assign({ particleCount: 60, angle: 60,  spread: 55, origin: { x: 0,   y: 0.7 }, colors: colors }, zi));
                    c(Object.assign({ particleCount: 60, angle: 120, spread: 55, origin: { x: 1,   y: 0.7 }, colors: colors }, zi));
                }, 220);
                setTimeout(function() {
                    c(Object.assign({ particleCount: 120, spread: 120, startVelocity: 35, origin: { x: 0.5, y: 0.4 }, colors: colors }, zi));
                }, 520);
            } catch (e) {}
        }

        function showWinCongrats(areaName, auraAwarded) {
            // Replay the spin card in "won" state. The hero image,
            // breadcrumb, name and Wikipedia extract are still in the
            // DOM from when openModal() populated them before launch,
            // so we don't need to re-render any content — just flip
            // the card into its celebration state and bring it back.
            //
            // If the user signed up via the inline auth panel we flipped
            // the result body into earlier, we also need to drop the
            // .is-authpanel modifier so the card's native won-state
            // content (hero, name, confetti CTA) is what paints.
            modal.querySelectorAll('.spin-body.is-authpanel').forEach(function(b) {
                b.classList.remove('is-authpanel');
            });
            msGameOverEl.classList.remove('visible');

            // Sanity-check the displayed name against the server's
            // authoritative area_name, in case anything drifted.
            if (areaName) {
                var heroNameEl = document.getElementById('spinModalHeroLocationName');
                if (heroNameEl && !heroNameEl.textContent) {
                    heroNameEl.textContent = areaName;
                }
                if (nameEl && !nameEl.textContent) {
                    nameEl.textContent = areaName;
                }
                if (isJutdeeSpinModal()) {
                    var stampBottomEl = spinCardEl
                        ? spinCardEl.querySelector('.spin-claim-stamp-bottom')
                        : null;
                    if (stampBottomEl) {
                        stampBottomEl.textContent = areaName;
                    }
                }
            }

            if (isJutdeeSpinModal()) resetJutdeeSpinUi();

            // Paint the "+N Aura earned" celebration line. The server
            // echoes aura_awarded in the claim response (see
            // GameClaimValidator::handle()). Inject a new element above
            // the won-state .spin-actions — the CSS is gated on
            // .spin-card.won so it stays invisible on the pre-play /
            // is-authpanel states. Always wipe a previous line first
            // so a second spin-win in the same session doesn't stack
            // two readouts, and only render when the server actually
            // paid Aura (> 0) so zero-reward / already-owned claims
            // don't show a confusing "+0 Aura" message.
            var bodyEl = spinCardEl ? spinCardEl.querySelector('.spin-body') : null;
            var actionsEl = bodyEl ? bodyEl.querySelector('.spin-actions') : null;
            var existingAuraLine = bodyEl ? bodyEl.querySelector('#spinWonAuraLine') : null;
            if (existingAuraLine) existingAuraLine.remove();
            var auraAmount = parseInt(auraAwarded, 10);
            if (bodyEl && actionsEl && isFinite(auraAmount) && auraAmount > 0) {
                var auraLine = document.createElement('div');
                auraLine.id = 'spinWonAuraLine';
                auraLine.className = 'spin-aura-won';
                auraLine.setAttribute('aria-live', 'polite');
                auraLine.textContent = '+' + auraAmount.toLocaleString() + ' Aura earned';
                bodyEl.insertBefore(auraLine, actionsEl);
            }

            // Ensure the card is fully resettable, then flip into won
            // state. Force a reflow between class removals/adds so the
            // fly-in animation replays cleanly after the earlier
            // fly-up (otherwise the card can linger off-screen).
            modal.classList.remove('flying-up');
            modal.classList.remove('visible');
            if (spinCardEl) {
                spinCardEl.classList.remove('won');
                void spinCardEl.offsetWidth;
                spinCardEl.classList.add('won');
            }
            modal.classList.add('visible');

            // Retry a few times so the burst lands even if the CDN
            // script hadn't finished loading yet when the user hit
            // Enter. Once window.confetti is the real function, the
            // first retry after load will actually paint particles.
            var tries = 0;
            (function loop() {
                msFireConfettiBurst();
                if (tries++ < 6) setTimeout(loop, 200);
            })();
        }


        function closeMsAndResume() {
            // Per-game teardown happens in the scaffold's own
            // closeAndResume() BEFORE this host hook fires — each
            // game's registered onTeardown wipes its own layers,
            // HUDs, timers, and game-over overlays. By the time we
            // get here, the map is already clean of game state.
            //
            // When called DIRECTLY by the host (e.g. spin-again,
            // Escape with a game-over overlay showing, or an error
            // path that bypassed GamifEYEDGame.closeAndResume),
            // notifyHostTeardown lets the scaffold wipe activeSlug
            // and pendingClaim so the next launch isn't wedged by
            // a stale guard. It's a no-op when the scaffold is the
            // one that called us (state is already clean).
            //
            // What stays host-side is the globe-resume choreography:
            // the dungeon how-to defensive hide (dungeon stays off
            // the scaffold), the auth-panel reset, the ease-back to
            // globe framing, and the demos-remaining toast.
            if (window.GamifEYEDGame && typeof window.GamifEYEDGame.notifyHostTeardown === 'function') {
                try { window.GamifEYEDGame.notifyHostTeardown(); } catch (e) {}
            }
            //
            toggleMapInteractivity(false);
            msLaunchArmed = false;
            // If the post-win auth panel was open on the result modal,
            // drop it so the card isn't stranded in .is-authpanel mode
            // if it ever gets reopened (e.g. another spin).
            if (modal) {
                modal.querySelectorAll('.spin-body.is-authpanel').forEach(function(b) {
                    b.classList.remove('is-authpanel');
                });
            }

            // Fade the landing HUDs back in as the globe re-frames.
            document.body.classList.remove('ms-active');
            setPingTopChromeHidden(false);
            restoreBasemapChrome();

            // Re-frame the map so the ambient spin picks up from a sensible
            // position rather than the pitched close-up where the user
            // finished their game.
            restoreIdleMapFraming(900);

            window.__spinActive = false;
            document.body.classList.remove('is-spinning');
            STATE = 'IDLE';

            // Bring the intro modal back so the user has a visible CTA
            // when the map re-frames — matching closeModal() / abortSpin()
            // which both re-surface the intro on their way out. Without
            // this the user is left staring at a bare spinning globe.
            // Jutdee guests use the cream win/walk modal instead of
            // #spinIntroModal (guests don't get the intro card).
            if (!window.__pingReturnToTerritoriesModal
                && !restoreGuestLandingChromeAfterPlay()
                && !restoreAuthedJutdeePlaySurface()) {
                showIntro();
            }

            // Guest-only "N demo games left this session" toast.
            // Authed users don't pay against this counter (see the
            // matching guard in spinGlobe*Start) so showing it would
            // be a lie — and worse, it would imply they're about to
            // be locked out of games they can keep playing freely.
            if (!isAuthed && msDemosLeft != null) {
                var tmpl = msDemosLeft === 1
                    ? PL.oneDemoLeft
                    : PL.nDemosLeft.replace(':n', msDemosLeft);
                if (msDemosLeft <= 0) tmpl = PL.noDemosSession;
                showToast(tmpl);
            }
        }

        /**
         * Slim cousin of closeMsAndResume. Used when the user is going
         * straight from a finished game into a fresh spin (e.g. the
         * Minesweeper BOOM modal "Spin The Globe" button). Skips the
         * ease-back-to-idle and the intro-modal show because beginSpin
         * owns the camera and modal stack from here on.
         *
         * What's omitted vs closeMsAndResume:
         *   - 900ms easeTo to idle framing — beginSpin's jumpTo
         *     to {zoom:1.8, pitch:0} sets framing instantly. Running
         *     them concurrently produced the "out of sync" feel the
         *     BOOM-spin button used to have.
         *   - showIntro() — the user isn't landing on the intro
         *     modal, they're starting a spin. Showing then 220ms
         *     later hiding the intro flashed it on/off-screen.
         *   - autoSpin re-arm — beginSpin disables autoSpin and
         *     drives setCenter directly during the spin.
         *   - Demos-remaining toast — the next spin's result modal
         *     surfaces the counter; double-toasting reads as buggy.
         *
         * What's preserved (so the next spin starts from a clean
         * slate identical to the closeMsAndResume path):
         *   - Per-game scaffold teardown (onTeardown, pendingClaim,
         *     activeSlug, preLaunchCamera) — already runs in
         *     GamifEYEDGame.closeAndSpinAgain BEFORE this hook fires;
         *     the notifyHostTeardown call below is defensive in case
         *     the host hook is invoked directly without going through
         *     the scaffold.
         *   - is-authpanel cleanup on the result modal.
         *   - ms-active body class removal.
         *   - restoreBasemapChrome.
         *   - toggleMapInteractivity(false) — beginSpin re-enables
         *     it via setSpinActive on its way through.
         *   - STATE = 'IDLE' — beginSpin checks this on entry and
         *     bails if it isn't IDLE.
         */
        function closeMsAndSpinAgain() {
            if (window.GamifEYEDGame && typeof window.GamifEYEDGame.notifyHostTeardown === 'function') {
                try { window.GamifEYEDGame.notifyHostTeardown(); } catch (e) {}
            }
            toggleMapInteractivity(false);
            msLaunchArmed = false;
            if (modal) {
                modal.querySelectorAll('.spin-body.is-authpanel').forEach(function(b) {
                    b.classList.remove('is-authpanel');
                });
            }
            document.body.classList.remove('ms-active');
            setPingTopChromeHidden(false);
            restoreBasemapChrome();

            window.__spinActive = false;
            document.body.classList.remove('is-spinning');
            STATE = 'IDLE';

            // Single uninterrupted animation pipeline: from here on,
            // beginSpin is the only thing touching the camera. No
            // overlapping easeTos, no modal flicker.
            beginSpin();
        }

        // ── Configure the GamifEYED game scaffold ───────────────────
        // Hand the base module everything it needs to orchestrate a
        // game launch: the map + result-modal references, the
        // localisation dictionary, and host-level helpers the per-
        // game modules delegate back to (toast, demo counter, auto-
        // spin, interactivity toggle, and the post-win auth modal).
        //
        // Done once, right after closeMsAndResume exists so the
        // scaffold's closeAndResume can bounce through it on teardown.
        // Every property the base module reads is spelled out here —
        // if you add a new helper in gamifeyed-game-base.js, add it
        // to this object too or games will see `undefined` at runtime.
        if (window.GamifEYEDGame && typeof window.GamifEYEDGame.configure === 'function') {
            window.GamifEYEDGame.configure({
                map: map,
                modal: modal,
                PL: PL,
                hideBasemapChrome: hideBasemapChrome,
                restoreBasemapChrome: restoreBasemapChrome,
                setPingTopChromeHidden: setPingTopChromeHidden,
                showToast: showToast,
                toggleMapInteractivity: toggleMapInteractivity,
                setAutoSpin: function(on) { try { autoSpin.active = !!on; } catch (e) {} },
                setSpinActive: function(on) { window.__spinActive = !!on; },
                setDemosLeft: function(n) { msDemosLeft = (typeof n === 'number') ? n : null; },
                recordGuestPlay: recordGuestPlayIfNeeded,
                // Authed users are NOT gated by the guest demo cap (see
                // spinGlobe*Start in UserController and the noDemos check
                // earlier in this file). Returning null here makes every
                // per-game "Play Again disabled when demos<=0" check —
                // minesweeper.js:358/436/572, flood-fill.js:494/919/1107 —
                // naturally pass for logged-in users, since they all use
                // the (demos != null && demos <= 0) shape. Guests still
                // get the real number so their cap UI keeps working.
                getDemosLeft: function() { return isAuthed ? null : msDemosLeft; },
                updateSpinGlobeSub: updateSpinGlobeSub,
                showWinAuthModal: showWinAuthModal,
                closeAndResume: closeMsAndResume,
                closeAndSpinAgain: closeMsAndSpinAgain,
                updateAuraPills: updateAuraPills
            });
        }

        // The old #msAuthModal tab / dismiss wiring used to sit here.
        // It's been retired along with that markup — the shared inline
        // .spin-auth-panel (already bound below) now drives the
        // post-minesweeper-win sign-up/login flow through the same
        // handler the pill's Login/Register uses.
        if (btnEnterAura) {
            btnEnterAura.addEventListener('click', function() {
                // Bring the user back to the landing hero so the newly
                // updated Lens + Aura pills (balances just moved on the
                // server) can slam in fresh. The ?celebrate=1 flag is
                // read by spinCelebrateInit() below, which shows
                // "[Place] Has Been Added / To Your Territories" in
                // #spinCelebrateBanner (outside the intro modal), fires
                // one last confetti burst, then clears the banner once
                // the burst finishes. The place name rides along as a
                // second param so the init doesn't have to round-trip
                // to the server just to label the territory.
                var place = getSpinPlaceName();
                try { localStorage.setItem('spinIntroAuthedCarouselSlide', '2'); } catch (e) {}
                var url = '/?celebrate=1';
                if (place) url += '&place=' + encodeURIComponent(place);
                window.location.href = url;
            });
        }
        if (btnJutdeeContinue) {
            btnJutdeeContinue.addEventListener('click', function() {
                if (STATE !== 'SHOW_MODAL') return;
                if (btnJutdeeContinue.disabled || jutdeeSpinUiPhase !== 'continue') return;
                var slug = jutdeePickedGameSlug;
                if (!slug) {
                    closeModal();
                    return;
                }
                jutdeeSpinUiPhase = 'loading';
                btnJutdeeContinue.disabled = true;
                if (btnJutdeePlayRow) btnJutdeePlayRow.hidden = true;
                setJutdeeContinueLoadingLabel();
                preloadJutdeeGame(slug).then(function(result) {
                    if (!result || !result.ok) jutdeePreloadFailed();
                });
            });
        }
        if (btnJutdeePlay) {
            btnJutdeePlay.addEventListener('click', function() {
                if (jutdeeSpinUiPhase !== 'ready') return;
                beginJutdeePlay();
            });
        }
        if (btnJutdeeHowTo) {
            btnJutdeeHowTo.addEventListener('click', function() {
                if (jutdeeSpinUiPhase !== 'ready') return;
                showJutdeeHowTo();
            });
        }
        if (btnJutdeeBackTerritories) {
            btnJutdeeBackTerritories.addEventListener('click', dismissJutdeeTerritoryClaimed);
        }

        function isTerritoryCapClaimFailure(res) {
            if (!res || !res.data) return false;
            var d = res.data;
            if (d.error_code === 'territory_cap' || d.no_free_slots) return true;
            return res.status === 403 && d.error && /territory limit/i.test(String(d.error));
        }

        function showSpinCelebrateNoFreeSlots() {
            if (typeof window.openSpinNoFreeSocketsModal === 'function') {
                window.openSpinNoFreeSocketsModal();
            }
        }

        function ensureTerritoryCelebrateConfettiLoaded(done) {
            var c = window.confetti;
            if (typeof c === 'function' && typeof c.reset === 'function') {
                done();
                return;
            }
            var existing = document.querySelector('script[src*="canvas-confetti"]');
            if (existing) {
                var waited = 0;
                (function poll() {
                    var loaded = window.confetti;
                    if (typeof loaded === 'function' && typeof loaded.reset === 'function') {
                        done();
                        return;
                    }
                    if (waited++ < 40) {
                        setTimeout(poll, 100);
                    } else {
                        done();
                    }
                })();
                return;
            }
            var script = document.createElement('script');
            script.src = '/js/vendor/canvas-confetti-1.9.3.browser.min.js';
            script.defer = true;
            script.onload = function() { done(); };
            script.onerror = function() { done(); };
            document.head.appendChild(script);
        }

        window.pingLandingFireConfettiBurst = function (opts) {
            ensureTerritoryCelebrateConfettiLoaded(function () {
                var burstTries = 0;
                (function confettiLoop() {
                    msFireConfettiBurst(opts);
                    if (burstTries++ < 6) setTimeout(confettiLoop, 200);
                })();
            });
        };

        // Territory celebrate banner: a single pending restore timer,
        // tracked at closure scope so a re-spin or a fresh celebrate can
        // cancel it before the 4s elapses. Without this, a stale timer
        // would fire mid-next-flow, release __spinCelebrateBannerLock and
        // re-sync the slide banner, clobbering freshly-set state.
        var territoryCelebrateTimer = null;
        var territoryCelebrateRestore = null;

        function cancelTerritoryCelebrate() {
            if (territoryCelebrateTimer) {
                clearTimeout(territoryCelebrateTimer);
                territoryCelebrateTimer = null;
            }
            // Run the in-flight restore synchronously so the banner /
            // title is reset (and the lock released) before the caller
            // repaints or starts a new spin.
            if (typeof territoryCelebrateRestore === 'function') {
                var fn = territoryCelebrateRestore;
                territoryCelebrateRestore = null;
                fn();
            }
        }
        window.cancelTerritoryCelebrate = cancelTerritoryCelebrate;

        function runTerritoryCelebrateBanner(place) {
            // Finalize any in-flight celebrate first, so we don't snapshot
            // celebrate markup as the "original" title on re-entry.
            cancelTerritoryCelebrate();

            place = (place || '').trim();
            window.__spinCelebrateBannerLock = true;

            var bannerEl = document.getElementById('spinCelebrateBanner');
            var titleEl = document.getElementById('spinIntroTitle');
            var originalTitleHtml = null;
            var hadWelcomeClass = false;
            var useBanner = !!(bannerEl);

            if (useBanner) {
                bannerEl.hidden = false;
                bannerEl.innerHTML = '';
                var bLine1 = document.createElement('span');
                bLine1.className = 'spin-celebrate-line1';
                bLine1.textContent = (place ? place + ' ' : '') + (PL.territoryAddedSuffix || 'Has Been Added');
                var bLine2 = document.createElement('span');
                bLine2.className = 'spin-celebrate-line2';
                bLine2.textContent = PL.territoryAddedLine2 || 'To Your Territories';
                bannerEl.appendChild(bLine1);
                bannerEl.appendChild(bLine2);
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        if (typeof window.syncSpinCelebrateBannerUnderFloatingPill === 'function') {
                            window.syncSpinCelebrateBannerUnderFloatingPill();
                        }
                        if (typeof window.syncSpinIntroSlide1UnderBannerPad === 'function') {
                            window.syncSpinIntroSlide1UnderBannerPad();
                        }
                        if (typeof window.syncSpinIntroMergeDock === 'function') {
                            window.syncSpinIntroMergeDock();
                        }
                    });
                });
            } else if (titleEl) {
                originalTitleHtml = titleEl.innerHTML;
                hadWelcomeClass = titleEl.classList.contains('is-welcome');
                titleEl.classList.remove('is-welcome');
                titleEl.classList.add('is-celebrate');
                titleEl.innerHTML = '';
                var line1 = document.createElement('span');
                line1.className = 'spin-intro-name-hero spin-intro-celebrate-line1';
                line1.textContent = (place ? place + ' ' : '') + (PL.territoryAddedSuffix || 'Has Been Added');
                var line2 = document.createElement('span');
                line2.className = 'spin-intro-name-hero spin-intro-celebrate-line2';
                line2.textContent = PL.territoryAddedLine2 || 'To Your Territories';
                titleEl.appendChild(line1);
                titleEl.appendChild(line2);
            }

            function restoreCelebrateUI() {
                // Idempotent: clear the shared timer/ref so a later
                // cancelTerritoryCelebrate() (or a second call) is a no-op.
                if (territoryCelebrateTimer) {
                    clearTimeout(territoryCelebrateTimer);
                    territoryCelebrateTimer = null;
                }
                territoryCelebrateRestore = null;
                window.__spinCelebrateBannerLock = false;
                if (useBanner && bannerEl) {
                    bannerEl.innerHTML = '';
                    bannerEl.hidden = true;
                } else if (titleEl && originalTitleHtml !== null) {
                    titleEl.classList.remove('is-celebrate');
                    if (hadWelcomeClass) titleEl.classList.add('is-welcome');
                    titleEl.innerHTML = originalTitleHtml;
                }
                // syncSpinIntroSlideBanner() routes through
                // finishIntroCarouselBannerLayout(), which already calls the
                // (self-guarding) restorePingLandingTopChrome() safety net —
                // so no separate chrome-restore call is needed here.
                if (typeof window.syncSpinIntroSlideBanner === 'function') {
                    window.syncSpinIntroSlideBanner();
                }
                if (typeof window.syncSpinIntroMergeDock === 'function') {
                    window.syncSpinIntroMergeDock();
                }
            }

            ensureTerritoryCelebrateConfettiLoaded(function() {
                var burstTries = 0;
                (function confettiLoop() {
                    msFireConfettiBurst();
                    if (burstTries++ < 6) setTimeout(confettiLoop, 200);
                })();
            });
            territoryCelebrateRestore = restoreCelebrateUI;
            territoryCelebrateTimer = setTimeout(restoreCelebrateUI, 4000);
        }

        // Shared handler for both auth submit paths: on success, keep the
        // user on the homepage for confetti + won-state card. On failure,
        // return to / (not /aura) so the Play The Planet flow stays put.
        function msCompleteAuth(res) {
            var ok = res && res.status >= 200 && res.status < 300 && res.data && res.data.success;
            if (ok) {
                // Achievements unlocked by this claim — render via the
                // shared toast helper before the congrats card so the
                // toasts stack down the right edge while the player
                // reads "Territory claimed". The helper auto-removes
                // each toast after ~4s; the congrats card stays open
                // until the player navigates away, so the toasts will
                // always finish their lifecycle ahead of the redirect.
                if (window.GameAchievementToast
                    && Array.isArray(res.data.achievements)
                    && res.data.achievements.length) {
                    try { window.GameAchievementToast.showMany(res.data.achievements); } catch (e) {}
                }

                // Win-claim returns aura_balance (post-claim total_aura)
                // from GameClaimValidator — same hook as game-loss uses
                // so the floating auth pill count-up runs for MS/FF/etc.
                var claimAuraBal = res.data.aura_balance;
                var claimAuraAwarded = parseInt(res.data.aura_awarded, 10) || 0;
                if (claimAuraBal != null && claimAuraAwarded > 0) {
                    var claimBalN = (typeof claimAuraBal === 'number')
                        ? claimAuraBal
                        : parseInt(String(claimAuraBal).replace(/[^\d-]/g, ''), 10);
                    if (isFinite(claimBalN)) {
                        updateAuraPills(claimBalN);
                    }
                }

                var stash = (window.GamifEYEDGame && window.GamifEYEDGame.getPendingClaim)
                    ? window.GamifEYEDGame.getPendingClaim()
                    : null;
                if (stash && stash.hex_count && res.data.hex_count == null) {
                    res.data.hex_count = stash.hex_count;
                }
                // Fallback country attrs from the spun place if claim JSON omitted them.
                if (currentPlace) {
                    if (!res.data.country && currentPlace.country) {
                        res.data.country = currentPlace.country;
                    }
                    if (!res.data.country_code) {
                        var placeCc = currentPlace.country_code
                            || (currentPlace.area && currentPlace.area.country_code);
                        if (placeCc) res.data.country_code = placeCc;
                    }
                }
                if (!appendTerritoryTownFromClaim(res.data)) {
                    // First territory or empty mount — reload so slide 2 matches DB.
                    var place = res.data.area_name || getSpinPlaceName();
                    try { localStorage.setItem('spinIntroAuthedCarouselSlide', '2'); } catch (e) {}
                    var reloadUrl = '/?celebrate=1';
                    if (place) reloadUrl += '&place=' + encodeURIComponent(place);
                    window.location.href = reloadUrl;
                    return;
                }

                // Thread aura_awarded through to the congrats card so
                // it can render the "+N Aura earned" line. The field
                // comes from GameClaimValidator::handle() — 0 on
                // already-owned / no-calculator paths, positive for a
                // fresh paying claim. showWinCongrats gates the render
                // on > 0 so falsy values are safe to pass.
                showWinCongrats(res.data.area_name, res.data.aura_awarded);
            } else if (isTerritoryCapClaimFailure(res)) {
                window.location.href = '/?no_free_slots=1';
            } else {
                var errMsg = (res && res.data && (res.data.error || res.data.message)) || '';
                if (!errMsg && res && res.status === 429) {
                    errMsg = 'Too many requests — wait a moment, then tap Claim again.';
                }
                if (!errMsg && res && res.status === 0) {
                    errMsg = 'Could not save your territory. Check your connection and try again.';
                }
                if (!errMsg) {
                    errMsg = 'Could not add this territory. Please try again.';
                }
                // Still close out the game visually — the board is over
                // even when the claim POST failed (429 throttle, expired
                // session stamp, etc.). Paint the won card from the
                // stashed place name so the player isn't stuck on the map.
                var fallbackName = (res && res.data && res.data.area_name)
                    || getSpinPlaceName()
                    || 'this place';
                showWinCongrats(fallbackName, null);
                showToast(errMsg, 5000);
            }
        }
        // POST the stashed win to the server so the newly-authed user
        // ends up owning the territory before we redirect them to
        // /territory. The CSRF token is regenerated during login /
        // register, so we prefer the fresh one from the auth response
        // body and fall back to the <meta> (which still matches the
        // current session even when regenerate() has just rotated it).
        // Returns a Promise that resolves regardless of claim outcome —
        // we never block the redirect on claim errors.
        //
        // All games post to the same unified endpoint now — the
        // `game` discriminator in the payload (auto-injected by
        // GamifEYEDGame.onWin before this runs) routes the server-
        // side dispatcher to the right validator. The legacy per-
        // game routes (/claim-pending-win, /flood-fill-claim) still
        // exist as forwarders so any old ping-landing.js still
        // cached in a user's browser doesn't break.
        function claimPendingWinIfAny(freshCsrf) {
            var stash = (window.GamifEYEDGame && window.GamifEYEDGame.getPendingClaim)
                ? window.GamifEYEDGame.getPendingClaim()
                : null;
            if (!stash || !stash.cp_id) {
                return Promise.resolve(null);
            }
            var CSRF = freshCsrf || ((document.querySelector('meta[name="csrf-token"]') || {}).content || '');
            var claimBody = Object.assign({}, stash, pingSlotBankJsonExtra());
            return fetch('/api/spin-globe/game-claim', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': CSRF, 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify(claimBody)
            })
            .then(function(r) { return r.json().then(function(d) { return { status: r.status, data: d }; }); })
            .catch(function() { return { status: 0, data: null }; })
            .then(function(res) {
                var ok = res && res.status >= 200 && res.status < 300
                    && res.data && res.data.success;
                // Only drop the stash once the server accepted the win.
                // On 429 / network / validation failure we keep it so the
                // player can retry without replaying the whole board.
                if (ok && window.GamifEYEDGame && window.GamifEYEDGame.clearPendingClaim) {
                    window.GamifEYEDGame.clearPendingClaim();
                }
                if (res.data) {
                    applyPingSlotBankFromResponse(res.data);
                } else {
                    endPingSlotBankSpend();
                }
                return res;
            });
        }

        // The per-form #msFormLogin / #msFormRegister submit handlers
        // that used to live here are gone along with the #msAuthModal
        // markup. The shared delegated [data-spin-auth-form] handler
        // below (the one that drives the pill's Login/Register panel)
        // now owns the post-win submit path too, and detects the
        // minesweeper-specific case via the pendingClaim stash.

        // ── Inline auth panel (spin-auth-panel.blade.php) ──
        // The panel's helpers (spinAuthSetTab/Open/Close/GetRecaptchaToken)
        // and the delegated tab / back / submit handlers now live in
        // public/js/spin-auth-panel.js so live.gamifeye.com's win modal
        // can reuse the same hardened auth surface. The shared file
        // attaches the helpers to window before this IIFE runs (its
        // <script> tag is emitted ahead of ping-landing.js), so we rebind
        // them as locals here so existing in-IIFE call-sites keep
        // working unchanged.
        var spinAuthGetBodyFor       = window.spinAuthGetBodyFor;
        var spinAuthSetTab           = window.spinAuthSetTab;
        var spinAuthOpen             = window.spinAuthOpen;
        var spinAuthClose            = window.spinAuthClose;
        var spinAuthGetRecaptchaToken = window.spinAuthGetRecaptchaToken;
        // Host hook the shared submit handler calls after a successful
        // /api/auth/{login,register} response when there's a stashed
        // game claim to settle. Runs the homepage's claim-then-confetti
        // tail (claimPendingWinIfAny → msCompleteAuth) — both functions
        // are IIFE-scoped above, so we expose them via this hook rather
        // than as broad globals. Any page that doesn't register this
        // hook (e.g. live-enrichment) falls through to location.reload()
        // in the shared file, which is exactly the right post-auth UX.
        if (window.GamifEYEDGame && !window.GamifEYEDGame.completePendingWinAuth) {
            window.GamifEYEDGame.completePendingWinAuth = function(freshCsrf) {
                return claimPendingWinIfAny(freshCsrf).then(msCompleteAuth);
            };
        }
        // Delegated click: "Spin Again" button inside the panel in
        // win-mode. Tears down the pending minesweeper session (so
        // no stray hex grid, HUD, or pending-claim stash leaks into
        // the next spin) and then kicks off a fresh spin using the
        // same fast-path the result modal's primary button uses.
        document.addEventListener('click', function(e) {
            var again = e.target.closest('[data-spin-auth-winagain]');
            if (!again) return;
            e.preventDefault();
            // Game session teardown — mirrors the essential cleanup of
            // closeMsAndResume() minus its globe-ease + showIntro calls
            // (beginSpin handles framing on its own, and the intro is
            // not the target state here). notifyHostTeardown clears
            // the scaffold's pendingClaim stash + activeSlug without
            // calling the host's closeAndResume again (we're doing
            // the host-side cleanup right here inline).
            if (window.GamifEYEDGame && window.GamifEYEDGame.getActiveSlug()) {
                try { window.GamifEYEDGame.closeAndResume(); } catch (err) {}
            }
            if (window.GamifEYEDGame && window.GamifEYEDGame.clearPendingClaim) {
                try { window.GamifEYEDGame.clearPendingClaim(); } catch (err) {}
            }
            try { toggleMapInteractivity(false); } catch (err) {}
            msLaunchArmed = false;
            document.body.classList.remove('ms-active');
            setPingTopChromeHidden(false);
            try { restoreBasemapChrome(); } catch (err) {}
            // Close the auth panel visually before the spin begins so
            // the fly-out animation doesn't flash the form one last time.
            var panelBody = again.closest('.spin-body');
            if (panelBody) spinAuthClose(panelBody);
            // Same teardown the result modal's corner ×-close uses
            // (closeModal()) minus the tail showIntro() and globe
            // restore — beginSpin handles framing on its own and we
            // want to skip the intro flash since the user is
            // explicitly asking for another spin from win-mode.
            modal.classList.remove('visible');
            currentPlace = null;
            window.__spinActive = false;
            document.body.classList.remove('is-spinning');
            STATE = 'IDLE';
            setTimeout(beginSpin, 180);
        });
        // Delegated click: Login / Register switch triggers from the pill.
        // Stays homepage-only because live-enrichment has no auth pill.
        document.addEventListener('click', function(e) {
            var trigger = e.target.closest('[data-spin-auth-switch]');
            if (!trigger) return;
            e.preventDefault();
            e.stopPropagation();
            spinAuthOpen(trigger, trigger.getAttribute('data-spin-auth-switch'));
        });
        window.setPingGuestBannerSuppressed = function (suppressed) {
            var banner = document.querySelector('[data-spin-guest-banner="1"]');
            if (!banner) return;
            banner.classList.toggle('is-guest-banner-suppressed', !!suppressed);
        };
        /** Hides guest headline + bottom CTAs while spin / slideshow is up. */
        window.setPingGuestEyeOpenerChromeHidden = function (hidden) {
            document.body.classList.toggle('is-ping-guest-eye-opener-active', !!hidden);
            var banner = document.querySelector('[data-spin-guest-banner="1"]');
            if (banner) {
                banner.classList.toggle('is-guest-banner-suppressed', !!hidden);
            }
            if (hidden) {
                if (banner) banner.setAttribute('hidden', '');
            } else {
                if (banner) banner.removeAttribute('hidden');
            }
            if (typeof window.setPingGuestBannerSuppressed === 'function') {
                window.setPingGuestBannerSuppressed(hidden);
            }
        };
        (function initGuestCelebrateBannerActions() {
            var learnBtn = document.getElementById('spinGuestBannerLearnMore');
            if (!learnBtn) return;
            learnBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if (typeof window.openPingEyeOpener === 'function') {
                    window.openPingEyeOpener();
                }
            });
        })();
        // Tab-click, Back-button, and the form submit handlers (with the
        // honeypot + reCAPTCHA-aware POST flow) all live in
        // public/js/spin-auth-panel.js now.

        // Returns true when the current viewer is a guest whose free
        // demo-game allowance for this session is exhausted. Spinning
        // itself is still free for guests server-side, but once they've
        // burned through all five Minesweeper / Dungeon / Flood Fill
        // demos every follow-on spin is a dead end — they'd land on a
        // place and every game button would 429 on start. So when this
        // returns true we redirect the Spin / Spin Again CTAs into the
        // inline login/register panel instead of calling beginSpin(),
        // giving the user a productive next step (register → keep
        // playing with full authed flow) instead of a pointless spin.
        //
        // Detection: authFreeSpinsLeft is null for guests (only seeded
        // for authed users via data-free-spins-left), so we gate the
        // guest-only demo counter behind that null check.
        function isGuestSpinsExhausted() {
            if (authFreeSpinsLeft !== null) return false;
            if (window.SpinGuestAllowance) {
                return !window.SpinGuestAllowance.canPlay();
            }
            return (msDemosLeft !== null && msDemosLeft <= 0);
        }
        // The pill button now lives inside the intro modal. Hide the intro
        // before starting the spin so the flyin animation has a clean
        // backdrop; the globe keeps running behind it either way.
        //
        // Exhausted-guest short-circuit: when the sub-label reads
        // "No free games left" there's nothing the next spin can deliver,
        // so we swap the .spin-intro-body into .is-authpanel mode on
        // the Register tab (same surface the inline login/register pill
        // opens) rather than firing another useless round-trip.
        function triggerPingSpin(triggerEl) {
            if (document.body.classList.contains('is-walk-earn-active')) {
                return;
            }
            var spinTrigger = document.getElementById('spinGlobeTrigger')
                || document.getElementById('spinGlobeTriggerAuthedSentinel');
            if (spinTrigger && spinTrigger.classList.contains('is-location-cap')
                && !window.pingSlotBankPending) {
                return;
            }
            if (authFreeSpinsLeft !== null && authFreeSpinsLeft <= 0) {
                if (typeof window.pingLandingRequestWalkLocation === 'function') {
                    window.pingLandingRequestWalkLocation();
                }
                return;
            }
            if (isGuestSpinsExhausted()) {
                spinAuthOpen(triggerEl || btn, 'register');
                return;
            }
            if (document.querySelector('[data-spin-guest-banner="1"]')
                && typeof window.setPingGuestEyeOpenerChromeHidden === 'function') {
                window.setPingGuestEyeOpenerChromeHidden(true);
            }
            if (typeof hideJutdeeAuthedCta === 'function') {
                hideJutdeeAuthedCta();
            }
            hideIntro();
            beginSpin();
        }
        window.triggerPingSpin = triggerPingSpin;

        if (floatingSpinBtn) {
            floatingSpinBtn.addEventListener('click', function () {
                if (document.body.classList.contains('is-walk-earn-active')) {
                    return;
                }
                var spinTrigger = document.getElementById('spinGlobeTrigger')
                    || document.getElementById('spinGlobeTriggerAuthedSentinel');
                if (spinTrigger && spinTrigger.classList.contains('is-location-cap')) {
                    if (typeof window.openSlotUpgrade === 'function') {
                        window.openSlotUpgrade('territory', null);
                    }
                    return;
                }
                triggerPingSpin(floatingSpinBtn);
            });
        }
        var guestBannerTerritorySpinBtn = document.getElementById('spinGuestBannerWinTerritory');
        if (guestBannerTerritorySpinBtn) {
            guestBannerTerritorySpinBtn.addEventListener('click', function () {
                triggerPingSpin(guestBannerTerritorySpinBtn);
            });
        }
        function wireJutdeeAuthedSpinPillClick(btn) {
            if (!btn || btn.__jutdeeAuthedSpinPillWired) return;
            btn.__jutdeeAuthedSpinPillWired = true;
            btn.addEventListener('click', function () {
                if (document.body.classList.contains('is-walk-earn-active')) {
                    return;
                }
                if (btn.disabled || btn.classList.contains('is-sunflowers-empty')) {
                    return;
                }
                if (btn.classList.contains('spin-globe-pill--walk-earn')
                    && !btn.classList.contains('is-territory-slot-cap')) {
                    if (typeof window.pingLandingRequestWalkLocation === 'function') {
                        window.pingLandingRequestWalkLocation();
                    }
                    return;
                }
                var spinTrigger = document.getElementById('spinGlobeTrigger')
                    || document.getElementById('spinGlobeTriggerAuthedSentinel');
                if (spinTrigger && spinTrigger.classList.contains('is-location-cap')) {
                    if (typeof window.openSlotUpgrade === 'function') {
                        window.openSlotUpgrade('territory', null);
                    }
                    return;
                }
                triggerPingSpin(btn);
            });
        }
        wireJutdeeAuthedSpinPillClick(
            document.getElementById('spinAuthedTerritoriesSpinBtn')
        );
        wireJutdeeAuthedSpinPillClick(
            document.getElementById('spinIntroTerritoriesTableSpinBtn')
        );
        if (heroSpinEye) {
            heroSpinEye.addEventListener('click', function () {
                if (PL.isJutdeeTenant) return;
                if (typeof window.openPingEyeOpener === 'function') {
                    window.openPingEyeOpener();
                }
            });
        }

        (function initJutdeeGuestWalkReward() {
            var rewardMount = document.getElementById('spinJutdeeGuestWalkRewardMount');
            if (!rewardMount) return;

            function guestCreditsLabel(n) {
                return jutdeeGameCreditsLabel(n);
            }

            function animateWalkRewardCount(fromCount, toCount) {
                fromCount = Math.max(0, parseInt(fromCount, 10) || 0);
                toCount = Math.max(fromCount, parseInt(toCount, 10) || 0);
                var labelEl = rewardMount.querySelector('[data-spin-reward-count-label]');
                var subEl = rewardMount.querySelector('[data-spin-reward-count-sub]');
                if (!labelEl) return;
                if (subEl) {
                    subEl.textContent = formatGuestSpinExpiryLine();
                    subEl.style.display = '';
                }
                if (rewardMount.__walkRewardCountRaf) {
                    cancelAnimationFrame(rewardMount.__walkRewardCountRaf);
                    rewardMount.__walkRewardCountRaf = null;
                }
                if (rewardMount.__walkRewardCountTimer) {
                    clearInterval(rewardMount.__walkRewardCountTimer);
                    rewardMount.__walkRewardCountTimer = null;
                }
                labelEl.textContent = guestCreditsLabel(fromCount);
                if (toCount <= fromCount) {
                    labelEl.textContent = guestCreditsLabel(toCount);
                    return;
                }
                // Step one integer at a time so each credit tick is visible
                // (4 → 5 → 6 …), not a blurred rAF ease that can skip frames.
                var cur = fromCount;
                var STEP_MS = 130;
                rewardMount.__walkRewardCountTimer = setInterval(function () {
                    cur += 1;
                    labelEl.textContent = guestCreditsLabel(cur);
                    if (cur >= toCount) {
                        clearInterval(rewardMount.__walkRewardCountTimer);
                        rewardMount.__walkRewardCountTimer = null;
                        labelEl.textContent = guestCreditsLabel(toCount);
                    }
                }, STEP_MS);
            }

            function dismissWalkRewardToCta() {
                hideJutdeeGuestWalkReward();
                if (window.SpinGuestAllowance) {
                    setFreeSpinsLeft(window.SpinGuestAllowance.getCombinedLeft(false));
                }
                if (typeof window.setPingGuestEyeOpenerChromeHidden === 'function') {
                    window.setPingGuestEyeOpenerChromeHidden(false);
                }
                revealJutdeeGuestCta();
            }

            function revealJutdeeGuestWalkReward(creditsWon, creditsBefore) {
                creditsWon = Math.max(0, parseInt(creditsWon, 10) || 0);
                if (creditsWon <= 0) {
                    dismissWalkRewardToCta();
                    return;
                }
                hideJutdeeGuestCta();
                var fromCount = Math.max(0, parseInt(creditsBefore, 10) || 0);
                var storedTo = window.SpinGuestAllowance
                    ? window.SpinGuestAllowance.getCombinedLeft(false)
                    : (msDemosLeft != null ? msDemosLeft : fromCount + creditsWon);
                // Authoritative range: walk-start balance → start + earned.
                // Storage can lag behind sessionSpinsEarned; never animate 0 steps.
                var toCount = Math.max(storedTo, fromCount + creditsWon);
                if (fromCount === 0 && storedTo > creditsWon) {
                    fromCount = storedTo - creditsWon;
                }
                var titleEl = document.getElementById('spinJutdeeGuestWalkRewardTitle');
                if (titleEl) {
                    titleEl.textContent = creditsWon === 1
                        ? (PL.guestWalkRewardTitleOne || 'You Won 1 Game Credit')
                        : (PL.guestWalkRewardTitleN || 'You Won :n Game Credits')
                            .replace(':n', creditsWon);
                }
                rewardMount.classList.add('is-revealed');
                rewardMount.setAttribute('aria-hidden', 'false');
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        animateWalkRewardCount(fromCount, toCount);
                    });
                });
            }
            window.revealJutdeeGuestWalkReward = revealJutdeeGuestWalkReward;

            var rewardCloseBtn = document.getElementById('jutdeeGuestWalkRewardClose');
            if (rewardCloseBtn && !rewardCloseBtn.__jutdeeWalkRewardCloseWired) {
                rewardCloseBtn.__jutdeeWalkRewardCloseWired = true;
                rewardCloseBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    dismissWalkRewardToCta();
                });
            }

            var rewardMainMenuBtn = document.getElementById('jutdeeGuestWalkRewardMainMenu');
            if (rewardMainMenuBtn && !rewardMainMenuBtn.__jutdeeWalkRewardMainMenuWired) {
                rewardMainMenuBtn.__jutdeeWalkRewardMainMenuWired = true;
                rewardMainMenuBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    dismissWalkRewardToCta();
                });
            }
        })();

        (function initJutdeeAuthedWalkReward() {
            var rewardMount = document.getElementById('spinJutdeeAuthedWalkRewardMount');
            if (!rewardMount) return;

            function hideJutdeeAuthedWalkReward() {
                // Clear the guard FIRST so a following restore/reveal of the
                // play menu is allowed through (see revealJutdeeAuthedCta).
                window.__jutdeeWalkRewardActive = false;
                rewardMount.classList.remove('is-revealed');
                rewardMount.setAttribute('aria-hidden', 'true');
                if (rewardMount.__walkRewardCountTimer) {
                    clearInterval(rewardMount.__walkRewardCountTimer);
                    rewardMount.__walkRewardCountTimer = null;
                }
            }
            window.hideJutdeeAuthedWalkReward = hideJutdeeAuthedWalkReward;

            function authedCreditsLabel(n) {
                return jutdeeGameCreditsLabel(n);
            }

            function animateAuthedWalkRewardCount(fromCount, toCount) {
                fromCount = Math.max(0, parseInt(fromCount, 10) || 0);
                toCount = Math.max(fromCount, parseInt(toCount, 10) || 0);
                var labelEl = rewardMount.querySelector('[data-spin-authed-reward-count-label]');
                var subEl = rewardMount.querySelector('[data-spin-authed-reward-count-sub]');
                if (!labelEl) return;
                if (subEl) {
                    subEl.textContent = formatJutdeeGameCreditsExpiryLine();
                    subEl.style.display = '';
                }
                if (rewardMount.__walkRewardCountTimer) {
                    clearInterval(rewardMount.__walkRewardCountTimer);
                    rewardMount.__walkRewardCountTimer = null;
                }
                labelEl.textContent = authedCreditsLabel(fromCount);
                if (toCount <= fromCount) {
                    labelEl.textContent = authedCreditsLabel(toCount);
                    return;
                }
                var cur = fromCount;
                var STEP_MS = 130;
                rewardMount.__walkRewardCountTimer = setInterval(function () {
                    cur += 1;
                    labelEl.textContent = authedCreditsLabel(cur);
                    if (cur >= toCount) {
                        clearInterval(rewardMount.__walkRewardCountTimer);
                        rewardMount.__walkRewardCountTimer = null;
                        labelEl.textContent = authedCreditsLabel(toCount);
                    }
                }, STEP_MS);
            }

            function dismissAuthedWalkRewardToIntro() {
                hideJutdeeAuthedWalkReward();
                if (!restoreAuthedJutdeePlaySurface()) {
                    try { showIntro(); } catch (e) {}
                }
            }

            function revealJutdeeAuthedWalkReward(creditsWon, creditsBefore) {
                creditsWon = Math.max(0, parseInt(creditsWon, 10) || 0);
                if (creditsWon <= 0) {
                    dismissAuthedWalkRewardToIntro();
                    return;
                }
                hideJutdeeAuthedCta();
                // Take ownership of the surface: while the reward is showing,
                // NOTHING may reveal the play menu behind it (globe-framing
                // moveend auto-reveals, late sync callbacks, onboarding, etc.).
                // The guard is honoured by revealJutdeeAuthedCta and
                // showJutdeeAuthedLandingAfterFlyIn and cleared only when the
                // reward is dismissed (Return To Main Menu / close / new walk).
                window.__jutdeeWalkRewardActive = true;
                try { if (typeof hideIntro === 'function') hideIntro(true); } catch (e) {}
                var fromCount = Math.max(0, parseInt(creditsBefore, 10) || 0);
                var storedTo = authFreeSpinsLeft != null
                    ? authFreeSpinsLeft
                    : fromCount + creditsWon;
                var toCount = Math.max(storedTo, fromCount + creditsWon);
                var titleEl = document.getElementById('spinJutdeeAuthedWalkRewardTitle');
                if (titleEl) {
                    titleEl.textContent = creditsWon === 1
                        ? (PL.guestWalkRewardTitleOne || 'You Won 1 Game Credit')
                        : (PL.guestWalkRewardTitleN || 'You Won :n Game Credits')
                            .replace(':n', creditsWon);
                }
                rewardMount.classList.add('is-revealed');
                rewardMount.setAttribute('aria-hidden', 'false');
                ensureTerritoryCelebrateConfettiLoaded(function () {
                    var confettiTries = 0;
                    (function confettiLoop() {
                        msFireConfettiBurst({ zIndex: 80 });
                        if (confettiTries++ < 6) setTimeout(confettiLoop, 200);
                    })();
                });
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        animateAuthedWalkRewardCount(fromCount, toCount);
                    });
                });
            }
            window.revealJutdeeAuthedWalkReward = revealJutdeeAuthedWalkReward;

            var rewardCloseBtn = document.getElementById('jutdeeAuthedWalkRewardClose');
            if (rewardCloseBtn && !rewardCloseBtn.__jutdeeAuthedWalkRewardCloseWired) {
                rewardCloseBtn.__jutdeeAuthedWalkRewardCloseWired = true;
                rewardCloseBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    dismissAuthedWalkRewardToIntro();
                });
            }

            var rewardMainMenuBtn = document.getElementById('jutdeeAuthedWalkRewardMainMenu');
            if (rewardMainMenuBtn && !rewardMainMenuBtn.__jutdeeAuthedWalkRewardMainMenuWired) {
                rewardMainMenuBtn.__jutdeeAuthedWalkRewardMainMenuWired = true;
                rewardMainMenuBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    dismissAuthedWalkRewardToIntro();
                });
            }
        })();

        (function initJutdeeAuthedCta() {
            var ctaMount = document.getElementById('spinJutdeeAuthedCtaMount');
            if (!ctaMount) return;

            var closeBtn = document.getElementById('jutdeeAuthedCtaClose');
            if (closeBtn && !closeBtn.__jutdeeAuthedCtaCloseWired) {
                closeBtn.__jutdeeAuthedCtaCloseWired = true;
                closeBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    hideJutdeeAuthedCta();
                    showIntro();
                });
            }

            var editBtn = document.getElementById('jutdeeAuthedCtaEdit');
            if (editBtn && !editBtn.__jutdeeAuthedCtaEditWired) {
                editBtn.__jutdeeAuthedCtaEditWired = true;
                editBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    var profileModal = document.getElementById('dashProfileEditModal');
                    if (profileModal) {
                        profileModal.classList.add('is-open');
                    }
                });
            }

            function openAuthedIntroSlide(slideId) {
                openAuthedIntroCarouselSlide(slideId);
            }

            var territoriesBtn = document.getElementById('spinAuthedCtaTerritoriesBtn');
            if (territoriesBtn && !territoriesBtn.__jutdeeAuthedCtaTerritoriesWired) {
                territoriesBtn.__jutdeeAuthedCtaTerritoriesWired = true;
                territoriesBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    openAuthedIntroSlide('2');
                });
            }

            var focalPointsBtn = document.getElementById('spinAuthedCtaFocalPointsBtn');
            if (focalPointsBtn && !focalPointsBtn.__jutdeeAuthedCtaFocalWired) {
                focalPointsBtn.__jutdeeAuthedCtaFocalWired = true;
                focalPointsBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (typeof window.pingLandingReturnToFocalPointsModal === 'function') {
                        window.pingLandingReturnToFocalPointsModal();
                    } else {
                        openAuthedIntroSlide('1');
                    }
                });
            }

            ['spinIntroBackToMenuFocal', 'spinIntroBackToMenuTerritories'].forEach(function (btnId) {
                var backBtn = document.getElementById(btnId);
                if (backBtn && !backBtn.__jutdeeBackToMenuWired) {
                    backBtn.__jutdeeBackToMenuWired = true;
                    backBtn.addEventListener('click', function (e) {
                        e.preventDefault();
                        returnJutdeeAuthedToPlayMenu();
                    });
                }
            });

            if (typeof window.pingLandingUpdateSpinGlobeSub === 'function') {
                window.pingLandingUpdateSpinGlobeSub();
            }
        })();

        (function spinWalkEarnInit() {
            if (!window.WalkTracking) return;

            var geoModal = document.getElementById('spinWalkGeoModal');
            var geoClose = document.getElementById('spinWalkGeoClose');
            var hud = document.getElementById('spinWalkHud');
            var hudStop = document.getElementById('spinWalkHudStop');
            var hudStatus = document.getElementById('spinWalkHudStatus');
            var hudStatusTitle = document.querySelector('[data-spin-walk-status-title]');
            var hudStatusSub = document.querySelector('[data-spin-walk-status-sub]');
            var hudCreditsLabel = document.querySelector('[data-spin-walk-credits-earned-label]');
            var hudStopSub = document.querySelector('[data-spin-walk-stop-sub]');

            function formatWalkHudCreditsEarned(count) {
                count = Math.max(0, parseInt(count, 10) || 0);
                if (count === 1 && PL.walkHudCreditsEarnedOne) {
                    return PL.walkHudCreditsEarnedOne;
                }
                var tpl = PL.walkHudCreditsEarnedN || ':n Game Credits Earned';
                return tpl.replace(':n', String(count));
            }

            function updateWalkHudCreditsLabel(count) {
                if (!hudCreditsLabel) return;
                count = Math.max(0, parseInt(count, 10) || 0);
                if (count > walkHudDisplayedCredits) {
                    pulseWalkHudCreditButton();
                }
                walkHudDisplayedCredits = count;
                hudCreditsLabel.textContent = formatWalkHudCreditsEarned(walkHudDisplayedCredits);
            }

            function pulseWalkHudCreditButton() {
                if (!hudStop) return;
                hudStop.classList.remove('is-credit-pulse');
                void hudStop.offsetWidth;
                hudStop.classList.add('is-credit-pulse');
                if (hudStop.__creditPulseTimer) {
                    clearTimeout(hudStop.__creditPulseTimer);
                }
                hudStop.__creditPulseTimer = setTimeout(function () {
                    hudStop.classList.remove('is-credit-pulse');
                    hudStop.__creditPulseTimer = null;
                }, 1100);
            }

            function metersRemainingForNextCredit(totalM) {
                var metersPerSpin = (window.WalkTracking && window.WalkTracking.METERS_PER_SPIN) || 50;
                totalM = Math.max(0, typeof totalM === 'number' && isFinite(totalM) ? totalM : 0);
                var remainder = totalM % metersPerSpin;
                if (remainder < 0.001) return metersPerSpin;
                return metersPerSpin - remainder;
            }

            function replaceWalkMeterPlaceholder(tpl, meters) {
                var n = String(Math.max(0, Math.round(meters)));
                // English templates use :nm → "125m"; Thai often uses :n with "เมตร" beside it.
                return tpl.replace(':nm', n + 'm').replace(':n', n);
            }

            function formatWalkHudNextCreditSub(totalM) {
                var remainingM = Math.max(1, Math.ceil(metersRemainingForNextCredit(totalM)));
                var tpl = PL.walkHudNextCreditSub || 'Walk :nm For Another Credit';
                return replaceWalkMeterPlaceholder(tpl, remainingM);
            }

            function updateWalkHudNextCreditSub(totalM) {
                if (!hudStopSub) return;
                hudStopSub.textContent = formatWalkHudNextCreditSub(totalM);
            }

            var walkHudDisplayedCredits = 0;
            var walkLastTotalM = 0;
            var walkLastSlowTotalM = 0;
            var walkIdleLastDistanceM = 0;
            var walkIdleStagnantSince = null;
            var walkIdlePromptVisible = false;
            var walkIdleAutoYesTimer = null;
            var walkIdlePollTimer = null;
            var walkIdlePromptMount = document.getElementById('spinWalkIdlePromptMount');
            var walkIdlePromptSub = document.getElementById('spinWalkIdlePromptSubtitle');
            var walkIdlePromptYes = document.getElementById('spinWalkIdlePromptYes');
            var walkIdlePromptNo = document.getElementById('spinWalkIdlePromptNo');
            var WALK_IDLE_PROMPT_MS = 15000;
            var WALK_IDLE_AUTO_YES_MS = 10000;
            // GPS jitter adds centimetres every fix while standing still —
            // only a real move (≥5 m) counts as "distance registered".
            var WALK_IDLE_DISTANCE_EPS_M = 5;

            function formatWalkIdlePromptSubtitle(count) {
                count = Math.max(0, parseInt(count, 10) || 0);
                if (count === 1 && PL.walkIdlePromptSubtitleOne) {
                    return PL.walkIdlePromptSubtitleOne;
                }
                var tpl = PL.walkIdlePromptSubtitleN || 'We will add :n Game Credits to your total.';
                return tpl.replace(':n', String(count));
            }

            function resolveWalkIdlePromptMount() {
                if (!walkIdlePromptMount) {
                    walkIdlePromptMount = document.getElementById('spinWalkIdlePromptMount');
                }
                if (!walkIdlePromptSub) {
                    walkIdlePromptSub = document.getElementById('spinWalkIdlePromptSubtitle');
                }
                return walkIdlePromptMount;
            }

            function clearWalkIdleAutoYesTimer() {
                if (walkIdleAutoYesTimer) {
                    clearTimeout(walkIdleAutoYesTimer);
                    walkIdleAutoYesTimer = null;
                }
            }

            function stopWalkIdleMonitor() {
                if (walkIdlePollTimer) {
                    clearInterval(walkIdlePollTimer);
                    walkIdlePollTimer = null;
                }
            }

            function hideWalkIdlePrompt() {
                walkIdlePromptVisible = false;
                clearWalkIdleAutoYesTimer();
                var mount = resolveWalkIdlePromptMount();
                if (!mount) return;
                mount.classList.remove('is-revealed');
                mount.setAttribute('aria-hidden', 'true');
                mount.setAttribute('hidden', '');
            }

            function showWalkIdlePrompt() {
                if (!PL.isJutdeeTenant) return;
                if (walkIdlePromptVisible) return;
                if (!document.body.classList.contains('is-walk-earn-active')) return;
                var mount = resolveWalkIdlePromptMount();
                if (!mount) return;
                walkIdlePromptVisible = true;
                if (walkIdlePromptSub) {
                    walkIdlePromptSub.textContent = formatWalkIdlePromptSubtitle(walkHudDisplayedCredits);
                }
                mount.removeAttribute('hidden');
                mount.classList.add('is-revealed');
                mount.setAttribute('aria-hidden', 'false');
                clearWalkIdleAutoYesTimer();
                walkIdleAutoYesTimer = setTimeout(function () {
                    walkIdleAutoYesTimer = null;
                    confirmWalkIdleStop();
                }, WALK_IDLE_AUTO_YES_MS);
            }

            function confirmWalkIdleStop() {
                if (!document.body.classList.contains('is-walk-earn-active')) return;
                hideWalkIdlePrompt();
                walkIdleStagnantSince = null;
                stopWalkSession();
            }

            function dismissWalkIdlePrompt() {
                hideWalkIdlePrompt();
                // Restart the stagnant clock from now so "No" doesn't
                // immediately re-open the prompt.
                walkIdleStagnantSince = Date.now();
            }

            // Wall-clock poll: does not depend on GPS fix cadence. A move
            // only resets the clock if metres rose by ≥ WALK_IDLE_DISTANCE_EPS_M
            // (filters standing-still GPS drift that previously blocked the modal).
            function startWalkIdleMonitor() {
                if (!PL.isJutdeeTenant) return;
                stopWalkIdleMonitor();
                walkIdleLastDistanceM = Math.max(0, walkLastTotalM || 0);
                walkIdleStagnantSince = Date.now();
                walkIdlePollTimer = setInterval(function () {
                    if (!document.body.classList.contains('is-walk-earn-active')) return;
                    if (!walkCameraReady) return;
                    var total = Math.max(0, walkLastTotalM || 0);
                    if (total >= walkIdleLastDistanceM + WALK_IDLE_DISTANCE_EPS_M) {
                        walkIdleLastDistanceM = total;
                        walkIdleStagnantSince = Date.now();
                        if (walkIdlePromptVisible) hideWalkIdlePrompt();
                        return;
                    }
                    if (walkIdlePromptVisible) return;
                    if (!walkIdleStagnantSince) {
                        walkIdleStagnantSince = Date.now();
                        return;
                    }
                    if ((Date.now() - walkIdleStagnantSince) >= WALK_IDLE_PROMPT_MS) {
                        showWalkIdlePrompt();
                    }
                }, 1000);
            }

            var walkUserMarker = null;
            var walkSyncInFlight = false;
            var walkPendingSegments = [];
            var walkSyncRetryTimer = null;
            // Transient failures (lost mobile signal, 5xx, lock contention) are
            // retried with backoff so the segment is NOT lost. Walking past
            // this many consecutive failures on one segment, we give up on it.
            var WALK_SYNC_MAX_RETRIES = 12;
            var sessionSpinsEarned = 0;
            var walkCreditsAtStart = 0;
            var walkCameraReady = false;
            var walkTrackingStarted = false;
            var WALK_LOCAL_ZOOM = 16;
            var WALK_LOCAL_PITCH = 60;
            var WALK_FLY_IN_MS = 2000;
            // maximumAge is deliberately generous: on iOS Home Screen
            // (standalone) PWAs a fresh high-accuracy lock frequently
            // stalls, so accepting a recent cached fix lets the walk start
            // instead of hanging. A ~30s-old position is fine for a walk
            // that's about to move anyway.
            var geoOpts = { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 };

            // Breadcrumb trail (mirrors our-app-home.js user-trail).
            var WALK_TRAIL_SOURCE_ID = 'spin-walk-trail-source';
            var WALK_TRAIL_LAYER_ID = 'spin-walk-trail-layer';
            var WALK_TRAIL_MAX_POINTS = 500;
            var WALK_TRAIL_MIN_DISPLACEMENT_M = 2;
            var walkTrailSegments = [];
            var walkTrailReady = false;

            function walkTrailEmptyFc() {
                return { type: 'FeatureCollection', features: [] };
            }

            function walkTrailHaversineM(aLng, aLat, bLng, bLat) {
                if (window.WalkTracking && window.WalkTracking.haversineMeters) {
                    return window.WalkTracking.haversineMeters(aLng, aLat, bLng, bLat);
                }
                var R = 6371000;
                var toRad = function (d) { return d * Math.PI / 180; };
                var dLat = toRad(bLat - aLat);
                var dLng = toRad(bLng - aLng);
                var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) *
                    Math.sin(dLng / 2) * Math.sin(dLng / 2);
                return 2 * R * Math.asin(Math.min(1, Math.sqrt(s)));
            }

            function walkTrailVertexCount() {
                var n = 0;
                for (var i = 0; i < walkTrailSegments.length; i++) {
                    n += walkTrailSegments[i].coords.length;
                }
                return n;
            }

            function trimWalkTrailToCap(cap) {
                while (walkTrailVertexCount() > cap && walkTrailSegments.length) {
                    var head = walkTrailSegments[0];
                    head.coords.shift();
                    if (head.coords.length < 2) walkTrailSegments.shift();
                }
            }

            function ensureWalkTrailLayer(walkMap) {
                if (walkTrailReady) return;
                if (!walkMap || typeof walkMap.addSource !== 'function') return;
                if (typeof walkMap.isStyleLoaded === 'function' && !walkMap.isStyleLoaded()) return;
                try {
                    walkMap.addSource(WALK_TRAIL_SOURCE_ID, {
                        type: 'geojson',
                        data: walkTrailEmptyFc(),
                    });
                    walkMap.addLayer({
                        id: WALK_TRAIL_LAYER_ID,
                        type: 'line',
                        source: WALK_TRAIL_SOURCE_ID,
                        layout: {
                            'line-cap': 'round',
                            'line-join': 'round',
                        },
                        paint: {
                            'line-color': [
                                'case',
                                ['boolean', ['get', 'slow'], false],
                                '#22c55e',
                                '#e91e8c',
                            ],
                            'line-width': 8,
                            'line-opacity': 0.85,
                            'line-blur': 0.5,
                        },
                    });
                    walkTrailReady = true;
                } catch (e) {
                    /* source/layer race — next fix retries */
                }
            }

            function repaintWalkTrail(walkMap) {
                if (!walkTrailReady || !walkMap) return;
                var src = walkMap.getSource(WALK_TRAIL_SOURCE_ID);
                if (!src) return;
                if (!walkTrailSegments.length) {
                    src.setData(walkTrailEmptyFc());
                    return;
                }
                var features = [];
                for (var i = 0; i < walkTrailSegments.length; i++) {
                    var seg = walkTrailSegments[i];
                    if (!seg || seg.coords.length < 2) continue;
                    features.push({
                        type: 'Feature',
                        properties: { slow: !!seg.slow },
                        geometry: { type: 'LineString', coordinates: seg.coords.slice() },
                    });
                }
                src.setData({ type: 'FeatureCollection', features: features });
            }

            function appendWalkTrailPoint(walkMap, lat, lng, slow) {
                if (!walkMap || typeof lat !== 'number' || typeof lng !== 'number') return;
                if (isNaN(lat) || isNaN(lng)) return;
                var slowBool = slow === false ? false : true;
                var lastSeg = walkTrailSegments.length
                    ? walkTrailSegments[walkTrailSegments.length - 1]
                    : null;
                var lastVtx = lastSeg && lastSeg.coords.length
                    ? lastSeg.coords[lastSeg.coords.length - 1]
                    : null;
                if (lastVtx) {
                    var d = walkTrailHaversineM(lastVtx[0], lastVtx[1], lng, lat);
                    if (d < WALK_TRAIL_MIN_DISPLACEMENT_M) return;
                }
                if (!lastSeg) {
                    walkTrailSegments.push({ slow: slowBool, coords: [[lng, lat]] });
                } else if (lastSeg.slow === slowBool) {
                    lastSeg.coords.push([lng, lat]);
                } else {
                    walkTrailSegments.push({
                        slow: slowBool,
                        coords: [[lastVtx[0], lastVtx[1]], [lng, lat]],
                    });
                }
                trimWalkTrailToCap(WALK_TRAIL_MAX_POINTS);
                ensureWalkTrailLayer(walkMap);
                repaintWalkTrail(walkMap);
            }

            function clearWalkTrail(walkMap) {
                walkTrailSegments = [];
                walkTrailReady = false;
                if (!walkMap) return;
                try {
                    if (walkMap.getLayer(WALK_TRAIL_LAYER_ID)) walkMap.removeLayer(WALK_TRAIL_LAYER_ID);
                    if (walkMap.getSource(WALK_TRAIL_SOURCE_ID)) walkMap.removeSource(WALK_TRAIL_SOURCE_ID);
                } catch (e) {}
            }

            function walkGeoErrorReason(err) {
                if (!err) return 'unavailable';
                if (err.code === 1) return 'denied';
                if (err.code === 3) return 'timeout';
                return 'unavailable';
            }

            function closeWalkGeoModal() {
                if (!geoModal) return;
                geoModal.classList.remove('is-visible');
                geoModal.setAttribute('hidden', '');
            }

            function showWalkGeoError(err) {
                if (!geoModal) return;
                geoModal.removeAttribute('hidden');
                geoModal.classList.add('is-visible');
                geoModal.setAttribute('data-state', 'error');
                geoModal.setAttribute('data-reason', walkGeoErrorReason(err));
            }

            function formatWalkHudSpeed(kph) {
                kph = Math.max(0, parseInt(kph, 10) || 0);
                return String(kph) + 'km/h';
            }

            function updateWalkHudStatus(totalM, kph, isSlow) {
                if (!hudStatusTitle || !hudStatusSub) return;
                var speedStr = formatWalkHudSpeed(kph);
                if (isSlow) {
                    var meters = Math.max(0, Math.round(totalM));
                    hudStatusTitle.textContent = replaceWalkMeterPlaceholder(
                        PL.walkHudStatusTitleSlow || 'You have walked :nm in this session.',
                        meters
                    );
                    hudStatusSub.textContent = (PL.walkHudStatusSubSlow || 'Your current speed is :speed.')
                        .replace(':speed', speedStr);
                } else {
                    hudStatusTitle.textContent = PL.walkHudStatusTitleFast || 'Reduce Speed To Less Than 10km/h';
                    hudStatusSub.textContent = (PL.walkHudStatusSubFast || 'You are currently going :speed.')
                        .replace(':speed', speedStr);
                }
                if (hudStatus) {
                    hudStatus.classList.toggle('is-slow', !!isSlow);
                    hudStatus.classList.toggle('is-fast', !isSlow);
                }
            }

            function paintWalkHud(fix) {
                var traveledM = fix.distanceTraveledM || 0;
                var pendingM = fix.pendingSlowMeters || 0;
                var totalM = traveledM + pendingM;
                var isSlow = true;
                var kph = 0;
                if (fix.resolution) {
                    var mps = fix.resolution.speedMps;
                    kph = mps != null && isFinite(mps) ? Math.round(mps * 3.6) : 0;
                    if (!fix.resolution.glitch) {
                        isSlow = !!fix.resolution.slow;
                    }
                }
                if (isSlow) {
                    walkLastSlowTotalM = totalM;
                }
                var displayTotalM = isSlow ? totalM : walkLastSlowTotalM;
                walkLastTotalM = displayTotalM;
                updateWalkHudStatus(displayTotalM, kph, isSlow);
                if (hudCreditsLabel && window.WalkTracking && isSlow) {
                    var metersPerSpin = window.WalkTracking.METERS_PER_SPIN || 50;
                    var previewSpins = Math.floor(displayTotalM / metersPerSpin);
                    updateWalkHudCreditsLabel(Math.max(sessionSpinsEarned, previewSpins));
                    updateWalkHudNextCreditSub(displayTotalM);
                }
            }

            function removeWalkUserMarker() {
                if (walkUserMarker) {
                    try { walkUserMarker.remove(); } catch (e) {}
                    walkUserMarker = null;
                }
            }

            function placeWalkUserMarker(lng, lat) {
                var walkMap = typeof window.pingLandingGetMap === 'function'
                    ? window.pingLandingGetMap()
                    : null;
                if (!walkMap || typeof maplibregl === 'undefined') return;
                if (walkUserMarker) {
                    walkUserMarker.setLngLat([lng, lat]);
                    return;
                }
                var el = document.createElement('div');
                el.className = 'spin-walk-user-marker';
                el.setAttribute('aria-hidden', 'true');
                var avatarUrl = window.PLAYER_AVATAR_URL;
                if (avatarUrl && typeof avatarUrl === 'string') {
                    el.classList.add('has-avatar');
                    var img = document.createElement('img');
                    img.src = avatarUrl;
                    img.alt = '';
                    el.appendChild(img);
                }
                walkUserMarker = new maplibregl.Marker({ element: el })
                    .setLngLat([lng, lat])
                    .addTo(walkMap);
            }

            function finishAuthedJutdeeWalkRewardReveal(creditsBefore) {
                // Best-known win count at stop time. sessionSpinsEarned only
                // reflects server-CONFIRMED segments, which can lag when the
                // final segment is still syncing. previewSpins is the same
                // distance-derived number the HUD showed the user throughout
                // the walk, so max() of the two is what they just saw ticking
                // up. Revealing on it means the reward modal appears instantly
                // and we never flash the main menu behind it.
                var metersPerSpin = (window.WalkTracking && window.WalkTracking.METERS_PER_SPIN) || 50;
                var previewSpins = Math.floor((walkLastTotalM || 0) / metersPerSpin);
                var creditsWon = Math.max(sessionSpinsEarned, previewSpins);

                if (creditsWon > 0) {
                    // WIN → reveal immediately; do NOT restore the play surface.
                    // The sync queue keeps draining in the background (it
                    // self-chains on each success), so the authoritative
                    // balance/pill reconciles to the server total while the
                    // reward modal is already on screen. The menu only appears
                    // when the user taps "Return To Main Menu".
                    sessionSpinsEarned = 0;
                    if (typeof window.revealJutdeeAuthedWalkReward === 'function') {
                        window.revealJutdeeAuthedWalkReward(creditsWon, creditsBefore);
                    } else if (!restoreAuthedJutdeePlaySurface()) {
                        try { showIntro(); } catch (e) {}
                    }
                    if (walkSyncInFlight || walkPendingSegments.length > 0) {
                        drainWalkSyncQueue();
                    }
                    return;
                }

                // No win → main menu right away (the user's one exception).
                if (!restoreAuthedJutdeePlaySurface()) {
                    try { showIntro(); } catch (e) {}
                }
                // Safety net: if a final segment is still settling and turns
                // out to award a credit after all, reveal the reward on top
                // when it lands (preserves the old zero-path behaviour).
                if (walkSyncInFlight || walkPendingSegments.length > 0) {
                    var deadline = Date.now() + 30000;
                    (function poll() {
                        if (!walkSyncInFlight && walkPendingSegments.length === 0) {
                            var lateWon = sessionSpinsEarned;
                            sessionSpinsEarned = 0;
                            if (lateWon > 0 && typeof window.revealJutdeeAuthedWalkReward === 'function') {
                                window.revealJutdeeAuthedWalkReward(lateWon, creditsBefore);
                            }
                            return;
                        }
                        if (Date.now() < deadline) {
                            drainWalkSyncQueue();
                            setTimeout(poll, 150);
                        }
                    })();
                }
            }
            window.finishAuthedJutdeeWalkRewardReveal = finishAuthedJutdeeWalkRewardReveal;

            function stopWalkSession() {
                stopWalkIdleMonitor();
                hideWalkIdlePrompt();
                walkIdleStagnantSince = null;
                walkIdleLastDistanceM = 0;
                var walkMap = typeof window.pingLandingGetMap === 'function'
                    ? window.pingLandingGetMap()
                    : null;
                // Emit any buffered (sub-threshold) metres BEFORE stopping GPS
                // tracking — stop() nulls the last position and callback.
                try { window.WalkTracking.flush(); } catch (e) {}
                window.WalkTracking.stop();
                removeWalkUserMarker();
                clearWalkTrail(walkMap);
                // Do NOT wipe the queue: any segments still pending (including
                // the just-flushed remainder and anything awaiting retry) keep
                // draining in the background so they're credited even though
                // the walk UI has closed. The spins button updates live as
                // each one lands. Leave walkSyncInFlight alone so an in-flight
                // request finishes cleanly.
                if (walkPendingSegments.length > 0) {
                    showToast(PL.walkEarnSavingSpins || 'Saving your spins\u2026', 2600);
                }
                drainWalkSyncQueue();
                walkCameraReady = false;
                walkTrackingStarted = false;
                walkHudDisplayedCredits = 0;
                if (hud) hud.setAttribute('hidden', '');
                document.body.classList.remove('is-walk-earn-active');
                try { toggleMapInteractivity(false); } catch (e) {}
                teardownJutdeeSpinMapView();
                if (typeof window.pingLandingRestoreGlobeFraming === 'function') {
                    window.pingLandingRestoreGlobeFraming(800);
                }
                if (document.getElementById('spinJutdeeGuestWalkRewardMount')) {
                    var creditsWon = sessionSpinsEarned;
                    sessionSpinsEarned = 0;
                    if (creditsWon > 0
                        && typeof window.revealJutdeeGuestWalkReward === 'function') {
                        if (typeof window.setPingGuestEyeOpenerChromeHidden === 'function') {
                            window.setPingGuestEyeOpenerChromeHidden(false);
                        }
                        window.revealJutdeeGuestWalkReward(creditsWon, walkCreditsAtStart);
                    } else if (!restoreGuestLandingChromeAfterPlay() && !restoreAuthedJutdeePlaySurface()) {
                        try { showIntro(); } catch (e) {}
                    }
                } else if (isAuthed && PL.isJutdeeTenant
                        && document.getElementById('spinJutdeeAuthedWalkRewardMount')
                        && typeof window.finishAuthedJutdeeWalkRewardReveal === 'function') {
                    window.finishAuthedJutdeeWalkRewardReveal(walkCreditsAtStart);
                } else if (!restoreGuestLandingChromeAfterPlay() && !restoreAuthedJutdeePlaySurface()) {
                    try { showIntro(); } catch (e) {}
                }
            }

            function flyWalkMapToLocal(walkMap, lng, lat) {
                try {
                    var camZoom = walkMap.getZoom();
                    if (camZoom < 10) {
                        walkMap.jumpTo({
                            center: [lng, lat],
                            zoom: 12,
                            pitch: 30,
                            bearing: 0,
                        });
                    }
                    walkMap.flyTo({
                        center: [lng, lat],
                        zoom: WALK_LOCAL_ZOOM,
                        pitch: WALK_LOCAL_PITCH,
                        bearing: 0,
                        duration: WALK_FLY_IN_MS,
                        essential: true,
                        curve: 1.4,
                    });
                } catch (e) {}
            }

            function beginWalkTracking(walkMap, seedLat, seedLng) {
                if (walkTrackingStarted) return;
                walkTrackingStarted = true;
                window.WalkTracking.start({
                    initialPos: { lat: seedLat, lng: seedLng },
                    onSegment: function (segment) {
                        syncWalkSegment(segment);
                    },
                    onFix: function (fix) {
                        placeWalkUserMarker(fix.lng, fix.lat);
                        paintWalkHud(fix);
                        if (!fix.resolution || !fix.resolution.glitch) {
                            appendWalkTrailPoint(
                                walkMap,
                                fix.lat,
                                fix.lng,
                                fix.resolution && fix.resolution.slow
                            );
                        }
                        if (!walkCameraReady) return;
                        try {
                            walkMap.easeTo({
                                center: [fix.lng, fix.lat],
                                zoom: WALK_LOCAL_ZOOM,
                                pitch: WALK_LOCAL_PITCH,
                                duration: 500,
                                essential: true,
                            });
                        } catch (e) {}
                    },
                    onError: function () {},
                });
            }

            function applyWalkSyncPayload(data) {
                if (!data) return;
                if (typeof data.free_spins_left === 'number') {
                    applyFreeSpinsExpiryFromPayload(data);
                    setFreeSpinsLeft(data.free_spins_left);
                }
                if (typeof data.spins_awarded === 'number' && data.spins_awarded > 0) {
                    sessionSpinsEarned += data.spins_awarded;
                    if (isAuthed) {
                        var awarded = data.spins_awarded;
                        var earnToast = awarded === 1
                            ? (PL.walkEarnCreditToastOne || '+1 Game Credit')
                            : (PL.walkEarnCreditToastN || '+:n Game Credits').replace(':n', String(awarded));
                        if (PL.isJutdeeTenant && typeof window.pingLandingFireGameCreditsFloater === 'function') {
                            window.pingLandingFireGameCreditsFloater(earnToast);
                        } else if (typeof window.pingLandingShowToast === 'function') {
                            window.pingLandingShowToast(earnToast, 2400);
                        }
                    }
                }
                if (hudCreditsLabel) {
                    updateWalkHudCreditsLabel(sessionSpinsEarned);
                    updateWalkHudNextCreditSub(walkLastTotalM);
                }
            }

            function drainWalkSyncQueue() {
                if (walkSyncInFlight || walkPendingSegments.length === 0) return;
                if (walkSyncRetryTimer) { clearTimeout(walkSyncRetryTimer); walkSyncRetryTimer = null; }
                var segment = walkPendingSegments[0];

                if (!isAuthed && window.SpinGuestAllowance) {
                    var localPayload = window.SpinGuestAllowance.applyWalkSegment(
                        segment.segMeters,
                        true
                    );
                    if (walkPendingSegments[0] === segment) walkPendingSegments.shift();
                    applyWalkSyncPayload(localPayload);
                    drainWalkSyncQueue();
                    return;
                }

                walkSyncInFlight = true;
                fetch('/api/spin-globe/walk-sync', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': (document.querySelector('meta[name="csrf-token"]') || {}).content || '',
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        lat: segment.lat,
                        lng: segment.lng,
                        seg_meters: segment.segMeters,
                        speed_mps: segment.speedMps,
                    }),
                })
                    .then(function (r) {
                        if (r.status === 503) {
                            showToast(PL.walkEarnUnavailable || 'Walk spins are not available yet.', 3200);
                            stopWalkSession();
                            throw new Error('feature_unavailable');
                        }
                        // Permanent client-side rejection (bad payload) — drop
                        // the segment so it can't wedge the queue. 419 (stale
                        // CSRF/session) is treated as transient and retried.
                        if (r.status >= 400 && r.status < 500 && r.status !== 419 && r.status !== 423) {
                            return null;
                        }
                        if (!r.ok) throw new Error('HTTP ' + r.status);
                        return r.json();
                    })
                    .then(function (data) {
                        // Accepted (or permanently dropped): remove from queue.
                        if (walkPendingSegments[0] === segment) walkPendingSegments.shift();
                        segment.__retries = 0;
                        if (data) applyWalkSyncPayload(data);
                    })
                    .catch(function (err) {
                        if (err && err.message === 'feature_unavailable') {
                            if (walkPendingSegments[0] === segment) walkPendingSegments.shift();
                            return;
                        }
                        // Transient failure — keep the segment for retry unless
                        // it has failed too many times in a row.
                        segment.__retries = (segment.__retries || 0) + 1;
                        if (segment.__retries > WALK_SYNC_MAX_RETRIES) {
                            if (walkPendingSegments[0] === segment) walkPendingSegments.shift();
                        }
                    })
                    .finally(function () {
                        walkSyncInFlight = false;
                        var retried = segment.__retries && segment.__retries > 0
                            && walkPendingSegments[0] === segment;
                        if (retried) {
                            // Exponential backoff capped at 8s so a flaky signal
                            // gets time to recover without hammering the server.
                            var delay = Math.min(8000, 500 * Math.pow(2, segment.__retries - 1));
                            walkSyncRetryTimer = setTimeout(function () {
                                walkSyncRetryTimer = null;
                                drainWalkSyncQueue();
                            }, delay);
                        } else {
                            drainWalkSyncQueue();
                        }
                    });
            }

            function syncWalkSegment(segment) {
                walkPendingSegments.push(segment);
                drainWalkSyncQueue();
            }

            function startWalkSession(lat, lng) {
                if (STATE !== 'IDLE') return;
                var walkMap = typeof window.pingLandingGetMap === 'function'
                    ? window.pingLandingGetMap()
                    : null;
                if (!walkMap) return;

                sessionSpinsEarned = 0;
                walkCreditsAtStart = isAuthed
                    ? authFreeSpinsLeft
                    : (window.SpinGuestAllowance
                        ? window.SpinGuestAllowance.getCombinedLeft(false)
                        : (msDemosLeft != null ? msDemosLeft : 0));
                walkCameraReady = false;
                walkTrackingStarted = false;
                walkHudDisplayedCredits = 0;
                walkLastTotalM = 0;
                walkLastSlowTotalM = 0;
                walkIdleStagnantSince = null;
                walkIdleLastDistanceM = 0;
                stopWalkIdleMonitor();
                hideWalkIdlePrompt();
                if (typeof window.pingLandingStopGlobeSpin === 'function') {
                    window.pingLandingStopGlobeSpin();
                }
                autoSpin.active = false;
                try { hideIntro(true); } catch (e) {}
                if (typeof hideJutdeeAuthedCta === 'function') {
                    hideJutdeeAuthedCta();
                }
                if (introModal) {
                    introModal.classList.remove('visible');
                    introModal.classList.remove('is-flying-out');
                }

                document.body.classList.add('is-walk-earn-active');
                if (hud) hud.removeAttribute('hidden');
                clearWalkTrail(walkMap);
                paintWalkHud({ distanceTraveledM: 0, resolution: { slow: true, speedMps: 0 } });
                updateWalkHudCreditsLabel(0);
                walkLastTotalM = 0;
                walkLastSlowTotalM = 0;
                updateWalkHudNextCreditSub(0);

                try { toggleMapInteractivity(true); } catch (e) {}
                try { attachPinkBuildings(); } catch (e) {}

                placeWalkUserMarker(lng, lat);
                flyWalkMapToLocal(walkMap, lng, lat);
                beginWalkTracking(walkMap, lat, lng);

                var flyInSettled = false;
                function onWalkFlyInSettled() {
                    if (flyInSettled) return;
                    flyInSettled = true;
                    walkCameraReady = true;
                    startWalkIdleMonitor();
                    if (isJutdeeSpinFlyIn()) {
                        var fadeMs = 900;
                        fadeJutdeeSpinSatelliteIn(fadeMs);
                        removeJutdeeCountryBackdrop(fadeMs);
                    }
                }
                walkMap.once('moveend', onWalkFlyInSettled);
                setTimeout(onWalkFlyInSettled, WALK_FLY_IN_MS + 400);
            }

            function requestWalkLocation() {
                if (STATE !== 'IDLE') return;
                if (document.body.classList.contains('is-walk-earn-active')) return;
                hideJutdeeGuestWalkReward();
                if (typeof window.hideJutdeeAuthedWalkReward === 'function') {
                    window.hideJutdeeAuthedWalkReward();
                }
                if (!('geolocation' in navigator)) {
                    showWalkGeoError({ code: 0 });
                    return;
                }
                if (geoModal) {
                    geoModal.removeAttribute('hidden');
                    geoModal.classList.add('is-visible');
                    geoModal.setAttribute('data-state', 'loading');
                }

                // iOS Home Screen (standalone) PWAs frequently never fire a
                // getCurrentPosition callback and silently ignore
                // options.timeout, stranding this modal on "Finding you…"
                // forever (works fine in normal Safari). watchPosition DOES
                // deliver a first fix in that same standalone context, so we
                // make it the primary path: start a watch, take the first
                // fix, then clear it. We also fire a one-shot
                // getCurrentPosition in parallel (whichever answers first
                // wins) and keep an absolute hard-stop so the user can never
                // hang — they always land on an actionable screen.
                var geoSettled = false;
                var geoWatchId = null;
                var geoHardStop = null;

                function stopGeoWatch() {
                    if (geoWatchId !== null) {
                        try { navigator.geolocation.clearWatch(geoWatchId); } catch (e) {}
                        geoWatchId = null;
                    }
                }
                function clearGeoTimers() {
                    if (geoHardStop) { clearTimeout(geoHardStop); geoHardStop = null; }
                }
                function onWalkGeoOk(pos) {
                    if (geoSettled) return;
                    geoSettled = true;
                    stopGeoWatch();
                    clearGeoTimers();
                    closeWalkGeoModal();
                    startWalkSession(pos.coords.latitude, pos.coords.longitude);
                }
                function onWalkGeoFail(err) {
                    if (geoSettled) return;
                    geoSettled = true;
                    stopGeoWatch();
                    clearGeoTimers();
                    showWalkGeoError(err);
                }

                // Primary: watchPosition — resolves reliably on iOS standalone.
                try {
                    geoWatchId = navigator.geolocation.watchPosition(onWalkGeoOk, function (err) {
                        // A hard permission denial (code 1) is final — surface
                        // it at once. Transient errors (timeout/unavailable)
                        // are swallowed; the hard-stop below is our safety net.
                        if (err && err.code === 1) {
                            onWalkGeoFail(err);
                        }
                    }, geoOpts);
                } catch (e) {
                    onWalkGeoFail({ code: 2 });
                    return;
                }

                // Belt-and-braces one-shot in parallel — first answer wins.
                try {
                    navigator.geolocation.getCurrentPosition(onWalkGeoOk, function (err) {
                        if (err && err.code === 1) { onWalkGeoFail(err); }
                    }, geoOpts);
                } catch (e) {}

                // Absolute hard-stop so "Finding you…" can never hang forever.
                geoHardStop = setTimeout(function () {
                    onWalkGeoFail({ code: 3 });
                }, geoOpts.timeout + 6000);
            }

            function wireSpinWalkEarnButton() {
                document.querySelectorAll('#spinWalkEarnBtn, #spinAuthedCtaWalkBtn').forEach(function (walkBtn) {
                    if (walkBtn.__walkEarnWired) {
                        return;
                    }
                    walkBtn.__walkEarnWired = true;
                    walkBtn.addEventListener('click', function () {
                        requestWalkLocation();
                    });
                });
            }
            window.pingLandingRequestWalkLocation = requestWalkLocation;
            window.wireSpinWalkEarnButton = wireSpinWalkEarnButton;
            wireSpinWalkEarnButton();

            if (geoClose) {
                geoClose.addEventListener('click', closeWalkGeoModal);
            }
            if (hudStop) {
                hudStop.addEventListener('click', stopWalkSession);
            }
            if (walkIdlePromptYes) {
                walkIdlePromptYes.addEventListener('click', confirmWalkIdleStop);
            }
            if (walkIdlePromptNo) {
                walkIdlePromptNo.addEventListener('click', dismissWalkIdlePrompt);
            }
        })();

        btnCloseX.addEventListener('click', closeModal);

        // ── Inline avatar-upload prompt (intro modal only) ──
        // Rendered by public/partials/spin-avatar-prompt.blade.php for
        // any authed viewer. Two modes, set on the partial root via
        // data-spin-avatar-mode and branched on here:
        //   forced → no avatar_url yet. We apply .is-avatarprompt to
        //            the intro .spin-body synchronously (before
        //            showIntro() fires) so the Spin CTA never flashes;
        //            the modal animates in already showing this prompt
        //            and there's no Cancel affordance.
        //   optin  → user already has an avatar. The partial stays
        //            dormant (no body modifier applied on load) until
        //            they click their avatar image in the top-left
        //            pill, which carries data-spin-avatar-change and
        //            triggers the open handler further down. Cancel
        //            backs out to whatever was on screen before.
        // The whole block is a no-op for guests (partial not rendered).
        (function spinAvatarInit() {
            var introBody = document.querySelector('#spinIntroModal .spin-body.spin-intro-body');
            if (!introBody) return;
            var prompt = introBody.querySelector('.spin-avatar-prompt');
            if (!prompt) return;

            // Two modes, set by the partial based on avatar_url:
            //   forced → no avatar yet, auto-show the prompt on load
            //            (the onboarding gate kept from the original flow).
            //   optin  → user already has an avatar; the prompt sits
            //            dormant until they click their avatar in the
            //            top-left pill, which fires data-spin-avatar-change.
            var mode = prompt.getAttribute('data-spin-avatar-mode') || 'forced';

            // Jutdee: never force avatar/verify onboarding — territories is home.
            // Opt-in avatar change from the nav pill still works below.
            if (mode === 'forced' && !(PL && PL.isJutdeeTenant)) {
                // Apply the modifier synchronously so no Spin CTA flicker
                // happens between DOMContentLoaded and the 1s showIntro timer.
                introBody.classList.add('is-avatarprompt');
                var forcedBanner = document.getElementById('spinCelebrateBanner');
                if (forcedBanner) {
                    forcedBanner.innerHTML = '';
                    forcedBanner.hidden = true;
                    forcedBanner.removeAttribute('data-spin-slide-carousel');
                }
                kickJutdeeOnboardingIfPending();
                syncJutdeeOnboardingScrim();
            }

            var tileBtn     = prompt.querySelector('[data-spin-avatar-pick]');
            var fileInput   = prompt.querySelector('[data-spin-avatar-input]');
            var uploadErrEl = prompt.querySelector('[data-spin-avatar-error]');
            var dismissBtn  = prompt.querySelector('[data-spin-avatar-dismiss]');
            var uploadUrl   = prompt.getAttribute('data-spin-avatar-url') || '';

            var jutdeeCropShell = document.getElementById('spinJutdeeAvatarCropMount');
            var useJutdeeCropModal = !!jutdeeCropShell;
            var cropMount   = useJutdeeCropModal
                ? jutdeeCropShell.querySelector('[data-spin-avatar-crop-mount]')
                : prompt.querySelector('[data-spin-avatar-crop-mount]');
            var cropErrEl   = useJutdeeCropModal
                ? jutdeeCropShell.querySelector('[data-spin-avatar-crop-error]')
                : uploadErrEl;
            var cancelBtn   = useJutdeeCropModal
                ? jutdeeCropShell.querySelector('[data-spin-avatar-cancel]')
                : prompt.querySelector('[data-spin-avatar-cancel]');
            var applyBtn    = useJutdeeCropModal
                ? jutdeeCropShell.querySelector('[data-spin-avatar-apply]')
                : prompt.querySelector('[data-spin-avatar-apply]');

            var cropper       = null;
            var webpSupported = null; // lazy-probed on first Apply.

            function setUploadError(msg) {
                if (!uploadErrEl) return;
                uploadErrEl.textContent = msg || '';
            }

            function setCropError(msg) {
                if (!cropErrEl) return;
                cropErrEl.textContent = msg || '';
            }

            function hideJutdeeCropModal() {
                if (!useJutdeeCropModal || !jutdeeCropShell) return;
                jutdeeCropShell.classList.remove('is-revealed');
                jutdeeCropShell.setAttribute('aria-hidden', 'true');
                var introCard = document.getElementById('spinIntroCard');
                if (introCard) introCard.classList.remove('spin-jutdee-onboarding-upload-hidden');
            }

            function showJutdeeCropModal() {
                if (!useJutdeeCropModal || !jutdeeCropShell) return;
                var introCard = document.getElementById('spinIntroCard');
                if (introCard) introCard.classList.add('spin-jutdee-onboarding-upload-hidden');
                jutdeeCropShell.classList.add('is-revealed');
                jutdeeCropShell.setAttribute('aria-hidden', 'false');
            }

            // Probe once: some older Safari versions silently fall back
            // to PNG when asked for image/webp. PNG is still accepted by
            // the server (the regex on UserController@uploadAvatar allows
            // jpeg/png/webp), but PNG dataURLs are much larger than webp,
            // so we prefer an explicit jpeg/0.75 when webp is missing.
            function supportsWebp() {
                if (webpSupported !== null) return webpSupported;
                try {
                    var c = document.createElement('canvas');
                    c.width = 2; c.height = 2;
                    webpSupported = c.toDataURL('image/webp').indexOf('data:image/webp') === 0;
                } catch (e) {
                    webpSupported = false;
                }
                return webpSupported;
            }

            // Cropper.js lazy-loader (CDN 1.5.12, same as the rest of the
            // app). Guarded on window.__cropperJsLoadPromise so any other
            // component that appears on the landing page in future gets
            // the single shared load without double-inserting tags.
            function loadCropperJS() {
                if (window.__cropperJsLoadPromise) return window.__cropperJsLoadPromise;
                window.__cropperJsLoadPromise = new Promise(function(resolve, reject) {
                    if (typeof window.Cropper === 'function') { resolve(); return; }
                    var link = document.createElement('link');
                    link.rel  = 'stylesheet';
                    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.12/cropper.min.css';
                    document.head.appendChild(link);
                    var script = document.createElement('script');
                    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.12/cropper.min.js';
                    script.onload  = function() { resolve(); };
                    script.onerror = function() {
                        window.__cropperJsLoadPromise = null;
                        reject(new Error('cropper load failed'));
                    };
                    document.head.appendChild(script);
                });
                return window.__cropperJsLoadPromise;
            }

            function showEmptyState() {
                if (cropper) { try { cropper.destroy(); } catch (e) {} cropper = null; }
                if (cropMount) cropMount.innerHTML = '';
                prompt.classList.remove('is-cropping');
                hideJutdeeCropModal();
                setUploadError('');
                setCropError('');
                if (fileInput) fileInput.value = '';
            }

            function showCropState(dataUrl) {
                if (useJutdeeCropModal) {
                    prompt.classList.remove('is-cropping');
                    showJutdeeCropModal();
                } else {
                    prompt.classList.add('is-cropping');
                }
                setCropError('');

                if (!cropMount) return;
                cropMount.innerHTML = '';
                var img = new Image();
                img.onload = function() {
                    cropMount.innerHTML = '';
                    cropMount.appendChild(img);
                    try {
                        cropper = new window.Cropper(img, {
                            aspectRatio: 1,
                            viewMode: 1,
                            dragMode: 'move',
                            autoCropArea: 1,
                            restore: false,
                            guides: true,
                            center: true,
                            highlight: false,
                            cropBoxMovable: true,
                            cropBoxResizable: true,
                            toggleDragModeOnDblclick: false
                        });
                    } catch (e) {
                        setCropError(PL && PL.netErr ? PL.netErr : 'Could not initialise image editor.');
                        showEmptyState();
                    }
                };
                img.onerror = function() {
                    setCropError('Could not load that image.');
                    showEmptyState();
                };
                img.src = dataUrl;
            }

            // Tile click → open the file picker.
            if (tileBtn) {
                tileBtn.addEventListener('click', function() {
                    if (fileInput) fileInput.click();
                });
            }

            // File chosen → validate, read as dataURL, lazy-load Cropper
            // and enter the crop state.
            if (fileInput) {
                fileInput.addEventListener('change', function(e) {
                    var file = e.target.files && e.target.files[0];
                    if (!file) return;
                    if (!/^image\//.test(file.type)) {
                        setUploadError('Please choose an image file.');
                        fileInput.value = '';
                        return;
                    }
                    if (file.size > 10 * 1024 * 1024) {
                        setUploadError('Image must be smaller than 10 MB.');
                        fileInput.value = '';
                        return;
                    }
                    setUploadError('');
                    var reader = new FileReader();
                    reader.onload = function(ev) {
                        var dataUrl = ev.target.result;
                        loadCropperJS().then(function() {
                            showCropState(dataUrl);
                        }).catch(function() {
                            setUploadError(PL && PL.netErr ? PL.netErr : 'Could not load image editor.');
                        });
                    };
                    reader.onerror = function() { setUploadError('Could not read that file.'); };
                    reader.readAsDataURL(file);
                });
            }

            // Cancel → destroy cropper, reset to the empty tile state.
            if (cancelBtn) {
                cancelBtn.addEventListener('click', function() {
                    showEmptyState();
                    if (useJutdeeCropModal && fileInput) {
                        fileInput.click();
                    }
                });
            }

            // Apply → encode the crop as webp/0.75 (or jpeg/0.75 fallback)
            // and POST to user.avatar.upload. On success: fire confetti,
            // toast, reload. Reuses msFireConfettiBurst + showToast from
            // the same IIFE scope — no new globals, no new deps.
            if (applyBtn) {
                applyBtn.addEventListener('click', function() {
                    if (!cropper) return;
                    if (!uploadUrl) { setCropError('Upload URL missing.'); return; }
                    applyBtn.disabled  = true;
                    if (cancelBtn) cancelBtn.disabled = true;
                    setCropError('');

                    var canvas;
                    try {
                        canvas = cropper.getCroppedCanvas({
                            width: 512,
                            height: 512,
                            imageSmoothingEnabled: true,
                            imageSmoothingQuality: 'high'
                        });
                    } catch (e) { canvas = null; }
                    if (!canvas) {
                        setCropError('Could not encode your image. Try a different file.');
                        applyBtn.disabled  = false;
                        if (cancelBtn) cancelBtn.disabled = false;
                        return;
                    }

                    var mime = supportsWebp() ? 'image/webp' : 'image/jpeg';
                    var dataUrl = canvas.toDataURL(mime, 0.75);

                    var CSRF = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
                    fetch(uploadUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': CSRF,
                            'Accept': 'application/json'
                        },
                        credentials: 'same-origin',
                        body: JSON.stringify({ avatar: dataUrl })
                    })
                    .then(function(r) { return r.json().then(function(d) { return { status: r.status, data: d }; }); })
                    .then(function(res) {
                        if (res.status >= 400 || !res.data || res.data.success === false) {
                            var msg = (res.data && (res.data.message || res.data.error)) || '';
                            if (!msg && PL && PL.netErr) msg = PL.netErr;
                            setCropError(msg || 'Upload failed. Please try again.');
                            applyBtn.disabled  = false;
                            if (cancelBtn) cancelBtn.disabled = false;
                            return;
                        }

                        // Success. Fire the confetti celebration using
                        // the same shim-aware retry loop as the spin-win
                        // path; show the toast; reload after 1.2s so the
                        // pill picks up the new avatar, the prompt stops
                        // rendering, and the Spin CTA is restored.
                        var tries = 0;
                        (function confettiLoop() {
                            msFireConfettiBurst();
                            if (tries++ < 6) setTimeout(confettiLoop, 200);
                        })();

                        var rewardGiven = !!(res.data && res.data.avatar_reward);
                        var toastMsg = rewardGiven
                            ? 'Nice pic! +5 Lenses'
                            : 'Nice pic! Verify Your Email To Get 5 Lenses.';
                        showToast(toastMsg, 1200);

                        setTimeout(function() {
                            window.location.reload();
                        }, 1200);
                    })
                    .catch(function() {
                        setCropError(PL && PL.netErr ? PL.netErr : 'Network error. Please try again.');
                        applyBtn.disabled  = false;
                        if (cancelBtn) cancelBtn.disabled = false;
                    });
                });
            }

            // ── Opt-in open/dismiss handlers ──
            // Opening: the avatar <img> in the top-left pill carries
            // data-spin-avatar-change. We bind a direct click listener
            // (not delegated) so stopPropagation works cleanly — the
            // parent <button class="spin-auth-btn"> has an inline
            // onclick="toggleSpinAuthMenu" that would otherwise also
            // fire on bubble and open the dropdown behind the panel.
            // Enter/Space on the img (role="button" tabindex="0") opens
            // the panel too so it stays keyboard accessible.
            //
            // Dismissing: the Cancel button inside the prompt (only
            // rendered in optin mode) restores whichever bottom-section
            // state was visible before we took over — the verify prompt
            // if the user still needs to verify, otherwise the default
            // Spin CTA. We also reset any mid-crop state so the next
            // open starts from the empty tile.
            function spinAvatarOpen() {
                // If the verify prompt was active, remember to restore
                // it when the user cancels out of the avatar panel.
                prompt.__verifyWasActive = introBody.classList.contains('is-verifyprompt');
                introBody.classList.remove('is-verifyprompt');
                introBody.classList.add('is-avatarprompt');
                if (typeof window.hideSpinIntroCarouselBanner === 'function') {
                    window.hideSpinIntroCarouselBanner();
                }
                syncJutdeeOnboardingScrim();
                // Close the pill dropdown if the avatar-click arrived
                // while it was open (keyboard users).
                document.querySelectorAll('.spin-auth-dropdown.open').forEach(function(d) {
                    d.classList.remove('open');
                    var b = d.querySelector('.spin-auth-btn');
                    if (b) b.setAttribute('aria-expanded', 'false');
                });
            }
            function spinAvatarDismiss() {
                showEmptyState();
                introBody.classList.remove('is-avatarprompt');
                if (prompt.__verifyWasActive) {
                    introBody.classList.add('is-verifyprompt');
                }
                prompt.__verifyWasActive = false;
                if (typeof window.syncSpinIntroSlideBanner === 'function') {
                    window.syncSpinIntroSlideBanner();
                }
                if (document.getElementById('spinJutdeeAuthedCtaMount')) {
                    if (typeof window.restoreAuthedJutdeePlaySurface === 'function') {
                        window.restoreAuthedJutdeePlaySurface();
                    }
                }
                syncJutdeeOnboardingScrim();
            }

            // Bind only to avatar images inside the intro modal: the
            // pill partial is included twice (once per modal) but the
            // avatar prompt only lives in the intro body, so clicks
            // from the result modal's pill would have no visible
            // effect. Leaving the result-modal avatar as a plain open
            // menu target matches user expectation when they're in
            // the middle of a spin result flow.
            document.querySelectorAll('#spinIntroModal [data-spin-avatar-change]').forEach(function(img) {
                img.addEventListener('click', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    spinAvatarOpen();
                });
                img.addEventListener('keydown', function(e) {
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                        e.stopPropagation();
                        e.preventDefault();
                        spinAvatarOpen();
                    }
                });
            });

            if (dismissBtn) {
                dismissBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    spinAvatarDismiss();
                });
            }
        })();

        // ── Inline email-verify prompt (intro modal only) ──
        // Rendered by public/partials/spin-verify-prompt.blade.php when
        // the viewer is authed, has an avatar_url, and has not yet
        // verified their email (or just returned from the verify link
        // with the reward flash). Uses its own body modifier,
        // .is-verifyprompt, which is independent of .is-avatarprompt
        // so the two prompts can coexist in the DOM and the user can
        // swap between them without either clobbering the other.
        (function spinVerifyInit() {
            var introBody = document.querySelector('#spinIntroModal .spin-body.spin-intro-body');
            if (!introBody) return;
            var prompt = introBody.querySelector('.spin-verify-prompt');
            if (!prompt) return;

            // Applied synchronously so the modal animates in already
            // showing this prompt rather than flashing the Spin CTA.
            // Jutdee: skip — territories is home; no verify interrupt.
            if (!(PL && PL.isJutdeeTenant)) {
                introBody.classList.add('is-verifyprompt');
                kickJutdeeOnboardingIfPending();
                syncJutdeeOnboardingScrim();
            }

            var sendUrl = prompt.getAttribute('data-spin-verify-url') || '';
            var errEl   = prompt.querySelector('[data-spin-verify-error]');
            var btn     = prompt.querySelector('[data-spin-verify-send]');
            // If the server-rendered state is the non-clickable "sent <3h
            // ago" variant, there's no button wired for sending. Nothing
            // else to bind — the user just waits for the email.
            if (!btn) return;

            function setError(msg) {
                if (!errEl) return;
                errEl.textContent = msg || '';
            }

            function getCsrfToken() {
                // Prefer a meta tag (standard Laravel pattern); fall back
                // to any globally exposed token set by an earlier script.
                var meta = document.querySelector('meta[name="csrf-token"]');
                if (meta) return meta.getAttribute('content') || '';
                return (typeof window !== 'undefined' && window.dashboardCsrfToken) || '';
            }

            // Original button label so we can restore it on error after
            // flipping to a sending/failed state.
            var originalHTML = btn.innerHTML;

            function verifyL10n(key, fallback) {
                var val = (window.__pingL10n || {})[key];
                return (val !== undefined && val !== null && String(val).trim() !== '')
                    ? String(val)
                    : fallback;
            }

            btn.addEventListener('click', function(e) {
                e.preventDefault();
                if (btn.classList.contains('sending')) return;

                setError('');
                btn.classList.add('sending');
                btn.classList.remove('unverified', 'verify-pending', 'verified', 'sent', 'failed');
                btn.disabled = true;
                btn.innerHTML = '<i class="bi bi-hourglass-split" aria-hidden="true"></i><span>'
                    + verifyL10n('verifySending', 'Sending Email…') + '</span>';

                fetch(sendUrl, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'X-CSRF-TOKEN': getCsrfToken(),
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                .then(function(r) {
                    if (!r.ok) throw new Error('HTTP ' + r.status);
                    return r.json();
                })
                .then(function(data) {
                    if (data && data.status === 'already-verified') {
                        // Rare edge case: the user verified in another tab
                        // while this one was open. Flash green, then reload
                        // so the partial gate excludes them and they get
                        // the normal Spin CTA.
                        btn.classList.remove('sending');
                        btn.classList.add('verified');
                        btn.innerHTML = '<i class="bi bi-patch-check-fill" aria-hidden="true"></i><span>'
                            + verifyL10n('verified', 'Verified') + '</span>';
                        btn.disabled = true;
                        setTimeout(function() { window.location.reload(); }, 900);
                        return;
                    }
                    if (data && data.status === 'verification-link-sent') {
                        // Brief "Sent!" acknowledgement, then settle into
                        // the same orange "Verify Now, Check Your Email"
                        // state that the server would render on reload.
                        btn.classList.remove('sending');
                        btn.classList.add('sent');
                        btn.innerHTML = '<i class="bi bi-envelope-check-fill" aria-hidden="true"></i><span>'
                            + verifyL10n('verifySentSpam', 'Sent, Please Check Your Spam!') + '</span>';
                        setTimeout(function() {
                            btn.classList.remove('sent');
                            btn.classList.add('verify-pending');
                            btn.innerHTML = '<i class="bi bi-envelope-exclamation-fill" aria-hidden="true"></i><span>'
                                + verifyL10n('verifyCheckEmail', 'Verify Now, Check Your Email') + '</span>';
                            btn.disabled = true;
                            btn.setAttribute('aria-disabled', 'true');
                            btn.style.cursor = 'default';
                        }, 3000);
                        return;
                    }
                    throw new Error('Unexpected response: ' + JSON.stringify(data || {}));
                })
                .catch(function(err) {
                    if (console && console.error) console.error('Verify email send failed:', err);
                    btn.classList.remove('sending');
                    btn.classList.add('failed');
                    btn.innerHTML = originalHTML;
                    btn.disabled = false;
                    setError(verifyL10n('verifySendFail', 'Could not send verification email. Please try again.'));
                    // After a beat, drop the failed class so the user can
                    // re-attempt with the original pulsing-red affordance.
                    setTimeout(function() {
                        btn.classList.remove('failed');
                        if (btn.getAttribute('data-spin-verify-state') === 'unverified') {
                            btn.classList.add('unverified');
                        } else {
                            btn.classList.add('verify-pending');
                        }
                    }, 2500);
                });
            });
        })();

        // ── Post-verification reward celebration ──
        // When CustomEmailVerificationController::verify() redirects to
        // '/' after a successful first-time email verification, it flashes
        // verification_reward to the session. The blade renders two things
        // in response:
        //   (a) spin-verify-prompt in its .is-verified "success" state,
        //       with the "Verification Successful" title + description
        //       already baked into the card's bottom section;
        //   (b) a hidden [data-spin-verify-reward] sentinel here, which
        //       tells us to fire the same confetti burst as showWinCongrats.
        // After a brief "Verified" hold we run a 3-2-1 countdown inside
        // the success pill and then reload, so the user lands on the
        // normal Spin-globe view (the flash is consumed on reload, which
        // makes the verify partial emit nothing and yields the default
        // CTA title + description). No toast; the copy lives in the card.
        // Post-claim celebration.
        // When the result modal's "Back To Home" button fires we
        // redirect to /?celebrate=1&place=<Name> so the user lands
        // back on the hero (where the newly updated Lens + Aura
        // balances slam in) rather than /aura. This init:
        //   1. shows "[Place] Has Been Added / To Your Territories" in
        //      #spinCelebrateBanner (fixed over the map, outside the
        //      intro modal),
        //   2. fires one more confetti burst on top of the balance
        //      slams,
        //   3. clears the banner after the burst so the hero returns to
        //      its normal state without a full page reload.
        // The celebrate+place params are stripped from the address
        // bar via replaceState() as soon as we've read them so a
        // manual refresh doesn't replay the party.
        (function spinCelebrateInit() {
            var params;
            try { params = new URLSearchParams(window.location.search); }
            catch (e) { return; }

            var noFreeSlots = params.get('no_free_slots') === '1';
            var celebrateWin = params.get('celebrate') === '1';
            if (!noFreeSlots && !celebrateWin) return;

            var place = (params.get('place') || '').trim();

            // Clean the URL before doing anything observable.
            try {
                params.delete('no_free_slots');
                params.delete('celebrate');
                params.delete('place');
                var qs = params.toString();
                var clean = window.location.pathname + (qs ? ('?' + qs) : '') + window.location.hash;
                window.history.replaceState(null, '', clean);
            } catch (e) {}

            if (noFreeSlots) {
                // This overlay owns the modal for the rest of this page
                // load — see __pingCelebrateTakeover note below.
                window.__pingCelebrateTakeover = true;
                showSpinCelebrateNoFreeSlots();
                return;
            }

            runTerritoryCelebrateBanner(place);
            if (document.getElementById('spinJutdeeAuthedCtaMount')
                && typeof window.pingLandingReturnToTerritoriesModal === 'function') {
                // Claim @ ping-landing win reloads to /?celebrate=1 and lands
                // here, opening the territories modal (intro slide 2). The
                // globe-framing fly-in that runs on every load resolves ~2s
                // later and, on `moveend`, calls revealJutdeeTenantLanding()
                // to bring up the DEFAULT play-menu CTA — which clobbered this
                // territories modal after a few seconds (raced the overlay's
                // 0/150/400ms reassert retries, so it only bit "sometimes").
                // Flag that a celebrate has taken over the modal so those
                // on-load auto-reveals stand down for this page load. Only set
                // it when the territories modal actually opened (authed CTA
                // present) — guests get only the banner and still need their
                // normal landing revealed.
                window.__pingCelebrateTakeover = true;
                window.pingLandingReturnToTerritoriesModal();
            }
        })();

        (function spinVerifyRewardInit() {
            var el = document.querySelector('[data-spin-verify-reward]');
            if (!el) return;

            // Retry loop matches showWinCongrats() so the burst still
            // lands if canvas-confetti hasn't finished loading yet.
            var tries = 0;
            (function loop() {
                msFireConfettiBurst();
                if (tries++ < 6) setTimeout(loop, 200);
            })();

            // Remove the sentinel so a subsequent in-page navigation
            // (e.g. pushState) can't re-trigger the celebration.
            if (el.parentNode) el.parentNode.removeChild(el);

            // 3-2-1 countdown inside the success pill, then reload. The
            // 600ms head-start keeps the "Verified" copy on screen long
            // enough to register as the outcome before the text starts
            // moving — otherwise the confirmation feels rushed. Falls
            // back to a plain reload if the pill isn't in the DOM (e.g.
            // user has no avatar, so the avatar partial took the slot).
            var countdownEl = document.querySelector('[data-spin-verify-countdown]');
            if (!countdownEl) {
                setTimeout(function() { window.location.reload(); }, 3200);
                return;
            }
            var count = 3;
            setTimeout(function tick() {
                if (count < 1) {
                    window.location.reload();
                    return;
                }
                var continuingFmt = PL.verifyContinuingFmt || 'Continuing in :count…';
                countdownEl.textContent = continuingFmt.replace(':count', String(count));
                count -= 1;
                setTimeout(tick, 1000);
            }, 600);
        })();

        // Delay the first paint of the intro modal by 1 second so the
        // ambient globe is visible and rotating for a beat before the
        // card flies in — establishes the setting ("we're on a spinning
        // Earth") before the CTA asks the user to interact with it.
        // Only the initial paint is delayed; closeModal/abortSpin still
        // call showIntro() synchronously so returning from a spin feels
        // immediate rather than sluggish.
        if (document.getElementById('spinIntroAuthedCarouselViewport')) {
            if (!document.getElementById('spinJutdeeAuthedCtaMount')) {
                setTimeout(showIntro, 1000);
            }
        }
        modal.addEventListener('click', function(e) {
            if (e.target !== modal) return;
            // Territory-claimed celebration (.spin-card.won): the × close is
            // hidden in CSS — only #spinModalEnterAura should dismiss, not
            // a stray click on the dimmed backdrop.
            if (spinCardEl && spinCardEl.classList.contains('won')) return;
            closeModal();
        });
        (function wireJutdeeSpinScrimClick() {
            var frost = document.getElementById('spinModalJutdeeScrimFrost');
            if (!frost) return;
            frost.addEventListener('click', function () {
                if (spinCardEl && spinCardEl.classList.contains('won')) return;
                closeModal();
            });
        })();
        document.addEventListener('keydown', function(e) {
            if (e.key !== 'Escape') return;
            // Escape closes the inline auth panel first if one is open —
            // users expect it to back them out to the card's original
            // content before any higher-level modal dismissal fires.
            var openPanel = document.querySelector('.spin-body.is-authpanel');
            if (openPanel) {
                // If the panel is open on top of a pending game win,
                // Esc should also tear the game session down so the
                // globe resumes — matching the old "Maybe later"
                // button behaviour on the retired #msAuthModal.
                var _escStash = (window.GamifEYEDGame && window.GamifEYEDGame.getPendingClaim)
                    ? window.GamifEYEDGame.getPendingClaim()
                    : null;
                if (_escStash && _escStash.cp_id) {
                    spinAuthClose(openPanel);
                    closeMsAndResume();
                    return;
                }
                spinAuthClose(openPanel);
                return;
            }
            if (msGameOverEl && msGameOverEl.classList.contains('visible')) { msGameOverEl.classList.remove('visible'); closeMsAndResume(); return; }
            if (floodGameOverEl && floodGameOverEl.classList.contains('visible')) { floodGameOverEl.classList.remove('visible'); closeMsAndResume(); return; }
            // A scaffolded game is active — drop into shared
            // teardown via the base module (calls the game's
            // onTeardown, then bounces through closeMsAndResume
            // on the way out).
            if (window.GamifEYEDGame && window.GamifEYEDGame.getActiveSlug()) {
                window.GamifEYEDGame.closeAndResume();
                return;
            }
            if (modal.classList.contains('visible')) {
                if (spinCardEl && spinCardEl.classList.contains('won')) return;
                closeModal();
            }
        });

        // Closure-scoped references to the map overlays
        // pingLandingFocusOnGamifeye adds. Held here (not inside the
        // focus function) so the detail-modal close handler can tear
        // them down when the user dismisses the card and flies back
        // to the globe.
        var lastGfeMarker = null;

        // ─── Branch-stamps display layer ────────────────────────────
        // Display-only mirror of the subdomain branch-stamps mechanic
        // (challenge-mission-v2.blade.php) ported to the ping-landing
        // focal-point fly-in. The user is browsing remotely from the
        // homepage, so we never wire collect / poll here — we just
        // paint the same green-circle markers the subdomain map shows
        // so the player can SEE which slots are open this week before
        // they decide to physically travel to the place.
        //
        // Source/layer ids are intentionally distinct from the
        // subdomain map's `branch-stamps-v2-*` ids so that if a
        // future flow ever mounts both maps in the same DOM (e.g.
        // an embedded mini-preview) they don't collide.
        //
        // Globally-claimed slots are filtered server-side by the
        // /api/branch-stamps/{branchId} endpoint via
        // `globally_claimed_keys` and dropped here before the
        // GeoJSON ever hits MapLibre, so the same FCFS visibility
        // rule applies on this surface as on the subdomain map.
        var PING_BRANCH_STAMPS_SOURCE_ID = 'ping-branch-stamps';
        var PING_BRANCH_STAMPS_LAYER_CIRCLE = 'ping-branch-stamps-circle';
        var PING_BRANCH_STAMPS_LAYER_ICON   = 'ping-branch-stamps-icon';
        var _pingBranchStampsBranchId = null;
        var _pingBranchStampsAbort    = null;

        function branchStampsEnabledFromPayload(payload) {
            if (!payload) return true;
            if (payload.is_branch_stamps_enabled === false) return false;
            if (payload.is_branch_stamps_enabled === 0 || payload.is_branch_stamps_enabled === '0') return false;
            return true;
        }

        function syncPingMapStampsForLocation(locId, enabled) {
            if (String(_branchActiveBranchId) !== String(locId)) return;
            if (enabled) {
                renderPingBranchStampsForBranch(locId);
            } else {
                clearPingBranchStamps();
            }
        }
        window.__branchStampsEnabledFromPayload = branchStampsEnabledFromPayload;
        window.__syncPingMapStampsForLocation = syncPingMapStampsForLocation;

        function renderPingBranchStampsForBranch(branchId, payloadHint) {
            if (!branchId || !map) return;
            if (payloadHint && !branchStampsEnabledFromPayload(payloadHint)) {
                clearPingBranchStamps();
                return;
            }
            // Cancel any in-flight fetch for a different branch — the
            // user may have flown out and into another focal point
            // before the first response landed.
            if (_pingBranchStampsAbort) {
                try { _pingBranchStampsAbort.abort(); } catch (e) {}
                _pingBranchStampsAbort = null;
            }
            _pingBranchStampsBranchId = branchId;

            var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
            _pingBranchStampsAbort = ctrl;
            var fetchOpts = {
                headers: { 'Accept': 'application/json' },
                credentials: 'same-origin'
            };
            if (ctrl) fetchOpts.signal = ctrl.signal;

            fetch('/api/branch-stamps/' + encodeURIComponent(String(branchId)), fetchOpts)
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (data) {
                    // Race guard: if the user clicked a different focal
                    // point while this fetch was in flight, the active
                    // branch id will have moved on. Drop the stale
                    // result rather than painting stamps for a place
                    // the camera no longer points at.
                    if (!data || _pingBranchStampsBranchId !== branchId) return;

                    var layout = Array.isArray(data.layout) ? data.layout : [];
                    var hidden = Array.isArray(data.globally_claimed_keys)
                        ? data.globally_claimed_keys
                        : [];
                    var hiddenSet = Object.create(null);
                    for (var i = 0; i < hidden.length; i++) hiddenSet[hidden[i]] = true;

                    var feats = [];
                    for (var j = 0; j < layout.length; j++) {
                        var s = layout[j];
                        if (hiddenSet[s.stamp_key]) continue;
                        feats.push({
                            type: 'Feature',
                            properties: { key: s.stamp_key },
                            geometry: { type: 'Point', coordinates: [s.lng, s.lat] }
                        });
                    }
                    var fc = { type: 'FeatureCollection', features: feats };

                    // Idempotent paint — replace data on a re-entry,
                    // add source + layers on first paint.
                    var existing = map.getSource(PING_BRANCH_STAMPS_SOURCE_ID);
                    if (existing) {
                        try { existing.setData(fc); } catch (e) {}
                        return;
                    }
                    try {
                        map.addSource(PING_BRANCH_STAMPS_SOURCE_ID, { type: 'geojson', data: fc });
                        map.addLayer({
                            id: PING_BRANCH_STAMPS_LAYER_CIRCLE,
                            type: 'circle',
                            source: PING_BRANCH_STAMPS_SOURCE_ID,
                            paint: {
                                'circle-radius': [
                                    'interpolate', ['linear'], ['zoom'],
                                    14, 4,
                                    17, 14,
                                    20, 36
                                ],
                                'circle-color': '#22c55e',
                                'circle-opacity': 0.28,
                                'circle-stroke-color': '#16a34a',
                                'circle-stroke-width': 1.5,
                                'circle-stroke-opacity': 0.85,
                                'circle-pitch-alignment': 'map'
                            }
                        });
                        map.addLayer({
                            id: PING_BRANCH_STAMPS_LAYER_ICON,
                            type: 'circle',
                            source: PING_BRANCH_STAMPS_SOURCE_ID,
                            paint: {
                                'circle-radius': [
                                    'interpolate', ['linear'], ['zoom'],
                                    14, 1.5,
                                    17, 4,
                                    20, 7
                                ],
                                'circle-color': '#ffffff',
                                'circle-stroke-color': '#16a34a',
                                'circle-stroke-width': 1.5,
                                'circle-pitch-alignment': 'viewport'
                            }
                        });
                    } catch (err) {
                        console.warn('[ping-branch-stamps] paint failed', err);
                    }
                    if (_pingMapDecorHidden) setPingMapDecorVisible(false);
                })
                .catch(function (err) {
                    // AbortError on a deliberate cancel is expected;
                    // anything else gets a debug breadcrumb but no
                    // user-facing toast — the surface is purely
                    // additive eye-candy, a silent fail is fine.
                    if (err && err.name === 'AbortError') return;
                    console.warn('[ping-branch-stamps] fetch failed', err);
                });
        }

        // Jutdee location manage modal: the frosted card owns the page, so
        // the h3 grid + stamp markers behind it are noise. Layers are
        // painted async (hex lib + stamp fetch), so a plain setLayoutProperty
        // at modal-open time can miss them — the flag below is re-applied by
        // both painters when they add layers late.
        var _pingMapDecorHidden = false;
        var PING_MAP_DECOR_LAYERS = [
            'branch-h3-fill', 'branch-h3-line', 'branch-h3-center-pulse',
            PING_BRANCH_STAMPS_LAYER_CIRCLE, PING_BRANCH_STAMPS_LAYER_ICON
        ];
        function setPingMapDecorVisible(visible) {
            _pingMapDecorHidden = !visible;
            var vis = visible ? 'visible' : 'none';
            if (!map) return;
            for (var i = 0; i < PING_MAP_DECOR_LAYERS.length; i++) {
                try {
                    if (map.getLayer(PING_MAP_DECOR_LAYERS[i])) {
                        map.setLayoutProperty(PING_MAP_DECOR_LAYERS[i], 'visibility', vis);
                    }
                } catch (e) { /* noop */ }
            }
        }
        window.__setPingMapDecorVisible = setPingMapDecorVisible;

        function clearPingBranchStamps() {
            _pingBranchStampsBranchId = null;
            if (_pingBranchStampsAbort) {
                try { _pingBranchStampsAbort.abort(); } catch (e) {}
                _pingBranchStampsAbort = null;
            }
            if (!map) return;
            try { if (map.getLayer(PING_BRANCH_STAMPS_LAYER_ICON))   map.removeLayer(PING_BRANCH_STAMPS_LAYER_ICON); }   catch (e) {}
            try { if (map.getLayer(PING_BRANCH_STAMPS_LAYER_CIRCLE)) map.removeLayer(PING_BRANCH_STAMPS_LAYER_CIRCLE); } catch (e) {}
            try { if (map.getSource(PING_BRANCH_STAMPS_SOURCE_ID))   map.removeSource(PING_BRANCH_STAMPS_SOURCE_ID); }   catch (e) {}
        }

        var _gfeFocalPulseRaf = null;

        function stopGfeFocalCenterPulse() {
            if (_gfeFocalPulseRaf) {
                try { cancelAnimationFrame(_gfeFocalPulseRaf); } catch (e) {}
                _gfeFocalPulseRaf = null;
            }
            try { if (map.getLayer('gfe-focal-center-pulse')) map.removeLayer('gfe-focal-center-pulse'); } catch (e) {}
        }

        function startGfeFocalCenterPulse() {
            if (_gfeFocalPulseRaf) {
                try { cancelAnimationFrame(_gfeFocalPulseRaf); } catch (e) {}
                _gfeFocalPulseRaf = null;
            }
            if (!map.getLayer('gfe-focal-center-pulse')) return;
            var pulseStart = Date.now();
            function tick() {
                if (!map.getLayer('gfe-focal-center-pulse')) {
                    _gfeFocalPulseRaf = null;
                    return;
                }
                var t = ((Date.now() - pulseStart) % 1200) / 1200;
                var wave = 0.5 + 0.5 * Math.sin(t * Math.PI * 2);
                try {
                    map.setPaintProperty('gfe-focal-center-pulse', 'line-width', 3 + wave * 4);
                    map.setPaintProperty('gfe-focal-center-pulse', 'line-opacity', 0.45 + wave * 0.55);
                    map.triggerRepaint();
                } catch (e) {}
                _gfeFocalPulseRaf = requestAnimationFrame(tick);
            }
            _gfeFocalPulseRaf = requestAnimationFrame(tick);
        }

        var _gfeCreatedBannerData = null;
        var _gfePostImportBannerTrip = 0;

        function dismissGfeImportBlockingOverlays() {
            try {
                var intro = document.getElementById('spinIntroModal');
                if (intro) intro.classList.remove('visible', 'is-flying-out');
            } catch (e) {}
            try {
                document.querySelectorAll('[data-gfe-add-modal]').forEach(function (el) {
                    el.classList.remove('is-open');
                    el.setAttribute('aria-hidden', 'true');
                    el.hidden = true;
                });
            } catch (e) {}
            try { document.body.classList.remove('gfe-add-modal-lock'); } catch (e) {}
        }

        function ensureGfeCreatedPanel() {
            var panel = document.getElementById('gfeCreatedPanel');
            if (panel) return panel;
            panel = document.createElement('div');
            panel.id = 'gfeCreatedPanel';
            panel.className = 'hello-location-panel';
            panel.setAttribute('aria-live', 'polite');
            panel.innerHTML =
                '<div class="hello-location-card">' +
                    '<p class="hello-mission-label" id="gfeCreatedMessage"></p>' +
                        '<button type="button" class="hello-location-btn" id="gfeCreatedSetupBtn">' +
                            (PL.clickHere || 'Click here') +
                        '</button>' +
                '</div>';
            document.body.appendChild(panel);
            return panel;
        }

        function normalizeGfeLocPayload(raw) {
            if (!raw) return null;
            if (raw.data && raw.data.id) raw = raw.data;
            if (!raw.id) return null;
            var out = {};
            for (var k in raw) {
                if (Object.prototype.hasOwnProperty.call(raw, k)) out[k] = raw[k];
            }
            out.id = raw.id;
            if (out.latitude == null && out.lat != null) out.latitude = out.lat;
            if (out.longitude == null && out.lng != null) out.longitude = out.lng;
            return out;
        }

        function resolvePostImportLocPayload() {
            var payload = normalizeGfeLocPayload(_gfeCreatedBannerData)
                || normalizeGfeLocPayload(_pingHeroFlyinData);
            if (payload) return payload;

            var panel = document.getElementById('gfeCreatedPanel');
            if (panel) {
                var raw = panel.getAttribute('data-gfe-created-payload');
                if (raw) {
                    try {
                        var parsed = normalizeGfeLocPayload(JSON.parse(raw));
                        if (parsed) return parsed;
                    } catch (e) { /* noop */ }
                }
            }

            var tiles = document.querySelectorAll('li.gfe-loc-item:not(.is-tour)[data-gfe-loc-id]');
            if (tiles.length) {
                var newest = tiles[0];
                try {
                    var tilePayload = normalizeGfeLocPayload(JSON.parse(newest.getAttribute('data-gfe-loc-payload') || '{}'));
                    if (tilePayload) return tilePayload;
                } catch (e2) { /* noop */ }
            }

            return null;
        }

        function openGfeEditFromPostImportFlyin(opts) {
            opts = opts || {};
            var payload = resolvePostImportLocPayload();
            if (!payload || !payload.id) {
                try {
                    window.alert('Could not open setup — please refresh the page and try the pencil icon on your location card.');
                } catch (alertErr) { /* noop */ }
                return false;
            }
            if (typeof window.openGfeEditModal !== 'function') {
                try {
                    window.alert('Setup editor is not available on this page. Please refresh and try again.');
                } catch (alertErr2) { /* noop */ }
                return false;
            }

            var jutdeeInline = !!(opts.jutdeeInline
                && typeof window.enterJutdeeLocationViewSetup === 'function'
                && document.getElementById('jutdeeLocationViewModal'));

            if (!jutdeeInline) {
                document.body.classList.add('is-gfe-import-flyin');
                var editModal = document.getElementById('gfeEditModal');
                if (editModal) editModal.classList.add('is-post-import-edit');
            }
            try {
                window.openGfeEditModal(payload, jutdeeInline
                    ? { jutdeeInline: true, jutdeeSection: 'address' }
                    : null);
            } catch (openErr) {
                console.error('[gfe-focus] openGfeEditModal failed', openErr);
                try {
                    window.alert('Could not open the setup editor. Please refresh and try again.');
                } catch (alertErr3) { /* noop */ }
                return false;
            }
            hideGfeCreatedBanner();
            return true;
        }
        window.openGfeEditFromPostImportFlyin = openGfeEditFromPostImportFlyin;

        function syncPostImportFocusCloseBtn() {
            var closeBtn = document.getElementById('pingFocusCloseBtn');
            if (!closeBtn) return;
            var setupPending = document.body.classList.contains('is-gfe-import-setup-pending');
            if (setupPending) {
                closeBtn.setAttribute('title', 'Complete setup');
                closeBtn.setAttribute('aria-label', 'Complete setup');
            } else if (document.body.classList.contains('is-gfe-import-flyin')) {
                closeBtn.setAttribute('title', 'Back to your locations');
                closeBtn.setAttribute('aria-label', 'Back to your locations');
            }
        }

        function exitGfeFlyinToItemView() {
            var locPayload = resolvePostImportLocPayload();
            if (locPayload && typeof window.appendPingFpLocationItem === 'function') {
                try { window.appendPingFpLocationItem(locPayload); } catch (appendErr) {}
            }
            document.body.classList.remove('is-gfe-focused');
            document.body.classList.remove('is-gfe-import-flyin');
            document.body.classList.remove('is-gfe-import-setup-pending');
            var editModal = document.getElementById('gfeEditModal');
            if (editModal) {
                editModal.classList.remove('is-post-import-edit');
            }
            clearSpinFlyinLocationTitle();
            clearPingHeroLocationImage();
            clearPingHeroEditBtn();
            clearPingHeroStampBtn();
            try { resetGfeMapOverlays(); } catch (err) {}
            try { restoreGlobeFraming(900); } catch (err) {}
            setTimeout(function () {
                try { showIntro(); } catch (e) {}
            }, 900);
        }
        window.exitGfeFlyinToItemView = exitGfeFlyinToItemView;

        function completePostImportSetupAfterSave() {
            if (!document.body.classList.contains('is-gfe-import-setup-pending')) {
                return;
            }
            document.body.classList.remove('is-gfe-import-setup-pending');
            var editModal = document.getElementById('gfeEditModal');
            if (editModal) {
                editModal.classList.remove('is-post-import-edit');
            }
            syncPostImportFocusCloseBtn();
        }
        window.completePostImportSetupAfterSave = completePostImportSetupAfterSave;

        function wireGfeCreatedSetupBtnOnce() {
            // Direct onclick on the button — survives re-renders and does
            // not depend on capture-phase ordering vs the map canvas.
            var setupBtn = document.getElementById('gfeCreatedSetupBtn');
            if (!setupBtn) return;
            setupBtn.onclick = function (e) {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                openGfeEditFromPostImportFlyin();
            };
        }

        function hideGfeCreatedBanner() {
            var panel = document.getElementById('gfeCreatedPanel');
            if (panel) {
                panel.classList.remove('active');
                panel.removeAttribute('data-gfe-created-payload');
            }
            _gfeCreatedBannerData = null;
        }

        function showGfeCreatedBanner(data) {
            data = normalizeGfeLocPayload(data);
            if (!data) return;
            dismissGfeImportBlockingOverlays();
            var panel = ensureGfeCreatedPanel();
            var msgEl = document.getElementById('gfeCreatedMessage');
            if (!msgEl) return;
            _gfeCreatedBannerData = data;
            try {
                panel.setAttribute('data-gfe-created-payload', JSON.stringify(data));
            } catch (storeErr) { /* noop */ }
            wireGfeCreatedSetupBtnOnce();
            var name = (data.title || data.name || 'GamifEYE').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            var createdFmt = PL.gfeCreatedSuccessFmt || ':name has been successfully created. Please click here to complete the setup and publish.';
            msgEl.innerHTML = createdFmt.replace(':name', '<strong>' + name + '</strong>');
            var setupBtn = document.getElementById('gfeCreatedSetupBtn');
            if (setupBtn) setupBtn.textContent = PL.clickHere || 'Click here';
            document.body.classList.add('is-gfe-import-flyin');
            panel.classList.add('active');
        }
        window.showGfeCreatedBanner = showGfeCreatedBanner;
        window.hideGfeCreatedBanner = hideGfeCreatedBanner;
        wireGfeCreatedSetupBtnOnce();

        function scheduleGfePostImportBanner(locData, flyMs) {
            var trip = ++_gfePostImportBannerTrip;
            var delay = (parseInt(flyMs, 10) || 4000) + 500;
            setTimeout(function () {
                if (trip !== _gfePostImportBannerTrip) return;
                try { showGfeCreatedBanner(locData); }
                catch (err) { console.warn('[gfe-focus] post-import banner failed', err); }
            }, delay);
        }

        function resetGfeMapOverlays() {
            if (lastGfeMarker) {
                try { lastGfeMarker.remove(); } catch(e) {}
                lastGfeMarker = null;
            }
            hideGfeCreatedBanner();
            stopGfeFocalCenterPulse();
            try { if (map.getLayer('gfe-focal-fill')) map.removeLayer('gfe-focal-fill'); } catch(e) {}
            try { if (map.getLayer('gfe-focal-line')) map.removeLayer('gfe-focal-line'); } catch(e) {}
            try { if (map.getSource('gfe-focal'))     map.removeSource('gfe-focal'); }    catch(e) {}
            // Also tear down the rich branch-h3 grid (slide-1 click flow)
            // so re-opening the focused view on a different focal point
            // starts clean. Layers/source guarded with getLayer/getSource
            // so the importer flow (which never adds them) is a cheap
            // no-op. State vars cleared too so isBranchHexAdjacent and
            // friends start from an empty world.
            stopBranchCenterHexPulse();
            try { if (map.getLayer('branch-h3-fill')) map.removeLayer('branch-h3-fill'); } catch(e) {}
            try { if (map.getLayer('branch-h3-line')) map.removeLayer('branch-h3-line'); } catch(e) {}
            try { if (map.getSource('branch-h3'))     map.removeSource('branch-h3'); }    catch(e) {}
            // Branch-stamps display layer — drop the circles when the
            // focal-point fly-in is exited so the next focus call
            // starts clean.
            clearPingBranchStamps();
            _branchSelectedHexes  = new Set();
            _branchZoneSet        = new Set();
            _branchAllHexSet      = new Set();
            _branchHexGeojson     = null;
            _branchCenterCell     = null;
            _branchActiveBranchId = null;
            _branchActiveAreaId   = null;
            _branchActiveCardEl   = null;
            _branchExpandInFlight = false;
        }
        // Exported for the jutdee location-view close path
        // (returnToFocalPointsFromLocationView) — without this the grid
        // + focus pin survive the return to the territories page.
        window.resetGfeMapOverlays = resetGfeMapOverlays;

        // ─────────────────────────────────────────────────────────────────
        // Slide-1 focal-point hex expansion
        // -----------------------------------------------------------------
        // Parallel copy of /focal-points' branch hex expansion flow
        // (resources/views/user/focal-points.blade.php L3611-L4999), ported
        // here so the in-place flyTo view (pingLandingFocusOnGamifeye
        // skipDetail:true) supports the same "click pink hex → select →
        // commit one lens per cell" mechanic. The /focal-points view is
        // not touched; this is a parallel copy to minimise risk to that
        // working flow. Both share the same POST endpoint
        // (POST /user-locations/{id}/expand-hexes) and the same
        // window.dashboardHexBalance global so the server-side rules
        // (1 lens per hex, balance gate, dedup, area auto-provision)
        // remain in one place.
        // ─────────────────────────────────────────────────────────────────
        var _branchSelectedHexes  = new Set();   // user-picked but not committed
        var _branchZoneSet        = new Set();   // server-owned res-9 hexes
        var _branchAllHexSet      = new Set();   // every cell currently in geojson
        var _branchHexGeojson     = null;
        var _branchCenterCell     = null;
        var _branchActiveBranchId = null;
        var _branchActiveAreaId   = null;
        var _branchActiveCardEl   = null;        // slide-1 card DOM element for badge/data sync on commit
        var _branchHexRenderGen   = 0;           // bumps per focal click; stale grid paints no-op
        var _branchExpandInFlight = false;       // POST inflight guard (close-during-commit race)
        var _branchCenterPulseRaf   = null;      // rAF handle for center-hex magenta ring

        function stopBranchCenterHexPulse() {
            if (_branchCenterPulseRaf) {
                try { cancelAnimationFrame(_branchCenterPulseRaf); } catch (e) {}
                _branchCenterPulseRaf = null;
            }
            try { if (map.getLayer('branch-h3-center-pulse')) map.removeLayer('branch-h3-center-pulse'); } catch (e) {}
        }

        function startBranchCenterHexPulse() {
            // Cancel any prior rAF only — do NOT call
            // stopBranchCenterHexPulse() here; that removes the layer
            // we just added one line above.
            if (_branchCenterPulseRaf) {
                try { cancelAnimationFrame(_branchCenterPulseRaf); } catch (e) {}
                _branchCenterPulseRaf = null;
            }
            if (!map.getLayer('branch-h3-center-pulse')) return;
            var pulseStart = Date.now();
            function tick() {
                if (!map.getLayer('branch-h3-center-pulse')) {
                    _branchCenterPulseRaf = null;
                    return;
                }
                var t = ((Date.now() - pulseStart) % 1200) / 1200;
                var wave = 0.5 + 0.5 * Math.sin(t * Math.PI * 2);
                try {
                    map.setPaintProperty('branch-h3-center-pulse', 'line-width', 3 + wave * 4);
                    map.setPaintProperty('branch-h3-center-pulse', 'line-opacity', 0.45 + wave * 0.55);
                    map.triggerRepaint();
                } catch (e) {}
                _branchCenterPulseRaf = requestAnimationFrame(tick);
            }
            _branchCenterPulseRaf = requestAnimationFrame(tick);
        }

        function isBranchHexAdjacent(cellId) {
            if (typeof h3 === 'undefined' || !h3.gridDisk) return false;
            var neighbors = h3.gridDisk(cellId, 1);
            for (var i = 0; i < neighbors.length; i++) {
                if (neighbors[i] !== cellId && (_branchZoneSet.has(neighbors[i]) || _branchSelectedHexes.has(neighbors[i]))) {
                    return true;
                }
            }
            return false;
        }

        function isOnOuterRing(cellId) {
            if (typeof h3 === 'undefined' || !h3.gridDisk) return false;
            var neighbors = h3.gridDisk(cellId, 1);
            for (var i = 0; i < neighbors.length; i++) {
                if (!_branchAllHexSet.has(neighbors[i])) return true;
            }
            return false;
        }

        function expandBranchHexGrid() {
            if (typeof h3 === 'undefined' || !h3.gridDisk) return;
            var borderCells = [];
            _branchAllHexSet.forEach(function (cellId) {
                var neighbors = h3.gridDisk(cellId, 1);
                for (var i = 0; i < neighbors.length; i++) {
                    if (!_branchAllHexSet.has(neighbors[i])) {
                        borderCells.push(cellId);
                        return;
                    }
                }
            });
            var newCells = new Set();
            for (var b = 0; b < borderCells.length; b++) {
                var ring = h3.gridDisk(borderCells[b], 3);
                for (var i = 0; i < ring.length; i++) {
                    if (!_branchAllHexSet.has(ring[i])) newCells.add(ring[i]);
                }
            }
            var newFeatures = [];
            newCells.forEach(function (cellId) {
                _branchAllHexSet.add(cellId);
                var boundary = h3.cellToBoundary(cellId);
                var ring = boundary.map(function (c) { return [c[1], c[0]]; });
                ring.push(ring[0]);
                newFeatures.push({
                    type: 'Feature',
                    properties: {
                        h3Index: cellId,
                        isCenter: false,
                        isZone: false,
                        isExpansion: true,
                        selected: false,
                        isAdjacent: isBranchHexAdjacent(cellId)
                    },
                    geometry: { type: 'Polygon', coordinates: [ring] }
                });
            });
            if (newFeatures.length > 0 && _branchHexGeojson) {
                _branchHexGeojson.features = _branchHexGeojson.features.concat(newFeatures);
                for (var i = 0; i < _branchHexGeojson.features.length; i++) {
                    var f = _branchHexGeojson.features[i];
                    if (!f.properties.isZone && !f.properties.selected) {
                        f.properties.isAdjacent = isBranchHexAdjacent(f.properties.h3Index);
                    }
                }
                var src = map.getSource('branch-h3');
                if (src) src.setData(_branchHexGeojson);
            }
        }

        function updateBranchHexOverlay() {
            var idle   = document.getElementById('pingFocusHexIdle');
            var btn    = document.getElementById('pingFocusHexUpdateBtn');
            var countS = document.getElementById('pingFocusHexSelectedCount');
            var labelS = document.getElementById('pingFocusHexUpdateLabel');
            if (!btn || !idle) return;
            var n = _branchSelectedHexes.size;
            // Ping-landing slide-1 expand is priced in Aura: 5,000 per hex.
            // currentAuraBalance is closure-scoped (L932) and kept fresh
            // by updateAuraPills, so it reflects the latest tween target
            // even mid-animation. The button chip surfaces the full Aura
            // bill so the spend is legible before commit.
            var costPerHex = 5000;
            var costAura   = n * costPerHex;
            var auraBal    = currentAuraBalance || 0;
            // Jutdee brands total_aura as "Good Luck" everywhere user-facing.
            var auraWord = document.body.classList.contains('is-jutdee-tenant')
                ? 'Good Luck'
                : 'Aura';
            if (n > 0) {
                idle.style.display = 'none';
                btn.style.display  = 'inline-flex';
                if (countS) countS.textContent = String(n);
                if (costAura > auraBal) {
                    btn.disabled = true;
                    if (labelS) labelS.textContent = 'needed — not enough ' + auraWord;
                } else {
                    btn.disabled = false;
                    if (labelS) labelS.textContent = 'selected — ' + costAura.toLocaleString() + ' ' + auraWord + ' · Update';
                }
            } else {
                idle.style.display = 'inline-flex';
                btn.style.display  = 'none';
            }
        }

        function updateBranchHexSelection() {
            if (!_branchHexGeojson) return;
            var needsExpansion = false;
            for (var i = 0; i < _branchHexGeojson.features.length; i++) {
                var f = _branchHexGeojson.features[i];
                var cid = f.properties.h3Index;
                f.properties.selected = _branchSelectedHexes.has(cid);
                if (!f.properties.isZone && !f.properties.selected) {
                    f.properties.isAdjacent = isBranchHexAdjacent(cid);
                }
            }
            _branchSelectedHexes.forEach(function (cellId) {
                if (isOnOuterRing(cellId)) needsExpansion = true;
            });
            var src = map.getSource('branch-h3');
            if (src) src.setData(_branchHexGeojson);
            if (needsExpansion) expandBranchHexGrid();
            updateBranchHexOverlay();
        }

        // Render the rich interactive hex grid for the slide-1 click
        // flow. Mirrors _updateIdCardForBranch's render block on
        // /focal-points (L4014-L4104) — same color/opacity expressions
        // (selected amber, isCenter gold, isZone lime, isAdjacent
        // magenta), same click/mousemove/mouseleave handlers gated
        // once via map._branchHexClickBound. Empty `savedHexes` falls
        // back to the center cell only so a brand-new focal point with
        // no committed hexes still gets a visible claim preview to expand from.
        function renderBranchHexGrid(opts) {
            opts = opts || {};
            var renderGen = opts.renderGen;
            if (renderGen != null && renderGen < _branchHexRenderGen) {
                return;
            }
            var lat = opts.lat;
            var lng = opts.lng;
            var savedHexes = opts.savedHexes || [];
            if (typeof h3 === 'undefined' || !h3.latLngToCell) return;
            try {
                _branchSelectedHexes = new Set();
                _branchAllHexSet     = new Set();

                var centerCell = h3.latLngToCell(lat, lng, 9);
                _branchCenterCell = centerCell;

                var zoneSet;
                if (savedHexes.length > 0) {
                    var res9Hexes = [];
                    for (var si = 0; si < savedHexes.length; si++) {
                        var res = h3.getResolution(savedHexes[si]);
                        if (res === 9) {
                            res9Hexes.push(savedHexes[si]);
                        } else {
                            var children = h3.cellToChildren(savedHexes[si], 9);
                            for (var ci = 0; ci < children.length; ci++) res9Hexes.push(children[ci]);
                        }
                    }
                    zoneSet = new Set(res9Hexes);
                } else {
                    zoneSet = new Set([centerCell]);
                }
                _branchZoneSet = zoneSet;

                var expansionSet = new Set();
                zoneSet.forEach(function (hex) {
                    var ring = h3.gridDisk(hex, 3);
                    for (var r = 0; r < ring.length; r++) expansionSet.add(ring[r]);
                });
                var expandedDisk = Array.from(expansionSet);
                for (var i = 0; i < expandedDisk.length; i++) _branchAllHexSet.add(expandedDisk[i]);

                var features = [];
                for (var j = 0; j < expandedDisk.length; j++) {
                    var cellId = expandedDisk[j];
                    var isZone = zoneSet.has(cellId);
                    var boundary = h3.cellToBoundary(cellId);
                    var ring2 = boundary.map(function (c) { return [c[1], c[0]]; });
                    ring2.push(ring2[0]);
                    features.push({
                        type: 'Feature',
                        properties: {
                            h3Index:    cellId,
                            isCenter:   cellId === centerCell,
                            isZone:     isZone,
                            isExpansion: !isZone,
                            selected:   false,
                            isAdjacent: !isZone && isBranchHexAdjacent(cellId)
                        },
                        geometry: { type: 'Polygon', coordinates: [ring2] }
                    });
                }
                _branchHexGeojson = { type: 'FeatureCollection', features: features };

                // Replace any prior render before adding new layers so a
                // re-focus on a different card doesn't stack layers.
                stopBranchCenterHexPulse();
                try { if (map.getLayer('branch-h3-fill')) map.removeLayer('branch-h3-fill'); } catch(e) {}
                try { if (map.getLayer('branch-h3-line')) map.removeLayer('branch-h3-line'); } catch(e) {}
                try { if (map.getLayer('branch-h3-center-pulse')) map.removeLayer('branch-h3-center-pulse'); } catch(e) {}
                try { if (map.getSource('branch-h3'))     map.removeSource('branch-h3'); }    catch(e) {}

                map.addSource('branch-h3', { type: 'geojson', data: _branchHexGeojson });
                // Render BELOW pink extrusions so the claim outline isn't buried.
                var beforeId = map.getLayer(BUILDINGS_LAYER_ID) ? BUILDINGS_LAYER_ID : undefined;
                map.addLayer({
                    id: 'branch-h3-fill',
                    type: 'fill',
                    source: 'branch-h3',
                    paint: {
                        'fill-color': [
                            'case',
                            ['==', ['get', 'selected'], true],   '#f59e0b',
                            ['==', ['get', 'isCenter'], true],   '#fbbf24',
                            ['==', ['get', 'isZone'], true],     '#ccff00',
                            ['==', ['get', 'isAdjacent'], true], '#e91e8c',
                            'rgba(0,0,0,0)'
                        ],
                        'fill-opacity': [
                            'case',
                            ['==', ['get', 'selected'], true],   0.5,
                            ['==', ['get', 'isCenter'], true],   0.35,
                            ['==', ['get', 'isZone'], true],     0.15,
                            ['==', ['get', 'isAdjacent'], true], 0.25,
                            0
                        ]
                    }
                }, beforeId);
                map.addLayer({
                    id: 'branch-h3-line',
                    type: 'line',
                    source: 'branch-h3',
                    paint: {
                        'line-color': [
                            'case',
                            ['==', ['get', 'selected'], true],   '#d97706',
                            ['==', ['get', 'isCenter'], true],   '#ca8a04',
                            ['==', ['get', 'isZone'], true],     '#a3cc00',
                            ['==', ['get', 'isAdjacent'], true], '#e91e8c',
                            'rgba(0,0,0,0)'
                        ],
                        'line-width': [
                            'case',
                            ['==', ['get', 'selected'], true], 2,
                            1.5
                        ],
                        'line-opacity': [
                            'case',
                            ['==', ['get', 'selected'], true], 0.9,
                            ['==', ['get', 'isZone'], true],   0.6,
                            0.25
                        ]
                    }
                }, beforeId);
                // Magenta ring on the central (gold) hex only — pulses via
                // startBranchCenterHexPulse() so it reads as the focal
                // anchor while pink marks expandable neighbors.
                map.addLayer({
                    id: 'branch-h3-center-pulse',
                    type: 'line',
                    source: 'branch-h3',
                    filter: ['==', ['get', 'isCenter'], true],
                    paint: {
                        'line-color': '#e91e8c',
                        'line-width': 4,
                        'line-opacity': 1
                    }
                });
                try { map.moveLayer('branch-h3-center-pulse'); } catch (e) {}
                startBranchCenterHexPulse();

                if (!map._branchHexClickBound) {
                    map.on('click', 'branch-h3-fill', function (e) {
                        if (!e.features || !e.features[0]) return;
                        var props = e.features[0].properties;
                        if (props.isZone) return;
                        var cellId = props.h3Index;
                        if (_branchSelectedHexes.has(cellId)) {
                            _branchSelectedHexes.delete(cellId);
                        } else {
                            if (!isBranchHexAdjacent(cellId)) return;
                            _branchSelectedHexes.add(cellId);
                        }
                        updateBranchHexSelection();
                    });
                    map.on('mousemove', 'branch-h3-fill', function (e) {
                        if (e.features && e.features[0]) {
                            var p = e.features[0].properties;
                            if (!p.isZone && (p.selected || isBranchHexAdjacent(p.h3Index))) {
                                map.getCanvas().style.cursor = 'pointer';
                            } else {
                                map.getCanvas().style.cursor = '';
                            }
                        }
                    });
                    map.on('mouseleave', 'branch-h3-fill', function () {
                        map.getCanvas().style.cursor = '';
                    });
                    map._branchHexClickBound = true;
                }
                updateBranchHexOverlay();
                if (_pingMapDecorHidden) setPingMapDecorVisible(false);
            } catch (err) {
                console.warn('[gfe-focus] branch hex render failed', err);
            }
        }

        // Late-arriving hex list entry point used by the slide-1
        // focal-point card click handler. The card fires
        // pingLandingFocusOnGamifeye(payload, {skipDetail:true}) with an
        // empty savedHexes array immediately so motion + the 7-cell
        // preview ring start at click time, then calls this once the
        // /api/locations/{id}/hexes fetch resolves to swap in the real
        // claimed zone (lime fill, magenta center pulse, pink adjacency
        // ring). renderBranchHexGrid removes its prior layers before
        // re-adding so the second call cleanly replaces the preview.
        window.pingLandingPaintFpHexesLate = function (lat, lng, hexes, areaId, renderGen) {
            if (!isFinite(lat) || !isFinite(lng)) return;
            if (!Array.isArray(hexes) || !hexes.length) return;
            if (areaId != null && _branchActiveAreaId !== areaId) return;
            if (renderGen != null && renderGen < _branchHexRenderGen) return;
            ensureH3(function () {
                try {
                    renderBranchHexGrid({
                        lat: lat,
                        lng: lng,
                        savedHexes: hexes,
                        renderGen: renderGen != null ? renderGen : _branchHexRenderGen
                    });
                } catch (e) { console.warn('[gfe-focus] late hex paint failed', e); }
            });
        };

        function showPingFocusHexToast(msg) {
            var toast = document.getElementById('pingFocusHexToast');
            if (!toast) return;
            toast.textContent = msg;
            toast.classList.add('visible');
            if (toast._dismissTimer) clearTimeout(toast._dismissTimer);
            toast._dismissTimer = setTimeout(function () {
                toast.classList.remove('visible');
            }, 2400);
        }

        function saveBranchHexExpansion() {
            if (!_branchActiveBranchId || _branchSelectedHexes.size === 0) return;
            if (_branchExpandInFlight) return;
            _branchExpandInFlight = true;

            var btn      = document.getElementById('pingFocusHexUpdateBtn');
            var labelS   = document.getElementById('pingFocusHexUpdateLabel');
            var closeBtn = document.getElementById('pingFocusCloseBtn');
            if (btn)      btn.disabled = true;
            if (labelS)   labelS.textContent = 'Saving…';
            if (closeBtn) closeBtn.disabled = true;

            var hexes = Array.from(_branchSelectedHexes);
            var csrfMeta = document.querySelector('meta[name="csrf-token"]');
            var csrf = csrfMeta ? csrfMeta.getAttribute('content') : '';
            fetch('/user-locations/' + _branchActiveBranchId + '/expand-hexes', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrf,
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ hexes: hexes, payment_mode: 'aura' })
            })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
            .then(function (res) {
                if (res.ok && res.data && res.data.success) {
                    hexes.forEach(function (h) { _branchZoneSet.add(h); });
                    _branchSelectedHexes = new Set();
                    if (_branchHexGeojson) {
                        for (var i = 0; i < _branchHexGeojson.features.length; i++) {
                            var f = _branchHexGeojson.features[i];
                            if (hexes.indexOf(f.properties.h3Index) !== -1) {
                                f.properties.isZone     = true;
                                f.properties.isExpansion = false;
                                f.properties.selected   = false;
                            }
                        }
                        // Re-evaluate isAdjacent for every non-zone cell
                        // so the pink ring rolls outward as new zone
                        // cells become anchors.
                        for (var k = 0; k < _branchHexGeojson.features.length; k++) {
                            var ff = _branchHexGeojson.features[k];
                            if (!ff.properties.isZone && !ff.properties.selected) {
                                ff.properties.isAdjacent = isBranchHexAdjacent(ff.properties.h3Index);
                            }
                        }
                        var src = map.getSource('branch-h3');
                        if (src) src.setData(_branchHexGeojson);
                    }

                    // Sync the slide-1 card's data-hexes + visible
                    // "X Lenses" badge so the carousel state is
                    // honest if the user X-closes back to it.
                    if (_branchActiveCardEl) {
                        try {
                            var updatedHexes = Array.from(_branchZoneSet);
                            _branchActiveCardEl.setAttribute('data-hexes', JSON.stringify(updatedHexes));
                            var badge = _branchActiveCardEl.querySelector('.ping-fp-slide1-loc-badge-count');
                            if (badge) badge.textContent = String(updatedHexes.length);
                        } catch (errCard) {
                            console.warn('[gfe-focus] card sync failed', errCard);
                        }
                    }

                    // Currency animation. Ping-landing slide-1 expand
                    // sends payment_mode:'aura' so the server returns
                    // new_aura_balance + echoes payment_mode. We tween
                    // the auth-pill Aura count via updateAuraPills and
                    // fire the floating "-25,000" debit label off the
                    // pill so the spend reads visually — same pair the
                    // spin-globe flow uses, kept consistent here.
                    //
                    // The lens-balance update block is preserved below
                    // as a defensive fallback (only fires if a future
                    // caller omits payment_mode and the server falls
                    // back to the lens debit path). /focal-points
                    // continues to live on that path.
                    var pmode = (res.data && res.data.payment_mode) || 'lens';
                    if (pmode === 'aura' && res.data && typeof res.data.new_aura_balance !== 'undefined') {
                        var nbAura = parseInt(res.data.new_aura_balance, 10);
                        if (!isNaN(nbAura)) {
                            updateAuraPills(nbAura);
                            fireAuraDebitFloater(hexes.length * 5000);
                        }
                    } else if (res.data && typeof res.data.new_balance !== 'undefined') {
                        var nb = parseInt(res.data.new_balance, 10);
                        if (!isNaN(nb)) {
                            window.dashboardHexBalance = nb;
                            var formatted = nb.toLocaleString();
                            var pillEls = document.querySelectorAll('[data-spin-lens-count]');
                            for (var p = 0; p < pillEls.length; p++) pillEls[p].textContent = formatted;
                            var labelEls = document.querySelectorAll('.spin-lens-overlay-label');
                            for (var q = 0; q < labelEls.length; q++) labelEls[q].textContent = nb === 1 ? 'Lens' : 'Lenses';
                            var balEls = document.querySelectorAll('.balance-hexes-value');
                            for (var bi = 0; bi < balEls.length; bi++) balEls[bi].textContent = formatted;
                        }
                    }

                    updateBranchHexOverlay();
                    showPingFocusHexToast((hexes.length === 1 ? '1 hex' : hexes.length + ' hexes') + ' added.');
                } else {
                    var m = (res.data && res.data.message) || 'Failed to update focal point.';
                    alert(m);
                    if (labelS) labelS.textContent = 'selected — Update';
                    updateBranchHexOverlay();
                }
            })
            .catch(function (err) {
                console.error('[gfe-focus] expand hexes error', err);
                alert('An error occurred. Please try again.');
                if (labelS) labelS.textContent = 'selected — Update';
                updateBranchHexOverlay();
            })
            .then(function () {
                _branchExpandInFlight = false;
                if (closeBtn) closeBtn.disabled = false;
                // Re-evaluate the Update button against the Aura wallet
                // (5,000 per selected hex). updateBranchHexOverlay() has
                // already done this in both branches above; this is a
                // belt-and-braces reset in case the overlay call ever
                // short-circuits before the disabled flag is set.
                if (btn) {
                    var pendingCount = _branchSelectedHexes.size;
                    var pendingCost  = pendingCount * 5000;
                    btn.disabled = (pendingCount === 0) || (pendingCost > (currentAuraBalance || 0));
                }
            });
        }

        // Wire the Update button once on DOMContentLoaded. The
        // overlay markup is server-rendered (auth-gated) so the
        // element is present from page load forwards.
        (function () {
            var btn = document.getElementById('pingFocusHexUpdateBtn');
            if (btn) btn.addEventListener('click', saveBranchHexExpansion);
        })();

        // ── GamifEYE detail modal ────────────────────────────────────────
        // Bounce-in card that appears after the intro modal flies away,
        // carrying the Google-Places-derived header image + business
        // info (title, rating, description, contact links, subdomain).
        // Fed by either:
        //   - a fresh import response (POST /user-locations), or
        //   - a click on one of the user's existing GamifEYEs in the
        //     "Your Locations" tab (data-gfe-loc-payload).
        // Keeping the DOM query + data-hydration logic inside its own
        // function means pingLandingFocusOnGamifeye stays focused on
        // map behaviour and the two concerns can evolve independently.
        wireGfeCreatedSetupBtnOnce();

        function showGfeDetailModal(data) {
            clearSpinFlyinLocationTitle();
            clearPingHeroLocationImage();
            var modalEl = document.getElementById('gfeDetailModal');
            if (!modalEl || !data) return;

            // Helpers for the per-row show/hide pattern. When a field
            // is present we populate + display; when absent we hide
            // the whole row so the info block doesn't render with
            // an awkward label-only line.
            function setText(id, val) {
                var el = document.getElementById(id);
                if (el) el.textContent = val == null ? '' : String(val);
            }
            function setEl(id, show) {
                var el = document.getElementById(id);
                if (el) el.style.display = show ? '' : 'none';
            }

            // ── Hero image ───────────────────────────────────────────
            // `logo_url` on the payload is the Places-API first photo
            // (see GooglePlacesService::resolvePhotoUrl), so it's the
            // right "header image" to use as the card hero. We preload
            // the image first so the .is-loaded fade runs against a
            // warm cache and doesn't flash a half-rendered raster.
            var heroImg      = document.getElementById('gfeDetailHeroImg');
            var heroFallback = document.getElementById('gfeDetailHeroFallback');
            if (heroImg) {
                heroImg.classList.remove('is-loaded');
                heroImg.style.backgroundImage = '';
            }
            if (heroFallback) heroFallback.style.display = '';
            var logoUrl = data.logo_url || data.logo || '';
            if (logoUrl && heroImg) {
                var probe = new Image();
                probe.onload = function() {
                    heroImg.style.backgroundImage = "url('" + logoUrl.replace(/'/g, "%27") + "')";
                    heroImg.classList.add('is-loaded');
                    if (heroFallback) heroFallback.style.display = 'none';
                };
                probe.onerror = function() { /* fallback stays visible */ };
                probe.src = logoUrl;
            }

            // ── Title ────────────────────────────────────────────────
            setText('gfeDetailTitle', data.title || 'GamifEYE');

            // ── Rating pill ──────────────────────────────────────────
            var rating = data.rating != null ? parseFloat(data.rating) : null;
            var reviewCount = data.review_count != null ? parseInt(data.review_count, 10) : null;
            if (rating && isFinite(rating) && rating > 0) {
                setText('gfeDetailRatingVal', rating.toFixed(1));
                setText(
                    'gfeDetailRatingCount',
                    (reviewCount && reviewCount > 0) ? ('(' + reviewCount.toLocaleString() + ')') : ''
                );
                setEl('gfeDetailRating', true);
            } else {
                setEl('gfeDetailRating', false);
            }

            // ── Category + subdomain row ─────────────────────────────
            var cat = data.primary_category_display_name || data.primary_category || '';
            if (cat) {
                // Google's raw categories arrive as e.g. "park" or
                // "tourist_attraction" — humanise so the chip reads
                // cleanly without needing per-category copy.
                var humanised = String(cat).replace(/_/g, ' ').replace(/\b\w/g, function(c) {
                    return c.toUpperCase();
                });
                setText('gfeDetailCategory', humanised);
                setEl('gfeDetailCategory', true);
            } else {
                setEl('gfeDetailCategory', false);
            }

            var slug = data.subdomain_slug || '';
            var slugLink = document.getElementById('gfeDetailSlug');
            if (slug && slugLink) {
                setText('gfeDetailSlugText', window.gfeSubdomainHost(slug));
                slugLink.href = 'https://' + window.gfeSubdomainHost(slug);
                slugLink.style.display = '';
            } else if (slugLink) {
                slugLink.style.display = 'none';
            }

            // ── Description ──────────────────────────────────────────
            var descEl = document.getElementById('gfeDetailDescription');
            if (descEl) {
                if (data.description) {
                    descEl.textContent = data.description;
                    descEl.style.display = '';
                } else {
                    descEl.textContent = '';
                    descEl.style.display = 'none';
                }
            }

            // ── Add-Domain badge ─────────────────────────────────────
            // Static CTA — the title + description are baked into the
            // Blade markup, so there's nothing to populate here. The
            // badge replaces the old address/phone/website/Google-Maps
            // rows which used to live at the bottom of the card.

            // Reveal. Toggling .visible triggers gfeDetailBounceIn
            // (see public/css/ping-landing.css) — spring descent with
            // a slight settling overshoot.
            modalEl.classList.remove('is-flying-out');
            // Force a reflow between resetting and adding .visible so
            // the animation restarts cleanly when the modal is opened
            // a second time without a full page navigation.
            // eslint-disable-next-line no-unused-expressions
            modalEl.offsetHeight;
            modalEl.classList.add('visible');
        }

        // Close button + backdrop click + Escape all dismiss the
        // detail modal. Dismissal is a full "rewind" back to the
        // resting landing surface:
        //   1. Detail card flies UP off-screen (gfeDetailFlyOut).
        //   2. Map overlays (pin + hex grid) tear down so the globe
        //      isn't littered with stale imported state.
        //   3. Camera eases back to globe framing (zoom 1.8, pitch 0)
        //      and auto-spin resumes once the ease completes. Same
        //      helper the spin-result closeModal path uses, so both
        //      "back to idle" flows produce the same motion beat.
        //   4. Intro modal re-opens in its .is-gfeimport state — the
        //      user arrived at the detail card via the "GamifEYE A
        //      Location" CTA, so that's the sub-view we return them
        //      to (with the importer ready for a next location and
        //      the refreshed "Your Locations" list).
        (function wireGfeDetailClose() {
            var modalEl = document.getElementById('gfeDetailModal');
            if (!modalEl) return;

            // Timings for the rewind sequence. Mirrors the inbound
            // "flyin then 500ms dwell then modal" pattern in reverse
            // — the detail card flies out first, we hold the map
            // still for half a second so the user registers that the
            // card is gone, THEN the globe zoom-out kicks in.
            var DETAIL_FLYOUT_MS      = 450; // match gfeDetailFlyOut keyframes
            var DETAIL_TO_GLOBE_DWELL = 500; // user-requested pause between the two
            var GLOBE_EASE_MS         = 900; // restoreGlobeFraming ease duration

            function hide() {
                if (!modalEl.classList.contains('visible')) return;

                // Phase 1: the detail card flies up off-screen. Map
                // overlays and camera stay exactly as they are — no
                // motion on the map during this beat.
                modalEl.classList.add('is-flying-out');

                // Phase 2: once the card is fully off-screen, hold
                // for 500ms (DETAIL_TO_GLOBE_DWELL), then tear down
                // the pin + hex overlays and ease the camera back to
                // the idle globe framing. restoreGlobeFraming() also
                // re-enables autoSpin after its own ease completes.
                setTimeout(function () {
                    // Clear the modal's display flag now — its exit
                    // animation has finished.
                    modalEl.classList.remove('visible');
                    modalEl.classList.remove('is-flying-out');

                    resetGfeMapOverlays();
                    try { restoreGlobeFraming(GLOBE_EASE_MS); } catch(e) {}
                }, DETAIL_FLYOUT_MS + DETAIL_TO_GLOBE_DWELL);

                // Phase 3: after the globe ease completes, bring the
                // intro modal back in its GamifEYE-A-Location
                // sub-view. Timed off the same wall-clock so it
                // lands exactly when restoreGlobeFraming finishes,
                // not while the camera is still mid-ease.
                setTimeout(function () {
                    restoreIntroInGfeimportMode();
                }, DETAIL_FLYOUT_MS + DETAIL_TO_GLOBE_DWELL + GLOBE_EASE_MS);
            }
            var closeBtn = document.getElementById('gfeDetailClose');
            if (closeBtn) closeBtn.addEventListener('click', hide);
            modalEl.addEventListener('click', function(e) {
                // Clicks on the card itself shouldn't dismiss — only
                // backdrop clicks (i.e. event target === modal root).
                if (e.target === modalEl) hide();
            });
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape' && modalEl.classList.contains('visible')) hide();
            });
        })();

        // ────────────────────────────────────────────────────────────────
        // Voucher detail modal (#voucherDetailModal)
        // --------------------------------------------------------------
        // Direct sibling of the #gfeDetailModal IIFE above. Opens when
        // the user clicks a reward row in #pingFpRewardsHint on carousel
        // slide 4 (#gfeRewardsList). The click is delegated from the rewards
        // IIFE in ping-landing.blade.php — that handler
        // builds the payload from data-* attrs the Blade @foreach
        // stamped on the row, then calls window.openVoucherDetailModal
        // defined here.
        //
        // Visual contract: same .gfe-detail-card chrome as #gfeDetailModal
        // and #townDetailModal (9:16 magenta-ringed card, hero band +
        // body, glass close chip, gfeDetailBounceIn keyframes) so the
        // modal reads as a voucher-shaped sibling of the location modal.
        // CSS lives under #voucherDetailModal in public/css/ping-landing.css
        // (copy_subset of the #gfeDetailModal block).
        //
        // Sequencing — open:
        //   1. hideIntro(true) — intro card flies UP via spinFlyOut
        //      (~500ms / FLY_OUT_MS), bg image fades.
        //   2. After 500ms dwell, .visible is added to #voucherDetailModal
        //      so .gfe-detail-card's gfeDetailBounceIn keyframes fire.
        //
        // Sequencing — close (X / backdrop / Esc):
        //   1. .is-flying-out is added so .gfe-detail-card animates UP
        //      via gfeDetailFlyOut (~450ms / DETAIL_FLYOUT_MS).
        //   2. modalEl.visible class removed, intro modal restored via
        //      restoreIntroAfterVoucherClose() (showIntro only — rewards
        //      list stays in #pingFpOverlay).
        //
        // No map/globe choreography in either direction — the voucher
        // has no geographic anchor. This is the key behavioural
        // difference vs the location/town flows which trigger
        // restoreGlobeFraming on close.
        // ────────────────────────────────────────────────────────────
        (function () {
            var modalEl = document.getElementById('voucherDetailModal');
            if (!modalEl) return; // guest users — markup wrapped in @auth

            // Cache modal nodes once. The voucher modal markup is
            // owner-controlled (Blade renders it on every page load),
            // so these IDs are stable for the lifetime of the page.
            var heroImgEl     = document.getElementById('voucherDetailHeroImg');
            var heroFbEl      = document.getElementById('voucherDetailHeroFallback');
            var statusEl      = document.getElementById('voucherDetailStatus');
            var statusLabelEl = document.getElementById('voucherDetailStatusLabel');
            var titleEl       = document.getElementById('voucherDetailTitle');
            var stampEl       = document.getElementById('voucherDetailStamp');
            var descEl        = document.getElementById('voucherDetailDescription');
            var qrEl          = document.getElementById('voucherDetailQr');
            var codeEl        = document.getElementById('voucherDetailCode');
            var termsEl       = document.getElementById('voucherDetailTerms');
            var expiryRowEl   = document.getElementById('voucherDetailExpiryRow');
            var expiryEl      = document.getElementById('voucherDetailExpiry');
            var minRowEl      = document.getElementById('voucherDetailMinRow');
            var minEl         = document.getElementById('voucherDetailMin');
            var instrRowEl    = document.getElementById('voucherDetailInstructionsRow');
            var instrEl       = document.getElementById('voucherDetailInstructions');
            var stampDescRowEl = document.getElementById('voucherDetailStampDescRow');
            var stampDescEl   = document.getElementById('voucherDetailStampDesc');

            // Light date formatter — produces "12 Jan 2026" via the
            // browser's locale-aware toLocaleDateString. Falls back to
            // an empty string for invalid / missing inputs so callers
            // can use the result directly in the conditional show
            // checks below.
            function fmtDate(iso) {
                if (!iso) return '';
                var d = new Date(iso);
                if (isNaN(d.getTime())) return '';
                try {
                    return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
                } catch (e) {
                    return d.toDateString();
                }
            }

            function setText(el, text) {
                if (!el) return;
                el.textContent = text || '';
            }
            function showHide(el, on) {
                if (!el) return;
                el.style.display = on ? '' : 'none';
            }

            function hydrate(payload) {
                payload = payload || {};

                // Hero image — set background-image when present, fade
                // in via .is-loaded once the image actually decodes.
                // Hide the fallback when an image is present so the
                // gradient + gift icon doesn't show through under a
                // half-loaded photo.
                if (heroImgEl) {
                    heroImgEl.classList.remove('is-loaded');
                    heroImgEl.style.backgroundImage = '';
                }
                if (payload.image && heroImgEl) {
                    showHide(heroFbEl, false);
                    var pre = new Image();
                    pre.onload = function () {
                        heroImgEl.style.backgroundImage = 'url("' + payload.image.replace(/"/g, '\\"') + '")';
                        heroImgEl.classList.add('is-loaded');
                    };
                    pre.onerror = function () { showHide(heroFbEl, true); };
                    pre.src = payload.image;
                } else {
                    showHide(heroFbEl, true);
                }

                // Status pill — green when redeemed, amber when not.
                // Same translated copy the row uses (see ping-landing.blade.php).
                if (statusEl) {
                    statusEl.classList.remove('is-redeemed', 'is-pending');
                    var iconEl = statusEl.querySelector('.bi');
                    if (payload.redeemed_at) {
                        statusEl.classList.add('is-redeemed');
                        if (iconEl) iconEl.className = 'bi bi-check-circle-fill';
                        setText(statusLabelEl, 'REDEEMED');
                    } else {
                        statusEl.classList.add('is-pending');
                        if (iconEl) iconEl.className = 'bi bi-hourglass-split';
                        setText(statusLabelEl, 'PENDING');
                    }
                    showHide(statusEl, true);
                }

                setText(titleEl, payload.quest_name || '');

                if (payload.stamp_name) {
                    setText(stampEl, payload.stamp_name);
                    showHide(stampEl, true);
                } else {
                    showHide(stampEl, false);
                }

                if (payload.quest_description) {
                    setText(descEl, payload.quest_description);
                    showHide(descEl, true);
                } else {
                    showHide(descEl, false);
                }

                // QR — keyed off the same /qr/{code} endpoint already
                // wired by user.rewards.blade.php (line 83) and
                // challenge-mission.blade.php (line 3511).
                if (qrEl && payload.voucher_code) {
                    qrEl.src = '/qr/' + encodeURIComponent(payload.voucher_code);
                } else if (qrEl) {
                    qrEl.removeAttribute('src');
                }
                setText(codeEl, payload.voucher_code || '');

                // Terms list — each row hides individually when its
                // source field is empty; the whole wrapper hides
                // when none of the four are present so the modal
                // doesn't show an orphan "Terms" header.
                var anyTerms = false;

                var expiryFmt = fmtDate(payload.reward_expiry);
                if (expiryFmt) {
                    setText(expiryEl, expiryFmt);
                    showHide(expiryRowEl, true);
                    anyTerms = true;
                } else {
                    showHide(expiryRowEl, false);
                }

                // Minimum purchase — the controller serialises this as
                // a 2dp string (e.g. "5.00") via number_format. We
                // prepend a generic currency symbol; if the project
                // ever needs per-tenant currency this is the spot to
                // wire it up.
                var minNum = parseFloat(payload.minimum_purchase);
                if (!isNaN(minNum) && minNum > 0) {
                    setText(minEl, '$' + minNum.toFixed(2));
                    showHide(minRowEl, true);
                    anyTerms = true;
                } else {
                    showHide(minRowEl, false);
                }

                if (payload.redemption_instructions) {
                    setText(instrEl, payload.redemption_instructions);
                    showHide(instrRowEl, true);
                    anyTerms = true;
                } else {
                    showHide(instrRowEl, false);
                }

                if (payload.stamp_description) {
                    setText(stampDescEl, payload.stamp_description);
                    showHide(stampDescRowEl, true);
                    anyTerms = true;
                } else {
                    showHide(stampDescRowEl, false);
                }

                showHide(termsEl, anyTerms);
            }

            // Open: fly intro out, then bounce voucher in. 500ms dwell
            // matches FLY_OUT_MS in the hideIntro keyframes so the
            // voucher card starts its descent as the intro card is
            // still clearing the top of the viewport.
            window.openVoucherDetailModal = function (payload) {
                if (!payload) return;
                hydrate(payload);
                try { hideIntro(true); } catch (e) {}
                setTimeout(function () {
                    modalEl.classList.add('visible');
                }, 500);
            };

            // Close: phase structure matches wireTownDetailClose
            // (ping-landing.js ~L6140) minus the globe ease — voucher
            // has no map work to undo. INTRO_RESTORE_DELAY is a brief
            // dwell so the voucher's fly-out is visibly clear before
            // the intro starts bouncing back.
            var DETAIL_FLYOUT_MS    = 450;
            var INTRO_RESTORE_DELAY = 250;

            function restoreIntroAfterVoucherClose() {
                try { showIntro(); } catch (e) {}
            }

            function hide() {
                if (!modalEl.classList.contains('visible')) return;
                modalEl.classList.add('is-flying-out');
                setTimeout(function () {
                    modalEl.classList.remove('visible');
                    modalEl.classList.remove('is-flying-out');
                }, DETAIL_FLYOUT_MS);
                setTimeout(function () {
                    restoreIntroAfterVoucherClose();
                }, DETAIL_FLYOUT_MS + INTRO_RESTORE_DELAY);
            }

            var closeBtn = document.getElementById('voucherDetailClose');
            if (closeBtn) closeBtn.addEventListener('click', hide);
            modalEl.addEventListener('click', function (e) {
                if (e.target === modalEl) hide();
            });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && modalEl.classList.contains('visible')) hide();
            });
        })();

        // ────────────────────────────────────────────────────────────────
        // Shared Cropper.js singleton
        // --------------------------------------------------------------
        // Owns the #gfeEditCropModal (16:9 cropper) so it can be driven
        // by multiple flows that all need to crop owner-uploaded images
        // to a 16:9 WebP data URL:
        //   • Edit Location modal — Change Logo button
        //   • Tour Detail modal   — Change Cover button
        //
        // Lifted out of wireGfeEditModal's closure when the tour-cover
        // flow needed access to the same modal markup. Each caller hands
        // in its own onApply callback so the cropper stays agnostic
        // about where the cropped data URL ultimately lands. A single
        // shared cropperInstance + lazy-mounted listeners guarantees the
        // two flows can never leak two simultaneous Cropper instances
        // even if the user opens one immediately after the other.
        // ──────────────────────────────────────────────────────────────
        var sharedCropper = (function () {
            var cropperInstance = null;
            var els = null;            // lazily resolved on first open()
            var currentOnApply = null; // active session's apply callback
            var currentCropOpts = null; // width/height/quality for apply()

            function ensureEls() {
                if (els) return els;
                var modal = document.getElementById('gfeEditCropModal');
                if (!modal) return null;
                els = {
                    modal:  modal,
                    area:   document.getElementById('gfeEditCropArea'),
                    close:  document.getElementById('gfeEditCropClose'),
                    cancel: document.getElementById('gfeEditCropCancel'),
                    apply:  document.getElementById('gfeEditCropApply'),
                };
                // Wire shared close/cancel/apply listeners ONCE so the
                // user can re-open the cropper any number of times
                // without piling on duplicate handlers.
                if (els.close)  els.close.addEventListener('click', close);
                if (els.cancel) els.cancel.addEventListener('click', close);
                if (els.apply)  els.apply.addEventListener('click', apply);
                els.modal.addEventListener('click', function (e) {
                    if (e.target === els.modal) close();
                });
                // Esc closes the cropper if it's the topmost modal —
                // capture-phase + stopPropagation so the parent modal's
                // own Esc handler doesn't also fire (otherwise picking
                // Esc inside the cropper would close the edit modal too).
                document.addEventListener('keydown', function (e) {
                    if (e.key === 'Escape' && isVisible()) {
                        e.stopPropagation();
                        close();
                    }
                }, true);
                return els;
            }

            function open(dataUrl, options) {
                var e = ensureEls();
                if (!e) return false;
                if (typeof Cropper === 'undefined') {
                    // Cropper.js failed to load — fall back to using
                    // the picked file as-is (no crop). Better than a
                    // silent dead-end. Server-side image_data regex
                    // still accepts the data URL.
                    console.warn('[cropper] Cropper.js not available, using image as-is');
                    if (options && options.onApply) options.onApply(dataUrl);
                    return false;
                }

                // Tear down any prior session before mounting a new one
                // — defends against the user re-opening the cropper
                // before the previous instance has been disposed (e.g.
                // hammering Change Cover twice in quick succession).
                if (cropperInstance) { cropperInstance.destroy(); cropperInstance = null; }

                currentOnApply = (options && options.onApply) || null;
                currentCropOpts = options || null;

                // Stamp-reward sessions get black/white 1:1 chrome; other
                // flows (logo / tour cover) keep the default 16:9 modal.
                var titleEl = e.modal.querySelector('.gfe-edit-crop-header span');
                if (titleEl && els.defaultTitle == null) {
                    els.defaultTitle = titleEl.textContent || 'Crop Logo Image';
                    els.defaultAria = e.modal.getAttribute('aria-label') || els.defaultTitle;
                }
                if (options && options.variant === 'stamp-reward') {
                    e.modal.classList.add('is-stamp-reward-crop');
                    if (titleEl) titleEl.textContent = 'Crop Reward Image';
                    e.modal.setAttribute('aria-label', 'Crop Reward Image');
                } else {
                    e.modal.classList.remove('is-stamp-reward-crop');
                    if (titleEl && els.defaultTitle != null) {
                        titleEl.textContent = els.defaultTitle;
                        e.modal.setAttribute('aria-label', els.defaultAria);
                    }
                }

                // Mount a fresh <img> inside the crop area — Cropper
                // attaches to that element directly. We attach as raw
                // HTML (matching the dashboard's openLocationCropModal
                // exactly) rather than building the node and querying
                // it back, so the construction order matches the
                // proven path verbatim and there's no chance of init
                // drift.
                e.area.innerHTML = '<img alt="" src="' +
                    String(dataUrl).replace(/"/g, '&quot;') +
                    '" style="max-width:100%;">';
                var img = e.area.querySelector('img');

                // Show the modal first so Cropper can compute the
                // container's actual dimensions. Cropper uses 0×0 if
                // it's measured while display:none.
                e.modal.removeAttribute('hidden');
                /* eslint-disable no-unused-expressions */
                e.modal.offsetHeight;
                /* eslint-enable no-unused-expressions */
                e.modal.classList.add('visible');

                // Initialise Cropper immediately — the library handles
                // image-load internally. The previous version here
                // wrapped this in img.onload, which races for data:
                // URLs whose load event can be queued before the
                // listener is attached.
                cropperInstance = new Cropper(img, {
                    aspectRatio:              (options && options.aspectRatio) || (16 / 9),
                    viewMode:                 1,
                    dragMode:                 'move',
                    autoCropArea:             1,
                    restore:                  false,
                    guides:                   true,
                    center:                   true,
                    highlight:                false,
                    cropBoxMovable:           true,
                    cropBoxResizable:         true,
                    toggleDragModeOnDblclick: false,
                });
                return true;
            }

            function close() {
                if (cropperInstance) { cropperInstance.destroy(); cropperInstance = null; }
                if (els) {
                    els.area.innerHTML = '';
                    els.modal.classList.remove('visible');
                    els.modal.classList.remove('is-stamp-reward-crop');
                    if (els.defaultTitle != null) {
                        var closeTitle = els.modal.querySelector('.gfe-edit-crop-header span');
                        if (closeTitle) closeTitle.textContent = els.defaultTitle;
                        els.modal.setAttribute('aria-label', els.defaultAria);
                    }
                    setTimeout(function () {
                        if (els && !els.modal.classList.contains('visible')) {
                            els.modal.setAttribute('hidden', '');
                        }
                    }, 280);
                }
                currentOnApply = null;
                currentCropOpts = null;
            }

            function apply() {
                if (!cropperInstance) { close(); return; }
                var opts = currentCropOpts || {};
                var outW = opts.width || 800;
                var outH = opts.height || 450;
                var quality = (opts.quality != null) ? opts.quality : 0.9;
                var canvas = cropperInstance.getCroppedCanvas({
                    width:  outW,
                    height: outH,
                });
                if (!canvas) { close(); return; }
                var dataUrl;
                try {
                    dataUrl = canvas.toDataURL('image/webp', quality);
                    // Safari et al. silently return PNG when asked for
                    // WebP — detect and fall back. Server still force-
                    // re-encodes stamp rewards to WebP either way.
                    if (!dataUrl || dataUrl.indexOf('data:image/webp') !== 0) {
                        dataUrl = canvas.toDataURL('image/jpeg', Math.min(0.85, quality || 0.85));
                    }
                } catch (err) {
                    dataUrl = canvas.toDataURL('image/jpeg', 0.85);
                }
                // Cache the callback before close() nulls it, so the
                // teardown can fully complete before we hand control
                // back to the caller (caller may immediately reopen).
                var cb = currentOnApply;
                close();
                if (cb) cb(dataUrl);
            }

            function isVisible() {
                return !!(els && els.modal && els.modal.classList.contains('visible'));
            }

            return { open: open, close: close, isVisible: isVisible };
        })();
        window.__gfeSharedCropper = sharedCropper;

        // ────────────────────────────────────────────────────────────────
        // Edit Location modal (#gfeEditModal)
        // --------------------------------------------------------------
        // Opens when the user clicks the pencil button on a tile in the
        // "Your Locations" list inside the intro modal. Hydrates from
        // the tile's data-gfe-loc-payload, lets the user edit every
        // field the existing PATCH /user-locations/{id} endpoint
        // accepts, and on save patches the matching tile in-place so
        // the UI reflects the new values without a full reload.
        //
        // Pieces in order down this section:
        //   1. State (formState) + DOM refs lookup
        //   2. openGfeEditModal(payload)  — hydrate + show
        //   3. Logo upload handler        — file → sharedCropper (16:9)
        //                                   → onApply stashes pending
        //                                   logo data URL
        //   4. Slug availability check    — debounced GET to
        //                                   /user-locations/check-slug
        //   5. Form submit                — PATCH /user-locations/{id}
        //                                   with X-CSRF-TOKEN header
        //   6. updateLocationTileInPlace  — rewrite the matching <li>'s
        //                                   visible bits from the response
        //   7. wireGfeEditClose           — X only (dirty-confirm on close)
        //                                   check confirm
        //   8. Document-level click delegate for [data-gfe-loc-edit]
        // ──────────────────────────────────────────────────────────────
        (function wireGfeEditModal() {
            var modalEl = document.getElementById('gfeEditModal');
            if (!modalEl) return;
            var canEditDomain = pingCanEditDomain();

            // Per-open form state. Reset on each open so a previous
            // edit's logo/dirty flags don't leak into the next.
            var formState = {
                id:           null, // home point id being edited
                originalSlug: '',   // the slug as it was on open (lets
                                    // us treat "no change" as always-OK
                                    // without hitting the check endpoint)
                pendingLogo:  null, // data: URL stashed by the upload
                                    // handler, sent as image_data on
                                    // submit. null = no new logo picked.
                pristine:     {},   // snapshot of every field value on
                                    // open so wireGfeEditClose can
                                    // detect whether anything changed
                                    // and prompt before discard.
                jutdeeInline: false, // form mounted in #jutdeeLocationViewModal
                jutdeeSection: null,
                jutdeeManage: false,
            };

            // DOM refs — looked up once on bind. The edit modal is
            // emitted unconditionally inside @auth so these are
            // guaranteed to exist at script load.
            //
            // logoPreview is the full-bleed hero image div (a <div>
            // painted via background-image, NOT an <img>) — see
            // .gfe-edit-hero-img in public/css/ping-landing.css.
            var els = {
                modal:           modalEl,
                closeBtn:        document.getElementById('gfeEditClose'),
                form:            document.getElementById('gfeEditForm'),
                save:            document.getElementById('gfeEditSave'),
                deleteBtn:       document.getElementById('gfeEditDelete'),
                hero:            document.getElementById('gfeEditHero'),
                logoBtn:         document.getElementById('gfeEditLogoBtn'),
                logoInput:       document.getElementById('gfeEditLogoInput'),
                logoPreview:     document.getElementById('gfeEditLogoPreview'),
                slugInput:       document.getElementById('gfeEditFieldSlug'),
                slugPip:         document.getElementById('gfeEditSlugPip'),
                title:           document.getElementById('gfeEditFieldTitle'),
                description:     document.getElementById('gfeEditFieldDescription'),
                address:         document.getElementById('gfeEditFieldAddress'),
                showOnMap:       document.getElementById('gfeEditShowOnMap'),
                phone:           document.getElementById('gfeEditFieldPhone'),
                website:         document.getElementById('gfeEditFieldWebsite'),
                visitDuration:   document.getElementById('gfeEditFieldVisitDuration'),
                visitArrivalRadius: document.getElementById('gfeEditFieldArrivalRadius'),
                facebook:        document.getElementById('gfeEditFieldFacebook'),
                instagram:       document.getElementById('gfeEditFieldInstagram'),
                twitter:         document.getElementById('gfeEditFieldTwitter'),
                linkedin:        document.getElementById('gfeEditFieldLinkedin'),
                youtube:         document.getElementById('gfeEditFieldYoutube'),
                tiktok:          document.getElementById('gfeEditFieldTiktok'),
                // Custom-domain toggle pane controls. The hidden
                // gfeEditFieldDomainMode input is the canonical
                // source of truth for which pane is active — both
                // the toggle buttons and collectFormValues read it.
                domainTabSub:    document.getElementById('gfeDomainTabSub'),
                domainTabCustom: document.getElementById('gfeDomainTabCustom'),
                domainPaneSub:   document.getElementById('gfeDomainPaneSub'),
                domainPaneCustom:document.getElementById('gfeDomainPaneCustom'),
                domainModeInput: document.getElementById('gfeEditFieldDomainMode'),
                customDomain:    document.getElementById('gfeEditFieldCustomDomain'),
                customDomainPip: document.getElementById('gfeEditCustomDomainPip'),
                domainCheckBtn:  document.getElementById('gfeDomainCheckBtn'),
                domainCheckResult: document.getElementById('gfeDomainCheckResult'),
                domainReadonlyLink: document.getElementById('gfeEditDomainReadonlyLink'),
            };
            // Cropper.js modal markup is owned by the shared
            // sharedCropper singleton above — this closure just hands
            // it a data URL + onApply callback when the user picks a
            // new logo. No instance state is held here anymore.

            // Allowed minimum-dwell presets (minutes) — mirror
            // UserHomePoint::VISIT_MIN_DURATION_PRESETS. Off-list/zero
            // values coerce to 5 so the selector always has a valid pick.
            var VISIT_DURATION_PRESETS = [1, 5, 15, 30, 60, 180, 360, -10];
            function coerceVisitDurationPreset(v) {
                var dur = parseInt(v, 10);
                return VISIT_DURATION_PRESETS.indexOf(dur) !== -1 ? dur : 5;
            }
            var VISIT_ARRIVAL_RADIUS_PRESETS = [15, 25, 50, 750];
            function coerceVisitArrivalRadiusPreset(v) {
                var r = parseInt(v, 10);
                return VISIT_ARRIVAL_RADIUS_PRESETS.indexOf(r) !== -1 ? r : 15;
            }

            // ── 1. open + hydrate ────────────────────────────────────
            // opts.jutdeeInline: hydrate into #jutdeeLocationViewModal
            // below the hero — do not show #gfeEditModal as a second overlay.
            // opts.jutdeeSection: address|subdomain|socials|loyalty
            // opts.jutdeeManage: existing-location manage flow (save → menu)
            function openGfeEditModal(payload, opts) {
                if (!payload || !payload.id) return;
                opts = opts || {};
                var jutdeeInline = !!opts.jutdeeInline;
                var jutdeeSection = opts.jutdeeSection || 'address';
                var jutdeeManage = !!opts.jutdeeManage;

                formState.id           = payload.id;
                formState.originalSlug = (payload.subdomain_slug || '').toLowerCase();
                formState.pendingLogo  = null;
                formState.jutdeeInline = jutdeeInline;
                formState.jutdeeSection = jutdeeInline ? jutdeeSection : null;
                formState.jutdeeManage = jutdeeInline && jutdeeManage;
                try { window.__gfeEditOriginalSlug = formState.originalSlug; } catch (e) { /* noop */ }

                // Populate every input from the payload. Empty strings
                // (not undefined/null) keep the inputs controllable so
                // the user can clear → re-fill without quirks.
                els.title.value       = payload.title           || '';
                els.description.value = payload.description     || '';
                els.address.value     = payload.address         || '';
                if (els.showOnMap) {
                    els.showOnMap.checked = locationShowsOnMap(payload);
                }
                els.phone.value       = payload.phone           || '';
                els.website.value     = payload.website         || '';
                if (els.visitDuration) {
                    els.visitDuration.value = String(coerceVisitDurationPreset(payload.visit_duration_minutes));
                }
                if (els.visitArrivalRadius) {
                    els.visitArrivalRadius.value = String(coerceVisitArrivalRadiusPreset(payload.arrival_radius_m));
                }
                els.facebook.value    = payload.facebook_url    || '';
                els.instagram.value   = payload.instagram_url   || '';
                els.twitter.value     = payload.twitter_url     || '';
                if (els.linkedin) els.linkedin.value = payload.linkedin_url || '';
                els.youtube.value     = payload.youtube_url     || '';
                els.tiktok.value      = payload.tiktok_url      || '';

                if (canEditDomain) {
                    if (els.slugInput) {
                        els.slugInput.value = payload.subdomain_slug || '';
                    }
                    // Custom-domain hydration. Soft-keep semantics: the
                    // input always holds the remembered string (so a user
                    // who toggled off can see what to toggle back on); the
                    // active pane is derived from custom_domain_active.
                    if (els.customDomain) {
                        els.customDomain.value = payload.custom_domain || '';
                    }
                    var initialDomainMode = (payload.custom_domain && payload.custom_domain_active)
                        ? 'custom'
                        : 'subdomain';
                    setDomainPane(initialDomainMode, /* userInitiated */ false);
                    setCustomDomainPip('neutral');
                    clearDomainCheckResult();
                } else {
                    pingSetDomainReadonlyLink(els.domainReadonlyLink, payload.subdomain_slug);
                }

                // Logo preview from existing logo_url. Painted as a
                // CSS background-image on the .gfe-edit-hero-img
                // div; the .is-loaded class fades it in once the
                // image is decoded so the swap is smooth (no flash
                // of the magenta gradient at full opacity through
                // a half-loaded image). When no logo is set, the
                // .gfe-edit-hero-fallback glyph stays visible thanks
                // to the sibling-combinator CSS rule.
                // Jutdee inline setup keeps the location-view hero —
                // sync that surface instead of the (hidden) edit hero.
                setHeroImage(payload.logo_url || null);

                // Reset slug pip + Save button to neutral state. The
                // input listener below will re-evaluate as soon as
                // the user types — and a no-change keep-current-slug
                // submit doesn't need the pip to be green to pass.
                if (canEditDomain) {
                    setSlugPip('neutral');
                }
                els.save.disabled = false;
                els.save.classList.remove('is-saving');

                // Clear any leftover error states from a previous open.
                clearAllErrors();

                // Snapshot for dirty-check on close.
                formState.pristine = collectFormValues();

                if (jutdeeInline) {
                    if (typeof window.enterJutdeeLocationViewSetup === 'function') {
                        window.enterJutdeeLocationViewSetup(jutdeeSection || 'address');
                    }
                    // No autofocus — iOS would pop the keyboard over the form.
                    return;
                }

                // Show the modal. removeAttribute('hidden') first
                // because the [hidden] attribute would otherwise
                // override display:flex from .visible.
                modalEl.removeAttribute('hidden');
                // Force a reflow before adding .visible so the bounce
                // animation reliably plays from frame 0 — without this
                // the browser may collapse the display:none → display:
                // flex transition into a single frame and skip the
                // anim.
                /* eslint-disable no-unused-expressions */
                modalEl.offsetHeight;
                /* eslint-enable no-unused-expressions */
                modalEl.classList.add('visible');

                // Autofocus the title field after the bounce settles
                // (~800ms) so the focus ring doesn't fight the entry
                // animation.
                setTimeout(function () {
                    if (modalEl.classList.contains('visible')) {
                        try { els.title.focus({ preventScroll:true }); } catch(e) { els.title.focus(); }
                    }
                }, 820);
            }
            window.openGfeEditModal = openGfeEditModal;
            window.closeGfeEditModal = hide;

            function gfeSocialHostMeta(key) {
                var map = {
                    facebook:  { prefix: 'https://facebook.com/',  hosts: ['facebook.com', 'fb.com', 'fb.me'] },
                    instagram: { prefix: 'https://instagram.com/', hosts: ['instagram.com'] },
                    twitter:   { prefix: 'https://x.com/',         hosts: ['x.com', 'twitter.com'] },
                    youtube:   { prefix: 'https://youtube.com/',   hosts: ['youtube.com', 'youtu.be'] },
                    tiktok:    { prefix: 'https://tiktok.com/@',   hosts: ['tiktok.com'] },
                };
                return map[key] || null;
            }
            window.gfeSocialHostMeta = gfeSocialHostMeta;

            function gfeSocialToPath(key, raw) {
                var meta = gfeSocialHostMeta(key);
                var v = String(raw == null ? '' : raw).trim();
                if (!v || !meta) return '';
                var pref = meta.prefix;
                if (v.toLowerCase().indexOf(pref.toLowerCase()) === 0) {
                    v = v.slice(pref.length);
                    if (key === 'tiktok') v = v.replace(/^@+/, '');
                    return v.replace(/^\/+/, '').toLowerCase();
                }
                var looksFull = /^[a-z][a-z0-9+.-]*:\/\//i.test(v);
                if (!looksFull) {
                    var lower = v.toLowerCase().replace(/^\/+/, '');
                    for (var hi = 0; hi < meta.hosts.length; hi++) {
                        var hd = meta.hosts[hi];
                        if (lower === hd || lower.indexOf(hd + '/') === 0 || lower.indexOf('www.' + hd + '/') === 0 || lower.indexOf('www.' + hd) === 0) {
                            looksFull = true;
                            break;
                        }
                    }
                }
                if (!looksFull) {
                    v = v.replace(/^\/+/, '');
                    if (key === 'tiktok') v = v.replace(/^@+/, '');
                    return v.toLowerCase();
                }
                try {
                    var withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(v) ? v : ('https://' + v.replace(/^\/+/, ''));
                    var u = new URL(withScheme);
                    var host = String(u.hostname || '').toLowerCase().replace(/^www\./, '');
                    var ok = false;
                    for (var i = 0; i < meta.hosts.length; i++) {
                        var d = meta.hosts[i];
                        if (host === d || host.slice(-(d.length + 1)) === '.' + d) {
                            ok = true;
                            break;
                        }
                    }
                    if (!ok) {
                        return v.replace(/^\/+/, '').toLowerCase();
                    }
                    if (host === 'youtu.be') {
                        var vid = String(u.pathname || '').replace(/^\/+/, '');
                        return vid ? ('watch?v=' + vid).toLowerCase() : '';
                    }
                    var path = String(u.pathname || '').replace(/^\/+/, '');
                    if (key === 'tiktok') path = path.replace(/^@+/, '');
                    if (u.search) path += u.search;
                    if (u.hash) path += u.hash;
                    return path.toLowerCase();
                } catch (err) {
                    return v.replace(/^\/+/, '').toLowerCase();
                }
            }
            window.gfeSocialToPath = gfeSocialToPath;

            function gfeSocialToFullUrl(key, raw) {
                var meta = gfeSocialHostMeta(key);
                var path = gfeSocialToPath(key, raw);
                if (!path || !meta) return '';
                return meta.prefix + path;
            }
            window.gfeSocialToFullUrl = gfeSocialToFullUrl;

            function socialFieldUrl(el, key) {
                if (!el) return '';
                var raw = String(el.value || '').trim();
                if (el.getAttribute('data-gfe-social-path-mode') === '1') {
                    return gfeSocialToFullUrl(key, raw);
                }
                return raw.toLowerCase();
            }

            function collectFormValues() {
                var values = {
                    title:           els.title.value.trim(),
                    description:     els.description.value.trim(),
                    address:         els.address.value.trim(),
                    show_location_on_map: !!(els.showOnMap && els.showOnMap.checked),
                    phone:           els.phone.value.trim(),
                    website:         els.website.value.trim(),
                    facebook_url:    socialFieldUrl(els.facebook, 'facebook'),
                    instagram_url:   socialFieldUrl(els.instagram, 'instagram'),
                    twitter_url:     socialFieldUrl(els.twitter, 'twitter'),
                    linkedin_url:    els.linkedin ? els.linkedin.value.trim() : '',
                    youtube_url:     socialFieldUrl(els.youtube, 'youtube'),
                    tiktok_url:      socialFieldUrl(els.tiktok, 'tiktok'),
                    image_data:      formState.pendingLogo, // null if untouched
                    // Visit-rewards minimum-stay preset. Mechanic is
                    // always-on; this is the only owner-tunable knob.
                    visit_duration_minutes: els.visitDuration
                        ? coerceVisitDurationPreset(els.visitDuration.value)
                        : 5,
                    arrival_radius_m: els.visitArrivalRadius
                        ? coerceVisitArrivalRadiusPreset(els.visitArrivalRadius.value)
                        : 15,
                };
                if (!canEditDomain) return values;
                var domainMode = (els.domainModeInput && els.domainModeInput.value) || 'subdomain';
                values.subdomain_slug = els.slugInput ? els.slugInput.value.trim().toLowerCase() : '';
                values.domain_mode = domainMode;
                // Always send the current value so the backend can
                // persist it on switch-to-custom OR toggle-back-to-
                // subdomain (the latter keeps the string for
                // pre-fill on next open without requiring a new
                // entry). Backend ignores it when domain_mode is
                // 'subdomain'.
                values.custom_domain = els.customDomain ? els.customDomain.value.trim().toLowerCase() : '';
                return values;
            }

            function locationPayloadReadyToPublish(data) {
                if (!data) return false;
                var hasLogo = !!(data.logo_url && String(data.logo_url).trim());
                var slug = data.subdomain_slug ? String(data.subdomain_slug).trim() : '';
                if (!hasLogo || slug.length < 2) return false;
                // Visit mechanic is always-on and self-defaults its
                // minimum dwell, so it never blocks publishing.
                return true;
            }

            function publishLocationIfReady(id, saved) {
                if (!id || !saved || saved.is_public || !locationPayloadReadyToPublish(saved)) {
                    return Promise.resolve(saved || {});
                }
                var csrfMeta = document.querySelector('meta[name="csrf-token"]');
                var csrf = csrfMeta ? csrfMeta.getAttribute('content') : '';
                return fetch('/user-locations/' + encodeURIComponent(id) + '/publish', {
                    method: 'PATCH',
                    credentials: 'same-origin',
                    headers: {
                        'Accept':           'application/json',
                        'Content-Type':     'application/json',
                        'X-CSRF-TOKEN':     csrf,
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify({ is_public: true }),
                }).then(function (resp) {
                    return resp.text().then(function (txt) {
                        var json = {};
                        if (txt) {
                            try { json = JSON.parse(txt); } catch (pe) { /* non-JSON */ }
                        }
                        if (!resp.ok || !json || json.status !== 'success') {
                            return saved;
                        }
                        var hp = json.home_point || {};
                        var merged = {};
                        for (var k in saved) {
                            if (Object.prototype.hasOwnProperty.call(saved, k)) merged[k] = saved[k];
                        }
                        merged.is_public = !!(hp.is_public);
                        if (hp.subdomain_slug) merged.subdomain_slug = hp.subdomain_slug;
                        return merged;
                    });
                }).catch(function () {
                    return saved;
                });
            }

            function setSlugPip(state) {
                if (!els.slugPip) return;
                // Manage the four pip states explicitly so an unknown
                // string from a future caller doesn't leave the pip
                // stuck in its previous look.
                els.slugPip.classList.remove('is-checking', 'is-ok', 'is-bad');
                if (state === 'checking') els.slugPip.classList.add('is-checking');
                else if (state === 'ok')  els.slugPip.classList.add('is-ok');
                else if (state === 'bad') els.slugPip.classList.add('is-bad');
                // 'neutral' = no class added; pip is invisible
            }

            // ── Domain mode toggle helpers ────────────────────────────
            // Hidden gfeEditFieldDomainMode input is the canonical
            // truth so the form submit reads a single string instead
            // of inferring from DOM state. setDomainPane keeps the
            // tablist's aria-selected, the panes' [hidden] attribute,
            // and the hidden input in sync — any one of those reading
            // out of step would leave a confusing UI.
            function setDomainPane(mode, userInitiated) {
                if (!els.domainModeInput) return;
                var next = (mode === 'custom') ? 'custom' : 'subdomain';

                els.domainModeInput.value = next;

                if (els.domainTabSub && els.domainTabCustom) {
                    var subActive = (next === 'subdomain');
                    els.domainTabSub.setAttribute('aria-selected',    subActive ? 'true' : 'false');
                    els.domainTabCustom.setAttribute('aria-selected', subActive ? 'false' : 'true');
                    els.domainTabSub.classList.toggle('is-active',    subActive);
                    els.domainTabCustom.classList.toggle('is-active', !subActive);
                }
                if (els.domainPaneSub)    els.domainPaneSub.hidden    = (next !== 'subdomain');
                if (els.domainPaneCustom) els.domainPaneCustom.hidden = (next !== 'custom');

                // Save button must NOT inherit a stale "disabled by
                // slug pip" state when the user moves to the custom
                // pane (where the slug pip's verdict is irrelevant)
                // or back from custom to subdomain (where the custom
                // pip's verdict is irrelevant). Only re-enable on
                // user-initiated switches so the initial open doesn't
                // trample a programmatic disable.
                if (userInitiated && els.save) {
                    els.save.disabled = false;
                    els.save.classList.remove('is-saving');
                }
            }

            function setCustomDomainPip(state) {
                if (!els.customDomainPip) return;
                els.customDomainPip.classList.remove('is-checking', 'is-ok', 'is-bad');
                if (state === 'checking') els.customDomainPip.classList.add('is-checking');
                else if (state === 'ok')  els.customDomainPip.classList.add('is-ok');
                else if (state === 'bad') els.customDomainPip.classList.add('is-bad');
            }

            function clearDomainCheckResult() {
                if (!els.domainCheckResult) return;
                els.domainCheckResult.textContent = '';
                els.domainCheckResult.className = 'gfe-domain-check-result';
            }

            function setDomainCheckResult(status, message) {
                if (!els.domainCheckResult) return;
                els.domainCheckResult.textContent = message || '';
                // Drop any prior status modifier and add the new one
                // so the colour reflects the latest answer.
                els.domainCheckResult.className = 'gfe-domain-check-result is-' + (status || 'unknown');
            }

            function clearAllErrors() {
                var fields = els.form.querySelectorAll('.gfe-edit-field.has-error');
                for (var i = 0; i < fields.length; i++) {
                    fields[i].classList.remove('has-error');
                }
                var errs = els.form.querySelectorAll('[data-gfe-edit-error]');
                for (var j = 0; j < errs.length; j++) {
                    errs[j].textContent = '';
                }
            }

            function setFieldError(fieldName, message) {
                var errEl = els.form.querySelector('[data-gfe-edit-error="' + fieldName + '"]');
                if (!errEl) return;
                errEl.textContent = message;
                var parent = errEl.closest('.gfe-edit-field');
                if (parent) parent.classList.add('has-error');
            }

            // ── 3. logo upload (Cropper.js → 16:9 → WebP) ────────────
            // Mirrors the dashboard's location-image cropper at
            // resources/views/user/dashboard.blade.php (search for
            // openLocationCropModal). Cropper.js v1.5.12 is loaded
            // from CDN inside @auth in ping-landing.blade.php, so
            // by the time the user clicks Change Logo it's ready.
            //
            // Flow:
            //   1. logoBtn click → open hidden file input
            //   2. file picked → FileReader.readAsDataURL → mount
            //      <img> inside #gfeEditCropArea + new Cropper(...)
            //      with aspectRatio:16/9 (matches the read-only
            //      detail modal's hero band)
            //   3. Apply → cropper.getCroppedCanvas({width:800,
            //      height:450}).toDataURL('image/webp', 0.9) →
            //      stash on formState.pendingLogo, paint as the
            //      hero background, close crop modal
            //   4. Cancel/Close → destroy cropper, close crop
            //      modal, reset file input

            // Paint a URL (remote http(s) or local data:) as the
            // hero background-image. Preloads via a throw-away
            // Image so the .is-loaded fade-in only kicks in once
            // the source is decoded. Passing null clears the
            // background and reveals the fallback glyph.
            function setHeroImage(url) {
                els.logoPreview.classList.remove('is-loaded');
                if (!url) {
                    els.logoPreview.style.backgroundImage = '';
                } else {
                    var pre = new Image();
                    pre.onload = function () {
                        // Quote-safe inline url() — same escaping
                        // pattern the importer's bg-image rule uses.
                        var safe = String(url).replace(/'/g, '%27').replace(/"/g, '%22');
                        els.logoPreview.style.backgroundImage = "url('" + safe + "')";
                        els.logoPreview.classList.add('is-loaded');
                    };
                    pre.onerror = function () {
                        els.logoPreview.style.backgroundImage = '';
                    };
                    pre.src = url;
                }
                if (formState.jutdeeInline && typeof window.paintJutdeeLocationViewHero === 'function') {
                    window.paintJutdeeLocationViewHero({
                        title: els.title ? els.title.value : '',
                        address: els.address ? els.address.value : '',
                        phone: els.phone ? els.phone.value : '',
                        logo_url: url || ''
                    });
                }
                if (formState.jutdeeInline && typeof window.syncJutdeeManageAddressSaveGate === 'function') {
                    try { window.syncJutdeeManageAddressSaveGate(); } catch (eGate) { /* noop */ }
                }
            }

            function syncJutdeeInlineHeroText() {
                if (!formState.jutdeeInline) return;
                if (typeof window.paintJutdeeLocationViewHero !== 'function') return;
                var logoUrl = '';
                if (formState.pendingLogo) {
                    logoUrl = formState.pendingLogo;
                } else {
                    var bg = els.logoPreview && els.logoPreview.style.backgroundImage;
                    if (bg && bg.indexOf('url(') === 0) {
                        logoUrl = bg.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
                    }
                    var locImg = document.getElementById('jutdeeLocationViewHeroImg');
                    if (!logoUrl && locImg && !locImg.hidden && locImg.src) {
                        logoUrl = locImg.src;
                    }
                }
                window.paintJutdeeLocationViewHero({
                    title: els.title ? els.title.value : '',
                    address: els.address ? els.address.value : '',
                    phone: els.phone ? els.phone.value : '',
                    logo_url: logoUrl
                });
            }
            if (els.title) {
                els.title.addEventListener('input', syncJutdeeInlineHeroText);
            }
            if (els.address) {
                els.address.addEventListener('input', syncJutdeeInlineHeroText);
            }
            if (els.phone) {
                els.phone.addEventListener('input', syncJutdeeInlineHeroText);
            }

            els.logoBtn.addEventListener('click', function (e) {
                e.preventDefault();
                els.logoInput.click();
            });

            els.logoInput.addEventListener('change', function (e) {
                var file = e.target.files && e.target.files[0];
                if (!file) return;

                // Cropper.js needs an <img> with a loaded src. We
                // use FileReader (same as the dashboard) rather
                // than URL.createObjectURL because Cropper's own
                // preload swap occasionally races the revoke on
                // ObjectURLs in older Safari builds.
                var reader = new FileReader();
                reader.onload = function (evt) {
                    openCropModal(evt.target.result);
                };
                reader.onerror = function () {
                    setFieldError('image_data', 'Could not read that image. Try a JPG, PNG, or WebP.');
                };
                reader.readAsDataURL(file);

                // Allow re-picking the same file twice in a row
                // (browsers won't fire `change` for an identical
                // selection unless the input is reset).
                els.logoInput.value = '';
            });

            // Hand the picked file off to the shared Cropper.js
            // singleton (defined above wireGfeEditModal). The onApply
            // callback is what makes this flow specific to the edit-
            // location form: stash the cropped data URL in formState
            // so the next form submit ships it as image_data, and
            // repaint the hero so the user sees their crop immediately.
            // No instance state is held in this closure — sharedCropper
            // owns the lifecycle (open/close/destroy) and its own Esc
            // handler, so destroying & rebuilding the location-edit
            // closure here cannot leave a dangling Cropper.
            function openCropModal(dataUrl) {
                sharedCropper.open(dataUrl, {
                    aspectRatio: 16 / 9,
                    onApply: function (croppedDataUrl) {
                        formState.pendingLogo = croppedDataUrl;
                        setHeroImage(croppedDataUrl);
                    },
                });
            }

            if (canEditDomain) {
            if (els.domainTabSub) {
                els.domainTabSub.addEventListener('click', function (e) {
                    e.preventDefault();
                    setDomainPane('subdomain', /* userInitiated */ true);
                });
            }
            if (els.domainTabCustom) {
                els.domainTabCustom.addEventListener('click', function (e) {
                    e.preventDefault();
                    setDomainPane('custom', /* userInitiated */ true);
                    if (els.customDomain && els.customDomain.value.trim()) {
                        runCustomDomainCheck();
                    }
                });
            }

            // ── 4. slug availability (debounced) ─────────────────────
            // Hits GET /user-locations/check-slug?slug=X&exclude_id=Y.
            // The endpoint already excludes the current row when
            // exclude_id matches, so the user can keep their
            // existing slug without it falsely reporting "taken".
            var slugCheckTimer = null;
            var slugCheckSeq   = 0; // ignore stale responses if the
                                    // user keeps typing past an
                                    // in-flight request
            function runSlugCheck() {
                var slug = els.slugInput.value.trim().toLowerCase();
                // Empty slug = clearing it (the endpoint allows null/
                // empty in the PATCH payload to leave the field
                // untouched). Treat as neutral — Save stays enabled.
                if (!slug) {
                    setSlugPip('neutral');
                    els.save.disabled = false;
                    if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                        window.syncJutdeeSubdomainSaveGate();
                    }
                    return;
                }
                // No-change — keeping the original slug is always OK.
                if (slug === formState.originalSlug) {
                    setSlugPip('ok');
                    els.save.disabled = false;
                    if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                        window.syncJutdeeSubdomainSaveGate();
                    }
                    return;
                }
                // Min length matches the server-side rule (after
                // normalisation): < 2 chars is invalid before we
                // even hit the network.
                if (slug.length < 2) {
                    setSlugPip('bad');
                    els.save.disabled = true;
                    if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                        window.syncJutdeeSubdomainSaveGate();
                    }
                    return;
                }

                setSlugPip('checking');
                els.save.disabled = true; // hold Save until the
                                          // network round-trip
                                          // settles, OK or bad.
                if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                    window.syncJutdeeSubdomainSaveGate();
                }

                var mySeq = ++slugCheckSeq;
                var url = '/user-locations/check-slug'
                        + '?slug=' + encodeURIComponent(slug)
                        + '&exclude_id=' + encodeURIComponent(formState.id);
                fetch(url, {
                    method:      'GET',
                    credentials: 'same-origin',
                    headers:     { 'Accept': 'application/json' },
                }).then(function (r) {
                    return r.ok ? r.json() : { available: false };
                }).then(function (json) {
                    // Stale response — a newer request has been
                    // fired since this one started. Drop it on the
                    // floor so it can't override the current state.
                    if (mySeq !== slugCheckSeq) return;
                    var available = !!(json && json.available);
                    setSlugPip(available ? 'ok' : 'bad');
                    els.save.disabled = !available;
                    if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                        window.syncJutdeeSubdomainSaveGate();
                    }
                }).catch(function () {
                    if (mySeq !== slugCheckSeq) return;
                    setSlugPip('bad');
                    els.save.disabled = true;
                    if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                        window.syncJutdeeSubdomainSaveGate();
                    }
                });
            }
            els.slugInput.addEventListener('input', function () {
                var caret = els.slugInput.selectionStart;
                var lower = String(els.slugInput.value || '').toLowerCase();
                if (els.slugInput.value !== lower) {
                    els.slugInput.value = lower;
                    try {
                        if (typeof caret === 'number') {
                            els.slugInput.setSelectionRange(caret, caret);
                        }
                    } catch (caretErr) { /* noop */ }
                }
                clearTimeout(slugCheckTimer);
                slugCheckTimer = setTimeout(runSlugCheck, 350);
                if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                    window.syncJutdeeSubdomainSaveGate();
                }
            });

            // ── 4b. custom-domain availability (debounced) ───────────
            // Mirrors runSlugCheck but hits the parallel /check-custom-
            // domain endpoint. Same stale-response guard (mySeq vs
            // domainCheckSeq) so a fast typist doesn't see a flicker
            // from an in-flight earlier request resolving after a
            // newer one. Save button is gated on the custom pane's
            // own pip when the user is in custom mode.
            var domainCheckTimer = null;
            var domainCheckSeq   = 0;
            function runCustomDomainCheck() {
                if (!els.customDomain) return;
                var raw = els.customDomain.value.trim().toLowerCase();
                if (!raw) {
                    setCustomDomainPip('neutral');
                    if (els.save) els.save.disabled = false;
                    return;
                }

                // Same FQDN sanity check the backend applies. Avoid
                // a network round-trip when the input clearly isn't
                // a hostname yet (no dot, single label).
                if (raw.indexOf('.') < 0 || raw.length < 4) {
                    setCustomDomainPip('bad');
                    if (els.save) els.save.disabled = true;
                    return;
                }

                setCustomDomainPip('checking');
                if (els.save) els.save.disabled = true;

                var mySeq = ++domainCheckSeq;
                var url = '/user-locations/check-custom-domain'
                        + '?domain=' + encodeURIComponent(raw)
                        + '&exclude_id=' + encodeURIComponent(formState.id);
                fetch(url, {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { 'Accept': 'application/json' },
                }).then(function (r) {
                    return r.ok ? r.json() : { available: false };
                }).then(function (json) {
                    if (mySeq !== domainCheckSeq) return;
                    var available = !!(json && json.available);
                    setCustomDomainPip(available ? 'ok' : 'bad');
                    if (els.save) els.save.disabled = !available;
                }).catch(function () {
                    if (mySeq !== domainCheckSeq) return;
                    setCustomDomainPip('bad');
                    if (els.save) els.save.disabled = true;
                });
            }
            if (els.customDomain) {
                els.customDomain.addEventListener('input', function () {
                    clearTimeout(domainCheckTimer);
                    // Propagation result becomes meaningless the
                    // moment the user types a different hostname.
                    clearDomainCheckResult();
                    domainCheckTimer = setTimeout(runCustomDomainCheck, 350);
                });
            }

            // ── 4c. DNS propagation check button ─────────────────────
            // Calls the throttled /check-domain-propagation endpoint
            // and renders the JSON status into .gfe-domain-check-
            // result. The button is disabled while the request is in
            // flight to prevent rapid-fire clicks from chewing the
            // 10/min throttle bucket.
            if (els.domainCheckBtn) {
                els.domainCheckBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (!formState.id) {
                        setDomainCheckResult('lookup_failed', 'Save your custom domain first, then check propagation.');
                        return;
                    }
                    var typed = els.customDomain ? els.customDomain.value.trim() : '';
                    if (!typed) {
                        setDomainCheckResult('lookup_failed', 'Enter a domain first.');
                        return;
                    }

                    els.domainCheckBtn.disabled = true;
                    els.domainCheckBtn.classList.add('is-loading');
                    setDomainCheckResult('checking', 'Checking DNS…');

                    var url = '/user-locations/' + encodeURIComponent(formState.id) + '/check-domain-propagation';
                    fetch(url, {
                        method: 'GET',
                        credentials: 'same-origin',
                        headers: { 'Accept': 'application/json' },
                    }).then(function (r) {
                        return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
                    }).then(function (result) {
                        els.domainCheckBtn.disabled = false;
                        els.domainCheckBtn.classList.remove('is-loading');

                        if (result.status === 422 && result.json && result.json.message) {
                            setDomainCheckResult('lookup_failed', result.json.message);
                            return;
                        }
                        if (result.status === 429) {
                            setDomainCheckResult('lookup_failed', 'Too many checks in a short time. Wait a minute and try again.');
                            return;
                        }
                        if (!result.ok || !result.json) {
                            setDomainCheckResult('lookup_failed', 'Could not run the DNS check right now.');
                            return;
                        }
                        var st  = result.json.status  || 'unknown';
                        var msg = result.json.message || '';
                        setDomainCheckResult(st, msg);
                    }).catch(function () {
                        els.domainCheckBtn.disabled = false;
                        els.domainCheckBtn.classList.remove('is-loading');
                        setDomainCheckResult('lookup_failed', 'Network error. Please try again.');
                    });
                });
            }
            } // canEditDomain

            // ── 5. submit → PATCH ────────────────────────────────────
            function saveGfeEditForm(opts) {
                opts = opts || {};
                var quiet = !!opts.quiet;
                var socialKey = opts.socialKey || null;
                // Subdomain section, unchanged slug: treat Save as
                // "Back To Your Businesses" (no PATCH / no debit).
                if (!quiet && formState.jutdeeInline
                    && formState.jutdeeSection === 'subdomain'
                    && els.save
                    && els.save.getAttribute('data-jutdee-subdomain-back') === '1') {
                    if (typeof window.returnToFocalPointsFromLocationView === 'function') {
                        try { window.returnToFocalPointsFromLocationView(); } catch (backErr) { /* noop */ }
                    }
                    return Promise.resolve({ skipped: true });
                }
                // Underfunded subdomain gate: the progress bar is shown in
                // place of Save (CSS hides the button but Enter in the slug
                // field can still submit). Block it so no optimistic debit
                // flashes and the server 400 is never provoked.
                if (formState.jutdeeInline && formState.jutdeeSection === 'subdomain') {
                    var luckModal = document.getElementById('jutdeeLocationViewModal');
                    if (luckModal && luckModal.classList.contains('is-subdomain-luck-locked')) {
                        return Promise.resolve({ skipped: true });
                    }
                }
                // Single-flight: a PATCH is already pending for this form.
                // Ignore re-submits so a double-click can't fire two saves
                // (and, on a paid subdomain change, two debits).
                if (formState.saving) {
                    return Promise.resolve({ skipped: true, saving: true });
                }
                if (!quiet && els.save && els.save.disabled) {
                    var msg = 'Complete the required fields before saving.';
                    if (canEditDomain) {
                        var slug = els.slugInput ? els.slugInput.value.trim().toLowerCase() : '';
                        var onCustom = els.domainModeInput && els.domainModeInput.value === 'custom';
                        msg = onCustom
                            ? 'Wait for the domain check to finish, or fix the domain field, before saving.'
                            : (slug && slug !== formState.originalSlug && slug.length >= 2)
                                ? 'Wait for the subdomain check to finish, or choose a different subdomain, before saving.'
                                : msg;
                    }
                    try { window.alert(msg); } catch (alertErr) { /* noop */ }
                    return Promise.resolve({ skipped: true });
                }

                var values = collectFormValues();
                var csrfMeta = document.querySelector('meta[name="csrf-token"]');
                var csrf = csrfMeta ? csrfMeta.getAttribute('content') : '';

                // Strip out image_data when no new logo was picked,
                // so we don't send a literal `null` and trigger the
                // controller's regex test on it (it would fail
                // because null is also "not a base64 data URL").
                var body = {};
                for (var k in values) {
                    if (!Object.prototype.hasOwnProperty.call(values, k)) continue;
                    if (k === 'image_data' && !values[k]) continue;
                    if (values[k] === undefined) continue;
                    body[k] = values[k];
                }

                clearAllErrors();
                if (!quiet && els.save) {
                    els.save.classList.add('is-saving');
                    els.save.disabled = true;
                }

                var paidSubdomainChange = !!(!quiet
                    && formState.jutdeeInline
                    && formState.jutdeeSection === 'subdomain'
                    && typeof window.isJutdeeSubdomainSlugChanged === 'function'
                    && window.isJutdeeSubdomainSlugChanged());
                var preAuraBalance = null;
                if (paidSubdomainChange && typeof window.updateAuraPills === 'function') {
                    // Authoritative balance, not the pill's animating text —
                    // reading textContent mid-tween captures a wrong midpoint
                    // and corrupts the optimistic debit / rollback.
                    if (typeof window.getCurrentAuraBalance === 'function') {
                        preAuraBalance = window.getCurrentAuraBalance();
                    }
                    if (preAuraBalance == null) {
                        var auraElPre = document.querySelector('.spin-intro-floating-corner-bar [data-spin-aura-count]')
                            || document.querySelector('[data-spin-aura-count]');
                        if (auraElPre) {
                            preAuraBalance = parseInt((auraElPre.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
                        }
                    }
                    var cost = typeof window.jutdeeSubdomainUpdateCost === 'function'
                        ? window.jutdeeSubdomainUpdateCost()
                        : 4000;
                    if (preAuraBalance != null) {
                        window.updateAuraPills(Math.max(0, preAuraBalance - cost));
                    }
                }

                formState.saving = true;
                return fetch('/user-locations/' + encodeURIComponent(formState.id), {
                    method: 'PATCH',
                    credentials: 'same-origin',
                    headers: {
                        'Accept':         'application/json',
                        'Content-Type':   'application/json',
                        'X-CSRF-TOKEN':   csrf,
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify(body),
                }).then(function (resp) {
                    return resp.text().then(function (txt) {
                        var json = {};
                        if (txt) {
                            try { json = JSON.parse(txt); } catch (pe) { /* HTML error page, etc. */ }
                        }
                        return { ok: resp.ok, status: resp.status, json: json };
                    });
                }).then(function (result) {
                    if (!quiet && els.save) els.save.classList.remove('is-saving');

                    if (result.ok && result.json && result.json.status === 'success') {
                        var saved = result.json.data || {};
                        if (paidSubdomainChange && typeof window.updateAuraPills === 'function') {
                            var serverBal = result.json.new_aura_balance;
                            if (serverBal == null && saved && saved.new_aura_balance != null) {
                                serverBal = saved.new_aura_balance;
                            }
                            if (serverBal != null && isFinite(parseInt(serverBal, 10))) {
                                window.updateAuraPills(parseInt(serverBal, 10));
                            }
                        }
                        return publishLocationIfReady(formState.id, saved).then(function (finalData) {
                            // Successful save — update the tile in-place
                            // from the response data, then close. The
                            // pristine snapshot is reset so the close
                            // path doesn't think the form is still dirty.
                            try {
                                updateLocationTileInPlace(formState.id, finalData);
                            } catch (err) {
                                console.warn('[gfe-edit] in-place tile update failed', err);
                            }
                            try {
                                if (typeof propagateLocationPublishToCards === 'function') {
                                    propagateLocationPublishToCards(formState.id, finalData);
                                }
                            } catch (propErr) {
                                console.warn('[gfe-edit] propagateLocationPublishToCards failed', propErr);
                            }
                            try {
                                document.dispatchEvent(new CustomEvent('gfe-location-edited', {
                                    detail: {
                                        id:   formState.id,
                                        data: finalData
                                    }
                                }));
                            } catch (err) {
                                console.warn('[gfe-edit] gfe-location-edited dispatch failed', err);
                            }
                            formState.pristine = collectFormValues();
                            if (finalData.subdomain_slug) {
                                formState.originalSlug = String(finalData.subdomain_slug).toLowerCase();
                                try { window.__gfeEditOriginalSlug = formState.originalSlug; } catch (e) { /* noop */ }
                            }
                            if (formState.jutdeeInline) {
                                if (typeof window.syncJutdeeLocationViewPayload === 'function') {
                                    try { window.syncJutdeeLocationViewPayload(finalData); } catch (syncErr) {
                                        console.warn('[gfe-edit] jutdee payload sync failed', syncErr);
                                    }
                                }
                                if (quiet) {
                                    if (typeof opts.onQuietSuccess === 'function') {
                                        try { opts.onQuietSuccess(finalData, socialKey); } catch (qErr) { /* noop */ }
                                    }
                                    if (els.save) els.save.disabled = false;
                                    return { ok: true, quiet: true, data: finalData };
                                }
                                if (formState.jutdeeManage) {
                                    if (formState.jutdeeSection === 'subdomain'
                                        && typeof window.showJutdeeLocationViewSetupComplete === 'function') {
                                        try {
                                            window.showJutdeeLocationViewSetupComplete(finalData, {
                                                variant: 'subdomainUpdated'
                                            });
                                        } catch (doneErr) {
                                            console.warn('[gfe-edit] jutdee subdomain-updated failed', doneErr);
                                        }
                                        hide(true);
                                        return;
                                    }
                                    if (typeof window.returnToJutdeeLocationViewMenu === 'function') {
                                        try { window.returnToJutdeeLocationViewMenu(); } catch (menuErr) {
                                            console.warn('[gfe-edit] jutdee return-to-menu failed', menuErr);
                                        }
                                    }
                                    hide(true);
                                    return;
                                }
                                if (typeof window.showJutdeeLocationViewSetupComplete === 'function') {
                                    if (typeof window.completePostImportSetupAfterSave === 'function') {
                                        window.completePostImportSetupAfterSave();
                                    }
                                    try {
                                        window.showJutdeeLocationViewSetupComplete(finalData);
                                    } catch (doneErr) {
                                        console.warn('[gfe-edit] jutdee setup-complete failed', doneErr);
                                    }
                                    hide(true);
                                    return;
                                }
                            }
                            if (finalData.is_public && finalData.subdomain_slug) {
                                var liveUrl = 'https://' + window.gfeSubdomainHost(String(finalData.subdomain_slug).toLowerCase()) + '/';
                                try {
                                    window.alert('Your location is now live at ' + liveUrl);
                                } catch (alertErr) { /* noop */ }
                            } else if (locationPayloadReadyToPublish(finalData) && !finalData.is_public) {
                                try {
                                    window.alert('Saved, but publishing did not complete. Use the Publish chip on your location card, or try Save again.');
                                } catch (alertErr2) { /* noop */ }
                            }
                            if (typeof window.completePostImportSetupAfterSave === 'function') {
                                window.completePostImportSetupAfterSave();
                            }
                            hide(true);
                        });
                    }

                    // Validation failure — render inline field errors.
                    // Laravel returns either {message, errors:{field:[msg]}}
                    // for $request->validate failures, or {status:'error',
                    // field, message} for the controller's manual 422s
                    // (slug rules, social host allowlist).
                    if (paidSubdomainChange && typeof window.updateAuraPills === 'function') {
                        var failBal = result.json && result.json.new_aura_balance;
                        if (failBal != null && isFinite(parseInt(failBal, 10))) {
                            window.updateAuraPills(parseInt(failBal, 10));
                        } else if (preAuraBalance != null) {
                            window.updateAuraPills(preAuraBalance);
                        }
                    }
                    if (result.status === 400 && result.json && result.json.message) {
                        if (!quiet) {
                            try { window.alert(result.json.message); } catch (alertErr400) { /* noop */ }
                        }
                        if (els.save) els.save.disabled = false;
                        if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                            window.syncJutdeeSubdomainSaveGate();
                        }
                        return { ok: false, status: result.status };
                    }
                    if (result.status === 422 && result.json) {
                        if (result.json.errors) {
                            for (var f in result.json.errors) {
                                if (!Object.prototype.hasOwnProperty.call(result.json.errors, f)) continue;
                                var msgs = result.json.errors[f];
                                setFieldError(f, Array.isArray(msgs) ? msgs[0] : String(msgs));
                            }
                        } else if (result.json.field && result.json.message) {
                            setFieldError(result.json.field, result.json.message);
                        } else if (result.json.message) {
                            // Fall back to the slug error slot for an
                            // unattributed message — this is rare but
                            // keeps the user from seeing a silent fail.
                            setFieldError('subdomain_slug', result.json.message);
                        }
                        if (els.save) els.save.disabled = false;
                        if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                            window.syncJutdeeSubdomainSaveGate();
                        }
                        return { ok: false, status: 422 };
                    }

                    // Network / 5xx — surface a single generic error.
                    setFieldError('title', 'Could not save changes. Please try again.');
                    if (els.save) els.save.disabled = false;
                    if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                        window.syncJutdeeSubdomainSaveGate();
                    }
                    return { ok: false };
                }).catch(function (err) {
                    console.warn('[gfe-edit] PATCH failed', err);
                    if (!quiet && els.save) els.save.classList.remove('is-saving');
                    if (paidSubdomainChange && preAuraBalance != null
                        && typeof window.updateAuraPills === 'function') {
                        window.updateAuraPills(preAuraBalance);
                    }
                    setFieldError('title', 'Network error. Please check your connection and try again.');
                    if (els.save) els.save.disabled = false;
                    if (typeof window.syncJutdeeSubdomainSaveGate === 'function') {
                        window.syncJutdeeSubdomainSaveGate();
                    }
                    return { ok: false, error: err };
                }).finally(function () {
                    formState.saving = false;
                });
            }
            window.saveGfeEditForm = saveGfeEditForm;

            els.form.addEventListener('submit', function (e) {
                e.preventDefault();
                saveGfeEditForm({});
            });

            // ── 6. updateLocationTileInPlace ─────────────────────────
            // Mirrors the partial's render logic in JS so the edited
            // tile reflects the new values without a full reload.
            // Source-of-truth here: gamifeye-importer.blade.php's
            // foreach (lines ~144–360). Drift between the two paths
            // would only show after a fresh page load (when the
            // partial re-renders), so a same-session save always
            // looks correct.
            function removeLocationTileById(id) {
                if (id == null) return;
                var enc = String(id).replace(/"/g, '\\"');
                var li = document.querySelector(
                    'li.gfe-loc-item:not(.is-tour)[data-gfe-loc-id="' + enc + '"]'
                ) || document.querySelector('li[data-gfe-loc-id="' + enc + '"]:not(.is-tour)');
                if (li && li.parentNode) li.parentNode.removeChild(li);
            }

            function removeSlide1CarouselCardById(id) {
                if (id == null) return;
                var enc = String(id).replace(/"/g, '\\"');
                var card = document.querySelector(
                    '#pingFpLocationsList .ping-fp-location-item[data-fpid="' + enc + '"]'
                );
                if (card && card.parentNode) card.parentNode.removeChild(card);
            }

            function exitFocusedFlyinAfterDelete(deletedId) {
                var wasFocused = document.body.classList.contains('is-gfe-focused');
                var wasCurrent = _pingHeroFlyinData && String(_pingHeroFlyinData.id) === String(deletedId);
                if (!wasFocused && !wasCurrent) return;
                document.body.classList.remove('is-gfe-focused');
                clearSpinFlyinLocationTitle();
                clearPingHeroLocationImage();
                clearPingHeroSocials();
                clearPingHeroEditBtn();
                clearPingHeroStampBtn();
                try { resetGfeMapOverlays(); } catch (err) {}
                try { restoreGlobeFraming(900); } catch (err2) {}
                setTimeout(function () {
                    try { showIntro(); } catch (err3) {}
                }, 900);
            }

            function updateLocationTileInPlace(id, data) {
                var li = document.querySelector('li.gfe-loc-item[data-gfe-loc-id="' + id + '"]');
                if (!li) return;

                // ── Update the data-gfe-loc-payload first so any
                //    subsequent open of THIS tile's edit modal (or
                //    the read-only detail modal) sees the new
                //    values. We MERGE the response data into the
                //    existing payload so fields the endpoint
                //    doesn't return (e.g. lat/lng, place_url,
                //    google_place_id, rating, review_count,
                //    primary_category) survive the edit.
                var existingPayload = {};
                try {
                    existingPayload = JSON.parse(li.getAttribute('data-gfe-loc-payload') || '{}');
                } catch (err) { /* keep empty */ }
                var newPayload = Object.assign({}, existingPayload, data);
                li.setAttribute('data-gfe-loc-payload', JSON.stringify(newPayload));

                // Mirror flat data-* attrs the importer's click
                // handler reads when the JSON payload is missing.
                if (typeof data.title !== 'undefined')          li.setAttribute('data-gfe-loc-title', data.title || '');
                if (typeof data.logo_url !== 'undefined')       li.setAttribute('data-gfe-loc-logo',  data.logo_url || '');
                if (typeof data.subdomain_slug !== 'undefined') li.setAttribute('data-gfe-loc-slug',  data.subdomain_slug || '');

                // Background image (the tile is full-bleed). Quotes
                // in the URL would break the inline style, so apply
                // via the CSSOM rather than as a string attribute.
                if (data.logo_url) {
                    li.classList.add('has-bg-image');
                    li.style.backgroundImage = "url('" + String(data.logo_url).replace(/'/g, '%27').replace(/"/g, '%22') + "')";
                } else {
                    li.classList.remove('has-bg-image');
                    li.style.backgroundImage = '';
                }

                // Title text
                var titleEl = li.querySelector('.gfe-loc-item-title');
                if (titleEl) titleEl.textContent = data.title || 'Untitled';

                // Description excerpt — toggle visibility by
                // recreating the node so the partial's @if-gating
                // is faithfully reproduced (no empty <div>).
                var bodyEl = li.querySelector('.gfe-loc-item-body');
                var descEl = li.querySelector('.gfe-loc-item-desc');
                if (data.description) {
                    if (descEl) {
                        descEl.textContent = data.description;
                    } else if (bodyEl) {
                        var newDesc = document.createElement('div');
                        newDesc.className = 'gfe-loc-item-desc';
                        newDesc.textContent = data.description;
                        // Description sits between .gfe-loc-item-head
                        // and .gfe-loc-item-bottom in the partial.
                        var headEl = bodyEl.querySelector('.gfe-loc-item-head');
                        if (headEl && headEl.nextSibling) {
                            bodyEl.insertBefore(newDesc, headEl.nextSibling);
                        } else {
                            bodyEl.appendChild(newDesc);
                        }
                    }
                } else if (descEl) {
                    descEl.parentNode.removeChild(descEl);
                }

                // Address line in the bottom block
                var addrEl = li.querySelector('.gfe-loc-item-addr');
                var bottomEl = li.querySelector('.gfe-loc-item-bottom');
                if (data.address) {
                    if (addrEl) {
                        addrEl.textContent = data.address;
                    } else if (bottomEl) {
                        var newAddr = document.createElement('div');
                        newAddr.className = 'gfe-loc-item-addr';
                        newAddr.textContent = data.address;
                        bottomEl.insertBefore(newAddr, bottomEl.firstChild);
                    }
                } else if (addrEl) {
                    addrEl.parentNode.removeChild(addrEl);
                }

                // Phone + website action chips. Matching the
                // partial's website-vs-social dedup so a venue
                // whose website matches its Facebook URL only
                // shows the social icon (not the duplicate
                // magenta chip). Re-render the whole .gfe-loc-
                // item-actions container from scratch — simpler
                // than mutating individual <a>s, and cheap.
                rebuildActionChips(li, newPayload);

                // Socials — same approach: rebuild the full
                // socials cluster from the merged payload so
                // any added/removed network reflects instantly.
                rebuildSocialsCluster(li, newPayload);

                if (typeof syncLocationCardPublishUi === 'function') {
                    syncLocationCardPublishUi(li);
                }

                // Propagate the change into every cached tour
                // payload that references this home_point. The
                // tour cards (.gfe-loc-item.is-tour) bake their
                // full stops array (including each stop's logo_url
                // and title) into a JSON data-attr at server
                // render time so pingLandingFocusOnTour can hand
                // the same shape straight to the detail modal
                // without a refetch — and the visible thumbnail
                // strip on each card needs the same fresh logo_url
                // re-painted in place. Without this the tour-detail
                // stops list AND the card's stop strip keep
                // painting whatever URL was on disk when the page
                // loaded, so a freshly re-uploaded logo only
                // updates the location tile.
                propagateHomePointToTourPayloads(parseInt(id, 10), data);
            }

            function propagateHomePointToTourPayloads(homePointId, data) {
                if (!homePointId) return;

                // After the #spinHeroToursList compact list was
                // removed, tour cards live as .gfe-loc-item.is-tour
                // <li>s in the locations view. Each carries the same
                // stops payload shape on data-gfe-tour-payload PLUS
                // a visible thumbnail strip (.gfe-loc-item-stops) we
                // need to re-paint when a stop's logo changes.
                var rows = document.querySelectorAll('li.gfe-loc-item.is-tour[data-gfe-tour-payload]');
                rows.forEach(function (row) {
                    var raw = row.getAttribute('data-gfe-tour-payload');
                    if (!raw) return;
                    var payload;
                    try { payload = JSON.parse(raw); } catch (err) { return; }
                    if (!payload || !Array.isArray(payload.stops)) return;
                    var changed = false;
                    var stopIndexes = [];
                    payload.stops.forEach(function (s, idx) {
                        if (!s || parseInt(s.home_point_id, 10) !== homePointId) return;
                        if (typeof data.logo_url !== 'undefined') { s.logo_url = data.logo_url || null; changed = true; }
                        if (typeof data.title    !== 'undefined') { s.title    = data.title    || '';   changed = true; }
                        stopIndexes.push(idx);
                    });
                    if (changed) {
                        row.setAttribute('data-gfe-tour-payload', JSON.stringify(payload));
                        // Re-paint the visible thumbnail strip in
                        // place. Each .gfe-loc-item-stop is in stop-
                        // order, so the indices match payload.stops.
                        var stripChildren = row.querySelectorAll('.gfe-loc-item-stops .gfe-loc-item-stop');
                        stopIndexes.forEach(function (idx) {
                            var stop = payload.stops[idx];
                            var node = stripChildren[idx];
                            if (!node || !stop) return;
                            node.setAttribute('title', stop.title || '');
                            if (stop.logo_url) {
                                var img = node.querySelector('img');
                                if (img) {
                                    img.src = stop.logo_url;
                                } else {
                                    node.innerHTML = '<img src="' +
                                        String(stop.logo_url).replace(/"/g, '&quot;') +
                                        '" alt="" loading="lazy">';
                                }
                            } else {
                                node.innerHTML = '<span class="gfe-loc-item-stop-num">' + (idx + 1) + '</span>';
                            }
                        });
                    }
                });
            }

            function normUrl(u) {
                if (!u) return '';
                var s = String(u).toLowerCase().trim();
                s = s.replace(/^https?:\/\//, '');
                s = s.replace(/^\/\//, '');
                s = s.replace(/^www\./, '');
                return s.replace(/\/+$/, '');
            }

            function rebuildActionChips(li, payload) {
                var footer = li.querySelector('.gfe-loc-item-footer');
                if (!footer) return;
                var existing = footer.querySelector('.gfe-loc-item-actions');
                if (existing) existing.parentNode.removeChild(existing);

                // Same dedup as the Blade partial: hide website
                // chip when its normalised form matches any
                // populated social URL.
                var socials = collectSocialMap(payload);
                var nWeb = normUrl(payload.website);
                var websiteIsSocial = false;
                for (var k in socials) {
                    if (Object.prototype.hasOwnProperty.call(socials, k)) {
                        if (nWeb && normUrl(socials[k]) === nWeb) { websiteIsSocial = true; break; }
                    }
                }
                var showWebsite = !!payload.website && !websiteIsSocial;
                if (!payload.phone && !showWebsite) return;

                var box = document.createElement('div');
                box.className = 'gfe-loc-item-actions';

                if (payload.phone) {
                    var aPhone = document.createElement('a');
                    aPhone.href = 'tel:' + payload.phone;
                    aPhone.className = 'gfe-loc-item-action gfe-loc-item-action--icon';
                    aPhone.setAttribute('aria-label', 'Call ' + payload.phone);
                    aPhone.setAttribute('title', payload.phone);
                    aPhone.setAttribute('onclick', 'event.stopPropagation();');
                    aPhone.innerHTML = '<i class="bi bi-telephone-fill"></i>';
                    box.appendChild(aPhone);
                }
                if (showWebsite) {
                    var webDisplay = String(payload.website).replace(/^(https?:)?\/\//i, '').replace(/\/+$/, '');
                    var aWeb = document.createElement('a');
                    aWeb.href = payload.website;
                    aWeb.target = '_blank';
                    aWeb.rel = 'noopener';
                    aWeb.className = 'gfe-loc-item-action gfe-loc-item-action--web';
                    aWeb.setAttribute('aria-label', 'Website');
                    aWeb.setAttribute('title', payload.website);
                    aWeb.setAttribute('onclick', 'event.stopPropagation();');
                    aWeb.innerHTML = '<i class="bi bi-box-arrow-up-right"></i><span></span>';
                    aWeb.querySelector('span').textContent = webDisplay;
                    box.appendChild(aWeb);
                }

                // Insert before the slug pill so the ordering
                // (socials | actions | slug) matches the partial.
                var slugEl = footer.querySelector('.gfe-loc-item-slug');
                if (slugEl) {
                    footer.insertBefore(box, slugEl);
                } else {
                    footer.appendChild(box);
                }
            }

            function collectSocialMap(payload) {
                var keys = ['facebook','instagram','twitter','linkedin','youtube','tiktok'];
                var out = {};
                for (var i = 0; i < keys.length; i++) {
                    var v = payload[keys[i] + '_url'];
                    if (v) out[keys[i]] = v;
                }
                return out;
            }

            function rebuildSocialsCluster(li, payload) {
                var footer = li.querySelector('.gfe-loc-item-footer');
                if (!footer) return;
                var existing = footer.querySelector('.gfe-loc-item-socials');
                if (existing) existing.parentNode.removeChild(existing);

                var socials = collectSocialMap(payload);
                var keys = Object.keys(socials);
                if (keys.length === 0) return;

                var box = document.createElement('div');
                box.className = 'gfe-loc-item-socials';
                // Preserve the partial's ordering convention
                var ordered = ['facebook','instagram','twitter','linkedin','youtube','tiktok'];
                for (var i = 0; i < ordered.length; i++) {
                    var k = ordered[i];
                    if (!socials[k]) continue;
                    var a = document.createElement('a');
                    a.href = socials[k];
                    a.target = '_blank';
                    a.rel = 'noopener';
                    a.className = 'gfe-loc-item-social is-' + k;
                    a.setAttribute('aria-label', k.charAt(0).toUpperCase() + k.slice(1));
                    a.setAttribute('onclick', 'event.stopPropagation();');
                    a.innerHTML = '<i class="bi bi-' + k + '"></i>';
                    box.appendChild(a);
                }
                // Socials cluster is the leftmost item in the
                // footer — prepend.
                footer.insertBefore(box, footer.firstChild);
            }

            // ── 7. close (X only — no backdrop / Esc) ───────────────
            function isDirty() {
                if (formState.pendingLogo) return true;
                var current = collectFormValues();
                for (var k in formState.pristine) {
                    if (!Object.prototype.hasOwnProperty.call(formState.pristine, k)) continue;
                    if (k === 'image_data') continue; // handled by pendingLogo above
                    if ((current[k] || '') !== (formState.pristine[k] || '')) return true;
                }
                return false;
            }

            function hide(force) {
                if (formState.jutdeeInline) {
                    if (!force && isDirty()) {
                        var okInline = window.confirm('Discard your changes?');
                        if (!okInline) return;
                    }
                    var wasForce = !!force;
                    var wasManage = !!formState.jutdeeManage;
                    formState.jutdeeInline = false;
                    formState.jutdeeManage = false;
                    formState.jutdeeSection = null;
                    formState.open = false;
                    formState.payload = null;
                    formState.pristine = null;
                    if (wasForce) {
                        // Successful save — create shows Setup Complete;
                        // manage already returned to the 4-button menu.
                        return;
                    }
                    if (wasManage
                        && typeof window.returnToJutdeeLocationViewMenu === 'function') {
                        try { window.returnToJutdeeLocationViewMenu(); } catch (menuErr) { /* noop */ }
                        return;
                    }
                    if (typeof window.exitJutdeeLocationViewSetup === 'function') {
                        window.exitJutdeeLocationViewSetup({
                            hideSetupCta: false
                        });
                    }
                    return;
                }
                if (!modalEl.classList.contains('visible')) return;
                if (!force && isDirty()) {
                    var ok = window.confirm('Discard your changes?');
                    if (!ok) return;
                }
                modalEl.classList.remove('visible');
                modalEl.classList.remove('is-post-import-edit');
                // Defer the [hidden] attribute reapplication until the
                // opacity fade-out finishes (.3s in CSS) so the modal
                // doesn't pop instantly.
                setTimeout(function () {
                    if (!modalEl.classList.contains('visible')) {
                        modalEl.setAttribute('hidden', '');
                    }
                }, 320);
            }

            window.isGfeEditFormDirty = isDirty;
            window.refreshGfeEditPristine = function () {
                formState.pristine = collectFormValues();
            };

            if (els.closeBtn) els.closeBtn.addEventListener('click', function () { hide(false); });
            els.form.addEventListener('click', function (e) {
                var t = e.target;
                while (t && t !== els.form) {
                    if (t.hasAttribute && t.hasAttribute('data-gfe-edit-close')) {
                        e.preventDefault();
                        hide(false);
                        return;
                    }
                    t = t.parentNode;
                }
            });

            // ── 7b. delete focal point ───────────────────────────────
            if (els.deleteBtn) {
                els.deleteBtn.addEventListener('click', function () {
                    if (els.deleteBtn.disabled || !formState.id) return;
                    var title = (els.title && els.title.value.trim())
                        ? els.title.value.trim()
                        : 'this focal point';
                    var msg = 'Are you sure you want to delete "' + title
                        + '"? This cannot be undone. The subdomain will be made available for other users.';
                    if (!window.confirm(msg)) return;

                    var deletedId = formState.id;
                    var csrfMeta = document.querySelector('meta[name="csrf-token"]');
                    var csrf = csrfMeta ? csrfMeta.getAttribute('content') : '';

                    els.deleteBtn.disabled = true;
                    els.save.disabled = true;
                    els.deleteBtn.classList.add('is-deleting');

                    fetch('/user-locations/' + encodeURIComponent(deletedId), {
                        method: 'DELETE',
                        credentials: 'same-origin',
                        headers: {
                            'Accept':           'application/json',
                            'X-CSRF-TOKEN':     csrf,
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    }).then(function (resp) {
                        return resp.text().then(function (txt) {
                            var json = {};
                            if (txt) {
                                try { json = JSON.parse(txt); } catch (pe) { /* non-JSON */ }
                            }
                            return { ok: resp.ok, status: resp.status, json: json };
                        });
                    }).then(function (result) {
                        els.deleteBtn.classList.remove('is-deleting');
                        els.deleteBtn.disabled = false;
                        els.save.disabled = false;

                        if (result.ok && result.json && result.json.status === 'success') {
                            removeLocationTileById(deletedId);
                            removeSlide1CarouselCardById(deletedId);
                            try {
                                document.dispatchEvent(new CustomEvent('gfe-location-deleted', {
                                    detail: { id: deletedId }
                                }));
                            } catch (err) {
                                console.warn('[gfe-edit] gfe-location-deleted dispatch failed', err);
                            }
                            formState.id = null;
                            formState.pristine = {};
                            hide(true);
                            exitFocusedFlyinAfterDelete(deletedId);
                            return;
                        }

                        var errMsg = 'Could not delete focal point. Please try again.';
                        if (result.json && result.json.message) errMsg = result.json.message;
                        window.alert(errMsg);
                    }).catch(function () {
                        els.deleteBtn.classList.remove('is-deleting');
                        els.deleteBtn.disabled = false;
                        els.save.disabled = false;
                        window.alert('Network error. Please try again.');
                    });
                });
            }

            // ── 8. document-level pencil click delegate ──────────────
            // Attached at document level so dynamically added tiles
            // (e.g. after the importer creates a new location and
            // re-renders the list) automatically pick it up without
            // a re-bind step. The pencil's inline onclick in the
            // partial already stops propagation as a belt-and-braces
            // safety, but stopping here too prevents the surrounding
            // li.gfe-loc-item click handler (which flies the map to
            // the location's lat/lng) from firing.
            document.addEventListener('click', function (e) {
                var btn = e.target && e.target.closest && e.target.closest('[data-gfe-loc-edit]');
                if (!btn) return;
                e.preventDefault();
                e.stopPropagation();
                var li = btn.closest('li.gfe-loc-item');
                if (!li) return;
                var raw = li.getAttribute('data-gfe-loc-payload');
                if (!raw) return;
                try {
                    var payload = JSON.parse(raw);
                    openGfeEditModal(payload);
                } catch (err) {
                    console.warn('[gfe-edit] could not parse tile payload', err);
                }
            }, true); // capture phase so we beat the bubbling tile
                      // click handler that fires pingLandingFocusOnGamifeye.

            // ── 9. document-level trophy click delegate ──────────────
            // Mirrors the pencil delegate above for the new
            // [data-gfe-loc-challenge] button (the trophy that opens
            // the create-challenge modal mounted at the bottom of
            // ping-landing.blade.php under @auth). Reads area id, hex
            // count, title and logo straight off the <li>'s data-*
            // attrs and hands them to the dashboard's existing
            // window.openChallengeModal entry point — same call shape
            // /aura's branch chips already use, so the modal opens in
            // the identical state it would on the dashboard.
            //
            // No null-area fallback is required: pingLanding() filters
            // userLocations through whereNotNull('eyeland_area_id'),
            // and gamifeye-importer.js's buildLocItemHtml gates the
            // button on data.eyeland_area_id, so any tile that
            // actually carries the trophy is guaranteed to have one.
            // Capture phase keeps the surrounding li click handler
            // (pingLandingFocusOnGamifeye) from firing on the same
            // event.
            document.addEventListener('click', function (e) {
                var btn = e.target && e.target.closest && e.target.closest('[data-gfe-loc-challenge]');
                if (!btn) return;
                e.preventDefault();
                e.stopPropagation();
                if (typeof window.openChallengeModal !== 'function') {
                    console.warn('[gfe-challenge] openChallengeModal global is missing — is the modal partial mounted?');
                    return;
                }
                var li = btn.closest('li.gfe-loc-item');
                if (!li) return;
                var areaId = parseInt(li.getAttribute('data-gfe-loc-area-id'), 10);
                if (!areaId) {
                    console.warn('[gfe-challenge] tile has no eyeland area id');
                    return;
                }
                var title    = li.getAttribute('data-gfe-loc-title') || '';
                var logo     = li.getAttribute('data-gfe-loc-logo')  || '';
                var hexCount = parseInt(li.getAttribute('data-gfe-loc-hex-count'), 10) || 0;
                window.openChallengeModal(areaId, title, hexCount, logo);
            }, true);
        })();

        // ────────────────────────────────────────────────────────────────
        // Edit Route modal (#routeEditModal) — title, 16:9 hero, subdomain.
        // ──────────────────────────────────────────────────────────────
        (function wireRouteEditModal() {
            var modalEl = document.getElementById('routeEditModal');
            if (!modalEl) return;
            var canEditDomain = pingCanEditDomain();
            var sharedCropper = window.__gfeSharedCropper;

            var formState = {
                id: null,
                originalSlug: '',
                pendingImage: null,
                pristine: {},
            };

            var els = {
                modal: modalEl,
                closeBtn: document.getElementById('routeEditClose'),
                form: document.getElementById('routeEditForm'),
                save: document.getElementById('routeEditSave'),
                heroPreview: document.getElementById('routeEditHeroPreview'),
                imageBtn: document.getElementById('routeEditImageBtn'),
                imageInput: document.getElementById('routeEditImageInput'),
                title: document.getElementById('routeEditFieldTitle'),
                slugInput: document.getElementById('routeEditFieldSlug'),
                slugPip: document.getElementById('routeEditSlugPip'),
                domainReadonlyLink: document.getElementById('routeEditDomainReadonlyLink'),
            };

            function setHeroImage(url) {
                if (!els.heroPreview) return;
                els.heroPreview.classList.remove('is-loaded');
                if (!url) {
                    els.heroPreview.style.backgroundImage = '';
                    return;
                }
                var pre = new Image();
                pre.onload = function () {
                    var safe = String(url).replace(/'/g, '%27').replace(/"/g, '%22');
                    els.heroPreview.style.backgroundImage = "url('" + safe + "')";
                    els.heroPreview.classList.add('is-loaded');
                };
                pre.onerror = function () {
                    els.heroPreview.style.backgroundImage = '';
                };
                pre.src = url;
            }

            function setSlugPip(state) {
                if (!els.slugPip) return;
                els.slugPip.classList.remove('is-checking', 'is-ok', 'is-bad');
                if (state === 'checking') els.slugPip.classList.add('is-checking');
                else if (state === 'ok') els.slugPip.classList.add('is-ok');
                else if (state === 'bad') els.slugPip.classList.add('is-bad');
            }

            function clearAllErrors() {
                var fields = modalEl.querySelectorAll('.gfe-edit-field.has-error');
                for (var i = 0; i < fields.length; i++) fields[i].classList.remove('has-error');
                modalEl.classList.remove('has-hero-error');
                var errs = modalEl.querySelectorAll('[data-route-edit-error]');
                for (var j = 0; j < errs.length; j++) errs[j].textContent = '';
            }

            function setFieldError(fieldName, message) {
                var errEl = modalEl.querySelector('[data-route-edit-error="' + fieldName + '"]');
                if (!errEl) return;
                errEl.textContent = message;
                var parent = errEl.closest('.gfe-edit-field');
                if (parent) parent.classList.add('has-error');
                else if (fieldName === 'image_data') modalEl.classList.add('has-hero-error');
            }

            function collectFormValues() {
                var values = {
                    title: els.title.value.trim(),
                    image_data: formState.pendingImage,
                };
                if (canEditDomain && els.slugInput) {
                    values.subdomain_slug = els.slugInput.value.trim().toLowerCase();
                }
                return values;
            }

            function openRouteEditModal(payload) {
                if (!payload || payload.id == null) return;

                formState.id = payload.id;
                formState.originalSlug = (payload.subdomain_slug || payload.slug || '').toLowerCase();
                formState.pendingImage = null;

                els.title.value = payload.title || '';
                if (canEditDomain && els.slugInput) {
                    els.slugInput.value = payload.subdomain_slug || payload.slug || '';
                    setSlugPip('neutral');
                } else {
                    pingSetDomainReadonlyLink(els.domainReadonlyLink, payload.subdomain_slug || payload.slug);
                }

                var heroUrl = payload.thumbnail_url || payload.image || payload.logo_url || '';
                setHeroImage(heroUrl);

                clearAllErrors();
                els.save.disabled = false;
                els.save.classList.remove('is-saving');
                formState.pristine = collectFormValues();

                modalEl.removeAttribute('hidden');
                /* eslint-disable no-unused-expressions */
                modalEl.offsetHeight;
                /* eslint-enable no-unused-expressions */
                modalEl.classList.add('visible');

                setTimeout(function () {
                    if (modalEl.classList.contains('visible')) {
                        try { els.title.focus({ preventScroll: true }); } catch (fe) { els.title.focus(); }
                    }
                }, 820);
            }
            window.openRouteEditModal = openRouteEditModal;

            function hide(force) {
                if (!modalEl.classList.contains('visible')) return;
                if (!force) {
                    var current = collectFormValues();
                    var dirty = formState.pendingImage != null;
                    if (!dirty) {
                        for (var k in formState.pristine) {
                            if (!Object.prototype.hasOwnProperty.call(formState.pristine, k)) continue;
                            if (k === 'image_data') continue;
                            if ((current[k] || '') !== (formState.pristine[k] || '')) { dirty = true; break; }
                        }
                    }
                    if (dirty && !window.confirm('Discard your changes?')) return;
                }
                modalEl.classList.remove('visible');
                setTimeout(function () {
                    if (!modalEl.classList.contains('visible')) modalEl.setAttribute('hidden', '');
                }, 320);
            }
            window.closeRouteEditModal = hide;

            if (els.imageBtn && els.imageInput) {
                els.imageBtn.addEventListener('click', function () { els.imageInput.click(); });
                els.imageInput.addEventListener('change', function () {
                    var file = els.imageInput.files && els.imageInput.files[0];
                    if (!file) return;
                    var reader = new FileReader();
                    reader.onload = function (evt) {
                        if (!sharedCropper) return;
                        sharedCropper.open(evt.target.result, {
                            aspectRatio: 16 / 9,
                            width: 800,
                            height: 450,
                            quality: 0.5,
                            onApply: function (croppedDataUrl) {
                                formState.pendingImage = croppedDataUrl;
                                setHeroImage(croppedDataUrl);
                            },
                        });
                    };
                    reader.onerror = function () {
                        setFieldError('image_data', 'Could not read that image. Try a JPG, PNG, or WebP.');
                    };
                    reader.readAsDataURL(file);
                    els.imageInput.value = '';
                });
            }

            if (canEditDomain && els.slugInput) {
                var slugCheckTimer = null;
                var slugCheckSeq = 0;
                function runSlugCheck() {
                    var slug = els.slugInput.value.trim().toLowerCase();
                    if (!slug) {
                        setSlugPip('neutral');
                        els.save.disabled = false;
                        return;
                    }
                    if (slug === formState.originalSlug) {
                        setSlugPip('ok');
                        els.save.disabled = false;
                        return;
                    }
                    if (slug.length < 2) {
                        setSlugPip('bad');
                        els.save.disabled = true;
                        return;
                    }
                    setSlugPip('checking');
                    els.save.disabled = true;
                    var mySeq = ++slugCheckSeq;
                    var url = '/user-routes/check-slug'
                        + '?slug=' + encodeURIComponent(slug)
                        + '&exclude_id=' + encodeURIComponent(formState.id);
                    fetch(url, {
                        method: 'GET',
                        credentials: 'same-origin',
                        headers: { 'Accept': 'application/json' },
                    }).then(function (r) {
                        return r.ok ? r.json() : { available: false };
                    }).then(function (json) {
                        if (mySeq !== slugCheckSeq) return;
                        var available = !!(json && json.available);
                        setSlugPip(available ? 'ok' : 'bad');
                        els.save.disabled = !available;
                    }).catch(function () {
                        if (mySeq !== slugCheckSeq) return;
                        setSlugPip('bad');
                        els.save.disabled = true;
                    });
                }
                els.slugInput.addEventListener('input', function () {
                    clearTimeout(slugCheckTimer);
                    slugCheckTimer = setTimeout(runSlugCheck, 350);
                });
            }

            els.form.addEventListener('submit', function (e) {
                e.preventDefault();
                if (els.save.disabled) {
                    try { window.alert('Wait for the subdomain check to finish, or fix the subdomain field, before saving.'); } catch (ae) { /* noop */ }
                    return;
                }

                var values = collectFormValues();
                var body = {};
                for (var bk in values) {
                    if (!Object.prototype.hasOwnProperty.call(values, bk)) continue;
                    if (bk === 'image_data' && !values[bk]) continue;
                    body[bk] = values[bk];
                }

                clearAllErrors();
                els.save.classList.add('is-saving');
                els.save.disabled = true;

                var csrfMeta = document.querySelector('meta[name="csrf-token"]');
                var csrf = csrfMeta ? csrfMeta.getAttribute('content') : '';

                fetch('/user-routes/' + encodeURIComponent(formState.id), {
                    method: 'PATCH',
                    credentials: 'same-origin',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrf,
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify(body),
                }).then(function (resp) {
                    return resp.text().then(function (txt) {
                        var json = {};
                        if (txt) {
                            try { json = JSON.parse(txt); } catch (pe) { /* noop */ }
                        }
                        return { ok: resp.ok, status: resp.status, json: json };
                    });
                }).then(function (result) {
                    els.save.classList.remove('is-saving');
                    els.save.disabled = false;

                    try {
                        if (result.ok && result.json && result.json.status === 'success' && result.json.route) {
                            var saved = result.json.route;
                            if (saved.thumbnail_url && typeof window.bustRouteThumbUrl === 'function') {
                                saved.thumbnail_url = window.bustRouteThumbUrl(saved.thumbnail_url);
                            }
                            formState.pendingImage = null;
                            formState.pristine = collectFormValues();
                            try {
                                document.dispatchEvent(new CustomEvent('route-edited', {
                                    detail: { id: formState.id, route: saved },
                                }));
                            } catch (evErr) { /* noop */ }
                            hide(true);
                            return;
                        }
                    } catch (saveOkErr) {
                        console.warn('[route-edit] save success handler failed', saveOkErr);
                        try { window.alert('Saved, but the page could not refresh. Reload and try again.'); } catch (a0) { /* noop */ }
                        return;
                    }

                    if (result.status === 422 && result.json) {
                        var shownErr = false;
                        if (result.json.errors) {
                            for (var f in result.json.errors) {
                                if (!Object.prototype.hasOwnProperty.call(result.json.errors, f)) continue;
                                var msgs = result.json.errors[f];
                                setFieldError(f, Array.isArray(msgs) ? msgs[0] : String(msgs));
                                shownErr = true;
                            }
                        } else if (result.json.field && result.json.message) {
                            setFieldError(result.json.field, result.json.message);
                            shownErr = true;
                        }
                        if (!shownErr && result.json.message) {
                            try { window.alert(result.json.message); } catch (a2) { /* noop */ }
                        }
                        return;
                    }

                    var failMsg = 'Could not save route. Please try again.';
                    if (result.json && result.json.message) failMsg = result.json.message;
                    else if (result.json && result.json.error) failMsg = String(result.json.error);
                    else if (result.status) failMsg = 'Could not save route (HTTP ' + result.status + ').';
                    console.warn('[route-edit] save failed', result.status, result.json);
                    try { window.alert(failMsg); } catch (a3) { /* noop */ }
                }).catch(function (err) {
                    els.save.classList.remove('is-saving');
                    els.save.disabled = false;
                    console.warn('[route-edit] save network error', err);
                    try { window.alert('Network error. Please try again.'); } catch (a4) { /* noop */ }
                });
            });

            if (els.closeBtn) els.closeBtn.addEventListener('click', function () { hide(false); });
            els.form.addEventListener('click', function (e) {
                var t = e.target;
                while (t && t !== els.form) {
                    if (t.hasAttribute && t.hasAttribute('data-route-edit-close')) {
                        e.preventDefault();
                        hide(false);
                        return;
                    }
                    t = t.parentNode;
                }
            });
        })();

        (function wireGfeLocationRewardModal() {
            var modalEl = document.getElementById('gfeLocationRewardModal');
            if (!modalEl) return;

            var RL = window.__pingL10n || {};

            var state = {
                locationId: null,
                locationTitle: '',
                rewards: [],
                maxRewards: 10,
                editingId: null,
                pendingImage: null,
                saving: false,
            };

            function resolveMaxRewards(json) {
                var fromApi = json && json.max_slots != null ? parseInt(json.max_slots, 10) : NaN;
                if (isFinite(fromApi) && fromApi >= 0) return fromApi;
                var fromWin = parseInt(window.pingMaxStampRewards, 10);
                return (isFinite(fromWin) && fromWin >= 0) ? fromWin : 10;
            }

            var els = {
                closeBtn:       document.getElementById('gfeLocRewardClose'),
                listView:       document.getElementById('gfeLocRewardListView'),
                formView:       document.getElementById('gfeLocRewardFormView'),
                locName:        document.getElementById('gfeLocRewardLocName'),
                list:           document.getElementById('gfeLocRewardList'),
                empty:          document.getElementById('gfeLocRewardEmpty'),
                imgPreview:     document.getElementById('gfeLocRewardImgPreview'),
                imgFallback:    document.getElementById('gfeLocRewardImgFallback'),
                imgBtn:         document.getElementById('gfeLocRewardImgBtn'),
                imgInput:       document.getElementById('gfeLocRewardImgInput'),
                form:           document.getElementById('gfeLocRewardForm'),
                title:          document.getElementById('gfeLocRewardTitle'),
                stamps:         document.getElementById('gfeLocRewardStamps'),
                maxWins:        document.getElementById('gfeLocRewardMaxWins'),
                maxWinsUnlimited: document.getElementById('gfeLocRewardMaxWinsUnlimited'),
                expiry:         document.getElementById('gfeLocRewardExpiry'),
                save:           document.getElementById('gfeLocRewardSave'),
            };

            function syncMaxWinsUnlimitedUi() {
                var unlimited = !!(els.maxWinsUnlimited && els.maxWinsUnlimited.checked);
                if (els.maxWins) {
                    els.maxWins.disabled = unlimited;
                    if (unlimited) {
                        els.maxWins.removeAttribute('required');
                    } else {
                        els.maxWins.setAttribute('required', 'required');
                    }
                }
            }

            function setMaxWinsUnlimited(unlimited) {
                if (els.maxWinsUnlimited) els.maxWinsUnlimited.checked = !!unlimited;
                syncMaxWinsUnlimitedUi();
            }

            function csrfToken() {
                var meta = document.querySelector('meta[name="csrf-token"]');
                return meta ? meta.getAttribute('content') : '';
            }

            function escHtml(s) {
                return String(s || '')
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;');
            }

            function clearFieldErrors() {
                var nodes = modalEl.querySelectorAll('[data-gfe-loc-reward-error]');
                for (var i = 0; i < nodes.length; i++) {
                    nodes[i].textContent = '';
                    nodes[i].style.display = 'none';
                }
            }

            function showFieldError(field, msg) {
                var node = modalEl.querySelector('[data-gfe-loc-reward-error="' + field + '"]');
                if (!node) return;
                node.textContent = msg;
                node.style.display = msg ? 'block' : 'none';
            }

            function isStampsRequiredTaken(stamps) {
                var n = Number(stamps);
                if (!isFinite(n) || n < 1) return false;
                var list = state.rewards || [];
                for (var i = 0; i < list.length; i++) {
                    if (Number(list[i].stamps_required) !== n) continue;
                    if (state.editingId && String(list[i].id) === String(state.editingId)) continue;
                    return true;
                }
                return false;
            }

            function validateStampsRequiredUnique() {
                var stamps = els.stamps ? parseInt(els.stamps.value, 10) : 0;
                if (!stamps || stamps < 1) {
                    showFieldError('stamps_required', '');
                    return true;
                }
                if (isStampsRequiredTaken(stamps)) {
                    showFieldError('stamps_required', 'A reward already uses this stamp count.');
                    return false;
                }
                showFieldError('stamps_required', '');
                return true;
            }

            function hasRewardImage() {
                if (state.pendingImage) return true;
                if (!state.editingId) return false;
                var list = state.rewards || [];
                for (var i = 0; i < list.length; i++) {
                    if (String(list[i].id) === String(state.editingId) && list[i].image_url) {
                        return true;
                    }
                }
                return false;
            }

            function isRewardFormComplete() {
                var title = els.title ? els.title.value.trim() : '';
                if (!title) return false;

                var stamps = els.stamps ? parseInt(els.stamps.value, 10) : 0;
                if (!stamps || stamps < 1) return false;
                if (isStampsRequiredTaken(stamps)) return false;

                var unlimited = !!(els.maxWinsUnlimited && els.maxWinsUnlimited.checked);
                var maxWins = unlimited ? 0 : (els.maxWins ? parseInt(els.maxWins.value, 10) : 0);
                if (!unlimited && (!maxWins || maxWins < 1)) return false;

                var expiryPeriod = els.expiry ? els.expiry.value : '';
                var validExpiry = ['1_hour', '1_day', '1_week', '1_month', '1_year', 'never'];
                if (!expiryPeriod || validExpiry.indexOf(expiryPeriod) === -1) return false;

                if (!hasRewardImage()) return false;
                return true;
            }

            function syncSaveEnabled() {
                if (!els.save) return;
                if (state.saving) {
                    els.save.disabled = true;
                    return;
                }
                els.save.disabled = !isRewardFormComplete();
            }

            function setImagePreview(url) {
                if (!els.imgPreview) return;
                if (url) {
                    els.imgPreview.style.backgroundImage = "url('" + String(url).replace(/'/g, '%27') + "')";
                    els.imgPreview.classList.add('is-loaded');
                } else {
                    els.imgPreview.style.backgroundImage = '';
                    els.imgPreview.classList.remove('is-loaded');
                }
            }

            function showListView() {
                if (els.listView) els.listView.hidden = false;
                if (els.formView) els.formView.hidden = true;
            }

            function showFormView() {
                if (els.listView) els.listView.hidden = true;
                if (els.formView) els.formView.hidden = false;
            }

            function appendFilledRewardRow(reward, isOverflow) {
                var row = document.createElement('div');
                row.className = 'gfe-loc-reward-item' + (isOverflow ? ' gfe-loc-reward-item--locked' : '');
                if (!isOverflow) {
                    row.setAttribute('role', 'button');
                    row.setAttribute('tabindex', '0');
                } else {
                    row.setAttribute('aria-disabled', 'true');
                }
                var thumb = reward.image_url
                    ? '<img class="gfe-loc-reward-item-thumb" src="' + escHtml(reward.image_url) + '" alt="">'
                    : '<div class="gfe-loc-reward-item-thumb"></div>';
                var stampsFmt = RL.stampRewardStampsFmt || ':count stamps';
                var stampsLabel = isOverflow
                    ? 'Over your plan limit'
                    : stampsFmt.replace(':count', escHtml(reward.stamps_required));
                row.innerHTML =
                    thumb +
                    '<div class="gfe-loc-reward-item-body">' +
                        '<span class="gfe-loc-reward-item-title">' + escHtml(reward.title) + '</span>' +
                        '<span class="gfe-loc-reward-item-stamps">' + stampsLabel + '</span>' +
                    '</div>' +
                    '<button type="button" class="gfe-loc-reward-item-delete" aria-label="Delete">' +
                        '<i class="bi bi-trash3"></i>' +
                    '</button>';
                row.querySelector('.gfe-loc-reward-item-delete').addEventListener('click', function (e) {
                    e.stopPropagation();
                    deleteReward(reward.id);
                });
                if (!isOverflow) {
                    row.addEventListener('click', function () {
                        openFormForEdit(reward);
                    });
                }
                els.list.appendChild(row);
            }

            function appendEmptySlotRow(slotNum) {
                var slot = document.createElement('div');
                slot.className = 'gfe-loc-reward-item gfe-loc-reward-item--empty';
                slot.setAttribute('role', 'button');
                slot.setAttribute('tabindex', '0');
                slot.setAttribute('aria-label', 'Add reward — empty slot ' + slotNum);
                slot.innerHTML =
                    '<div class="gfe-loc-reward-item-thumb gfe-loc-reward-item-thumb--empty" aria-hidden="true">' +
                        '<i class="bi bi-plus-lg"></i>' +
                    '</div>' +
                    '<div class="gfe-loc-reward-item-body">' +
                        '<span class="gfe-loc-reward-item-title">' + escHtml(RL.emptySlot || 'Empty slot') + '</span>' +
                        '<span class="gfe-loc-reward-item-stamps">' + escHtml(RL.tapToAddReward || 'Tap to add a reward') + '</span>' +
                    '</div>' +
                    '<span class="gfe-loc-reward-item-slot-spacer" aria-hidden="true"></span>';
                slot.addEventListener('click', function () {
                    openFormForCreate();
                });
                els.list.appendChild(slot);
            }

            function renderRewardList() {
                if (!els.list || !els.empty) return;
                els.list.innerHTML = '';
                var items = (state.rewards || []).slice().sort(function (a, b) {
                    return (Number(a && a.stamps_required) || 0) - (Number(b && b.stamps_required) || 0);
                });
                var maxSlots = Math.max(0, state.maxRewards);

                els.empty.hidden = (maxSlots > 0) || items.length > 0;

                for (var s = 0; s < maxSlots; s++) {
                    if (items[s]) {
                        appendFilledRewardRow(items[s], false);
                    } else {
                        appendEmptySlotRow(s + 1);
                    }
                }

                if (items.length > maxSlots) {
                    var note = document.createElement('p');
                    note.className = 'gfe-loc-reward-overflow-note';
                    note.textContent = (items.length - maxSlots) + ' reward(s) exceed your plan limit. Delete below to stay within your allowance.';
                    els.list.appendChild(note);
                    for (var o = maxSlots; o < items.length; o++) {
                        appendFilledRewardRow(items[o], true);
                    }
                }

            }

            function fetchRewards() {
                return fetch('/user-locations/' + encodeURIComponent(state.locationId) + '/stamp-rewards', {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }).then(function (resp) {
                    return resp.json().then(function (json) {
                        if (!resp.ok) throw new Error((json && json.message) || 'Could not load rewards.');
                        state.maxRewards = resolveMaxRewards(json);
                        window.pingMaxStampRewards = state.maxRewards;
                        state.rewards = (json && json.data) ? json.data : [];
                        renderRewardList();
                    });
                });
            }

            function resetForm() {
                state.editingId = null;
                state.pendingImage = null;
                if (els.title) els.title.value = '';
                if (els.stamps) els.stamps.value = '';
                if (els.maxWins) els.maxWins.value = '1';
                setMaxWinsUnlimited(false);
                if (els.expiry) els.expiry.value = '1_month';
                setImagePreview(null);
                clearFieldErrors();
                syncSaveEnabled();
            }

            function openFormForCreate() {
                if ((state.rewards || []).length >= state.maxRewards) return;
                resetForm();
                showFormView();
                syncSaveEnabled();
            }

            function openFormForEdit(reward) {
                state.editingId = reward.id;
                state.pendingImage = null;
                if (els.title) els.title.value = reward.title || '';
                if (els.stamps) els.stamps.value = reward.stamps_required || '';
                var maxWinsVal = Number(reward.max_wins_per_user);
                if (maxWinsVal === 0) {
                    if (els.maxWins) els.maxWins.value = '1';
                    setMaxWinsUnlimited(true);
                } else {
                    if (els.maxWins) els.maxWins.value = String(maxWinsVal || 1);
                    setMaxWinsUnlimited(false);
                }
                if (els.expiry) els.expiry.value = reward.voucher_expiry_period || '1_month';
                setImagePreview(reward.image_url || null);
                clearFieldErrors();
                showFormView();
                syncSaveEnabled();
            }

            function hide() {
                if (!modalEl.classList.contains('visible')) return;
                modalEl.classList.remove('visible');
                setTimeout(function () {
                    if (!modalEl.classList.contains('visible')) {
                        modalEl.setAttribute('hidden', '');
                    }
                }, 320);
                showListView();
                resetForm();
            }

            function showModal() {
                if (typeof window.hidePingIntro === 'function') {
                    try { window.hidePingIntro(true); } catch (hiErr) { /* noop */ }
                }
                modalEl.removeAttribute('hidden');
                modalEl.style.display = '';
                modalEl.offsetHeight;
                modalEl.classList.add('visible');
            }

            function resolveLocationId(payload) {
                if (!payload) return null;
                var id = payload.id != null ? payload.id : payload.fpid;
                if (id == null || id === '') return null;
                return id;
            }

            function openGfeLocationRewardModal(payload) {
                var locId = resolveLocationId(payload);
                if (locId == null) return;
                state.locationId = locId;
                state.locationTitle = payload.title || payload.name || '';
                resetForm();
                showListView();
                fetchRewards().then(function () {
                    showModal();
                }).catch(function (err) {
                    try { window.alert(err.message || 'Could not load stamp rewards.'); } catch (e) { /* noop */ }
                });
            }

            function deleteReward(rewardId) {
                if (!window.confirm('Delete this stamp reward?')) return;
                fetch('/user-locations/' + encodeURIComponent(state.locationId) +
                    '/stamp-rewards/' + encodeURIComponent(rewardId), {
                    method: 'DELETE',
                    credentials: 'same-origin',
                    headers: {
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': csrfToken(),
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }).then(function (resp) {
                    return resp.json().then(function (json) {
                        if (!resp.ok) throw new Error((json && json.message) || 'Delete failed.');
                        return fetchRewards();
                    });
                }).catch(function (err) {
                    try { window.alert(err.message || 'Delete failed.'); } catch (e) { /* noop */ }
                });
            }

            if (els.imgBtn && els.imgInput) {
                els.imgBtn.addEventListener('click', function () { els.imgInput.click(); });
                els.imgInput.addEventListener('change', function () {
                    var file = els.imgInput.files && els.imgInput.files[0];
                    if (!file) return;
                    var reader = new FileReader();
                    reader.onload = function (evt) {
                        var cropperApi = window.__gfeSharedCropper;
                        if (!cropperApi) return;
                        cropperApi.open(evt.target.result, {
                            variant: 'stamp-reward',
                            aspectRatio: 1,
                            quality: 0.5,
                            width: 800,
                            height: 800,
                            onApply: function (dataUrl) {
                                state.pendingImage = dataUrl;
                                setImagePreview(dataUrl);
                                syncSaveEnabled();
                            },
                        });
                    };
                    reader.readAsDataURL(file);
                    els.imgInput.value = '';
                });
            }

            if (els.maxWinsUnlimited) {
                els.maxWinsUnlimited.addEventListener('change', function () {
                    syncMaxWinsUnlimitedUi();
                    syncSaveEnabled();
                });
            }

            if (els.stamps) {
                els.stamps.addEventListener('blur', function () {
                    validateStampsRequiredUnique();
                    syncSaveEnabled();
                });
                els.stamps.addEventListener('input', syncSaveEnabled);
            }
            if (els.title) els.title.addEventListener('input', syncSaveEnabled);
            if (els.maxWins) els.maxWins.addEventListener('input', syncSaveEnabled);
            if (els.expiry) els.expiry.addEventListener('change', syncSaveEnabled);

            if (els.form) {
                els.form.addEventListener('submit', function (e) {
                    e.preventDefault();
                    if (!isRewardFormComplete()) {
                        syncSaveEnabled();
                        return;
                    }
                    clearFieldErrors();
                    var title = els.title ? els.title.value.trim() : '';
                    var stamps = els.stamps ? parseInt(els.stamps.value, 10) : 0;
                    var unlimited = !!(els.maxWinsUnlimited && els.maxWinsUnlimited.checked);
                    var maxWins = unlimited ? 0 : (els.maxWins ? parseInt(els.maxWins.value, 10) : 0);
                    var expiryPeriod = els.expiry ? els.expiry.value : '';
                    var validExpiry = ['1_hour', '1_day', '1_week', '1_month', '1_year', 'never'];

                    if (!title) { showFieldError('title', 'Title is required.'); return; }
                    if (!stamps || stamps < 1) { showFieldError('stamps_required', 'Enter at least 1 stamp.'); return; }
                    if (!validateStampsRequiredUnique()) return;
                    if (!unlimited && (!maxWins || maxWins < 1)) {
                        showFieldError('max_wins_per_user', 'Enter at least 1 win per user.');
                        return;
                    }
                    if (!expiryPeriod || validExpiry.indexOf(expiryPeriod) === -1) {
                        showFieldError('voucher_expiry_period', 'Please choose an expiry period.');
                        return;
                    }

                    if (!hasRewardImage()) {
                        showFieldError('image_data', 'Please add an image.');
                        return;
                    }

                    var body = {
                        title: title,
                        stamps_required: stamps,
                        max_wins_per_user: maxWins,
                        voucher_expiry_period: expiryPeriod,
                    };
                    if (state.pendingImage) body.image_data = state.pendingImage;

                    var url = '/user-locations/' + encodeURIComponent(state.locationId) + '/stamp-rewards';
                    var method = 'POST';
                    if (state.editingId) {
                        url += '/' + encodeURIComponent(state.editingId);
                        method = 'PATCH';
                    }

                    state.saving = true;
                    syncSaveEnabled();
                    fetch(url, {
                        method: method,
                        credentials: 'same-origin',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': csrfToken(),
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                        body: JSON.stringify(body),
                    }).then(function (resp) {
                        return resp.json().then(function (json) {
                            if (!resp.ok) {
                                if (json && json.field) {
                                    showFieldError(json.field, json.message || 'Invalid value.');
                                }
                                throw new Error((json && json.message) || 'Save failed.');
                            }
                            return fetchRewards().then(function () {
                                resetForm();
                                showListView();
                            });
                        });
                    }).catch(function (err) {
                        if (err && err.message) {
                            try { window.alert(err.message); } catch (ae) { /* noop */ }
                        }
                    }).finally(function () {
                        state.saving = false;
                        syncSaveEnabled();
                    });
                });
            }

            if (els.closeBtn) els.closeBtn.addEventListener('click', function () { hide(); });
            document.addEventListener('keydown', function (e) {
                if (e.key !== 'Escape') return;
                if (!modalEl.classList.contains('visible')) return;
                var cropperApi = window.__gfeSharedCropper;
                if (cropperApi && cropperApi.isVisible()) return;
                // Esc only navigates form → list; X is required to dismiss.
                if (els.formView && !els.formView.hidden) {
                    showListView();
                    resetForm();
                }
            });

            window.openGfeLocationRewardModal = openGfeLocationRewardModal;
            window.closeGfeLocationRewardModal = hide;
        })();

        // The standalone Visit Rewards modal was removed — its single
        // owner control (minimum-stay preset) now lives inline in the
        // Edit Location modal (gfeEditForm → #gfeEditFieldVisitDuration).

        // ── GamifEYE-imported focus hook ──────────────────────────────────
        // Wired by public/js/gamifeye-importer.js after a successful
        // POST /user-locations from the ping-landing intro modal.
        //
        // We handle the post-create UX here (rather than redirecting to
        // /aura) because the landing already owns a configured maplibre
        // map, an h3-js loader, and the intro-modal lifecycle helpers
        // (hideIntro, autoSpin, bgImage). Doing the work here keeps the
        // user on the page they just acted on and gives the new GamifEYE
        // an immediate visual home — the same "your zone exists on the
        // planet" beat the spin-globe game already delivers.
        //
        // Visual contract:
        //   1. Close the intro modal (which is currently showing the
        //      importer body).
        //   2. Stop the auto-globe rotation so flyTo isn't fighting the
        //      rAF spin loop.
        //   3. Drop a magenta pin at the new GamifEYE's lat/lng.
        //   4. Render the single center res-9 hex (matches
        //      doBootstrapFocalPointZoneAndDraft — one cell on create)
        //      with a magenta pulsating ring.
        //   5. flyTo with pitch 50° at zoom 16 so the cell reads clearly.
        //   6. Re-enable map interaction so the user can pan around the
        //      new map area (the landing map otherwise launches with
        //      interactive:false for the auto-spin globe).
        // `opts.skipDetail === true` uses the interactive hex grid
        // (slide-1 focal-point click). Importer call-sites pass no
        // second arg; after fly-in they get #gfeCreatedPanel instead
        // of the old 9:16 #gfeDetailModal.
        window.pingLandingFocusOnGamifeye = function(data, opts) {
            data = normalizeGfeLocPayload(data);
            if (!data) return;
            try {
            var lat = parseFloat(data.latitude || data.lat);
            var lng = parseFloat(data.longitude || data.lng);
            if (!isFinite(lat) || !isFinite(lng)) {
                console.warn('[gfe-focus] missing/invalid lat,lng on payload', data);
                return;
            }
            console.log('[gfe-focus] focusing on', lat, lng);

            ++_gfePostImportBannerTrip;
            hideGfeCreatedBanner();
            if (opts && opts.postImport) {
                document.body.classList.add('is-gfe-import-setup-pending');
                if (!(opts && opts.jutdeeLocationView)) {
                    document.body.classList.add('is-gfe-import-flyin');
                    syncPostImportFocusCloseBtn();
                }
            }

            try { hideIntro(true); } catch(e) {}
            // Mark this fly-in editable — both call paths into
            // pingLandingFocusOnGamifeye (slide-1 focal-point click and
            // importer "Your Locations" pencil) hand in a UserHomePoint
            // the current user owns, so the hero pencil should appear.
            bindPingHeroFlyinData(data, {
                editable: !(opts && opts.postImport),
                skipHeroImage: !!(opts && opts.jutdeeLocationView)
            });
            if (!pickLocationHeroUrl(data) && bgImage) bgImage.classList.add('is-faded');
            autoSpin.active = false;
            if (fastSpinRaf) { try { cancelAnimationFrame(fastSpinRaf); } catch(e) {} fastSpinRaf = null; }

            // Jutdee location modal: post-create setup OR manage existing.
            if (opts && opts.jutdeeLocationView) {
                if (opts.postImport && typeof window.showJutdeeLocationViewModal === 'function') {
                    try {
                        _gfeCreatedBannerData = data;
                        window.showJutdeeLocationViewModal(data);
                    } catch (modalErr) {
                        console.warn('[gfe-focus] jutdee location modal failed', modalErr);
                    }
                } else if (opts.jutdeeLocationManage
                    && typeof window.showJutdeeLocationViewModal === 'function') {
                    try {
                        window.showJutdeeLocationViewModal(data, { manage: true });
                    } catch (manageErr) {
                        console.warn('[gfe-focus] jutdee manage modal failed', manageErr);
                    }
                }
            }

            // Gate the in-place close FAB on opts.skipDetail. Post-import
            // fly-ins use is-gfe-import-flyin + is-gfe-import-setup-pending
            // (X opens #gfeEditModal until first save, then flies home).
            // The slide-1 click flow (skipDetail:true)
            // has no modal, so we surface #pingFocusCloseBtn as the
            // only way back to the carousel. body.is-gfe-focused
            // drives the CSS swap defined in ping-landing.blade.php.
            //
            // Same gate captures the branch-hex active state so
            // saveBranchHexExpansion knows which focal point to POST
            // against and which card to sync on commit. We always
            // start with an empty selection — re-entering focused
            // mode on the same card means a fresh expansion session.
            // Jutdee manage modal uses skipDetail for hex paint but
            // keeps the frosted card as the primary chrome.
            if (opts && opts.skipDetail) {
                document.body.classList.add('is-gfe-focused');
                _branchActiveBranchId = data.id || null;
                _branchActiveAreaId   = data.eyeland_area_id || null;
                _branchActiveCardEl   = data.__cardEl || null;
                _branchSelectedHexes  = new Set();

                // Branch-stamps display layer — paint the same green
                // markers the subdomain v2 page shows so the user
                // can preview which slots are open this week before
                // travelling to the place. Display-only, no collect
                // or polling here. Cleanup is wired through
                // resetGfeMapOverlays(), so re-entering on a
                // different focal point starts from a clean source.
                if (_branchActiveBranchId) {
                    renderPingBranchStampsForBranch(_branchActiveBranchId, data);
                }
            }

            // Detail-modal trigger is wired from inside flyAndPaint()
            // so it fires 500ms AFTER the camera animation completes
            // (map `moveend` + 500ms), letting the user see their new
            // zone fully framed on the map for half a beat before the
            // info card drops down over it. Anchoring off moveend
            // means the timing stays correct regardless of whether
            // the map style was already loaded when focus was
            // requested (instant flyTo) or had to wait for a
            // styledata / idle event (delayed flyTo). See flyAndPaint
            // below for the one-shot listener.

            // The landing map is created with `interactive: false` for
            // the auto-spin globe. Re-enable interaction NOW (not after
            // flyTo) so the user can pan/zoom the moment the camera
            // settles — and so flyTo's internal handlers aren't gated
            // on a still-disabled handler set.
            try { if (map.dragPan)         map.dragPan.enable(); } catch(e) {}
            try { if (map.scrollZoom)      map.scrollZoom.enable(); } catch(e) {}
            try { if (map.touchZoomRotate) map.touchZoomRotate.enable(); } catch(e) {}
            try { if (map.doubleClickZoom) map.doubleClickZoom.enable(); } catch(e) {}
            try { if (map.keyboard)        map.keyboard.enable(); } catch(e) {}

            function paintHexes() {
                ensureH3(function() {
                    try {
                        stopGfeFocalCenterPulse();
                        var centerR9 = h3.latLngToCell(lat, lng, 9);
                        var bnd = h3.cellToBoundary(centerR9);
                        var ring = bnd.map(function(c) { return [c[1], c[0]]; });
                        ring.push(ring[0]);
                        var geojson = {
                            type: 'FeatureCollection',
                            features: [{
                                type: 'Feature',
                                properties: { isCenter: true },
                                geometry: { type: 'Polygon', coordinates: [ring] }
                            }]
                        };

                        try { if (map.getLayer('gfe-focal-fill')) map.removeLayer('gfe-focal-fill'); } catch(e) {}
                        try { if (map.getLayer('gfe-focal-line')) map.removeLayer('gfe-focal-line'); } catch(e) {}
                        try { if (map.getLayer('gfe-focal-center-pulse')) map.removeLayer('gfe-focal-center-pulse'); } catch(e) {}
                        try { if (map.getSource('gfe-focal')) map.removeSource('gfe-focal'); } catch(e) {}

                        map.addSource('gfe-focal', { type: 'geojson', data: geojson });
                        map.addLayer({
                            id: 'gfe-focal-fill', type: 'fill', source: 'gfe-focal',
                            paint: { 'fill-color': '#fbbf24', 'fill-opacity': 0 }
                        });
                        map.addLayer({
                            id: 'gfe-focal-line', type: 'line', source: 'gfe-focal',
                            paint: { 'line-color': '#ca8a04', 'line-width': 2, 'line-opacity': 0 }
                        });
                        map.addLayer({
                            id: 'gfe-focal-center-pulse', type: 'line', source: 'gfe-focal',
                            paint: { 'line-color': '#e91e8c', 'line-width': 4, 'line-opacity': 0 }
                        });
                        try { map.moveLayer('gfe-focal-center-pulse'); } catch (e) {}

                        // Fade the center hex in, then start the pulse ring.
                        var step = 0, steps = 30;
                        var iv = setInterval(function() {
                            step++;
                            var t = step / steps;
                            try {
                                map.setPaintProperty('gfe-focal-fill', 'fill-opacity', 0.45 * t);
                                map.setPaintProperty('gfe-focal-line', 'line-opacity', 0.85 * t);
                            } catch(e) {}
                            if (step >= steps) {
                                clearInterval(iv);
                                startGfeFocalCenterPulse();
                            }
                        }, 50);
                    } catch(e) { console.warn('[gfe-focus] hex render failed', e); }
                });
            }

            function clearGfeFocusPin() {
                if (lastGfeMarker) {
                    try { lastGfeMarker.remove(); } catch (e) {}
                    lastGfeMarker = null;
                }
            }

            function placeGfeFocusPin(pinData, pinLat, pinLng) {
                if (!locationShowsOnMap(pinData)) {
                    clearGfeFocusPin();
                    return;
                }
                try {
                    var logo  = pinData.logo_url || pinData.logo || '';
                    var title = pinData.title || pinData.name || '';
                    var locViewActive = document.body.classList.contains('is-jutdee-location-view-active');
                    var borderColor = locViewActive ? '#000' : '#e91e8c';

                    var el = document.createElement('div');
                    el.className = 'fp-marker';
                    el.style.cssText = 'display:flex;flex-direction:column;align-items:center;cursor:pointer;';

                    if (logo) {
                        var img = document.createElement('img');
                        img.src = logo;
                        img.alt = title || '';
                        img.style.cssText = 'width:40px;height:40px;border-radius:50%;border:3px solid ' + borderColor + ';object-fit:cover;box-shadow:0 2px 8px rgba(0,0,0,0.35);background:#fff;';
                        el.appendChild(img);
                    } else {
                        var pin = document.createElement('div');
                        pin.style.cssText = 'width:32px;height:32px;background:' + borderColor + ';border:3px solid #fff;border-radius:50%;box-shadow:0 2px 8px rgba(0,0,0,0.35);display:flex;align-items:center;justify-content:center;color:#fff;font-size:14px;';
                        pin.innerHTML = '<i class="bi bi-geo-alt-fill"></i>';
                        el.appendChild(pin);
                    }

                    if (title) {
                        var label = document.createElement('span');
                        label.textContent = title;
                        var labelBg = locViewActive ? '#000' : borderColor;
                        label.style.cssText = "font-family:'Fredoka',sans-serif;font-size:11px;font-weight:700;color:#fff;background:" + labelBg + ";padding:3px 8px;border-radius:6px;margin-top:4px;max-width:100px;text-align:center;line-height:1.3;box-shadow:0 1px 4px rgba(0,0,0,0.15);border:1.5px solid #fff;";
                        el.appendChild(label);
                    }

                    clearGfeFocusPin();
                    lastGfeMarker = new maplibregl.Marker({ element: el, anchor: 'bottom' })
                        .setLngLat([pinLng, pinLat])
                        .addTo(map);
                } catch (e) { console.warn('[gfe-focus] marker add failed', e); }
            }

            window.syncGfeFocusMapPin = function (pinData) {
                if (!map || !pinData) return;
                var pinLat = parseFloat(pinData.latitude != null ? pinData.latitude : pinData.lat);
                var pinLng = parseFloat(pinData.longitude != null ? pinData.longitude : pinData.lng);
                if (!isFinite(pinLat) || !isFinite(pinLng)) return;
                placeGfeFocusPin(pinData, pinLat, pinLng);
            };

            function dropPin() {
                placeGfeFocusPin(data, lat, lng);
            }

            function flyAndPaint() {
                var flyMs = 4000;
                // After the camera settles: paint the viewport title,
                // then (existing-location clicks only) open the detail
                // modal 500ms later. Fresh imports use
                // scheduleGfePostImportBanner() tied to this flyTo's
                // moveend — not revealFlyinTitleAfterMove's afterReveal,
                // which can be cancelled when _flyinTitleTrip bumps.
                // Jutdee location view owns its own hero title — do not
                // also paint #spinFlyinLocationTitle (it sits under the
                // territories scrim when the user returns home).
                if (!(opts && opts.jutdeeLocationView)) {
                    revealFlyinTitleAfterMove(data.title || data.name || '', {
                        flyMs: flyMs,
                        fallbackMs: flyMs + 600,
                        afterReveal: function () {
                            if (opts && opts.skipDetail) return;
                            if (opts && opts.postImport) return;
                            setTimeout(function () {
                                try {
                                    if (typeof showGfeDetailModal === 'function') {
                                        showGfeDetailModal(data);
                                    }
                                } catch (err) {
                                    console.warn('[gfe-focus] post-flyin UI failed', err);
                                }
                            }, 500);
                        }
                    });
                }

                try {
                    attachPinkBuildings();
                } catch (err) { console.warn('[gfe-focus] 3D buildings layer add failed', err); }

                try {
                    map.flyTo({
                        center: [lng, lat],
                        zoom: 16,
                        pitch: 50,
                        bearing: 0,
                        duration: flyMs,
                        essential: true,
                        curve: 1.4
                    });
                    console.log('[gfe-focus] flyTo dispatched');
                } catch(e) {
                    console.warn('[gfe-focus] flyTo failed', e);
                }
                if (opts && opts.postImport) {
                    if (!(opts && opts.jutdeeLocationView)) {
                        scheduleGfePostImportBanner(data, flyMs);
                    }
                }

                dropPin();
                // Slide-1 click flow gets the rich interactive grid
                // (lime owned + pink adjacency + click-to-select) and
                // the bottom-center commit overlay. The importer flow
                // (skipDetail falsy) keeps the single-cell preview
                // since its detail modal owns the next action.
                //
                // ensureH3() wrap is mandatory here — the h3 lib is
                // loaded lazily from CDN on first use (see paintHexes
                // for the canonical pattern). Without this wrap,
                // renderBranchHexGrid hits its `typeof h3 ===
                // 'undefined'` guard on first focus and returns
                // silently, leaving the grid invisible.
                if (opts && opts.skipDetail) {
                    var savedHexes = Array.isArray(data.hexes) ? data.hexes : [];
                    var hexRenderGen = data.__hexRenderGen != null ? data.__hexRenderGen : _branchHexRenderGen;
                    ensureH3(function () {
                        renderBranchHexGrid({
                            lat: lat,
                            lng: lng,
                            savedHexes: savedHexes,
                            renderGen: hexRenderGen
                        });
                    });
                } else {
                    paintHexes();
                }
            }

            // The map is interactive-ready as soon as its style is
            // loaded; tiles can keep streaming in afterwards. `loaded()`
            // is too strict (it returns false whenever ANY tile is
            // mid-fetch), and `map.once('load', …)` only fires for the
            // very first style load — bind it after that fires and the
            // callback never runs, which is exactly the bug we're
            // fixing here. `isStyleLoaded()` + a `styledata` fallback
            // covers both cases.
            if (map.isStyleLoaded && map.isStyleLoaded()) {
                flyAndPaint();
            } else {
                console.log('[gfe-focus] style not loaded yet, deferring');
                var fired = false;
                var onReady = function() {
                    if (fired) return;
                    if (map.isStyleLoaded && !map.isStyleLoaded()) return;
                    fired = true;
                    map.off('styledata', onReady);
                    map.off('idle', onReady);
                    flyAndPaint();
                };
                map.on('styledata', onReady);
                map.on('idle', onReady);
                // Hard fallback — even if no event fires (bad style URL,
                // offline, etc.) we still try to fly so the user isn't
                // stuck on a frozen modal-less landing page.
                setTimeout(onReady, 2000);
            }
            } catch (focusErr) {
                console.error('[gfe-focus] pingLandingFocusOnGamifeye failed', focusErr);
                if (opts && opts.postImport) {
                    try { showGfeCreatedBanner(data); } catch (bannerErr) {
                        console.warn('[gfe-focus] post-crash banner failed', bannerErr);
                    }
                }
            }
        };

        // ── Slide-1 focal-point card click → in-place flyTo ──────────────
        // Intercepts clicks on the slide-1 focal-point cards
        // (#pingFpLocationsList .ping-fp-location-item) and routes
        // them through pingLandingFocusOnGamifeye() with
        // `skipDetail: true` instead of letting the <a> navigate to
        // /focal-points?fp=<id>. Carousel closes, map flies to the
        // focal point, paints its 7-cell hex grid, drops the pin —
        // no detail modal afterwards.
        //
        // Defensive ordering: we ONLY preventDefault after we've
        // confirmed coords are present AND pingLandingFocusOnGamifeye
        // exists. If either is missing, the click falls through to
        // the <a>'s href so the user still gets routed to
        // /focal-points as a fallback rather than dead-clicking.
        //
        // Single-flight cache for the lazy hex fetch below. Keyed by
        // areaId so a frantic clicker on the same card doesn't fire N
        // parallel requests. The entry self-removes on settlement
        // (success or failure) so a later click after expansion
        // changes can still re-fetch.
        var _fpHexesInFlight = new Map();

        document.addEventListener('click', function (e) {
            var card = e.target && e.target.closest && e.target.closest('.ping-fp-location-item');
            if (!card) return;
            if (!card.closest('#pingFpLocationsList')) return;
            if (card.classList.contains('ping-fp-location-item--disabled') || card.getAttribute('data-subscription-locked') === '1') {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            var lat = parseFloat(card.getAttribute('data-lat'));
            var lng = parseFloat(card.getAttribute('data-lng'));
            if (!isFinite(lat) || !isFinite(lng)) return;
            if (typeof window.pingLandingFocusOnGamifeye !== 'function') return;
            e.preventDefault();
            e.stopPropagation();
            // The h3 index list is no longer embedded inline on every
            // card — it starts empty and is fetched on click from
            // /api/locations/{areaId}/hexes (Redis-cached, count+max(id)
            // keyed). The post-expansion write-back in
            // saveBranchHexExpansion's success branch keeps writing the
            // updated list back to data-hexes so the second click on
            // the same card after an expansion is synchronous. See
            // UserController::areaHexes() for the endpoint.
            var hexes = [];
            try { hexes = JSON.parse(card.getAttribute('data-hexes') || '[]'); } catch (_) { hexes = []; }
            var areaId = parseInt(card.getAttribute('data-areaid'), 10);
            var fpData = null;
            var rawPayload = card.getAttribute('data-gfe-loc-payload');
            if (rawPayload) {
                try { fpData = JSON.parse(rawPayload); } catch (_) { fpData = null; }
            }
            if (!fpData) {
                fpData = {
                    id:              card.getAttribute('data-fpid') || '',
                    eyeland_area_id: isNaN(areaId) ? null : areaId,
                    title:           card.getAttribute('data-title') || '',
                    logo_url:        card.getAttribute('data-logo') || ''
                };
            }
            fpData.latitude  = lat;
            fpData.longitude = lng;
            fpData.hexes     = hexes;
            fpData.__cardEl  = card;
            fpData.__hexRenderGen = ++_branchHexRenderGen;

            // Fire the flyTo + preview-ring render immediately so
            // motion starts at click time. renderBranchHexGrid falls
            // back to gridDisk(centerCell, 1) — a 7-cell preview — when
            // savedHexes is empty, which matches the new-focal-point
            // default zone size and is the right visual fallback while
            // the real claimed zone is in flight.
            // Jutdee: open the frosted manage modal instead of bare
            // full-screen focus chrome.
            var PL = window.__pingL10n || {};
            if (PL.isJutdeeTenant
                && typeof window.showJutdeeLocationViewForExisting === 'function') {
                window.showJutdeeLocationViewForExisting(fpData);
            } else {
                window.pingLandingFocusOnGamifeye(fpData, { skipDetail: true });
            }

            if (hexes.length > 0 || isNaN(areaId) || areaId <= 0) return;
            if (typeof window.pingLandingPaintFpHexesLate !== 'function') return;

            var inflight = _fpHexesInFlight.get(areaId);
            if (!inflight) {
                inflight = fetch('/api/locations/' + encodeURIComponent(areaId) + '/hexes', {
                    credentials: 'same-origin',
                    headers: { 'Accept': 'application/json' }
                })
                    .then(function (r) { return r.ok ? r.json() : { hexes: [] }; })
                    .then(function (j) { return (j && Array.isArray(j.hexes)) ? j.hexes : []; })
                    .catch(function () { return []; })
                    .then(function (real) {
                        _fpHexesInFlight.delete(areaId);
                        return real;
                    });
                _fpHexesInFlight.set(areaId, inflight);
            }
            inflight.then(function (real) {
                if (!real || !real.length) return;
                if (_branchActiveAreaId !== areaId) return;
                try { card.setAttribute('data-hexes', JSON.stringify(real)); } catch (_) {}
                var lateGen = ++_branchHexRenderGen;
                try {
                    window.pingLandingPaintFpHexesLate(lat, lng, real, areaId, lateGen);
                } catch (_) {}
            });
        }, false);

        // ── #pingFocusCloseBtn click ─────────────────────────────────────
        // Post-import before first save (is-gfe-import-setup-pending):
        // opens #gfeEditModal. After save, or slide-1 focus: fly back to
        // the locations carousel.
        (function () {
            var closeBtn = document.getElementById('pingFocusCloseBtn');
            if (!closeBtn) return;
            closeBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if (document.body.classList.contains('is-route-focused')) {
                    if (typeof window.pingLandingCloseRouteOverlay === 'function') {
                        window.pingLandingCloseRouteOverlay();
                    }
                    return;
                }
                if (document.body.classList.contains('is-gfe-import-setup-pending')) {
                    if (typeof window.openGfeEditFromPostImportFlyin === 'function') {
                        window.openGfeEditFromPostImportFlyin();
                    }
                    return;
                }
                if (document.body.classList.contains('is-gfe-import-flyin')
                    || document.body.classList.contains('is-gfe-focused')) {
                    if (_branchExpandInFlight) return;
                    if (_branchSelectedHexes && _branchSelectedHexes.size > 0) {
                        var n = _branchSelectedHexes.size;
                        if (!confirm('Discard ' + n + ' unsaved hex' + (n === 1 ? '' : 'es') + '?')) return;
                    }
                    if (typeof window.exitJutdeeExpandZoneToFocalPoints === 'function'
                        && window.exitJutdeeExpandZoneToFocalPoints()) {
                        return;
                    }
                    if (typeof window.exitGfeFlyinToItemView === 'function') {
                        window.exitGfeFlyinToItemView();
                    }
                    return;
                }
            });
        })();

        // ── GamifEYED Town detail modal ──────────────────────────────────
        // Parallel of pingLandingFocusOnGamifeye above, but for a
        // claimed Eyeland ("GamifEYED Town") surfaced in #gfeTownsList
        // inside #gfeTownsTabbedMount on the intro modal (resources/views/public/ping-landing.blade.php).
        // The click handler on the town cards lives in that blade (so it can
        // respect the SortableJS suppressNextClick flag the merge
        // tray already manages) and hands off to this function with
        // the card's data-* bundle parsed into a payload.
        //
        // Visual contract mirrors the location-click path:
        //   1. Intro card flies UP (hideIntro → spinFlyOut).
        //   2. Main map flies to the town — fitBounds on the
        //      boundary polygon when available, plain flyTo on the
        //      centroid otherwise — and paints the boundary outline
        //      (magenta fill + stroke, same language as the merge-
        //      preview hero map).
        //   3. After moveend + 500ms dwell, #townDetailModal bounces
        //      in from the top (gfeDetailBounceIn).
        //
        // Close handler is the inverse: intro reopens and the right
        // overlay expands; #gfeTownsTabbedMount scrolls into view inside
        // the intro body so the user lands back on Your Places / merge.
        //
        // Town POI heatmap state — lives at IIFE scope so the
        // Overpass selector's fetch handler (further down) and
        // the modal-close handler can both manage the layers
        // without tripping on each other.
        //
        // Structure:
        //   sourceId  one shared GeoJSON source for every POI
        //             Point feature; the per-category filter
        //             below is what fans the points out into
        //             separate heatmap layers.
        //   layerIds  every heatmap layer id we added, so tear-
        //             down can iterate and remove cleanly.
        //   legend    the custom maplibregl.IControl instance
        //             we drop into the top-left corner of the
        //             map. Kept so we can map.removeControl()
        //             it during teardown rather than relying
        //             on DOM surgery.
        var townPoiState = {
            sourceId: 'town-poi-src',
            layerIds: [],
            legend: null
        };

        // Cached boundary GeoJSON Feature for the currently-focused
        // town. Kept in sync by drawTownBoundary() and cleared by
        // resetTownMapOverlays(), so renderTownPoiHeatmaps() can
        // fold a ['within', <boundary>] clause into each heatmap
        // layer's filter and automatically drop any POI that fell
        // in the bbox-based Overpass query but outside the actual
        // polygon. We cache the feature client-side rather than
        // reading .getSource('town-boundary')._data because that
        // private field isn't part of MapLibre's public API.
        var townBoundaryCache = null;
        var townFocusSeq = 0;

        function townBoundaryLayerPaint() {
            var jutdee = document.body.classList.contains('is-jutdee-tenant');
            return {
                fillColor: jutdee ? '#D85A30' : '#ff2bd6',
                fillOpacity: jutdee ? 0.24 : 0.16,
                lineColor: jutdee ? '#4A3B2A' : '#ff2bd6',
                lineWidth: jutdee ? 3.5 : 2.2,
            };
        }

        function applyTownBoundaryPaint() {
            var paint = townBoundaryLayerPaint();
            try {
                if (map.getLayer('town-boundary-fill')) {
                    map.setPaintProperty('town-boundary-fill', 'fill-color', paint.fillColor);
                    map.setPaintProperty('town-boundary-fill', 'fill-opacity', paint.fillOpacity);
                }
                if (map.getLayer('town-boundary-line')) {
                    map.setPaintProperty('town-boundary-line', 'line-color', paint.lineColor);
                    map.setPaintProperty('town-boundary-line', 'line-width', paint.lineWidth);
                }
            } catch (e) {}
        }

        function ensureTownBoundaryLayers() {
            if (!map.getSource('town-boundary')) return;
            var paint = townBoundaryLayerPaint();
            if (!map.getLayer('town-boundary-fill')) {
                map.addLayer({
                    id: 'town-boundary-fill',
                    type: 'fill',
                    source: 'town-boundary',
                    paint: { 'fill-color': paint.fillColor, 'fill-opacity': paint.fillOpacity }
                });
            }
            if (!map.getLayer('town-boundary-line')) {
                map.addLayer({
                    id: 'town-boundary-line',
                    type: 'line',
                    source: 'town-boundary',
                    paint: {
                        'line-color': paint.lineColor,
                        'line-width': paint.lineWidth,
                        'line-opacity': 0.95
                    }
                });
            }
            applyTownBoundaryPaint();
            try {
                // Keep outline above Jutdee satellite raster (added mid-fly-in).
                if (map.getLayer('town-boundary-line')) map.moveLayer('town-boundary-line');
                if (map.getLayer('town-boundary-fill') && map.getLayer('town-boundary-line')) {
                    map.moveLayer('town-boundary-fill', 'town-boundary-line');
                }
            } catch (e) {}
        }

        function fetchTownBoundaryRing(areaId, focusSeq, onRing) {
            if (!areaId) return;
            var cached = lookupTownBoundaryRing(areaId);
            if (cached) {
                if (focusSeq === townFocusSeq && typeof onRing === 'function') onRing(cached);
                return;
            }
            fetch('/api/territories/' + encodeURIComponent(areaId) + '/boundary', {
                credentials: 'same-origin',
                headers: { 'Accept': 'application/json' }
            })
                .then(function (r) { return r.ok ? r.json() : { boundary: null }; })
                .then(function (j) {
                    if (focusSeq !== townFocusSeq) return;
                    var ring = (j && j.boundary) || null;
                    if (ring && ring.length >= 3) {
                        rememberTownBoundaryRing(areaId, ring);
                    }
                    if (ring && typeof onRing === 'function') onRing(ring);
                })
                .catch(function () {});
        }
        window.__pingFetchTownBoundaryRing = fetchTownBoundaryRing;

        function clearTownPoiHeatmaps() {
            if (!map) return;
            for (var i = 0; i < townPoiState.layerIds.length; i++) {
                try {
                    if (map.getLayer(townPoiState.layerIds[i])) {
                        map.removeLayer(townPoiState.layerIds[i]);
                    }
                } catch(e) {}
            }
            townPoiState.layerIds = [];
            try {
                if (map.getSource(townPoiState.sourceId)) {
                    map.removeSource(townPoiState.sourceId);
                }
            } catch(e) {}
            if (townPoiState.legend) {
                try { map.removeControl(townPoiState.legend); } catch(e) {}
                townPoiState.legend = null;
            }
            // Hide the floating Targets cart in lock-step with the
            // legend. The cart's purpose (add targets from the
            // legend rows) is meaningless without the legend on
            // screen, so the two surfaces appear and disappear
            // together. See .is-visible rule on #gfeTargetCart in
            // ping-landing.css for the fade treatment.
            var cartEl = document.getElementById('gfeTargetCart');
            if (cartEl) cartEl.classList.remove('is-visible');
        }

        function resetTownMapOverlays() {
            try { if (map.getLayer('town-boundary-fill')) map.removeLayer('town-boundary-fill'); } catch(e) {}
            try { if (map.getLayer('town-boundary-line')) map.removeLayer('town-boundary-line'); } catch(e) {}
            try { if (map.getSource('town-boundary'))    map.removeSource('town-boundary'); }    catch(e) {}
            townBoundaryCache = null;
            clearTownPoiHeatmaps();
        }

        // Normalise whatever boundary shape the server serialised into
        // a real GeoJSON Feature MapLibre can consume. We accept:
        //   - a flat ring [[lng,lat], ...]                → Polygon
        //   - a list of rings [[[lng,lat],...], ...]      → MultiPolygon
        //   - a bare Polygon / MultiPolygon geometry      → wrapped
        //   - an existing GeoJSON Feature                 → returned as-is
        // Returns null on empty / malformed input so callers can
        // fall back to the centre lat/lng without crashing.
        function townBoundaryFeature(raw) {
            if (!raw) return null;
            if (Array.isArray(raw)) {
                if (!raw.length) return null;
                if (typeof raw[0][0] === 'number') {
                    return { type: 'Feature', properties: {}, geometry: { type: 'Polygon', coordinates: [raw] } };
                }
                if (Array.isArray(raw[0]) && Array.isArray(raw[0][0]) && typeof raw[0][0][0] === 'number') {
                    return {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'MultiPolygon',
                            coordinates: raw.map(function (r) { return [r]; })
                        }
                    };
                }
                return null;
            }
            if (raw.type === 'Feature' && raw.geometry) return raw;
            if (raw.type === 'Polygon' || raw.type === 'MultiPolygon') {
                return { type: 'Feature', properties: {}, geometry: raw };
            }
            return null;
        }

        function townBoundaryBounds(feature) {
            if (!feature || !feature.geometry) return null;
            var minLng = Infinity, minLat = Infinity, maxLng = -Infinity, maxLat = -Infinity;
            var found = false;
            function walk(node) {
                if (!node) return;
                if (typeof node[0] === 'number' && typeof node[1] === 'number') {
                    if (node[0] < minLng) minLng = node[0];
                    if (node[0] > maxLng) maxLng = node[0];
                    if (node[1] < minLat) minLat = node[1];
                    if (node[1] > maxLat) maxLat = node[1];
                    found = true; return;
                }
                for (var i = 0; i < node.length; i++) walk(node[i]);
            }
            walk(feature.geometry.coordinates);
            return found ? [[minLng, minLat], [maxLng, maxLat]] : null;
        }

        function drawTownBoundary(feature) {
            if (!feature) return;
            townBoundaryCache = feature;
            try {
                if (map.getSource('town-boundary')) {
                    map.getSource('town-boundary').setData(feature);
                    ensureTownBoundaryLayers();
                    return;
                }
                map.addSource('town-boundary', { type: 'geojson', data: feature });
                ensureTownBoundaryLayers();
            } catch(e) { console.warn('[town-focus] boundary draw failed', e); }
        }

        // Late-arriving boundary entry point used by the town-card click
        // handler in ping-landing.blade.php. The card fires
        // pingLandingFocusOnTown(payload) with boundary:null immediately
        // so motion starts at click time, then calls this once the
        // /api/territories/{id}/boundary fetch resolves to paint the
        // magenta outline and tighten the framing onto the polygon.
        //
        // Safe to call after the initial flyTo + town-detail modal have
        // started — drawTownBoundary uses setData() when the source
        // already exists, and fitBounds() smoothly re-frames the camera
        // around the actual polygon rather than the centroid fallback.
        window.pingLandingPaintTownBoundaryLate = function (ring) {
            var feature = townBoundaryFeature(ring);
            if (!feature) return;
            try { drawTownBoundary(feature); } catch (e) {}
            var bounds = townBoundaryBounds(feature);
            if (!bounds) return;
            try {
                map.fitBounds(bounds, {
                    padding: 60,
                    pitch: 45,
                    bearing: 0,
                    duration: 1500,
                    maxZoom: 14,
                    essential: true,
                    linear: false
                });
            } catch (e) {}
        };

        function showTownDetailModal(data) {
            clearSpinFlyinLocationTitle();
            clearPingHeroLocationImage();
            var modalEl = document.getElementById('townDetailModal');
            if (!modalEl || !data) return;

            function setText(id, val) {
                var el = document.getElementById(id);
                if (el) el.textContent = val == null ? '' : String(val);
            }

            // Hero image — wikipedia thumbnail when present, with the
            // same preload-then-fade pattern the GamifEYE hero uses so
            // the .is-loaded fade runs against a warm cache.
            var heroImg      = document.getElementById('townDetailHeroImg');
            var heroFallback = document.getElementById('townDetailHeroFallback');
            if (heroImg) {
                heroImg.classList.remove('is-loaded');
                heroImg.style.backgroundImage = '';
            }
            if (heroFallback) heroFallback.style.display = '';
            var thumb = data.thumbnail || '';
            if (thumb && heroImg) {
                var probe = new Image();
                probe.onload = function() {
                    heroImg.style.backgroundImage = "url('" + thumb.replace(/'/g, "%27") + "')";
                    heroImg.classList.add('is-loaded');
                    if (heroFallback) heroFallback.style.display = 'none';
                };
                probe.onerror = function() { /* fallback stays visible */ };
                probe.src = thumb;
            }

            // Level + reward pills — hidden when the payload doesn't
            // carry them (shouldn't happen in practice, but defensive
            // so the hero doesn't render with empty "Lv" / "+⬡"
            // chips).
            var levelEl  = document.getElementById('townDetailLevel');
            var rewardEl = document.getElementById('townDetailReward');
            if (levelEl) {
                if (data.level !== '' && data.level != null) {
                    levelEl.textContent = 'Lv ' + data.level;
                    levelEl.style.display = '';
                } else {
                    levelEl.style.display = 'none';
                }
            }
            if (rewardEl) {
                if (data.reward !== '' && data.reward != null) {
                    rewardEl.textContent = '+' + data.reward + ' \u2B22';
                    rewardEl.style.display = '';
                } else {
                    rewardEl.style.display = 'none';
                }
            }

            setText('townDetailTitle', data.name || 'GamifEYED Town');

            var countryEl = document.getElementById('townDetailCountry');
            if (countryEl) {
                if (data.country) {
                    countryEl.textContent = data.country;
                    countryEl.style.display = '';
                } else {
                    countryEl.style.display = 'none';
                }
            }

            // Wikipedia extract.
            //
            // When data.wiki_url is present we render the paragraph
            // body as an anchor (class .gfe-detail-wiki-link) so the
            // user can deep-link straight into the full Wikipedia
            // article. We build the anchor imperatively rather than
            // via innerHTML to avoid injecting HTML from an extract
            // field, and open in a new tab with noopener/noreferrer
            // so the landing page doesn't lose its animation state.
            //
            // Without a wiki_url we fall back to plain-text, matching
            // the pre-existing behaviour (and keeps layout identical
            // for areas whose wikipedia_json never carried a page_url).
            var extractEl = document.getElementById('townDetailExtract');
            if (extractEl) {
                while (extractEl.firstChild) extractEl.removeChild(extractEl.firstChild);
                if (data.extract) {
                    if (data.wiki_url) {
                        var wikiA = document.createElement('a');
                        wikiA.href = data.wiki_url;
                        wikiA.className = 'gfe-detail-wiki-link';
                        wikiA.target = '_blank';
                        wikiA.rel = 'noopener noreferrer';
                        wikiA.textContent = data.extract;
                        extractEl.appendChild(wikiA);
                        var caret = document.createElement('i');
                        caret.className = 'bi bi-box-arrow-up-right gfe-detail-wiki-caret';
                        caret.setAttribute('aria-hidden', 'true');
                        extractEl.appendChild(document.createTextNode(' '));
                        extractEl.appendChild(caret);
                    } else {
                        extractEl.appendChild(document.createTextNode(data.extract));
                    }
                    extractEl.style.display = '';
                } else {
                    extractEl.style.display = 'none';
                }
            }

            // Stat tiles — em-dash placeholder for missing / non-
            // numeric values so the grid never renders with literal
            // "null" / "NaN" text.
            function fmtInt(n) {
                if (n == null || n === '' || !isFinite(+n)) return '\u2014';
                return (+n).toLocaleString();
            }
            function fmtFloat1(n) {
                if (n == null || n === '' || !isFinite(+n)) return '\u2014';
                return (+n).toLocaleString(undefined, { maximumFractionDigits: 1 });
            }
            setText('townDetailArea',     fmtFloat1(data.area_km2));
            setText('townDetailPop',      fmtInt(data.population));
            setText('townDetailHex',      fmtInt(data.hex_count));
            setText('townDetailClaims',   fmtInt(data.total_claims));
            setText('townDetailVisitors', fmtInt(data.unique_visitors));

            // Bind the currently-viewed eyeland_area_id onto the
            // Overpass selector panel, and reset its transient UI so
            // a reopen never shows stale results from the previous
            // town. The selector's own event handlers (wireTownOverpassSelector)
            // read data-area-id at click time, so just stamping it
            // here is enough to re-point the preview endpoint.
            var overpassEl = document.getElementById('townDetailOverpass');
            if (overpassEl) {
                if (data.eyeland_area_id) {
                    overpassEl.setAttribute('data-area-id', String(data.eyeland_area_id));
                } else {
                    overpassEl.removeAttribute('data-area-id');
                }
                try { resetTownOverpassSelector(overpassEl); } catch(e) {}

                // Auto-kick the POI count fetch on modal open so a
                // town we've already scanned shows its cached POI
                // count immediately — the user should never see "—"
                // on a town that's actually been scanned. The
                // backend serves the cached row from town_poi_scans
                // when present and only falls through to Overpass
                // for first-time scans, so this is cheap for the
                // common reopen case. Small rAF delay so the
                // bounce-in animation gets its first paint before
                // the button flips into its loading state.
                if (data.eyeland_area_id && typeof window.triggerTownHeatmapsPreview === 'function') {
                    window.requestAnimationFrame(function () {
                        window.requestAnimationFrame(function () {
                            try { window.triggerTownHeatmapsPreview(); } catch (e) {}
                        });
                    });
                }
            }

            modalEl.classList.remove('is-flying-out');
            // Reflow so the bounce animation restarts on a reopen.
            // eslint-disable-next-line no-unused-expressions
            modalEl.offsetHeight;
            modalEl.classList.add('visible');
        }

        // ── Town heatmap CTA (inside the town-detail modal) ───
        //
        // UI contract with the blade:
        //   #townDetailOverpass          container; carries data-area-id
        //   #townDetailHeatmapsBtn       single action button; data-url="/towns"
        //   #townDetailPreviewCount      POI-count span inside the button
        //   #townDetailHeatmapsError     inline error line (role="alert")
        //
        // Lifecycle:
        //   1. Modal opens → auto-fire preview → populate count,
        //      enable button, flip to 'ready' state.
        //   2. User clicks button → fire fetch → render heatmaps →
        //      bounce modal up to reveal the map.
        //
        // The preview/fetch always covers every category in
        // window.TOWN_POI_CATEGORIES — there is no per-category
        // chip selector.

        function resetTownOverpassSelector(rootEl) {
            if (!rootEl) rootEl = document.getElementById('townDetailOverpass');
            if (!rootEl) return;
            var btn = rootEl.querySelector('#townDetailHeatmapsBtn');
            if (btn) {
                // Return the button to its pristine "loading the
                // count" state. Disabled until the auto-preview
                // succeeds and stamps a real number onto the label.
                btn.disabled = true;
                btn.classList.remove('is-loading', 'is-error', 'is-ready');
                btn.classList.add('is-priming');
                var title = btn.querySelector('.town-detail-heatmaps-title');
                if (title) {
                    title.textContent = btn.getAttribute('data-label-idle') || 'View Heatmaps';
                }
                var countEl = btn.querySelector('#townDetailPreviewCount');
                if (countEl) countEl.textContent = '—';
            }
            var errEl = rootEl.querySelector('#townDetailHeatmapsError');
            if (errEl) {
                errEl.textContent = '';
                errEl.hidden = true;
            }
        }

        // Modal bounce-up helper (used by the "Show on map" flow).
        //
        // Reuses the same #townDetailModal.is-flying-out keyframe the
        // close button uses, but *stops* after the card has left the
        // viewport — we deliberately skip the subsequent map teardown
        // and intro-modal restore because the whole point of this
        // flow is to leave the user looking at the town on the map
        // with the fresh POI markers painted. Mirrors the DETAIL_FLYOUT_MS
        // constant inside wireTownDetailClose; keep the two in sync.
        var TOWN_MODAL_FLYOUT_MS = 450;
        function bounceTownModalUpOnly() {
            var modalEl = document.getElementById('townDetailModal');
            if (!modalEl || !modalEl.classList.contains('visible')) return;
            modalEl.classList.add('is-flying-out');
            setTimeout(function () {
                modalEl.classList.remove('visible');
                modalEl.classList.remove('is-flying-out');
            }, TOWN_MODAL_FLYOUT_MS);
        }

        // Category-key → {icon, color, label} lookup, built on demand
        // from the blade-embedded window.TOWN_POI_CATEGORIES array.
        // Falls back to a generic magenta hexagon when either the
        // catalog isn't on the page (dev preview without @auth) or
        // the POI's category key doesn't resolve — the marker still
        // renders, just with neutral styling.
        function townPoiCategoryIndex() {
            var raw = Array.isArray(window.TOWN_POI_CATEGORIES)
                ? window.TOWN_POI_CATEGORIES
                : [];
            var idx = {};
            for (var i = 0; i < raw.length; i++) {
                var c = raw[i] || {};
                if (!c.key) continue;
                idx[c.key] = {
                    key:   c.key,
                    label: c.label || c.key,
                    icon:  c.icon  || 'bi-hexagon-fill',
                    color: c.color || '#ff2bd6',
                    // match_tags is included in the blade's category
                    // bridge — see the $__townPoiCategoriesJs loop in
                    // resources/views/public/ping-landing.blade.php.
                    // Kept here so derivePrimaryTag() can classify a
                    // POI into a sub-category without another server
                    // roundtrip.
                    match_tags: Array.isArray(c.match_tags) ? c.match_tags : []
                };
            }
            idx._fallback = {
                key:   '_fallback',
                label: 'POI',
                icon:  'bi-hexagon-fill',
                color: '#ff2bd6',
                match_tags: []
            };
            return idx;
        }

        // Derive the (tag_key, tag_value) pair that classified a POI
        // into its parent category. Mirrors primaryTagForCategory() in
        // app/Http/Controllers/TownPoiController.php exactly: walk the
        // parent's match_tags rules in declared order and return the
        // first rule whose key is present on the POI AND (rule values
        // is null OR the POI's value is in the rule values).
        //
        // Having this client-side means the legend can count and
        // toggle sub-categories from data already on the page (POIs
        // carry their full OSM tag bag in p.tags) rather than hitting
        // /pois/histogram on every expand. Saves a roundtrip and keeps
        // the legend reactive to the same POIs the map actually shows.
        function derivePrimaryTag(tags, catEntry) {
            if (!tags || !catEntry || !Array.isArray(catEntry.match_tags)) {
                return { tag_key: null, tag_value: null };
            }
            var rules = catEntry.match_tags;
            for (var i = 0; i < rules.length; i++) {
                var rule = rules[i] || [];
                var k = rule[0];
                var vs = rule[1];
                if (!k) continue;
                if (!Object.prototype.hasOwnProperty.call(tags, k)) continue;
                var v = tags[k];
                if (v == null || v === '') continue;
                if (vs == null) {
                    return { tag_key: k, tag_value: String(v) };
                }
                if (Array.isArray(vs)) {
                    for (var j = 0; j < vs.length; j++) {
                        if (vs[j] === v) {
                            return { tag_key: k, tag_value: String(v) };
                        }
                    }
                }
            }
            return { tag_key: null, tag_value: null };
        }

        // Parse '#ff2bd6' → [255, 43, 214]. Used to build the rgba()
        // strings in the heatmap-color gradient. Returns null on
        // anything that isn't a clean 6-digit hex so the caller
        // can fall back to the magenta default.
        function hexToRgb(hex) {
            if (typeof hex !== 'string') return null;
            var m = /^#?([a-fA-F0-9]{6})$/.exec(hex.trim());
            if (!m) return null;
            var n = parseInt(m[1], 16);
            return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
        }
        function rgbaString(rgb, a) {
            return 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + a + ')';
        }

        // Render a list of POIs as per-category MapLibre heatmap
        // layers backed by a single shared GeoJSON source.
        //
        // Why one source + filtered layers (rather than one
        // source per category):
        //   - Heatmaps evaluate density per-layer, so a filtered
        //     layer still gets a "clean" density field over just
        //     its own points.
        //   - It means a single .setData() call could swap the
        //     whole dataset in a future update without having
        //     to diff N sources.
        //
        // Layer styling: each heatmap fades transparent → category
        // colour as density rises, inserted beneath the boundary
        // line so the outline stays crisp on top of the heat.
        //
        // After the layers are added we drop a custom IControl
        // into the top-left of the map (the "legend") whose
        // rows toggle each layer's visibility. The control fades
        // in via the .is-visible class on the next animation
        // frame — that frame coincides with the modal's
        // bounce-out so the legend appears as the card lifts.
        function renderTownPoiHeatmaps(pois) {
            clearTownPoiHeatmaps();
            if (!Array.isArray(pois) || !pois.length) return;
            if (typeof maplibregl === 'undefined' || !map) return;

            var idx = townPoiCategoryIndex();

            // Counts maintained alongside the feature stream so the
            // legend can render parent totals, per-sub counts, and
            // the "N Data Points" header without a second pass over
            // the payload. Shape:
            //   catCounts[catKey]              = total POIs in that parent
            //   subCounts[catKey][subId]       = POIs in that (tag_key, tag_value)
            //   subMeta  [catKey][subId]       = { tag_key, tag_value } lookup
            //   subOrder [catKey]              = insertion order of subIds
            //                                    (so legend list is stable)
            //   totalCount                     = sum of every valid POI
            //
            // subId is the composite "tag_key=tag_value" — used as a
            // single feature property so MapLibre filter expressions
            // can check membership with a plain ['in', ...] rather
            // than compounding two ['get'] calls.
            var features = [];
            var present = {};
            var catCounts = {};
            var subCounts = {};
            var subMeta   = {};
            var subOrder  = {};
            var totalCount = 0;

            for (var i = 0; i < pois.length; i++) {
                var p = pois[i];
                if (!p || !isFinite(+p.lat) || !isFinite(+p.lng)) continue;
                var catKey = (p.category && idx[p.category]) ? p.category : '_fallback';

                var primary = derivePrimaryTag(p.tags || {}, idx[catKey]);
                var subId = (primary.tag_key && primary.tag_value)
                    ? (primary.tag_key + '=' + primary.tag_value)
                    : '_uncategorised';

                features.push({
                    type: 'Feature',
                    geometry: { type: 'Point', coordinates: [+p.lng, +p.lat] },
                    properties: {
                        category:  catKey,
                        sub_id:    subId,
                        tag_key:   primary.tag_key || '',
                        tag_value: primary.tag_value || ''
                    }
                });
                present[catKey] = true;
                totalCount++;
                catCounts[catKey] = (catCounts[catKey] || 0) + 1;

                if (!subCounts[catKey]) { subCounts[catKey] = {}; subMeta[catKey] = {}; subOrder[catKey] = []; }
                if (!Object.prototype.hasOwnProperty.call(subCounts[catKey], subId)) {
                    subCounts[catKey][subId] = 0;
                    subMeta[catKey][subId] = {
                        tag_key:   primary.tag_key,
                        tag_value: primary.tag_value,
                        sub_id:    subId
                    };
                    subOrder[catKey].push(subId);
                }
                subCounts[catKey][subId]++;
            }
            if (!features.length) return;

            try {
                map.addSource(townPoiState.sourceId, {
                    type: 'geojson',
                    data: { type: 'FeatureCollection', features: features }
                });
            } catch (e) {
                console.warn('[town-poi] add source failed', e);
                return;
            }

            // Insert heatmaps beneath the boundary line so the
            // outline stays crisp on top of the heat. Fall back
            // to top-of-stack if the boundary line isn't
            // present (shouldn't happen but defensive).
            var beforeId = null;
            try {
                if (map.getLayer('town-boundary-line')) beforeId = 'town-boundary-line';
            } catch(e) {}

            // Walk the catalog in its declared order so the
            // legend rows and the layer stack always agree,
            // then append the _fallback bucket if anything
            // landed in it.
            var catalog = Array.isArray(window.TOWN_POI_CATEGORIES)
                ? window.TOWN_POI_CATEGORIES
                : [];
            var catList = [];
            for (var c = 0; c < catalog.length; c++) {
                var k = catalog[c] && catalog[c].key;
                if (k && present[k] && idx[k]) catList.push(idx[k]);
            }
            if (present._fallback) catList.push(idx._fallback);

            // Build the base filter we'll combine with each
            // category check. If we have a boundary cached from
            // the most recent drawTownBoundary() call, use the
            // ['within', <polygon>] expression so MapLibre drops
            // any POI point that landed in the bbox-based Overpass
            // query but outside the real town boundary — no
            // bleed of the heat across the outline.
            var clipFilter = null;
            if (townBoundaryCache && townBoundaryCache.geometry) {
                clipFilter = ['within', townBoundaryCache];
            }

            for (var j = 0; j < catList.length; j++) {
                var cat = catList[j];
                var rgb = hexToRgb(cat.color) || [255, 43, 214];
                var layerId = 'town-poi-heat-' + cat.key;
                var layerFilter = clipFilter
                    ? ['all', ['==', ['get', 'category'], cat.key], clipFilter]
                    : ['==', ['get', 'category'], cat.key];
                try {
                    map.addLayer({
                        id: layerId,
                        type: 'heatmap',
                        source: townPoiState.sourceId,
                        filter: layerFilter,
                        paint: {
                            // Weight per feature. Bumped from 1.0 to
                            // 1.4 so a town like Lisburn (400+ POIs
                            // in one category) lights up mid-zoom
                            // where fitBounds parks the camera after
                            // flyTo. Anything beyond ~1.5 starts
                            // saturating the colour ramp at low
                            // density and loses the gradient, which
                            // is why we're not going higher.
                            'heatmap-weight': 1.4,
                            // Intensity is a global multiplier
                            // applied before the colour ramp —
                            // cranking it at the zooms where towns
                            // are usually framed (10–14) is the
                            // single biggest readability win.
                            'heatmap-intensity': [
                                'interpolate', ['linear'], ['zoom'],
                                0,  0.8,
                                9,  1.6,
                                12, 2.2,
                                15, 2.8
                            ],
                            // Larger radii so neighbouring POIs
                            // merge into a shared glow faster,
                            // which is what "dense town" should
                            // feel like rather than 400 discrete
                            // dots.
                            'heatmap-radius': [
                                'interpolate', ['linear'], ['zoom'],
                                0,  10,
                                9,  26,
                                13, 38,
                                16, 56
                            ],
                            // Colour ramp pulled left: mid-density
                            // regions (0.2–0.4) now sit at 60–80%
                            // opacity instead of 25–50%, so a mid
                            // cluster reads as a real hotspot
                            // instead of a pastel wash.
                            'heatmap-color': [
                                'interpolate', ['linear'], ['heatmap-density'],
                                0,    rgbaString(rgb, 0),
                                0.05, rgbaString(rgb, 0.25),
                                0.15, rgbaString(rgb, 0.45),
                                0.3,  rgbaString(rgb, 0.65),
                                0.5,  rgbaString(rgb, 0.80),
                                0.75, rgbaString(rgb, 0.92),
                                1,    rgbaString(rgb, 1.00)
                            ],
                            'heatmap-opacity': 0.9
                        }
                    }, beforeId || undefined);
                    townPoiState.layerIds.push(layerId);
                } catch (e) {
                    console.warn('[town-poi] heat layer add failed for ' + cat.key, e);
                }
            }

            // Snapshot the area context for the legend's cart
            // affordances. We read data-area-id off the overpass
            // section (same source the preview/fetch wires use)
            // rather than plumbing it through the render path, so
            // the legend stays a pure visual concern and the cart
            // hook is a late binding.
            var areaCtx = null;
            try {
                var overpassEl = document.getElementById('townDetailOverpass');
                var titleEl    = document.getElementById('townDetailTitle');
                if (overpassEl) {
                    var aid = overpassEl.getAttribute('data-area-id');
                    if (aid) {
                        areaCtx = {
                            areaId: aid,
                            areaName: titleEl ? (titleEl.textContent || '').trim() : ''
                        };
                    }
                }
            } catch (e) { /* non-fatal — legend just renders without +/v */ }

            townPoiState.legend = buildTownPoiLegendControl(catList, areaCtx, {
                totalCount: totalCount,
                catCounts:  catCounts,
                subCounts:  subCounts,
                subMeta:    subMeta,
                subOrder:   subOrder
            });
            try {
                map.addControl(townPoiState.legend, 'top-left');
                requestAnimationFrame(function () {
                    if (townPoiState.legend && townPoiState.legend._el) {
                        townPoiState.legend._el.classList.add('is-visible');
                    }
                    // Reveal the floating Targets cart in the same
                    // frame so its fade-in is perceptually synced
                    // with the legend's. clearTownPoiHeatmaps above
                    // strips the class when the legend is torn down.
                    var cartEl = document.getElementById('gfeTargetCart');
                    if (cartEl) cartEl.classList.add('is-visible');
                });
            } catch (e) {
                console.warn('[town-poi] legend add failed', e);
            }
        }

        // Custom IControl: renders a legend panel with one row
        // per category that landed on the map. Each row is a
        // real <button> so it's keyboard-focusable; clicking
        // it toggles the matching heatmap layer's visibility
        // via setLayoutProperty and flips .is-off for the
        // dimmed styling.
        //
        // The root element intentionally starts with opacity 0
        // (see .town-poi-heatmap-key in ping-landing.css); the
        // caller flips .is-visible on the next frame to drive
        // the fade-in.
        function buildTownPoiLegendControl(cats, areaCtx, counts) {
            // All counts/metadata come from the render pass that built
            // the map features — no /pois/histogram roundtrip is needed
            // since we already have the full tag bag for every POI on
            // the page. See renderTownPoiHeatmaps() above for how this
            // is populated.
            var _counts = counts || {};
            var totalCount  = _counts.totalCount || 0;
            var catCounts   = _counts.catCounts  || {};
            var subCounts   = _counts.subCounts  || {};
            var subMeta     = _counts.subMeta    || {};
            var subOrder    = _counts.subOrder   || {};

            // Per-parent UI state:
            //   mainEnabled[catKey]            = user toggled the main row on/off
            //   disabledSubs[catKey]           = Set of subIds hidden within
            //                                    the parent (via sub-row clicks)
            //   mainCountEl[catKey]            = DOM handle for live count update
            //   subCountEl [catKey][subId]     = ditto for sub rows
            //
            // Kept in closure rather than on each row element so the
            // header-total recalc can walk state for every category in
            // one pass without DOM traversal.
            var mainEnabled  = {};
            var disabledSubs = {};
            var mainCountEl  = {};
            var subCountEl   = {};
            var headerCountEl = null;
            var headerRootEl  = null;

            cats.forEach(function (cat) {
                mainEnabled[cat.key] = true;
                disabledSubs[cat.key] = {};
                subCountEl[cat.key] = {};
            });

            // Friendly sub-category label. Falls back to the raw
            // tag_value (underscores → spaces) so a row is never blank.
            function subLabelFor(tagKey, tagValue) {
                if (!tagValue) return tagKey || 'other';
                return String(tagValue).replace(/_/g, ' ');
            }

            function fmt(n) {
                try { return Number(n || 0).toLocaleString(); }
                catch (e) { return String(n || 0); }
            }

            // ── Live count / header / filter recalc helpers ──
            //
            // visibleSubCountFor(catKey): total POIs currently shown
            //   for a parent — respects per-sub toggles. When the
            //   parent itself is off we still report the sub-level
            //   sum so the per-row number stays informative (the
            //   header total uses visibleCatCountFor below which
            //   DOES zero out when the parent is off).
            function visibleSubCountFor(catKey) {
                var subs = subCounts[catKey] || {};
                var disabled = disabledSubs[catKey] || {};
                var sum = 0;
                for (var id in subs) {
                    if (!Object.prototype.hasOwnProperty.call(subs, id)) continue;
                    if (disabled[id]) continue;
                    sum += subs[id];
                }
                return sum;
            }
            function visibleCatCountFor(catKey) {
                if (!mainEnabled[catKey]) return 0;
                return visibleSubCountFor(catKey);
            }
            function updateMainCount(catKey) {
                var el = mainCountEl[catKey];
                if (!el) return;
                el.textContent = fmt(visibleSubCountFor(catKey));
            }
            function updateHeaderTotal() {
                if (!headerCountEl) return;
                var sum = 0;
                for (var k in mainEnabled) {
                    if (!Object.prototype.hasOwnProperty.call(mainEnabled, k)) continue;
                    sum += visibleCatCountFor(k);
                }
                headerCountEl.textContent = fmt(sum);
            }

            // Build the MapLibre filter for a parent layer from the
            // current disabledSubs set + cached boundary clip. When
            // nothing's disabled the filter collapses back to the
            // simple category check (+ clip).
            function rebuildLayerFilter(mapInstance, cat) {
                var layerId = 'town-poi-heat-' + cat.key;
                try { if (!mapInstance.getLayer(layerId)) return; }
                catch (e) { return; }

                var parts = [['==', ['get', 'category'], cat.key]];
                if (townBoundaryCache && townBoundaryCache.geometry) {
                    parts.push(['within', townBoundaryCache]);
                }
                var disabled = disabledSubs[cat.key] || {};
                var disabledList = [];
                for (var id in disabled) {
                    if (disabled[id]) disabledList.push(id);
                }
                if (disabledList.length) {
                    parts.push(['!', ['in', ['get', 'sub_id'], ['literal', disabledList]]]);
                }
                var filter = parts.length === 1 ? parts[0] : ['all'].concat(parts);
                try { mapInstance.setFilter(layerId, filter); }
                catch (err) { console.warn('[town-poi] setFilter failed for ' + cat.key, err); }
            }

            return {
                _el: null,
                onAdd: function (mapInstance) {
                    var root = document.createElement('div');
                    root.className = 'maplibregl-ctrl town-poi-heatmap-key';
                    root.setAttribute('aria-label', 'Heatmap legend');
                    headerRootEl = root;

                    // Header reads "{N} Data Points" rather than the
                    // static "Heatmaps". The count is the live total
                    // of every visible POI across every parent row,
                    // respecting both main- and sub-level toggles.
                    var header = document.createElement('div');
                    header.className = 'town-poi-heatmap-key-head';
                    var headerIcon = document.createElement('i');
                    headerIcon.className = 'bi bi-thermometer-half';
                    headerIcon.setAttribute('aria-hidden', 'true');
                    var headerText = document.createElement('span');
                    headerText.className = 'town-poi-heatmap-key-head-text';
                    headerCountEl = document.createElement('strong');
                    headerCountEl.className = 'town-poi-heatmap-key-head-count';
                    headerCountEl.textContent = fmt(totalCount);
                    headerText.appendChild(headerCountEl);
                    headerText.appendChild(document.createTextNode(' Data Points'));
                    header.appendChild(headerIcon);
                    header.appendChild(headerText);
                    root.appendChild(header);

                    var list = document.createElement('div');
                    list.className = 'town-poi-heatmap-key-list';

                    for (var i = 0; i < cats.length; i++) {
                        (function buildOneCat(cat) {
                            var wrapper = document.createElement('div');
                            wrapper.className = 'town-poi-heatmap-key-wrapper';
                            wrapper.setAttribute('data-cat-key', cat.key);

                            var row = document.createElement('button');
                            row.type = 'button';
                            row.className = 'town-poi-heatmap-key-row';
                            row.setAttribute('data-layer-id', 'town-poi-heat-' + cat.key);
                            row.setAttribute('aria-pressed', 'true');
                            row.setAttribute('aria-label', 'Toggle ' + cat.label + ' heatmap');

                            var swatch = document.createElement('span');
                            swatch.className = 'town-poi-heatmap-key-swatch';
                            swatch.style.setProperty('--swatch-color', cat.color);
                            var swatchIcon = document.createElement('i');
                            swatchIcon.className = 'bi ' + cat.icon;
                            swatchIcon.setAttribute('aria-hidden', 'true');
                            swatch.appendChild(swatchIcon);
                            row.appendChild(swatch);

                            var label = document.createElement('span');
                            label.className = 'town-poi-heatmap-key-label';
                            label.textContent = cat.label;
                            row.appendChild(label);

                            // Live count for this parent — sum of all
                            // enabled sub-categories within it. Updated
                            // by updateMainCount() whenever a sub-row
                            // is toggled below.
                            var countBadge = document.createElement('span');
                            countBadge.className = 'town-poi-heatmap-key-count';
                            countBadge.textContent = fmt(catCounts[cat.key] || 0);
                            row.appendChild(countBadge);
                            mainCountEl[cat.key] = countBadge;

                            // Cart affordances live in a dedicated
                            // container on the right so they tab
                            // after the row label. Both buttons use
                            // stopPropagation() to keep the outer
                            // row's heatmap toggle untouched.
                            if (areaCtx && window.gfeCart && typeof window.gfeCart.addParent === 'function') {
                                var actions = document.createElement('span');
                                actions.className = 'town-poi-heatmap-key-actions';

                                var ownedWrap = document.createElement('span');
                                ownedWrap.setAttribute('data-owned-slot', 'parent');

                                var addBtn = document.createElement('button');
                                addBtn.type = 'button';
                                addBtn.className = 'town-poi-heatmap-key-btn town-poi-heatmap-key-add';
                                addBtn.setAttribute('aria-label', 'Add ' + cat.label + ' to targeting cart');
                                addBtn.innerHTML = '<i class="bi bi-plus-lg" aria-hidden="true"></i>';
                                addBtn.addEventListener('click', function (e) {
                                    e.stopPropagation();
                                    addBtn.classList.add('is-pending');
                                    window.gfeCart.addParent({
                                        areaId:   areaCtx.areaId,
                                        areaName: areaCtx.areaName,
                                        category: cat.key,
                                        categoryLabel: cat.label,
                                        color:    cat.color,
                                        icon:     cat.icon
                                    }).then(function () {
                                        addBtn.classList.remove('is-pending');
                                    }, function () {
                                        addBtn.classList.remove('is-pending');
                                    });
                                });

                                var expandBtn = document.createElement('button');
                                expandBtn.type = 'button';
                                expandBtn.className = 'town-poi-heatmap-key-btn town-poi-heatmap-key-expand';
                                expandBtn.setAttribute('aria-label', 'Show sub-categories for ' + cat.label);
                                expandBtn.setAttribute('aria-expanded', 'false');
                                expandBtn.innerHTML = '<i class="bi bi-chevron-down" aria-hidden="true"></i>';

                                var subContainer = null;
                                expandBtn.addEventListener('click', function (e) {
                                    e.stopPropagation();
                                    var isOpen = expandBtn.classList.toggle('is-expanded');
                                    expandBtn.setAttribute('aria-expanded', String(isOpen));
                                    if (!isOpen) {
                                        if (subContainer) subContainer.remove();
                                        subContainer = null;
                                        return;
                                    }
                                    subContainer = document.createElement('div');
                                    subContainer.className = 'town-poi-heatmap-key-sub';
                                    wrapper.appendChild(subContainer);
                                    renderSubRowsLocal(subContainer, cat, mapInstance);
                                });

                                actions.appendChild(ownedWrap);
                                actions.appendChild(addBtn);
                                actions.appendChild(expandBtn);
                                row.appendChild(actions);

                                var applyOwnership = function () {
                                    var owned = isParentOwned(areaCtx.areaId, cat.key);
                                    if (owned) {
                                        ownedWrap.innerHTML = '<span class="town-poi-heatmap-key-owned"><i class="bi bi-check2" aria-hidden="true"></i>Owned</span>';
                                        addBtn.style.display = 'none';
                                    } else {
                                        ownedWrap.innerHTML = '';
                                        addBtn.style.display = '';
                                    }
                                };
                                applyOwnership();
                                document.addEventListener('gfe:targets-changed', applyOwnership);
                            }

                            row.addEventListener('click', function (e) {
                                var btn = e.currentTarget;
                                var layerId = btn.getAttribute('data-layer-id');
                                if (!layerId) return;
                                try {
                                    if (!mapInstance.getLayer(layerId)) return;
                                } catch(err) { return; }
                                var isOff = btn.classList.toggle('is-off');
                                btn.setAttribute('aria-pressed', String(!isOff));
                                mainEnabled[cat.key] = !isOff;
                                try {
                                    mapInstance.setLayoutProperty(
                                        layerId,
                                        'visibility',
                                        isOff ? 'none' : 'visible'
                                    );
                                } catch (err) {
                                    console.warn('[town-poi] visibility toggle failed', err);
                                }
                                updateHeaderTotal();
                            });

                            wrapper.appendChild(row);
                            list.appendChild(wrapper);
                        })(cats[i]);
                    }

                    root.appendChild(list);
                    this._el = root;
                    updateHeaderTotal();
                    return root;
                },
                onRemove: function () {
                    if (this._el && this._el.parentNode) {
                        this._el.parentNode.removeChild(this._el);
                    }
                    this._el = null;
                    headerCountEl = null;
                    headerRootEl  = null;
                }
            };

            // ── Helpers closed over the legend instance ───────────

            // Sub-rows are driven entirely from the local counts/meta
            // captured during feature building. Each row is a button
            // so clicking anywhere on the row body toggles that sub-
            // category's visibility within the parent heatmap. The
            // existing + (cart) button stops propagation so it keeps
            // its single responsibility.
            function renderSubRowsLocal(container, cat, mapInstance) {
                container.innerHTML = '';
                var ids = subOrder[cat.key] || [];
                if (!ids.length) {
                    var empty = document.createElement('div');
                    empty.className = 'town-poi-heatmap-key-sub-empty';
                    empty.textContent = 'No sub-categories for this town.';
                    container.appendChild(empty);
                    return;
                }

                // Sort: highest count first, but keep the insertion
                // order stable for ties so re-expanding the row shows
                // the same list.
                var sorted = ids.slice().sort(function (a, b) {
                    var ca = subCounts[cat.key][a] || 0;
                    var cb = subCounts[cat.key][b] || 0;
                    if (cb !== ca) return cb - ca;
                    return ids.indexOf(a) - ids.indexOf(b);
                });

                sorted.forEach(function (subId) {
                    var meta = (subMeta[cat.key] && subMeta[cat.key][subId]) || {};
                    var labelText = subLabelFor(meta.tag_key, meta.tag_value);

                    // Sub-row is a <div role="button"> rather than a
                    // real <button> so the nested cart <button> stays
                    // valid HTML. Keyboard behaviour is restored via
                    // tabindex + a keydown handler below.
                    var row = document.createElement('div');
                    row.className = 'town-poi-heatmap-key-sub-row';
                    row.setAttribute('role', 'button');
                    row.setAttribute('tabindex', '0');
                    row.setAttribute('data-sub-id', subId);
                    row.setAttribute('aria-pressed', 'true');
                    row.setAttribute('aria-label', 'Toggle ' + labelText + ' in ' + cat.label + ' heatmap');

                    var dot = document.createElement('span');
                    dot.className = 'town-poi-heatmap-key-sub-dot';
                    dot.style.setProperty('--swatch-color', cat.color);
                    row.appendChild(dot);

                    var lbl = document.createElement('span');
                    lbl.className = 'town-poi-heatmap-key-sub-label';
                    lbl.textContent = labelText;
                    row.appendChild(lbl);

                    var cnt = document.createElement('span');
                    cnt.className = 'town-poi-heatmap-key-sub-count';
                    cnt.textContent = fmt(subCounts[cat.key][subId] || 0);
                    row.appendChild(cnt);
                    subCountEl[cat.key][subId] = cnt;

                    // Cart affordances stay intact — nested real
                    // <button> elements for the owned badge + add
                    // action. stopPropagation on each click keeps
                    // the outer row's toggle quiet.
                    var ownedSlot = document.createElement('span');
                    ownedSlot.setAttribute('data-owned-slot', 'sub');
                    row.appendChild(ownedSlot);

                    if (areaCtx && window.gfeCart && typeof window.gfeCart.addSub === 'function') {
                        var addBtn = document.createElement('button');
                        addBtn.type = 'button';
                        addBtn.className = 'town-poi-heatmap-key-btn town-poi-heatmap-key-sub-add';
                        addBtn.setAttribute('aria-label', 'Add ' + labelText + ' to targeting cart');
                        addBtn.innerHTML = '<i class="bi bi-plus-lg" aria-hidden="true"></i>';
                        addBtn.addEventListener('click', function (e) {
                            e.stopPropagation();
                            if (!window.gfeCart) return;
                            addBtn.classList.add('is-pending');
                            window.gfeCart.addSub({
                                areaId:        areaCtx.areaId,
                                areaName:      areaCtx.areaName,
                                category:      cat.key,
                                categoryLabel: cat.label,
                                color:         cat.color,
                                icon:          cat.icon,
                                tag_key:       meta.tag_key,
                                tag_value:     meta.tag_value,
                                subLabel:      labelText
                            }).then(function () { addBtn.classList.remove('is-pending'); },
                                   function () { addBtn.classList.remove('is-pending'); });
                        });
                        row.appendChild(addBtn);

                        var applyOwnership = function () {
                            var owned = isSubOwned(areaCtx.areaId, cat.key, meta.tag_key, meta.tag_value);
                            if (owned) {
                                ownedSlot.innerHTML = '<span class="town-poi-heatmap-key-owned"><i class="bi bi-check2" aria-hidden="true"></i>Owned</span>';
                                addBtn.style.display = 'none';
                            } else {
                                ownedSlot.innerHTML = '';
                                addBtn.style.display = '';
                            }
                        };
                        applyOwnership();
                        document.addEventListener('gfe:targets-changed', applyOwnership);
                    }

                    function toggleSub() {
                        var wasDisabled = !!disabledSubs[cat.key][subId];
                        if (wasDisabled) {
                            delete disabledSubs[cat.key][subId];
                            row.classList.remove('is-off');
                            row.setAttribute('aria-pressed', 'true');
                        } else {
                            disabledSubs[cat.key][subId] = true;
                            row.classList.add('is-off');
                            row.setAttribute('aria-pressed', 'false');
                        }
                        rebuildLayerFilter(mapInstance, cat);
                        updateMainCount(cat.key);
                        updateHeaderTotal();
                    }

                    row.addEventListener('click', function (e) {
                        // Clicks on the nested cart button are caught
                        // by its own stopPropagation, but belt-and-braces
                        // the check here so a keyboard Enter bubbling
                        // up from the button doesn't also toggle the row.
                        if (e.target && e.target.closest('.town-poi-heatmap-key-btn')) return;
                        toggleSub();
                    });
                    row.addEventListener('keydown', function (e) {
                        if (e.key === ' ' || e.key === 'Enter') {
                            e.preventDefault();
                            toggleSub();
                        }
                    });

                    // Restore UI state if the user toggled this sub
                    // off before collapsing and re-opening the row.
                    if (disabledSubs[cat.key][subId]) {
                        row.classList.add('is-off');
                        row.setAttribute('aria-pressed', 'false');
                    }

                    container.appendChild(row);
                });
            }
        }

        // Ownership helpers — read from the canonical
        // window.gfeOwnedTargets cache. Both legend badges and the
        // cart's dedupe pass call through here so the definition of
        // "owned" lives in one place.
        function isParentOwned(areaId, category) {
            var list = (window.gfeOwnedTargets || []);
            var aid = String(areaId);
            for (var i = 0; i < list.length; i++) {
                var t = list[i];
                if (t && String(t.area_id) === aid &&
                    t.tier === 'category' && t.category === category) {
                    return true;
                }
            }
            return false;
        }
        function isSubOwned(areaId, category, tagKey, tagValue) {
            var list = (window.gfeOwnedTargets || []);
            var aid = String(areaId);
            for (var i = 0; i < list.length; i++) {
                var t = list[i];
                if (t && String(t.area_id) === aid &&
                    t.tier === 'subcategory' &&
                    t.category === category &&
                    t.tag_key === tagKey &&
                    t.tag_value === tagValue) {
                    return true;
                }
            }
            return false;
        }

        function csrfToken() {
            var m = document.querySelector('meta[name="csrf-token"]');
            return m ? m.getAttribute('content') : '';
        }

        (function wireTownHeatmapsButton() {
            var rootEl = document.getElementById('townDetailOverpass');
            if (!rootEl) return;

            var btn     = rootEl.querySelector('#townDetailHeatmapsBtn');
            var countEl = rootEl.querySelector('#townDetailPreviewCount');
            var titleEl = rootEl.querySelector('.town-detail-heatmaps-title');
            var errEl   = rootEl.querySelector('#townDetailHeatmapsError');
            if (!btn) return;

            // Read the catalog at click time (not wire time) so a
            // hot-reloaded blade doesn't leave us with a stale list
            // baked into closure scope. Scan target is always
            // "every category the catalog knows about" — there is
            // no per-category chip selector.
            function allCategoryKeys() {
                var raw = Array.isArray(window.TOWN_POI_CATEGORIES)
                    ? window.TOWN_POI_CATEGORIES
                    : [];
                var keys = [];
                for (var i = 0; i < raw.length; i++) {
                    var c = raw[i];
                    if (c && typeof c.key === 'string' && c.key !== '') {
                        keys.push(c.key);
                    }
                }
                return keys;
            }

            function csrfToken() {
                var m = document.querySelector('meta[name="csrf-token"]');
                return m ? m.getAttribute('content') : '';
            }

            function setState(state) {
                // is-priming  → initial auto-preview in flight
                // is-ready    → count populated, button enabled
                // is-loading  → user clicked, fetch in flight
                // is-error    → surface an inline error on the button
                btn.classList.remove('is-priming', 'is-ready', 'is-loading', 'is-error');
                btn.classList.add(state);
                btn.disabled = (state === 'is-priming' || state === 'is-loading');
                if (titleEl) {
                    var labelKey = (state === 'is-loading') ? 'data-label-loading' : 'data-label-idle';
                    var fallback = (state === 'is-loading') ? 'Loading heatmaps…' : 'View Heatmaps';
                    titleEl.textContent = btn.getAttribute(labelKey) || fallback;
                }
            }

            function showError(text) {
                setState('is-error');
                if (errEl) {
                    errEl.textContent = text;
                    errEl.hidden = false;
                }
            }

            function clearError() {
                if (errEl) {
                    errEl.textContent = '';
                    errEl.hidden = true;
                }
            }

            // Humanise the controller's error codes into copy the
            // user can actually act on. Anything unexpected falls
            // through to a generic message.
            function errorCopy(payload, status) {
                var code = (payload && payload.error) ? payload.error : '';
                if (status === 401) return 'Please sign in again.';
                if (status === 403 || code === 'not_owner') return 'You do not own this town.';
                if (status === 404 || code === 'area_not_found') return 'This town has no geography on file.';
                if (code === 'no_boundary') return 'This town has no boundary to scan.';
                if (code === 'no_valid_categories') return 'Categories not configured. Please refresh the page.';
                if (code === 'overpass_unavailable') return 'Overpass is offline — try again in a moment.';
                if (code === 'overpass_error') return 'Overpass returned an error. Try again shortly.';
                return 'Could not load POI data.';
            }

            // Public helper the modal-open path calls after stamping
            // the fresh data-area-id. Fires the preview count and
            // flips the button into 'ready' once we've got a number
            // to display. Kicking it off this way (rather than
            // synthesising a click on the button itself) means the
            // button's own click handler stays scoped to "user
            // wants to see heatmaps".
            function runPreview() {
                var cats = allCategoryKeys();
                if (cats.length === 0) {
                    showError('Categories not configured. Please refresh the page.');
                    return;
                }
                var areaId = rootEl.getAttribute('data-area-id');
                var base   = btn.getAttribute('data-url') || '';
                if (!areaId || !base) {
                    showError('Missing town context — reopen the card and try again.');
                    return;
                }

                clearError();
                setState('is-priming');
                if (countEl) countEl.textContent = '—';

                var url = base.replace(/\/+$/, '') + '/' + encodeURIComponent(areaId) + '/pois/preview';
                fetch(url, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': csrfToken(),
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({ categories: cats })
                })
                .then(function (resp) {
                    return resp.json().then(function (json) {
                        return { status: resp.status, ok: resp.ok, json: json };
                    }).catch(function () {
                        return { status: resp.status, ok: resp.ok, json: {} };
                    });
                })
                .then(function (r) {
                    if (!r.ok) {
                        showError(errorCopy(r.json, r.status));
                        return;
                    }
                    var n = (r.json && typeof r.json.count === 'number') ? r.json.count : 0;
                    if (countEl) countEl.textContent = n.toLocaleString();
                    setState('is-ready');
                })
                .catch(function () {
                    showError('Network error — check your connection.');
                });
            }

            // Exposed globally because showTownDetailModal (which
            // lives above this IIFE but runs in the same closure)
            // kicks the preview via window.triggerTownHeatmapsPreview
            // after stamping data-area-id — the public hook keeps
            // the wiring explicit instead of hunting for a button
            // to .click() by ID.
            window.triggerTownHeatmapsPreview = runPreview;

            // ── Click = fetch + render heatmaps ──
            //
            // Flow:
            //   1. Flip button into is-loading so a double-click
            //      can't double-fire the network call.
            //   2. POST /pois/fetch for all categories.
            //   3. Paint heatmaps BEFORE bouncing the modal so the
            //      reveal feels like the card "lifting to show
            //      what was underneath" rather than a separate
            //      async shoe dropping.
            //   4. Modal bounces up (bounceTownModalUpOnly — NO
            //      globe restore, NO intro reopen), legend fades
            //      in on the next frame.
            btn.addEventListener('click', function () {
                if (btn.disabled) return;
                if (btn.classList.contains('is-error')) {
                    // Treat a click on an errored button as "retry
                    // the preview" — the user's recovery path for
                    // a transient Overpass blip.
                    runPreview();
                    return;
                }

                var cats = allCategoryKeys();
                if (cats.length === 0) {
                    showError('Categories not configured. Please refresh the page.');
                    return;
                }
                var areaId = rootEl.getAttribute('data-area-id');
                var base   = btn.getAttribute('data-url') || '';
                if (!areaId || !base) {
                    showError('Missing town context — reopen the card and try again.');
                    return;
                }

                clearError();
                setState('is-loading');

                var url = base.replace(/\/+$/, '') + '/' + encodeURIComponent(areaId) + '/pois/fetch';
                fetch(url, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': csrfToken(),
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({ categories: cats })
                })
                .then(function (resp) {
                    return resp.json().then(function (json) {
                        return { status: resp.status, ok: resp.ok, json: json };
                    }).catch(function () {
                        return { status: resp.status, ok: resp.ok, json: {} };
                    });
                })
                .then(function (r) {
                    if (!r.ok) {
                        showError(errorCopy(r.json, r.status));
                        return;
                    }
                    var pois = (r.json && Array.isArray(r.json.pois)) ? r.json.pois : [];
                    try { renderTownPoiHeatmaps(pois); }
                    catch (err) { console.warn('[town-poi] heatmap pass failed', err); }

                    bounceTownModalUpOnly();

                    // Leave the button in a sensible re-entry state
                    // for when the user reopens the card later.
                    setState('is-ready');
                })
                .catch(function () {
                    showError('Network error — check your connection.');
                });
            });
        })();

        // Close wiring for the town detail modal. Phase structure
        // matches wireGfeDetailClose:
        //   1. card flies up off-screen (gfeDetailFlyOut)
        //   2. 500ms dwell, boundary overlay tears down, camera
        //      eases back to the resting globe framing
        //   3. intro modal reopens; #gfeTownsTabbedMount scrolls into view
        (function wireTownDetailClose() {
            var modalEl = document.getElementById('townDetailModal');
            if (!modalEl) return;

            function restoreIntroAfterTownDetail() {
                try { showIntro(); } catch(e) {}
                var townsTabbed = document.getElementById('gfeTownsTabbedMount');
                if (townsTabbed && typeof townsTabbed.scrollIntoView === 'function') {
                    try {
                        townsTabbed.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                    } catch(e2) {
                        townsTabbed.scrollIntoView(true);
                    }
                }
            }

            var DETAIL_FLYOUT_MS      = 450;
            var DETAIL_TO_GLOBE_DWELL = 500;
            var GLOBE_EASE_MS         = 900;

            function hide() {
                if (!modalEl.classList.contains('visible')) return;
                modalEl.classList.add('is-flying-out');
                setTimeout(function () {
                    modalEl.classList.remove('visible');
                    modalEl.classList.remove('is-flying-out');
                    resetTownMapOverlays();
                    try { restoreGlobeFraming(GLOBE_EASE_MS); } catch(e) {}
                }, DETAIL_FLYOUT_MS + DETAIL_TO_GLOBE_DWELL);
                setTimeout(function () {
                    restoreIntroAfterTownDetail();
                }, DETAIL_FLYOUT_MS + DETAIL_TO_GLOBE_DWELL + GLOBE_EASE_MS);
            }

            var closeBtn = document.getElementById('townDetailClose');
            if (closeBtn) closeBtn.addEventListener('click', hide);
            modalEl.addEventListener('click', function(e) {
                if (e.target === modalEl) hide();
            });
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape' && modalEl.classList.contains('visible')) hide();
            });
            // The in-body CTA is a plain anchor to /aura — no click
            // interception here, let the user navigate.
        })();

        window.pingLandingReturnToTerritoriesFromView = function () {
            try { hidePingHeroLocationImageOnly(); } catch (e) {}
            try { resetTownMapOverlays(); } catch (e) {}
            try { restoreGlobeFraming(900); } catch (e) {}
            // Keep is-jutdee-territory-view-active until the territories
            // overlay is back — that flag blocks satellite fade-out while
            // the overlay is briefly not-yet-revealed during reopen.
            if (typeof window.pingLandingReturnToTerritoriesModal === 'function') {
                window.pingLandingReturnToTerritoriesModal();
            }
            document.body.classList.remove('is-jutdee-territory-view-active');
            if (typeof window.syncJutdeeModalSatelliteBackdrop === 'function') {
                window.syncJutdeeModalSatelliteBackdrop();
            }
        };

        window.pingLandingReturnToTerritoriesFromGameLoss = function () {
            if (typeof window.pingLandingReturnToTerritoriesModal === 'function') {
                window.pingLandingReturnToTerritoriesModal();
            }
        };

        window.pingLandingFocusOnTown = function(data) {
            if (!data) return;
            townFocusSeq += 1;
            var focusSeq = townFocusSeq;
            var lat = parseFloat(data.area_lat);
            var lng = parseFloat(data.area_lng);
            var feature = null;
            var bounds = null;
            try {
                feature = townBoundaryFeature(data.boundary || null);
                bounds = townBoundaryBounds(feature);
            } catch (boundaryErr) {
                console.warn('[town-focus] boundary normalize failed', boundaryErr);
            }
            // Derive a centre from the bounding box when the payload
            // has no stored lat/lng (legacy rows whose centroid
            // fallback didn't resolve on the server).
            if ((!isFinite(lat) || !isFinite(lng)) && bounds) {
                lat = (bounds[0][1] + bounds[1][1]) / 2;
                lng = (bounds[0][0] + bounds[1][0]) / 2;
            }
            if (!isFinite(lat) || !isFinite(lng)) {
                console.warn('[town-focus] missing/invalid lat,lng + boundary on payload', data);
                return;
            }

            var jutdeeTerritoryView = document.body.classList.contains('is-jutdee-tenant');
            if (jutdeeTerritoryView) {
                document.body.classList.add('is-jutdee-territory-view-active');
            }
            try { hideIntro(true); } catch(e) {}
            if (document.body.classList.contains('is-jutdee-tenant')
                && typeof window.hideSpinIntroCarouselBanner === 'function') {
                try { window.hideSpinIntroCarouselBanner(); } catch (e) {}
            }
            if (jutdeeTerritoryView) {
                bindPingHeroFlyinData(data, { skipHeroImage: true });
                hidePingHeroLocationImageOnly();
            } else {
                bindPingHeroFlyinData(data);
                if (!pickLocationHeroUrl(data) && bgImage) bgImage.classList.add('is-faded');
            }
            autoSpin.active = false;
            if (fastSpinRaf) { try { cancelAnimationFrame(fastSpinRaf); } catch(e) {} fastSpinRaf = null; }

            try { if (map.dragPan)         map.dragPan.enable(); } catch(e) {}
            try { if (map.scrollZoom)      map.scrollZoom.enable(); } catch(e) {}
            try { if (map.touchZoomRotate) map.touchZoomRotate.enable(); } catch(e) {}
            try { if (map.doubleClickZoom) map.doubleClickZoom.enable(); } catch(e) {}
            try { if (map.keyboard)        map.keyboard.enable(); } catch(e) {}

            function flyAndPaint() {
                var flyinTitle = document.body.classList.contains('is-jutdee-tenant')
                    ? ''
                    : (data.name || data.title || '');
                revealFlyinTitleAfterMove(flyinTitle, {
                    flyMs: 3500,
                    fallbackMs: 4600,
                    afterReveal: function () {
                        setTimeout(function () {
                            try {
                                var spinModalEl = document.getElementById('spinModal');
                                var spinBusy = !!(window.__spinActive
                                    || (spinModalEl && spinModalEl.classList.contains('visible')));
                                if (document.body.classList.contains('is-jutdee-tenant')
                                    && !spinBusy
                                    && typeof window.showJutdeeTerritoryViewModal === 'function') {
                                    if (typeof window.hideJutdeeTerritoriesTableOverlay === 'function') {
                                        window.hideJutdeeTerritoriesTableOverlay();
                                    }
                                    clearSpinFlyinLocationTitle();
                                    window.showJutdeeTerritoryViewModal(data);
                                } else {
                                    showTownDetailModal(data);
                                }
                            }
                            catch (err) { console.warn('[town-focus] detail modal failed to open', err); }
                        }, 500);
                    }
                });

                resetTownMapOverlays();
                if (feature) {
                    drawTownBoundary(feature);
                } else {
                    var areaId = data.eyeland_area_id || '';
                    fetchTownBoundaryRing(areaId, focusSeq, function (ring) {
                        if (typeof window.pingLandingPaintTownBoundaryLate === 'function') {
                            try { window.pingLandingPaintTownBoundaryLate(ring); } catch (e) {}
                        }
                    });
                }

                map.once('styledata', function onTownFocusStyleData() {
                    if (focusSeq !== townFocusSeq || !townBoundaryCache) return;
                    try { drawTownBoundary(townBoundaryCache); } catch (e) {}
                });

                try {
                    if (bounds) {
                        // Frame the town's full polygon on screen with
                        // a modest pitch so the outline reads as a
                        // territory on the ground rather than a flat
                        // cut-out. padding:60 keeps the magenta stroke
                        // clear of the viewport edge; maxZoom:14 stops
                        // tiny hamlets from punching all the way to
                        // building-level detail.
                        map.fitBounds(bounds, {
                            padding: 60,
                            pitch: 45,
                            bearing: 0,
                            duration: 3500,
                            maxZoom: 14,
                            essential: true,
                            linear: false
                        });
                    } else {
                        // No usable boundary — fly to the centroid at
                        // a town-scale zoom so the user still gets a
                        // recognisable "here's your place" framing.
                        map.flyTo({
                            center: [lng, lat],
                            zoom: 13.5,
                            pitch: 45,
                            bearing: 0,
                            duration: 3500,
                            essential: true,
                            curve: 1.4
                        });
                    }
                    if (isJutdeeSpinFlyIn()) {
                        map.once('moveend', function onTerritoryViewSatelliteFade() {
                            var fadeMs = 900;
                            fadeJutdeeSpinSatelliteIn(fadeMs);
                            removeJutdeeCountryBackdrop(fadeMs);
                            setTimeout(function () {
                                if (focusSeq !== townFocusSeq || !townBoundaryCache) return;
                                try { drawTownBoundary(townBoundaryCache); } catch (e) {}
                            }, fadeMs + 80);
                        });
                    }
                } catch(e) { console.warn('[town-focus] fitBounds/flyTo failed', e); }
            }

            if (map.isStyleLoaded && map.isStyleLoaded()) {
                flyAndPaint();
            } else {
                var fired = false;
                var onReady = function() {
                    if (fired) return;
                    if (map.isStyleLoaded && !map.isStyleLoaded()) return;
                    fired = true;
                    map.off('styledata', onReady);
                    map.off('idle', onReady);
                    flyAndPaint();
                };
                map.on('styledata', onReady);
                map.on('idle', onReady);
                setTimeout(onReady, 2000);
            }
        };

        // ── Tour detail modal ───────────────────────────────────────────
        if (!pingToursSectionEnabled()) {
            window.pingLandingFocusOnTour = function () {};
            window.gfeRefreshUserToursList = function () {};
        } else {
        // Third sibling of the GamifEYE and Town focus paths. Called
        // from the delegated .gfe-tour-item click handler in
        // ping-landing.blade.php when the user taps one of their
        // tour cards in the intro modal's Tours tab.
        //
        // Visual contract mirrors the location/town paths:
        //   1. Intro card flies UP (hideIntro → spinFlyOut).
        //   2. Main map fitBounds()'s across every stop with a modest
        //      pitch, draws a magenta route polyline between the stops
        //      in order, and drops numbered markers on each stop —
        //      same visual language as the create-tour preview so the
        //      owner sees the route they authored at full scale.
        //   3. After moveend + 500ms dwell #tourDetailModal bounces in
        //      from the top (gfeDetailBounceIn).
        //
        // Close handler is the inverse and restores the intro modal
        // with the Tours tab re-selected so the user lands back where
        // they launched from.
        //
        // All map overlays this path adds live on tourFocusState so
        // the close handler can tear them down cleanly without having
        // to poke at MapLibre's private source data.
        var tourFocusState = {
            sourceId: 'tour-route-focus',
            lineId:   'tour-route-focus-line',
            markers:  [],
            // SortableJS instance bound to #tourDetailStopsList.
            // Destroyed and re-created each time the modal opens
            // so the handler closures capture the correct tour's
            // currentStops array.
            sortable:               null,
            // Snapshot of stop ids in their original render order.
            // Used both to compute isDirty on every drop and to
            // restore the original order when the user discards.
            initialStopIds:         [],
            // Live, mutable stops array — reordered in place as the
            // user drags. Always the source of truth for the map
            // polyline and marker numbering.
            currentStops:           [],
            // Identifying / display fields captured at open time so
            // the save handler and close guard can reach them
            // without re-parsing the originating <li>.
            currentTourId:          null,
            currentTourSlug:        null,
            currentTourTitle:       null,
            currentTourDescription: null,
            currentTourDistanceM:   0,
            currentTourCoverUrl:    null,
            currentTourStopCount:   0,
            isPublic:               false,
            isDirty:                false,
            // Guards against submitting the same reorder twice if
            // the user double-clicks the Save button.
            saveInFlight:           false
        };
        var tourFocusInFlight = false;

        function resetTourMapOverlays() {
            try { if (map.getLayer(tourFocusState.lineId)) map.removeLayer(tourFocusState.lineId); } catch(e) {}
            try { if (map.getSource(tourFocusState.sourceId)) map.removeSource(tourFocusState.sourceId); } catch(e) {}
            if (tourFocusState.markers && tourFocusState.markers.length) {
                for (var i = 0; i < tourFocusState.markers.length; i++) {
                    try { tourFocusState.markers[i].remove(); } catch(e) {}
                }
            }
            tourFocusState.markers = [];
            // Tear down the Sortable bound to the (now-dead) modal
            // list so we don't leak handlers between openings.
            if (tourFocusState.sortable) {
                try { tourFocusState.sortable.destroy(); } catch(e) {}
                tourFocusState.sortable = null;
            }
        }

        // Rebuild the tour's route polyline from the current stops
        // without recreating markers. Used by the Sortable onEnd
        // hook so the magenta line follows the new order as soon
        // as the user drops a row.
        function updateTourRouteLine() {
            var src = null;
            try { src = map.getSource(tourFocusState.sourceId); } catch(e) {}
            if (!src || !tourFocusState.currentStops.length) return;
            try {
                src.setData({
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'LineString',
                        coordinates: tourFocusState.currentStops.map(function (s) {
                            return [s.lng, s.lat];
                        })
                    }
                });
            } catch(e) { console.warn('[tour-focus] route line update failed', e); }
        }

        // Reassign marker numbers in place so a reorder swaps the
        // badges without remounting MapLibre Markers (which would
        // flicker and lose transitions). Walks tourFocusState.markers
        // in the same index order as currentStops so they stay
        // aligned after paintTourRouteAndMarkers() runs.
        function renumberTourMarkers() {
            var markers = tourFocusState.markers || [];
            // The markers array was populated in currentStops order
            // at paint time. After a reorder currentStops is in the
            // NEW order, so pair them by stop id to find each
            // marker's new number.
            var byId = {};
            var stops = tourFocusState.currentStops;
            // Markers were pushed in the original render order, so
            // markers[i] is the marker for the stop that was at
            // position i at paint time. We remember the stop id on
            // the marker element so we can re-pair after a drag.
            for (var i = 0; i < markers.length; i++) {
                var el = null;
                try { el = markers[i].getElement(); } catch(e) {}
                if (!el) continue;
                var sid = el.getAttribute('data-tour-stop-id');
                if (sid) byId[sid] = markers[i];
            }
            stops.forEach(function (s, idx) {
                var marker = byId[String(s.id)];
                if (!marker) return;
                var el = marker.getElement();
                var badge = el.querySelector('.tour-page-map-marker-num');
                if (badge) badge.textContent = String(idx + 1);
            });
        }

        function paintTourRouteAndMarkers(stops) {
            // Clear any previous route before painting the new one so
            // rapid re-focus (tour A → close → tour B) doesn't leave
            // stale stops on the map.
            resetTourMapOverlays();
            if (!stops || stops.length < 2) return;

            try {
                map.addSource(tourFocusState.sourceId, {
                    type: 'geojson',
                    data: {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'LineString',
                            coordinates: stops.map(function (s) { return [s.lng, s.lat]; })
                        }
                    }
                });
                map.addLayer({
                    id: tourFocusState.lineId,
                    type: 'line',
                    source: tourFocusState.sourceId,
                    paint: { 'line-color': '#ec4899', 'line-width': 4, 'line-opacity': 0.9 },
                    layout: { 'line-cap': 'round', 'line-join': 'round' }
                });
            } catch (e) { console.warn('[tour-focus] route line failed', e); }

            stops.forEach(function (s, i) {
                try {
                    var outer = document.createElement('div');
                    outer.className = 'tour-page-map-marker';
                    // Tag the outer element with the stop id so
                    // renumberTourMarkers() can re-pair each marker
                    // to its row after a drag reorder without
                    // rebuilding the marker DOM.
                    if (s && s.id != null) {
                        outer.setAttribute('data-tour-stop-id', String(s.id));
                    }
                    var inner = document.createElement('div');
                    inner.className = 'tour-page-map-marker-inner';
                    if (s.logo_url) {
                        inner.style.backgroundImage = 'url("' + String(s.logo_url).replace(/"/g, '\\"') + '")';
                    } else {
                        inner.classList.add('no-image');
                    }
                    var badge = document.createElement('span');
                    badge.className = 'tour-page-map-marker-num';
                    badge.textContent = String(i + 1);
                    inner.appendChild(badge);
                    outer.appendChild(inner);
                    var m = new maplibregl.Marker({ element: outer, anchor: 'center' })
                        .setLngLat([s.lng, s.lat])
                        .addTo(map);
                    tourFocusState.markers.push(m);
                } catch (e) { console.warn('[tour-focus] marker add failed', e); }
            });
        }

        function normalizeTourStop(s) {
            if (!s) return null;
            var lat = s.lat != null ? parseFloat(s.lat) : (s.latitude != null ? parseFloat(s.latitude) : null);
            var lng = s.lng != null ? parseFloat(s.lng) : (s.longitude != null ? parseFloat(s.longitude) : null);
            return {
                id:            s.id != null ? parseInt(s.id, 10) : null,
                position:      s.position,
                home_point_id: s.home_point_id != null ? parseInt(s.home_point_id, 10)
                    : (s.user_home_point_id != null ? parseInt(s.user_home_point_id, 10) : null),
                title:         s.title || '',
                logo_url:      s.logo_url || null,
                lat:           isFinite(lat) ? lat : null,
                lng:           isFinite(lng) ? lng : null
            };
        }

        function normalizeTourPayload(data) {
            if (!data) return data;
            var stops = Array.isArray(data.stops)
                ? data.stops.map(normalizeTourStop).filter(Boolean)
                : [];
            data.stops = stops;
            var sc = parseInt(data.stop_count, 10);
            if (!isFinite(sc) || sc < stops.length) {
                data.stop_count = stops.length;
            }
            return data;
        }

        function mergeTourPayload(seed, fresh) {
            var out = {};
            var k;
            if (seed) {
                for (k in seed) {
                    if (Object.prototype.hasOwnProperty.call(seed, k)) out[k] = seed[k];
                }
            }
            if (fresh) {
                for (k in fresh) {
                    if (Object.prototype.hasOwnProperty.call(fresh, k)) out[k] = fresh[k];
                }
            }
            if (fresh && Array.isArray(fresh.stops) && fresh.stops.length) {
                out.stops = fresh.stops;
            } else if (seed && Array.isArray(seed.stops)) {
                out.stops = seed.stops;
            }
            if (fresh && fresh.cover_image_url) {
                out.cover_image_url = fresh.cover_image_url;
            } else if (seed && seed.cover_image_url) {
                out.cover_image_url = seed.cover_image_url;
            }
            if (fresh && fresh.stop_count != null) {
                out.stop_count = fresh.stop_count;
            }
            return normalizeTourPayload(out);
        }

        function tourHasEnoughStops(data) {
            if (!data) return false;
            var stops = Array.isArray(data.stops) ? data.stops : [];
            if (stops.length >= 2) return true;
            var stopCount = parseInt(data.stop_count, 10);
            return isFinite(stopCount) && stopCount >= 2;
        }

        function tourHasCoverImage(data) {
            if (!data) return false;
            var url = data.cover_image_url;
            return !!(url && String(url).trim());
        }

        function tourIsReadyToPublish(data) {
            return tourHasEnoughStops(data) && tourHasCoverImage(data);
        }

        function syncTourCardPublishChip(li, merged) {
            if (!li || !merged) return;
            var pubChip = li.querySelector('[data-gfe-tour-publish]');
            if (!pubChip) return;
            var isPublic = !!merged.is_public;
            var ready = tourIsReadyToPublish(merged);
            pubChip.classList.toggle('is-published', isPublic);
            pubChip.disabled = isPublic ? false : !ready;
            var chipHint;
            if (isPublic) {
                chipHint = 'Unpublish';
            } else if (!ready) {
                if (!tourHasEnoughStops(merged)) {
                    chipHint = 'Add at least 2 stops before publishing';
                } else if (!tourHasCoverImage(merged)) {
                    chipHint = 'Upload a cover image before publishing';
                } else {
                    chipHint = 'Complete setup before publishing';
                }
            } else {
                chipHint = 'Publish';
            }
            pubChip.setAttribute('aria-label', isPublic ? 'Unpublish tour' : chipHint);
            pubChip.setAttribute('title', chipHint);
            var pubIcon = pubChip.querySelector('i');
            if (pubIcon) pubIcon.className = 'bi ' + (isPublic ? 'bi-eye-slash' : 'bi-broadcast');
        }

        function syncTourDetailPublishBtn() {
            var pubBtn  = document.getElementById('tourDetailPublishBtn');
            var pubLbl  = pubBtn && pubBtn.querySelector('.tour-detail-publish-btn-label');
            var pubIcon = pubBtn && pubBtn.querySelector('i');
            if (!pubBtn) return;

            var isPublic = !!tourFocusState.isPublic;
            var publishData = {
                stops:           tourFocusState.currentStops || [],
                stop_count:      tourFocusState.currentTourStopCount != null
                    ? tourFocusState.currentTourStopCount
                    : (tourFocusState.currentStops ? tourFocusState.currentStops.length : 0),
                cover_image_url: tourFocusState.currentTourCoverUrl
            };
            var ready = tourIsReadyToPublish(publishData);

            pubBtn.classList.toggle('is-published', isPublic);
            pubBtn.disabled = isPublic ? false : !ready;
            pubBtn.setAttribute('data-tour-publish', isPublic ? '0' : '1');
            if (pubLbl)  pubLbl.textContent  = isPublic ? 'Unpublish' : 'Publish';
            if (pubIcon) pubIcon.className   = isPublic ? 'bi bi-eye-slash' : 'bi bi-broadcast';

            var hint;
            if (isPublic) {
                hint = 'Unpublish tour';
            } else if (!ready) {
                if (!tourHasEnoughStops(publishData)) {
                    hint = 'Add at least 2 stops before publishing';
                } else if (!tourHasCoverImage(publishData)) {
                    hint = 'Upload a cover image before publishing';
                } else {
                    hint = 'Complete setup before publishing';
                }
            } else {
                hint = 'Publish tour';
            }
            pubBtn.setAttribute('aria-label', hint);
            pubBtn.setAttribute('title', hint);
        }
        window.syncTourDetailPublishBtn = syncTourDetailPublishBtn;

        function refreshTourDetailFromServer(tourId, seedData) {
            if (tourId == null) return;
            fetch('/tours/' + encodeURIComponent(tourId), {
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (body) {
                if (!body || !body.tour) return;
                if (tourFocusState.currentTourId !== tourId) return;
                var merged = mergeTourPayload(seedData, body.tour);
                tourFocusState.currentStops = normalizeServerStopsToFocus(merged.stops || []);
                tourFocusState.currentTourStopCount = parseInt(merged.stop_count, 10) || tourFocusState.currentStops.length;
                tourFocusState.initialStopIds = tourFocusState.currentStops.map(function (s) { return s.id; });
                tourFocusState.currentTourCoverUrl = merged.cover_image_url || tourFocusState.currentTourCoverUrl;
                tourFocusState.isPublic = !!merged.is_public;
                var countEl = document.getElementById('tourDetailStopCount');
                if (countEl) countEl.textContent = String(tourFocusState.currentTourStopCount);
                rerenderTourStopsList();
                syncTourDetailPublishBtn();
                syncTourCardPublishChip(
                    document.querySelector('li.gfe-loc-item.is-tour[data-gfe-tour-id="' + String(tourId).replace(/"/g, '\\"') + '"]'),
                    merged
                );
                if (typeof propagateTourCoverToCards === 'function') {
                    propagateTourCoverToCards(tourId, merged);
                }
            })
            .catch(function () { /* keep seed payload */ });
        }

        function showTourDetailModal(data) {
            var modalEl = document.getElementById('tourDetailModal');
            if (!modalEl || !data) return;
            if (typeof window.hideSpinIntroCarouselBanner === 'function') {
                window.hideSpinIntroCarouselBanner();
            }
            data = normalizeTourPayload(data);

            function setText(id, val) {
                var el = document.getElementById(id);
                if (el) el.textContent = val == null ? '' : String(val);
            }

            // Title hydration. The legacy <h3 id="tourDetailTitle">
            // was replaced by an editable <input id="tourEditFieldTitle">
            // when the modal was tabbed, so setText (which writes
            // textContent) became a no-op for it. We write to .value
            // instead. The wireTourEditTab1Save IIFE re-snapshots
            // this baseline below for dirty-state tracking.
            (function hydrateTourTitleInput() {
                var titleInput = document.getElementById('tourEditFieldTitle');
                if (titleInput) titleInput.value = data.title == null ? '' : String(data.title);
            })();

            // Reset the modal to Tab 1 (Edit Tour) on every (re)open.
            // This sets the data-active-tab attribute the footer CSS
            // keys off (Save Tour vs Save Order visibility), flips
            // [hidden] on the two .tour-detail-tabpanel siblings,
            // and resets the role="tab" buttons' .is-active +
            // aria-selected pair. Also clears the footer status
            // pill so a stale "Saved"/"Save failed" from a previous
            // open of any tour can't bleed into the new one.
            (function resetTourModalToEditTab() {
                var modalEl = document.getElementById('tourDetailModal');
                if (!modalEl) return;
                modalEl.setAttribute('data-active-tab', 'edit');
                var paneEdit = document.getElementById('tourTabPaneEdit');
                var paneLocs = document.getElementById('tourTabPaneLocations');
                if (paneEdit) paneEdit.hidden = false;
                if (paneLocs) paneLocs.hidden = true;
                var tabEdit = document.getElementById('tourDetailTabEdit');
                var tabLocs = document.getElementById('tourDetailTabLocations');
                if (tabEdit) {
                    tabEdit.classList.add('is-active');
                    tabEdit.setAttribute('aria-selected', 'true');
                }
                if (tabLocs) {
                    tabLocs.classList.remove('is-active');
                    tabLocs.setAttribute('aria-selected', 'false');
                }
                var status = document.getElementById('tourDetailStatus');
                if (status) {
                    status.textContent = '';
                    status.removeAttribute('data-state');
                }
            })();

            // Hero cover image — full-bleed background painted from
            // the tour's cover_image_url. The .is-loaded class is
            // toggled after preload so the .35s opacity fade only
            // kicks in once the image is paint-ready (matches the
            // #gfeEditModal hero pipeline). Setting bgImage to '' +
            // removing .is-loaded reveals the signpost-icon fallback.
            (function hydrateTourHero() {
                var heroImg = document.getElementById('tourDetailHeroImg');
                if (!heroImg) return;
                var coverUrl = data.cover_image_url || null;
                heroImg.classList.remove('is-loaded');
                heroImg.style.backgroundImage = '';
                if (!coverUrl) return;
                var pre = new Image();
                pre.onload = function () {
                    var safe = String(coverUrl).replace(/'/g, '%27').replace(/"/g, '%22');
                    heroImg.style.backgroundImage = "url('" + safe + "')";
                    heroImg.classList.add('is-loaded');
                };
                pre.onerror = function () {
                    heroImg.style.backgroundImage = '';
                };
                pre.src = coverUrl;
            })();

            // Stops count pill — always visible, pulls from the stops
            // array rather than a separate count so it stays correct
            // if callers ever hand in a filtered subset.
            var stopsArr = Array.isArray(data.stops) ? data.stops : [];
            setText('tourDetailStopCount', stopsArr.length);

            // Distance pill — hidden when the payload has no
            // route_distance_m (shouldn't happen for saved tours,
            // but the create-preview path doesn't carry it either,
            // so we defensively skip rather than show "0 km").
            var distancePill = document.getElementById('tourDetailDistancePill');
            var distEl       = document.getElementById('tourDetailDistance');
            var km = data.route_distance_m ? (data.route_distance_m / 1000) : 0;
            if (distancePill && distEl) {
                if (km > 0) {
                    distEl.textContent = km.toFixed(1);
                    distancePill.style.display = '';
                } else {
                    distancePill.style.display = 'none';
                }
            }

            // WEB ADDRESS section — subdomain ↔ custom-domain toggle
            // hydration. The blade markup replaced the read-only
            // slug link with the same toggle UI the location modal
            // uses; setup happens in the wireTourDomainEditor IIFE
            // below, which exposes window.hydrateTourDomainEditor
            // so this open path can hand it the freshly-clicked
            // tour's data without coupling the two closures.
            if (typeof window.hydrateTourDomainEditor === 'function') {
                window.hydrateTourDomainEditor(data);
            }

            // Description hydration. The legacy <p id="tourDetailDescription">
            // (hidden when empty) was replaced by an editable
            // <textarea id="tourEditFieldDescription"> when the
            // modal was tabbed, so we write to .value and leave
            // the textarea always-visible — empty state is just
            // an empty input, not a missing element.
            (function hydrateTourDescriptionTextarea() {
                var descTa = document.getElementById('tourEditFieldDescription');
                if (descTa) descTa.value = data.description == null ? '' : String(data.description);
            })();

            // Owner-editable metadata hydration. Each input is
            // looked up by id; null/missing payload values map to
            // ''. Inputs themselves are gated on existing because
            // a tenant whose schema pre-dates the metadata init
            // command may render the modal without the fields (a
            // future blade gate would do this — currently the blade
            // always renders them, so the lookups always succeed
            // on a current build, but the gate keeps this safe if
            // the blade ever conditional-renders).
            (function hydrateTourMetadataInputs() {
                function setVal(id, v) {
                    var el = document.getElementById(id);
                    if (!el) return;
                    el.value = (v == null) ? '' : String(v);
                }
                setVal('tourEditFieldPhone',           data.phone);
                setVal('tourEditFieldEmail',           data.email);
                setVal('tourEditFieldWebsite',         data.website);
                setVal('tourEditFieldBookingUrl',      data.booking_url);
                setVal('tourEditFieldDurationMinutes', data.duration_minutes);
                setVal('tourEditFieldInstagram',       data.instagram_url);
                setVal('tourEditFieldFacebook',        data.facebook_url);
                setVal('tourEditFieldTiktok',          data.tiktok_url);
                setVal('tourEditFieldYoutube',         data.youtube_url);
            })();

            // Capture identifying + reorder state for later use by
            // the Save handler and close guard. We deep-copy stopsArr
            // into currentStops (and snapshot the id order into
            // initialStopIds) so subsequent drags never mutate the
            // caller's payload and discard can rebuild cleanly.
            tourFocusState.currentTourId              = data.id != null ? data.id : null;
            tourFocusState.currentTourSlug            = data.slug || null;
            tourFocusState.currentTourTitle           = data.title || '';
            tourFocusState.currentTourDescription     = data.description || '';
            tourFocusState.currentTourDistanceM       = parseInt(data.route_distance_m || 0, 10);
            tourFocusState.currentTourCompletionCount = parseInt(data.completion_count || 0, 10);
            tourFocusState.currentTourCoverUrl         = data.cover_image_url || null;
            tourFocusState.currentTourStopCount       = parseInt(data.stop_count, 10);
            if (!isFinite(tourFocusState.currentTourStopCount)) {
                tourFocusState.currentTourStopCount = (data.stops || []).length;
            }
            tourFocusState.isPublic                   = !!data.is_public;

            // Snapshot the freshly-opened tour into the Tab 1 save
            // baseline so the dirty-state tracker and Save Tour
            // button start clean (no leftover dirty flag from the
            // previous tour, no auto-enabled save on open).
            if (typeof window.hydrateTourEditTab1 === 'function') {
                window.hydrateTourEditTab1(data);
            }

            // Reset the delete button so a previous click's
            // disabled-while-fetching state doesn't carry into
            // the next open.
            var delBtn = document.getElementById('tourDetailDeleteBtn');
            if (delBtn) delBtn.disabled = false;

            tourFocusState.currentStops           = stopsArr.map(normalizeTourStop).filter(Boolean);
            tourFocusState.initialStopIds = tourFocusState.currentStops.map(function (s) {
                return s.id;
            });
            tourFocusState.isDirty      = false;
            tourFocusState.saveInFlight = false;

            syncTourDetailPublishBtn();

            // Reset the footer save-status row so reopening any tour
            // starts clean (no leftover "Saved" / "Save failed" text
            // from a previous session).
            setSaveButtonState('clean');

            // Stops list rendered via the shared rerenderTourStopsList
            // helper so the Add Location and Remove Stop flows can
            // re-render with the same markup + Sortable wiring after
            // their respective backend calls return.
            rerenderTourStopsList();

            modalEl.classList.remove('is-flying-out');
            // Force a reflow between resetting and adding .visible so
            // the bounce-in animation restarts cleanly on reopen.
            // eslint-disable-next-line no-unused-expressions
            modalEl.offsetHeight;
            modalEl.classList.add('visible');

            if (data.id != null) {
                refreshTourDetailFromServer(data.id, data);
            }
        }

        // Re-renders #tourDetailStopsList from tourFocusState.currentStops
        // and re-initializes the SortableJS instance over the new
        // DOM. Three callsites:
        //   1. showTourDetailModal (initial render on open)
        //   2. wireTourAddLocationPicker (after POST /tours/{id}/stops)
        //   3. wireTourRemoveStop (after DELETE /tours/{id}/stops/{stopId})
        //
        // Both 2 and 3 also call resetTourReorderBaseline() afterwards
        // so the unchanged-from-saved list isn't fake-dirty (Save
        // Order would otherwise re-arm the moment Sortable.onEnd
        // fires, even though the user hasn't dragged anything).
        //
        // The remove button per row is disabled when the tour is at
        // the 2-stop floor — UserTour business rules require >=2
        // stops, and removeStop() rejects below that threshold.
        function rerenderTourStopsList() {
            var listEl = document.getElementById('tourDetailStopsList');
            if (!listEl) return;
            var stopsArr = tourFocusState.currentStops || [];
            if (stopsArr.length === 0) {
                listEl.innerHTML = '<p class="tour-detail-stops-empty">'
                    + 'No stops on this tour yet. Tap <strong>Add New Location</strong> below.</p>';
            } else {
                var htmlEsc = function (s) {
                    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
                        return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
                    });
                };
                var removeDisabled = stopsArr.length <= 2 ? ' disabled' : '';
                listEl.innerHTML = stopsArr.map(function (s, i) {
                    var thumb = s.logo_url
                        ? '<img src="' + htmlEsc(s.logo_url) + '" alt="" loading="lazy">'
                        : '<i class="bi bi-geo-alt-fill"></i>';
                    var sid = (s.id != null) ? htmlEsc(s.id) : '';
                    var hpid = (s.home_point_id != null) ? htmlEsc(s.home_point_id) : '';
                    return '<div class="tour-detail-stop-row" data-stop-id="' + sid + '" data-hp-id="' + hpid + '">'
                         +   '<div class="tour-detail-stop-main">'
                         +     '<span class="tour-detail-stop-grip" aria-hidden="true"><i class="bi bi-grip-vertical"></i></span>'
                         +     '<div class="tour-detail-stop-num">' + (i + 1) + '</div>'
                         +     '<div class="tour-detail-stop-thumb">' + thumb + '</div>'
                         +     '<div class="tour-detail-stop-title">' + htmlEsc(s.title || ('Stop ' + (i + 1))) + '</div>'
                         +     '<button type="button" class="tour-detail-stop-remove-btn" data-stop-id="' + sid + '" aria-label="Remove stop"' + removeDisabled + '>'
                         +       '<i class="bi bi-x-lg"></i>'
                         +     '</button>'
                         +     '<button type="button" class="tour-detail-stop-expand" aria-expanded="false" aria-label="Show location details">'
                         +       '<i class="bi bi-chevron-down"></i>'
                         +     '</button>'
                         +   '</div>'
                         +   '<div class="tour-detail-stop-accordion" hidden></div>'
                         + '</div>';
                }).join('');
            }

            // SortableJS wiring. Destroy any instance left over
            // from a previous render (the handlers close over the
            // stale currentStops) before creating a new one.
            if (tourFocusState.sortable) {
                try { tourFocusState.sortable.destroy(); } catch(e) {}
                tourFocusState.sortable = null;
            }
            if (typeof Sortable !== 'undefined' && stopsArr.length > 1) {
                try {
                    tourFocusState.sortable = new Sortable(listEl, {
                        handle:      '.tour-detail-stop-grip',
                        animation:   150,
                        ghostClass:  'tour-detail-stop-row--ghost',
                        chosenClass: 'tour-detail-stop-row--chosen',
                        forceFallback: true,
                        onEnd: handleTourReorderEnd
                    });
                } catch (e) { console.warn('[tour-focus] sortable init failed', e); }
            }
        }

        // Resets the Save Order button + dirty baseline so a fresh
        // server-side stops list isn't immediately marked dirty
        // (otherwise the next Sortable.onEnd compare against the
        // OLD initialStopIds would wrongly flag the unchanged list).
        // Called after Add Location and Remove Stop succeed.
        function resetTourReorderBaseline() {
            tourFocusState.initialStopIds = (tourFocusState.currentStops || [])
                .map(function (s) { return s.id; });
            tourFocusState.isDirty = false;
            setSaveButtonState('clean');
        }

        // Updates the count + distance pills in the modal hero.
        // Called after Add/Remove finishes so the pills reflect
        // the new server-computed stop_count + route_distance_m.
        function updateTourDetailPills(stopCount, routeDistanceM) {
            var countEl = document.getElementById('tourDetailStopCount');
            if (countEl) countEl.textContent = String(stopCount != null ? stopCount : 0);
            var distancePill = document.getElementById('tourDetailDistancePill');
            var distEl       = document.getElementById('tourDetailDistance');
            var km = routeDistanceM ? (routeDistanceM / 1000) : 0;
            if (distancePill && distEl) {
                if (km > 0) {
                    distEl.textContent = km.toFixed(1);
                    distancePill.style.display = '';
                } else {
                    distancePill.style.display = 'none';
                }
            }
        }

        // Expose the renderer + post-mutation helpers globally so
        // the Add Location picker IIFE and Remove Stop delegated
        // handler (defined further down, in their own closures) can
        // call them without needing a sibling-scope reference.
        if (typeof window !== 'undefined') {
            window.rerenderTourStopsList   = rerenderTourStopsList;
            window.resetTourReorderBaseline = resetTourReorderBaseline;
            window.updateTourDetailPills   = updateTourDetailPills;
        }

        // Toggle the save button + status-line into one of four
        // states. Centralised so every callsite (reorder, save
        // click, save success/failure, modal close) stays in sync
        // on the DOM attributes the CSS keys off (data-state).
        //   clean  — Save disabled, no status text.
        //   dirty  — Save enabled, "Unsaved changes".
        //   saving — Save disabled, "Saving…".
        //   saved  — Save disabled, "Saved".
        //   error  — Save enabled, "Save failed. Try again.".
        function setSaveButtonState(state) {
            var btn    = document.getElementById('tourDetailSave');
            var status = document.getElementById('tourDetailStatus');
            if (!btn || !status) return;
            status.setAttribute('data-state', state);
            switch (state) {
                case 'dirty':
                    btn.disabled = false;
                    status.textContent = 'Unsaved changes';
                    break;
                case 'saving':
                    btn.disabled = true;
                    status.textContent = 'Saving…';
                    break;
                case 'saved':
                    btn.disabled = true;
                    status.textContent = 'Saved';
                    break;
                case 'error':
                    btn.disabled = false;
                    status.textContent = 'Save failed. Try again.';
                    break;
                case 'clean':
                default:
                    btn.disabled = true;
                    status.textContent = '';
                    break;
            }
        }

        // Sortable.onEnd handler. Rebuilds currentStops from DOM
        // order (which is the source of truth after the drag),
        // renumbers the row badges in place, redraws the map
        // polyline, renumbers the map marker badges, and toggles
        // the dirty flag + Save button.
        function handleTourReorderEnd() {
            var listEl = document.getElementById('tourDetailStopsList');
            if (!listEl) return;
            var rows  = listEl.querySelectorAll('.tour-detail-stop-row');
            var byId  = {};
            tourFocusState.currentStops.forEach(function (s) {
                if (s && s.id != null) byId[String(s.id)] = s;
            });
            var next = [];
            for (var i = 0; i < rows.length; i++) {
                var rid = rows[i].getAttribute('data-stop-id');
                if (rid && byId[rid]) next.push(byId[rid]);
            }
            // Sanity check — if the DOM order dropped a row (it
            // shouldn't, Sortable is strictly reorder-only) fall
            // back to the previous state rather than corrupting
            // currentStops.
            if (next.length !== tourFocusState.currentStops.length) {
                console.warn('[tour-focus] reorder dropped rows; aborting update');
                return;
            }
            tourFocusState.currentStops = next;

            // Renumber the row number chips in place so the
            // user sees the new order immediately. The title /
            // thumbnail / grip stay put — only the badge changes.
            for (var j = 0; j < rows.length; j++) {
                var numEl = rows[j].querySelector('.tour-detail-stop-num');
                if (numEl) numEl.textContent = String(j + 1);
            }

            // Repaint the route polyline + renumber markers.
            updateTourRouteLine();
            renumberTourMarkers();

            // Recompute dirty — compare the id sequence against
            // the snapshot taken at open time. Catches the case
            // where the user drags a row and then drags it back
            // (state is clean again).
            var dirty = false;
            for (var k = 0; k < next.length; k++) {
                if (next[k].id !== tourFocusState.initialStopIds[k]) { dirty = true; break; }
            }
            tourFocusState.isDirty = dirty;
            setSaveButtonState(dirty ? 'dirty' : 'clean');
        }

        // Close handler — mirrors wireTownDetailClose above. Three-phase
        // rewind: card flies up, 500ms dwell, globe framing restores +
        // tour overlays tear down, then intro re-opens on the Tours tab.
        // Also gates on the reorder dirty flag so a half-saved drag
        // doesn't silently get thrown away.
        (function wireTourDetailClose() {
            var modalEl = document.getElementById('tourDetailModal');
            if (!modalEl) return;

            // Re-open the intro modal after the tour-detail
            // modal flies out. The legacy importer Tours tab
            // (which we used to re-select here via a synthetic
            // click on [data-gfe-loctab="tours"]) was removed
            // when the compact tours list moved into the
            // bottom drawer's left column — so showIntro() is
            // sufficient on its own. The drawer's left column
            // is always populated for users with >= 2 home
            // points, so the user lands somewhere they can
            // immediately re-open the same tour.
            function restoreIntroAfterTourDetail() {
                try { showIntro(); } catch(e) {}
            }

            var DETAIL_FLYOUT_MS      = 450;
            var DETAIL_TO_GLOBE_DWELL = 500;
            var GLOBE_EASE_MS         = 900;

            function hide() {
                if (!modalEl.classList.contains('visible')) return;

                // Unsaved reorder guard. If the user says Cancel we
                // keep the modal open and preserve their staging; if
                // they confirm we revert the map overlays to the
                // original order so the bounce-out doesn't flash a
                // stale polyline during the fly-up.
                if (tourFocusState.isDirty) {
                    if (!confirm('Discard unsaved order?')) return;
                    // Rebuild currentStops in the original order by
                    // looking up each id in the (still-unmodified)
                    // rows' data — the row thumbnails / titles live
                    // on currentStops so we can pivot off those.
                    var byId = {};
                    tourFocusState.currentStops.forEach(function (s) {
                        if (s && s.id != null) byId[String(s.id)] = s;
                    });
                    var restored = [];
                    tourFocusState.initialStopIds.forEach(function (sid) {
                        if (sid != null && byId[String(sid)]) restored.push(byId[String(sid)]);
                    });
                    if (restored.length === tourFocusState.initialStopIds.length) {
                        tourFocusState.currentStops = restored;
                        updateTourRouteLine();
                        renumberTourMarkers();
                    }
                    tourFocusState.isDirty = false;
                    setSaveButtonState('clean');
                }

                modalEl.classList.add('is-flying-out');

                setTimeout(function () {
                    modalEl.classList.remove('visible');
                    modalEl.classList.remove('is-flying-out');
                    resetTourMapOverlays();
                    tourFocusInFlight = false;
                    try { restoreGlobeFraming(GLOBE_EASE_MS); } catch(e) {}
                }, DETAIL_FLYOUT_MS + DETAIL_TO_GLOBE_DWELL);

                setTimeout(function () {
                    restoreIntroAfterTourDetail();
                }, DETAIL_FLYOUT_MS + DETAIL_TO_GLOBE_DWELL + GLOBE_EASE_MS);
            }

            // Close is intentionally restricted to the X button in
            // the top-right ONLY. Backdrop click + Escape were both
            // wired here previously, but Tab 1 of the modal now
            // hosts editable fields (title, description, contact +
            // social metadata) whose dirty state isn't tracked by
            // the unsaved-reorder guard in hide() — only the
            // tourFocusState.isDirty (stop reorder) flag is. An
            // accidental backdrop click would silently discard
            // pending edits with no recovery, so we drop both the
            // implicit-close affordances and require an explicit
            // click on #tourDetailClose. The hide() function itself
            // is unchanged so the in-modal flow (Save → setTimeout
            // → close) still works as before.
            var closeBtn = document.getElementById('tourDetailClose');
            if (closeBtn) closeBtn.addEventListener('click', hide);

            // Save button — PATCHes the new stop_ids order to the
            // server. Wired here (inside the same IIFE) because it
            // shares the modal's lifecycle state and has access to
            // tourFocusState + setSaveButtonState + resetTourMapOverlays.
            var saveBtn = document.getElementById('tourDetailSave');
            if (saveBtn) {
                saveBtn.addEventListener('click', function () {
                    submitTourReorder();
                });
            }

            // Accordion expand/collapse on each stop row. Delegated
            // on the list element so it survives the innerHTML
            // rewrite that happens every time the modal reopens.
            // The accordion body is rendered lazily on first
            // expand — reading the full location payload off the
            // matching <li.gfe-loc-item> already in the DOM — so a
            // tour with 25 stops doesn't spend layout time building
            // 25 detail blocks the user will never look at.
            var listEl = document.getElementById('tourDetailStopsList');
            if (listEl) {
                listEl.addEventListener('click', function (ev) {
                    var btn = ev.target.closest('.tour-detail-stop-expand');
                    if (!btn) return;
                    ev.preventDefault();
                    var row = btn.closest('.tour-detail-stop-row');
                    if (!row) return;
                    var acc = row.querySelector('.tour-detail-stop-accordion');
                    if (!acc) return;

                    var isOpen = row.classList.contains('is-expanded');
                    if (isOpen) {
                        row.classList.remove('is-expanded');
                        btn.setAttribute('aria-expanded', 'false');
                        acc.hidden = true;
                        return;
                    }

                    // Single-open accordion — collapse any other
                    // row currently expanded before opening this
                    // one so the modal never shows two stacked
                    // detail bodies at the same time.
                    var openRows = listEl.querySelectorAll('.tour-detail-stop-row.is-expanded');
                    for (var r = 0; r < openRows.length; r++) {
                        var otherRow  = openRows[r];
                        var otherBtn  = otherRow.querySelector('.tour-detail-stop-expand');
                        var otherAcc  = otherRow.querySelector('.tour-detail-stop-accordion');
                        otherRow.classList.remove('is-expanded');
                        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
                        if (otherAcc) otherAcc.hidden = true;
                    }

                    // Lazy-render on first expand. Re-renders on
                    // each subsequent open too because the
                    // originating <li.gfe-loc-item> payload can
                    // change between sessions (if the user edits
                    // a location between opens); cheap enough to
                    // rebuild from the cached payload every time.
                    var hpId = row.getAttribute('data-hp-id');
                    acc.innerHTML = renderStopAccordionBody(hpId);

                    row.classList.add('is-expanded');
                    btn.setAttribute('aria-expanded', 'true');
                    acc.hidden = false;
                });
            }
        })();

        // ────────────────────────────────────────────────────────────────
        // Tour mutation helpers — togglePublishForTour() / deleteTourById()
        // --------------------------------------------------------------
        // Extracted from the inline button handlers in
        // wireTourDetailActionButtons so the new tour cards
        // (.gfe-loc-item.is-tour) can call the same helpers from their
        // own publish/delete chips. Both functions return a Promise that
        // resolves with the parsed JSON body on success, or rejects with
        // a normalised error so the caller can decide whether to show
        // an alert (modal/card) or stay silent.
        //
        // The functions intentionally do NOT touch the DOM — every
        // caller (modal button, card chip) is responsible for its own
        // optimistic UI flip. That keeps the helpers pure and testable.
        // ──────────────────────────────────────────────────────────────
        function getCsrfToken() {
            var meta = document.querySelector('meta[name="csrf-token"]');
            return meta ? meta.getAttribute('content') : '';
        }

        // ────────────────────────────────────────────────────────────────
        // propagateTourCoverToCards(tourId, data)
        // --------------------------------------------------------------
        // Mirror image of propagateHomePointToTourPayloads added during
        // the location-edit flow. Called after every successful tour
        // mutation (cover image PATCH, publish flip, delete) so the
        // matching tour <li.gfe-loc-item.is-tour> reflects the new
        // server state without re-fetching the whole locations view.
        //
        // `data` is whatever the caller has — typically the controller's
        // tour payload (from PATCH/publish responses), or a sentinel
        // `{_deleted:true}` for delete. Each branch is best-effort: any
        // missing field is left as-is on the card.
        // ──────────────────────────────────────────────────────────────
        function propagateTourCoverToCards(tourId, data) {
            if (tourId == null) return;
            var enc = String(tourId).replace(/"/g, '\\"');
            var li = document.querySelector(
                'li.gfe-loc-item.is-tour[data-gfe-tour-id="' + enc + '"]'
            ) || document.querySelector(
                'li[data-gfe-tour-id="' + enc + '"]'
            );
            if (!li) return;

            // Hard delete branch — strip the <li> entirely. Source of
            // truth is the server, so once DELETE 200s we don't keep
            // a tombstone around.
            if (data && data._deleted) {
                if (li && li.parentNode) li.parentNode.removeChild(li);
                return;
            }

            // Update the cached payload first so any subsequent click
            // handlers read the fresh state. Merge over the old one so
            // partial updates (e.g. publish flip without cover change)
            // don't blow away unrelated fields.
            var existing = {};
            try { existing = JSON.parse(li.getAttribute('data-gfe-tour-payload') || '{}'); } catch (e) {}
            var merged = {};
            for (var k in existing) if (Object.prototype.hasOwnProperty.call(existing, k)) merged[k] = existing[k];
            for (var k2 in data) {
                if (!Object.prototype.hasOwnProperty.call(data, k2)) continue;
                if (k2[0] === '_') continue; // skip our own sentinel keys
                merged[k2] = data[k2];
            }
            li.setAttribute('data-gfe-tour-payload', JSON.stringify(merged));

            // Cover image — bg-image on the <li> + the inner thumb
            // <img>. Skip when data carries no cover_image_url so an
            // unrelated mutation (publish flip) doesn't blank the
            // image.
            if (Object.prototype.hasOwnProperty.call(data, 'cover_image_url')) {
                var url = data.cover_image_url || null;
                if (url) {
                    var safe = String(url).replace(/'/g, '%27').replace(/"/g, '%22');
                    li.style.backgroundImage = "url('" + safe + "')";
                    li.classList.add('has-bg-image');
                    var thumb = li.querySelector('.gfe-loc-item-thumb');
                    if (thumb) {
                        var img = thumb.querySelector('img');
                        if (img) {
                            img.src = url;
                        } else {
                            thumb.innerHTML = '<img src="' + url.replace(/"/g, '&quot;') + '" alt="" loading="lazy">';
                        }
                    }
                } else {
                    li.style.backgroundImage = '';
                    li.classList.remove('has-bg-image');
                    var thumb2 = li.querySelector('.gfe-loc-item-thumb');
                    if (thumb2) thumb2.innerHTML = '<i class="bi bi-signpost-2-fill"></i>';
                }
            }

            // is_public — re-paint publish chip + slug
            // pill in lockstep. Source of truth is server's body when
            // present, otherwise the merged payload (e.g. the
            // optimistic publish-flip path passes is_public directly).
            if (Object.prototype.hasOwnProperty.call(data, 'is_public')) {
                var isPublic = !!data.is_public;
                li.classList.toggle('is-public',  isPublic);
                li.classList.toggle('is-private', !isPublic);

                syncTourCardPublishChip(li, merged);

                // Slug pill — swap <a> ↔ <span> chrome by replacing the
                // node so we don't leak href/click semantics across
                // states. Reuses the same selector + classes the
                // server-side partial emits so the rendered DOM stays
                // identical to a fresh page load.
                var slugEl = li.querySelector('.gfe-loc-item-slug');
                if (slugEl && merged.slug) {
                    var slugTxt = window.gfeSubdomainHost(merged.slug);
                    var newSlug;
                    if (isPublic) {
                        newSlug = document.createElement('a');
                        newSlug.href = 'https://' + slugTxt;
                        newSlug.target = '_blank';
                        newSlug.rel = 'noopener';
                        newSlug.className = 'gfe-loc-item-slug';
                        newSlug.title = slugTxt;
                        newSlug.innerHTML = '<i class="bi bi-globe2"></i><span class="gfe-loc-item-slug-text">'
                                          + slugTxt.replace(/</g,'&lt;') + '</span>';
                    } else {
                        newSlug = document.createElement('span');
                        newSlug.className = 'gfe-loc-item-slug is-private';
                        newSlug.title = 'Publish to activate';
                        newSlug.innerHTML = '<i class="bi bi-lock-fill"></i><span class="gfe-loc-item-slug-text">'
                                          + slugTxt.replace(/</g,'&lt;') + '</span>';
                    }
                    // Carry over the same stop-propagation guard the
                    // server-side partial emits (so chip clicks
                    // inside the slug area never bubble to the card
                    // body click handler).
                    newSlug.addEventListener('click', function (ev) { ev.stopPropagation(); });
                    slugEl.parentNode.replaceChild(newSlug, slugEl);
                }
            }

            // Title / description — straight text swaps when present.
            if (Object.prototype.hasOwnProperty.call(data, 'title')) {
                var titleEl = li.querySelector('.gfe-loc-item-title');
                if (titleEl) titleEl.textContent = data.title || '';
            }
            if (Object.prototype.hasOwnProperty.call(data, 'description')) {
                var descEl = li.querySelector('.gfe-loc-item-desc');
                var descTxt = (data.description == null ? '' : String(data.description)).trim();
                if (descTxt) {
                    if (descEl) {
                        descEl.textContent = descTxt;
                    } else {
                        // Description didn't exist before — inject
                        // one. The body's structure is fixed: the
                        // .gfe-loc-item-desc sits between .head and
                        // .bottom, so we insert before .bottom.
                        var body = li.querySelector('.gfe-loc-item-body');
                        var bottom = body && body.querySelector('.gfe-loc-item-bottom');
                        if (body && bottom) {
                            var d = document.createElement('div');
                            d.className = 'gfe-loc-item-desc';
                            d.textContent = descTxt;
                            body.insertBefore(d, bottom);
                        }
                    }
                } else if (descEl) {
                    descEl.parentNode.removeChild(descEl);
                }
            }

            // Cover-only PATCHes don't touch is_public but still change
            // whether the tour can be published.
            syncTourCardPublishChip(li, merged);
        }

        function locationIsReadyToPublish(merged) {
            if (!merged) return false;
            var hasLogo = !!(merged.logo_url && String(merged.logo_url).trim());
            if (!hasLogo) return false;
            // Visit mechanic is always-on and self-defaults its minimum
            // dwell, so it never blocks publishing.
            return true;
        }

        /**
         * Repaint publish/delete chips + slug pill on a landing location
         * card from its merged data-gfe-loc-payload (is_public +
         * subdomain_slug).
         */
        function syncLocationCardPublishUi(li) {
            if (!li) return;
            if (!li.querySelector('[data-gfe-loc-publish]')) return;

            var merged = {};
            try { merged = JSON.parse(li.getAttribute('data-gfe-loc-payload') || '{}'); } catch (e) { /* noop */ }

            var isPublic = !!merged.is_public;
            var slugVal = merged.subdomain_slug ? String(merged.subdomain_slug).trim() : '';
            var ready = locationIsReadyToPublish(merged);

            li.classList.toggle('is-public', isPublic);
            li.classList.toggle('is-private', !isPublic);

            var pubChip = li.querySelector('[data-gfe-loc-publish]');
            if (pubChip) {
                pubChip.classList.toggle('is-published', isPublic);
                var canPublish = slugVal && (isPublic || ready);
                pubChip.disabled = !canPublish;
                var publishHint;
                if (!slugVal) {
                    publishHint = 'Set a subdomain to publish';
                } else if (!isPublic && !ready) {
                    publishHint = 'Upload a profile image and set stay duration before publishing';
                } else if (isPublic) {
                    publishHint = 'Unpublish';
                } else {
                    publishHint = 'Publish';
                }
                pubChip.setAttribute('aria-label',
                    slugVal ? (isPublic ? 'Unpublish location' : (ready ? 'Publish location' : 'Publish location — complete setup first')) : 'Publish location — set a subdomain first');
                pubChip.setAttribute('title', publishHint);
                var pubIcon = pubChip.querySelector('i');
                if (pubIcon) pubIcon.className = 'bi ' + (isPublic ? 'bi-eye-slash' : 'bi-broadcast');
            }

            var slugEl = li.querySelector('.gfe-loc-item-slug');
            if (!slugVal) {
                if (slugEl && slugEl.parentNode) slugEl.parentNode.removeChild(slugEl);
                return;
            }

            var slugTxt = window.gfeSubdomainHost(slugVal);
            var newSlug;
            if (isPublic) {
                newSlug = document.createElement('a');
                newSlug.href = 'https://' + slugTxt;
                newSlug.target = '_blank';
                newSlug.rel = 'noopener';
                newSlug.className = 'gfe-loc-item-slug';
                newSlug.title = slugTxt;
                newSlug.innerHTML = '<i class="bi bi-globe2"></i><span class="gfe-loc-item-slug-text">'
                    + slugTxt.replace(/</g, '&lt;') + '</span>';
            } else {
                newSlug = document.createElement('span');
                newSlug.className = 'gfe-loc-item-slug is-private';
                newSlug.title = 'Publish to activate';
                newSlug.innerHTML = '<i class="bi bi-lock-fill"></i><span class="gfe-loc-item-slug-text">'
                    + slugTxt.replace(/</g, '&lt;') + '</span>';
            }
            newSlug.addEventListener('click', function (ev) { ev.stopPropagation(); });

            var footer = li.querySelector('.gfe-loc-item-footer');
            if (slugEl && slugEl.parentNode) {
                slugEl.parentNode.replaceChild(newSlug, slugEl);
            } else if (footer) {
                footer.appendChild(newSlug);
            }
        }

        /**
         * Merge server fields into the location tile payload and sync
         * publish/slug UI — used after PATCH publish, delete, and edit.
         */
        function propagateLocationPublishToCards(homePointId, data) {
            if (homePointId == null) return;
            var enc = String(homePointId).replace(/"/g, '\\"');
            var li = document.querySelector(
                'li.gfe-loc-item:not(.is-tour)[data-gfe-loc-id="' + enc + '"]'
            ) || document.querySelector(
                'li[data-gfe-loc-id="' + enc + '"]:not(.is-tour)'
            );
            if (!li) return;

            if (data && data._deleted) {
                if (li.parentNode) li.parentNode.removeChild(li);
                return;
            }

            var existing = {};
            try { existing = JSON.parse(li.getAttribute('data-gfe-loc-payload') || '{}'); } catch (e2) {}
            var merged = {};
            for (var k in existing) if (Object.prototype.hasOwnProperty.call(existing, k)) merged[k] = existing[k];
            for (var k2 in data) {
                if (!Object.prototype.hasOwnProperty.call(data, k2)) continue;
                if (k2[0] === '_') continue;
                merged[k2] = data[k2];
            }
            li.setAttribute('data-gfe-loc-payload', JSON.stringify(merged));
            if (Object.prototype.hasOwnProperty.call(data, 'subdomain_slug')) {
                li.setAttribute('data-gfe-loc-slug', merged.subdomain_slug || '');
            }

            syncLocationCardPublishUi(li);
        }

        function togglePublishForTour(id, makePublic) {
            return fetch('/tours/' + id + '/publish', {
                method: 'PATCH',
                credentials: 'same-origin',
                headers: {
                    'Content-Type':   'application/json',
                    'X-CSRF-TOKEN':   getCsrfToken(),
                    'Accept':         'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({ is_public: !!makePublic })
            }).then(function (res) {
                return res.json().then(function (body) {
                    if (!res.ok) {
                        var err = new Error('publish_failed');
                        err.status = res.status;
                        err.body = body;
                        throw err;
                    }
                    return body;
                });
            });
        }

        function deleteTourById(id) {
            return fetch('/tours/' + id, {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: {
                    'X-CSRF-TOKEN': getCsrfToken(),
                    'Accept':       'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                }
            }).then(function (res) {
                if (!res.ok) {
                    var err = new Error('delete_failed');
                    err.status = res.status;
                    throw err;
                }
                return res.json().catch(function () { return {}; });
            });
        }

        function togglePublishForLocation(id, makePublic) {
            return fetch('/user-locations/' + encodeURIComponent(id) + '/publish', {
                method: 'PATCH',
                credentials: 'same-origin',
                headers: {
                    'Content-Type':   'application/json',
                    'X-CSRF-TOKEN':   getCsrfToken(),
                    'Accept':         'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({ is_public: !!makePublic })
            }).then(function (res) {
                return res.json().then(function (body) {
                    if (!res.ok) {
                        var err = new Error('publish_failed');
                        err.status = res.status;
                        err.body = body;
                        throw err;
                    }
                    return body;
                });
            });
        }

        function deleteLocationById(id) {
            return fetch('/user-locations/' + encodeURIComponent(id), {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: {
                    'X-CSRF-TOKEN': getCsrfToken(),
                    'Accept':       'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                }
            }).then(function (res) {
                return res.text().then(function (txt) {
                    var body = {};
                    if (txt) {
                        try { body = JSON.parse(txt); } catch (pe) { /* non-JSON error page */ }
                    }
                    if (!res.ok) {
                        var err = new Error('delete_failed');
                        err.status = res.status;
                        err.body = body || {};
                        throw err;
                    }
                    return body;
                });
            });
        }

        // Owner-only Publish + Delete buttons inside the tour detail
        // modal. Both delegate to the named togglePublishForTour() /
        // deleteTourById() helpers above so the tour cards' chip
        // versions of the same affordance hit identical code paths.
        //
        // Delete fires the close button click after success so the
        // same flyOut → globe-restore → showIntro sequence wired in
        // wireTourDetailClose runs without us re-implementing it here.
        (function wireTourDetailActionButtons() {
            var modalEl = document.getElementById('tourDetailModal');
            if (!modalEl) return;
            var pubBtn  = document.getElementById('tourDetailPublishBtn');
            var delBtn  = document.getElementById('tourDetailDeleteBtn');
            var closeBtn = document.getElementById('tourDetailClose');

            if (pubBtn) {
                pubBtn.addEventListener('click', function () {
                    if (pubBtn.disabled) return;
                    var id = tourFocusState.currentTourId;
                    if (id == null) return;
                    // data-tour-publish is the FORWARD intent set by
                    // syncTourDetailPublishBtn — "1" means "the user
                    // wants to publish" (currently private), "0"
                    // means "the user wants to unpublish".
                    var wantPublic = pubBtn.getAttribute('data-tour-publish') === '1';
                    if (wantPublic && !tourIsReadyToPublish({
                        stops: tourFocusState.currentStops,
                        stop_count: tourFocusState.currentTourStopCount != null
                            ? tourFocusState.currentTourStopCount
                            : tourFocusState.currentStops.length,
                        cover_image_url: tourFocusState.currentTourCoverUrl
                    })) {
                        if (!tourHasCoverImage({ cover_image_url: tourFocusState.currentTourCoverUrl })) {
                            alert('Upload a cover image before publishing.');
                        } else {
                            alert('Add at least 2 stops before publishing.');
                        }
                        return;
                    }
                    pubBtn.disabled = true;
                    togglePublishForTour(id, wantPublic).then(function (body) {
                        pubBtn.disabled = false;
                        // Flip the modal's own state + button chrome.
                        // Card chips piggyback on propagateTourCoverToCards()
                        // (see js_propagate todo) for their own UI.
                        tourFocusState.isPublic = !!wantPublic;
                        syncTourDetailPublishBtn();
                        // Propagate to the matching tour card so its
                        // state pill / slug pill / chip flip in step
                        // with the modal. Source of truth = the
                        // server's response body if it carried one,
                        // otherwise our forward intent.
                        var data = (body && body.tour) ? body.tour : { is_public: wantPublic };
                        if (typeof propagateTourCoverToCards === 'function') {
                            propagateTourCoverToCards(id, data);
                        }
                        if (typeof window.gfeRefreshUserToursList === 'function') {
                            try { window.gfeRefreshUserToursList(); } catch (e) {}
                        }
                    }).catch(function (err) {
                        pubBtn.disabled = false;
                        alert((err && err.body && err.body.error === 'slug_unavailable')
                            ? 'That subdomain is no longer available. Please create a new tour.'
                            : 'Could not update tour. Please try again.');
                    });
                });
            }

            if (delBtn) {
                delBtn.addEventListener('click', function () {
                    if (delBtn.disabled) return;
                    var id    = tourFocusState.currentTourId;
                    var title = tourFocusState.currentTourTitle || 'this tour';
                    if (id == null) return;
                    if (!confirm('Delete "' + title + '"? This cannot be undone.')) return;
                    delBtn.disabled = true;
                    deleteTourById(id).then(function () {
                        // Remove the matching card from the locations
                        // view BEFORE the flyOut so the user doesn't
                        // see it momentarily snap back when the intro
                        // restores.
                        if (typeof propagateTourCoverToCards === 'function') {
                            propagateTourCoverToCards(id, { _deleted: true });
                        }
                        if (typeof window.gfeRefreshUserToursList === 'function') {
                            try { window.gfeRefreshUserToursList(); } catch (e) {}
                        }
                        // Reset dirty so the close handler's
                        // "Discard unsaved order?" prompt doesn't
                        // pop after a successful delete.
                        tourFocusState.isDirty = false;
                        if (closeBtn) closeBtn.click();
                    }).catch(function () {
                        delBtn.disabled = false;
                        alert('Could not delete tour. Please try again.');
                    });
                });
            }
        })();

        // ────────────────────────────────────────────────────────────────
        // Change Cover wiring — #tourDetailModal hero
        // --------------------------------------------------------------
        // Click the Change Cover button → fire the hidden file picker.
        // On file pick → FileReader → sharedCropper.open with a 16:9
        // ratio. On cropper Apply → PATCH /tours/{id} with the
        // base64 image_data. On 200 → repaint the modal hero AND
        // propagate to the matching tour card so the new cover is
        // visible everywhere without a page refresh.
        // ──────────────────────────────────────────────────────────────
        (function wireTourDetailCoverBtn() {
            var btn   = document.getElementById('tourDetailCoverBtn');
            var input = document.getElementById('tourDetailCoverInput');
            var heroImg = document.getElementById('tourDetailHeroImg');
            if (!btn || !input || !heroImg) return;

            function setHero(url) {
                heroImg.classList.remove('is-loaded');
                if (!url) {
                    heroImg.style.backgroundImage = '';
                    return;
                }
                var pre = new Image();
                pre.onload = function () {
                    var safe = String(url).replace(/'/g, '%27').replace(/"/g, '%22');
                    heroImg.style.backgroundImage = "url('" + safe + "')";
                    heroImg.classList.add('is-loaded');
                };
                pre.onerror = function () {
                    heroImg.style.backgroundImage = '';
                };
                pre.src = url;
            }

            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (btn.classList.contains('is-saving')) return;
                input.click();
            });

            input.addEventListener('change', function () {
                var file = input.files && input.files[0];
                if (!file) return;
                var reader = new FileReader();
                reader.onload = function (evt) {
                    sharedCropper.open(evt.target.result, {
                        aspectRatio: 16 / 9,
                        onApply: function (croppedDataUrl) {
                            var id = tourFocusState.currentTourId;
                            if (id == null) {
                                // No active tour — paint the preview
                                // anyway so the user can see the crop,
                                // but don't fire a PATCH. (Edge case;
                                // shouldn't happen in normal flow.)
                                setHero(croppedDataUrl);
                                return;
                            }
                            btn.classList.add('is-saving');
                            // Optimistic preview while the PATCH is
                            // in flight — instant feedback even on
                            // slow connections.
                            setHero(croppedDataUrl);
                            tourFocusState.currentTourCoverUrl = croppedDataUrl;
                            syncTourDetailPublishBtn();
                            fetch('/tours/' + id, {
                                method: 'PATCH',
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type':     'application/json',
                                    'X-CSRF-TOKEN':     getCsrfToken(),
                                    'Accept':           'application/json',
                                    'X-Requested-With': 'XMLHttpRequest',
                                },
                                body: JSON.stringify({ image_data: croppedDataUrl })
                            }).then(function (res) {
                                return res.json().then(function (body) {
                                    return { ok: res.ok, status: res.status, body: body };
                                });
                            }).then(function (r) {
                                btn.classList.remove('is-saving');
                                if (!r.ok) {
                                    alert('Could not save cover image. Please try again.');
                                    return;
                                }
                                var tour = (r.body && r.body.tour) ? r.body.tour : null;
                                if (tour && tour.cover_image_url) {
                                    // Re-paint with the canonical
                                    // server URL (in case the upload
                                    // was rewritten through tenant
                                    // storage path) so we don't keep
                                    // a stale data: URL forever.
                                    setHero(tour.cover_image_url);
                                    tourFocusState.currentTourCoverUrl = tour.cover_image_url;
                                    syncTourDetailPublishBtn();
                                    if (typeof propagateTourCoverToCards === 'function') {
                                        propagateTourCoverToCards(id, tour);
                                    }
                                }
                            }).catch(function () {
                                btn.classList.remove('is-saving');
                                alert('Network error saving cover image.');
                            });
                        },
                    });
                };
                reader.onerror = function () {
                    alert('Could not read that image. Try a JPG, PNG, or WebP.');
                };
                reader.readAsDataURL(file);
                input.value = ''; // allow re-picking the same file
            });
        })();

        // ────────────────────────────────────────────────────────────────
        // Tour-edit modal — WEB ADDRESS section (subdomain ↔ custom)
        // --------------------------------------------------------------
        // Mirror of wireGfeEditModal's domain-toggle wiring at
        // ~line 3380, scoped to the tour modal's tourEdit* IDs and
        // posting to the tour-side endpoints. Three independent
        // network paths run from this section:
        //
        //   - GET  /tours/check-slug?slug=…&exclude_id=…
        //   - GET  /tours/check-custom-domain?domain=…&exclude_id=…
        //   - GET  /tours/{id}/check-domain-propagation
        //   - PATCH /tours/{id}  with {subdomain_slug, domain_mode, custom_domain}
        //
        // Open-time hydration is exposed as window.hydrateTourDomainEditor
        // so showTourDetailModal can hand the closure the freshly-
        // clicked tour without coupling. Save-time card sync calls
        // refreshTourCardPayloadAfterDomainSave so the tile in the
        // importer's Tours tab reflects the new slug / custom-domain
        // state on next click without a full-page re-render.
        // ──────────────────────────────────────────────────────────────
        // ────────────────────────────────────────────────────────────────
        // Tab switcher — Edit Tour ↔ Edit Locations
        // --------------------------------------------------------------
        // Click the role="tab" buttons in the modal's tab strip to
        // toggle which .tour-detail-tabpanel is visible. The modal
        // root's data-active-tab attribute drives the footer save-
        // button visibility (Save Tour vs Save Order) via CSS. The
        // shared #tourDetailStatus footer pill is cleared on switch
        // so a stale "Saved"/"Save failed" message from one tab can't
        // bleed into the other. Default tab is "edit" (set on every
        // showTourDetailModal call); this handler only kicks in when
        // the user explicitly clicks a tab.
        // ──────────────────────────────────────────────────────────────
        (function wireTourDetailTabs() {
            var modalEl = document.getElementById('tourDetailModal');
            if (!modalEl) return;
            var tabs = modalEl.querySelectorAll('[data-tour-tab]');
            if (!tabs.length) return;

            function activateTab(name) {
                modalEl.setAttribute('data-active-tab', name);
                for (var i = 0; i < tabs.length; i++) {
                    var t = tabs[i];
                    var isActive = t.getAttribute('data-tour-tab') === name;
                    t.classList.toggle('is-active', isActive);
                    t.setAttribute('aria-selected', isActive ? 'true' : 'false');
                }
                var paneEdit = document.getElementById('tourTabPaneEdit');
                var paneLocs = document.getElementById('tourTabPaneLocations');
                if (paneEdit) paneEdit.hidden = (name !== 'edit');
                if (paneLocs) paneLocs.hidden = (name !== 'locations');

                if (name === 'locations' && typeof rerenderTourStopsList === 'function') {
                    rerenderTourStopsList();
                }

                // Clear the footer status pill so a "Saved" /
                // "Save failed" message from one tab doesn't sit
                // there confusingly while the user is on the other.
                var status = document.getElementById('tourDetailStatus');
                if (status) {
                    status.textContent = '';
                    status.removeAttribute('data-state');
                }
            }

            for (var i = 0; i < tabs.length; i++) {
                (function (t) {
                    t.addEventListener('click', function (e) {
                        e.preventDefault();
                        var name = t.getAttribute('data-tour-tab');
                        if (name) activateTab(name);
                    });
                })(tabs[i]);
            }
        })();

        (function wireTourDomainEditor() {
            var canEditDomain = pingCanEditDomain();
            var els = {
                tabSub:           document.getElementById('tourEditDomainTabSub'),
                tabCustom:        document.getElementById('tourEditDomainTabCustom'),
                paneSub:          document.getElementById('tourEditDomainPaneSub'),
                paneCustom:       document.getElementById('tourEditDomainPaneCustom'),
                domainModeInput:  document.getElementById('tourEditFieldDomainMode'),
                slugInput:        document.getElementById('tourEditFieldSlug'),
                slugPip:          document.getElementById('tourEditSlugPip'),
                customDomain:     document.getElementById('tourEditFieldCustomDomain'),
                customDomainPip:  document.getElementById('tourEditCustomDomainPip'),
                domainCheckBtn:   document.getElementById('tourEditDomainCheckBtn'),
                domainCheckResult:document.getElementById('tourEditDomainCheckResult'),
                statusEl:         document.getElementById('tourEditDomainStatus'),
                domainReadonlyLink: document.getElementById('tourEditDomainReadonlyLink'),
            };
            if (canEditDomain) {
                if (!els.slugInput || !els.domainModeInput) return;
            } else if (!els.domainReadonlyLink) {
                return;
            }

            // Slim formState — only carries what the live-check
            // closures need. The save flow (Save Tour button) lives
            // in the wireTourEditTab1Save IIFE further down and
            // sources its originals from tourFocusState directly.
            var formState = {
                id:           null,
                originalSlug: '',
            };

            // ── State helpers ───────────────────────────────────────
            function setSlugPip(state) {
                if (!els.slugPip) return;
                els.slugPip.classList.remove('is-checking', 'is-ok', 'is-bad');
                if (state === 'checking') els.slugPip.classList.add('is-checking');
                else if (state === 'ok')  els.slugPip.classList.add('is-ok');
                else if (state === 'bad') els.slugPip.classList.add('is-bad');
            }
            function setCustomDomainPip(state) {
                if (!els.customDomainPip) return;
                els.customDomainPip.classList.remove('is-checking', 'is-ok', 'is-bad');
                if (state === 'checking') els.customDomainPip.classList.add('is-checking');
                else if (state === 'ok')  els.customDomainPip.classList.add('is-ok');
                else if (state === 'bad') els.customDomainPip.classList.add('is-bad');
            }
            function clearDomainCheckResult() {
                if (!els.domainCheckResult) return;
                els.domainCheckResult.textContent = '';
                els.domainCheckResult.className = 'gfe-domain-check-result';
            }
            function setDomainCheckResult(status, message) {
                if (!els.domainCheckResult) return;
                els.domainCheckResult.textContent = message || '';
                els.domainCheckResult.className = 'gfe-domain-check-result is-' + (status || 'unknown');
            }
            function setStatus(text, klass) {
                if (!els.statusEl) return;
                els.statusEl.textContent = text || '';
                els.statusEl.className = 'gfe-edit-domain-status' + (klass ? ' ' + klass : '');
            }
            function clearAllErrors() {
                var fields = document.querySelectorAll('#tourDetailModal .gfe-edit-field.has-error');
                for (var i = 0; i < fields.length; i++) {
                    fields[i].classList.remove('has-error');
                }
                var errs = document.querySelectorAll('#tourDetailModal [data-tour-edit-error]');
                for (var j = 0; j < errs.length; j++) {
                    errs[j].textContent = '';
                }
            }
            function setFieldError(fieldName, message) {
                var errEl = document.querySelector('#tourDetailModal [data-tour-edit-error="' + fieldName + '"]');
                if (!errEl) return;
                errEl.textContent = message;
                var parent = errEl.closest('.gfe-edit-field');
                if (parent) parent.classList.add('has-error');
            }

            // ── Domain mode toggle ──────────────────────────────────
            // Hidden input is the canonical truth; setDomainPane keeps
            // the tablist's aria-selected, the panes' [hidden] attr,
            // and the hidden input in sync. See setDomainPane in
            // wireGfeEditModal at ~line 3540 for the original.
            function setDomainPane(mode, userInitiated) {
                var next = (mode === 'custom') ? 'custom' : 'subdomain';
                els.domainModeInput.value = next;
                if (els.tabSub && els.tabCustom) {
                    var subActive = (next === 'subdomain');
                    els.tabSub.setAttribute('aria-selected',    subActive ? 'true' : 'false');
                    els.tabCustom.setAttribute('aria-selected', subActive ? 'false' : 'true');
                    els.tabSub.classList.toggle('is-active',    subActive);
                    els.tabCustom.classList.toggle('is-active', !subActive);
                }
                if (els.paneSub)    els.paneSub.hidden    = (next !== 'subdomain');
                if (els.paneCustom) els.paneCustom.hidden = (next !== 'custom');

                // On user-initiated switches, clear the inline status
                // pill so a stale "Slug taken" / "Available!" verdict
                // from the other pane doesn't carry over. The Save
                // button lives in wireTourEditTab1Save and gates
                // itself on its own validity check.
                if (userInitiated) {
                    setStatus('', '');
                }
            }

            if (canEditDomain) {
            if (els.tabSub) {
                els.tabSub.addEventListener('click', function (e) {
                    e.preventDefault();
                    setDomainPane('subdomain', true);
                });
            }
            if (els.tabCustom) {
                els.tabCustom.addEventListener('click', function (e) {
                    e.preventDefault();
                    setDomainPane('custom', true);
                    if (els.customDomain && els.customDomain.value.trim()) {
                        runCustomDomainCheck();
                    }
                });
            }

            // ── Slug availability (debounced) ───────────────────────
            // Same stale-response guard as runSlugCheck in
            // wireGfeEditModal so a fast typist doesn't see a flicker
            // from an in-flight earlier request resolving after a
            // newer one. No-change keeps the original slug → always OK.
            // Slug-availability live check. The pip icon (ok/bad/
            // checking) is the single source of truth surfaced to
            // the user — the Save Tour button (in wireTourEditTab1Save)
            // also reads window.tourEditSlugPipState on click and
            // refuses to submit when it's 'bad' so a server-side
            // race doesn't ship a known-taken slug.
            var slugCheckTimer = null;
            var slugCheckSeq   = 0;
            function runSlugCheck() {
                if (!els.slugInput) return;
                var slug = els.slugInput.value.trim().toLowerCase();
                if (!slug) {
                    setSlugPip('neutral');
                    window.tourEditSlugPipState = 'neutral';
                    return;
                }
                if (slug === formState.originalSlug) {
                    setSlugPip('ok');
                    window.tourEditSlugPipState = 'ok';
                    return;
                }
                if (slug.length < 2) {
                    setSlugPip('bad');
                    window.tourEditSlugPipState = 'bad';
                    return;
                }

                setSlugPip('checking');
                window.tourEditSlugPipState = 'checking';

                var mySeq = ++slugCheckSeq;
                var url = '/tours/check-slug'
                        + '?slug=' + encodeURIComponent(slug)
                        + '&exclude_id=' + encodeURIComponent(formState.id);
                fetch(url, {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { 'Accept': 'application/json' },
                }).then(function (r) {
                    return r.ok ? r.json() : { available: false };
                }).then(function (json) {
                    if (mySeq !== slugCheckSeq) return;
                    var available = !!(json && json.available);
                    setSlugPip(available ? 'ok' : 'bad');
                    window.tourEditSlugPipState = available ? 'ok' : 'bad';
                }).catch(function () {
                    if (mySeq !== slugCheckSeq) return;
                    setSlugPip('bad');
                    window.tourEditSlugPipState = 'bad';
                });
            }
            if (els.slugInput) {
                els.slugInput.addEventListener('input', function () {
                    clearTimeout(slugCheckTimer);
                    slugCheckTimer = setTimeout(runSlugCheck, 350);
                });
            }

            // ── Custom-domain availability (debounced) ──────────────
            // Same pattern as runSlugCheck — pip icon is the live
            // source of truth, Save Tour button consults
            // window.tourEditCustomDomainPipState to short-circuit
            // submission when known-taken.
            var domainCheckTimer = null;
            var domainCheckSeq   = 0;
            function runCustomDomainCheck() {
                if (!els.customDomain) return;
                var raw = els.customDomain.value.trim().toLowerCase();
                if (!raw) {
                    setCustomDomainPip('neutral');
                    window.tourEditCustomDomainPipState = 'neutral';
                    return;
                }
                if (raw.indexOf('.') < 0 || raw.length < 4) {
                    setCustomDomainPip('bad');
                    window.tourEditCustomDomainPipState = 'bad';
                    return;
                }

                setCustomDomainPip('checking');
                window.tourEditCustomDomainPipState = 'checking';

                var mySeq = ++domainCheckSeq;
                var url = '/tours/check-custom-domain'
                        + '?domain=' + encodeURIComponent(raw)
                        + '&exclude_id=' + encodeURIComponent(formState.id);
                fetch(url, {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { 'Accept': 'application/json' },
                }).then(function (r) {
                    return r.ok ? r.json() : { available: false };
                }).then(function (json) {
                    if (mySeq !== domainCheckSeq) return;
                    var available = !!(json && json.available);
                    setCustomDomainPip(available ? 'ok' : 'bad');
                    window.tourEditCustomDomainPipState = available ? 'ok' : 'bad';
                }).catch(function () {
                    if (mySeq !== domainCheckSeq) return;
                    setCustomDomainPip('bad');
                    window.tourEditCustomDomainPipState = 'bad';
                });
            }
            if (els.customDomain) {
                els.customDomain.addEventListener('input', function () {
                    clearTimeout(domainCheckTimer);
                    // Propagation result becomes meaningless the
                    // moment the user types a different hostname.
                    clearDomainCheckResult();
                    domainCheckTimer = setTimeout(runCustomDomainCheck, 350);
                });
            }

            // ── DNS propagation check ───────────────────────────────
            if (els.domainCheckBtn) {
                els.domainCheckBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (!formState.id) {
                        setDomainCheckResult('lookup_failed', 'Save your custom domain first, then check propagation.');
                        return;
                    }
                    var typed = els.customDomain ? els.customDomain.value.trim() : '';
                    if (!typed) {
                        setDomainCheckResult('lookup_failed', 'Enter a domain first.');
                        return;
                    }

                    els.domainCheckBtn.disabled = true;
                    els.domainCheckBtn.classList.add('is-loading');
                    setDomainCheckResult('checking', 'Checking DNS…');

                    var url = '/tours/' + encodeURIComponent(formState.id) + '/check-domain-propagation';
                    fetch(url, {
                        method: 'GET',
                        credentials: 'same-origin',
                        headers: { 'Accept': 'application/json' },
                    }).then(function (r) {
                        return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
                    }).then(function (result) {
                        els.domainCheckBtn.disabled = false;
                        els.domainCheckBtn.classList.remove('is-loading');

                        if (result.status === 422 && result.json && result.json.message) {
                            setDomainCheckResult('lookup_failed', result.json.message);
                            return;
                        }
                        if (result.status === 429) {
                            setDomainCheckResult('lookup_failed', 'Too many checks in a short time. Wait a minute and try again.');
                            return;
                        }
                        if (!result.ok || !result.json) {
                            setDomainCheckResult('lookup_failed', 'Could not run the DNS check right now.');
                            return;
                        }
                        var st  = result.json.status  || 'unknown';
                        var msg = result.json.message || '';
                        setDomainCheckResult(st, msg);
                    }).catch(function () {
                        els.domainCheckBtn.disabled = false;
                        els.domainCheckBtn.classList.remove('is-loading');
                        setDomainCheckResult('lookup_failed', 'Network error. Please try again.');
                    });
                });
            }
            } // canEditDomain

            // ── Save → handled by wireTourEditTab1Save ──────────────
            // The inline "Save Web Address" button was removed when
            // the modal was tabbed; saves now ride the unified
            // "Save Tour" footer button. The PATCH payload there
            // includes title + description in addition to the
            // web-address fields, and the slug-change cliff guard
            // is preserved verbatim there. See wireTourEditTab1Save
            // and refreshTourCardPayloadAfterSave below.

            // Expose the small-but-shared helpers (clearAllErrors,
            // setFieldError) so wireTourEditTab1Save can drive the
            // same per-field error UI without re-implementing it.
            window.tourEditClearAllErrors = clearAllErrors;
            window.tourEditSetFieldError  = setFieldError;
            window.tourEditSetSlugPip     = setSlugPip;

            // ── Open-time hydration entry point ─────────────────────
            // Called by showTourDetailModal each time a tour is
            // opened. Resets the form, fills inputs, picks the
            // initial pane based on custom_domain_active, and
            // snapshots originalSlug for the no-change OK path of
            // runSlugCheck.
            window.hydrateTourDomainEditor = function (data) {
                formState.id           = data.id != null ? data.id : null;
                formState.originalSlug = (data.slug || '').toLowerCase();

                if (canEditDomain) {
                    if (els.slugInput) {
                        els.slugInput.value = data.slug || '';
                    }
                    if (els.customDomain) {
                        els.customDomain.value = data.custom_domain || '';
                    }

                    var initialMode = (data.custom_domain && data.custom_domain_active)
                        ? 'custom'
                        : 'subdomain';
                    setDomainPane(initialMode, false);

                    setSlugPip('neutral');
                    setCustomDomainPip('neutral');
                    clearDomainCheckResult();
                    setStatus('', '');
                } else {
                    pingSetDomainReadonlyLink(els.domainReadonlyLink, data.slug || '');
                }

                window.tourEditSlugPipState         = 'neutral';
                window.tourEditCustomDomainPipState = 'neutral';
                clearAllErrors();
            };
        })();

        // ────────────────────────────────────────────────────────────────
        // wireTourEditTab1Save — unified Save Tour button (Tab 1)
        // --------------------------------------------------------------
        // PATCH /tours/{id} carrying:
        //   title, description, subdomain_slug, domain_mode, custom_domain
        //
        // The modal footer's #tourEditSaveBtn is the single save action
        // for everything inside Tab 1 (Edit Tour). #tourDetailSave
        // (Save Order) is Tab 2's save — they coexist in the footer
        // and CSS visibility is driven by the modal root's
        // data-active-tab so only one is shown at a time.
        //
        // Slug-change cliff guard mirrors the one removed from
        // wireTourDomainEditor verbatim — sourcing originalSlug,
        // isPublic, and completionCount from tourFocusState
        // (populated on modal open in showTourDetailModal).
        //
        // Field-level errors and the inline-pip live-check helpers
        // are shared with wireTourDomainEditor via window.tourEdit*
        // so we don't duplicate the per-field error DOM walking.
        // The footer status pill (#tourDetailStatus) is shared with
        // the Save Order flow's setSaveButtonState — we only flip
        // its data-state attribute + textContent here and let the
        // CSS keyed off data-state handle the colour/animation.
        // ──────────────────────────────────────────────────────────────
        (function wireTourEditTab1Save() {
            var canEditDomain = pingCanEditDomain();
            var els = {
                saveBtn:         document.getElementById('tourEditSaveBtn'),
                statusEl:        document.getElementById('tourDetailStatus'),
                titleInput:      document.getElementById('tourEditFieldTitle'),
                descTextarea:    document.getElementById('tourEditFieldDescription'),
                slugInput:       document.getElementById('tourEditFieldSlug'),
                customDomain:    document.getElementById('tourEditFieldCustomDomain'),
                domainModeInput: document.getElementById('tourEditFieldDomainMode'),
                tabSubBtn:       document.getElementById('tourEditDomainTabSub'),
                tabCustomBtn:    document.getElementById('tourEditDomainTabCustom'),
                // Owner-editable metadata fields. All optional —
                // missing inputs (e.g. on a tenant where the schema
                // pre-dates tour-metadata:init-tables and the blade
                // didn't render the fields, or a future trim of the
                // social set) safely degrade in readForm/baseline
                // because every access goes through `els.X &&` guards.
                phone:           document.getElementById('tourEditFieldPhone'),
                email:           document.getElementById('tourEditFieldEmail'),
                website:         document.getElementById('tourEditFieldWebsite'),
                bookingUrl:      document.getElementById('tourEditFieldBookingUrl'),
                durationMinutes: document.getElementById('tourEditFieldDurationMinutes'),
                instagram:       document.getElementById('tourEditFieldInstagram'),
                facebook:        document.getElementById('tourEditFieldFacebook'),
                tiktok:          document.getElementById('tourEditFieldTiktok'),
                youtube:         document.getElementById('tourEditFieldYoutube'),
            };
            if (!els.saveBtn || !els.titleInput || !els.descTextarea) return;

            // Tab 1's dirty-state baseline. Snapshotted on every
            // hydrate so re-opening the modal on a different tour
            // doesn't carry stale originals across. Metadata fields
            // are normalized to '' (or '' for duration_minutes) so
            // a hydrate that landed null/undefined doesn't immediately
            // count as dirty when the live readForm() returns ''.
            var baseline = {
                title:           '',
                description:     '',
                slug:            '',
                domainMode:      'subdomain',
                customDomain:    '',
                phone:           '',
                email:           '',
                website:         '',
                bookingUrl:      '',
                durationMinutes: '',
                instagram:       '',
                facebook:        '',
                tiktok:          '',
                youtube:         '',
            };

            function setFooterStatus(state, text) {
                if (!els.statusEl) return;
                if (state) els.statusEl.setAttribute('data-state', state);
                else       els.statusEl.removeAttribute('data-state');
                els.statusEl.textContent = text || '';
            }

            // Compute the live values + compare against baseline.
            // Used both by the input listeners (to flip the dirty
            // flag + Save button enable) and by the save handler
            // (to short-circuit if nothing actually changed).
            // Helper: read a value off an optional element without
            // tripping on null. Used for the metadata fields whose
            // inputs are only present on tenants where the blade
            // rendered them (i.e. the schema has the columns).
            function valOrEmpty(el) {
                return el ? (el.value == null ? '' : String(el.value)) : '';
            }

            function readForm() {
                return {
                    title:           (els.titleInput.value || '').trim(),
                    description:     els.descTextarea.value || '',
                    slug:            (els.slugInput ? els.slugInput.value || '' : '').trim().toLowerCase(),
                    domainMode:      els.domainModeInput ? (els.domainModeInput.value || 'subdomain') : 'subdomain',
                    customDomain:    (els.customDomain ? els.customDomain.value || '' : '').trim().toLowerCase(),
                    // Metadata: phone keeps internal whitespace
                    // (international formats use spaces); URLs and
                    // email get trimmed of leading/trailing
                    // whitespace; durationMinutes stays a string at
                    // this layer and is parseInt'd into the PATCH
                    // body below — keeps the dirty-compare correct
                    // when the user has typed e.g. "90 " (trailing
                    // space) vs. baseline "90".
                    phone:           valOrEmpty(els.phone).trim(),
                    email:           valOrEmpty(els.email).trim(),
                    website:         valOrEmpty(els.website).trim(),
                    bookingUrl:      valOrEmpty(els.bookingUrl).trim(),
                    durationMinutes: valOrEmpty(els.durationMinutes).trim(),
                    instagram:       valOrEmpty(els.instagram).trim(),
                    facebook:        valOrEmpty(els.facebook).trim(),
                    tiktok:          valOrEmpty(els.tiktok).trim(),
                    youtube:         valOrEmpty(els.youtube).trim(),
                };
            }
            function isDirty(snap) {
                return snap.title           !== baseline.title
                    || snap.description     !== baseline.description
                    || snap.slug            !== baseline.slug
                    || snap.domainMode      !== baseline.domainMode
                    || snap.customDomain    !== baseline.customDomain
                    || snap.phone           !== baseline.phone
                    || snap.email           !== baseline.email
                    || snap.website         !== baseline.website
                    || snap.bookingUrl      !== baseline.bookingUrl
                    || snap.durationMinutes !== baseline.durationMinutes
                    || snap.instagram       !== baseline.instagram
                    || snap.facebook        !== baseline.facebook
                    || snap.tiktok          !== baseline.tiktok
                    || snap.youtube         !== baseline.youtube;
            }
            function refreshDirtyState() {
                var snap = readForm();
                els.saveBtn.disabled = !isDirty(snap);
            }

            // Wire dirty-state listeners. The domain-tab buttons
            // also flip the hidden input via wireTourDomainEditor's
            // setDomainPane, so we listen on those clicks AFTER the
            // setDomainPane handler fires (microtask queue) to read
            // the post-toggle value.
            ['input', 'change'].forEach(function (evt) {
                els.titleInput.addEventListener(evt, refreshDirtyState);
                els.descTextarea.addEventListener(evt, refreshDirtyState);
                if (els.slugInput)    els.slugInput.addEventListener(evt, refreshDirtyState);
                if (els.customDomain) els.customDomain.addEventListener(evt, refreshDirtyState);
                // Metadata fields. Each is gated on existing in case
                // the blade is on an older tenant where the schema
                // pre-dates the metadata init and the fields weren't
                // rendered. (Currently the blade always renders them
                // — gating is defence-in-depth so a future tenant
                // gate doesn't NPE here.)
                if (els.phone)           els.phone.addEventListener(evt, refreshDirtyState);
                if (els.email)           els.email.addEventListener(evt, refreshDirtyState);
                if (els.website)         els.website.addEventListener(evt, refreshDirtyState);
                if (els.bookingUrl)      els.bookingUrl.addEventListener(evt, refreshDirtyState);
                if (els.durationMinutes) els.durationMinutes.addEventListener(evt, refreshDirtyState);
                if (els.instagram)       els.instagram.addEventListener(evt, refreshDirtyState);
                if (els.facebook)        els.facebook.addEventListener(evt, refreshDirtyState);
                if (els.tiktok)          els.tiktok.addEventListener(evt, refreshDirtyState);
                if (els.youtube)         els.youtube.addEventListener(evt, refreshDirtyState);
            });
            if (els.tabSubBtn)    els.tabSubBtn.addEventListener('click', function () { setTimeout(refreshDirtyState, 0); });
            if (els.tabCustomBtn) els.tabCustomBtn.addEventListener('click', function () { setTimeout(refreshDirtyState, 0); });

            els.saveBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if (els.saveBtn.disabled) return;

                var tourId = tourFocusState.currentTourId;
                if (tourId == null) return;

                var snap = readForm();
                if (!isDirty(snap)) return;

                // Server-side validation rules: title required, min 1.
                if (!snap.title) {
                    if (typeof window.tourEditClearAllErrors === 'function') window.tourEditClearAllErrors();
                    if (typeof window.tourEditSetFieldError === 'function') {
                        window.tourEditSetFieldError('title', 'Title is required.');
                    }
                    setFooterStatus('error', 'Save failed');
                    return;
                }

                if (canEditDomain) {
                    // Live-check pip short-circuit. If a debounced
                    // /check-slug or /check-custom-domain call has
                    // already declared the value taken, refuse to ship
                    // it (the server would reject too, but failing fast
                    // saves the round-trip and the "Save failed" flash).
                    if (snap.slug && snap.slug !== baseline.slug
                        && window.tourEditSlugPipState === 'bad') {
                        if (typeof window.tourEditSetFieldError === 'function') {
                            window.tourEditSetFieldError('subdomain_slug', 'This subdomain is already taken. Please choose another.');
                        }
                        setFooterStatus('error', 'Save failed');
                        return;
                    }
                    if (snap.domainMode === 'custom' && snap.customDomain
                        && snap.customDomain !== baseline.customDomain
                        && window.tourEditCustomDomainPipState === 'bad') {
                        if (typeof window.tourEditSetFieldError === 'function') {
                            window.tourEditSetFieldError('custom_domain', 'This custom domain is not available.');
                        }
                        setFooterStatus('error', 'Save failed');
                        return;
                    }

                    // Slug-change cliff guard. Identical to the one
                    // previously living in wireTourDomainEditor — fire
                    // the confirm() before submitting if the rename
                    // would orphan in-flight visitors. completionCount
                    // is captured on modal open in showTourDetailModal.
                    var originalSlug    = (tourFocusState.currentTourSlug || '').toLowerCase();
                    var isPublic        = !!tourFocusState.isPublic;
                    var completionCount = parseInt(tourFocusState.currentTourCompletionCount || 0, 10);
                    if (snap.slug && snap.slug !== originalSlug
                        && (isPublic || completionCount > 0)) {
                        var ok = window.confirm(
                            'Renaming will break "' + window.gfeSubdomainHost(originalSlug) + '" — '
                            + 'visitors who already opened that link will see a 404. '
                            + 'Continue?'
                        );
                        if (!ok) return;
                    }
                }

                if (typeof window.tourEditClearAllErrors === 'function') window.tourEditClearAllErrors();
                els.saveBtn.disabled = true;
                els.saveBtn.classList.add('is-saving');
                setFooterStatus('saving', 'Saving…');

                var csrfMeta = document.querySelector('meta[name="csrf-token"]');
                var csrf     = csrfMeta ? csrfMeta.getAttribute('content') : '';

                var body = {
                    title:         snap.title,
                    description:   snap.description,
                };
                if (canEditDomain) {
                    body.domain_mode   = snap.domainMode;
                    body.custom_domain = snap.customDomain;
                    // Always send subdomain_slug so the backend can
                    // decide rename vs. no-op. Empty string is allowed
                    // by the controller's "sometimes|nullable" rule.
                    if (snap.slug !== '') body.subdomain_slug = snap.slug;
                }

                // Metadata fields. Each is sent only when the input
                // exists in the DOM AND the value differs from
                // baseline — keeps the PATCH lean and means a tenant
                // whose schema pre-dates tour-metadata:init-tables
                // (and therefore didn't render the fields) doesn't
                // accidentally null-out anything. duration_minutes
                // gets an explicit Number conversion so the JSON
                // body sends an integer, not "90"; empty string maps
                // to null so the user can clear the value.
                function snapMaybe(elKey, snapKey, bodyKey) {
                    if (!els[elKey]) return;
                    if (snap[snapKey] === baseline[snapKey]) return;
                    body[bodyKey] = snap[snapKey] === '' ? null : snap[snapKey];
                }
                snapMaybe('phone',      'phone',      'phone');
                snapMaybe('email',      'email',      'email');
                snapMaybe('website',    'website',    'website');
                snapMaybe('bookingUrl', 'bookingUrl', 'booking_url');
                if (els.durationMinutes && snap.durationMinutes !== baseline.durationMinutes) {
                    if (snap.durationMinutes === '') {
                        body.duration_minutes = null;
                    } else {
                        var dm = parseInt(snap.durationMinutes, 10);
                        body.duration_minutes = isFinite(dm) ? dm : null;
                    }
                }
                snapMaybe('instagram', 'instagram', 'instagram_url');
                snapMaybe('facebook',  'facebook',  'facebook_url');
                snapMaybe('tiktok',    'tiktok',    'tiktok_url');
                snapMaybe('youtube',   'youtube',   'youtube_url');

                fetch('/tours/' + encodeURIComponent(tourId), {
                    method: 'PATCH',
                    credentials: 'same-origin',
                    headers: {
                        'Accept':           'application/json',
                        'Content-Type':     'application/json',
                        'X-CSRF-TOKEN':     csrf,
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify(body),
                }).then(function (resp) {
                    return resp.json().then(function (json) {
                        return { ok: resp.ok, status: resp.status, json: json };
                    });
                }).then(function (result) {
                    els.saveBtn.classList.remove('is-saving');

                    if (!result.ok || (result.json && result.json.status === 'error')) {
                        // Field-level error from the controller's
                        // {status, field, message} shape.
                        if (result.json && result.json.field && result.json.message
                            && typeof window.tourEditSetFieldError === 'function') {
                            window.tourEditSetFieldError(result.json.field, result.json.message);
                            setFooterStatus('error', 'Save failed');
                            els.saveBtn.disabled = false;
                            return;
                        }
                        // Laravel validator's {message, errors:{}}.
                        if (result.status === 422 && result.json && result.json.errors
                            && typeof window.tourEditSetFieldError === 'function') {
                            for (var f in result.json.errors) {
                                if (!Object.prototype.hasOwnProperty.call(result.json.errors, f)) continue;
                                var msgs = result.json.errors[f];
                                window.tourEditSetFieldError(f, Array.isArray(msgs) ? msgs[0] : String(msgs));
                            }
                            setFooterStatus('error', 'Save failed');
                            els.saveBtn.disabled = false;
                            return;
                        }
                        if (result.status === 409) {
                            setFooterStatus('error', 'Slug just taken — pick another.');
                            els.saveBtn.disabled = false;
                            return;
                        }
                        setFooterStatus('error', 'Save failed — try again.');
                        els.saveBtn.disabled = false;
                        return;
                    }

                    // Success. Tour body shape matches tourToArray
                    // — refresh local state + propagate the new
                    // title / description / slug / custom-domain
                    // status to the matching card in the importer.
                    var tour = (result.json && result.json.tour) ? result.json.tour : null;
                    if (tour) {
                        if (tour.slug != null) {
                            tourFocusState.currentTourSlug = tour.slug;
                            // Sync the slug pip so a no-change save
                            // doesn't leave the pip in a stale state.
                            if (typeof window.tourEditSetSlugPip === 'function') {
                                window.tourEditSetSlugPip('ok');
                            }
                            window.tourEditSlugPipState = 'ok';
                        }
                        if (tour.title != null)        tourFocusState.currentTourTitle       = tour.title;
                        if (tour.description != null)  tourFocusState.currentTourDescription = tour.description;
                        if (typeof refreshTourCardPayloadAfterSave === 'function') {
                            refreshTourCardPayloadAfterSave(tourId, tour);
                        }
                    }

                    // Re-snapshot baseline so the Save button
                    // disables itself + the next edit is what
                    // re-arms it.
                    baseline = readForm();
                    refreshDirtyState();

                    setFooterStatus('saved', 'Saved');
                    setTimeout(function () { setFooterStatus(null, ''); }, 2400);
                }).catch(function () {
                    els.saveBtn.classList.remove('is-saving');
                    els.saveBtn.disabled = false;
                    setFooterStatus('error', 'Network error.');
                });
            });

            // ── Hydration entry point ───────────────────────────────
            // Called by showTourDetailModal after the title +
            // description fields are filled. Snapshots the baseline
            // so the dirty-state tracker can compare against the
            // freshly-opened tour rather than the previously-open one.
            window.hydrateTourEditTab1 = function (data) {
                // Helper: pull a string off the payload, defaulting
                // to '' so the dirty-compare doesn't see null !== ''.
                function s(key) {
                    if (!data) return '';
                    var v = data[key];
                    if (v == null) return '';
                    return String(v).trim();
                }
                baseline = {
                    title:           (data && data.title) ? String(data.title).trim() : '',
                    description:     (data && data.description != null) ? String(data.description) : '',
                    slug:            canEditDomain && data && data.slug ? String(data.slug).trim().toLowerCase() : '',
                    domainMode:      canEditDomain && data && data.custom_domain && data.custom_domain_active ? 'custom' : 'subdomain',
                    customDomain:    canEditDomain && data && data.custom_domain ? String(data.custom_domain).trim().toLowerCase() : '',
                    phone:           s('phone'),
                    email:           s('email'),
                    website:         s('website'),
                    bookingUrl:      s('booking_url'),
                    durationMinutes: (data && data.duration_minutes != null) ? String(data.duration_minutes) : '',
                    instagram:       s('instagram_url'),
                    facebook:        s('facebook_url'),
                    tiktok:          s('tiktok_url'),
                    youtube:         s('youtube_url'),
                };
                els.saveBtn.disabled = true;
                els.saveBtn.classList.remove('is-saving');
                setFooterStatus(null, '');
            };
        })();

        // ────────────────────────────────────────────────────────────────
        // refreshTourCardPayloadAfterSave (extends the previous
        // refreshTourCardPayloadAfterDomainSave). Walks the importer's
        // Tours tab, finds the row for this tour, patches its
        // data-gfe-tour-payload + visible title + slug pill so the
        // next click hydrates with fresh values without a full
        // page refresh. Now also handles title + description sync
        // since the unified Tab 1 save can mutate them.
        // ──────────────────────────────────────────────────────────────
        function refreshTourCardPayloadAfterSave(tourId, tour) {
            var card = document.querySelector('li.gfe-loc-item.is-tour[data-gfe-tour-id="' + tourId + '"]');
            if (!card) return;

            var payload = null;
            try { payload = JSON.parse(card.getAttribute('data-gfe-tour-payload') || '{}'); }
            catch (e) { payload = {}; }
            if (tour.title != null)                      payload.title                = tour.title;
            if (tour.description !== undefined)          payload.description          = tour.description;
            if (tour.slug != null)                       payload.slug                 = tour.slug;
            if (tour.custom_domain !== undefined)        payload.custom_domain        = tour.custom_domain;
            if (tour.custom_domain_active !== undefined) payload.custom_domain_active = !!tour.custom_domain_active;
            if (tour.custom_domain_status !== undefined) payload.custom_domain_status = tour.custom_domain_status;
            if (tour.stop_count !== undefined)           payload.stop_count           = tour.stop_count;
            if (tour.route_distance_m !== undefined)     payload.route_distance_m     = tour.route_distance_m;
            if (tour.stops !== undefined)                payload.stops                = tour.stops;
            // Owner-editable metadata. None of these are visually
            // rendered on the card (per the "edit modal only" design
            // call), but the cached payload still has to track the
            // saved values so a close-then-reopen of the modal
            // hydrates with fresh values rather than the stale
            // pre-save snapshot. Each gates on `!== undefined` so
            // a server response that omits a field (e.g. a tenant
            // whose schema lacks the column) doesn't blow away an
            // existing payload entry.
            if (tour.phone !== undefined)            payload.phone            = tour.phone;
            if (tour.email !== undefined)            payload.email            = tour.email;
            if (tour.website !== undefined)          payload.website          = tour.website;
            if (tour.booking_url !== undefined)      payload.booking_url      = tour.booking_url;
            if (tour.duration_minutes !== undefined) payload.duration_minutes = tour.duration_minutes;
            if (tour.instagram_url !== undefined)    payload.instagram_url    = tour.instagram_url;
            if (tour.facebook_url !== undefined)     payload.facebook_url     = tour.facebook_url;
            if (tour.tiktok_url !== undefined)       payload.tiktok_url       = tour.tiktok_url;
            if (tour.youtube_url !== undefined)      payload.youtube_url      = tour.youtube_url;
            card.setAttribute('data-gfe-tour-payload', JSON.stringify(payload));

            // Visible title text on the card.
            var titleEl = card.querySelector('.gfe-loc-item-title');
            if (titleEl && tour.title != null) titleEl.textContent = String(tour.title);

            // Slug pill anchor + label.
            var slugAnchor = card.querySelector('a.gfe-loc-item-slug');
            var slugTxtEl  = card.querySelector('.gfe-loc-item-slug-text');
            var newSlug    = tour.slug || '';
            if (newSlug && slugTxtEl) {
                slugTxtEl.textContent = window.gfeSubdomainHost(newSlug);
            }
            if (newSlug && slugAnchor) {
                slugAnchor.href  = 'https://' + window.gfeSubdomainHost(newSlug);
                slugAnchor.title = window.gfeSubdomainHost(newSlug);
            }
        }
        if (typeof window !== 'undefined') {
            window.refreshTourCardPayloadAfterSave = refreshTourCardPayloadAfterSave;
        }

        // ────────────────────────────────────────────────────────────────
        // Helper — normalize a controller stops[] array (which uses
        // user_home_point_id) into the in-page tourFocusState.currentStops
        // shape (which uses home_point_id, matching the importer payload
        // wired in gamifeye-importer.blade.php). Centralized so Add and
        // Remove flows don't drift on the field-name translation.
        // ──────────────────────────────────────────────────────────────
        function normalizeServerStopsToFocus(stopsArr) {
            if (!Array.isArray(stopsArr)) return [];
            return stopsArr.map(normalizeTourStop).filter(Boolean);
        }

        // ────────────────────────────────────────────────────────────────
        // wireTourAddLocationPicker — Tab 2 "Add New Location" picker
        // --------------------------------------------------------------
        // Click #tourEditAddLocationBtn (in Tab 2) to open the
        // #tourEditAddLocationModal sibling overlay. On open we
        // GET /user-locations and filter out any UserHomePoint
        // already attached to this tour. Multi-select via checkboxes;
        // a live counter shows "X selected · room for Y more (cap 25
        // per tour)". "Add Selected" POSTs to /tours/{id}/stops
        // which appends the chosen ids, recomputes route_distance_m
        // + stop_count, and returns the refreshed tour payload. We
        // then re-render #tourDetailStopsList, update the hero pills,
        // re-init Sortable, reset the Save Order baseline, and sync
        // the matching tour card in the importer.
        // ──────────────────────────────────────────────────────────────
        (function wireTourAddLocationPicker() {
            var picker = document.getElementById('tourEditAddLocationModal');
            var triggerBtn = document.getElementById('tourEditAddLocationBtn');
            if (!picker || !triggerBtn) return;

            var els = {
                listEl:     document.getElementById('tourEditAddLocationList'),
                counterEl:  document.getElementById('tourEditAddLocationCounter'),
                errEl:      document.getElementById('tourEditAddLocationErr'),
                confirmBtn: document.getElementById('tourEditAddLocationConfirm'),
                subEl:      document.getElementById('tourEditAddLocationSub'),
            };

            var TOUR_STOP_CAP = 25;

            function htmlEsc(s) {
                return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
                    return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
                });
            }

            function setErr(text) {
                if (els.errEl) els.errEl.textContent = text || '';
            }

            function openPicker() {
                picker.hidden = false;
                picker.setAttribute('aria-hidden', 'false');
                document.body.style.overflow = 'hidden';
            }
            function closePicker() {
                picker.hidden = true;
                picker.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';
                setErr('');
                if (els.listEl) els.listEl.innerHTML = '';
                if (els.confirmBtn) {
                    els.confirmBtn.disabled = true;
                    els.confirmBtn.classList.remove('is-saving');
                }
            }

            // Clicks on the X button or the backdrop close the picker.
            // Bound on the picker root so injected nodes are covered.
            picker.addEventListener('click', function (e) {
                if (e.target.closest('[data-tour-add-loc-close]')) {
                    e.preventDefault();
                    closePicker();
                }
            });
            // Escape key closes when the picker is open.
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && !picker.hidden) closePicker();
            });

            function refreshCounter() {
                if (!els.counterEl) return;
                var checked = els.listEl ? els.listEl.querySelectorAll('input[type="checkbox"]:checked').length : 0;
                var current = (tourFocusState.currentStops || []).length;
                var capRoom = Math.max(0, TOUR_STOP_CAP - current);
                els.counterEl.textContent = checked + ' selected · room for ' + capRoom + ' more (cap ' + TOUR_STOP_CAP + ' per tour)';
                els.counterEl.classList.toggle('is-cap', capRoom === 0);
                if (els.confirmBtn) {
                    els.confirmBtn.disabled = (checked === 0 || checked > capRoom);
                }
            }

            function renderList(items) {
                if (!els.listEl) return;
                if (!items.length) {
                    els.listEl.innerHTML = '<div class="tour-add-loc-modal-empty">'
                        + 'No more locations to add — create one in the Locations tab, then come back.'
                        + '</div>';
                    refreshCounter();
                    return;
                }
                els.listEl.innerHTML = items.map(function (loc) {
                    var thumb = loc.logo_url
                        ? '<span class="tour-add-loc-row-thumb" style="background-image:url(\'' + htmlEsc(loc.logo_url).replace(/'/g, '%27') + '\');"></span>'
                        : '<span class="tour-add-loc-row-thumb"><i class="bi bi-geo-alt-fill"></i></span>';
                    return '<label class="tour-add-loc-row">'
                         +   '<input type="checkbox" value="' + htmlEsc(loc.id) + '" />'
                         +   thumb
                         +   '<span class="tour-add-loc-row-title">' + htmlEsc(loc.title || ('Location ' + loc.id)) + '</span>'
                         + '</label>';
                }).join('');
                refreshCounter();
            }

            // Delegated change listener — refreshes the counter
            // whenever any checkbox toggles.
            if (els.listEl) {
                els.listEl.addEventListener('change', function (e) {
                    if (e.target && e.target.type === 'checkbox') refreshCounter();
                });
            }

            triggerBtn.addEventListener('click', function () {
                if (triggerBtn.disabled) return;
                var current = (tourFocusState.currentStops || []).length;
                if (current >= TOUR_STOP_CAP) {
                    setErr('This tour already has the maximum of ' + TOUR_STOP_CAP + ' stops.');
                    return;
                }
                openPicker();
                if (els.listEl) {
                    els.listEl.innerHTML = '<div class="tour-add-loc-modal-loading">Loading your locations…</div>';
                }
                if (els.counterEl) els.counterEl.textContent = '';
                setErr('');

                fetch('/user-locations', {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { 'Accept': 'application/json' },
                }).then(function (r) {
                    return r.ok ? r.json() : { data: [] };
                }).then(function (json) {
                    var rows = (json && Array.isArray(json.data)) ? json.data : [];
                    // Filter out anything already in this tour. The
                    // tour's currentStops carries home_point_id; the
                    // /user-locations rows carry id (the
                    // UserHomePoint's primary key).
                    var inTourIds = {};
                    (tourFocusState.currentStops || []).forEach(function (s) {
                        if (s && s.home_point_id != null) inTourIds[String(s.home_point_id)] = true;
                    });
                    var eligible = rows.filter(function (loc) {
                        return loc && loc.id != null && !inTourIds[String(loc.id)];
                    });
                    renderList(eligible);
                }).catch(function () {
                    if (els.listEl) {
                        els.listEl.innerHTML = '<div class="tour-add-loc-modal-empty">Could not load your locations. Try again.</div>';
                    }
                    refreshCounter();
                });
            });

            if (els.confirmBtn) {
                els.confirmBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (els.confirmBtn.disabled) return;

                    var tourId = tourFocusState.currentTourId;
                    if (tourId == null) return;

                    var checked = els.listEl
                        ? Array.prototype.slice.call(els.listEl.querySelectorAll('input[type="checkbox"]:checked'))
                        : [];
                    var ids = checked.map(function (c) { return parseInt(c.value, 10); }).filter(function (n) { return n > 0; });
                    if (!ids.length) return;

                    var capRoom = Math.max(0, TOUR_STOP_CAP - (tourFocusState.currentStops || []).length);
                    if (ids.length > capRoom) {
                        setErr('You can only add ' + capRoom + ' more stop(s).');
                        return;
                    }

                    setErr('');
                    els.confirmBtn.disabled = true;
                    els.confirmBtn.classList.add('is-saving');

                    var csrfMeta = document.querySelector('meta[name="csrf-token"]');
                    var csrf     = csrfMeta ? csrfMeta.getAttribute('content') : '';

                    fetch('/tours/' + encodeURIComponent(tourId) + '/stops', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Accept':           'application/json',
                            'Content-Type':     'application/json',
                            'X-CSRF-TOKEN':     csrf,
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                        body: JSON.stringify({ location_ids: ids }),
                    }).then(function (r) {
                        return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
                    }).then(function (result) {
                        els.confirmBtn.classList.remove('is-saving');
                        if (!result.ok || !result.json || result.json.success === false) {
                            var err = (result.json && result.json.error) || 'Could not add stops. Please try again.';
                            var human = ({
                                stops_cap_exceeded: 'Adding those would exceed the ' + TOUR_STOP_CAP + '-stop cap.',
                                unowned_location_ids: 'One of those locations is not yours.',
                                already_in_tour: 'One of those locations is already in this tour.',
                            })[err] || ('Could not add stops (' + err + ').');
                            setErr(human);
                            els.confirmBtn.disabled = false;
                            return;
                        }
                        var tour = result.json.tour;
                        if (tour && Array.isArray(tour.stops)) {
                            tourFocusState.currentStops = normalizeServerStopsToFocus(tour.stops);
                        }
                        if (typeof rerenderTourStopsList === 'function')      rerenderTourStopsList();
                        if (typeof resetTourReorderBaseline === 'function')   resetTourReorderBaseline();
                        if (tour) {
                            tourFocusState.currentTourStopCount = parseInt(tour.stop_count, 10) || tourFocusState.currentStops.length;
                            if (typeof updateTourDetailPills === 'function') {
                                updateTourDetailPills(tour.stop_count, tour.route_distance_m);
                            }
                            syncTourDetailPublishBtn();
                        }
                        if (tour && typeof refreshTourCardPayloadAfterSave === 'function') {
                            refreshTourCardPayloadAfterSave(tourId, tour);
                        }
                        closePicker();
                    }).catch(function () {
                        els.confirmBtn.classList.remove('is-saving');
                        els.confirmBtn.disabled = false;
                        setErr('Network error. Please try again.');
                    });
                });
            }
        })();

        // ────────────────────────────────────────────────────────────────
        // wireTourRemoveStop — Tab 2 per-row Remove Stop handler
        // --------------------------------------------------------------
        // Delegated click handler on #tourDetailStopsList listens for
        // .tour-detail-stop-remove-btn clicks. confirm() then fires
        // DELETE /tours/{id}/stops/{stopId}. The backend rejects
        // when stop_count <= 2 (UserTour business rule), repacks the
        // remaining positions to 0..n-1 in a transaction, and
        // recomputes route_distance_m + stop_count. We mirror the
        // post-mutation flow used by Add Location: re-render the
        // stops list, re-init Sortable, reset the Save Order
        // baseline, update the hero pills, sync the tour card in
        // the importer.
        // ──────────────────────────────────────────────────────────────
        (function wireTourRemoveStop() {
            var listEl = document.getElementById('tourDetailStopsList');
            if (!listEl) return;
            var removeInFlight = false;

            listEl.addEventListener('click', function (e) {
                var btn = e.target.closest('.tour-detail-stop-remove-btn');
                if (!btn || !listEl.contains(btn)) return;
                e.preventDefault();
                e.stopPropagation();
                if (btn.disabled || removeInFlight) return;

                var stopId = parseInt(btn.getAttribute('data-stop-id') || '0', 10);
                var tourId = tourFocusState.currentTourId;
                if (!stopId || tourId == null) return;

                if ((tourFocusState.currentStops || []).length <= 2) return;

                var rowTitleEl = btn.closest('.tour-detail-stop-row') &&
                    btn.closest('.tour-detail-stop-row').querySelector('.tour-detail-stop-title');
                var rowTitle = rowTitleEl ? rowTitleEl.textContent : 'this stop';
                var ok = window.confirm('Remove "' + rowTitle + '" from this tour? You can add it back later from your locations.');
                if (!ok) return;

                removeInFlight = true;
                btn.disabled = true;

                var csrfMeta = document.querySelector('meta[name="csrf-token"]');
                var csrf     = csrfMeta ? csrfMeta.getAttribute('content') : '';

                fetch('/tours/' + encodeURIComponent(tourId) + '/stops/' + encodeURIComponent(stopId), {
                    method: 'DELETE',
                    credentials: 'same-origin',
                    headers: {
                        'Accept':           'application/json',
                        'X-CSRF-TOKEN':     csrf,
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }).then(function (r) {
                    return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
                }).then(function (result) {
                    removeInFlight = false;
                    if (!result.ok || !result.json || result.json.success === false) {
                        var err = (result.json && result.json.error) || 'unknown';
                        var human = ({
                            min_stops_required: 'Tours must have at least 2 stops. You can\'t remove this one.',
                            not_found:          'That stop no longer exists on this tour.',
                        })[err] || 'Could not remove this stop. Please try again.';
                        alert(human);
                        btn.disabled = false;
                        return;
                    }
                    var tour = result.json.tour;
                    if (tour && Array.isArray(tour.stops)) {
                        tourFocusState.currentStops = normalizeServerStopsToFocus(tour.stops);
                    }
                    if (typeof rerenderTourStopsList === 'function')    rerenderTourStopsList();
                    if (typeof resetTourReorderBaseline === 'function') resetTourReorderBaseline();
                    if (tour) {
                        tourFocusState.currentTourStopCount = parseInt(tour.stop_count, 10) || tourFocusState.currentStops.length;
                        if (typeof updateTourDetailPills === 'function') {
                            updateTourDetailPills(tour.stop_count, tour.route_distance_m);
                        }
                        syncTourDetailPublishBtn();
                    }
                    if (tour && typeof refreshTourCardPayloadAfterSave === 'function') {
                        refreshTourCardPayloadAfterSave(tourId, tour);
                    }
                }).catch(function () {
                    removeInFlight = false;
                    btn.disabled = false;
                    alert('Network error. Please try again.');
                });
            });
        })();

        // ────────────────────────────────────────────────────────────────
        // Tour-card click delegates — .gfe-loc-item.is-tour
        // --------------------------------------------------------------
        // Tours render as cards in the locations view above the
        // location cards (see gamifeye-importer.blade.php). Clicks
        // land here:
        //   • Card body  → pingLandingFocusOnTour (spin/fly + modal)
        //   • Pencil     → showTourDetailModal direct (no spin/fly)
        //   • Publish    → togglePublishForTour + propagate
        //   • Delete     → deleteTourById + remove card
        // All handlers are document-level + capture-phase so they
        // win against the generic .gfe-loc-item bubble handler in
        // gamifeye-importer.js (which would otherwise no-op on tour
        // cards because they have no lat/lng — we'd rather not even
        // race with it).
        // ──────────────────────────────────────────────────────────────
        (function wireTourCardDelegates() {
            document.querySelectorAll('li.gfe-loc-item.is-tour[data-gfe-tour-payload]').forEach(function (li) {
                try {
                    syncTourCardPublishChip(li, JSON.parse(li.getAttribute('data-gfe-tour-payload') || '{}'));
                } catch (e) { /* noop */ }
            });

            document.addEventListener('click', function (ev) {
                var target = ev.target;
                if (!target || !target.closest) return;

                // Pencil → open detail modal IMMEDIATELY (no globe
                // spin/fly). Decoupled from pingLandingFocusOnTour so
                // owners can edit a tour without sitting through the
                // 4-second flyTo every time.
                var pencil = target.closest('[data-gfe-tour-edit]');
                if (pencil) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    var pli = pencil.closest('li.gfe-loc-item.is-tour');
                    if (!pli) return;
                    var praw = pli.getAttribute('data-gfe-tour-payload');
                    if (!praw) return;
                    try {
                        var ppayload = JSON.parse(praw);
                        if (typeof showTourDetailModal === 'function') {
                            showTourDetailModal(ppayload);
                        }
                    } catch (e) { console.warn('[tour-card] pencil payload parse failed', e); }
                    return;
                }

                // Publish chip → toggle. The chip's [data-gfe-tour-publish]
                // is a flag, not an intent; we read the current
                // is_public from the card's payload and ask for the
                // opposite. propagateTourCoverToCards handles the UI
                // flip on success.
                var pubChip = target.closest('[data-gfe-tour-publish]');
                if (pubChip) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (pubChip.disabled) return;
                    var pbli = pubChip.closest('li.gfe-loc-item.is-tour');
                    if (!pbli) return;
                    var pbid = parseInt(pbli.getAttribute('data-gfe-tour-id') || '0', 10);
                    if (!pbid) return;
                    var pbraw = pbli.getAttribute('data-gfe-tour-payload');
                    var pbpayload = null;
                    try { pbpayload = JSON.parse(pbraw || '{}'); } catch (e2) {}
                    var wantPublic = !(pbpayload && pbpayload.is_public);
                    if (wantPublic && !tourIsReadyToPublish(pbpayload || {})) {
                        if (!tourHasEnoughStops(pbpayload || {})) {
                            alert('Add at least 2 stops before publishing.');
                        } else {
                            alert('Upload a cover image before publishing.');
                        }
                        return;
                    }
                    pubChip.disabled = true;
                    togglePublishForTour(pbid, wantPublic).then(function (body) {
                        pubChip.disabled = false;
                        var data = (body && body.tour) ? body.tour : { is_public: wantPublic };
                        if (typeof propagateTourCoverToCards === 'function') {
                            propagateTourCoverToCards(pbid, data);
                        }
                        // If the modal is open and showing this tour,
                        // sync its publish button too.
                        if (tourFocusState.currentTourId === pbid) {
                            tourFocusState.isPublic = !!wantPublic;
                            syncTourDetailPublishBtn();
                        }
                    }).catch(function (err) {
                        pubChip.disabled = false;
                        alert((err && err.body && err.body.error === 'slug_unavailable')
                            ? 'That subdomain is no longer available. Please create a new tour.'
                            : 'Could not update tour. Please try again.');
                    });
                    return;
                }

                // Delete chip → confirm + DELETE + remove card.
                var delChip = target.closest('[data-gfe-tour-delete]');
                if (delChip) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (delChip.disabled) return;
                    var dli = delChip.closest('li.gfe-loc-item.is-tour');
                    if (!dli) return;
                    var did = parseInt(dli.getAttribute('data-gfe-tour-id') || '0', 10);
                    if (!did) return;
                    var draw = dli.getAttribute('data-gfe-tour-payload');
                    var dpayload = null;
                    try { dpayload = JSON.parse(draw || '{}'); } catch (e3) {}
                    var dtitle = (dpayload && dpayload.title) ? dpayload.title : 'this tour';
                    if (!confirm('Delete "' + dtitle + '"? This cannot be undone.')) return;
                    delChip.disabled = true;
                    deleteTourById(did).then(function () {
                        // Remove the row we already have in hand —
                        // propagateTourCoverToCards() relies on
                        // querySelector and used to no-op silently when
                        // the selector missed (card stayed on screen).
                        if (dli && dli.parentNode) {
                            dli.parentNode.removeChild(dli);
                        } else if (typeof propagateTourCoverToCards === 'function') {
                            propagateTourCoverToCards(did, { _deleted: true });
                        }
                        // If the detail modal is open on the deleted
                        // tour, close it so the user isn't staring
                        // at a now-orphan modal.
                        if (tourFocusState.currentTourId === did) {
                            var closeBtn = document.getElementById('tourDetailClose');
                            tourFocusState.isDirty = false;
                            if (closeBtn) closeBtn.click();
                        }
                    }).catch(function () {
                        delChip.disabled = false;
                        alert('Could not delete tour. Please try again.');
                    });
                    return;
                }

                // Card body click → fly + open detail modal. Last so
                // chip clicks above don't cascade. closest() walks up
                // to the <li>, so a click anywhere outside the chips/
                // pencil counts as a body click.
                var card = target.closest('li.gfe-loc-item.is-tour[data-gfe-tour-payload]');
                if (card) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    var craw = card.getAttribute('data-gfe-tour-payload');
                    try {
                        var cpayload = JSON.parse(craw);
                        if (typeof window.pingLandingFocusOnTour === 'function') {
                            window.pingLandingFocusOnTour(cpayload);
                        }
                    } catch (e4) { console.warn('[tour-card] body payload parse failed', e4); }
                }
            }, true); // capture phase to beat bubble-phase handlers
        })();

        // Landing location cards — publish / delete chips (same capture
        // trick as tour cards so we beat gamifeye-importer.js bubble
        // handlers on the shared .gfe-loc-item list).
        (function wireLocationOwnerChips() {
            document.addEventListener('click', function (ev) {
                var target = ev.target;
                if (!target || !target.closest) return;

                var pubChip = target.closest('[data-gfe-loc-publish]');
                if (pubChip) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (pubChip.disabled) return;
                    var locLi = pubChip.closest('li.gfe-loc-item:not(.is-tour)');
                    if (!locLi) return;
                    var lid = parseInt(locLi.getAttribute('data-gfe-loc-id') || '0', 10);
                    if (!lid) return;
                    var raw = locLi.getAttribute('data-gfe-loc-payload');
                    var pl = null;
                    try { pl = JSON.parse(raw || '{}'); } catch (e0) {}
                    var wantPublic = !(pl && pl.is_public);
                    if (wantPublic && !locationIsReadyToPublish(pl)) {
                        alert('Upload a profile image and set stay duration (greater than 0) in Edit before publishing.');
                        return;
                    }
                    pubChip.disabled = true;
                    togglePublishForLocation(lid, wantPublic).then(function (body) {
                        pubChip.disabled = false;
                        var hp = (body && body.home_point) ? body.home_point : { is_public: wantPublic };
                        if (typeof propagateLocationPublishToCards === 'function') {
                            propagateLocationPublishToCards(lid, hp);
                        }
                    }).catch(function (err) {
                        pubChip.disabled = false;
                        var msg = 'Could not update location. Please try again.';
                        if (err && err.body) {
                            if (err.body.message) msg = err.body.message;
                            else if (err.body.error === 'slug_unavailable') msg = 'That subdomain cannot be activated — it conflicts with another page.';
                            else if (err.body.error === 'setup_incomplete') msg = err.body.message;
                        }
                        alert(msg);
                    });
                    return;
                }

                var delChip = target.closest('[data-gfe-loc-delete]');
                if (delChip) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (delChip.disabled) return;
                    var dLi = delChip.closest('li.gfe-loc-item:not(.is-tour)');
                    if (!dLi) return;
                    var did = parseInt(dLi.getAttribute('data-gfe-loc-id') || '0', 10);
                    if (!did) return;
                    var dRaw = dLi.getAttribute('data-gfe-loc-payload');
                    var dPl = null;
                    try { dPl = JSON.parse(dRaw || '{}'); } catch (e1) {}
                    var dtit = (dPl && dPl.title) ? dPl.title : 'this location';
                    if (!confirm('Delete "' + dtit + '"? This cannot be undone.')) return;
                    delChip.disabled = true;

                    // Optimistic remove: server-side userHomePointDestroy
                    // does a serial fan-out of bulk deletes against
                    // eyeland_area_hexes / eyeland_pois that can take
                    // minutes for a heavily-expanded focal point. The
                    // tour delete is sub-second (single row + MySQL
                    // CASCADE) which is why tour cards appear to vanish
                    // immediately. Detach the card now and re-insert
                    // in the same DOM slot if the DELETE actually fails.
                    var dParent      = dLi.parentNode;
                    var dNextSibling = dLi.nextSibling;
                    if (dParent) {
                        dParent.removeChild(dLi);
                    }

                    deleteLocationById(did).then(function () {
                        // Card is already gone. If a duplicate snuck
                        // back in via a re-render mid-flight, sweep it.
                        if (typeof propagateLocationPublishToCards === 'function') {
                            propagateLocationPublishToCards(did, { _deleted: true });
                        }
                    }).catch(function (err) {
                        if (dParent) {
                            // Re-insert at the original position so
                            // the user's list ordering is preserved.
                            if (dNextSibling && dNextSibling.parentNode === dParent) {
                                dParent.insertBefore(dLi, dNextSibling);
                            } else {
                                dParent.appendChild(dLi);
                            }
                        }
                        delChip.disabled = false;
                        var dm = 'Could not delete location. Please try again.';
                        if (err && err.body && err.body.message) dm = err.body.message;
                        alert(dm);
                    });
                    return;
                }
            }, true);
        })();

        // Build the HTML body of a stop row's details accordion.
        // The full location payload lives on the matching
        // <li.gfe-loc-item> in the Your Locations tab (same modal,
        // already rendered server-side) — we read it here rather
        // than duplicating every social/phone/email field onto
        // each tour stop's data-attr.
        //
        // Any empty field is silently skipped so descriptionless /
        // contact-less locations don't produce a body full of
        // empty rows.
        function renderStopAccordionBody(homePointId) {
            if (!homePointId) {
                return '<div class="tour-detail-stop-accordion-inner">'
                     +   '<div class="tour-detail-stop-detail-empty">No extra details available for this location.</div>'
                     + '</div>';
            }
            var selector = 'li.gfe-loc-item[data-gfe-loc-id="' + String(homePointId).replace(/"/g, '\\"') + '"]';
            var locLi = document.querySelector(selector);
            var payload = null;
            if (locLi) {
                var raw = locLi.getAttribute('data-gfe-loc-payload') || '';
                try { payload = JSON.parse(raw); } catch (e) { payload = null; }
            }
            if (!payload) {
                return '<div class="tour-detail-stop-accordion-inner">'
                     +   '<div class="tour-detail-stop-detail-empty">No extra details available for this location.</div>'
                     + '</div>';
            }

            var esc = function (s) {
                return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
                    return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
                });
            };
            // Normalise a user-entered URL: prefix https:// when
            // neither http:// nor https:// is present. Protects
            // href="example.com" from becoming a relative link.
            var normUrl = function (u) {
                if (!u) return '';
                var s = String(u).trim();
                if (!s) return '';
                if (!/^https?:\/\//i.test(s)) s = 'https://' + s;
                return s;
            };

            var html = '<div class="tour-detail-stop-accordion-inner">';

            // Description — narrative paragraph. Preserves newlines
            // via white-space: pre-wrap in the CSS.
            if (payload.description) {
                html += '<p class="tour-detail-stop-detail-desc">' + esc(payload.description) + '</p>';
            }

            // Category + rating meta strip. Rendered only when at
            // least one of the two is present.
            var hasCategory = !!payload.primary_category_display_name;
            var hasRating   = payload.rating != null && payload.rating !== '' && !isNaN(parseFloat(payload.rating));
            if (hasCategory || hasRating) {
                html += '<div class="tour-detail-stop-detail-meta">';
                if (hasCategory) {
                    html += '<span class="tour-detail-stop-detail-chip">'
                         +    '<i class="bi bi-tag-fill"></i> ' + esc(payload.primary_category_display_name)
                         + '</span>';
                }
                if (hasRating) {
                    var ratingTxt = parseFloat(payload.rating).toFixed(1);
                    var reviewStr = (payload.review_count && parseInt(payload.review_count, 10) > 0)
                        ? ' (' + parseInt(payload.review_count, 10) + ')'
                        : '';
                    html += '<span class="tour-detail-stop-detail-chip tour-detail-stop-detail-chip--rating">'
                         +    '<i class="bi bi-star-fill"></i> ' + esc(ratingTxt) + esc(reviewStr)
                         + '</span>';
                }
                html += '</div>';
            }

            // Contact rows: address / website / phone / email. Each
            // is its own row so screen readers announce them as
            // discrete items; links open in a new tab.
            var contactRows = '';
            if (payload.address) {
                contactRows += '<div class="tour-detail-stop-detail-row">'
                            +    '<i class="bi bi-geo-alt-fill"></i>'
                            +    '<span>' + esc(payload.address) + '</span>'
                            + '</div>';
            }
            if (payload.website) {
                var web = normUrl(payload.website);
                // Strip protocol + trailing slash for display only.
                var webDisplay = String(payload.website).replace(/^https?:\/\//i, '').replace(/\/$/, '');
                contactRows += '<div class="tour-detail-stop-detail-row">'
                            +    '<i class="bi bi-globe"></i>'
                            +    '<a href="' + esc(web) + '" target="_blank" rel="noopener">' + esc(webDisplay) + '</a>'
                            + '</div>';
            }
            if (payload.phone) {
                var telHref = 'tel:' + String(payload.phone).replace(/[^\d+]/g, '');
                contactRows += '<div class="tour-detail-stop-detail-row">'
                            +    '<i class="bi bi-telephone-fill"></i>'
                            +    '<a href="' + esc(telHref) + '">' + esc(payload.phone) + '</a>'
                            + '</div>';
            }
            if (payload.email) {
                contactRows += '<div class="tour-detail-stop-detail-row">'
                            +    '<i class="bi bi-envelope-fill"></i>'
                            +    '<a href="mailto:' + esc(payload.email) + '">' + esc(payload.email) + '</a>'
                            + '</div>';
            }
            // Subdomain — owned GamifEYE page at {slug}.gamifeye.com.
            if (payload.subdomain_slug) {
                var subUrl = 'https://' + window.gfeSubdomainHost(payload.subdomain_slug);
                contactRows += '<div class="tour-detail-stop-detail-row">'
                            +    '<i class="bi bi-globe2"></i>'
                            +    '<a href="' + esc(subUrl) + '" target="_blank" rel="noopener">' + esc(window.gfeSubdomainHost(payload.subdomain_slug)) + '</a>'
                            + '</div>';
            }
            // Place URL (Google Maps link) — tucked at the end of
            // the contact stack so it reads as "see on Google Maps".
            if (payload.place_url) {
                contactRows += '<div class="tour-detail-stop-detail-row">'
                            +    '<i class="bi bi-google"></i>'
                            +    '<a href="' + esc(payload.place_url) + '" target="_blank" rel="noopener">Open in Google Maps</a>'
                            + '</div>';
            }
            // Leave A Review — deep-links to Google's writereview
            // surface prefilled with the location's place id when
            // we have one (matches the star button on the public
            // subdomain page, see challenge-mission.blade.php).
            // Falls back to the generic place URL when place_id is
            // missing but place_url isn't, so either path still
            // lands the user on the right business profile.
            var reviewHref = '';
            if (payload.google_place_id) {
                reviewHref = 'https://search.google.com/local/writereview?placeid=' + encodeURIComponent(payload.google_place_id);
            } else if (payload.place_url) {
                reviewHref = payload.place_url;
            }
            if (reviewHref) {
                contactRows += '<div class="tour-detail-stop-detail-row">'
                            +    '<i class="bi bi-star-fill"></i>'
                            +    '<a href="' + esc(reviewHref) + '" target="_blank" rel="noopener">Leave A Review</a>'
                            + '</div>';
            }
            if (contactRows) {
                html += '<div class="tour-detail-stop-detail-rows">' + contactRows + '</div>';
            }

            // Socials — rendered only when at least one platform
            // link is present. Each is an icon button in a single
            // horizontal strip so multiple socials read as one set.
            var socials = [
                { key: 'facebook_url',  icon: 'bi-facebook',  label: 'Facebook'  },
                { key: 'instagram_url', icon: 'bi-instagram', label: 'Instagram' },
                { key: 'twitter_url',   icon: 'bi-twitter-x', label: 'X / Twitter' },
                { key: 'linkedin_url',  icon: 'bi-linkedin',  label: 'LinkedIn'  },
                { key: 'youtube_url',   icon: 'bi-youtube',   label: 'YouTube'   },
                { key: 'tiktok_url',    icon: 'bi-tiktok',    label: 'TikTok'    }
            ];
            var socialHtml = '';
            socials.forEach(function (s) {
                var url = payload[s.key];
                if (!url) return;
                var href = normUrl(url);
                socialHtml += '<a class="tour-detail-stop-social"'
                           +    ' href="' + esc(href) + '"'
                           +    ' target="_blank" rel="noopener"'
                           +    ' title="' + esc(s.label) + '"'
                           +    ' aria-label="' + esc(s.label) + '">'
                           +    '<i class="bi ' + s.icon + '"></i>'
                           + '</a>';
            });
            if (socialHtml) {
                html += '<div class="tour-detail-stop-detail-socials">' + socialHtml + '</div>';
            }

            // Final empty guard — if the location genuinely has no
            // details beyond the stuff already shown in the main
            // row (title/thumb/position), fall back to a muted
            // "nothing more to show" line so the accordion isn't
            // an empty box.
            if (html === '<div class="tour-detail-stop-accordion-inner">') {
                html += '<div class="tour-detail-stop-detail-empty">No extra details available for this location.</div>';
            }

            html += '</div>';
            return html;
        }

        // PATCH /tours/{id}/reorder handler. Only fires when the
        // list is actually dirty; extra public-tour confirm surfaces
        // the user-visible consequence ("changes go live at
        // {slug}.gamifeye.com") before committing.
        function submitTourReorder() {
            if (!tourFocusState.isDirty || tourFocusState.saveInFlight) return;
            var tourId = tourFocusState.currentTourId;
            if (!tourId) return;

            if (tourFocusState.isPublic) {
                var slug = tourFocusState.currentTourSlug || '';
                if (!confirm('This tour is public. Reordering will change the route visitors see at ' + window.gfeSubdomainHost(slug) + '. Continue?')) return;
            }

            var csrfMeta = document.querySelector('meta[name="csrf-token"]');
            var csrf     = csrfMeta ? csrfMeta.getAttribute('content') : '';
            var stopIds  = tourFocusState.currentStops.map(function (s) { return s.id; });

            tourFocusState.saveInFlight = true;
            setSaveButtonState('saving');

            fetch('/tours/' + tourId + '/reorder', {
                method: 'PATCH',
                credentials: 'same-origin',
                headers: {
                    'Content-Type':     'application/json',
                    'Accept':           'application/json',
                    'X-CSRF-TOKEN':     csrf,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({ stop_ids: stopIds })
            }).then(function (res) {
                return res.json().then(function (body) {
                    return { ok: res.ok, status: res.status, body: body };
                }).catch(function () {
                    return { ok: res.ok, status: res.status, body: null };
                });
            }).then(function (r) {
                tourFocusState.saveInFlight = false;
                if (!r.ok || !r.body || !r.body.success) {
                    setSaveButtonState('error');
                    return;
                }
                var fresh = r.body.tour || {};

                // Freeze the new order as the canonical "original"
                // so subsequent drags compute isDirty from the
                // updated baseline.
                tourFocusState.initialStopIds = tourFocusState.currentStops.map(function (s) {
                    return s.id;
                });
                tourFocusState.isDirty = false;

                // Distance pill — the server recomputed the route
                // distance on the new order, so mirror it into the
                // hero pill without reopening the modal.
                if (typeof fresh.route_distance_m === 'number') {
                    tourFocusState.currentTourDistanceM = fresh.route_distance_m;
                    var distancePill = document.getElementById('tourDetailDistancePill');
                    var distEl       = document.getElementById('tourDetailDistance');
                    if (distancePill && distEl) {
                        var km = fresh.route_distance_m / 1000;
                        if (km > 0) {
                            distEl.textContent = km.toFixed(1);
                            distancePill.style.display = '';
                        } else {
                            distancePill.style.display = 'none';
                        }
                    }
                }

                // Sync the originating <li> in the Tours tab so
                // re-opening the same tour reflects the new order
                // without a full refresh. Rebuild the compact
                // stops payload (positions 0..n) from fresh.stops.
                try {
                    var li = document.querySelector('li.gfe-tour-item[data-gfe-tour-id="' + tourId + '"]');
                    if (li && Array.isArray(fresh.stops)) {
                        var compact = fresh.stops.map(function (s) {
                            return {
                                id:            s.id,
                                position:      s.position,
                                // Keep home_point_id present so the
                                // chevron accordion on the next
                                // reopen can still find the matching
                                // <li.gfe-loc-item>.
                                home_point_id: s.user_home_point_id != null ? s.user_home_point_id : (s.home_point_id != null ? s.home_point_id : null),
                                title:         s.title || '',
                                logo_url:      s.logo_url || null,
                                lat:           s.lat != null ? parseFloat(s.lat) : null,
                                lng:           s.lng != null ? parseFloat(s.lng) : null
                            };
                        });
                        li.setAttribute('data-gfe-tour-stops', JSON.stringify(compact));
                        if (typeof fresh.route_distance_m === 'number') {
                            li.setAttribute('data-gfe-tour-distance-m', String(fresh.route_distance_m | 0));
                        }
                    }
                } catch (e) { console.warn('[tour-focus] li sync failed', e); }

                // The Tours tab re-fetches from /tours on
                // publish/delete rather than caching a tours array
                // in memory, so we only need to keep the <li>
                // attributes above in sync for the "reopen without
                // leaving the page" path — no further cache to
                // update here.

                setSaveButtonState('saved');
            }).catch(function () {
                tourFocusState.saveInFlight = false;
                setSaveButtonState('error');
            });
        }

        window.pingLandingFocusOnTour = function(data) {
            if (!data) return;
            // Guard against rapid double-clicks stacking concurrent
            // flyTo animations. Cleared on moveend, on close, or on
            // the hard-fallback timer below.
            if (tourFocusInFlight) return;

            var stops = Array.isArray(data.stops) ? data.stops.filter(function (s) {
                return s && isFinite(parseFloat(s.lat)) && isFinite(parseFloat(s.lng));
            }) : [];
            if (stops.length < 2) {
                // Degenerate tour (stops deleted / orphaned). Skip the map
                // fly but still open the edit modal so the owner can add
                // stops or delete the shell — a silent return made the
                // card feel completely dead.
                try {
                    if (typeof showTourDetailModal === 'function') {
                        showTourDetailModal(data);
                    }
                } catch (e) {
                    console.warn('[tour-focus] incomplete tour modal failed', e);
                }
                return;
            }
            // Normalise to numeric lat/lng so downstream math doesn't
            // have to cope with stringified values from the data-attr.
            // Preserve id (needed by the reorder save handler) and
            // coerce it to a number so future comparisons in
            // handleTourReorderEnd / submitTourReorder stay type-safe.
            stops = stops.map(function (s) {
                return {
                    id:            s.id != null ? parseInt(s.id, 10) : null,
                    position:      s.position,
                    home_point_id: s.home_point_id != null ? parseInt(s.home_point_id, 10)
                                 : (s.user_home_point_id != null ? parseInt(s.user_home_point_id, 10) : null),
                    title:         s.title,
                    logo_url:      s.logo_url,
                    lat:           parseFloat(s.lat),
                    lng:           parseFloat(s.lng)
                };
            });
            // Re-pack the normalised stops onto the payload so the
            // detail modal renders the same array the map is drawing.
            // cover_image_url is forwarded so showTourDetailModal can
            // hydrate .tour-detail-hero-img from it — the card-body
            // click delegate hands in the full payload (including the
            // cover URL) but this rebuild used to drop it on the floor.
            var tourData = {
                id:               data.id,
                slug:             data.slug,
                title:            data.title,
                description:      data.description || '',
                is_public:        !!data.is_public,
                route_distance_m: data.route_distance_m,
                stop_count:       data.stop_count,
                cover_image_url:  data.cover_image_url || null,
                facebook_url:     data.facebook_url || null,
                instagram_url:    data.instagram_url || null,
                twitter_url:      data.twitter_url || null,
                linkedin_url:     data.linkedin_url || null,
                youtube_url:      data.youtube_url || null,
                tiktok_url:       data.tiktok_url || null,
                stops:            stops
            };

            tourFocusInFlight = true;

            try { hideIntro(true); } catch(e) {}
            bindPingHeroFlyinData(tourData);
            if (!pickLocationHeroUrl(tourData) && bgImage) bgImage.classList.add('is-faded');
            autoSpin.active = false;
            if (fastSpinRaf) { try { cancelAnimationFrame(fastSpinRaf); } catch(e) {} fastSpinRaf = null; }

            try { if (map.dragPan)         map.dragPan.enable(); } catch(e) {}
            try { if (map.scrollZoom)      map.scrollZoom.enable(); } catch(e) {}
            try { if (map.touchZoomRotate) map.touchZoomRotate.enable(); } catch(e) {}
            try { if (map.doubleClickZoom) map.doubleClickZoom.enable(); } catch(e) {}
            try { if (map.keyboard)        map.keyboard.enable(); } catch(e) {}

            function flyAndPaint() {
                var detailFired = false;
                map.once('moveend', function () {
                    if (detailFired) return;
                    detailFired = true;
                    tourFocusInFlight = false;
                    setTimeout(function () {
                        try { showTourDetailModal(tourData); }
                        catch (err) { console.warn('[tour-focus] detail modal failed to open', err); }
                    }, 500);
                });
                // Hard fallback — if moveend never fires (flyTo
                // threw, browser throttled rAF, etc.) we still open
                // the modal and clear the in-flight guard after the
                // worst-case wall-clock window. 3500ms duration +
                // 500ms dwell + 600ms safety buffer.
                setTimeout(function () {
                    if (detailFired) return;
                    detailFired = true;
                    tourFocusInFlight = false;
                    try { showTourDetailModal(tourData); }
                    catch (err) { console.warn('[tour-focus] detail modal fallback failed', err); }
                }, 4600);

                var bounds = new maplibregl.LngLatBounds();
                stops.forEach(function (s) { bounds.extend([s.lng, s.lat]); });

                try {
                    map.fitBounds(bounds, {
                        padding: 80,
                        pitch: 45,
                        bearing: 0,
                        duration: 3500,
                        maxZoom: 15,
                        essential: true,
                        linear: false
                    });
                } catch(e) { console.warn('[tour-focus] fitBounds failed', e); }

                paintTourRouteAndMarkers(stops);
            }

            if (map.isStyleLoaded && map.isStyleLoaded()) {
                flyAndPaint();
            } else {
                var fired = false;
                var onReady = function() {
                    if (fired) return;
                    if (map.isStyleLoaded && !map.isStyleLoaded()) return;
                    fired = true;
                    map.off('styledata', onReady);
                    map.off('idle', onReady);
                    flyAndPaint();
                };
                map.on('styledata', onReady);
                map.on('idle', onReady);
                setTimeout(onReady, 2000);
            }
        };
        } // pingToursSectionEnabled
    })();
})();

/* ──────────────────────────────────────────────────────────────
   Targeting shopping cart (window.gfeCart)
   ──────────────────────────────────────────────────────────────
   Separate IIFE deliberately: the cart is a landing-page concern
   that lives outside the #townDetailModal IIFE because items can
   span multiple towns. It wires the floating #gfeTargetCart
   element to a minimal public API:

     window.gfeCart.addParent({areaId, areaName, category, ...})
     window.gfeCart.addSub   ({areaId, areaName, category, tag_key, tag_value, ...})
     window.gfeCart.remove(idx)
     window.gfeCart.clear()
     window.gfeCart.checkout()
     window.gfeCart.items  // current cart array

   Pricing is always a round-trip through /targets/preview so the
   UI never makes up lens costs client-side — if the server would
   charge 3 lenses, the cart must show 3 lenses.

   Concurrency: the cart is a plain client-side array; the real
   concurrency story (double-submit, insufficient balance) lives
   server-side in TownPoiTargetController::purchase(). Checkout
   temporarily flips data-state="submitting" which the CSS uses
   to disable interactions.
   ────────────────────────────────────────────────────────────── */
(function () {
    'use strict';

    // Expose a no-op stub immediately so legend rows rendered
    // before DOMContentLoaded still get a sane `window.gfeCart`
    // reference (they'll just silently queue their add calls).
    // The real implementation replaces this once the DOM is up.
    if (!window.gfeCart) {
        window.gfeCart = {
            items: [],
            addParent: function () { return Promise.reject(new Error('cart_not_ready')); },
            addSub:    function () { return Promise.reject(new Error('cart_not_ready')); },
            remove:    function () {},
            clear:     function () {},
            checkout:  function () { return Promise.reject(new Error('cart_not_ready')); }
        };
    }

    function ready(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }

    ready(function () {
        var root = document.getElementById('gfeTargetCart');
        if (!root) return; // guest users — no cart markup rendered

        var toggle   = document.getElementById('gfeTargetCartToggle');
        var collapse = document.getElementById('gfeTargetCartCollapse');
        var itemsEl  = document.getElementById('gfeTargetCartItems');
        var countEl  = document.getElementById('gfeTargetCartCount');
        var totalEl  = document.getElementById('gfeTargetCartTotal');
        var clearBtn = document.getElementById('gfeTargetCartClear');
        var coBtn    = document.getElementById('gfeTargetCartCheckout');
        var toastEl  = document.getElementById('gfeTargetCartToast');
        var panel    = document.getElementById('gfeTargetCartPanel');

        var items = [];  // each: { key, areaId, areaName, tier, category, categoryLabel, color, icon, tag_key, tag_value, subLabel, poi_count, lens_cost }

        function csrf() {
            var m = document.querySelector('meta[name="csrf-token"]');
            return m ? m.getAttribute('content') : '';
        }

        function keyOf(it) {
            return [it.areaId, it.tier, it.category, it.tag_key || '', it.tag_value || ''].join('|');
        }

        function total() {
            var t = 0;
            for (var i = 0; i < items.length; i++) t += (items[i].lens_cost || 0);
            return t;
        }

        function render() {
            var n = items.length;
            if (countEl) countEl.textContent = String(n);
            if (totalEl) totalEl.textContent = String(total());
            root.setAttribute('data-state', n === 0 ? 'empty' : 'populated');

            if (!itemsEl) return;
            itemsEl.innerHTML = '';
            items.forEach(function (it, idx) {
                var li = document.createElement('li');
                li.className = 'gfe-cart-item';

                var sw = document.createElement('span');
                sw.className = 'gfe-cart-item-swatch';
                sw.style.setProperty('--swatch-color', it.color || '#ff2bd6');
                var swi = document.createElement('i');
                swi.className = 'bi ' + (it.icon || 'bi-hexagon');
                swi.setAttribute('aria-hidden', 'true');
                sw.appendChild(swi);

                var text = document.createElement('span');
                text.className = 'gfe-cart-item-text';
                var title = document.createElement('span');
                title.className = 'gfe-cart-item-title';
                title.textContent = it.tier === 'subcategory'
                    ? (it.subLabel || it.tag_value)
                    : it.categoryLabel;
                var sub = document.createElement('span');
                sub.className = 'gfe-cart-item-sub';
                sub.textContent = (it.areaName ? it.areaName + ' · ' : '') +
                    (it.tier === 'subcategory' ? (it.categoryLabel + ' · ' + (it.poi_count || 0) + ' POIs')
                                               : (it.poi_count || 0) + ' POIs');
                text.appendChild(title);
                text.appendChild(sub);

                var cost = document.createElement('span');
                cost.className = 'gfe-cart-item-cost';
                var costNum = document.createElement('span');
                costNum.textContent = String(it.lens_cost || 0);
                var costIcon = document.createElement('i');
                costIcon.className = 'bi bi-eye-fill';
                costIcon.setAttribute('aria-hidden', 'true');
                cost.appendChild(costNum);
                cost.appendChild(costIcon);

                var rm = document.createElement('button');
                rm.type = 'button';
                rm.className = 'gfe-cart-item-remove';
                rm.setAttribute('aria-label', 'Remove from cart');
                rm.innerHTML = '<i class="bi bi-x-lg" aria-hidden="true"></i>';
                rm.addEventListener('click', function () { remove(idx); });

                li.appendChild(sw);
                li.appendChild(text);
                li.appendChild(cost);
                li.appendChild(rm);
                itemsEl.appendChild(li);
            });
        }

        function openPanel() {
            root.classList.add('is-open');
            if (panel) panel.hidden = false;
            if (toggle) toggle.setAttribute('aria-expanded', 'true');
        }
        function closePanel() {
            root.classList.remove('is-open');
            if (panel) panel.hidden = true;
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }

        function showToast(msg, isError) {
            if (!toastEl) return;
            toastEl.textContent = msg;
            toastEl.classList.toggle('is-error', !!isError);
            toastEl.hidden = false;
            setTimeout(function () {
                if (toastEl) toastEl.hidden = true;
            }, isError ? 5500 : 4000);
        }

        function alreadyInCart(k) {
            for (var i = 0; i < items.length; i++) {
                if (items[i].key === k) return true;
            }
            return false;
        }

        // Shared add flow. Handles server-side pricing preview,
        // ownership check, duplicate-in-cart guard, and panel
        // auto-open on the first successful add so users see
        // where their click went.
        function addInternal(payload) {
            var item = {
                areaId:         String(payload.areaId),
                areaName:       payload.areaName || '',
                tier:           payload.tier,
                category:       payload.category,
                categoryLabel:  payload.categoryLabel || payload.category,
                color:          payload.color || '#ff2bd6',
                icon:           payload.icon || 'bi-hexagon',
                tag_key:        payload.tag_key || '',
                tag_value:      payload.tag_value || '',
                subLabel:       payload.subLabel || ''
            };
            item.key = keyOf(item);

            if (alreadyInCart(item.key)) {
                showToast('Already in cart.', true);
                return Promise.resolve(false);
            }

            var url = '/towns/' + encodeURIComponent(item.areaId) + '/targets/preview';
            return fetch(url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type':'application/json',
                    'Accept':'application/json',
                    'X-CSRF-TOKEN': csrf()
                },
                body: JSON.stringify({
                    tier:      item.tier,
                    category:  item.category,
                    tag_key:   item.tag_key,
                    tag_value: item.tag_value
                })
            }).then(function (r) {
                return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
            }).then(function (resp) {
                if (!resp.ok) {
                    var err = (resp.json && resp.json.error) || 'preview_failed';
                    if (err === 'needs_scan') {
                        showToast('Scan this town first to unlock targeting.', true);
                    } else if (err === 'not_owner') {
                        showToast('You don\'t own this town.', true);
                    } else {
                        showToast('Could not price target: ' + err, true);
                    }
                    return false;
                }
                if (resp.json.already_owned) {
                    showToast('You already own this target.', true);
                    return false;
                }
                item.poi_count = resp.json.poi_count || 0;
                item.lens_cost = resp.json.lens_cost || 0;
                items.push(item);
                render();
                openPanel();
                return true;
            }, function () {
                showToast('Network error — try again.', true);
                return false;
            });
        }

        function remove(idx) {
            if (idx < 0 || idx >= items.length) return;
            items.splice(idx, 1);
            render();
        }

        function clearAll() {
            items = [];
            render();
        }

        function checkout() {
            if (!items.length) return Promise.resolve(false);

            // Group by areaId so we hit the per-town endpoint once
            // per town. A cart with items from 3 towns results in
            // 3 transactions; each is individually atomic.
            var buckets = {};
            items.forEach(function (it) {
                if (!buckets[it.areaId]) buckets[it.areaId] = [];
                buckets[it.areaId].push({
                    tier:      it.tier,
                    category:  it.category,
                    tag_key:   it.tag_key,
                    tag_value: it.tag_value
                });
            });

            root.setAttribute('data-state', 'submitting');
            if (coBtn) coBtn.disabled = true;

            var chain = Promise.resolve({ purchased: 0, debited: 0, failures: [] });
            Object.keys(buckets).forEach(function (areaId) {
                chain = chain.then(function (acc) {
                    var url = '/towns/' + encodeURIComponent(areaId) + '/targets/purchase';
                    return fetch(url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type':'application/json',
                            'Accept':'application/json',
                            'X-CSRF-TOKEN': csrf()
                        },
                        body: JSON.stringify({ items: buckets[areaId] })
                    }).then(function (r) {
                        return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
                    }).then(function (resp) {
                        if (resp.ok && resp.json) {
                            var purchased = (resp.json.purchased || []);
                            acc.purchased += purchased.length;
                            acc.debited   += (resp.json.total_cost || 0);
                            // Merge new targets into the canonical
                            // owned set so legend badges update
                            // immediately via gfe:targets-changed.
                            if (!Array.isArray(window.gfeOwnedTargets)) window.gfeOwnedTargets = [];
                            for (var i = 0; i < purchased.length; i++) {
                                window.gfeOwnedTargets.push(purchased[i]);
                            }
                        } else {
                            acc.failures.push({ areaId: areaId, status: resp.status, json: resp.json });
                        }
                        return acc;
                    }, function () {
                        acc.failures.push({ areaId: areaId, status: 0, json: null });
                        return acc;
                    });
                });
            });

            return chain.then(function (acc) {
                root.setAttribute('data-state', items.length ? 'populated' : 'empty');
                if (coBtn) coBtn.disabled = false;

                if (acc.purchased > 0) {
                    document.dispatchEvent(new CustomEvent('gfe:targets-changed'));
                }

                if (acc.failures.length === 0) {
                    showToast(acc.purchased + ' target' + (acc.purchased === 1 ? '' : 's') + ' purchased, ' + acc.debited + ' lens' + (acc.debited === 1 ? '' : 'es') + ' debited.');
                    clearAll();
                } else {
                    // Partial success: keep the failures in the cart
                    // so the user can retry without re-adding them.
                    var failedKeys = {};
                    acc.failures.forEach(function (f) {
                        // Rebuild a keyset from the failing town so
                        // we can drop only the succeeded items.
                        // Simpler heuristic: on total failure we keep
                        // everything, on any success we clear the
                        // known-owned ones via gfeOwnedTargets.
                        failedKeys[String(f.areaId)] = true;
                    });
                    // Drop items that are now owned (succeeded) but
                    // leave failed-town items where they are.
                    items = items.filter(function (it) {
                        var owned = (window.gfeOwnedTargets || []).some(function (t) {
                            return String(t.area_id) === it.areaId &&
                                   t.tier === it.tier &&
                                   t.category === it.category &&
                                   (t.tag_key || '') === it.tag_key &&
                                   (t.tag_value || '') === it.tag_value;
                        });
                        return !owned;
                    });
                    render();

                    var firstFailure = acc.failures[0];
                    var msg = 'Partial checkout';
                    if (firstFailure && firstFailure.json) {
                        if (firstFailure.json.error === 'insufficient_lenses') {
                            msg = 'Not enough lenses (need ' + firstFailure.json.required + ', have ' + firstFailure.json.lens_balance + ').';
                        } else if (firstFailure.json.error === 'already_owned') {
                            msg = 'Some targets were already owned — cart refreshed.';
                        } else if (firstFailure.json.error === 'needs_scan') {
                            msg = 'One or more towns need re-scanning before checkout.';
                        }
                    }
                    showToast(msg, true);
                }
                return acc;
            });
        }

        // Public API (replaces the early stub). Kept tiny — the
        // legend calls `addParent` / `addSub`, the panel calls
        // `remove` / `clear` / `checkout`.
        window.gfeCart = {
            get items() { return items.slice(); },
            total: total,
            addParent: function (p) {
                return addInternal({
                    areaId: p.areaId, areaName: p.areaName,
                    tier: 'category',
                    category: p.category, categoryLabel: p.categoryLabel,
                    color: p.color, icon: p.icon
                });
            },
            addSub: function (p) {
                return addInternal({
                    areaId: p.areaId, areaName: p.areaName,
                    tier: 'subcategory',
                    category: p.category, categoryLabel: p.categoryLabel,
                    color: p.color, icon: p.icon,
                    tag_key: p.tag_key, tag_value: p.tag_value,
                    subLabel: p.subLabel
                });
            },
            remove: remove,
            clear:  clearAll,
            checkout: checkout
        };

        if (toggle)   toggle.addEventListener('click', function () {
            if (root.classList.contains('is-open')) closePanel(); else openPanel();
        });
        if (collapse) collapse.addEventListener('click', closePanel);
        if (clearBtn) clearBtn.addEventListener('click', clearAll);
        if (coBtn)    coBtn.addEventListener('click', function () { checkout(); });

        render();
    });

    // ── Authed intro drawer header (optional) ──
    // When #spinHeroDrawerHeader exists, tapping toggles .is-drawer-closed
    // on the card. The header was removed from the intro blade; this
    // IIFE stays as a harmless no-op so a future strip can be re-wired
    // without hunting call sites.
    (function spinHeroDrawerInit() {
        var header = document.getElementById('spinHeroDrawerHeader');
        if (!header) return;
        var card = header.closest('.spin-card');
        if (!card) return;

        header.addEventListener('click', function () {
            var willClose = !card.classList.contains('is-drawer-closed');
            card.classList.toggle('is-drawer-closed', willClose);
            header.setAttribute('aria-expanded', willClose ? 'false' : 'true');
        });
    })();

    // ── Intro modal: collapse entire card (chevron on card) ──
    (function spinIntroModalToggleInit() {
        var btn = document.getElementById('spinIntroModalToggle');
        if (!btn) return;
        var card = document.getElementById('spinIntroCard');
        if (!card) return;

        function syncUi() {
            var collapsed = card.classList.contains('is-intro-modal-collapsed');
            var introModal = document.getElementById('spinIntroModal');
            if (introModal) {
                introModal.classList.toggle('is-intro-collapsed-bar', collapsed);
            }
            btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
            btn.title = collapsed
                ? (btn.getAttribute('data-title-collapsed') || '')
                : (btn.getAttribute('data-title-expanded') || '');
            if (typeof window.syncSpinIntroMergeDock === 'function') {
                window.syncSpinIntroMergeDock();
            }
        }

        function setIntroModalCollapsed(nextCollapsed) {
            if (!card.classList.contains('spin-intro-flyin-rest')) {
                card.classList.add('spin-intro-flyin-rest');
            }
            card.classList.toggle('is-intro-modal-collapsed', nextCollapsed);
            syncUi();
        }

        btn.addEventListener('click', function (e) {
            e.stopPropagation();
            setIntroModalCollapsed(!card.classList.contains('is-intro-modal-collapsed'));
        });
        /* Collapsed strip: hero + label use pointer-events:none so taps pass
           through — expand when the user hits anywhere on the thin card,
           not only the chevron (chevron stops propagation above). */
        card.addEventListener('click', function () {
            if (!card.classList.contains('is-drawer-layout')) return;
            if (!card.classList.contains('is-intro-modal-collapsed')) return;
            setIntroModalCollapsed(false);
        });
        syncUi();
    })();

    // ── Authed intro: N-slide horizontal carousel ──
    // Tracks which slide is centred, persists the choice in localStorage,
    // and restores it on init + every showIntro() re-open.
    (function spinIntroAuthedCarouselInit() {
        var viewport = document.getElementById('spinIntroAuthedCarouselViewport');
        if (!viewport) return;
        var STORAGE_KEY = 'spinIntroAuthedCarouselSlide';
        // Generalised over N slides (was hardcoded for 2). Slides come
        // from [data-spin-intro-slide], in DOM order — slide 1 is focal
        // points (demo), slide 2 is the live territories UI, slides 3+ are
        // other demo clones. Ordering matters because activeFromScroll() rounds
        // scrollLeft / clientWidth to an integer and we use it as the
        // 0-based slide index.
        var slides = Array.prototype.slice.call(
            viewport.querySelectorAll(
                '.spin-intro-authed-carousel-slide[data-spin-intro-slide]'
            )
        );
        if (slides.length < 1) return;

        if (viewport.getAttribute('data-territories-enabled') === '0') {
            try {
                var savedRaw = localStorage.getItem(STORAGE_KEY);
                if (savedRaw === '2') {
                    localStorage.removeItem(STORAGE_KEY);
                }
            } catch (e) {}
        }

        // data-spin-intro-slide is a stable CONTENT id (1 = focal points,
        // 2 = territories, 3 = routes), NOT a DOM position. Sections can be
        // toggled off in /administrator/settings/site, so the rendered slides may be a
        // non-contiguous subset (e.g. just [2,3] when focal points is off,
        // or [1,2] when routes is off). The carousel therefore navigates by
        // DOM POSITION and uses the content id only for identity (the active
        // marker, inert, localStorage, and the per-slide banner-pad sync that
        // keys off data-active-slide). idAt() maps a position -> content id;
        // posOf() maps a content id -> position (-1 if not rendered).
        function idAt(idx) {
            return slides[idx].getAttribute('data-spin-intro-slide');
        }
        function posOf(which) {
            for (var i = 0; i < slides.length; i++) {
                if (idAt(i) === String(which)) return i;
            }
            return -1;
        }

        function getSavedSlide() {
            try {
                var raw = localStorage.getItem(STORAGE_KEY);
                if (raw !== null && posOf(raw) >= 0) return raw;
            } catch (e) {}
            return idAt(0);
        }

        function saveSlide(which) {
            try {
                if (posOf(which) >= 0) {
                    localStorage.setItem(STORAGE_KEY, String(which));
                }
            } catch (e) {}
        }

        function setActive(which) {
            // Fall back to the first rendered slide if asked for a content id
            // that isn't on the page (e.g. a hardcoded setActive('1') call
            // when focal points is toggled off).
            var pos = posOf(which);
            if (pos < 0) { pos = 0; which = idAt(0); }
            viewport.setAttribute('data-active-slide', which);
            // data-can-prev/next are read by the chevron CSS — JS owns
            // the "is there a slide in this direction?" decision (by DOM
            // position) so the CSS doesn't need to enumerate slide numbers.
            viewport.setAttribute(
                'data-can-prev', pos > 0 ? 'true' : 'false'
            );
            viewport.setAttribute(
                'data-can-next', pos < slides.length - 1 ? 'true' : 'false'
            );
            // inert keeps off-screen slides out of the tab order and
            // ignored by screen readers. Only the active slide is
            // interactive at a time.
            slides.forEach(function (s) {
                if (s.getAttribute('data-spin-intro-slide') === which) {
                    s.removeAttribute('inert');
                } else {
                    s.setAttribute('inert', '');
                }
            });
            saveSlide(which);
            if (typeof window.syncSpinIntroMergeDock === 'function') {
                window.syncSpinIntroMergeDock();
            }
            if (typeof window.syncSpinIntroSlideBanner === 'function') {
                window.syncSpinIntroSlideBanner();
            }
            if (typeof window.syncPingMapBackdropFromCarousel === 'function') {
                window.syncPingMapBackdropFromCarousel();
            }
            if (typeof window.__jutdeeOnCarouselSlideActive === 'function') {
                window.__jutdeeOnCarouselSlideActive(which);
            }
        }
        viewport._spinIntroCarSetActive = setActive;

        var suppressScrollSync = false;

        function goToSlide(which, instant) {
            which = String(which);
            var pos = posOf(which);
            if (pos < 0) return false;

            suppressScrollSync = true;
            if (viewport._spinIntroCarT) {
                clearTimeout(viewport._spinIntroCarT);
                viewport._spinIntroCarT = null;
            }

            function doScroll(attempt) {
                attempt = attempt || 0;
                var slideEl = slides[pos];
                if (!slideEl) {
                    suppressScrollSync = false;
                    return;
                }
                var w = viewport.clientWidth;
                if (!(w > 0)) {
                    if (attempt < 32) {
                        requestAnimationFrame(function () {
                            doScroll(attempt + 1);
                        });
                    } else {
                        suppressScrollSync = false;
                    }
                    return;
                }
                var left = slideEl.offsetLeft;
                if (instant) {
                    viewport.scrollLeft = left;
                } else {
                    viewport.scrollTo({ left: left, behavior: 'smooth' });
                }
                setActive(which);
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        suppressScrollSync = false;
                    });
                });
            }
            doScroll(0);
            return true;
        }
        viewport._spinIntroCarGoTo = goToSlide;
        viewport._spinIntroCarScrollTo = scrollToSlide;
        viewport._spinIntroCarForceSlide = function (which) {
            which = String(which);
            var slideEl = viewport.querySelector(
                '.spin-intro-authed-carousel-slide[data-spin-intro-slide="' + which + '"]'
            );
            if (!slideEl) return false;

            suppressScrollSync = true;
            if (viewport._spinIntroCarT) {
                clearTimeout(viewport._spinIntroCarT);
                viewport._spinIntroCarT = null;
            }

            var w = viewport.clientWidth;
            if (!(w > 0)) return false;

            var prevSnap = viewport.style.scrollSnapType;
            viewport.style.scrollSnapType = 'none';
            viewport.scrollLeft = slideEl.offsetLeft;
            setActive(which);
            requestAnimationFrame(function () {
                viewport.style.scrollSnapType = prevSnap;
                requestAnimationFrame(function () {
                    suppressScrollSync = false;
                });
            });
            return true;
        };

        function scrollToSlide(which, instant) {
            var pos = posOf(which);
            if (pos < 0) return false;
            var w = viewport.clientWidth;
            if (!(w > 0)) {
                requestAnimationFrame(function () {
                    scrollToSlide(which, instant);
                });
                return true;
            }
            var left = slides[pos].offsetLeft;
            if (instant) {
                viewport.scrollLeft = left;
            } else {
                viewport.scrollTo({ left: left, behavior: 'smooth' });
            }
            setActive(which);
            return true;
        }

        viewport._spinIntroCarRestore = function () {
            goToSlide(getSavedSlide(), true);
        };

        function activeFromScroll() {
            var w = viewport.clientWidth;
            if (!(w > 0)) return idAt(0);
            var idx = Math.round(viewport.scrollLeft / w);
            if (idx < 0) idx = 0;
            if (idx > slides.length - 1) idx = slides.length - 1;
            return idAt(idx);
        }

        function onScrollSettled() {
            if (suppressScrollSync) return;
            setActive(activeFromScroll());
        }

        viewport.addEventListener('scrollend', onScrollSettled);
        viewport.addEventListener('scroll', function () {
            if (suppressScrollSync) return;
            if (viewport._spinIntroCarT) clearTimeout(viewport._spinIntroCarT);
            viewport._spinIntroCarT = setTimeout(onScrollSettled, 80);
        });

        // Prev / next chevrons (siblings of viewport, inside #spinIntroModal).
        // Click smooth-scrolls the viewport one slide in the requested
        // direction relative to the current active slide. CSS hides each
        // chevron when its direction is unavailable (via data-can-prev /
        // data-can-next, set in setActive()).
        var introModalEl = document.getElementById('spinIntroModal');
        if (introModalEl) {
            introModalEl.querySelectorAll('[data-spin-intro-nav]').forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    var dir = btn.getAttribute('data-spin-intro-nav');
                    var w = viewport.clientWidth;
                    if (!(w > 0)) return;
                    // Step by DOM position, not content id, so toggled-off
                    // (absent) sections don't leave gaps in the sequence.
                    var pos = posOf(viewport.getAttribute('data-active-slide'));
                    if (pos < 0) pos = 0;
                    var target = dir === 'next' ? pos + 1 : pos - 1;
                    if (target < 0) target = 0;
                    if (target > slides.length - 1) target = slides.length - 1;
                    viewport.scrollTo({
                        left: target * w,
                        behavior: 'smooth'
                    });
                });
            });
        }

        /* Apply saved slide before first paint so slide-2 merge chrome does
           not flash hidden (display:none) then pop in after rAF. */
        var initialSlide = getSavedSlide();
        setActive(initialSlide);
        requestAnimationFrame(function () {
            scrollToSlide(initialSlide, true);
        });
    })();

    // ── Demo-slide chevrons: each collapses ONLY its own card clone ──
    (function spinIntroSlideDemoToggleInit() {
        // Iterate every demo chevron — slides 2..N each have one.
        // Per-instance state means collapsing one demo never reflows
        // another, and never touches #spinIntroCard / #spinIntroModal
        // classes / syncSpinIntroMergeDock — purely visual.
        var toggles = document.querySelectorAll('[data-spin-intro-slide-demo-toggle]');
        toggles.forEach(function (btn) {
            var card = btn.closest('.spin-intro-card-clone');
            if (!card) return;

            function setCollapsed(next) {
                card.classList.toggle('is-intro-modal-collapsed', next);
                btn.setAttribute('aria-expanded', next ? 'false' : 'true');
                btn.title = next
                    ? (btn.getAttribute('data-title-collapsed') || '')
                    : (btn.getAttribute('data-title-expanded') || '');
            }

            btn.addEventListener('click', function (e) {
                e.stopPropagation();
                setCollapsed(!card.classList.contains('is-intro-modal-collapsed'));
            });
            // Tap anywhere on the collapsed strip expands it (mirrors
            // the live card's expand-on-click). The chevron's
            // stopPropagation above prevents double-toggles.
            card.addEventListener('click', function () {
                if (!card.classList.contains('is-intro-modal-collapsed')) return;
                setCollapsed(false);
            });
        });
    })();

    // ── Demo-slide eyes: open the existing "Add Location" modal ──
    // The cloned eye renders only on slide 1 (after the
    // showLocations gate in spin-intro-slide-demo.blade.php), so
    // there's no per-slide check here. The eye uses the shared
    // spin-globe-trigger inner partial which renders a
    // <button id="spinGlobeBtn"> — wrapping that in an <a> would be
    // invalid HTML (button-in-anchor) so we delegate via a click
    // handler on each wrapper instead. Capture phase beats any click
    // logic the (duplicate-id) inner buttons might inherit, and we
    // intercept clicks anywhere on the clone (chevron, eye, status).
    //
    // The click is forwarded to the FIRST [data-gfe-add-open] button
    // on the page — that's the "Add Location" CTA inside
    // .spin-intro-gfeimport (rendered by partials.gamifeye-importer
    // when userLocations is passed). Clicking it triggers the
    // existing addOpener handler in gamifeye-importer.js
    // (initImporter, L124), which calls openAddModal() to show
    // .gfe-add-modal.
    //
    // Why we move the modals to body-level first:
    // .gfe-add-modal is position:fixed; inset:0
    // (per public/css/gamifeye-importer.css ~L1340), but they're
    // rendered INSIDE .spin-intro-gfeimport, which is inside #spinIntroCard
    // — and #spinIntroCard has a permanent transform (see
    // public/css/ping-landing.css ~L279, transform:scale().
    // translateY(); plus the spinIntroFlyIn keyframes). A transformed
    // ancestor creates a containing block for position:fixed
    // descendants, so without this move the modal would be positioned
    // relative to the card's bounding box (off-screen when the user
    // is on slide 1 of the carousel) rather than the viewport.
    //
    // We move the modal element to a body-level <div class="gfe-importer">
    // host wrapper so the existing CSS selectors (all scoped under
    // .gfe-importer .gfe-add-modal*) still apply, but the containing
    // block becomes the viewport. The click listener attached during
    // initImporter() stays bound to the modal node — moving DOM nodes
    // preserves their event listeners — so openAddModal() / close
    // handlers / busy overlay all continue to work.
    //
    // Idempotent: subsequent eye clicks are no-ops on the move (the
    // modal is already body-level) and just trigger the button.
    //
    // At focal-point tier cap, [data-gfe-add-open] is omitted from the
    // importer — open the ping upgrades modal instead of /focal-points.
    function pingViewerIsAuthed() {
        var vp = document.getElementById('spinIntroAuthedCarouselViewport');
        if (vp) {
            return vp.getAttribute('data-viewer-authed') === '1';
        }
        var trigger = document.getElementById('spinGlobeTrigger');
        return !!(trigger && trigger.hasAttribute('data-free-spins-left'));
    }
    (function spinIntroSlideDemoEyeInit() {
        // Focal points are uncapped — no slot/tier gating. The eye and the
        // "+ Add Focal Point" tile always open the Add Location modal.
        function openAddLocationModal(e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            // NOTE: PL (the main IIFE's __pingL10n alias) is NOT in scope in
            // this IIFE — read the global directly or this throws a
            // ReferenceError before the modal ever opens.
            var l10n = window.__pingL10n || {};
            if (l10n.focalOnlyLanding && !pingViewerIsAuthed()) {
                if (typeof spinAuthOpen === 'function') {
                    var guestMount = document.getElementById('spinIntroGuestAuthMount');
                    var trigger = guestMount || document.body;
                    spinAuthOpen(trigger, 'register');
                }
                return;
            }
            // Focal points are uncapped — never route to the upgrade modal.
            // Always open the Add Location form.
            if (typeof window.ensureGfeModalsAtBody === 'function') {
                window.ensureGfeModalsAtBody();
            }
            if (typeof window.initGamifeyeImporters === 'function') {
                window.initGamifeyeImporters();
            }
            if (typeof window.openGfeAddLocationModal === 'function'
                && window.openGfeAddLocationModal()) {
                return;
            }
            var addBtn = document.querySelector('[data-gfe-add-open]');
            if (addBtn) {
                addBtn.click();
                return;
            }
            if (typeof window.revealGfeAddModal === 'function') {
                var modalEl = document.querySelector('[data-gfe-add-modal]');
                if (modalEl && window.revealGfeAddModal(modalEl)) {
                    return;
                }
            }
            if (typeof window.pingLandingShowToast === 'function') {
                window.pingLandingShowToast(
                    'Could not open the add-location form. Try again or visit Focal Points.',
                    5000
                );
            }
            window.location.href = '/focal-points?new=1';
        }
        window.openPingAddLocationModal = openAddLocationModal;
        function onFocalPointEyeActivate(e) {
            var eye = e.target && e.target.closest
                ? e.target.closest('.spin-globe-trigger--floating--clone:not(.is-create-route-cta)')
                : null;
            if (!eye || !eye.closest('#spinIntroAuthedCarouselViewport')) return;
            // Focal points are uncapped — the eye always opens the add form.
            openAddLocationModal(e);
        }
        function onEmptyFocalSlotActivate(e) {
            var slot = e.target && e.target.closest
                ? e.target.closest('[data-ping-fp-empty-slot]')
                : null;
            if (!slot || !slot.closest('#pingFpLocationsList')) return;
            openAddLocationModal(e);
        }
        var carViewport = document.getElementById('spinIntroAuthedCarouselViewport');
        if (carViewport && !carViewport.__focalEyeDelegated) {
            carViewport.__focalEyeDelegated = true;
            carViewport.addEventListener('click', onFocalPointEyeActivate, true);
        }
        // Document-level capture so SortableJS on .gfe-loc-list cannot
        // swallow taps on the empty-slot tile before our handler runs.
        if (!document.__pingEmptyFocalSlotDelegated) {
            document.__pingEmptyFocalSlotDelegated = true;
            document.addEventListener('click', onEmptyFocalSlotActivate, true);
            document.addEventListener('keydown', function (e) {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                onEmptyFocalSlotActivate(e);
            }, true);
        }
    })();

    (function spinIntroRouteSlotsInit() {
        var startBtn = document.getElementById('routeRecorderStartBtn');
        if (startBtn && !startBtn.__routeSlotsWired) {
            startBtn.__routeSlotsWired = true;
            startBtn.addEventListener('click', function (e) {
                if (startBtn.classList.contains('is-route-cap')) {
                    e.preventDefault();
                    e.stopPropagation();
                    openRouteUpgrade(e);
                }
            }, true);
        }

        function onEmptyRouteSlotActivate(e) {
            var slot = e.target && e.target.closest
                ? e.target.closest('[data-ping-fp-empty-route-slot]')
                : null;
            if (!slot || !slot.closest('#pingFpRoutesList')) return;
            e.preventDefault();
            e.stopPropagation();
            if ((slot.getAttribute('data-ping-fp-empty-route-slot-at-cap') === '1'
                || isRouteSlotCap()) && !window.pingSlotBankPending) {
                openRouteUpgrade(e);
                return;
            }
            if (window.RouteRecorder && typeof window.RouteRecorder.start === 'function') {
                window.RouteRecorder.start();
                return;
            }
            if (startBtn && !startBtn.classList.contains('is-route-cap')) {
                startBtn.click();
            }
        }

        var routesList = document.getElementById('pingFpRoutesList');
        if (routesList && !routesList.__emptyRouteSlotDelegated) {
            routesList.__emptyRouteSlotDelegated = true;
            routesList.addEventListener('click', onEmptyRouteSlotActivate, true);
            routesList.addEventListener('keydown', function (e) {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                var slot = e.target.closest('[data-ping-fp-empty-route-slot]');
                if (!slot) return;
                e.preventDefault();
                onEmptyRouteSlotActivate(e);
            });
        }
    })();

    // ── Territory slide-2 daily Aura collect ─────────────────────────
    (function initTerritoryDailyAura() {
        var cfg = window.PING_TERRITORY_AURA || {};
        var csrfEl = document.querySelector('meta[name="csrf-token"]');
        var csrfTok = csrfEl ? csrfEl.getAttribute('content') : '';

        function formatAmount(n) {
            var v = parseInt(n, 10) || 0;
            try {
                return v.toLocaleString();
            } catch (e) {
                return String(v);
            }
        }

        /** Slide-2 tile badge: whole km²/Aura unless rounded value is 0, then 1 decimal. */
        function formatTerritoryBadgeKm2(km2) {
            var n = parseFloat(km2);
            if (!isFinite(n) || n <= 0) return '';
            var rounded = Math.round(n);
            if (rounded === 0) {
                try {
                    return n.toLocaleString(undefined, {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1
                    });
                } catch (e) {
                    return n.toFixed(1);
                }
            }
            return formatAmount(rounded);
        }

        function toastAuraAwarded(amount) {
            if (typeof window.pingLandingShowToast !== 'function') return;
            var tmpl = cfg.toastAura || '+:amount Aura';
            window.pingLandingShowToast(
                tmpl.replace(':amount', formatAmount(amount)),
                3500
            );
        }

        function toastError(key, fallback) {
            if (typeof window.pingLandingShowToast !== 'function') return;
            window.pingLandingShowToast(cfg[key] || fallback, 4000);
        }

        function pad2(n) {
            return (n < 10 ? '0' : '') + n;
        }

        function parseIsoMs(iso) {
            if (!iso) return NaN;
            var ms = Date.parse(iso);
            if (isFinite(ms)) return ms;
            ms = Date.parse(String(iso).replace(' ', 'T'));
            return ms;
        }

        /** Next local midnight — aligned with free-spin expiry. */
        function computeNextAvailableIso() {
            if (typeof window.pingLandingMidnightIso === 'function') {
                return window.pingLandingMidnightIso();
            }
            var tz = (cfg && cfg.userTimezone) || (window.__pingL10n && window.__pingL10n.userTimezone) || 'UTC';
            var now = new Date();
            var parts;
            try {
                parts = new Intl.DateTimeFormat('en-US', {
                    timeZone: tz,
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: false,
                }).formatToParts(now);
            } catch (e) {
                parts = new Intl.DateTimeFormat('en-US', {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: false,
                }).formatToParts(now);
            }
            var hour = 0;
            var minute = 0;
            var second = 0;
            parts.forEach(function (p) {
                if (p.type === 'hour') hour = parseInt(p.value, 10) % 24;
                if (p.type === 'minute') minute = parseInt(p.value, 10);
                if (p.type === 'second') second = parseInt(p.value, 10);
            });
            var elapsed = hour * 3600 + minute * 60 + second;
            var secs = Math.max(0, 86400 - elapsed);
            return new Date(Date.now() + secs * 1000).toISOString();
        }

        function midnightCountdownMs() {
            if (typeof window.pingLandingSecondsUntilLocalMidnight === 'function') {
                return window.pingLandingSecondsUntilLocalMidnight() * 1000;
            }
            var iso = computeNextAvailableIso();
            var ms = parseIsoMs(iso) - Date.now();
            return Math.max(0, ms);
        }

        function openNewDayTerritoryAura(card) {
            if (!card) return;
            if (card.getAttribute('data-daily-aura-collectible') === '1'
                && card.getAttribute('data-daily-aura-collected') !== '1') {
                applyCollectibleChrome(card);
                scheduleExpiry(card);
                return;
            }
            releaseCollectedState(card);
            card.setAttribute('data-daily-aura-collected', '0');
            var amount = parseInt(card.getAttribute('data-daily-aura-amount') || '0', 10) || 0;
            if (amount < 1 || card.getAttribute('data-subscription-locked') === '1') {
                return;
            }
            var nextIso = computeNextAvailableIso();
            card.setAttribute('data-daily-aura-collectible', '1');
            if (nextIso) {
                card.setAttribute('data-daily-aura-expires-at', nextIso);
            }
            applyCollectibleChrome(card);
            scheduleExpiry(card);
        }

        function ensureNextAtOnCard(card) {
            var iso = card.getAttribute('data-daily-aura-next-at') || '';
            if (isFinite(parseIsoMs(iso)) && parseIsoMs(iso) > Date.now()) return iso;
            var computed = computeNextAvailableIso();
            if (computed) {
                card.setAttribute('data-daily-aura-next-at', computed);
                return computed;
            }
            return iso;
        }

        function restoreKm2Badge(card) {
            var badge = card.querySelector('.ping-fp-slide2-town-badge');
            var km2 = card.getAttribute('data-area-km2') || '';
            var km2n = parseFloat(km2);
            if (badge) {
                badge.classList.remove('ping-fp-slide2-town-badge--collectible');
                if (isFinite(km2n) && km2n > 0) {
                    badge.textContent = formatTerritoryBadgeKm2(km2n);
                }
            }
        }

        function removeCollectButton(card) {
            if (!card) return;
            var btn = card.querySelector('[data-territory-collect-btn]');
            if (btn) btn.remove();
            card.classList.remove('ping-fp-slide2-town-item--fly-blocked');
        }

        function ensureCollectButton(card) {
            if (!card || card.querySelector('[data-territory-collect-btn]')) return;
            var amount = parseInt(card.getAttribute('data-daily-aura-amount') || '0', 10) || 0;
            if (amount < 1) return;
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ping-fp-slide2-town-collect-btn';
            btn.setAttribute('data-territory-collect-btn', '');
            btn.setAttribute('aria-label', 'Collect ' + formatAmount(amount) + ' Aura');
            var label = document.createElement('span');
            label.className = 'ping-fp-slide2-town-collect-btn-label';
            label.textContent = cfg.collectBtnLabel || 'Collect';
            var amt = document.createElement('span');
            amt.className = 'ping-fp-slide2-town-collect-btn-amount';
            amt.textContent = formatAmount(amount);
            btn.appendChild(label);
            btn.appendChild(amt);
            card.appendChild(btn);
            card.classList.add('ping-fp-slide2-town-item--fly-blocked');
            if (card.getAttribute('href')) card.setAttribute('href', '#');
        }

        function applyCollectedState(card, nextAtIso) {
            if (!card) return;
            card.setAttribute('data-daily-aura-collectible', '0');
            card.setAttribute('data-daily-aura-collected', '1');
            if (nextAtIso) card.setAttribute('data-daily-aura-next-at', nextAtIso);
            card.classList.remove('ping-fp-slide2-town-item--aura-ready');
            card.classList.add('ping-fp-slide2-town-item--aura-collected');
            removeCollectButton(card);
            restoreKm2Badge(card);
        }

        function releaseCollectedState(card) {
            if (!card) return;
            card.classList.remove('ping-fp-slide2-town-item--aura-collected');
            card.removeAttribute('data-daily-aura-next-at');
            var ov = card.querySelector('.ping-fp-slide2-town-aura-wait');
            if (ov) ov.remove();
            restoreKm2Badge(card);
        }

        function applyCollectibleChrome(card) {
            if (!card || card.getAttribute('data-daily-aura-collectible') !== '1') return;
            card.classList.add('ping-fp-slide2-town-item--aura-ready', 'ping-fp-slide2-town-item--fly-blocked');
            if (card.getAttribute('href')) card.setAttribute('href', '#');
            var amount = parseInt(card.getAttribute('data-daily-aura-amount') || '0', 10) || 0;
            var badge = card.querySelector('.ping-fp-slide2-town-badge');
            if (badge && amount > 0) {
                badge.classList.add('ping-fp-slide2-town-badge--collectible');
                badge.textContent = formatAmount(amount);
            }
            ensureCollectButton(card);
        }

        function isTownFlyBlocked(card) {
            if (!card) return false;
            return card.getAttribute('data-daily-aura-collectible') === '1'
                || card.classList.contains('ping-fp-slide2-town-item--aura-ready')
                || card.classList.contains('ping-fp-slide2-town-item--fly-blocked');
        }

        /** Align greyscale/countdown DOM with data-* (fixes stale HTML after admin reset). */
        function syncCollectedDomFromAttrs(card) {
            if (!card) return;
            if (card.getAttribute('data-daily-aura-collected') === '1') {
                card.classList.add('ping-fp-slide2-town-item--aura-collected');
                card.classList.remove('ping-fp-slide2-town-item--aura-ready');
                ensureNextAtOnCard(card);
                return;
            }
            releaseCollectedState(card);
            card.classList.remove('ping-fp-slide2-town-item--aura-ready');
            if (card.getAttribute('data-daily-aura-collectible') === '1') {
                applyCollectibleChrome(card);
            }
        }

        function tickAuraWaitOverlays() {
            var left = midnightCountdownMs();
            if (left <= 0) {
                if (typeof window.pingLandingRefreshSpinExpiry === 'function') {
                    window.pingLandingRefreshSpinExpiry();
                } else {
                    document.querySelectorAll(
                        '#gfeTownsList .ping-fp-slide2-town-item'
                    ).forEach(openNewDayTerritoryAura);
                }
            } else {
                document.querySelectorAll(
                    '#gfeTownsList .ping-fp-slide2-town-item--aura-collected'
                ).forEach(function (card) {
                    ensureNextAtOnCard(card);
                });
            }
        }

        var auraWaitTickTimer = null;
        function startAuraWaitTicker() {
            tickAuraWaitOverlays();
            if (auraWaitTickTimer) return;
            auraWaitTickTimer = setInterval(tickAuraWaitOverlays, 1000);
        }

        function scheduleExpiry(card) {
            var iso = card.getAttribute('data-daily-aura-expires-at') || '';
            if (!iso) return;
            var exp = Date.parse(iso);
            if (!isFinite(exp)) return;
            var delay = exp - Date.now();
            if (delay <= 0) {
                if (card.getAttribute('data-daily-aura-collectible') === '1') {
                    card.setAttribute('data-daily-aura-collectible', '0');
                    card.classList.remove('ping-fp-slide2-town-item--aura-ready', 'ping-fp-slide2-town-item--fly-blocked');
                    removeCollectButton(card);
                    restoreKm2Badge(card);
                }
                return;
            }
            setTimeout(function () {
                if (card.getAttribute('data-daily-aura-collectible') === '1') {
                    card.setAttribute('data-daily-aura-collectible', '0');
                    card.classList.remove('ping-fp-slide2-town-item--aura-ready', 'ping-fp-slide2-town-item--fly-blocked');
                    removeCollectButton(card);
                    restoreKm2Badge(card);
                }
            }, delay + 50);
        }

        function buildTownFlyPayload(card) {
            var areaId = card.getAttribute('data-eyeland-area-id') || '';
            return {
                id:              card.getAttribute('data-id') || '',
                eyeland_area_id: areaId,
                area_slug:       card.getAttribute('data-area-slug') || '',
                area_lat:        card.getAttribute('data-area-lat') || '',
                area_lng:        card.getAttribute('data-area-lng') || '',
                name:            card.getAttribute('data-name') || '',
                country:         card.getAttribute('data-country') || '',
                country_code:    card.getAttribute('data-country-code') || '',
                area_km2:        card.getAttribute('data-area-km2') || '',
                daily_aura_amount: card.getAttribute('data-daily-aura-amount') || '',
                population:      card.getAttribute('data-population') || '',
                level:           card.getAttribute('data-level') || '',
                reward:          card.getAttribute('data-reward') || '',
                hex_count:       card.getAttribute('data-hex-count') || '',
                thumbnail:       card.getAttribute('data-thumbnail') || '',
                extract:         card.getAttribute('data-extract') || '',
                wiki_url:        card.getAttribute('data-wiki-url') || '',
                total_claims:    card.getAttribute('data-total-claims') || '',
                unique_visitors: card.getAttribute('data-unique-visitors') || '',
                boundary:        null
            };
        }

        function flyToTownCard(card) {
            if (!card || typeof window.pingLandingFocusOnTown !== 'function') return;
            window.pingLandingFocusOnTown(buildTownFlyPayload(card));
        }

        function bindTownCardClicks() {
            var townsList = document.getElementById('gfeTownsList');
            if (!townsList || townsList.__pingTownClickBound) return;
            townsList.__pingTownClickBound = true;
            townsList.addEventListener('click', function (e) {
                var collectBtn = e.target && e.target.closest
                    ? e.target.closest('[data-territory-collect-btn]')
                    : null;
                if (collectBtn) {
                    e.preventDefault();
                    e.stopPropagation();
                    var collectCard = collectBtn.closest('.ping-fp-slide2-town-item.gfe-towns-item');
                    if (collectCard) collectTerritoryDailyAura(collectCard);
                    return;
                }

                var card = e.target && e.target.closest
                    ? e.target.closest('.ping-fp-slide2-town-item.gfe-towns-item')
                    : null;
                if (!card || !card.closest('#gfeTownsList')) return;
                if (card.classList.contains('sortable-ghost')) return;
                if (card.classList.contains('ping-fp-slide2-town-item--disabled')
                    || card.getAttribute('data-subscription-locked') === '1') {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                if (isTownFlyBlocked(card)) return;
                flyToTownCard(card);
            });
        }

        function bootTerritoryDailyAuraUi() {
            var townsList = document.getElementById('gfeTownsList');
            if (!townsList) return;
            townsList.querySelectorAll('.gfe-towns-item.ping-fp-slide2-town-item').forEach(function (card) {
                syncCollectedDomFromAttrs(card);
            });
            townsList.querySelectorAll('.gfe-towns-item[data-daily-aura-collectible="1"]').forEach(scheduleExpiry);
            startAuraWaitTicker();
            bindTownCardClicks();
        }

        window.pingLandingInitTerritoryDailyAura = bootTerritoryDailyAuraUi;
        window.pingLandingSyncTerritoryCard = function (card) {
            if (!card) return;
            var amount = parseInt(card.getAttribute('data-daily-aura-amount') || '0', 10) || 0;
            if (amount < 1) {
                var km2 = parseFloat(card.getAttribute('data-area-km2') || '0');
                if (isFinite(km2) && km2 > 0) {
                    amount = Math.max(1, Math.round(km2));
                    card.setAttribute('data-daily-aura-amount', String(amount));
                }
            }
            if (amount >= 1
                && card.getAttribute('data-daily-aura-collected') !== '1'
                && card.getAttribute('data-subscription-locked') !== '1') {
                if (card.getAttribute('data-daily-aura-collectible') !== '1') {
                    openNewDayTerritoryAura(card);
                } else {
                    syncCollectedDomFromAttrs(card);
                }
            } else {
                syncCollectedDomFromAttrs(card);
            }
            if (card.getAttribute('data-daily-aura-collectible') === '1') {
                scheduleExpiry(card);
            }
            startAuraWaitTicker();
        };
        window.pingLandingOnLocalMidnight = function () {
            document.querySelectorAll('#gfeTownsList .ping-fp-slide2-town-item').forEach(function (card) {
                openNewDayTerritoryAura(card);
            });
        };

        /* ping-landing.js is defer-loaded after inline handlers register;
           boot here so countdown timers actually start on first paint. */
        bootTerritoryDailyAuraUi();

        function collectTerritoryDailyAura(card, onFallback) {
            if (!card) {
                if (onFallback) onFallback();
                return;
            }
            var territoryId = card.getAttribute('data-id') || '';
            if (!territoryId) {
                if (onFallback) onFallback();
                return;
            }

            var url = (cfg.collectUrlBase || '/api/territories/') + encodeURIComponent(territoryId) + '/collect-daily-aura';
            fetch(url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfTok,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: '{}'
            })
                .then(function (r) {
                    return r.text().then(function (text) {
                        var body = {};
                        if (text) {
                            try { body = JSON.parse(text); } catch (parseErr) { body = {}; }
                        }
                        return { ok: r.ok, status: r.status, body: body || {} };
                    });
                })
                .then(function (res) {
                    if (res.ok && res.body && (res.body.aura_awarded != null || res.body.aura_balance != null)) {
                        var awarded = parseInt(res.body.aura_awarded, 10) || 0;
                        var bal = res.body.aura_balance;
                        var balN = (typeof bal === 'number')
                            ? bal
                            : parseInt(String(bal).replace(/[^\d-]/g, ''), 10);
                        if (isFinite(balN)) {
                            if (typeof window.pingLandingAnimateAuraTo === 'function') {
                                window.pingLandingAnimateAuraTo(balN, awarded);
                            } else if (typeof window.updateAuraPills === 'function') {
                                window.updateAuraPills(balN);
                            }
                        }
                        applyCollectedState(card, res.body.next_available_at || '');
                        if (typeof window.__jutdeeSyncTerritoriesTableAfterAuraCollect === 'function') {
                            window.__jutdeeSyncTerritoriesTableAfterAuraCollect(territoryId);
                        }
                        if (awarded > 0 && !document.body.classList.contains('is-jutdee-tenant')) {
                            toastAuraAwarded(awarded);
                        }
                        return;
                    }
                    if (res.status === 409 && res.body.error === 'already_collected') {
                        applyCollectedState(card, res.body.next_available_at || card.getAttribute('data-daily-aura-next-at') || '');
                        if (typeof window.__jutdeeSyncTerritoriesTableAfterAuraCollect === 'function') {
                            window.__jutdeeSyncTerritoriesTableAfterAuraCollect(territoryId);
                        }
                        toastError('toastAlreadyCollected', 'Already collected today.');
                        return;
                    }
                    if (res.status === 409 && res.body.error === 'window_closed') {
                        restoreKm2Badge(card);
                        card.classList.remove('ping-fp-slide2-town-item--aura-ready', 'ping-fp-slide2-town-item--fly-blocked');
                        card.setAttribute('data-daily-aura-collectible', '0');
                        removeCollectButton(card);
                        toastError('toastWindowClosed', 'Territory Aura expired.');
                        if (onFallback) onFallback();
                        return;
                    }
                    if (res.status === 401) {
                        toastError('toastCollectFailed', 'Please sign in again.');
                        return;
                    }
                    if (res.status === 419) {
                        toastError('toastCollectFailed', 'Session expired — refresh the page.');
                        return;
                    }
                    if (res.status === 503) {
                        toastError('toastCollectFailed', 'Territory Aura is not available yet on this account.');
                        if (onFallback) onFallback();
                        return;
                    }
                    if (onFallback) onFallback();
                })
                .catch(function () {
                    toastError('toastCollectFailed', 'Could not collect Territory Aura.');
                });
        }

        window.collectTerritoryDailyAura = collectTerritoryDailyAura;
        window.flyToTownCard = flyToTownCard;

        (function sendTimezoneBeacon() {
            if (!cfg.authed) return;
            var stored = cfg.userTimezone || '';
            var tz = '';
            try {
                tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
            } catch (e) {}
            if (!tz || tz === stored) return;
            fetch('/api/user/timezone', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfTok
                },
                body: JSON.stringify({ timezone: tz })
            }).catch(function () {});
        })();
    })();

})();
